(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ccxt", [], factory);
	else if(typeof exports === 'object')
		exports["ccxt"] = factory();
	else
		root["ccxt"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 37);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = subclass(

/*  Root class                  */

Error,

/*  Derived class hierarchy     */

{ 'BaseError': { 'ExchangeError': { 'NotSupported': {},
            'AuthenticationError': { 'PermissionDenied': {}
            },
            'InsufficientFunds': {},
            'InvalidAddress': {},
            'InvalidOrder': { 'OrderNotFound': {},
                'OrderNotCached': {},
                'CancelPending': {}
            }
        },
        'NetworkError': { 'DDoSProtection': {},
            'RequestTimeout': {},
            'ExchangeNotAvailable': {},
            'InvalidNonce': {}
        }
    }
});

/*  ------------------------------------------------------------------------ */

function subclass(BaseClass, classes) {
    var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        var _loop = function _loop() {
            var _step$value = _slicedToArray(_step.value, 2),
                $class = _step$value[0],
                subclasses = _step$value[1];

            var Class = Object.assign(namespace, _defineProperty({}, $class, function (_BaseClass) {
                _inherits(_class, _BaseClass);

                function _class(message) {
                    _classCallCheck(this, _class);

                    /*  A workaround to make `instanceof` work on custom Error classes in transpiled ES5.
                        See my blog post for the explanation of this hack:
                         https://medium.com/@xpl/javascript-deriving-from-error-properly-8d2f8f315801        */

                    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, message));

                    _this.constructor = Class;
                    _this.__proto__ = Class.prototype;
                    _this.message = message;
                    return _this;
                }

                return _class;
            }(BaseClass)))[$class];

            subclass(Class, subclasses, namespace);
        };

        for (var _iterator = Object.entries(classes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            _loop();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return namespace;
}

/*  ------------------------------------------------------------------------ */

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/*  ------------------------------------------------------------------------ */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var functions = __webpack_require__(22),
    Market = __webpack_require__(69);

var isNode = functions.isNode,
    keys = functions.keys,
    values = functions.values,
    deepExtend = functions.deepExtend,
    extend = functions.extend,
    flatten = functions.flatten,
    unique = functions.unique,
    indexBy = functions.indexBy,
    sortBy = functions.sortBy,
    groupBy = functions.groupBy,
    aggregate = functions.aggregate,
    uuid = functions.uuid,
    unCamelCase = functions.unCamelCase,
    precisionFromString = functions.precisionFromString,
    throttle = functions.throttle,
    capitalize = functions.capitalize,
    now = functions.now,
    sleep = functions.sleep,
    timeout = functions.timeout,
    TimedOut = functions.TimedOut,
    buildOHLCVC = functions.buildOHLCVC;

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidAddress = _require.InvalidAddress,
    NotSupported = _require.NotSupported,
    AuthenticationError = _require.AuthenticationError,
    DDoSProtection = _require.DDoSProtection,
    RequestTimeout = _require.RequestTimeout,
    ExchangeNotAvailable = _require.ExchangeNotAvailable;

var DECIMAL_PLACES = functions.precisionConstants.DECIMAL_PLACES;


var defaultFetch = isNode ? __webpack_require__(70)().fetch : fetch;

var journal = undefined; // isNode && require ('./journal') // stub until we get a better solution for Webpack and React

/*  ------------------------------------------------------------------------ */

module.exports = function () {
    _createClass(Exchange, [{
        key: 'getMarket',
        value: function getMarket(symbol) {

            if (!this.marketClasses) this.marketClasses = {};

            var marketClass = this.marketClasses[symbol];

            if (marketClass) return marketClass;

            marketClass = new Market(this, symbol);
            this.marketClasses[symbol] = marketClass; // only one Market instance per market
            return marketClass;
        }
    }, {
        key: 'describe',
        value: function describe() {
            return {
                'id': undefined,
                'name': undefined,
                'countries': undefined,
                'enableRateLimit': false,
                'rateLimit': 2000, // milliseconds = seconds * 1000
                'has': {
                    'CORS': false,
                    'publicAPI': true,
                    'privateAPI': true,
                    'cancelOrder': true,
                    'cancelOrders': false,
                    'createDepositAddress': false,
                    'createOrder': true,
                    'createMarketOrder': true,
                    'createLimitOrder': true,
                    'deposit': false,
                    'editOrder': 'emulated',
                    'fetchBalance': true,
                    'fetchBidsAsks': false,
                    'fetchClosedOrders': false,
                    'fetchCurrencies': false,
                    'fetchDepositAddress': false,
                    'fetchFundingFees': false,
                    'fetchL2OrderBook': true,
                    'fetchMarkets': true,
                    'fetchMyTrades': false,
                    'fetchOHLCV': 'emulated',
                    'fetchOpenOrders': false,
                    'fetchOrder': false,
                    'fetchOrderBook': true,
                    'fetchOrderBooks': false,
                    'fetchOrders': false,
                    'fetchTicker': true,
                    'fetchTickers': false,
                    'fetchTrades': true,
                    'fetchTradingFees': false,
                    'withdraw': false
                },
                'urls': {
                    'logo': undefined,
                    'api': undefined,
                    'www': undefined,
                    'doc': undefined,
                    'fees': undefined
                },
                'api': undefined,
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': false,
                    'login': false,
                    'password': false,
                    'twofa': false // 2-factor authentication (one-time password key)
                },
                'markets': undefined, // to be filled manually or by fetchMarkets
                'currencies': {}, // to be filled manually or by fetchMarkets
                'timeframes': undefined, // redefine if the exchange has.fetchOHLCV
                'fees': {
                    'trading': {
                        'tierBased': undefined,
                        'percentage': undefined,
                        'taker': undefined,
                        'maker': undefined
                    },
                    'funding': {
                        'tierBased': undefined,
                        'percentage': undefined,
                        'withdraw': {},
                        'deposit': {}
                    }
                },
                'parseJsonResponse': true, // whether a reply is required to be in JSON or not
                'skipJsonOnStatusCodes': [], // array of http status codes which override requirement for JSON response
                'exceptions': undefined,
                // some exchanges report only 'free' on `fetchBlance` call (i.e. report no 'used' funds)
                // in this case ccxt will try to infer 'used' funds from open order cache, which might be stale
                // still, some exchanges report number of open orders together with balance
                // if you set the following flag to 'true' ccxt will leave 'used' funds undefined in case of discrepancy
                'dontGetUsedBalanceFromStaleCache': false,
                'commonCurrencies': { // gets extended/overwritten in subclasses
                    'XBT': 'BTC',
                    'BCC': 'BCH',
                    'DRK': 'DASH'
                },
                'precisionMode': DECIMAL_PLACES // return
            };
        } // describe ()

    }]);

    function Exchange() {
        var _this = this;

        var userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Exchange);

        Object.assign(this, functions, { encode: function encode(string) {
                return string;
            }, decode: function decode(string) {
                return string;
            } });

        if (isNode) this.nodeVersion = process.version.match(/\d+\.\d+.\d+/)[0];

        // if (isNode) {
        //     this.userAgent = {
        //         'User-Agent': 'ccxt/' + Exchange.ccxtVersion +
        //             ' (+https://github.com/ccxt/ccxt)' +
        //             ' Node.js/' + this.nodeVersion + ' (JavaScript)'
        //     }
        // }

        this.options = {}; // exchange-specific options, if any

        this.userAgents = {
            'chrome': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/62.0.3202.94 Safari/537.36',
            'chrome39': 'Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36'
        };

        this.headers = {};

        // prepended to URL, like https://proxy.com/https://exchange.com/api...
        this.proxy = '';
        this.origin = '*'; // CORS origin

        this.iso8601 = function (timestamp) {
            return typeof timestamp === 'undefined' ? timestamp : new Date(timestamp).toISOString();
        };
        this.parse8601 = function (x) {
            return Date.parse(x.indexOf('+') >= 0 || x.slice(-1) === 'Z' ? x : (x + 'Z').replace(/\s(\d\d):/, 'T$1:'));
        };
        this.parseDate = function (x) {
            if (typeof x === 'undefined') return x;
            return x.indexOf('GMT') >= 0 ? Date.parse(x) : _this.parse8601(x);
        };
        this.microseconds = function () {
            return now() * 1000;
        }; // TODO: utilize performance.now for that purpose
        this.seconds = function () {
            return Math.floor(now() / 1000);
        };

        this.minFundingAddressLength = 1; // used in checkAddress
        this.substituteCommonCurrencyCodes = true; // reserved

        // do not delete this line, it is needed for users to be able to define their own fetchImplementation
        this.fetchImplementation = defaultFetch;

        this.timeout = 10000; // milliseconds
        this.verbose = false;
        this.debug = false;
        this.journal = 'debug.json';
        this.userAgent = undefined;
        this.twofa = false; // two-factor authentication (2FA)

        this.apiKey = undefined;
        this.secret = undefined;
        this.uid = undefined;
        this.login = undefined;
        this.password = undefined;

        this.balance = {};
        this.orderbooks = {};
        this.tickers = {};
        this.orders = {};
        this.trades = {};

        this.last_http_response = undefined;
        this.last_json_response = undefined;
        this.last_response_headers = undefined;

        this.arrayConcat = function (a, b) {
            return a.concat(b);
        };

        var unCamelCaseProperties = function unCamelCaseProperties() {
            var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this;

            if (obj !== null) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = Object.getOwnPropertyNames(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var k = _step.value;

                        _this[unCamelCase(k)] = _this[k];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                unCamelCaseProperties(Object.getPrototypeOf(obj));
            }
        };
        unCamelCaseProperties();

        // merge configs
        var config = deepExtend(this.describe(), userConfig);

        // merge to this
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = Object.entries(config)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = _slicedToArray(_step2.value, 2),
                    property = _step2$value[0],
                    value = _step2$value[1];

                this[property] = deepExtend(this[property], value);
            } // generate old metainfo interface
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        for (var k in this.has) {
            this['has' + capitalize(k)] = !!this.has[k]; // converts 'emulated' to true
        }

        if (this.api) this.defineRestApi(this.api, 'request');

        this.initRestRateLimiter();

        if (this.markets) this.setMarkets(this.markets);

        if (this.debug && journal) {
            journal(function () {
                return _this.journal;
            }, this, Object.keys(this.has));
        }
    }

    _createClass(Exchange, [{
        key: 'defaults',
        value: function defaults() {
            return {/* override me */};
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.seconds();
        }
    }, {
        key: 'milliseconds',
        value: function milliseconds() {
            return now();
        }
    }, {
        key: 'encodeURIComponent',
        value: function (_encodeURIComponent) {
            function encodeURIComponent() {
                return _encodeURIComponent.apply(this, arguments);
            }

            encodeURIComponent.toString = function () {
                return _encodeURIComponent.toString();
            };

            return encodeURIComponent;
        }(function () {
            return encodeURIComponent.apply(undefined, arguments);
        })
    }, {
        key: 'checkRequiredCredentials',
        value: function checkRequiredCredentials() {
            var _this2 = this;

            Object.keys(this.requiredCredentials).forEach(function (key) {
                if (_this2.requiredCredentials[key] && !_this2[key]) throw new AuthenticationError(_this2.id + ' requires `' + key + '`');
            });
        }
    }, {
        key: 'checkAddress',
        value: function checkAddress(address) {

            if (typeof address === 'undefined') throw new InvalidAddress(this.id + ' address is undefined');

            // check the address is not the same letter like 'aaaaa' nor too short nor has a space
            if (unique(address).length === 1 || address.length < this.minFundingAddressLength || address.includes(' ')) throw new InvalidAddress(this.id + ' address is invalid or has less than ' + this.minFundingAddressLength.toString() + ' characters: "' + address.toString() + '"');

            return address;
        }
    }, {
        key: 'initRestRateLimiter',
        value: function initRestRateLimiter() {

            var fetchImplementation = this.fetchImplementation;

            if (this.rateLimit === undefined) throw new Error(this.id + '.rateLimit property is not configured');

            this.tokenBucket = this.extend({
                refillRate: 1 / this.rateLimit,
                delay: 1,
                capacity: 1,
                defaultCost: 1,
                maxCapacity: 1000
            }, this.tokenBucket);

            this.throttle = throttle(this.tokenBucket);

            this.executeRestRequest = function (url) {
                var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

                var _this3 = this;

                var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;


                var promise = fetchImplementation(url, { method: method, headers: headers, body: body, 'agent': this.agent || null, timeout: this.timeout }).catch(function (e) {
                    if (isNode) throw new ExchangeNotAvailable([_this3.id, method, url, e.type, e.message].join(' '));
                    throw e; // rethrow all unknown errors
                }).then(function (response) {
                    return _this3.handleRestResponse(response, url, method, headers, body);
                });

                return timeout(this.timeout, promise).catch(function (e) {
                    if (e instanceof TimedOut) throw new RequestTimeout(_this3.id + ' ' + method + ' ' + url + ' request timed out (' + _this3.timeout + ' ms)');
                    throw e;
                });
            };
        }
    }, {
        key: 'defineRestApi',
        value: function defineRestApi(api, methodName) {
            var _this4 = this;

            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                var _loop = function _loop() {
                    var type = _step3.value;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                        for (var _iterator4 = Object.keys(api[type])[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                            var httpMethod = _step4.value;


                            var paths = api[type][httpMethod];

                            var _loop2 = function _loop2(i) {
                                var path = paths[i].trim();
                                var splitPath = path.split(/[^a-zA-Z0-9]/);

                                var uppercaseMethod = httpMethod.toUpperCase();
                                var lowercaseMethod = httpMethod.toLowerCase();
                                var camelcaseMethod = _this4.capitalize(lowercaseMethod);
                                var camelcaseSuffix = splitPath.map(_this4.capitalize).join('');
                                var underscoreSuffix = splitPath.map(function (x) {
                                    return x.trim().toLowerCase();
                                }).filter(function (x) {
                                    return x.length > 0;
                                }).join('_');

                                var camelcase = type + camelcaseMethod + _this4.capitalize(camelcaseSuffix);
                                var underscore = type + '_' + lowercaseMethod + '_' + underscoreSuffix;

                                if ('suffixes' in options) {
                                    if ('camelcase' in options['suffixes']) camelcase += options['suffixes']['camelcase'];
                                    if ('underscore' in options.suffixes) underscore += options['suffixes']['underscore'];
                                }

                                if ('underscore_suffix' in options) underscore += options.underscoreSuffix;
                                if ('camelcase_suffix' in options) camelcase += options.camelcaseSuffix;

                                var partial = function () {
                                    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
                                        return regeneratorRuntime.wrap(function _callee$(_context) {
                                            while (1) {
                                                switch (_context.prev = _context.next) {
                                                    case 0:
                                                        return _context.abrupt('return', _this4[methodName](path, type, uppercaseMethod, params || {}));

                                                    case 1:
                                                    case 'end':
                                                        return _context.stop();
                                                }
                                            }
                                        }, _callee, _this4);
                                    }));

                                    return function partial(_x7) {
                                        return _ref.apply(this, arguments);
                                    };
                                }();

                                _this4[camelcase] = partial;
                                _this4[underscore] = partial;
                            };

                            for (var i = 0; i < paths.length; i++) {
                                _loop2(i);
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                _iterator4.return();
                            }
                        } finally {
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                };

                for (var _iterator3 = Object.keys(api)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'fetch',
        value: function fetch(url) {
            var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
            var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;


            if (isNode && this.userAgent) {
                if (typeof this.userAgent === 'string') headers = extend({ 'User-Agent': this.userAgent }, headers);else if (_typeof(this.userAgent) === 'object' && 'User-Agent' in this.userAgent) headers = extend(this.userAgent, headers);
            }

            if (typeof this.proxy === 'function') {

                url = this.proxy(url);
                if (isNode) headers = extend({ 'Origin': this.origin }, headers);
            } else if (typeof this.proxy === 'string') {

                if (this.proxy.length) if (isNode) headers = extend({ 'Origin': this.origin }, headers);

                url = this.proxy + url;
            }

            headers = extend(this.headers, headers);

            if (this.verbose) console.log("fetch:\n", this.id, method, url, "\nRequest:\n", headers, "\n", body, "\n");

            return this.executeRestRequest(url, method, headers, body);
        }
    }, {
        key: 'fetch2',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(path) {
                var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var request;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!this.enableRateLimit) {
                                    _context2.next = 3;
                                    break;
                                }

                                _context2.next = 3;
                                return this.throttle();

                            case 3:
                                request = this.sign(path, type, method, params, headers, body);
                                return _context2.abrupt('return', this.fetch(request.url, request.method, request.headers, request.body));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetch2(_x11) {
                return _ref2.apply(this, arguments);
            }

            return fetch2;
        }()
    }, {
        key: 'request',
        value: function request(path) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            return this.fetch2(path, type, method, params, headers, body);
        }
    }, {
        key: 'parseJson',
        value: function parseJson(response, responseBody, url, method) {
            try {

                return responseBody.length > 0 ? JSON.parse(responseBody) : {}; // empty object for empty body
            } catch (e) {

                if (this.verbose) console.log('parseJson:\n', this.id, method, url, response.status, 'error', e, "response body:\n'" + responseBody + "'\n");

                var title = undefined;
                var match = responseBody.match(/<title>([^<]+)/i);
                if (match) title = match[1].trim();

                var maintenance = responseBody.match(/offline|busy|retry|wait|unavailable|maintain|maintenance|maintenancing/i);
                var ddosProtection = responseBody.match(/cloudflare|incapsula|overload|ddos/i);

                if (e instanceof SyntaxError) {

                    var ExceptionClass = ExchangeNotAvailable;
                    var details = 'not accessible from this location at the moment';
                    if (maintenance) details = 'offline, on maintenance or unreachable from this location at the moment';
                    if (ddosProtection) ExceptionClass = DDoSProtection;
                    throw new ExceptionClass([this.id, method, url, response.status, title, details].join(' '));
                }

                throw e;
            }
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(statusCode, statusText, url, method, requestHeaders, responseBody, json) {
            // override me
        }
    }, {
        key: 'defaultErrorHandler',
        value: function defaultErrorHandler(response, responseBody, url, method) {
            var code = response.status,
                reason = response.statusText;

            if (code >= 200 && code <= 299) return;
            var error = undefined;
            var details = responseBody;
            var match = responseBody.match(/<title>([^<]+)/i);
            if (match) details = match[1].trim();
            if ([418, 429].includes(code)) {
                error = DDoSProtection;
            } else if ([404, 409, 500, 501, 502, 520, 521, 522, 525].includes(code)) {
                error = ExchangeNotAvailable;
            } else if ([400, 403, 405, 503, 530].includes(code)) {
                var ddosProtection = responseBody.match(/cloudflare|incapsula/i);
                if (ddosProtection) {
                    error = DDoSProtection;
                } else {
                    error = ExchangeNotAvailable;
                    details += ' (possible reasons: ' + ['invalid API keys', 'bad or old nonce', 'exchange is down or offline', 'on maintenance', 'DDoS protection', 'rate-limiting'].join(', ') + ')';
                }
            } else if ([408, 504].includes(code)) {
                error = RequestTimeout;
            } else if ([401, 511].includes(code)) {
                error = AuthenticationError;
            } else {
                error = ExchangeError;
            }
            throw new error([this.id, method, url, code, reason, details].join(' '));
        }
    }, {
        key: 'handleRestResponse',
        value: function handleRestResponse(response, url) {
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';

            var _this5 = this;

            var requestHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var requestBody = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;


            return response.text().then(function (responseBody) {

                var jsonRequired = _this5.parseJsonResponse && !_this5.skipJsonOnStatusCodes.includes(response.status);
                var json = jsonRequired ? _this5.parseJson(response, responseBody, url, method) : undefined;

                var responseHeaders = {};
                response.headers.forEach(function (value, key) {
                    key = key.split('-').map(function (word) {
                        return capitalize(word);
                    }).join('-');
                    responseHeaders[key] = value;
                });

                _this5.last_response_headers = responseHeaders;
                _this5.last_http_response = responseBody; // FIXME: for those classes that haven't switched to handleErrors yet
                _this5.last_json_response = json; // FIXME: for those classes that haven't switched to handleErrors yet

                if (_this5.verbose) console.log("handleRestResponse:\n", _this5.id, method, url, response.status, response.statusText, "\nResponse:\n", responseHeaders, "\n", responseBody, "\n");

                var args = [response.status, response.statusText, url, method, responseHeaders, responseBody, json];
                _this5.handleErrors.apply(_this5, args);
                _this5.defaultErrorHandler(response, responseBody, url, method);

                return jsonRequired ? json : responseBody;
            });
        }
    }, {
        key: 'setMarkets',
        value: function setMarkets(markets) {
            var _this6 = this;

            var currencies = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var values = Object.values(markets).map(function (market) {
                return deepExtend({
                    'limits': _this6.limits,
                    'precision': _this6.precision
                }, _this6.fees['trading'], market);
            });
            this.markets = deepExtend(this.markets, indexBy(values, 'symbol'));
            this.marketsById = indexBy(markets, 'id');
            this.markets_by_id = this.marketsById;
            this.symbols = Object.keys(this.markets).sort();
            this.ids = Object.keys(this.markets_by_id).sort();
            if (currencies) {
                this.currencies = deepExtend(currencies, this.currencies);
            } else {
                var baseCurrencies = values.filter(function (market) {
                    return 'base' in market;
                }).map(function (market) {
                    return {
                        id: market.baseId || market.base,
                        numericId: typeof market.baseNumericId !== 'undefined' ? market.baseNumericId : undefined,
                        code: market.base,
                        precision: market.precision ? market.precision.base || market.precision.amount : 8
                    };
                });
                var quoteCurrencies = values.filter(function (market) {
                    return 'quote' in market;
                }).map(function (market) {
                    return {
                        id: market.quoteId || market.quote,
                        numericId: typeof market.quoteNumericId !== 'undefined' ? market.quoteNumericId : undefined,
                        code: market.quote,
                        precision: market.precision ? market.precision.quote || market.precision.price : 8
                    };
                });
                var allCurrencies = baseCurrencies.concat(quoteCurrencies);
                var groupedCurrencies = groupBy(allCurrencies, 'code');
                var _currencies = Object.keys(groupedCurrencies).map(function (code) {
                    return groupedCurrencies[code].reduce(function (previous, current) {
                        return previous.precision > current.precision ? previous : current;
                    }, groupedCurrencies[code][0]);
                });
                var sortedCurrencies = sortBy(flatten(_currencies), 'code');
                this.currencies = deepExtend(indexBy(sortedCurrencies, 'code'), this.currencies);
            }
            this.currencies_by_id = indexBy(this.currencies, 'id');
            return this.markets;
        }
    }, {
        key: 'loadMarkets',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                var markets, currencies;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(!reload && this.markets)) {
                                    _context3.next = 4;
                                    break;
                                }

                                if (this.markets_by_id) {
                                    _context3.next = 3;
                                    break;
                                }

                                return _context3.abrupt('return', this.setMarkets(this.markets));

                            case 3:
                                return _context3.abrupt('return', this.markets);

                            case 4:
                                _context3.next = 6;
                                return this.fetchMarkets();

                            case 6:
                                markets = _context3.sent;
                                currencies = undefined;

                                if (!this.has.fetchCurrencies) {
                                    _context3.next = 12;
                                    break;
                                }

                                _context3.next = 11;
                                return this.fetchCurrencies();

                            case 11:
                                currencies = _context3.sent;

                            case 12:
                                return _context3.abrupt('return', this.setMarkets(markets, currencies));

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function loadMarkets() {
                return _ref3.apply(this, arguments);
            }

            return loadMarkets;
        }()
    }, {
        key: 'fetchBidsAsks',
        value: function fetchBidsAsks() {
            var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            throw new NotSupported(this.id + ' fetchBidsAsks not supported yet');
        }
    }, {
        key: 'fetchOHLCVC',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var trades, ohlcvc;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (this.has['fetchTrades']) {
                                    _context4.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchOHLCV() not supported yet');

                            case 2:
                                _context4.next = 4;
                                return this.loadMarkets();

                            case 4:
                                _context4.next = 6;
                                return this.fetchTrades(symbol, since, limits, params);

                            case 6:
                                trades = _context4.sent;
                                ohlcvc = buildOHLCVC(trades, timeframe, since, limits);
                                return _context4.abrupt('return', ohlcvc);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOHLCVC(_x29) {
                return _ref4.apply(this, arguments);
            }

            return fetchOHLCVC;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limits = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var trades, ohlcvc;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (this.has['fetchTrades']) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchOHLCV() not supported yet');

                            case 2:
                                _context5.next = 4;
                                return this.loadMarkets();

                            case 4:
                                _context5.next = 6;
                                return this.fetchTrades(symbol, since, limits, params);

                            case 6:
                                trades = _context5.sent;
                                ohlcvc = buildOHLCVC(trades, timeframe, since, limits);
                                return _context5.abrupt('return', ohlcvc.map(function (c) {
                                    return c.slice(0, -1);
                                }));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x34) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'convertTradingViewToOHLCV',
        value: function convertTradingViewToOHLCV(ohlcvs) {
            var result = [];
            for (var i = 0; i < ohlcvs['t'].length; i++) {
                result.push([ohlcvs['t'][i] * 1000, ohlcvs['o'][i], ohlcvs['h'][i], ohlcvs['l'][i], ohlcvs['c'][i], ohlcvs['v'][i]]);
            }
            return result;
        }
    }, {
        key: 'convertOHLCVToTradingView',
        value: function convertOHLCVToTradingView(ohlcvs) {
            var result = {
                't': [],
                'o': [],
                'h': [],
                'l': [],
                'c': [],
                'v': []
            };
            for (var i = 0; i < ohlcvs.length; i++) {
                result['t'].push(parseInt(ohlcvs[i][0] / 1000));
                result['o'].push(ohlcvs[i][1]);
                result['h'].push(ohlcvs[i][2]);
                result['l'].push(ohlcvs[i][3]);
                result['c'].push(ohlcvs[i][4]);
                result['v'].push(ohlcvs[i][5]);
            }
            return result;
        }
    }, {
        key: 'fetchTickers',
        value: function fetchTickers() {
            var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            throw new NotSupported(this.id + ' fetchTickers not supported yet');
        }
    }, {
        key: 'purgeCachedOrders',
        value: function purgeCachedOrders(before) {
            var orders = Object.values(this.orders).filter(function (order) {
                return order.status === 'open' || order.timestamp >= before;
            });
            this.orders = indexBy(orders, 'id');
            return this.orders;
        }
    }, {
        key: 'fetchOrder',
        value: function fetchOrder(id) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            throw new NotSupported(this.id + ' fetchOrder not supported yet');
        }
    }, {
        key: 'fetchOrders',
        value: function fetchOrders() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            throw new NotSupported(this.id + ' fetchOrders not supported yet');
        }
    }, {
        key: 'fetchOpenOrders',
        value: function fetchOpenOrders() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            throw new NotSupported(this.id + ' fetchOpenOrders not supported yet');
        }
    }, {
        key: 'fetchClosedOrders',
        value: function fetchClosedOrders() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            throw new NotSupported(this.id + ' fetchClosedOrders not supported yet');
        }
    }, {
        key: 'fetchMyTrades',
        value: function fetchMyTrades() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            throw new NotSupported(this.id + ' fetchMyTrades not supported yet');
        }
    }, {
        key: 'fetchCurrencies',
        value: function fetchCurrencies() {
            throw new NotSupported(this.id + ' fetchCurrencies not supported yet');
        }
    }, {
        key: 'fetchMarkets',
        value: function fetchMarkets() {
            var _this7 = this;

            return new Promise(function (resolve, reject) {
                return resolve(Object.values(_this7.markets));
            });
        }
    }, {
        key: 'fetchOrderStatus',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var order;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.fetchOrder(id, market);

                            case 2:
                                order = _context6.sent;
                                return _context6.abrupt('return', order['status']);

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOrderStatus(_x59) {
                return _ref6.apply(this, arguments);
            }

            return fetchOrderStatus;
        }()
    }, {
        key: 'account',
        value: function account() {
            return {
                'free': 0.0,
                'used': 0.0,
                'total': 0.0
            };
        }
    }, {
        key: 'commonCurrencyCode',
        value: function commonCurrencyCode(currency) {
            if (!this.substituteCommonCurrencyCodes) return currency;
            return this.safeString(this.commonCurrencies, currency, currency);
        }
    }, {
        key: 'currencyId',
        value: function currencyId(commonCode) {
            var currencyIds = {};
            var distinct = Object.keys(this.commonCurrencies);
            for (var i = 0; i < distinct.length; i++) {
                var k = distinct[i];
                currencyIds[this.commonCurrencies[k]] = k;
            }
            return this.safeString(currencyIds, commonCode, commonCode);
        }
    }, {
        key: 'currency',
        value: function currency(code) {

            if (typeof this.currencies === 'undefined') throw new ExchangeError(this.id + ' currencies not loaded');

            if (typeof code === 'string' && code in this.currencies) return this.currencies[code];

            throw new ExchangeError(this.id + ' does not have currency code ' + code);
        }
    }, {
        key: 'findMarket',
        value: function findMarket(string) {

            if (typeof this.markets === 'undefined') throw new ExchangeError(this.id + ' markets not loaded');

            if (typeof string === 'string') {

                if (string in this.markets_by_id) return this.markets_by_id[string];

                if (string in this.markets) return this.markets[string];
            }

            return string;
        }
    }, {
        key: 'findSymbol',
        value: function findSymbol(string) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;


            if (typeof market === 'undefined') market = this.findMarket(string);

            if ((typeof market === 'undefined' ? 'undefined' : _typeof(market)) === 'object') return market['symbol'];

            return string;
        }
    }, {
        key: 'market',
        value: function market(symbol) {

            if (typeof this.markets === 'undefined') throw new ExchangeError(this.id + ' markets not loaded');

            if (typeof symbol === 'string' && symbol in this.markets) return this.markets[symbol];

            throw new ExchangeError(this.id + ' does not have market symbol ' + symbol);
        }
    }, {
        key: 'marketId',
        value: function marketId(symbol) {
            var market = this.market(symbol);
            return typeof market !== 'undefined' ? market['id'] : symbol;
        }
    }, {
        key: 'marketIds',
        value: function marketIds(symbols) {
            var _this8 = this;

            return symbols.map(function (symbol) {
                return _this8.marketId(symbol);
            });
        }
    }, {
        key: 'symbol',
        value: function symbol(_symbol) {
            return this.market(_symbol).symbol || _symbol;
        }
    }, {
        key: 'extractParams',
        value: function extractParams(string) {
            var re = /{([\w-]+)}/g;
            var matches = [];
            var match = re.exec(string);
            while (match) {
                matches.push(match[1]);
                match = re.exec(string);
            }
            return matches;
        }
    }, {
        key: 'implodeParams',
        value: function implodeParams(string, params) {
            for (var property in params) {
                string = string.replace('{' + property + '}', params[property]);
            }return string;
        }
    }, {
        key: 'url',
        value: function url(path) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var result = this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (Object.keys(query).length) result += '?' + this.urlencode(query);
            return result;
        }
    }, {
        key: 'parseBidAsk',
        value: function parseBidAsk(bidask) {
            var priceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var amountKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            var price = parseFloat(bidask[priceKey]);
            var amount = parseFloat(bidask[amountKey]);
            return [price, amount];
        }
    }, {
        key: 'parseBidsAsks',
        value: function parseBidsAsks(bidasks) {
            var _this9 = this;

            var priceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var amountKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            return Object.values(bidasks || []).map(function (bidask) {
                return _this9.parseBidAsk(bidask, priceKey, amountKey);
            });
        }
    }, {
        key: 'fetchL2OrderBook',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetchOrderBook(symbol, limit, params);

                            case 2:
                                orderbook = _context7.sent;
                                return _context7.abrupt('return', extend(orderbook, {
                                    'bids': sortBy(aggregate(orderbook.bids), 0, true),
                                    'asks': sortBy(aggregate(orderbook.asks), 0)
                                }));

                            case 4:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchL2OrderBook(_x67) {
                return _ref7.apply(this, arguments);
            }

            return fetchL2OrderBook;
        }()
    }, {
        key: 'parseOrderBook',
        value: function parseOrderBook(orderbook) {
            var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var bidsKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bids';
            var asksKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'asks';
            var priceKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
            var amountKey = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

            return {
                'bids': sortBy(bidsKey in orderbook ? this.parseBidsAsks(orderbook[bidsKey], priceKey, amountKey) : [], 0, true),
                'asks': sortBy(asksKey in orderbook ? this.parseBidsAsks(orderbook[asksKey], priceKey, amountKey) : [], 0),
                'timestamp': timestamp,
                'datetime': typeof timestamp !== 'undefined' ? this.iso8601(timestamp) : undefined,
                'nonce': undefined
            };
        }
    }, {
        key: 'getCurrencyUsedOnOpenOrders',
        value: function getCurrencyUsedOnOpenOrders(currency) {
            var _this10 = this;

            return Object.values(this.orders).filter(function (order) {
                return order['status'] === 'open';
            }).reduce(function (total, order) {
                var symbol = order['symbol'];
                var market = _this10.markets[symbol];
                var remaining = order['remaining'];
                if (currency === market['base'] && order['side'] === 'sell') {
                    return total + remaining;
                } else if (currency === market['quote'] && order['side'] === 'buy') {
                    return total + order['price'] * remaining;
                } else {
                    return total;
                }
            }, 0);
        }
    }, {
        key: 'parseBalance',
        value: function parseBalance(balance) {
            var _this11 = this;

            var currencies = Object.keys(this.omit(balance, 'info'));

            currencies.forEach(function (currency) {

                if (typeof balance[currency].used === 'undefined') {
                    // exchange reports only 'free' balance -> try to derive 'used' funds from open orders cache

                    if (_this11.dontGetUsedBalanceFromStaleCache && 'open_orders' in balance['info']) {
                        // liqui exchange reports number of open orders with balance response
                        // use it to validate the cache
                        var exchangeOrdersCount = balance['info']['open_orders'];
                        var cachedOrdersCount = Object.values(_this11.orders).filter(function (order) {
                            return order['status'] === 'open';
                        }).length;
                        if (cachedOrdersCount === exchangeOrdersCount) {
                            balance[currency].used = _this11.getCurrencyUsedOnOpenOrders(currency);
                            balance[currency].total = balance[currency].used + balance[currency].free;
                        }
                    } else {
                        balance[currency].used = _this11.getCurrencyUsedOnOpenOrders(currency);
                        balance[currency].total = balance[currency].used + balance[currency].free;
                    }
                }

                ['free', 'used', 'total'].forEach(function (account) {
                    balance[account] = balance[account] || {};
                    balance[account][currency] = balance[currency][account];
                });
            });

            return balance;
        }
    }, {
        key: 'fetchPartialBalance',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(part) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var balance;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.fetchBalance(params);

                            case 2:
                                balance = _context8.sent;
                                return _context8.abrupt('return', balance[part]);

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchPartialBalance(_x75) {
                return _ref8.apply(this, arguments);
            }

            return fetchPartialBalance;
        }()
    }, {
        key: 'fetchFreeBalance',
        value: function fetchFreeBalance() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.fetchPartialBalance('free', params);
        }
    }, {
        key: 'fetchUsedBalance',
        value: function fetchUsedBalance() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.fetchPartialBalance('used', params);
        }
    }, {
        key: 'fetchTotalBalance',
        value: function fetchTotalBalance() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this.fetchPartialBalance('total', params);
        }
    }, {
        key: 'filterBySinceLimit',
        value: function filterBySinceLimit(array) {
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            if (typeof since !== 'undefined') array = array.filter(function (entry) {
                return entry.timestamp >= since;
            });
            if (typeof limit !== 'undefined') array = array.slice(0, limit);
            return array;
        }
    }, {
        key: 'filterBySymbolSinceLimit',
        value: function filterBySymbolSinceLimit(array) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;


            var symbolIsDefined = typeof symbol !== 'undefined';
            var sinceIsDefined = typeof since !== 'undefined';

            // single-pass filter for both symbol and since
            if (symbolIsDefined || sinceIsDefined) array = Object.values(array).filter(function (entry) {
                return (symbolIsDefined ? entry.symbol === symbol : true) && (sinceIsDefined ? entry.timestamp >= since : true);
            });

            if (typeof limit !== 'undefined') array = Object.values(array).slice(0, limit);

            return array;
        }
    }, {
        key: 'filterByArray',
        value: function filterByArray(objects, key) {
            var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var indexed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;


            objects = Object.values(objects);

            // return all of them if no values were passed
            if (typeof values === 'undefined') return indexed ? indexBy(objects, key) : objects;

            var result = [];
            for (var i = 0; i < objects.length; i++) {
                if (values.includes(objects[i][key])) result.push(objects[i]);
            }

            return indexed ? indexBy(result, key) : result;
        }
    }, {
        key: 'parseTrades',
        value: function parseTrades(trades) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var _this12 = this;

            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var result = Object.values(trades || []).map(function (trade) {
                return _this12.parseTrade(trade, market);
            });
            result = sortBy(result, 'timestamp');
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            return this.filterBySymbolSinceLimit(result, symbol, since, limit);
        }
    }, {
        key: 'parseOrders',
        value: function parseOrders(orders) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var _this13 = this;

            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var result = Object.values(orders).map(function (order) {
                return _this13.parseOrder(order, market);
            });
            result = sortBy(result, 'timestamp');
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            return this.filterBySymbolSinceLimit(result, symbol, since, limit);
        }
    }, {
        key: 'filterBySymbol',
        value: function filterBySymbol(array) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            return typeof symbol !== 'undefined' ? array.filter(function (entry) {
                return entry.symbol === symbol;
            }) : array;
        }
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return Array.isArray(ohlcv) ? ohlcv.slice(0, 6) : ohlcv;
        }
    }, {
        key: 'parseOHLCVs',
        value: function parseOHLCVs(ohlcvs) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            ohlcvs = Object.values(ohlcvs);
            var result = [];
            for (var i = 0; i < ohlcvs.length; i++) {
                if (limit && result.length >= limit) break;
                var ohlcv = this.parseOHLCV(ohlcvs[i], market, timeframe, since, limit);
                if (since && ohlcv[0] < since) continue;
                result.push(ohlcv);
            }
            return result;
        }
    }, {
        key: 'editLimitBuyOrder',
        value: function editLimitBuyOrder(id, symbol) {
            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            return this.editLimitOrder.apply(this, [id, symbol, 'buy'].concat(args));
        }
    }, {
        key: 'editLimitSellOrder',
        value: function editLimitSellOrder(id, symbol) {
            for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                args[_key2 - 2] = arguments[_key2];
            }

            return this.editLimitOrder.apply(this, [id, symbol, 'sell'].concat(args));
        }
    }, {
        key: 'editLimitOrder',
        value: function editLimitOrder(id, symbol) {
            for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                args[_key3 - 2] = arguments[_key3];
            }

            return this.editOrder.apply(this, [id, symbol, 'limit'].concat(args));
        }
    }, {
        key: 'editOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id, symbol) {
                for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
                    args[_key4 - 2] = arguments[_key4];
                }

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (this.enableRateLimit) {
                                    _context9.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' editOrder() requires enableRateLimit = true');

                            case 2:
                                _context9.next = 4;
                                return this.cancelOrder(id, symbol);

                            case 4:
                                return _context9.abrupt('return', this.createOrder.apply(this, [symbol].concat(args)));

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function editOrder(_x102, _x103) {
                return _ref9.apply(this, arguments);
            }

            return editOrder;
        }()
    }, {
        key: 'createLimitOrder',
        value: function createLimitOrder(symbol) {
            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                args[_key5 - 1] = arguments[_key5];
            }

            return this.createOrder.apply(this, [symbol, 'limit'].concat(args));
        }
    }, {
        key: 'createMarketOrder',
        value: function createMarketOrder(symbol) {
            for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                args[_key6 - 1] = arguments[_key6];
            }

            return this.createOrder.apply(this, [symbol, 'market'].concat(args));
        }
    }, {
        key: 'createLimitBuyOrder',
        value: function createLimitBuyOrder(symbol) {
            for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                args[_key7 - 1] = arguments[_key7];
            }

            return this.createOrder.apply(this, [symbol, 'limit', 'buy'].concat(args));
        }
    }, {
        key: 'createLimitSellOrder',
        value: function createLimitSellOrder(symbol) {
            for (var _len8 = arguments.length, args = Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
                args[_key8 - 1] = arguments[_key8];
            }

            return this.createOrder.apply(this, [symbol, 'limit', 'sell'].concat(args));
        }
    }, {
        key: 'createMarketBuyOrder',
        value: function createMarketBuyOrder(symbol, amount) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return this.createOrder(symbol, 'market', 'buy', amount, undefined, params);
        }
    }, {
        key: 'createMarketSellOrder',
        value: function createMarketSellOrder(symbol, amount) {
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            return this.createOrder(symbol, 'market', 'sell', amount, undefined, params);
        }
    }, {
        key: 'costToPrecision',
        value: function costToPrecision(symbol, cost) {
            return parseFloat(cost).toFixed(this.markets[symbol].precision.price);
        }
    }, {
        key: 'priceToPrecision',
        value: function priceToPrecision(symbol, price) {
            return parseFloat(price).toFixed(this.markets[symbol].precision.price);
        }
    }, {
        key: 'amountToPrecision',
        value: function amountToPrecision(symbol, amount) {
            return this.truncate(amount, this.markets[symbol].precision.amount);
        }
    }, {
        key: 'amountToString',
        value: function amountToString(symbol, amount) {
            return this.truncate_to_string(amount, this.markets[symbol].precision.amount);
        }
    }, {
        key: 'amountToLots',
        value: function amountToLots(symbol, amount) {
            var lot = this.markets[symbol].lot;
            return this.amountToPrecision(symbol, Math.floor(amount / lot) * lot);
        }
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(symbol, fee) {
            return parseFloat(fee).toFixed(this.markets[symbol].precision.price);
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * price));
            return {
                'type': takerOrMaker,
                'currency': market['quote'],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(symbol, rate * cost))
            };
        }
    }, {
        key: 'ymd',
        value: function ymd(timestamp) {
            var infix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

            var date = new Date(timestamp);
            var Y = date.getUTCFullYear();
            var m = date.getUTCMonth() + 1;
            var d = date.getUTCDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return Y + '-' + m + '-' + d;
        }
    }, {
        key: 'ymdhms',
        value: function ymdhms(timestamp) {
            var infix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

            var date = new Date(timestamp);
            var Y = date.getUTCFullYear();
            var m = date.getUTCMonth() + 1;
            var d = date.getUTCDate();
            var H = date.getUTCHours();
            var M = date.getUTCMinutes();
            var S = date.getUTCSeconds();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            H = H < 10 ? '0' + H : H;
            M = M < 10 ? '0' + M : M;
            S = S < 10 ? '0' + S : S;
            return Y + '-' + m + '-' + d + infix + H + ':' + M + ':' + S;
        }
    }]);

    return Exchange;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(4));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(15), __webpack_require__(16));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(foxbit, _Exchange);

    function foxbit() {
        _classCallCheck(this, foxbit);

        return _possibleConstructorReturn(this, (foxbit.__proto__ || Object.getPrototypeOf(foxbit)).apply(this, arguments));
    }

    _createClass(foxbit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(foxbit.prototype.__proto__ || Object.getPrototypeOf(foxbit.prototype), 'describe', this).call(this), {
                'id': 'foxbit',
                'name': 'FoxBit',
                'countries': 'BR',
                'has': {
                    'CORS': false,
                    'createMarketOrder': false
                },
                'rateLimit': 1000,
                'version': 'v1',
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27991413-11b40d42-647f-11e7-91ee-78ced874dd09.jpg',
                    'api': {
                        'public': 'https://api.blinktrade.com/api',
                        'private': 'https://api.blinktrade.com/tapi'
                    },
                    'www': 'https://foxbit.exchange',
                    'doc': 'https://blinktrade.com/docs'
                },
                'comment': 'Blinktrade API',
                'api': {
                    'public': {
                        'get': ['{currency}/ticker', // ?crypto_currency=BTC
                        '{currency}/orderbook', // ?crypto_currency=BTC
                        '{currency}/trades']
                    },
                    'private': {
                        'post': ['D', // order
                        'F', // cancel order
                        'U2', // balance
                        'U4', // my orders
                        'U6', // withdraw
                        'U18', // deposit
                        'U24', // confirm withdrawal
                        'U26', // list withdrawals
                        'U30', // list deposits
                        'U34', // ledger
                        'U70']
                    }
                },
                'markets': {
                    'BTC/VEF': { 'id': 'BTCVEF', 'symbol': 'BTC/VEF', 'base': 'BTC', 'quote': 'VEF', 'brokerId': 1, 'broker': 'SurBitcoin' },
                    'BTC/VND': { 'id': 'BTCVND', 'symbol': 'BTC/VND', 'base': 'BTC', 'quote': 'VND', 'brokerId': 3, 'broker': 'VBTC' },
                    'BTC/BRL': { 'id': 'BTCBRL', 'symbol': 'BTC/BRL', 'base': 'BTC', 'quote': 'BRL', 'brokerId': 4, 'broker': 'FoxBit' },
                    'BTC/PKR': { 'id': 'BTCPKR', 'symbol': 'BTC/PKR', 'base': 'BTC', 'quote': 'PKR', 'brokerId': 8, 'broker': 'UrduBit' },
                    'BTC/CLP': { 'id': 'BTCCLP', 'symbol': 'BTC/CLP', 'base': 'BTC', 'quote': 'CLP', 'brokerId': 9, 'broker': 'ChileBit' }
                },
                'options': {
                    'brokerId': '4' // https://blinktrade.com/docs/#brokers
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencyIds, i, currencyId, currency, code, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostU2({
                                    'BalanceReqID': this.nonce()
                                });

                            case 2:
                                response = _context.sent;
                                balances = this.safeValue(response['Responses'], this.options['brokerId']);
                                result = { 'info': response };

                                if (typeof balances !== 'undefined') {
                                    currencyIds = Object.keys(this.currencies_by_id);

                                    for (i = 0; i < currencyIds.length; i++) {
                                        currencyId = currencyIds[i];
                                        currency = this.currencies_by_id[currencyId];
                                        code = currency['code'];
                                        // we only set the balance for the currency if that currency is present in response
                                        // otherwise we will lose the info if the currency balance has been funded or traded or not

                                        if (currencyId in balances) {
                                            account = this.account();

                                            account['used'] = parseFloat(balances[currencyId + '_locked']) * 1e-8;
                                            account['total'] = parseFloat(balances[currencyId]) * 1e-8;
                                            account['free'] = account['total'] - account['used'];
                                            result[code] = account;
                                        }
                                    }
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetCurrencyOrderbook(this.extend({
                                    'currency': market['quote'],
                                    'crypto_currency': market['base']
                                }, params));

                            case 3:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker, timestamp, lowercaseQuote, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                market = this.market(symbol);
                                _context3.next = 3;
                                return this.publicGetCurrencyTicker(this.extend({
                                    'currency': market['quote'],
                                    'crypto_currency': market['base']
                                }, params));

                            case 3:
                                ticker = _context3.sent;
                                timestamp = this.milliseconds();
                                lowercaseQuote = market['quote'].toLowerCase();
                                quoteVolume = 'vol_' + lowercaseQuote;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'vol'),
                                    'quoteVolume': parseFloat(ticker[quoteVolume]),
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'id': this.safeString(trade, 'tid'),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['side'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetCurrencyTrades(this.extend({
                                    'currency': market['quote'],
                                    'crypto_currency': market['base']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, orderSide, order, response, indexed, execution;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                market = this.market(symbol);
                                orderSide = side === 'buy' ? '1' : '2';
                                order = {
                                    'ClOrdID': this.nonce(),
                                    'Symbol': market['id'],
                                    'Side': orderSide,
                                    'OrdType': '2',
                                    'Price': price,
                                    'OrderQty': amount,
                                    'BrokerID': market['brokerId']
                                };
                                _context5.next = 7;
                                return this.privatePostD(this.extend(order, params));

                            case 7:
                                response = _context5.sent;
                                indexed = this.indexBy(response['Responses'], 'MsgType');
                                execution = indexed['8'];
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': execution['OrderID']
                                });

                            case 11:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostF(this.extend({
                                    'ClOrdID': id
                                }, params));

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var request = this.extend({ 'MsgType': path }, query);
                body = this.json(request);
                headers = {
                    'APIKey': this.apiKey,
                    'Nonce': nonce,
                    'Signature': this.hmac(this.encode(nonce), this.encode(this.secret)),
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('Status' in response)) {
                                    _context7.next = 6;
                                    break;
                                }

                                if (!(response['Status'] !== 200)) {
                                    _context7.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context7.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return foxbit;
}(Exchange);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError;

module.exports = function (_Exchange) {
    _inherits(liqui, _Exchange);

    function liqui() {
        _classCallCheck(this, liqui);

        return _possibleConstructorReturn(this, (liqui.__proto__ || Object.getPrototypeOf(liqui)).apply(this, arguments));
    }

    _createClass(liqui, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(liqui.prototype.__proto__ || Object.getPrototypeOf(liqui.prototype), 'describe', this).call(this), {
                'id': 'liqui',
                'name': 'Liqui',
                'countries': 'UA',
                'rateLimit': 3000,
                'version': '3',
                'userAgent': this.userAgents['chrome'],
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchOrderBooks': true,
                    'fetchOrder': true,
                    'fetchOrders': 'emulated',
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': 'emulated',
                    'fetchTickers': true,
                    'fetchMyTrades': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27982022-75aea828-63a0-11e7-9511-ca584a8edd74.jpg',
                    'api': {
                        'public': 'https://api.liqui.io/api',
                        'private': 'https://api.liqui.io/tapi'
                    },
                    'www': 'https://liqui.io',
                    'doc': 'https://liqui.io/api',
                    'fees': 'https://liqui.io/fee'
                },
                'api': {
                    'public': {
                        'get': ['info', 'ticker/{pair}', 'depth/{pair}', 'trades/{pair}']
                    },
                    'private': {
                        'post': ['getInfo', 'Trade', 'ActiveOrders', 'OrderInfo', 'CancelOrder', 'TradeHistory', 'CoinDepositAddress', 'WithdrawCoin', 'CreateCoupon', 'RedeemCoupon']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.001,
                        'taker': 0.0025
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {},
                        'deposit': {}
                    }
                },
                'commonCurrencies': {
                    'DSH': 'DASH'
                },
                'exceptions': {
                    '803': InvalidOrder, // "Count could not be less than 0.001." (selling below minAmount)
                    '804': InvalidOrder, // "Count could not be more than 10000." (buying above maxAmount)
                    '805': InvalidOrder, // "price could not be less than X." (minPrice violation on buy & sell)
                    '806': InvalidOrder, // "price could not be more than X." (maxPrice violation on buy & sell)
                    '807': InvalidOrder, // "cost could not be less than X." (minCost violation on buy & sell)
                    '831': InsufficientFunds, // "Not enougth X to create buy order." (buying with balance.quote < order.cost)
                    '832': InsufficientFunds, // "Not enougth X to create sell order." (selling with balance.base < order.amount)
                    '833': OrderNotFound // "Order with id X was not found." (cancelling non-existent, closed and cancelled order)
                }
            });
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var key = 'quote';
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * rate));
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': cost
            };
        }
    }, {
        key: 'getBaseQuoteFromMarketId',
        value: function getBaseQuoteFromMarketId(id) {
            var uppercase = id.toUpperCase();

            var _uppercase$split = uppercase.split('_'),
                _uppercase$split2 = _slicedToArray(_uppercase$split, 2),
                base = _uppercase$split2[0],
                quote = _uppercase$split2[1];

            base = this.commonCurrencyCode(base);
            quote = this.commonCurrencyCode(quote);
            return [base, quote];
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, keys, result, p, id, market, _getBaseQuoteFromMark, _getBaseQuoteFromMark2, base, quote, symbol, precision, amountLimits, priceLimits, costLimits, limits, hidden, active;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetInfo();

                            case 2:
                                response = _context.sent;
                                markets = response['pairs'];
                                keys = Object.keys(markets);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    id = keys[p];
                                    market = markets[id];
                                    _getBaseQuoteFromMark = this.getBaseQuoteFromMarketId(id), _getBaseQuoteFromMark2 = _slicedToArray(_getBaseQuoteFromMark, 2), base = _getBaseQuoteFromMark2[0], quote = _getBaseQuoteFromMark2[1];
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': this.safeInteger(market, 'decimal_places'),
                                        'price': this.safeInteger(market, 'decimal_places')
                                    };
                                    amountLimits = {
                                        'min': this.safeFloat(market, 'min_amount'),
                                        'max': this.safeFloat(market, 'max_amount')
                                    };
                                    priceLimits = {
                                        'min': this.safeFloat(market, 'min_price'),
                                        'max': this.safeFloat(market, 'max_price')
                                    };
                                    costLimits = {
                                        'min': this.safeFloat(market, 'min_total')
                                    };
                                    limits = {
                                        'amount': amountLimits,
                                        'price': priceLimits,
                                        'cost': costLimits
                                    };
                                    hidden = this.safeInteger(market, 'hidden');
                                    active = hidden === 0;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': active,
                                        'taker': market['fee'] / 100,
                                        'precision': precision,
                                        'limits': limits,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, funds, currencies, c, currency, uppercase, total, used, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetInfo();

                            case 4:
                                response = _context2.sent;
                                balances = response['return'];
                                result = { 'info': balances };
                                funds = balances['funds'];
                                currencies = Object.keys(funds);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    uppercase = currency.toUpperCase();

                                    uppercase = this.commonCurrencyCode(uppercase);
                                    total = undefined;
                                    used = undefined;

                                    if (balances['open_orders'] === 0) {
                                        total = funds[currency];
                                        used = 0.0;
                                    }
                                    account = {
                                        'free': funds[currency],
                                        'used': used,
                                        'total': total
                                    };

                                    result[uppercase] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response, market_id_in_reponse, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // default = 150, max = 2000
                                _context3.next = 7;
                                return this.publicGetDepthPair(this.extend(request, params));

                            case 7:
                                response = _context3.sent;
                                market_id_in_reponse = market['id'] in response;

                                if (market_id_in_reponse) {
                                    _context3.next = 11;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + market['symbol'] + ' order book is empty or not available');

                            case 11:
                                orderbook = response[market['id']];
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchOrderBooks',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ids, numIds, response, result, i, id, symbol, market;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                ids = undefined;

                                if (symbols) {
                                    _context4.next = 10;
                                    break;
                                }

                                ids = this.ids.join('-');
                                // max URL length is 2083 symbols, including http schema, hostname, tld, etc...

                                if (!(ids.length > 2048)) {
                                    _context4.next = 8;
                                    break;
                                }

                                numIds = this.ids.length;
                                throw new ExchangeError(this.id + ' has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');

                            case 8:
                                _context4.next = 12;
                                break;

                            case 10:
                                ids = this.marketIds(symbols);
                                ids = ids.join('-');

                            case 12:
                                _context4.next = 14;
                                return this.publicGetDepthPair(this.extend({
                                    'pair': ids
                                }, params));

                            case 14:
                                response = _context4.sent;
                                result = {};

                                ids = Object.keys(response);
                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    symbol = id;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];

                                        symbol = market['symbol'];
                                    }
                                    result[symbol] = this.parseOrderBook(response[id]);
                                }
                                return _context4.abrupt('return', result);

                            case 19:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBooks() {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBooks;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['updated'] * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'avg'),
                'baseVolume': this.safeFloat(ticker, 'vol_cur'),
                'quoteVolume': this.safeFloat(ticker, 'vol'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ids, numIds, tickers, result, keys, k, id, ticker, symbol, market;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                ids = undefined;

                                if (symbols) {
                                    _context5.next = 10;
                                    break;
                                }

                                ids = this.ids.join('-');
                                // max URL length is 2083 symbols, including http schema, hostname, tld, etc...

                                if (!(ids.length > 2048)) {
                                    _context5.next = 8;
                                    break;
                                }

                                numIds = this.ids.length;
                                throw new ExchangeError(this.id + ' has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchTickers');

                            case 8:
                                _context5.next = 12;
                                break;

                            case 10:
                                ids = this.marketIds(symbols);
                                ids = ids.join('-');

                            case 12:
                                _context5.next = 14;
                                return this.publicGetTickerPair(this.extend({
                                    'pair': ids
                                }, params));

                            case 14:
                                tickers = _context5.sent;
                                result = {};
                                keys = Object.keys(tickers);

                                for (k = 0; k < keys.length; k++) {
                                    id = keys[k];
                                    ticker = tickers[id];
                                    symbol = id;
                                    market = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 19:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.fetchTickers([symbol], params);

                            case 2:
                                tickers = _context6.sent;
                                return _context6.abrupt('return', tickers[symbol]);

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x12) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['timestamp']) * 1000;
            var side = trade['type'];
            if (side === 'ask') side = 'sell';
            if (side === 'bid') side = 'buy';
            var price = this.safeFloat(trade, 'price');
            if ('rate' in trade) price = this.safeFloat(trade, 'rate');
            var id = this.safeString(trade, 'tid');
            if ('trade_id' in trade) id = this.safeString(trade, 'trade_id');
            var order = this.safeString(trade, this.getOrderIdKey());
            if ('pair' in trade) {
                var marketId = trade['pair'];
                market = this.markets_by_id[marketId];
            }
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var amount = trade['amount'];
            var type = 'limit'; // all trades are still limit trades
            var isYourOrder = this.safeValue(trade, 'is_your_order');
            var takerOrMaker = 'taker';
            if (typeof isYourOrder !== 'undefined') if (isYourOrder) takerOrMaker = 'maker';
            var fee = this.calculateFee(symbol, type, side, amount, price, takerOrMaker);
            return {
                'id': id,
                'order': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'amount': amount,
                'fee': fee,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context7.next = 7;
                                return this.publicGetTradesPair(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response[market['id']], market, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x15) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, response, id, status, filled, remaining, timestamp, order;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id'],
                                    'type': side,
                                    'amount': this.amountToPrecision(symbol, amount),
                                    'rate': this.priceToPrecision(symbol, price)
                                };

                                price = parseFloat(price);
                                amount = parseFloat(amount);
                                _context8.next = 10;
                                return this.privatePostTrade(this.extend(request, params));

                            case 10:
                                response = _context8.sent;
                                id = undefined;
                                status = 'open';
                                filled = 0.0;
                                remaining = amount;

                                if ('return' in response) {
                                    id = this.safeString(response['return'], this.getOrderIdKey());
                                    if (id === '0') {
                                        id = this.safeString(response['return'], 'init_order_id');
                                        status = 'closed';
                                    }
                                    filled = this.safeFloat(response['return'], 'received', 0.0);
                                    remaining = this.safeFloat(response['return'], 'remains', amount);
                                }
                                timestamp = this.milliseconds();
                                order = {
                                    'id': id,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': status,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'cost': price * filled,
                                    'amount': amount,
                                    'remaining': remaining,
                                    'filled': filled,
                                    'fee': undefined
                                    // 'trades': this.parseTrades (order['trades'], market),
                                };

                                this.orders[id] = order;
                                return _context8.abrupt('return', this.extend({ 'info': response }, order));

                            case 20:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x19, _x20, _x21, _x22) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'getOrderIdKey',
        value: function getOrderIdKey() {
            return 'order_id';
        }
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, request, idKey;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                response = undefined;
                                request = {};
                                idKey = this.getOrderIdKey();

                                request[idKey] = id;
                                _context9.next = 8;
                                return this.privatePostCancelOrder(this.extend(request, params));

                            case 8:
                                response = _context9.sent;

                                if (id in this.orders) this.orders[id]['status'] = 'canceled';
                                return _context9.abrupt('return', response);

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x25) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                '0': 'open',
                '1': 'closed',
                '2': 'canceled',
                '3': 'canceled' // or partially-filled and still open? https://github.com/ccxt/ccxt/issues/1594
            };
            if (status in statuses) return statuses[status];
            return status;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var id = order['id'].toString();
            var status = this.safeString(order, 'status');
            if (status !== 'undefined') status = this.parseOrderStatus(status);
            var timestamp = parseInt(order['timestamp_created']) * 1000;
            var symbol = undefined;
            if (!market) market = this.markets_by_id[order['pair']];
            if (market) symbol = market['symbol'];
            var remaining = undefined;
            var amount = undefined;
            var price = this.safeFloat(order, 'rate');
            var filled = undefined;
            var cost = undefined;
            if ('start_amount' in order) {
                amount = this.safeFloat(order, 'start_amount');
                remaining = this.safeFloat(order, 'amount');
            } else {
                remaining = this.safeFloat(order, 'amount');
                if (id in this.orders) amount = this.orders[id]['amount'];
            }
            if (typeof amount !== 'undefined') {
                if (typeof remaining !== 'undefined') {
                    filled = amount - remaining;
                    cost = price * filled;
                }
            }
            var fee = undefined;
            var result = {
                'info': order,
                'id': id,
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'remaining': remaining,
                'filled': filled,
                'status': status,
                'fee': fee
            };
            return result;
        }
    }, {
        key: 'parseOrders',
        value: function parseOrders(orders) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var ids = Object.keys(orders);
            var result = [];
            for (var i = 0; i < ids.length; i++) {
                var id = ids[i];
                var order = orders[id];
                var extended = this.extend(order, { 'id': id });
                result.push(this.parseOrder(extended, market));
            }
            return this.filterBySinceLimit(result, since, limit);
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, newOrder, oldOrder;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostOrderInfo(this.extend({
                                    'order_id': parseInt(id)
                                }, params));

                            case 4:
                                response = _context10.sent;

                                id = id.toString();
                                newOrder = this.parseOrder(this.extend({ 'id': id }, response['return'][id]));
                                oldOrder = id in this.orders ? this.orders[id] : {};

                                this.orders[id] = this.extend(oldOrder, newOrder);
                                return _context10.abrupt('return', this.orders[id]);

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrder(_x32) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'updateCachedOrders',
        value: function updateCachedOrders(openOrders, symbol) {
            // update local cache with open orders
            // this will add unseen orders and overwrite existing ones
            for (var j = 0; j < openOrders.length; j++) {
                var id = openOrders[j]['id'];
                this.orders[id] = openOrders[j];
            }
            var openOrdersIndexedById = this.indexBy(openOrders, 'id');
            var cachedOrderIds = Object.keys(this.orders);
            for (var k = 0; k < cachedOrderIds.length; k++) {
                // match each cached order to an order in the open orders array
                // possible reasons why a cached order may be missing in the open orders array:
                // - order was closed or canceled -> update cache
                // - symbol mismatch (e.g. cached BTC/USDT, fetched ETH/USDT) -> skip
                var cachedOrderId = cachedOrderIds[k];
                var cachedOrder = this.orders[cachedOrderId];
                if (!(cachedOrderId in openOrdersIndexedById)) {
                    // cached order is not in open orders array
                    // if we fetched orders by symbol and it doesn't match the cached order -> won't update the cached order
                    if (typeof symbol !== 'undefined' && symbol !== cachedOrder['symbol']) continue;
                    // cached order is absent from the list of open orders -> mark the cached order as closed
                    if (cachedOrder['status'] === 'open') {
                        cachedOrder = this.extend(cachedOrder, {
                            'status': 'closed', // likewise it might have been canceled externally (unnoticed by "us")
                            'cost': undefined,
                            'filled': cachedOrder['amount'],
                            'remaining': 0.0
                        });
                        if (typeof cachedOrder['cost'] === 'undefined') {
                            if (typeof cachedOrder['filled'] !== 'undefined') cachedOrder['cost'] = cachedOrder['filled'] * cachedOrder['price'];
                        }
                        this.orders[cachedOrderId] = cachedOrder;
                    }
                }
            }
            return this.toArray(this.orders);
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                var request, market, _market, response, openOrders, allOrders, result;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!('fetchOrdersRequiresSymbol' in this.options)) {
                                    _context11.next = 4;
                                    break;
                                }

                                if (!this.options['fetchOrdersRequiresSymbol']) {
                                    _context11.next = 4;
                                    break;
                                }

                                if (!(typeof symbol === 'undefined')) {
                                    _context11.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol argument');

                            case 4:
                                _context11.next = 6;
                                return this.loadMarkets();

                            case 6:
                                request = {};
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    _market = this.market(symbol);

                                    request['pair'] = _market['id'];
                                }
                                _context11.next = 11;
                                return this.privatePostActiveOrders(this.extend(request, params));

                            case 11:
                                response = _context11.sent;

                                // liqui etc can only return 'open' orders (i.e. no way to fetch 'closed' orders)
                                openOrders = [];

                                if ('return' in response) openOrders = this.parseOrders(response['return'], market);
                                allOrders = this.updateCachedOrders(openOrders, symbol);
                                result = this.filterBySymbol(allOrders, symbol);
                                return _context11.abrupt('return', this.filterBySinceLimit(result, since, limit));

                            case 17:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context12.sent;
                                return _context12.abrupt('return', this.filterBy(orders, 'status', 'open'));

                            case 4:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOpenOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context13.sent;
                                return _context13.abrupt('return', this.filterBy(orders, 'status', 'closed'));

                            case 4:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchClosedOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, trades;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {
                                    // 'from': 123456789, // trade ID, from which the display starts numerical 0 (test result: liqui ignores this field)
                                    // 'count': 1000, // the number of trades for display numerical, default = 1000
                                    // 'from_id': trade ID, from which the display starts numerical 0
                                    // 'end_id': trade ID on which the display ends numerical ∞
                                    // 'order': 'ASC', // sorting, default = DESC (test result: liqui ignores this field, most recent trade always goes last)
                                    // 'since': 1234567890, // UTC start time, default = 0 (test result: liqui ignores this field)
                                    // 'end': 1234567890, // UTC end time, default = ∞ (test result: liqui ignores this field)
                                    // 'pair': 'eth_btc', // default = all markets
                                };

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                }
                                if (typeof limit !== 'undefined') request['count'] = parseInt(limit);
                                if (typeof since !== 'undefined') request['since'] = parseInt(since / 1000);
                                _context14.next = 9;
                                return this.privatePostTradeHistory(this.extend(request, params));

                            case 9:
                                response = _context14.sent;
                                trades = [];

                                if ('return' in response) trades = response['return'];
                                return _context14.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 13:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchMyTrades() {
                return _ref14.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                this.checkAddress(address);
                                _context15.next = 3;
                                return this.loadMarkets();

                            case 3:
                                _context15.next = 5;
                                return this.privatePostWithdrawCoin(this.extend({
                                    'coinName': currency,
                                    'amount': parseFloat(amount),
                                    'address': address
                                }, params));

                            case 5:
                                response = _context15.sent;
                                return _context15.abrupt('return', {
                                    'info': response,
                                    'id': response['return']['tId']
                                });

                            case 7:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function withdraw(_x51, _x52, _x53) {
                return _ref15.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'signBodyWithSecret',
        value: function signBodyWithSecret(body) {
            return this.hmac(this.encode(body), this.encode(this.secret), 'sha512');
        }
    }, {
        key: 'getVersionString',
        value: function getVersionString() {
            return '/' + this.version;
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'nonce': nonce,
                    'method': path
                }, query));
                var signature = this.signBodyWithSecret(body);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': signature
                };
            } else if (api === 'public') {
                url += this.getVersionString() + '/' + this.implodeParams(path, params);
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            } else {
                url += '/' + this.implodeParams(path, params);
                if (method === 'GET') {
                    if (Object.keys(query).length) {
                        url += '?' + this.urlencode(query);
                    }
                } else {
                    if (Object.keys(query).length) {
                        body = this.json(query);
                        headers = {
                            'Content-Type': 'application/json'
                        };
                    }
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('success' in response) {
                    //
                    // 1 - Liqui only returns the integer 'success' key from their private API
                    //
                    //     { "success": 1, ... } httpCode === 200
                    //     { "success": 0, ... } httpCode === 200
                    //
                    // 2 - However, exchanges derived from Liqui, can return non-integers
                    //
                    //     It can be a numeric string
                    //     { "sucesss": "1", ... }
                    //     { "sucesss": "0", ... }, httpCode >= 200 (can be 403, 502, etc)
                    //
                    //     Or just a string
                    //     { "success": "true", ... }
                    //     { "success": "false", ... }, httpCode >= 200
                    //
                    //     Or a boolean
                    //     { "success": true, ... }
                    //     { "success": false, ... }, httpCode >= 200
                    //
                    // 3 - Oversimplified, Python PEP8 forbids comparison operator (===) of different types
                    //
                    // 4 - We do not want to copy-paste and duplicate the code of this handler to other exchanges derived from Liqui
                    //
                    // To cover points 1, 2, 3 and 4 combined this handler should work like this:
                    //
                    var success = this.safeValue(response, 'success', false);
                    if (typeof success === 'string') {
                        if (success === 'true' || success === '1') success = true;else success = false;
                    }
                    if (!success) {
                        var code = this.safeString(response, 'code');
                        var message = this.safeString(response, 'error');
                        var feedback = this.id + ' ' + this.json(response);
                        var exceptions = this.exceptions;
                        if (code in exceptions) {
                            throw new exceptions[code](feedback);
                        }
                        // need a second error map for these messages, apparently...
                        // in fact, we can use the same .exceptions with string-keys to save some loc here
                        if (message === 'invalid api key') {
                            throw new AuthenticationError(feedback);
                        } else if (message === 'invalid sign') {
                            throw new AuthenticationError(feedback);
                        } else if (message === 'api key dont have trade permission') {
                            throw new AuthenticationError(feedback);
                        } else if (message.indexOf('invalid parameter') >= 0) {
                            // errorCode 0, returned on buy(symbol, 0, 0)
                            throw new InvalidOrder(feedback);
                        } else if (message === 'invalid order') {
                            throw new InvalidOrder(feedback);
                        } else if (message === 'Requests too often') {
                            throw new DDoSProtection(feedback);
                        } else if (message === 'not available') {
                            throw new ExchangeNotAvailable(feedback);
                        } else if (message === 'data unavailable') {
                            throw new ExchangeNotAvailable(feedback);
                        } else if (message === 'external service unavailable') {
                            throw new ExchangeNotAvailable(feedback);
                        } else {
                            throw new ExchangeError(this.id + ' unknown "error" value: ' + this.json(response));
                        }
                    }
                }
            }
        }
    }]);

    return liqui;
}(Exchange);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(okcoinusd, _Exchange);

    function okcoinusd() {
        _classCallCheck(this, okcoinusd);

        return _possibleConstructorReturn(this, (okcoinusd.__proto__ || Object.getPrototypeOf(okcoinusd)).apply(this, arguments));
    }

    _createClass(okcoinusd, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(okcoinusd.prototype.__proto__ || Object.getPrototypeOf(okcoinusd.prototype), 'describe', this).call(this), {
                'id': 'okcoinusd',
                'name': 'OKCoin USD',
                'countries': ['CN', 'US'],
                'version': 'v1',
                'rateLimit': 1000, // up to 3000 requests per 5 minutes ≈ 600 requests per minute ≈ 10 requests per second ≈ 100 ms
                'has': {
                    'CORS': false,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOrders': false,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'withdraw': true,
                    'futures': false
                },
                'extension': '.do', // appended to endpoint URL
                'timeframes': {
                    '1m': '1min',
                    '3m': '3min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '1hour',
                    '2h': '2hour',
                    '4h': '4hour',
                    '6h': '6hour',
                    '12h': '12hour',
                    '1d': '1day',
                    '3d': '3day',
                    '1w': '1week'
                },
                'api': {
                    'web': {
                        'get': ['markets/currencies', 'markets/products']
                    },
                    'public': {
                        'get': ['depth', 'exchange_rate', 'future_depth', 'future_estimated_price', 'future_hold_amount', 'future_index', 'future_kline', 'future_price_limit', 'future_ticker', 'future_trades', 'kline', 'otcs', 'ticker', 'tickers', 'trades']
                    },
                    'private': {
                        'post': ['account_records', 'batch_trade', 'borrow_money', 'borrow_order_info', 'borrows_info', 'cancel_borrow', 'cancel_order', 'cancel_otc_order', 'cancel_withdraw', 'future_batch_trade', 'future_cancel', 'future_devolve', 'future_explosive', 'future_order_info', 'future_orders_info', 'future_position', 'future_position_4fix', 'future_trade', 'future_trades_history', 'future_userinfo', 'future_userinfo_4fix', 'lend_depth', 'order_fee', 'order_history', 'order_info', 'orders_info', 'otc_order_history', 'otc_order_info', 'repayment', 'submit_otc_order', 'trade', 'trade_history', 'trade_otc_order', 'withdraw', 'withdraw_info', 'unrepayments_info', 'userinfo']
                    }
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766791-89ffb502-5ee5-11e7-8a5b-c5950b68ac65.jpg',
                    'api': {
                        'web': 'https://www.okcoin.com/v2',
                        'public': 'https://www.okcoin.com/api',
                        'private': 'https://www.okcoin.com/api'
                    },
                    'www': 'https://www.okcoin.com',
                    'doc': ['https://www.okcoin.com/rest_getStarted.html', 'https://www.npmjs.com/package/okcoin.com']
                },
                'fees': {
                    'trading': {
                        'taker': 0.002,
                        'maker': 0.002
                    }
                },
                'exceptions': {
                    '1009': OrderNotFound, // for spot markets, cancelling closed order
                    '1051': OrderNotFound, // for spot markets, cancelling "just closed" order
                    '1019': OrderNotFound, // order closed?
                    '20015': OrderNotFound, // for future markets
                    '1013': InvalidOrder, // no contract type (PR-1101)
                    '1027': InvalidOrder, // createLimitBuyOrder(symbol, 0, 0): Incorrect parameter may exceeded limits
                    '1002': InsufficientFunds, // "The transaction amount exceed the balance"
                    '1050': InvalidOrder, // returned when trying to cancel an order that was filled or canceled previously
                    '10000': ExchangeError, // createLimitBuyOrder(symbol, undefined, undefined)
                    '10005': AuthenticationError, // bad apiKey
                    '10008': ExchangeError // Illegal URL parameter
                },
                'options': {
                    'warnOnFetchOHLCVLimitArgument': true
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, futureMarkets, i, id, _id$split, _id$split2, baseId, quoteId, baseIdUppercase, quoteIdUppercase, base, quote, symbol, precision, lot, minAmount, minPrice, active, baseNumericId, quoteNumericId, market, futureQuote, futureSymbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.webGetMarketsProducts();

                            case 2:
                                response = _context.sent;
                                markets = response['data'];
                                result = [];
                                futureMarkets = {
                                    'BCH/USD': true,
                                    'BTC/USD': true,
                                    'ETC/USD': true,
                                    'ETH/USD': true,
                                    'LTC/USD': true,
                                    'XRP/USD': true,
                                    'EOS/USD': true,
                                    'BTG/USD': true
                                };

                                for (i = 0; i < markets.length; i++) {
                                    id = markets[i]['symbol'];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    baseIdUppercase = baseId.toUpperCase();
                                    quoteIdUppercase = quoteId.toUpperCase();
                                    base = this.commonCurrencyCode(baseIdUppercase);
                                    quote = this.commonCurrencyCode(quoteIdUppercase);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': markets[i]['maxSizeDigit'],
                                        'price': markets[i]['maxPriceDigit']
                                    };
                                    lot = Math.pow(10, -precision['amount']);
                                    minAmount = markets[i]['minTradeSize'];
                                    minPrice = Math.pow(10, -precision['price']);
                                    active = markets[i]['online'] !== 0;
                                    baseNumericId = markets[i]['baseCurrency'];
                                    quoteNumericId = markets[i]['quoteCurrency'];
                                    market = this.extend(this.fees['trading'], {
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'baseNumericId': baseNumericId,
                                        'quoteNumericId': quoteNumericId,
                                        'info': markets[i],
                                        'type': 'spot',
                                        'spot': true,
                                        'future': false,
                                        'lot': lot,
                                        'active': active,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': minAmount,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': minPrice,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': minAmount * minPrice,
                                                'max': undefined
                                            }
                                        }
                                    });

                                    result.push(market);
                                    futureQuote = market['quote'] === 'USDT' ? 'USD' : market['quote'];
                                    futureSymbol = market['base'] + '/' + futureQuote;

                                    if (this.has['futures'] && futureSymbol in futureMarkets) {
                                        result.push(this.extend(market, {
                                            'quote': 'USD',
                                            'symbol': market['base'] + '/USD',
                                            'id': market['id'].replace('usdt', 'usd'),
                                            'quoteId': market['quoteId'].replace('usdt', 'usd'),
                                            'type': 'future',
                                            'spot': false,
                                            'future': true
                                        }));
                                    }
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, method, request, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'publicGet';
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['size'] = limit;
                                if (market['future']) {
                                    method += 'Future';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                }
                                method += 'Depth';
                                _context2.next = 10;
                                return this[method](this.extend(request, params));

                            case 10:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['timestamp'];
            var symbol = undefined;
            if (!market) {
                if ('symbol' in ticker) {
                    var marketId = ticker['symbol'];
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                }
            }
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, method, request, response, ticker, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'publicGet';
                                request = {
                                    'symbol': market['id']
                                };

                                if (market['future']) {
                                    method += 'Future';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                }
                                method += 'Ticker';
                                _context3.next = 9;
                                return this[method](this.extend(request, params));

                            case 9:
                                response = _context3.sent;
                                ticker = this.safeValue(response, 'ticker');

                                if (!(typeof ticker === 'undefined')) {
                                    _context3.next = 13;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchTicker returned an empty response: ' + this.json(response));

                            case 13:
                                timestamp = this.safeInteger(response, 'date');

                                if (typeof timestamp !== 'undefined') {
                                    timestamp *= 1000;
                                    ticker = this.extend(ticker, { 'timestamp': timestamp });
                                }
                                return _context3.abrupt('return', this.parseTicker(ticker, market));

                            case 16:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'info': trade,
                'timestamp': trade['date_ms'],
                'datetime': this.iso8601(trade['date_ms']),
                'symbol': symbol,
                'id': trade['tid'].toString(),
                'order': undefined,
                'type': undefined,
                'side': trade['type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, method, request, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'publicGet';
                                request = {
                                    'symbol': market['id']
                                };

                                if (market['future']) {
                                    method += 'Future';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                }
                                method += 'Trades';
                                _context4.next = 9;
                                return this[method](this.extend(request, params));

                            case 9:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, method, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'publicGet';
                                request = {
                                    'symbol': market['id'],
                                    'type': this.timeframes[timeframe]
                                };

                                if (market['future']) {
                                    method += 'Future';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                }
                                method += 'Kline';

                                if (!(typeof limit !== 'undefined')) {
                                    _context5.next = 11;
                                    break;
                                }

                                if (!this.options['warnOnFetchOHLCVLimitArgument']) {
                                    _context5.next = 10;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOHLCV counts "limit" candles from current time backwards, therefore the "limit" argument for ' + this.id + ' is disabled. Set ' + this.id + '.options["warnOnFetchOHLCVLimitArgument"] = false to suppress this warning message.');

                            case 10:
                                request['size'] = parseInt(limit); // max is 1440 candles

                            case 11:
                                if (typeof since !== 'undefined') request['since'] = since;else request['since'] = this.milliseconds() - 86400000; // last 24 hours
                                _context5.next = 14;
                                return this[method](this.extend(request, params));

                            case 14:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 16:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, ids, i, id, code, account;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privatePostUserinfo();

                            case 4:
                                response = _context6.sent;
                                balances = response['info']['funds'];
                                result = { 'info': response };
                                ids = Object.keys(this.currencies_by_id);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    code = this.currencies_by_id[id]['code'];
                                    account = this.account();

                                    account['free'] = this.safeFloat(balances['free'], id, 0.0);
                                    account['used'] = this.safeFloat(balances['freezed'], id, 0.0);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[code] = account;
                                }
                                return _context6.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchBalance() {
                return _ref6.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, order, response, timestamp;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'privatePost';
                                order = {
                                    'symbol': market['id'],
                                    'type': side
                                };

                                if (!market['future']) {
                                    _context7.next = 10;
                                    break;
                                }

                                method += 'Future';
                                order = this.extend(order, {
                                    'contract_type': 'this_week', // next_week, quarter
                                    'match_price': 0, // match best counter party price? 0 or 1, ignores price if 1
                                    'lever_rate': 10, // leverage rate value: 10 or 20 (10 by default)
                                    'price': price,
                                    'amount': amount
                                });
                                _context7.next = 23;
                                break;

                            case 10:
                                if (!(type === 'limit')) {
                                    _context7.next = 15;
                                    break;
                                }

                                order['price'] = price;
                                order['amount'] = amount;
                                _context7.next = 23;
                                break;

                            case 15:
                                order['type'] += '_market';

                                if (!(side === 'buy')) {
                                    _context7.next = 22;
                                    break;
                                }

                                order['price'] = this.safeFloat(params, 'cost');

                                if (order['price']) {
                                    _context7.next = 20;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' market buy orders require an additional cost parameter, cost = price * amount');

                            case 20:
                                _context7.next = 23;
                                break;

                            case 22:
                                order['amount'] = amount;

                            case 23:
                                params = this.omit(params, 'cost');
                                method += 'Trade';
                                _context7.next = 27;
                                return this[method](this.extend(order, params));

                            case 27:
                                response = _context7.sent;
                                timestamp = this.milliseconds();
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['order_id'].toString(),
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': undefined,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'amount': amount,
                                    'filled': undefined,
                                    'remaining': undefined,
                                    'cost': undefined,
                                    'trades': undefined,
                                    'fee': undefined
                                });

                            case 30:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x18, _x19, _x20, _x21) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, method, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (symbol) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder() requires a symbol argument');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'order_id': id
                                };
                                method = 'privatePost';

                                if (market['future']) {
                                    method += 'FutureCancel';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                } else {
                                    method += 'CancelOrder';
                                }
                                _context8.next = 10;
                                return this[method](this.extend(request, params));

                            case 10:
                                response = _context8.sent;
                                return _context8.abrupt('return', response);

                            case 12:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x24) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            if (status === -1) return 'canceled';
            if (status === 0) return 'open';
            if (status === 1) return 'open';
            if (status === 2) return 'closed';
            if (status === 3) return 'open';
            if (status === 4) return 'canceled';
            return status;
        }
    }, {
        key: 'parseOrderSide',
        value: function parseOrderSide(side) {
            if (side === 1) return 'buy'; // open long position
            if (side === 2) return 'sell'; // open short position
            if (side === 3) return 'sell'; // liquidate long position
            if (side === 4) return 'buy'; // liquidate short position
            return side;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            var type = undefined;
            if ('type' in order) {
                if (order['type'] === 'buy' || order['type'] === 'sell') {
                    side = order['type'];
                    type = 'limit';
                } else if (order['type'] === 'buy_market') {
                    side = 'buy';
                    type = 'market';
                } else if (order['type'] === 'sell_market') {
                    side = 'sell';
                    type = 'market';
                } else {
                    side = this.parseOrderSide(order['type']);
                    if ('contract_name' in order || 'lever_rate' in order) type = 'margin';
                }
            }
            var status = this.parseOrderStatus(order['status']);
            var symbol = undefined;
            if (!market) {
                if ('symbol' in order) if (order['symbol'] in this.markets_by_id) market = this.markets_by_id[order['symbol']];
            }
            if (market) symbol = market['symbol'];
            var timestamp = undefined;
            var createDateField = this.getCreateDateField();
            if (createDateField in order) timestamp = order[createDateField];
            var amount = this.safeFloat(order, 'amount');
            var filled = this.safeFloat(order, 'deal_amount');
            var remaining = amount - filled;
            if (type === 'market') {
                remaining = 0;
            }
            var average = this.safeFloat(order, 'avg_price');
            // https://github.com/ccxt/ccxt/issues/2452
            average = this.safeFloat(order, 'price_avg', average);
            var cost = average * filled;
            var result = {
                'info': order,
                'id': order['order_id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': order['price'],
                'average': average,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'getCreateDateField',
        value: function getCreateDateField() {
            // needed for derived exchanges
            // allcoin typo create_data instead of create_date
            return 'create_date';
        }
    }, {
        key: 'getOrdersField',
        value: function getOrdersField() {
            // needed for derived exchanges
            // allcoin typo order instead of orders (expected based on their API docs)
            return 'orders';
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, method, request, response, ordersField, numOrders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (symbol) {
                                    _context9.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a symbol parameter');

                            case 2:
                                _context9.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                method = 'privatePost';
                                request = {
                                    'order_id': id,
                                    'symbol': market['id']
                                    // 'status': 0, // 0 for unfilled orders, 1 for filled orders
                                    // 'current_page': 1, // current page number
                                    // 'page_length': 200, // number of orders returned per page, maximum 200
                                };

                                if (market['future']) {
                                    method += 'Future';
                                    request['contract_type'] = 'this_week'; // next_week, quarter
                                }
                                method += 'OrderInfo';
                                _context9.next = 11;
                                return this[method](this.extend(request, params));

                            case 11:
                                response = _context9.sent;
                                ordersField = this.getOrdersField();
                                numOrders = response[ordersField].length;

                                if (!(numOrders > 0)) {
                                    _context9.next = 16;
                                    break;
                                }

                                return _context9.abrupt('return', this.parseOrder(response[ordersField][0]));

                            case 16:
                                throw new OrderNotFound(this.id + ' order ' + id + ' not found');

                            case 17:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x28) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, method, request, order_id_in_params, status, name, response, ordersField;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (symbol) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol parameter');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                method = 'privatePost';
                                request = {
                                    'symbol': market['id']
                                };
                                order_id_in_params = 'order_id' in params;

                                if (!market['future']) {
                                    _context10.next = 15;
                                    break;
                                }

                                method += 'FutureOrdersInfo';
                                request['contract_type'] = 'this_week'; // next_week, quarter

                                if (order_id_in_params) {
                                    _context10.next = 13;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders() requires order_id param for futures market ' + symbol + ' (a string of one or more order ids, comma-separated)');

                            case 13:
                                _context10.next = 28;
                                break;

                            case 15:
                                status = undefined;

                                if (!('type' in params)) {
                                    _context10.next = 20;
                                    break;
                                }

                                status = params['type'];
                                _context10.next = 26;
                                break;

                            case 20:
                                if (!('status' in params)) {
                                    _context10.next = 24;
                                    break;
                                }

                                status = params['status'];
                                _context10.next = 26;
                                break;

                            case 24:
                                name = order_id_in_params ? 'type' : 'status';
                                throw new ExchangeError(this.id + ' fetchOrders() requires ' + name + ' param for spot market ' + symbol + ' (0 - for unfilled orders, 1 - for filled/canceled orders)');

                            case 26:
                                if (order_id_in_params) {
                                    method += 'OrdersInfo';
                                    request = this.extend(request, {
                                        'type': status,
                                        'order_id': params['order_id']
                                    });
                                } else {
                                    method += 'OrderHistory';
                                    request = this.extend(request, {
                                        'status': status,
                                        'current_page': 1, // current page number
                                        'page_length': 200 // number of orders returned per page, maximum 200
                                    });
                                }
                                params = this.omit(params, ['type', 'status']);

                            case 28:
                                _context10.next = 30;
                                return this[method](this.extend(request, params));

                            case 30:
                                response = _context10.sent;
                                ordersField = this.getOrdersField();
                                return _context10.abrupt('return', this.parseOrders(response[ordersField], market, since, limit));

                            case 33:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var open;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                open = 0; // 0 for unfilled orders, 1 for filled orders

                                _context11.next = 3;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': open
                                }, params));

                            case 3:
                                return _context11.abrupt('return', _context11.sent);

                            case 4:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var closed, orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                closed = 1; // 0 for unfilled orders, 1 for filled orders

                                _context12.next = 3;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': closed
                                }, params));

                            case 3:
                                orders = _context12.sent;
                                return _context12.abrupt('return', orders);

                            case 5:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchClosedOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, currencyId, request, query, passwordInRequest, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.checkAddress(address);
                                _context13.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                // if (amount < 0.01)
                                //     throw new ExchangeError (this.id + ' withdraw() requires amount > 0.01');
                                // for some reason they require to supply a pair of currencies for withdrawing one currency

                                currencyId = currency['id'] + '_usd';
                                request = {
                                    'symbol': currencyId,
                                    'withdraw_address': address,
                                    'withdraw_amount': amount,
                                    'target': 'address' // or 'okcn', 'okcom', 'okex'
                                };
                                query = params;

                                if (!('chargefee' in query)) {
                                    _context13.next = 12;
                                    break;
                                }

                                request['chargefee'] = query['chargefee'];
                                query = this.omit(query, 'chargefee');
                                _context13.next = 13;
                                break;

                            case 12:
                                throw new ExchangeError(this.id + ' withdraw() requires a `chargefee` parameter');

                            case 13:
                                if (this.password) {
                                    request['trade_pwd'] = this.password;
                                } else if ('password' in query) {
                                    request['trade_pwd'] = query['password'];
                                    query = this.omit(query, 'password');
                                } else if ('trade_pwd' in query) {
                                    request['trade_pwd'] = query['trade_pwd'];
                                    query = this.omit(query, 'trade_pwd');
                                }
                                passwordInRequest = 'trade_pwd' in request;

                                if (passwordInRequest) {
                                    _context13.next = 17;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' withdraw() requires this.password set on the exchange instance or a password / trade_pwd parameter');

                            case 17:
                                _context13.next = 19;
                                return this.privatePostWithdraw(this.extend(request, query));

                            case 19:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': this.safeString(response, 'withdraw_id')
                                });

                            case 21:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function withdraw(_x43, _x44, _x45) {
                return _ref13.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/';
            if (api !== 'web') url += this.version + '/';
            url += path + this.extension;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var query = this.keysort(this.extend({
                    'api_key': this.apiKey
                }, params));
                // secret key must be at the end of query
                var queryString = this.rawencode(query) + '&secret_key=' + this.secret;
                query['sign'] = this.hash(this.encode(queryString)).toUpperCase();
                body = this.urlencode(query);
                headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            url = this.urls['api'][api] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if ('error_code' in response) {
                    var error = this.safeString(response, 'error_code');
                    var message = this.id + ' ' + this.json(response);
                    if (error in this.exceptions) {
                        var ExceptionClass = this.exceptions[error];
                        throw new ExceptionClass(message);
                    } else {
                        throw new ExchangeError(message);
                    }
                }
                if ('result' in response) if (!response['result']) throw new ExchangeError(this.id + ' ' + this.json(response));
            }
        }
    }]);

    return okcoinusd;
}(Exchange);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    InsufficientFunds = _require.InsufficientFunds;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(huobipro, _Exchange);

    function huobipro() {
        _classCallCheck(this, huobipro);

        return _possibleConstructorReturn(this, (huobipro.__proto__ || Object.getPrototypeOf(huobipro)).apply(this, arguments));
    }

    _createClass(huobipro, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(huobipro.prototype.__proto__ || Object.getPrototypeOf(huobipro.prototype), 'describe', this).call(this), {
                'id': 'huobipro',
                'name': 'Huobi Pro',
                'countries': 'CN',
                'rateLimit': 2000,
                'userAgent': this.userAgents['chrome39'],
                'version': 'v1',
                'accounts': undefined,
                'accountsById': undefined,
                'hostname': 'api.huobipro.com',
                'has': {
                    'CORS': false,
                    'fetchDepositAddress': true,
                    'fetchOHCLV': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchOrder': true,
                    'fetchOrders': false,
                    'fetchTradingLimits': true,
                    'withdraw': true,
                    'fetchCurrencies': true
                },
                'timeframes': {
                    '1m': '1min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '60min',
                    '1d': '1day',
                    '1w': '1week',
                    '1M': '1mon',
                    '1y': '1year'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766569-15aa7b9a-5edd-11e7-9e7f-44791f4ee49c.jpg',
                    'api': 'https://api.huobipro.com',
                    'www': 'https://www.huobipro.com',
                    'doc': 'https://github.com/huobiapi/API_Docs/wiki/REST_api_reference',
                    'fees': 'https://www.huobipro.com/about/fee/'
                },
                'api': {
                    'market': {
                        'get': ['history/kline', // 获取K线数据
                        'detail/merged', // 获取聚合行情(Ticker)
                        'depth', // 获取 Market Depth 数据
                        'trade', // 获取 Trade Detail 数据
                        'history/trade', // 批量获取最近的交易记录
                        'detail']
                    },
                    'public': {
                        'get': ['common/symbols', // 查询系统支持的所有交易对
                        'common/currencys', // 查询系统支持的所有币种
                        'common/timestamp', // 查询系统当前时间
                        'common/exchange', // order limits
                        'settings/currencys']
                    },
                    'private': {
                        'get': ['account/accounts', // 查询当前用户的所有账户(即account-id)
                        'account/accounts/{id}/balance', // 查询指定账户的余额
                        'order/orders/{id}', // 查询某个订单详情
                        'order/orders/{id}/matchresults', // 查询某个订单的成交明细
                        'order/orders', // 查询当前委托、历史委托
                        'order/matchresults', // 查询当前成交、历史成交
                        'dw/withdraw-virtual/addresses', // 查询虚拟币提现地址
                        'dw/deposit-virtual/addresses', 'query/deposit-withdraw', 'margin/loan-orders', // 借贷订单
                        'margin/accounts/balance'],
                        'post': ['order/orders/place', // 创建并执行一个新订单 (一步下单， 推荐使用)
                        'order/orders', // 创建一个新的订单请求 （仅创建订单，不执行下单）
                        'order/orders/{id}/place', // 执行一个订单 （仅执行已创建的订单）
                        'order/orders/{id}/submitcancel', // 申请撤销一个订单请求
                        'order/orders/batchcancel', // 批量撤销订单
                        'dw/balance/transfer', // 资产划转
                        'dw/withdraw/api/create', // 申请提现虚拟币
                        'dw/withdraw-virtual/create', // 申请提现虚拟币
                        'dw/withdraw-virtual/{id}/place', // 确认申请虚拟币提现
                        'dw/withdraw-virtual/{id}/cancel', // 申请取消提现虚拟币
                        'dw/transfer-in/margin', // 现货账户划入至借贷账户
                        'dw/transfer-out/margin', // 借贷账户划出至现货账户
                        'margin/orders', // 申请借贷
                        'margin/orders/{id}/repay']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.002,
                        'taker': 0.002
                    }
                },
                'exceptions': {
                    'account-frozen-balance-insufficient-error': InsufficientFunds, // {"status":"error","err-code":"account-frozen-balance-insufficient-error","err-msg":"trade account balance is not enough, left: `0.0027`","data":null}
                    'order-limitorder-amount-min-error': InvalidOrder, // limit order amount error, min: `0.001`
                    'order-orderstate-error': OrderNotFound, // canceling an already canceled order
                    'order-queryorder-invalid': OrderNotFound, // querying a non-existent order
                    'order-update-error': ExchangeNotAvailable // undocumented error
                },
                'options': {
                    'fetchMarketsMethod': 'publicGetCommonSymbols',
                    'language': 'en-US'
                }
            });
        }
    }, {
        key: 'loadTradingLimits',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, limits, keys, i, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(reload || !('limitsLoaded' in this.options))) {
                                    _context.next = 7;
                                    break;
                                }

                                _context.next = 3;
                                return this.fetchTradingLimits(symbols);

                            case 3:
                                response = _context.sent;
                                limits = response['limits'];
                                keys = Object.keys(limits);

                                for (i = 0; i < keys.length; i++) {
                                    symbol = keys[i];

                                    this.markets[symbol] = this.deepExtend(this.markets[symbol], {
                                        'limits': limits[symbol]
                                    });
                                }

                            case 7:
                                return _context.abrupt('return', this.markets);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadTradingLimits() {
                return _ref.apply(this, arguments);
            }

            return loadTradingLimits;
        }()
    }, {
        key: 'fetchTradingLimits',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var info, limits, i, symbol, market, response, limit;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                info = {};
                                limits = {};

                                if (typeof symbols === 'undefined') symbols = this.symbols;
                                i = 0;

                            case 6:
                                if (!(i < symbols.length)) {
                                    _context2.next = 18;
                                    break;
                                }

                                symbol = symbols[i];
                                market = this.market(symbol);
                                _context2.next = 11;
                                return this.publicGetCommonExchange(this.extend({
                                    'symbol': market['id']
                                }));

                            case 11:
                                response = _context2.sent;
                                limit = this.parseTradingLimits(response);

                                info[symbol] = response;
                                limits[symbol] = limit;

                            case 15:
                                i++;
                                _context2.next = 6;
                                break;

                            case 18:
                                return _context2.abrupt('return', {
                                    'limits': limits,
                                    'info': info
                                });

                            case 19:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTradingLimits() {
                return _ref2.apply(this, arguments);
            }

            return fetchTradingLimits;
        }()
    }, {
        key: 'parseTradingLimits',
        value: function parseTradingLimits(response) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var data = response['data'];
            if (typeof data === 'undefined') {
                return undefined;
            }
            return {
                'amount': {
                    'min': data['limit-order-must-greater-than'],
                    'max': data['limit-order-must-less-than']
                }
            };
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var method, response, markets, numMarkets, result, i, market, baseId, quoteId, base, quote, id, symbol, precision, lot, maker, taker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                method = this.options['fetchMarketsMethod'];
                                _context3.next = 3;
                                return this[method]();

                            case 3:
                                response = _context3.sent;
                                markets = response['data'];
                                numMarkets = markets.length;

                                if (!(numMarkets < 1)) {
                                    _context3.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' publicGetCommonSymbols returned empty response: ' + this.json(markets));

                            case 8:
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    baseId = market['base-currency'];
                                    quoteId = market['quote-currency'];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();
                                    id = baseId + quoteId;

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': market['amount-precision'],
                                        'price': market['price-precision']
                                    };
                                    lot = Math.pow(10, -precision['amount']);
                                    maker = base === 'OMG' ? 0 : 0.2 / 100;
                                    taker = base === 'OMG' ? 0 : 0.2 / 100;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'lot': lot,
                                        'active': true,
                                        'precision': precision,
                                        'taker': taker,
                                        'maker': maker,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': 0,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context3.abrupt('return', result);

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchMarkets() {
                return _ref3.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var timestamp = this.milliseconds();
            if ('ts' in ticker) timestamp = ticker['ts'];
            var bid = undefined;
            var ask = undefined;
            var bidVolume = undefined;
            var askVolume = undefined;
            if ('bid' in ticker) {
                if (Array.isArray(ticker['bid'])) {
                    bid = this.safeFloat(ticker['bid'], 0);
                    bidVolume = this.safeFloat(ticker['bid'], 1);
                }
            }
            if ('ask' in ticker) {
                if (Array.isArray(ticker['ask'])) {
                    ask = this.safeFloat(ticker['ask'], 0);
                    askVolume = this.safeFloat(ticker['ask'], 1);
                }
            }
            var open = this.safeFloat(ticker, 'open');
            var close = this.safeFloat(ticker, 'close');
            var change = undefined;
            var percentage = undefined;
            var average = undefined;
            if (typeof open !== 'undefined' && typeof close !== 'undefined') {
                change = close - open;
                average = this.sum(open, close) / 2;
                if (typeof close !== 'undefined' && close > 0) percentage = change / open * 100;
            }
            var baseVolume = this.safeFloat(ticker, 'amount');
            var quoteVolume = this.safeFloat(ticker, 'vol');
            var vwap = undefined;
            if (typeof baseVolume !== 'undefined' && typeof quoteVolume !== 'undefined' && baseVolume > 0) vwap = quoteVolume / baseVolume;
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': ticker['high'],
                'low': ticker['low'],
                'bid': bid,
                'bidVolume': bidVolume,
                'ask': ask,
                'askVolume': askVolume,
                'vwap': vwap,
                'open': open,
                'close': close,
                'last': close,
                'previousClose': undefined,
                'change': change,
                'percentage': percentage,
                'average': average,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.marketGetDepth(this.extend({
                                    'symbol': market['id'],
                                    'type': 'step0'
                                }, params));

                            case 5:
                                response = _context4.sent;

                                if (!('tick' in response)) {
                                    _context4.next = 13;
                                    break;
                                }

                                if (response['tick']) {
                                    _context4.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrderBook() returned empty response: ' + this.json(response));

                            case 9:
                                orderbook = response['tick'];
                                timestamp = orderbook['ts'];

                                orderbook['nonce'] = orderbook['version'];
                                return _context4.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 13:
                                throw new ExchangeError(this.id + ' fetchOrderBook() returned unrecognized response: ' + this.json(response));

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x9) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.marketGetDetailMerged(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(response['tick'], market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['ts'];
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['direction'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, data, result, i, trades, j, trade;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['size'] = limit;
                                _context6.next = 7;
                                return this.marketGetHistoryTrade(this.extend(request, params));

                            case 7:
                                response = _context6.sent;
                                data = response['data'];
                                result = [];

                                for (i = 0; i < data.length; i++) {
                                    trades = data[i]['data'];

                                    for (j = 0; j < trades.length; j++) {
                                        trade = this.parseTrade(trades[j], market);

                                        result.push(trade);
                                    }
                                }
                                result = this.sortBy(result, 'timestamp');
                                return _context6.abrupt('return', this.filterBySymbolSinceLimit(result, symbol, since, limit));

                            case 13:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x14) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv['id'] * 1000, ohlcv['open'], ohlcv['high'], ohlcv['low'], ohlcv['close'], ohlcv['amount']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'period': this.timeframes[timeframe]
                                };

                                if (typeof limit !== 'undefined') {
                                    request['size'] = limit;
                                }
                                _context7.next = 7;
                                return this.marketGetHistoryKline(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(response['data'], market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x22) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'loadAccounts',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var reload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!reload) {
                                    _context8.next = 6;
                                    break;
                                }

                                _context8.next = 3;
                                return this.fetchAccounts();

                            case 3:
                                this.accounts = _context8.sent;
                                _context8.next = 14;
                                break;

                            case 6:
                                if (!this.accounts) {
                                    _context8.next = 10;
                                    break;
                                }

                                return _context8.abrupt('return', this.accounts);

                            case 10:
                                _context8.next = 12;
                                return this.fetchAccounts();

                            case 12:
                                this.accounts = _context8.sent;

                                this.accountsById = this.indexBy(this.accounts, 'id');

                            case 14:
                                return _context8.abrupt('return', this.accounts);

                            case 15:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function loadAccounts() {
                return _ref8.apply(this, arguments);
            }

            return loadAccounts;
        }()
    }, {
        key: 'fetchAccounts',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privateGetAccountAccounts();

                            case 4:
                                response = _context9.sent;
                                return _context9.abrupt('return', response['data']);

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchAccounts() {
                return _ref9.apply(this, arguments);
            }

            return fetchAccounts;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, precision, code, active;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.publicGetSettingsCurrencys(this.extend({
                                    'language': this.options['language']
                                }, params));

                            case 2:
                                response = _context10.sent;
                                currencies = response['data'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    //
                                    //  {                     name: "ctxc",
                                    //              'display-name': "CTXC",
                                    //        'withdraw-precision':  8,
                                    //             'currency-type': "eth",
                                    //        'currency-partition': "pro",
                                    //             'support-sites':  null,
                                    //                'otc-enable':  0,
                                    //        'deposit-min-amount': "2",
                                    //       'withdraw-min-amount': "4",
                                    //            'show-precision': "8",
                                    //                      weight: "2988",
                                    //                     visible:  true,
                                    //              'deposit-desc': "Please don’t deposit any other digital assets except CTXC t…",
                                    //             'withdraw-desc': "Minimum withdrawal amount: 4 CTXC. !>_<!For security reason…",
                                    //           'deposit-enabled':  true,
                                    //          'withdraw-enabled':  true,
                                    //    'currency-addr-with-tag':  false,
                                    //             'fast-confirms':  15,
                                    //             'safe-confirms':  30                                                             }
                                    //

                                    id = this.safeValue(currency, 'name');
                                    precision = this.safeInteger(currency, 'withdraw-precision');
                                    code = this.commonCurrencyCode(id.toUpperCase());
                                    active = currency['visible'] && currency['deposit-enabled'] && currency['withdraw-enabled'];

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'type': 'crypto',
                                        // 'payin': currency['deposit-enabled'],
                                        // 'payout': currency['withdraw-enabled'],
                                        // 'transfer': undefined,
                                        'name': currency['display-name'],
                                        'active': active,
                                        'status': active ? 'ok' : 'disabled',
                                        'fee': undefined, // todo need to fetch from fee endpoint
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'deposit': {
                                                'min': this.safeFloat(currency, 'deposit-min-amount'),
                                                'max': Math.pow(10, precision)
                                            },
                                            'withdraw': {
                                                'min': this.safeFloat(currency, 'withdraw-min-amount'),
                                                'max': Math.pow(10, precision)
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context10.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchCurrencies() {
                return _ref10.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, i, balance, uppercase, currency, account;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.loadAccounts();

                            case 4:
                                _context11.next = 6;
                                return this.privateGetAccountAccountsIdBalance(this.extend({
                                    'id': this.accounts[0]['id']
                                }, params));

                            case 6:
                                response = _context11.sent;
                                balances = response['data']['list'];
                                result = { 'info': response };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    uppercase = balance['currency'].toUpperCase();
                                    currency = this.commonCurrencyCode(uppercase);
                                    account = undefined;

                                    if (currency in result) account = result[currency];else account = this.account();
                                    if (balance['type'] === 'trade') account['free'] = parseFloat(balance['balance']);
                                    if (balance['type'] === 'frozen') account['used'] = parseFloat(balance['balance']);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context11.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchBalance() {
                return _ref11.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrdersByStates',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(states) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (symbol) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders() requires a symbol parameter');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context12.next = 7;
                                return this.privateGetOrderOrders(this.extend({
                                    'symbol': market['id'],
                                    'states': states
                                }, params));

                            case 7:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseOrders(response['data'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrdersByStates(_x30) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrdersByStates;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetchOrdersByStates('pre-submitted,submitted,partial-filled,filled,partial-canceled,canceled', symbol, since, limit, params);

                            case 2:
                                return _context13.abrupt('return', _context13.sent);

                            case 3:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetchOrdersByStates('pre-submitted,submitted,partial-filled', symbol, since, limit, params);

                            case 2:
                                return _context14.abrupt('return', _context14.sent);

                            case 3:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchOpenOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.fetchOrdersByStates('filled,partial-canceled,canceled', symbol, since, limit, params);

                            case 2:
                                return _context15.abrupt('return', _context15.sent);

                            case 3:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchClosedOrders() {
                return _ref15.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context16.next = 4;
                                return this.privateGetOrderOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context16.sent;
                                return _context16.abrupt('return', this.parseOrder(response['data']));

                            case 6:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchOrder(_x47) {
                return _ref16.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            if (status === 'partial-filled') {
                return 'open';
            } else if (status === 'partial-canceled') {
                return 'canceled';
            } else if (status === 'filled') {
                return 'closed';
            } else if (status === 'canceled') {
                return 'canceled';
            } else if (status === 'submitted') {
                return 'open';
            }
            return status;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            var type = undefined;
            var status = undefined;
            if ('type' in order) {
                var orderType = order['type'].split('-');
                side = orderType[0];
                type = orderType[1];
                status = this.parseOrderStatus(order['state']);
            }
            var symbol = undefined;
            if (!market) {
                if ('symbol' in order) {
                    if (order['symbol'] in this.markets_by_id) {
                        var marketId = order['symbol'];
                        market = this.markets_by_id[marketId];
                    }
                }
            }
            if (market) symbol = market['symbol'];
            var timestamp = order['created-at'];
            var amount = this.safeFloat(order, 'amount');
            var filled = parseFloat(order['field-amount']);
            var remaining = amount - filled;
            var price = this.safeFloat(order, 'price');
            var cost = parseFloat(order['field-cash-amount']);
            var average = 0;
            if (filled) average = parseFloat(cost / filled);
            var result = {
                'info': order,
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'average': average,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response, timestamp;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context17.next = 4;
                                return this.loadAccounts();

                            case 4:
                                market = this.market(symbol);
                                order = {
                                    'account-id': this.accounts[0]['id'],
                                    'amount': this.amountToPrecision(symbol, amount),
                                    'symbol': market['id'],
                                    'type': side + '-' + type
                                };

                                if (type === 'limit') order['price'] = this.priceToPrecision(symbol, price);
                                _context17.next = 9;
                                return this.privatePostOrderOrdersPlace(this.extend(order, params));

                            case 9:
                                response = _context17.sent;
                                timestamp = this.milliseconds();
                                return _context17.abrupt('return', {
                                    'info': response,
                                    'id': response['data'],
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': undefined,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'amount': amount,
                                    'filled': undefined,
                                    'remaining': undefined,
                                    'cost': undefined,
                                    'trades': undefined,
                                    'fee': undefined
                                });

                            case 12:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function createOrder(_x51, _x52, _x53, _x54) {
                return _ref17.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.privatePostOrderOrdersIdSubmitcancel({ 'id': id });

                            case 2:
                                return _context18.abrupt('return', _context18.sent);

                            case 3:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function cancelOrder(_x57) {
                return _ref18.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context19.next = 5;
                                return this.privateGetDwDepositVirtualAddresses(this.extend({
                                    'currency': currency['id'].toLowerCase()
                                }, params));

                            case 5:
                                response = _context19.sent;
                                address = this.safeString(response, 'data');

                                this.checkAddress(address);
                                return _context19.abrupt('return', {
                                    'currency': code,
                                    'status': 'ok',
                                    'address': address,
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function fetchDepositAddress(_x60) {
                return _ref19.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(currency, fee) {
            return parseFloat(this.decimalToPrecision(fee, 0, this.currencies[currency]['precision']));
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var rate = market[takerOrMaker];
            var cost = amount * rate;
            var key = 'quote';
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(market[key], cost))
            };
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response, id;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _context20.next = 2;
                                return this.loadMarkets();

                            case 2:
                                this.checkAddress(address);
                                currency = this.currency(code);
                                request = {
                                    'address': address, // only supports existing addresses in your withdraw address list
                                    'amount': amount,
                                    'currency': currency['id']
                                };

                                if (tag) request['addr-tag'] = tag; // only for XRP?
                                _context20.next = 8;
                                return this.privatePostDwWithdrawApiCreate(this.extend(request, params));

                            case 8:
                                response = _context20.sent;
                                id = undefined;

                                if ('data' in response) {
                                    id = response['data'];
                                }
                                return _context20.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 12:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function withdraw(_x64, _x65, _x66) {
                return _ref20.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/';
            if (api === 'market') url += api;else url += this.version;
            url += '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                var timestamp = this.ymdhms(this.milliseconds(), 'T');
                var request = this.keysort(this.extend({
                    'SignatureMethod': 'HmacSHA256',
                    'SignatureVersion': '2',
                    'AccessKeyId': this.apiKey,
                    'Timestamp': timestamp
                }, query));
                var auth = this.urlencode(request);
                // unfortunately, PHP demands double quotes for the escaped newline symbol
                // eslint-disable-next-line quotes
                var payload = [method, this.hostname, url, auth].join("\n");
                var signature = this.hmac(this.encode(payload), this.encode(this.secret), 'sha256', 'base64');
                auth += '&' + this.urlencode({ 'Signature': signature });
                url += '?' + auth;
                if (method === 'POST') {
                    body = this.json(query);
                    headers = {
                        'Content-Type': 'application/json'
                    };
                } else {
                    headers = {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    };
                }
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            url = this.urls['api'] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('status' in response) {
                    //
                    //     {"status":"error","err-code":"order-limitorder-amount-min-error","err-msg":"limit order amount error, min: `0.001`","data":null}
                    //
                    var status = this.safeString(response, 'status');
                    if (status === 'error') {
                        var code = this.safeString(response, 'err-code');
                        var feedback = this.id + ' ' + this.json(response);
                        var exceptions = this.exceptions;
                        if (code in exceptions) {
                            throw new exceptions[code](feedback);
                        }
                        throw new ExchangeError(feedback);
                    }
                }
            }
        }
    }]);

    return huobipro;
}(Exchange);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var uuid = function uuid(a) {
                        return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
};

module.exports = { uuid: uuid

                        // hasFetchOHLCV → has_fetch_ohlcv; parseHTTPResponse → parse_http_response
                        , unCamelCase: function unCamelCase(s) {
                                                return s.match(/^[A-Z0-9_]+$/) ? s : s.replace(/[a-z0-9][A-Z]/g, function (x) {
                                                                        return x[0] + '_' + x[1];
                                                }).replace(/[A-Z0-9][A-Z0-9][a-z]/g, function (x) {
                                                                        return x[0] + '_' + x[1] + x[2];
                                                }).toLowerCase();
                        },

                        capitalize: function capitalize(s) {
                                                return s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
                        }

                        /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isNumber = Number.isFinite,
    isArray = Array.isArray,
    isString = function isString(s) {
    return typeof s === 'string';
},
    isObject = function isObject(o) {
    return o !== null && (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object';
},
    isDictionary = function isDictionary(o) {
    return isObject(o) && !isArray(o);
},
    isStringCoercible = function isStringCoercible(x) {
    return hasProps(x) && x.toString || isNumber(x);
};

/*  .............................................   */

var hasProps = function hasProps(o) {
    return o !== undefined && o !== null;
},
    prop = function prop(o, k) {
    return isObject(o) ? o[k] : undefined;
};

/*  .............................................   */

var asFloat = function asFloat(x) {
    return isNumber(x) || isString(x) ? parseFloat(x) : NaN;
},
    asInteger = function asInteger(x) {
    return isNumber(x) || isString(x) ? parseInt(x, 10) : NaN;
};

/*  .............................................   */

module.exports = { isNumber: isNumber,
    isArray: isArray,
    isObject: isObject,
    isString: isString,
    isStringCoercible: isStringCoercible,
    isDictionary: isDictionary,

    hasProps: hasProps,
    prop: prop,

    asFloat: asFloat,
    asInteger: asInteger,

    safeFloat: function safeFloat(o, k, $default) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : asFloat(prop(o, k));
        return isNumber(n) ? n : $default;
    },
    safeInteger: function safeInteger(o, k, $default) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : asInteger(prop(o, k));
        return isNumber(n) ? n : $default;
    },
    safeValue: function safeValue(o, k, $default) {
        var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prop(o, k);
        return hasProps(x) ? x : $default;
    },
    safeString: function safeString(o, k, $default) {
        var x = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : prop(o, k);
        return isStringCoercible(x) ? String(x) : $default;
    }

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(13),
    isString = _require.isString,
    isNumber = _require.isNumber;

var max = Math.max;

/*  ------------------------------------------------------------------------

    NB: initially, I used objects for options passing:

            decimalToPrecision ('123.456', { digits: 2, round: true, afterPoint: true })

    ...but it turns out it's hard to port that across different languages and it is also
       probably has a performance penalty -- while it's a performance critical code! So
       I switched to using named constants instead, as it is actually more readable and
       succinct, and surely doesn't come with any inherent performance downside:

            decimalToPrecision ('123.456', ROUND, 2, DECIMAL_PLACES)                     */

var ROUND = 0 // rounding mode
,
    TRUNCATE = 1;

var DECIMAL_PLACES = 0 // digits counting mode
,
    SIGNIFICANT_DIGITS = 1;

var NO_PADDING = 0 // zero-padding mode
,
    PAD_WITH_ZERO = 1;

var precisionConstants = {
    ROUND: ROUND,
    TRUNCATE: TRUNCATE,
    DECIMAL_PLACES: DECIMAL_PLACES,
    SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS,
    NO_PADDING: NO_PADDING,
    PAD_WITH_ZERO: PAD_WITH_ZERO

    /*  ------------------------------------------------------------------------ */

    // See https://stackoverflow.com/questions/1685680/how-to-avoid-scientific-notation-for-large-numbers-in-javascript for discussion

};function numberToString(x) {
    // avoids scientific notation for too large and too small numbers

    if (isString(x)) return x;

    if (Math.abs(x) < 1.0) {
        var s = x.toString();
        var e = parseInt(s.split('e-')[1]);
        var neg = s[0] === '-';
        if (e) {
            x *= Math.pow(10, e - 1);
            x = (neg ? '-' : '') + '0.' + new Array(e).join('0') + x.toString().substring(neg ? 3 : 2);
        }
    } else {
        var _e = parseInt(x.toString().split('+')[1]);
        if (_e > 20) {
            _e -= 20;
            x /= Math.pow(10, _e);
            x += new Array(_e + 1).join('0');
        }
    }
    return x.toString();
}

//-----------------------------------------------------------------------------
// expects non-scientific notation

var truncate_regExpCache = [],
    truncate_to_string = function truncate_to_string(num) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    num = numberToString(num);
    if (precision > 0) {
        var re = truncate_regExpCache[precision] || (truncate_regExpCache[precision] = new RegExp("([-]*\\d+\\.\\d{" + precision + "})(\\d)"));

        var _ref = num.toString().match(re) || [null, num],
            _ref2 = _slicedToArray(_ref, 2),
            result = _ref2[1];

        return result.toString();
    }
    return parseInt(num).toString();
},
    truncate = function truncate(num) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return parseFloat(truncate_to_string(num, precision));
};

function precisionFromString(string) {
    var split = string.replace(/0+$/g, '').split('.');
    return split.length > 1 ? split[1].length : 0;
}

/*  ------------------------------------------------------------------------ */

var decimalToPrecision = function decimalToPrecision(x, roundingMode, numPrecisionDigits) {
    var countingMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DECIMAL_PLACES;
    var paddingMode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : NO_PADDING;


    if (numPrecisionDigits < 0) throw new Error('negative precision is not yet supported');

    /*  Convert to a string (if needed), skip leading minus sign (if any)   */

    var str = numberToString(x),
        isNegative = str[0] === '-',
        strStart = isNegative ? 1 : 0,
        strEnd = str.length;

    /*  Find the dot position in the source buffer   */

    for (var strDot = 0; strDot < strEnd; strDot++) {
        if (str[strDot] === '.') break;
    }var hasDot = strDot < str.length;

    /*  Char code constants         */

    var MINUS = 45,
        DOT = 46,
        ZERO = 48,
        ONE = ZERO + 1,
        FIVE = ZERO + 5,
        NINE = ZERO + 9;

    /*  For -123.4567 the `chars` array will hold 01234567 (leading zero is reserved for rounding cases when 099 → 100)    */

    var chars = new Uint8Array(strEnd - strStart + (hasDot ? 0 : 1));
    chars[0] = ZERO;

    /*  Validate & copy digits, determine certain locations in the resulting buffer  */

    var afterDot = chars.length,
        digitsStart = -1 // significant digits
    ,
        digitsEnd = -1;

    for (var i = 1, j = strStart; j < strEnd; j++, i++) {

        var c = str.charCodeAt(j);

        if (c === DOT) {
            afterDot = i--;
        } else if (c < ZERO || c > NINE) {
            throw new Error(str + ': invalid number (contains an illegal character \'' + str[i - 1] + '\')');
        } else {
            chars[i] = c;
            if (c !== ZERO && digitsStart < 0) digitsStart = i;
        }
    }

    if (digitsStart < 0) digitsStart = 1;

    /*  Determine the range to cut  */

    var precisionStart = countingMode === DECIMAL_PLACES ? afterDot // 0.(0)001234567
    : digitsStart // 0.00(1)234567
    ,
        precisionEnd = precisionStart + numPrecisionDigits;

    /*  Reset the last significant digit index, as it will change during the rounding/truncation.   */

    digitsEnd = -1;

    /*  Perform rounding/truncation per digit, from digitsEnd to digitsStart, by using the following
        algorithm (rounding 999 → 1000, as an example):
    
            step  =          i=3      i=2      i=1      i=0
    
            chars =         0999     0999     0900     1000
            memo  =         ---0     --1-     -1--     0---                     */

    for (var _i = chars.length - 1, memo = 0; _i >= 0; _i--) {

        var _c = chars[_i];

        if (_i !== 0) {
            _c += memo;

            if (_i >= precisionStart + numPrecisionDigits) {

                var ceil = roundingMode === ROUND && _c >= FIVE && !(_c === FIVE && memo); // prevents rounding of 1.45 to 2

                _c = ceil ? NINE + 1 : ZERO;
            }
            if (_c > NINE) {
                _c = ZERO;memo = 1;
            } else memo = 0;
        } else if (memo) _c = ONE; // leading extra digit (0900 → 1000)

        chars[_i] = _c;

        if (_c !== ZERO) {
            digitsStart = _i;
            digitsEnd = digitsEnd < 0 ? _i + 1 : digitsEnd;
        }
    }

    /*  Update the precision range, as `digitsStart` may have changed...     */

    if (countingMode === SIGNIFICANT_DIGITS) {
        precisionStart = digitsStart;
        precisionEnd = precisionStart + numPrecisionDigits;
    }

    /*  Determine the input character range     */

    var readStart = digitsStart >= afterDot ? afterDot - 1 : digitsStart // 0.000(1)234  ----> (0).0001234
    ,
        readEnd = digitsEnd < afterDot ? afterDot : digitsEnd; // 12(3)000     ----> 123000( )

    /*  Compute various sub-ranges       */

    var nSign = isNegative ? 1 : 0 // (-)123.456
    ,
        nBeforeDot = nSign + (afterDot - readStart) // (-123).456
    ,
        nAfterDot = max(readEnd - afterDot, 0) // -123.(456)
    ,
        actualLength = readEnd - readStart // -(123.456)
    ,
        desiredLength = paddingMode === NO_PADDING ? actualLength : // -(123.456)
    precisionEnd - readStart // -(123.456    )

    ,
        pad = max(desiredLength - actualLength, 0) //  -123.456(    )
    ,
        padStart = nBeforeDot + 1 + nAfterDot //  -123.456( )
    ,
        padEnd = padStart + pad //  -123.456     ( )
    ,
        isInteger = nAfterDot + pad === 0; //  -123

    /*  Fill the output buffer with characters    */

    var out = new Uint8Array(nBeforeDot + (isInteger ? 0 : 1) + nAfterDot + pad);
    // ---------------------
    if (isNegative) out[0] = MINUS; // -     minus sign
    for (i = nSign, j = readStart; i < nBeforeDot; i++, j++) {
        out[i] = chars[j];
    } // 123   before dot
    if (!isInteger) out[nBeforeDot] = DOT; // .     dot
    for (i = nBeforeDot + 1, j = afterDot; i < padStart; i++, j++) {
        out[i] = chars[j];
    } // 456   after dot
    for (i = padStart; i < padEnd; i++) {
        out[i] = ZERO;
    } // 000   padding

    /*  Build a string from the output buffer     */

    return String.fromCharCode.apply(String, _toConsumableArray(out));
};

/*  ------------------------------------------------------------------------ */

module.exports = {

    numberToString: numberToString,
    precisionFromString: precisionFromString,
    decimalToPrecision: decimalToPrecision,
    truncate_to_string: truncate_to_string,
    truncate: truncate,
    precisionConstants: precisionConstants,
    ROUND: ROUND,
    TRUNCATE: TRUNCATE,
    DECIMAL_PLACES: DECIMAL_PLACES,
    SIGNIFICANT_DIGITS: SIGNIFICANT_DIGITS,
    NO_PADDING: NO_PADDING,
    PAD_WITH_ZERO: PAD_WITH_ZERO

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(acx, _Exchange);

    function acx() {
        _classCallCheck(this, acx);

        return _possibleConstructorReturn(this, (acx.__proto__ || Object.getPrototypeOf(acx)).apply(this, arguments));
    }

    _createClass(acx, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(acx.prototype.__proto__ || Object.getPrototypeOf(acx.prototype), 'describe', this).call(this), {
                'id': 'acx',
                'name': 'ACX',
                'countries': 'AU',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'CORS': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'withdraw': true,
                    'fetchOrder': true
                },
                'timeframes': {
                    '1m': '1',
                    '5m': '5',
                    '15m': '15',
                    '30m': '30',
                    '1h': '60',
                    '2h': '120',
                    '4h': '240',
                    '12h': '720',
                    '1d': '1440',
                    '3d': '4320',
                    '1w': '10080'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30247614-1fe61c74-9621-11e7-9e8c-f1a627afa279.jpg',
                    'extension': '.json',
                    'api': 'https://acx.io/api',
                    'www': 'https://acx.io',
                    'doc': 'https://acx.io/documents/api_v2'
                },
                'api': {
                    'public': {
                        'get': ['depth', // Get depth or specified market Both asks and bids are sorted from highest price to lowest.
                        'k_with_pending_trades', // Get K data with pending trades, which are the trades not included in K data yet, because there's delay between trade generated and processed by K data generator
                        'k', // Get OHLC(k line) of specific market
                        'markets', // Get all available markets
                        'order_book', // Get the order book of specified market
                        'order_book/{market}', 'tickers', // Get ticker of all markets
                        'tickers/{market}', // Get ticker of specific market
                        'timestamp', // Get server current time, in seconds since Unix epoch
                        'trades', // Get recent trades on market, each trade is included only once Trades are sorted in reverse creation order.
                        'trades/{market}']
                    },
                    'private': {
                        'get': ['members/me', // Get your profile and accounts info
                        'deposits', // Get your deposits history
                        'deposit', // Get details of specific deposit
                        'deposit_address', // Where to deposit The address field could be empty when a new address is generating (e.g. for bitcoin), you should try again later in that case.
                        'orders', // Get your orders, results is paginated
                        'order', // Get information of specified order
                        'trades/my', // Get your executed trades Trades are sorted in reverse creation order.
                        'withdraws', // Get your cryptocurrency withdraws
                        'withdraw'],
                        'post': ['orders', // Create a Sell/Buy order
                        'orders/multi', // Create multiple sell/buy orders
                        'orders/clear', // Cancel all my orders
                        'order/delete', // Cancel an order
                        'withdraw']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': true,
                        'withdraw': {} // There is only 1% fee on withdrawals to your bank account.
                    }
                },
                'exceptions': {
                    '2002': InsufficientFunds,
                    '2003': OrderNotFound
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, symbol, _symbol$split, _symbol$split2, base, quote;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['id'];
                                    symbol = market['name'];
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetMembersMe();

                            case 4:
                                response = _context2.sent;
                                balances = response['accounts'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    uppercase = currency.toUpperCase();
                                    account = {
                                        'free': parseFloat(balance['balance']),
                                        'used': parseFloat(balance['locked']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[uppercase] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'market': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // default = 300
                                _context3.next = 7;
                                return this.publicGetDepth(this.extend(request, params));

                            case 7:
                                orderbook = _context3.sent;
                                timestamp = orderbook['timestamp'] * 1000;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['at'] * 1000;
            ticker = ticker['ticker'];
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, base, quote, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                tickers = _context4.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = undefined;
                                    symbol = id;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    } else {
                                        base = id.slice(0, 3);
                                        quote = id.slice(3, 6);

                                        base = base.toUpperCase();
                                        quote = quote.toUpperCase();
                                        base = this.commonCurrencyCode(base);
                                        quote = this.commonCurrencyCode(quote);
                                        symbol = base + '/' + quote;
                                    }
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTickersMarket(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(response, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['created_at']);
            return {
                'id': trade['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'volume'),
                'cost': this.safeFloat(trade, 'funds'),
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0] * 1000, ohlcv[1], ohlcv[2], ohlcv[3], ohlcv[4], ohlcv[5]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!limit) limit = 500; // default is 30
                                request = {
                                    'market': market['id'],
                                    'period': this.timeframes[timeframe],
                                    'limit': limit
                                };

                                if (typeof since !== 'undefined') request['timestamp'] = since;
                                _context7.next = 8;
                                return this.publicGetK(this.extend(request, params));

                            case 8:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x19) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                var marketId = order['market'];
                symbol = this.markets_by_id[marketId]['symbol'];
            }
            var timestamp = this.parse8601(order['created_at']);
            var state = order['state'];
            var status = undefined;
            if (state === 'done') {
                status = 'closed';
            } else if (state === 'wait') {
                status = 'open';
            } else if (state === 'cancel') {
                status = 'canceled';
            }
            return {
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['ord_type'],
                'side': order['side'],
                'price': this.safeFloat(order, 'price'),
                'amount': this.safeFloat(order, 'volume'),
                'filled': this.safeFloat(order, 'executed_volume'),
                'remaining': this.safeFloat(order, 'remaining_volume'),
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateGetOrder(this.extend({
                                    'id': parseInt(id)
                                }, params));

                            case 4:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrder(_x25) {
                return _ref8.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response, market;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'market': this.marketId(symbol),
                                    'side': side,
                                    'volume': amount.toString(),
                                    'ord_type': type
                                };

                                if (type === 'limit') {
                                    order['price'] = price.toString();
                                }
                                _context9.next = 6;
                                return this.privatePostOrders(this.extend(order, params));

                            case 6:
                                response = _context9.sent;
                                market = this.markets_by_id[response['market']];
                                return _context9.abrupt('return', this.parseOrder(response, market));

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x28, _x29, _x30, _x31) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var result, order, status;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostOrderDelete({ 'id': id });

                            case 4:
                                result = _context10.sent;
                                order = this.parseOrder(result);
                                status = order['status'];

                                if (!(status === 'closed' || status === 'canceled')) {
                                    _context10.next = 9;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' ' + this.json(order));

                            case 9:
                                return _context10.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x34) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                this.checkAddress(address);
                                _context11.next = 3;
                                return this.loadMarkets();

                            case 3:
                                _context11.next = 5;
                                return this.privatePostWithdraw(this.extend({
                                    'currency': currency.toLowerCase(),
                                    'sum': amount,
                                    'address': address
                                }, params));

                            case 5:
                                result = _context11.sent;
                                return _context11.abrupt('return', {
                                    'info': result,
                                    'id': undefined
                                });

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function withdraw(_x37, _x38, _x39) {
                return _ref11.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'encodeParams',
        value: function encodeParams(params) {
            if ('orders' in params) {
                var orders = params['orders'];
                var query = this.urlencode(this.keysort(this.omit(params, 'orders')));
                for (var i = 0; i < orders.length; i++) {
                    var order = orders[i];
                    var keys = Object.keys(order);
                    for (var k = 0; k < keys.length; k++) {
                        var key = keys[k];
                        var value = order[key];
                        query += '&orders%5B%5D%5B' + key + '%5D=' + value.toString();
                    }
                }
                return query;
            }
            return this.urlencode(this.keysort(params));
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = '/api' + '/' + this.version + '/' + this.implodeParams(path, params);
            if ('extension' in this.urls) request += this.urls['extension'];
            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + request;
            if (api === 'public') {
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var _query = this.encodeParams(this.extend({
                    'access_key': this.apiKey,
                    'tonce': nonce
                }, params));
                var auth = method + '|' + request + '|' + _query;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret));
                var suffix = _query + '&signature=' + signature;
                if (method === 'GET') {
                    url += '?' + suffix;
                } else {
                    body = suffix;
                    headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 400) {
                var response = JSON.parse(body);
                var error = this.safeValue(response, 'error');
                var errorCode = this.safeString(error, 'code');
                var feedback = this.id + ' ' + this.json(response);
                var exceptions = this.exceptions;
                if (errorCode in exceptions) {
                    throw new exceptions[errorCode](feedback);
                }
                // fallback to default error handler
            }
        }
    }]);

    return acx;
}(Exchange);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    NotSupported = _require.NotSupported,
    DDoSProtection = _require.DDoSProtection,
    AuthenticationError = _require.AuthenticationError,
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    InvalidNonce = _require.InvalidNonce;

var _require2 = __webpack_require__(14),
    ROUND = _require2.ROUND,
    TRUNCATE = _require2.TRUNCATE,
    SIGNIFICANT_DIGITS = _require2.SIGNIFICANT_DIGITS;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitfinex, _Exchange);

    function bitfinex() {
        _classCallCheck(this, bitfinex);

        return _possibleConstructorReturn(this, (bitfinex.__proto__ || Object.getPrototypeOf(bitfinex)).apply(this, arguments));
    }

    _createClass(bitfinex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitfinex.prototype.__proto__ || Object.getPrototypeOf(bitfinex.prototype), 'describe', this).call(this), {
                'id': 'bitfinex',
                'name': 'Bitfinex',
                'countries': 'VG',
                'version': 'v1',
                'rateLimit': 1500,
                // new metainfo interface
                'has': {
                    'CORS': false,
                    'createDepositAddress': true,
                    'deposit': true,
                    'fetchClosedOrders': true,
                    'fetchDepositAddress': true,
                    'fetchTradingFees': true,
                    'fetchFundingFees': true,
                    'fetchMyTrades': true,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true,
                    'fetchOrder': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '3h': '3h',
                    '6h': '6h',
                    '12h': '12h',
                    '1d': '1D',
                    '1w': '7D',
                    '2w': '14D',
                    '1M': '1M'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766244-e328a50c-5ed2-11e7-947b-041416579bb3.jpg',
                    'api': 'https://api.bitfinex.com',
                    'www': 'https://www.bitfinex.com',
                    'doc': ['https://bitfinex.readme.io/v1/docs', 'https://github.com/bitfinexcom/bitfinex-api-node']
                },
                'api': {
                    'v2': {
                        'get': ['candles/trade:{timeframe}:{symbol}/{section}', 'candles/trade:{timeframe}:{symbol}/last', 'candles/trade:{timeframe}:{symbol}/hist']
                    },
                    'public': {
                        'get': ['book/{symbol}',
                        // 'candles/{symbol}',
                        'lendbook/{currency}', 'lends/{currency}', 'pubticker/{symbol}', 'stats/{symbol}', 'symbols', 'symbols_details', 'tickers', 'today', 'trades/{symbol}']
                    },
                    'private': {
                        'post': ['account_fees', 'account_infos', 'balances', 'basket_manage', 'credits', 'deposit/new', 'funding/close', 'history', 'history/movements', 'key_info', 'margin_infos', 'mytrades', 'mytrades_funding', 'offer/cancel', 'offer/new', 'offer/status', 'offers', 'offers/hist', 'order/cancel', 'order/cancel/all', 'order/cancel/multi', 'order/cancel/replace', 'order/new', 'order/new/multi', 'order/status', 'orders', 'orders/hist', 'position/claim', 'position/close', 'positions', 'summary', 'taken_funds', 'total_taken_funds', 'transfer', 'unused_taken_funds', 'withdraw']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'maker': 0.1 / 100,
                        'taker': 0.2 / 100,
                        'tiers': {
                            'taker': [[0, 0.2 / 100], [500000, 0.2 / 100], [1000000, 0.2 / 100], [2500000, 0.2 / 100], [5000000, 0.2 / 100], [7500000, 0.2 / 100], [10000000, 0.18 / 100], [15000000, 0.16 / 100], [20000000, 0.14 / 100], [25000000, 0.12 / 100], [30000000, 0.1 / 100]],
                            'maker': [[0, 0.1 / 100], [500000, 0.08 / 100], [1000000, 0.06 / 100], [2500000, 0.04 / 100], [5000000, 0.02 / 100], [7500000, 0], [10000000, 0], [15000000, 0], [20000000, 0], [25000000, 0], [30000000, 0]]
                        }
                    },
                    'funding': {
                        'tierBased': false, // true for tier-based/progressive
                        'percentage': false, // fixed commission
                        // Actually deposit fees are free for larger deposits (> $1000 USD equivalent)
                        // these values below are deprecated, we should not hardcode fees and limits anymore
                        // to be reimplemented with bitfinex funding fees from their API or web endpoints
                        'deposit': {
                            'BTC': 0.0004,
                            'IOTA': 0.5,
                            'ETH': 0.0027,
                            'BCH': 0.0001,
                            'LTC': 0.001,
                            'EOS': 0.24279,
                            'XMR': 0.04,
                            'SAN': 0.99269,
                            'DASH': 0.01,
                            'ETC': 0.01,
                            'XRP': 0.02,
                            'YYW': 16.915,
                            'NEO': 0,
                            'ZEC': 0.001,
                            'BTG': 0,
                            'OMG': 0.14026,
                            'DATA': 20.773,
                            'QASH': 1.9858,
                            'ETP': 0.01,
                            'QTUM': 0.01,
                            'EDO': 0.95001,
                            'AVT': 1.3045,
                            'USDT': 0,
                            'TRX': 28.184,
                            'ZRX': 1.9947,
                            'RCN': 10.793,
                            'TNB': 31.915,
                            'SNT': 14.976,
                            'RLC': 1.414,
                            'GNT': 5.8952,
                            'SPK': 10.893,
                            'REP': 0.041168,
                            'BAT': 6.1546,
                            'ELF': 1.8753,
                            'FUN': 32.336,
                            'SNG': 18.622,
                            'AID': 8.08,
                            'MNA': 16.617,
                            'NEC': 1.6504
                        },
                        'withdraw': {
                            'BTC': 0.0004,
                            'IOTA': 0.5,
                            'ETH': 0.0027,
                            'BCH': 0.0001,
                            'LTC': 0.001,
                            'EOS': 0.24279,
                            'XMR': 0.04,
                            'SAN': 0.99269,
                            'DASH': 0.01,
                            'ETC': 0.01,
                            'XRP': 0.02,
                            'YYW': 16.915,
                            'NEO': 0,
                            'ZEC': 0.001,
                            'BTG': 0,
                            'OMG': 0.14026,
                            'DATA': 20.773,
                            'QASH': 1.9858,
                            'ETP': 0.01,
                            'QTUM': 0.01,
                            'EDO': 0.95001,
                            'AVT': 1.3045,
                            'USDT': 20,
                            'TRX': 28.184,
                            'ZRX': 1.9947,
                            'RCN': 10.793,
                            'TNB': 31.915,
                            'SNT': 14.976,
                            'RLC': 1.414,
                            'GNT': 5.8952,
                            'SPK': 10.893,
                            'REP': 0.041168,
                            'BAT': 6.1546,
                            'ELF': 1.8753,
                            'FUN': 32.336,
                            'SNG': 18.622,
                            'AID': 8.08,
                            'MNA': 16.617,
                            'NEC': 1.6504
                        }
                    }
                },
                'commonCurrencies': {
                    'BCC': 'CST_BCC',
                    'BCU': 'CST_BCU',
                    'DAT': 'DATA',
                    'DSH': 'DASH', // Bitfinex names Dash as DSH, instead of DASH
                    'IOS': 'IOST',
                    'IOT': 'IOTA',
                    'MNA': 'MANA',
                    'QSH': 'QASH',
                    'QTM': 'QTUM',
                    'SNG': 'SNGLS',
                    'SPK': 'SPANK',
                    'STJ': 'STORJ',
                    'YYW': 'YOYOW',
                    'USD': 'USDT'
                },
                'exceptions': {
                    'exact': {
                        'temporarily_unavailable': ExchangeNotAvailable, // Sorry, the service is temporarily unavailable. See https://www.bitfinex.com/ for more info.
                        'Order could not be cancelled.': OrderNotFound, // non-existent order
                        'No such order found.': OrderNotFound, // ?
                        'Order price must be positive.': InvalidOrder, // on price <= 0
                        'Could not find a key matching the given X-BFX-APIKEY.': AuthenticationError,
                        'This API key does not have permission for this action': AuthenticationError, // authenticated but not authorized
                        'Key price should be a decimal number, e.g. "123.456"': InvalidOrder, // on isNaN (price)
                        'Key amount should be a decimal number, e.g. "123.456"': InvalidOrder, // on isNaN (amount)
                        'ERR_RATE_LIMIT': DDoSProtection,
                        'Nonce is too small.': InvalidNonce
                    },
                    'broad': {
                        'Invalid order: not enough exchange balance for ': InsufficientFunds, // when buying cost is greater than the available quote currency
                        'Invalid order: minimum size for ': InvalidOrder, // when amount below limits.amount.min
                        'Invalid order': InvalidOrder, // ?
                        'The available balance is only': InsufficientFunds // {"status":"error","message":"Cannot withdraw 1.0027 ETH from your exchange wallet. The available balance is only 0.0 ETH. If you have limit orders, open positions, unused or active margin funding, this will decrease your available balance. To increase it, you can cancel limit orders or reduce/close your positions.","withdrawal_id":0,"fees":"0.0027"}
                    }
                },
                'precisionMode': SIGNIFICANT_DIGITS
            });
        }
    }, {
        key: 'fetchFundingFees',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, fees, withdraw, ids, i, id, code, currency;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostAccountFees(params);

                            case 4:
                                response = _context.sent;
                                fees = response['withdraw'];
                                withdraw = {};
                                ids = Object.keys(fees);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    code = id;

                                    if (id in this.currencies_by_id) {
                                        currency = this.currencies_by_id[id];

                                        code = currency['code'];
                                    }
                                    withdraw[code] = this.safeFloat(fees, id);
                                }
                                return _context.abrupt('return', {
                                    'info': response,
                                    'withdraw': withdraw,
                                    'deposit': withdraw // only for deposits of less than $1000
                                });

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchFundingFees() {
                return _ref.apply(this, arguments);
            }

            return fetchFundingFees;
        }()
    }, {
        key: 'fetchTradingFees',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostSummary(params);

                            case 4:
                                response = _context2.sent;
                                return _context2.abrupt('return', {
                                    'info': response,
                                    'maker': this.safeFloat(response, 'maker_fee'),
                                    'taker': this.safeFloat(response, 'taker_fee')
                                });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTradingFees() {
                return _ref2.apply(this, arguments);
            }

            return fetchTradingFees;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var markets, result, p, market, id, baseId, quoteId, base, quote, symbol, precision, limits;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetSymbolsDetails();

                            case 2:
                                markets = _context3.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['pair'].toUpperCase();
                                    baseId = id.slice(0, 3);
                                    quoteId = id.slice(3, 6);
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'price': market['price_precision'],
                                        'amount': market['price_precision']
                                    };
                                    limits = {
                                        'amount': {
                                            'min': this.safeFloat(market, 'minimum_order_size'),
                                            'max': this.safeFloat(market, 'maximum_order_size')
                                        },
                                        'price': {
                                            'min': Math.pow(10, -precision['price']),
                                            'max': Math.pow(10, precision['price'])
                                        }
                                    };

                                    limits['cost'] = {
                                        'min': limits['amount']['min'] * limits['price']['min'],
                                        'max': undefined
                                    };
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'precision': precision,
                                        'limits': limits,
                                        'info': market
                                    });
                                }
                                return _context3.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchMarkets() {
                return _ref3.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'costToPrecision',
        value: function costToPrecision(symbol, cost) {
            return this.decimalToPrecision(cost, ROUND, this.markets[symbol]['precision']['price'], this.precisionMode);
        }
    }, {
        key: 'priceToPrecision',
        value: function priceToPrecision(symbol, price) {
            return this.decimalToPrecision(price, ROUND, this.markets[symbol]['precision']['price'], this.precisionMode);
        }
    }, {
        key: 'amountToPrecision',
        value: function amountToPrecision(symbol, amount) {
            return this.decimalToPrecision(amount, TRUNCATE, this.markets[symbol]['precision']['amount'], this.precisionMode);
        }
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(currency, fee) {
            return this.decimalToPrecision(fee, ROUND, this.currencies[currency]['precision'], this.precisionMode);
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var rate = market[takerOrMaker];
            var cost = amount * rate;
            var key = 'quote';
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(market[key], cost))
            };
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balanceType, balances, result, i, balance, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                balanceType = this.safeString(params, 'type', 'exchange');
                                _context4.next = 5;
                                return this.privatePostBalances();

                            case 5:
                                balances = _context4.sent;
                                result = { 'info': balances };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];

                                    if (balance['type'] === balanceType) {
                                        currency = balance['currency'];
                                        uppercase = currency.toUpperCase();

                                        uppercase = this.commonCurrencyCode(uppercase);
                                        account = this.account();

                                        account['free'] = parseFloat(balance['available']);
                                        account['total'] = parseFloat(balance['amount']);
                                        account['used'] = account['total'] - account['free'];
                                        result[uppercase] = account;
                                    }
                                }
                                return _context4.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchBalance() {
                return _ref4.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'symbol': this.marketId(symbol)
                                };

                                if (typeof limit !== 'undefined') {
                                    request['limit_bids'] = limit;
                                    request['limit_asks'] = limit;
                                }
                                _context5.next = 6;
                                return this.publicGetBookSymbol(this.extend(request, params));

                            case 6:
                                orderbook = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x6) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, i, ticker, parsedTicker, symbol;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                tickers = _context6.sent;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    parsedTicker = this.parseTicker(ticker);
                                    symbol = parsedTicker['symbol'];

                                    result[symbol] = parsedTicker;
                                }
                                return _context6.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTickers() {
                return _ref6.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetPubtickerSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context7.sent;
                                return _context7.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTicker(_x11) {
                return _ref7.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeFloat(ticker, 'timestamp') * 1000;
            var symbol = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
            } else if ('pair' in ticker) {
                var id = ticker['pair'];
                if (id in this.markets_by_id) market = this.markets_by_id[id];
                if (typeof market !== 'undefined') {
                    symbol = market['symbol'];
                } else {
                    var baseId = id.slice(0, 3);
                    var quoteId = id.slice(3, 6);
                    var base = this.commonCurrencyCode(baseId);
                    var quote = this.commonCurrencyCode(quoteId);
                    symbol = base + '/' + quote;
                }
            }
            var last = this.safeFloat(ticker, 'last_price');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'mid'),
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(parseFloat(trade['timestamp'])) * 1000;
            var side = trade['type'].toLowerCase();
            var orderId = this.safeString(trade, 'order_id');
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var cost = price * amount;
            var fee = undefined;
            if ('fee_amount' in trade) {
                var feeCost = -this.safeFloat(trade, 'fee_amount');
                var feeCurrency = this.safeString(trade, 'fee_currency');
                if (feeCurrency in this.currencies_by_id) feeCurrency = this.currencies_by_id[feeCurrency]['code'];
                fee = {
                    'cost': feeCost,
                    'currency': feeCurrency
                };
            }
            return {
                'id': trade['tid'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'order': orderId,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'limit_trades': limit
                                };

                                if (typeof since !== 'undefined') request['timestamp'] = parseInt(since / 1000);
                                _context8.next = 7;
                                return this.publicGetTradesSymbol(this.extend(request, params));

                            case 7:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTrades(_x14) {
                return _ref8.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = { 'symbol': market['id'] };

                                if (typeof limit !== 'undefined') request['limit_trades'] = limit;
                                if (typeof since !== 'undefined') request['timestamp'] = parseInt(since / 1000);
                                _context9.next = 8;
                                return this.privatePostMytrades(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchMyTrades() {
                return _ref9.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var orderType, order, result;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                orderType = type;

                                if (type === 'limit' || type === 'market') orderType = 'exchange ' + type;
                                // amount = this.amountToPrecision (symbol, amount);
                                order = {
                                    'symbol': this.marketId(symbol),
                                    'amount': amount.toString(),
                                    'side': side,
                                    'type': orderType,
                                    'ocoorder': false,
                                    'buy_price_oco': 0,
                                    'sell_price_oco': 0
                                };

                                if (type === 'market') {
                                    order['price'] = this.nonce().toString();
                                } else {
                                    // price = this.priceToPrecision (symbol, price);
                                    order['price'] = price.toString();
                                }
                                _context10.next = 8;
                                return this.privatePostOrderNew(this.extend(order, params));

                            case 8:
                                result = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(result));

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x22, _x23, _x24, _x25) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.privatePostOrderCancel({ 'order_id': parseInt(id) });

                            case 4:
                                return _context11.abrupt('return', _context11.sent);

                            case 5:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function cancelOrder(_x28) {
                return _ref11.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['side'];
            var open = order['is_live'];
            var canceled = order['is_cancelled'];
            var status = undefined;
            if (open) {
                status = 'open';
            } else if (canceled) {
                status = 'canceled';
            } else {
                status = 'closed';
            }
            var symbol = undefined;
            if (!market) {
                var _exchange = order['symbol'].toUpperCase();
                if (_exchange in this.markets_by_id) {
                    market = this.markets_by_id[_exchange];
                }
            }
            if (market) symbol = market['symbol'];
            var orderType = order['type'];
            var exchange = orderType.indexOf('exchange ') >= 0;
            if (exchange) {
                var parts = order['type'].split(' ');
                orderType = parts[1];
            }
            var timestamp = parseInt(parseFloat(order['timestamp']) * 1000);
            var result = {
                'info': order,
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': orderType,
                'side': side,
                'price': this.safeFloat(order, 'price'),
                'average': this.safeFloat(order, 'avg_execution_price'),
                'amount': this.safeFloat(order, 'original_amount'),
                'remaining': this.safeFloat(order, 'remaining_amount'),
                'filled': this.safeFloat(order, 'executed_amount'),
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response, orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context12.next = 4;
                                return this.privatePostOrders(params);

                            case 4:
                                response = _context12.sent;
                                orders = this.parseOrders(response, undefined, since, limit);

                                if (symbol) orders = this.filterBy(orders, 'symbol', symbol);
                                return _context12.abrupt('return', orders);

                            case 8:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOpenOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, response, orders;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context13.next = 6;
                                return this.privatePostOrdersHist(this.extend(request, params));

                            case 6:
                                response = _context13.sent;
                                orders = this.parseOrders(response, undefined, since, limit);

                                if (typeof symbol !== 'undefined') orders = this.filterBy(orders, 'symbol', symbol);
                                orders = this.filterBy(orders, 'status', 'closed');
                                return _context13.abrupt('return', orders);

                            case 11:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchClosedOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context14.next = 4;
                                return this.privatePostOrderStatus(this.extend({
                                    'order_id': parseInt(id)
                                }, params));

                            case 4:
                                response = _context14.sent;
                                return _context14.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchOrder(_x40) {
                return _ref14.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0], ohlcv[1], ohlcv[3], ohlcv[4], ohlcv[2], ohlcv[5]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, v2id, request, response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (typeof limit === 'undefined') limit = 100;
                                market = this.market(symbol);
                                v2id = 't' + market['id'];
                                request = {
                                    'symbol': v2id,
                                    'timeframe': this.timeframes[timeframe],
                                    'sort': 1,
                                    'limit': limit
                                };

                                if (typeof since !== 'undefined') request['start'] = since;
                                _context15.next = 9;
                                return this.v2GetCandlesTradeTimeframeSymbolHist(this.extend(request, params));

                            case 9:
                                response = _context15.sent;
                                return _context15.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 11:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchOHLCV(_x47) {
                return _ref15.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'getCurrencyName',
        value: function getCurrencyName(currency) {
            var names = {
                'AGI': 'agi',
                'AID': 'aid',
                'AIO': 'aio',
                'ANT': 'ant',
                'AVT': 'aventus', // #1811
                'BAT': 'bat',
                'BCH': 'bcash', // undocumented
                'BCI': 'bci',
                'BFT': 'bft',
                'BTC': 'bitcoin',
                'BTG': 'bgold',
                'CFI': 'cfi',
                'DAI': 'dai',
                'DASH': 'dash',
                'DATA': 'datacoin',
                'DTH': 'dth',
                'EDO': 'eidoo', // #1811
                'ELF': 'elf',
                'EOS': 'eos',
                'ETC': 'ethereumc',
                'ETH': 'ethereum',
                'ETP': 'metaverse',
                'FUN': 'fun',
                'GNT': 'golem',
                'IOST': 'ios',
                'IOTA': 'iota',
                'LRC': 'lrc',
                'LTC': 'litecoin',
                'MANA': 'mna',
                'MIT': 'mit',
                'MTN': 'mtn',
                'NEO': 'neo',
                'ODE': 'ode',
                'OMG': 'omisego',
                'OMNI': 'mastercoin',
                'QASH': 'qash',
                'QTUM': 'qtum', // #1811
                'RCN': 'rcn',
                'RDN': 'rdn',
                'REP': 'rep',
                'REQ': 'req',
                'RLC': 'rlc',
                'SAN': 'santiment',
                'SNGLS': 'sng',
                'SNT': 'status',
                'SPANK': 'spk',
                'STJ': 'stj',
                'TNB': 'tnb',
                'TRX': 'trx',
                'USD': 'wire',
                'USDT': 'tetheruso', // undocumented
                'WAX': 'wax',
                'XLM': 'xlm',
                'XMR': 'monero',
                'XRP': 'ripple',
                'XVG': 'xvg',
                'YOYOW': 'yoyow',
                'ZEC': 'zcash',
                'ZRX': 'zrx'
            };
            if (currency in names) return names[currency];
            throw new NotSupported(this.id + ' ' + currency + ' not supported for withdrawal');
        }
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, address;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.fetchDepositAddress(currency, this.extend({
                                    'renew': 1
                                }, params));

                            case 2:
                                response = _context16.sent;
                                address = this.safeString(response, 'address');

                                this.checkAddress(address);
                                return _context16.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response['info']
                                });

                            case 6:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function createDepositAddress(_x52) {
                return _ref16.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var name, request, response, address, tag;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                name = this.getCurrencyName(currency);
                                request = {
                                    'method': name,
                                    'wallet_name': 'exchange',
                                    'renew': 0 // a value of 1 will generate a new address
                                };
                                _context17.next = 4;
                                return this.privatePostDepositNew(this.extend(request, params));

                            case 4:
                                response = _context17.sent;
                                address = response['address'];
                                tag = undefined;

                                if ('address_pool' in response) {
                                    tag = address;
                                    address = response['address_pool'];
                                }
                                this.checkAddress(address);
                                return _context17.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function fetchDepositAddress(_x54) {
                return _ref17.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var name, request, responses, response, id, message, errorMessage, Exception;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                this.checkAddress(address);
                                name = this.getCurrencyName(currency);
                                request = {
                                    'withdraw_type': name,
                                    'walletselected': 'exchange',
                                    'amount': amount.toString(),
                                    'address': address
                                };

                                if (tag) request['payment_id'] = tag;
                                _context18.next = 6;
                                return this.privatePostWithdraw(this.extend(request, params));

                            case 6:
                                responses = _context18.sent;
                                response = responses[0];
                                id = response['withdrawal_id'];
                                message = response['message'];
                                errorMessage = this.findBroadlyMatchedKey(this.exceptions['broad'], message);

                                if (!(id === 0)) {
                                    _context18.next = 16;
                                    break;
                                }

                                if (!(typeof errorMessage !== 'undefined')) {
                                    _context18.next = 15;
                                    break;
                                }

                                Exception = this.exceptions['broad'][errorMessage];
                                throw new Exception(this.id + ' ' + message);

                            case 15:
                                throw new ExchangeError(this.id + ' withdraw returned an id of zero: ' + this.json(response));

                            case 16:
                                return _context18.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 17:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function withdraw(_x56, _x57, _x58) {
                return _ref18.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = '/' + this.implodeParams(path, params);
            if (api === 'v2') {
                request = '/' + api + request;
            } else {
                request = '/' + this.version + request;
            }
            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + request;
            if (api === 'public' || path.indexOf('/hist') >= 0) {
                if (Object.keys(query).length) {
                    var suffix = '?' + this.urlencode(query);
                    url += suffix;
                    request += suffix;
                }
            }
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                query = this.extend({
                    'nonce': nonce.toString(),
                    'request': request
                }, query);
                query = this.json(query);
                query = this.encode(query);
                var payload = this.stringToBase64(query);
                var secret = this.encode(this.secret);
                var signature = this.hmac(payload, secret, 'sha384');
                headers = {
                    'X-BFX-APIKEY': this.apiKey,
                    'X-BFX-PAYLOAD': this.decode(payload),
                    'X-BFX-SIGNATURE': signature
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'findBroadlyMatchedKey',
        value: function findBroadlyMatchedKey(map, broadString) {
            var partialKeys = Object.keys(map);
            for (var i = 0; i < partialKeys.length; i++) {
                var partialKey = partialKeys[i];
                if (broadString.indexOf(partialKey) >= 0) return partialKey;
            }
            return undefined;
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body.length < 2) return;
            if (code >= 400) {
                if (body[0] === '{') {
                    var response = JSON.parse(body);
                    var feedback = this.id + ' ' + this.json(response);
                    var message = undefined;
                    if ('message' in response) message = response['message'];else if ('error' in response) message = response['error'];else throw new ExchangeError(feedback); // malformed (to our knowledge) response
                    var exact = this.exceptions['exact'];
                    if (message in exact) throw new exact[message](feedback);
                    var broad = this.exceptions['broad'];
                    var broadKey = this.findBroadlyMatchedKey(broad, message);
                    if (typeof broadKey !== 'undefined') throw new broad[broadKey](feedback);
                    throw new ExchangeError(feedback); // unknown message
                }
            }
        }
    }]);

    return bitfinex;
}(Exchange);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    DDoSProtection = _require.DDoSProtection,
    InvalidOrder = _require.InvalidOrder;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(zb, _Exchange);

    function zb() {
        _classCallCheck(this, zb);

        return _possibleConstructorReturn(this, (zb.__proto__ || Object.getPrototypeOf(zb)).apply(this, arguments));
    }

    _createClass(zb, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(zb.prototype.__proto__ || Object.getPrototypeOf(zb.prototype), 'describe', this).call(this), {
                'id': 'zb',
                'name': 'ZB',
                'countries': 'CN',
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1min',
                    '3m': '3min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '1hour',
                    '2h': '2hour',
                    '4h': '4hour',
                    '6h': '6hour',
                    '12h': '12hour',
                    '1d': '1day',
                    '3d': '3day',
                    '1w': '1week'
                },
                'exceptions': {
                    // '1000': 'Successful operation',
                    '1001': ExchangeError, // 'General error message',
                    '1002': ExchangeError, // 'Internal error',
                    '1003': AuthenticationError, // 'Verification does not pass',
                    '1004': AuthenticationError, // 'Funding security password lock',
                    '1005': AuthenticationError, // 'Funds security password is incorrect, please confirm and re-enter.',
                    '1006': AuthenticationError, // 'Real-name certification pending approval or audit does not pass',
                    '1009': ExchangeNotAvailable, // 'This interface is under maintenance',
                    '2001': InsufficientFunds, // 'Insufficient CNY Balance',
                    '2002': InsufficientFunds, // 'Insufficient BTC Balance',
                    '2003': InsufficientFunds, // 'Insufficient LTC Balance',
                    '2005': InsufficientFunds, // 'Insufficient ETH Balance',
                    '2006': InsufficientFunds, // 'Insufficient ETC Balance',
                    '2007': InsufficientFunds, // 'Insufficient BTS Balance',
                    '2009': InsufficientFunds, // 'Account balance is not enough',
                    '3001': OrderNotFound, // 'Pending orders not found',
                    '3002': InvalidOrder, // 'Invalid price',
                    '3003': InvalidOrder, // 'Invalid amount',
                    '3004': AuthenticationError, // 'User does not exist',
                    '3005': ExchangeError, // 'Invalid parameter',
                    '3006': AuthenticationError, // 'Invalid IP or inconsistent with the bound IP',
                    '3007': AuthenticationError, // 'The request time has expired',
                    '3008': OrderNotFound, // 'Transaction records not found',
                    '4001': ExchangeNotAvailable, // 'API interface is locked or not enabled',
                    '4002': DDoSProtection // 'Request too often',
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/32859187-cd5214f0-ca5e-11e7-967d-96568e2e2bd1.jpg',
                    'api': {
                        'public': 'http://api.zb.com/data', // no https for public API
                        'private': 'https://trade.zb.com/api'
                    },
                    'www': 'https://www.zb.com',
                    'doc': 'https://www.zb.com/i/developer',
                    'fees': 'https://www.zb.com/i/rate'
                },
                'api': {
                    'public': {
                        'get': ['markets', 'ticker', 'depth', 'trades', 'kline']
                    },
                    'private': {
                        'get': [
                        // spot API
                        'order', 'cancelOrder', 'getOrder', 'getOrders', 'getOrdersNew', 'getOrdersIgnoreTradeType', 'getUnfinishedOrdersIgnoreTradeType', 'getAccountInfo', 'getUserAddress', 'getWithdrawAddress', 'getWithdrawRecord', 'getChargeRecord', 'getCnyWithdrawRecord', 'getCnyChargeRecord', 'withdraw',
                        // leverage API
                        'getLeverAssetsInfo', 'getLeverBills', 'transferInLever', 'transferOutLever', 'loan', 'cancelLoan', 'getLoans', 'getLoanRecords', 'borrow', 'repay', 'getRepayments']
                    }
                },
                'fees': {
                    'funding': {
                        'withdraw': {
                            'BTC': 0.0001,
                            'BCH': 0.0006,
                            'LTC': 0.005,
                            'ETH': 0.01,
                            'ETC': 0.01,
                            'BTS': 3,
                            'EOS': 1,
                            'QTUM': 0.01,
                            'HSR': 0.001,
                            'XRP': 0.1,
                            'USDT': '0.1%',
                            'QCASH': 5,
                            'DASH': 0.002,
                            'BCD': 0,
                            'UBTC': 0,
                            'SBTC': 0,
                            'INK': 20,
                            'TV': 0.1,
                            'BTH': 0,
                            'BCX': 0,
                            'LBTC': 0,
                            'CHAT': 20,
                            'bitCNY': 20,
                            'HLC': 20,
                            'BTP': 0,
                            'BCW': 0
                        }
                    },
                    'trading': {
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, keys, result, i, id, market, _id$split, _id$split2, baseId, quoteId, base, quote, symbol, precision, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                markets = _context.sent;
                                keys = Object.keys(markets);
                                result = [];

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    market = markets[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = this.commonCurrencyCode(baseId.toUpperCase());
                                    quote = this.commonCurrencyCode(quoteId.toUpperCase());
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': market['amountScale'],
                                        'price': market['priceScale']
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'base': base,
                                        'quote': quote,
                                        'lot': lot,
                                        'active': true,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': 0,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, i, balance, account, currency;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetGetAccountInfo(params);

                            case 4:
                                response = _context2.sent;

                                // todo: use this somehow
                                // let permissions = response['result']['base'];
                                balances = response['result']['coins'];
                                result = { 'info': response };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    //     {        enName: "BTC",
                                    //               freez: "0.00000000",
                                    //         unitDecimal:  8, // always 8
                                    //              cnName: "BTC",
                                    //       isCanRecharge:  true, // TODO: should use this
                                    //             unitTag: "฿",
                                    //       isCanWithdraw:  true,  // TODO: should use this
                                    //           available: "0.00000000",
                                    //                 key: "btc"         }

                                    account = this.account();
                                    currency = balance['key'];

                                    if (currency in this.currencies_by_id) currency = this.currencies_by_id[currency]['code'];else currency = this.commonCurrencyCode(balance['enName']);
                                    account['free'] = parseFloat(balance['available']);
                                    account['used'] = parseFloat(balance['freez']);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'getMarketFieldName',
        value: function getMarketFieldName() {
            return 'market';
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, marketFieldName, request, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                marketFieldName = this.getMarketFieldName();
                                request = {};

                                request[marketFieldName] = market['id'];
                                _context3.next = 8;
                                return this.publicGetDepth(this.extend(request, params));

                            case 8:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, marketFieldName, request, response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                marketFieldName = this.getMarketFieldName();
                                request = {};

                                request[marketFieldName] = market['id'];
                                _context4.next = 8;
                                return this.publicGetTicker(this.extend(request, params));

                            case 8:
                                response = _context4.sent;
                                ticker = response['ticker'];
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'last');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'vol'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (typeof limit === 'undefined') limit = 1000;
                                request = {
                                    'market': market['id'],
                                    'type': this.timeframes[timeframe],
                                    'limit': limit
                                };

                                if (typeof since !== 'undefined') request['since'] = since;
                                _context5.next = 8;
                                return this.publicGetKline(this.extend(request, params));

                            case 8:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOHLCVs(response['data'], market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['date'] * 1000;
            var side = trade['trade_type'] === 'bid' ? 'buy' : 'sell';
            return {
                'info': trade,
                'id': trade['tid'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, marketFieldName, request, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                marketFieldName = this.getMarketFieldName();
                                request = {};

                                request[marketFieldName] = market['id'];
                                _context6.next = 8;
                                return this.publicGetTrades(this.extend(request, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x13) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new InvalidOrder(this.id + ' allows limit orders only');

                            case 2:
                                _context7.next = 4;
                                return this.loadMarkets();

                            case 4:
                                order = {
                                    'price': this.priceToPrecision(symbol, price),
                                    'amount': this.amountToString(symbol, amount),
                                    'tradeType': side === 'buy' ? '1' : '0',
                                    'currency': this.marketId(symbol)
                                };
                                _context7.next = 7;
                                return this.privateGetOrder(this.extend(order, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x17, _x18, _x19, _x20) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var order;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'id': id.toString(),
                                    'currency': this.marketId(symbol)
                                };

                                order = this.extend(order, params);
                                _context8.next = 6;
                                return this.privateGetCancelOrder(order);

                            case 6:
                                return _context8.abrupt('return', _context8.sent);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x23) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context9.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder() requires a symbol argument');

                            case 2:
                                _context9.next = 4;
                                return this.loadMarkets();

                            case 4:
                                order = {
                                    'id': id.toString(),
                                    'currency': this.marketId(symbol)
                                };

                                order = this.extend(order, params);
                                _context9.next = 8;
                                return this.privateGetGetOrder(order);

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(response, undefined, true));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x26) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, method, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (symbol) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + 'fetchOrders requires a symbol parameter');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'currency': market['id'],
                                    'pageIndex': 1, // default pageIndex is 1
                                    'pageSize': limit // default pageSize is 50
                                };
                                method = 'privateGetGetOrdersIgnoreTradeType';
                                // tradeType 交易类型1/0[buy/sell]

                                if ('tradeType' in params) method = 'privateGetGetOrdersNew';
                                response = undefined;
                                _context10.prev = 9;
                                _context10.next = 12;
                                return this[method](this.extend(request, params));

                            case 12:
                                response = _context10.sent;
                                _context10.next = 20;
                                break;

                            case 15:
                                _context10.prev = 15;
                                _context10.t0 = _context10['catch'](9);

                                if (!(_context10.t0 instanceof OrderNotFound)) {
                                    _context10.next = 19;
                                    break;
                                }

                                return _context10.abrupt('return', []);

                            case 19:
                                throw _context10.t0;

                            case 20:
                                return _context10.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 21:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this, [[9, 15]]);
            }));

            function fetchOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, method, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (symbol) {
                                    _context11.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + 'fetchOpenOrders requires a symbol parameter');

                            case 2:
                                _context11.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'currency': market['id'],
                                    'pageIndex': 1, // default pageIndex is 1
                                    'pageSize': limit // default pageSize is 10
                                };
                                method = 'privateGetGetUnfinishedOrdersIgnoreTradeType';
                                // tradeType 交易类型1/0[buy/sell]

                                if ('tradeType' in params) method = 'privateGetGetOrdersNew';
                                response = undefined;
                                _context11.prev = 9;
                                _context11.next = 12;
                                return this[method](this.extend(request, params));

                            case 12:
                                response = _context11.sent;
                                _context11.next = 20;
                                break;

                            case 15:
                                _context11.prev = 15;
                                _context11.t0 = _context11['catch'](9);

                                if (!(_context11.t0 instanceof OrderNotFound)) {
                                    _context11.next = 19;
                                    break;
                                }

                                return _context11.abrupt('return', []);

                            case 19:
                                throw _context11.t0;

                            case 20:
                                return _context11.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 21:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[9, 15]]);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['type'] === 1 ? 'buy' : 'sell';
            var type = 'limit'; // market order is not availalbe in ZB
            var timestamp = undefined;
            var createDateField = this.getCreateDateField();
            if (createDateField in order) timestamp = order[createDateField];
            var symbol = undefined;
            if ('currency' in order) {
                // get symbol from currency
                market = this.marketsById[order['currency']];
            }
            if (market) symbol = market['symbol'];
            var price = order['price'];
            var average = undefined;
            var filled = order['trade_amount'];
            var amount = order['total_amount'];
            var remaining = amount - filled;
            var cost = order['trade_money'];
            var status = this.safeString(order, 'status');
            if (typeof status !== 'undefined') status = this.parseOrderStatus(status);
            var result = {
                'info': order,
                'id': order['id'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'average': average,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                '0': 'open',
                '1': 'canceled',
                '2': 'closed',
                '3': 'open' // partial
            };
            if (status in statuses) return statuses[status];
            return status;
        }
    }, {
        key: 'getCreateDateField',
        value: function getCreateDateField() {
            return 'trade_date';
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api === 'public') {
                url += '/' + this.version + '/' + path;
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                var query = this.keysort(this.extend({
                    'method': path,
                    'accesskey': this.apiKey
                }, params));
                var nonce = this.nonce();
                query = this.keysort(query);
                var auth = this.rawencode(query);
                var secret = this.hash(this.encode(this.secret), 'sha1');
                var signature = this.hmac(this.encode(auth), this.encode(secret), 'md5');
                var suffix = 'sign=' + signature + '&reqTime=' + nonce.toString();
                url += '/' + path + '?' + auth + '&' + suffix;
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if ('code' in response) {
                    var code = this.safeString(response, 'code');
                    var message = this.id + ' ' + this.json(response);
                    if (code in this.exceptions) {
                        var ExceptionClass = this.exceptions[code];
                        throw new ExceptionClass(message);
                    } else if (code !== '1000') {
                        throw new ExchangeError(message);
                    }
                }
            }
        }
    }]);

    return zb;
}(Exchange);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    AuthenticationError = _require.AuthenticationError,
    InvalidNonce = _require.InvalidNonce,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinegg, _Exchange);

    function coinegg() {
        _classCallCheck(this, coinegg);

        return _possibleConstructorReturn(this, (coinegg.__proto__ || Object.getPrototypeOf(coinegg)).apply(this, arguments));
    }

    _createClass(coinegg, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinegg.prototype.__proto__ || Object.getPrototypeOf(coinegg.prototype), 'describe', this).call(this), {
                'id': 'coinegg',
                'name': 'CoinEgg',
                'countries': ['CN', 'UK'],
                'has': {
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': 'emulated',
                    'fetchMyTrades': true,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/36770310-adfa764e-1c5a-11e8-8e09-449daac3d2fb.jpg',
                    'api': {
                        'web': 'https://www.coinegg.com/coin',
                        'rest': 'https://api.coinegg.com/api/v1'
                    },
                    'www': 'https://www.coinegg.com',
                    'doc': 'https://www.coinegg.com/explain.api.html',
                    'fees': 'https://www.coinegg.com/fee.html'
                },
                'api': {
                    'web': {
                        'get': ['{quote}/allcoin', '{quote}/trends', '{quote}/{base}/order', '{quote}/{base}/trades', '{quote}/{base}/depth.js']
                    },
                    'public': {
                        'get': ['ticker/{quote}', 'depth/{quote}', 'orders/{quote}']
                    },
                    'private': {
                        'post': ['balance', 'trade_add/{quote}', 'trade_cancel/{quote}', 'trade_view/{quote}', 'trade_list/{quote}']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.008,
                            'BCH': 0.002,
                            'LTC': 0.001,
                            'ETH': 0.01,
                            'ETC': 0.01,
                            'NEO': 0,
                            'QTUM': '1%',
                            'XRP': '1%',
                            'DOGE': '1%',
                            'LSK': '1%',
                            'XAS': '1%',
                            'BTS': '1%',
                            'GAME': '1%',
                            'GOOC': '1%',
                            'NXT': '1%',
                            'IFC': '1%',
                            'DNC': '1%',
                            'BLK': '1%',
                            'VRC': '1%',
                            'XPM': '1%',
                            'VTC': '1%',
                            'TFC': '1%',
                            'PLC': '1%',
                            'EAC': '1%',
                            'PPC': '1%',
                            'FZ': '1%',
                            'ZET': '1%',
                            'RSS': '1%',
                            'PGC': '1%',
                            'SKT': '1%',
                            'JBC': '1%',
                            'RIO': '1%',
                            'LKC': '1%',
                            'ZCC': '1%',
                            'MCC': '1%',
                            'QEC': '1%',
                            'MET': '1%',
                            'YTC': '1%',
                            'HLB': '1%',
                            'MRYC': '1%',
                            'MTC': '1%',
                            'KTC': 0
                        }
                    }
                },
                'exceptions': {
                    '103': AuthenticationError,
                    '104': AuthenticationError,
                    '105': AuthenticationError,
                    '106': InvalidNonce,
                    '200': InsufficientFunds,
                    '201': InvalidOrder,
                    '202': InvalidOrder,
                    '203': OrderNotFound,
                    '402': DDoSProtection
                },
                'errorMessages': {
                    '100': 'Required parameters can not be empty',
                    '101': 'Illegal parameter',
                    '102': 'coin does not exist',
                    '103': 'Key does not exist',
                    '104': 'Signature does not match',
                    '105': 'Insufficient permissions',
                    '106': 'Request expired(nonce error)',
                    '200': 'Lack of balance',
                    '201': 'Too small for the number of trading',
                    '202': 'Price must be in 0 - 1000000',
                    '203': 'Order does not exist',
                    '204': 'Pending order amount must be above 0.001 BTC',
                    '205': 'Restrict pending order prices',
                    '206': 'Decimal place error',
                    '401': 'System error',
                    '402': 'Requests are too frequent',
                    '403': 'Non-open API',
                    '404': 'IP restriction does not request the resource',
                    '405': 'Currency transactions are temporarily closed'
                },
                'options': {
                    'quoteIds': ['btc', 'eth', 'usc']
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var quoteIds, result, b, quoteId, bases, baseIds, numBaseIds, i, baseId, market, base, quote, id, symbol, precision, lot;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                quoteIds = this.options['quoteIds'];
                                result = [];
                                b = 0;

                            case 3:
                                if (!(b < quoteIds.length)) {
                                    _context.next = 18;
                                    break;
                                }

                                quoteId = quoteIds[b];
                                _context.next = 7;
                                return this.webGetQuoteAllcoin({
                                    'quote': quoteId
                                });

                            case 7:
                                bases = _context.sent;

                                if (!(typeof bases === 'undefined')) {
                                    _context.next = 10;
                                    break;
                                }

                                throw new ExchangeNotAvailable(this.id + ' fetchMarkets() for "' + quoteId + '" returned: "' + this.json(bases) + '"');

                            case 10:
                                baseIds = Object.keys(bases);
                                numBaseIds = baseIds.length;

                                if (!(numBaseIds < 1)) {
                                    _context.next = 14;
                                    break;
                                }

                                throw new ExchangeNotAvailable(this.id + ' fetchMarkets() for "' + quoteId + '" returned: "' + this.json(bases) + '"');

                            case 14:
                                for (i = 0; i < baseIds.length; i++) {
                                    baseId = baseIds[i];
                                    market = bases[baseId];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    id = baseId + quoteId;
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'lot': lot,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': Math.pow(10, precision['price'])
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }

                            case 15:
                                b++;
                                _context.next = 3;
                                break;

                            case 18:
                                return _context.abrupt('return', result);

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = this.milliseconds();
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'change'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'quoteVol'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetTickerQuote(this.extend({
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                }, params));

                            case 5:
                                ticker = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var quoteIds, result, b, quoteId, tickers, baseIds, i, baseId, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                quoteIds = this.options['quoteIds'];
                                result = {};
                                b = 0;

                            case 5:
                                if (!(b < quoteIds.length)) {
                                    _context3.next = 17;
                                    break;
                                }

                                quoteId = quoteIds[b];
                                _context3.next = 9;
                                return this.webGetQuoteAllcoin({
                                    'quote': quoteId
                                });

                            case 9:
                                tickers = _context3.sent;
                                baseIds = Object.keys(tickers);

                                if (baseIds.length) {
                                    _context3.next = 13;
                                    break;
                                }

                                throw new ExchangeError('fetchTickers failed');

                            case 13:
                                for (i = 0; i < baseIds.length; i++) {
                                    baseId = baseIds[i];
                                    ticker = tickers[baseId];
                                    id = baseId + quoteId;

                                    if (id in this.markets_by_id) {
                                        market = this.marketsById[id];
                                        symbol = market['symbol'];

                                        result[symbol] = this.parseTicker({
                                            'high': ticker[4],
                                            'low': ticker[5],
                                            'buy': ticker[2],
                                            'sell': ticker[3],
                                            'last': ticker[1],
                                            'change': ticker[8],
                                            'vol': ticker[6],
                                            'quoteVol': ticker[7]
                                        }, market);
                                    }
                                }

                            case 14:
                                b++;
                                _context3.next = 5;
                                break;

                            case 17:
                                return _context3.abrupt('return', result);

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetDepthQuote(this.extend({
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                }, params));

                            case 5:
                                orderbook = _context4.sent;
                                return _context4.abrupt('return', this.parseOrderBook(orderbook));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['date']) * 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.costToPrecision(symbol, price * amount);
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tid'),
                'order': undefined,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetOrdersQuote(this.extend({
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                }, params));

                            case 5:
                                trades = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var response, result, balances, keys, i, key, _key$split, _key$split2, currencyId, accountType, code, currencies, _i, currency;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privatePostBalance(params);

                            case 4:
                                response = _context6.sent;
                                result = {};
                                balances = this.omit(response['data'], 'uid');
                                keys = Object.keys(balances);

                                for (i = 0; i < keys.length; i++) {
                                    key = keys[i];
                                    _key$split = key.split('_'), _key$split2 = _slicedToArray(_key$split, 2), currencyId = _key$split2[0], accountType = _key$split2[1];
                                    code = currencyId;

                                    if (currencyId in this.currencies_by_id) {
                                        code = this.currencies_by_id[currencyId]['code'];
                                    }
                                    if (!(code in result)) {
                                        result[code] = {
                                            'free': undefined,
                                            'used': undefined,
                                            'total': undefined
                                        };
                                    }
                                    accountType = accountType === 'lock' ? 'used' : 'free';
                                    result[code][accountType] = parseFloat(balances[key]);
                                }
                                currencies = Object.keys(result);

                                for (_i = 0; _i < currencies.length; _i++) {
                                    currency = currencies[_i];

                                    result[currency]['total'] = this.sum(result[currency]['free'], result[currency]['used']);
                                }
                                return _context6.abrupt('return', this.parseBalance(this.extend({ 'info': response }, result)));

                            case 12:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchBalance() {
                return _ref6.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = this.parse8601(order['datetime']);
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'amount_original');
            var remaining = this.safeFloat(order, 'amount_outstanding');
            var filled = amount - remaining;
            var status = this.safeString(order, 'status');
            if (status === 'cancelled') {
                status = 'canceled';
            } else {
                status = remaining ? 'open' : 'closed';
            }
            var info = this.safeValue(order, 'info', order);
            return {
                'id': this.safeString(order, 'id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': undefined,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': undefined,
                'info': info
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, response, id, order;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.privatePostTradeAddQuote(this.extend({
                                    'coin': market['baseId'],
                                    'quote': market['quoteId'],
                                    'type': side,
                                    'amount': amount,
                                    'price': price
                                }, params));

                            case 5:
                                response = _context7.sent;
                                id = response['id'].toString();
                                order = this.parseOrder({
                                    'id': id,
                                    'datetime': this.ymdhms(this.milliseconds()),
                                    'amount_original': amount,
                                    'amount_outstanding': amount,
                                    'price': price,
                                    'type': side,
                                    'info': response
                                }, market);

                                this.orders[id] = order;
                                return _context7.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x16, _x17, _x18, _x19) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.privatePostTradeCancelQuote(this.extend({
                                    'id': id,
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                }, params));

                            case 5:
                                response = _context8.sent;
                                return _context8.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x22) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context9.next = 5;
                                return this.privatePostTradeViewQuote(this.extend({
                                    'id': id,
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                }, params));

                            case 5:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(response['data'], market));

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x25) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, orders;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'coin': market['baseId'],
                                    'quote': market['quoteId']
                                };

                                if (typeof since !== 'undefined') request['since'] = since / 1000;
                                _context10.next = 7;
                                return this.privatePostTradeListQuote(this.extend(request, params));

                            case 7:
                                orders = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(orders['data'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'type': 'open'
                                }, params));

                            case 2:
                                result = _context11.sent;
                                return _context11.abrupt('return', result);

                            case 4:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var apiType = 'rest';
            if (api === 'web') {
                apiType = api;
            }
            var url = this.urls['api'][apiType] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public' || api === 'web') {
                if (api === 'web') query['t'] = this.nonce();
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                query = this.urlencode(this.extend({
                    'key': this.apiKey,
                    'nonce': this.nonce()
                }, query));
                var secret = this.hash(this.encode(this.secret));
                var signature = this.hmac(this.encode(query), this.encode(secret));
                query += '&' + 'signature=' + signature;
                if (method === 'GET') {
                    url += '?' + query;
                } else {
                    headers = {
                        'Content-type': 'application/x-www-form-urlencoded'
                    };
                    body = query;
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            // checks against error codes
            if (typeof body !== 'string') return;
            if (body.length === 0) return;
            if (body[0] !== '{') return;
            var response = JSON.parse(body);
            // private endpoints return the following structure:
            // {"result":true,"data":{...}} - success
            // {"result":false,"code":"103"} - failure
            // {"code":0,"msg":"Suceess","data":{"uid":"2716039","btc_balance":"0.00000000","btc_lock":"0.00000000","xrp_balance":"0.00000000","xrp_lock":"0.00000000"}}
            var result = this.safeValue(response, 'result');
            if (typeof result === 'undefined')
                // public endpoint ← this comment left here by the contributor, in fact a missing result does not necessarily mean a public endpoint...
                // we should just check the code and don't rely on the result at all here...
                return;
            if (result === true)
                // success
                return;
            var errorCode = this.safeString(response, 'code');
            var errorMessages = this.errorMessages;
            var message = this.safeString(errorMessages, errorCode, 'Unknown Error');
            if (errorCode in this.exceptions) {
                throw new this.exceptions[errorCode](this.id + ' ' + message);
            } else {
                throw new ExchangeError(this.id + ' ' + message);
            }
        }
    }]);

    return coinegg;
}(Exchange);

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var _require = __webpack_require__(12),
    unCamelCase = _require.unCamelCase;

var unCamelCasePropertyNames = function unCamelCasePropertyNames(x) {
    for (var k in x) {
        x[unCamelCase(k)] = x[k];
    } // camel_case_method = camelCaseMethod
    return x;
};

/*  ------------------------------------------------------------------------ */

module.exports = unCamelCasePropertyNames(Object.assign({}, __webpack_require__(38), __webpack_require__(39), __webpack_require__(12), __webpack_require__(13), __webpack_require__(14), __webpack_require__(23), __webpack_require__(66), __webpack_require__(29), __webpack_require__(67), __webpack_require__(68)));

/*  ------------------------------------------------------------------------ */

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var CryptoJS = __webpack_require__(24);
var qs = __webpack_require__(63); // querystring (TODO: get rid of that dependency)

/*  ------------------------------------------------------------------------ */

module.exports = { json: function json(data) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return JSON.stringify(data);
    },
    unjson: JSON.parse,

    stringToBinary: function stringToBinary(str) {
        var arr = new Uint8Array(str.length);
        for (var i = 0; i < str.length; i++) {
            arr[i] = str.charCodeAt(i);
        }
        return CryptoJS.lib.WordArray.create(arr);
    },
    stringToBase64: function stringToBase64(string) {
        return CryptoJS.enc.Latin1.parse(string).toString(CryptoJS.enc.Base64);
    },
    utf16ToBase64: function utf16ToBase64(string) {
        return CryptoJS.enc.Utf16.parse(string).toString(CryptoJS.enc.Base64);
    },
    base64ToBinary: function base64ToBinary(string) {
        return CryptoJS.enc.Base64.parse(string);
    },
    base64ToString: function base64ToString(string) {
        return CryptoJS.enc.Base64.parse(string).toString(CryptoJS.enc.Utf8);
    },
    binaryToString: function binaryToString(string) {
        return string;
    },

    binaryConcat: function binaryConcat() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return args.reduce(function (a, b) {
            return a.concat(b);
        });
    },

    urlencode: function urlencode(object) {
        return qs.stringify(object);
    },
    rawencode: function rawencode(object) {
        return qs.stringify(object, { encode: false });
    }

    // Url-safe-base64 without equals signs, with + replaced by - and slashes replaced by underscores

    , urlencodeBase64: function urlencodeBase64(base64string) {
        return base64string.replace(/[=]+$/, '').replace(/\+/g, '-').replace(/\//g, '_');
    }

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(9), __webpack_require__(40), __webpack_require__(41), __webpack_require__(5), __webpack_require__(6), __webpack_require__(15), __webpack_require__(25), __webpack_require__(42), __webpack_require__(26), __webpack_require__(43), __webpack_require__(44), __webpack_require__(45), __webpack_require__(16), __webpack_require__(46), __webpack_require__(4), __webpack_require__(3), __webpack_require__(47), __webpack_require__(48), __webpack_require__(49), __webpack_require__(50), __webpack_require__(51), __webpack_require__(52), __webpack_require__(53), __webpack_require__(54), __webpack_require__(55), __webpack_require__(56), __webpack_require__(57), __webpack_require__(58), __webpack_require__(59), __webpack_require__(60), __webpack_require__(61), __webpack_require__(62));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    var obj;

    while (queue.length) {
        var item = queue.pop();
        obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }

    return obj;
};

exports.arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

exports.merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = exports.arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = exports.merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = exports.merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

exports.assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

exports.decode = function (str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function encode(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    return compactQueue(queue);
};

exports.isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

exports.isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var now = Date.now; // TODO: figure out how to utilize performance.now () properly – it's not as easy as it does not return a unix timestamp...

/*  ------------------------------------------------------------------------ */

var setTimeout_original = setTimeout;
var setTimeout_safe = function setTimeout_safe(done, ms) {
    var setTimeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : setTimeout_original;
    var targetTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : now() + ms;


    /*  The built-in setTimeout function can fire its callback earlier than specified, so we
        need to ensure that it does not happen: sleep recursively until `targetTime` is reached...   */

    var clearInnerTimeout = function clearInnerTimeout() {};
    var active = true;

    var id = setTimeout(function () {
        active = true;
        var rest = targetTime - now();
        if (rest > 0) {
            clearInnerTimeout = setTimeout_safe(done, rest, setTimeout, targetTime); // try sleep more
        } else {
            done();
        }
    }, ms);

    return function clear() {
        if (active) {
            active = false; // dunno if IDs are unique on various platforms, so it's better to rely on this flag to exclude the possible cancellation of the wrong timer (if called after completion)
            clearTimeout(id);
        }
        clearInnerTimeout();
    };
};

/*  ------------------------------------------------------------------------ */

var TimedOut = function (_Error) {
    _inherits(TimedOut, _Error);

    function TimedOut() {
        _classCallCheck(this, TimedOut);

        var message = 'timed out';

        var _this = _possibleConstructorReturn(this, (TimedOut.__proto__ || Object.getPrototypeOf(TimedOut)).call(this, message));

        _this.constructor = TimedOut;
        _this.__proto__ = TimedOut.prototype;
        _this.message = message;
        return _this;
    }

    return TimedOut;
}(Error);

/*  ------------------------------------------------------------------------ */

module.exports = { now: now,
    setTimeout_safe: setTimeout_safe,
    sleep: function sleep(ms) {
        return new Promise(function (resolve) {
            return setTimeout_safe(resolve, ms);
        });
    },
    TimedOut: TimedOut,
    timeout: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ms, promise) {
            var clear, expires;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            clear = function clear() {};

                            expires = new Promise(function (resolve) {
                                return clear = setTimeout_safe(resolve, ms);
                            });
                            _context.prev = 2;
                            _context.next = 5;
                            return Promise.race([promise, expires.then(function () {
                                throw new TimedOut();
                            })]);

                        case 5:
                            return _context.abrupt('return', _context.sent);

                        case 6:
                            _context.prev = 6;

                            clear(); // fixes https://github.com/ccxt/ccxt/issues/749
                            return _context.finish(6);

                        case 9:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[2,, 6, 9]]);
        }));

        return function timeout(_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }()

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(_1btcxe, _Exchange);

    function _1btcxe() {
        _classCallCheck(this, _1btcxe);

        return _possibleConstructorReturn(this, (_1btcxe.__proto__ || Object.getPrototypeOf(_1btcxe)).apply(this, arguments));
    }

    _createClass(_1btcxe, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(_1btcxe.prototype.__proto__ || Object.getPrototypeOf(_1btcxe.prototype), 'describe', this).call(this), {
                'id': '_1btcxe',
                'name': '1BTCXE',
                'countries': 'PA', // Panama
                'comment': 'Crypto Capital API',
                'has': {
                    'CORS': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1d': '1year'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766049-2b294408-5ecc-11e7-85cc-adaff013dc1a.jpg',
                    'api': 'https://1btcxe.com/api',
                    'www': 'https://1btcxe.com',
                    'doc': 'https://1btcxe.com/api-docs.php'
                },
                'api': {
                    'public': {
                        'get': ['stats', 'historical-prices', 'order-book', 'transactions']
                    },
                    'private': {
                        'post': ['balances-and-info', 'open-orders', 'user-transactions', 'btc-deposit-address/get', 'btc-deposit-address/new', 'deposits/get', 'withdrawals/get', 'orders/new', 'orders/edit', 'orders/cancel', 'orders/status', 'withdrawals/new']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                return _context.abrupt('return', [{ 'id': 'USD', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD' }, { 'id': 'EUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' }, { 'id': 'CNY', 'symbol': 'BTC/CNY', 'base': 'BTC', 'quote': 'CNY' }, { 'id': 'RUB', 'symbol': 'BTC/RUB', 'base': 'BTC', 'quote': 'RUB' }, { 'id': 'CHF', 'symbol': 'BTC/CHF', 'base': 'BTC', 'quote': 'CHF' }, { 'id': 'JPY', 'symbol': 'BTC/JPY', 'base': 'BTC', 'quote': 'JPY' }, { 'id': 'GBP', 'symbol': 'BTC/GBP', 'base': 'BTC', 'quote': 'GBP' }, { 'id': 'CAD', 'symbol': 'BTC/CAD', 'base': 'BTC', 'quote': 'CAD' }, { 'id': 'AUD', 'symbol': 'BTC/AUD', 'base': 'BTC', 'quote': 'AUD' }, { 'id': 'AED', 'symbol': 'BTC/AED', 'base': 'BTC', 'quote': 'AED' }, { 'id': 'BGN', 'symbol': 'BTC/BGN', 'base': 'BTC', 'quote': 'BGN' }, { 'id': 'CZK', 'symbol': 'BTC/CZK', 'base': 'BTC', 'quote': 'CZK' }, { 'id': 'DKK', 'symbol': 'BTC/DKK', 'base': 'BTC', 'quote': 'DKK' }, { 'id': 'HKD', 'symbol': 'BTC/HKD', 'base': 'BTC', 'quote': 'HKD' }, { 'id': 'HRK', 'symbol': 'BTC/HRK', 'base': 'BTC', 'quote': 'HRK' }, { 'id': 'HUF', 'symbol': 'BTC/HUF', 'base': 'BTC', 'quote': 'HUF' }, { 'id': 'ILS', 'symbol': 'BTC/ILS', 'base': 'BTC', 'quote': 'ILS' }, { 'id': 'INR', 'symbol': 'BTC/INR', 'base': 'BTC', 'quote': 'INR' }, { 'id': 'MUR', 'symbol': 'BTC/MUR', 'base': 'BTC', 'quote': 'MUR' }, { 'id': 'MXN', 'symbol': 'BTC/MXN', 'base': 'BTC', 'quote': 'MXN' }, { 'id': 'NOK', 'symbol': 'BTC/NOK', 'base': 'BTC', 'quote': 'NOK' }, { 'id': 'NZD', 'symbol': 'BTC/NZD', 'base': 'BTC', 'quote': 'NZD' }, { 'id': 'PLN', 'symbol': 'BTC/PLN', 'base': 'BTC', 'quote': 'PLN' }, { 'id': 'RON', 'symbol': 'BTC/RON', 'base': 'BTC', 'quote': 'RON' }, { 'id': 'SEK', 'symbol': 'BTC/SEK', 'base': 'BTC', 'quote': 'SEK' }, { 'id': 'SGD', 'symbol': 'BTC/SGD', 'base': 'BTC', 'quote': 'SGD' }, { 'id': 'THB', 'symbol': 'BTC/THB', 'base': 'BTC', 'quote': 'THB' }, { 'id': 'TRY', 'symbol': 'BTC/TRY', 'base': 'BTC', 'quote': 'TRY' }, { 'id': 'ZAR', 'symbol': 'BTC/ZAR', 'base': 'BTC', 'quote': 'ZAR' }]);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, result, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.privatePostBalancesAndInfo();

                            case 2:
                                response = _context2.sent;
                                balance = response['balances-and-info'];
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    account['free'] = this.safeFloat(balance['available'], currency, 0.0);
                                    account['used'] = this.safeFloat(balance['on_hold'], currency, 0.0);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetOrderBook(this.extend({
                                    'currency': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(response['order-book'], undefined, 'bid', 'ask', 'price', 'order_amount'));

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.publicGetStats(this.extend({
                                    'currency': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context4.sent;
                                ticker = response['stats'];
                                last = this.safeFloat(ticker, 'last_price');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': undefined,
                                    'datetime': undefined,
                                    'high': this.safeFloat(ticker, 'max'),
                                    'low': this.safeFloat(ticker, 'min'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': this.safeFloat(ticker, 'daily_change'),
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': this.safeFloat(ticker, 'total_btc_traded'),
                                    'info': ticker
                                });

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [this.parse8601(ohlcv['date'] + ' 00:00:00'), undefined, undefined, undefined, parseFloat(ohlcv['price']), undefined];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1d';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response, ohlcvs;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                _context5.next = 3;
                                return this.publicGetHistoricalPrices(this.extend({
                                    'currency': market['id'],
                                    'timeframe': this.timeframes[timeframe]
                                }, params));

                            case 3:
                                response = _context5.sent;
                                ohlcvs = this.omit(response['historical-prices'], 'request_currency');
                                return _context5.abrupt('return', this.parseOHLCVs(ohlcvs, market, timeframe, since, limit));

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x11) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['timestamp']) * 1000;
            return {
                'id': trade['id'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': undefined,
                'type': undefined,
                'side': trade['maker_type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                market = this.market(symbol);
                                _context6.next = 3;
                                return this.publicGetTransactions(this.extend({
                                    'currency': market['id']
                                }, params));

                            case 3:
                                response = _context6.sent;
                                trades = this.omit(response['transactions'], 'request_currency');
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x16) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, result;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                order = {
                                    'side': side,
                                    'type': type,
                                    'currency': this.marketId(symbol),
                                    'amount': amount
                                };

                                if (type === 'limit') order['limit_price'] = price;
                                _context7.next = 4;
                                return this.privatePostOrdersNew(this.extend(order, params));

                            case 4:
                                result = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': result,
                                    'id': result
                                });

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x20, _x21, _x22, _x23) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.privatePostOrdersCancel({ 'id': id });

                            case 2:
                                return _context8.abrupt('return', _context8.sent);

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x26) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                this.checkAddress(address);
                                _context9.next = 3;
                                return this.loadMarkets();

                            case 3:
                                _context9.next = 5;
                                return this.privatePostWithdrawalsNew(this.extend({
                                    'currency': currency,
                                    'amount': parseFloat(amount),
                                    'address': address
                                }, params));

                            case 5:
                                response = _context9.sent;
                                return _context9.abrupt('return', {
                                    'info': response,
                                    'id': response['result']['uuid']
                                });

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function withdraw(_x29, _x30, _x31) {
                return _ref9.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            if (this.id === 'cryptocapital') throw new ExchangeError(this.id + ' is an abstract base API for _1btcxe');
            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var query = this.extend({
                    'api_key': this.apiKey,
                    'nonce': this.nonce()
                }, params);
                var request = this.json(query);
                query['signature'] = this.hmac(this.encode(request), this.encode(this.secret));
                body = this.json(query);
                headers = { 'Content-Type': 'application/json' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, errors, e, error;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('errors' in response)) {
                                    _context10.next = 8;
                                    break;
                                }

                                errors = [];

                                for (e = 0; e < response['errors'].length; e++) {
                                    error = response['errors'][e];

                                    errors.push(error['code'] + ': ' + error['message']);
                                }
                                errors = errors.join(' ');
                                throw new ExchangeError(this.id + ' ' + errors);

                            case 8:
                                return _context10.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x39) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return _1btcxe;
}(Exchange);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    AuthenticationError = _require.AuthenticationError,
    InvalidOrder = _require.InvalidOrder,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection,
    PermissionDenied = _require.PermissionDenied;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bittrex, _Exchange);

    function bittrex() {
        _classCallCheck(this, bittrex);

        return _possibleConstructorReturn(this, (bittrex.__proto__ || Object.getPrototypeOf(bittrex)).apply(this, arguments));
    }

    _createClass(bittrex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bittrex.prototype.__proto__ || Object.getPrototypeOf(bittrex.prototype), 'describe', this).call(this), {
                'id': 'bittrex',
                'name': 'Bittrex',
                'countries': 'US',
                'version': 'v1.1',
                'rateLimit': 1500,
                // new metainfo interface
                'has': {
                    'CORS': true,
                    'createMarketOrder': false,
                    'fetchDepositAddress': true,
                    'fetchClosedOrders': true,
                    'fetchCurrencies': true,
                    'fetchMyTrades': false,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': 'oneMin',
                    '5m': 'fiveMin',
                    '30m': 'thirtyMin',
                    '1h': 'hour',
                    '1d': 'day'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766352-cf0b3c26-5ed5-11e7-82b7-f3826b7a97d8.jpg',
                    'api': {
                        'public': 'https://bittrex.com/api',
                        'account': 'https://bittrex.com/api',
                        'market': 'https://bittrex.com/api',
                        'v2': 'https://bittrex.com/api/v2.0/pub'
                    },
                    'www': 'https://bittrex.com',
                    'doc': ['https://bittrex.com/Home/Api', 'https://www.npmjs.org/package/node.bittrex.api'],
                    'fees': ['https://bittrex.com/Fees', 'https://support.bittrex.com/hc/en-us/articles/115000199651-What-fees-does-Bittrex-charge-']
                },
                'api': {
                    'v2': {
                        'get': ['currencies/GetBTCPrice', 'market/GetTicks', 'market/GetLatestTick', 'Markets/GetMarketSummaries', 'market/GetLatestTick']
                    },
                    'public': {
                        'get': ['currencies', 'markethistory', 'markets', 'marketsummaries', 'marketsummary', 'orderbook', 'ticker']
                    },
                    'account': {
                        'get': ['balance', 'balances', 'depositaddress', 'deposithistory', 'order', 'orders', 'orderhistory', 'withdrawalhistory', 'withdraw']
                    },
                    'market': {
                        'get': ['buylimit', 'buymarket', 'cancel', 'openorders', 'selllimit', 'sellmarket']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.0025,
                        'taker': 0.0025
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'LTC': 0.01,
                            'DOGE': 2,
                            'VTC': 0.02,
                            'PPC': 0.02,
                            'FTC': 0.2,
                            'RDD': 2,
                            'NXT': 2,
                            'DASH': 0.002,
                            'POT': 0.002
                        },
                        'deposit': {
                            'BTC': 0,
                            'LTC': 0,
                            'DOGE': 0,
                            'VTC': 0,
                            'PPC': 0,
                            'FTC': 0,
                            'RDD': 0,
                            'NXT': 0,
                            'DASH': 0,
                            'POT': 0
                        }
                    }
                },
                'exceptions': {
                    // 'Call to Cancel was throttled. Try again in 60 seconds.': DDoSProtection,
                    // 'Call to GetBalances was throttled. Try again in 60 seconds.': DDoSProtection,
                    'APISIGN_NOT_PROVIDED': AuthenticationError,
                    'INVALID_SIGNATURE': AuthenticationError,
                    'INVALID_CURRENCY': ExchangeError,
                    'INVALID_PERMISSION': AuthenticationError,
                    'INSUFFICIENT_FUNDS': InsufficientFunds,
                    'QUANTITY_NOT_PROVIDED': InvalidOrder,
                    'MIN_TRADE_REQUIREMENT_NOT_MET': InvalidOrder,
                    'ORDER_NOT_OPEN': InvalidOrder,
                    'UUID_INVALID': OrderNotFound,
                    'RATE_NOT_PROVIDED': InvalidOrder, // createLimitBuyOrder ('ETH/BTC', 1, 0)
                    'WHITELIST_VIOLATION_IP': PermissionDenied
                },
                'options': {
                    'parseOrderStatus': false,
                    'hasAlreadyAuthenticatedSuccessfully': false // a workaround for APIKEY_INVALID
                }
            });
        }
    }, {
        key: 'costToPrecision',
        value: function costToPrecision(symbol, cost) {
            return this.truncate(parseFloat(cost), this.markets[symbol]['precision']['price']);
        }
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(symbol, fee) {
            return this.truncate(parseFloat(fee), this.markets[symbol]['precision']['price']);
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, result, i, market, id, baseId, quoteId, base, quote, symbol, precision, active;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.v2GetMarketsGetMarketSummaries();

                            case 2:
                                response = _context.sent;
                                result = [];

                                for (i = 0; i < response['result'].length; i++) {
                                    market = response['result'][i]['Market'];
                                    id = market['MarketName'];
                                    baseId = market['MarketCurrency'];
                                    quoteId = market['BaseCurrency'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    active = market['IsActive'] || market['IsActive'] === 'true';

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': active,
                                        'info': market,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': market['MinTradeSize'],
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, indexed, keys, i, id, currency, account, balance, free, total, used;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.accountGetBalances(params);

                            case 4:
                                response = _context2.sent;
                                balances = response['result'];
                                result = { 'info': balances };
                                indexed = this.indexBy(balances, 'Currency');
                                keys = Object.keys(indexed);

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    currency = this.commonCurrencyCode(id);
                                    account = this.account();
                                    balance = indexed[id];
                                    free = parseFloat(balance['Available']);
                                    total = parseFloat(balance['Balance']);
                                    used = total - free;

                                    account['free'] = free;
                                    account['used'] = used;
                                    account['total'] = total;
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderbook(this.extend({
                                    'market': this.marketId(symbol),
                                    'type': 'both'
                                }, params));

                            case 4:
                                response = _context3.sent;
                                orderbook = response['result'];

                                if ('type' in params) {
                                    if (params['type'] === 'buy') {
                                        orderbook = {
                                            'buy': response['result'],
                                            'sell': []
                                        };
                                    } else if (params['type'] === 'sell') {
                                        orderbook = {
                                            'buy': [],
                                            'sell': response['result']
                                        };
                                    }
                                }
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy', 'sell', 'Rate', 'Quantity'));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeString(ticker, 'TimeStamp');
            var iso8601 = undefined;
            if (typeof timestamp === 'string') {
                if (timestamp.length > 0) {
                    timestamp = this.parse8601(timestamp);
                    iso8601 = this.iso8601(timestamp);
                }
            }
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var previous = this.safeFloat(ticker, 'PrevDay');
            var last = this.safeFloat(ticker, 'Last');
            var change = undefined;
            var percentage = undefined;
            if (typeof last !== 'undefined') if (typeof previous !== 'undefined') {
                change = last - previous;
                if (previous > 0) percentage = change / previous * 100;
            }
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': iso8601,
                'high': this.safeFloat(ticker, 'High'),
                'low': this.safeFloat(ticker, 'Low'),
                'bid': this.safeFloat(ticker, 'Bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'Ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': percentage,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'Volume'),
                'quoteVolume': this.safeFloat(ticker, 'BaseVolume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, code, precision, address;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.publicGetCurrencies(params);

                            case 2:
                                response = _context4.sent;
                                currencies = response['result'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['Currency'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    code = this.commonCurrencyCode(id);
                                    precision = 8; // default precision, todo: fix "magic constants"

                                    address = this.safeValue(currency, 'BaseAddress');

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'address': address,
                                        'info': currency,
                                        'type': currency['CoinType'],
                                        'name': currency['CurrencyLong'],
                                        'active': currency['IsActive'],
                                        'status': 'ok',
                                        'fee': this.safeFloat(currency, 'TxFee'), // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['TxFee'],
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context4.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchCurrencies() {
                return _ref4.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, t, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetMarketsummaries(params);

                            case 4:
                                response = _context5.sent;
                                tickers = response['result'];
                                result = {};

                                for (t = 0; t < tickers.length; t++) {
                                    ticker = tickers[t];
                                    id = ticker['MarketName'];
                                    market = undefined;
                                    symbol = id;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    } else {
                                        symbol = this.parseSymbol(id);
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetMarketsummary(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                ticker = response['result'][0];
                                return _context6.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x9) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['TimeStamp'] + '+00:00');
            var side = undefined;
            if (trade['OrderType'] === 'BUY') {
                side = 'buy';
            } else if (trade['OrderType'] === 'SELL') {
                side = 'sell';
            }
            var id = undefined;
            if ('Id' in trade) id = trade['Id'].toString();
            return {
                'id': id,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': 'limit',
                'side': side,
                'price': this.safeFloat(trade, 'Price'),
                'amount': this.safeFloat(trade, 'Quantity')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetMarkethistory(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;

                                if (!('result' in response)) {
                                    _context7.next = 9;
                                    break;
                                }

                                if (!(typeof response['result'] !== 'undefined')) {
                                    _context7.next = 9;
                                    break;
                                }

                                return _context7.abrupt('return', this.parseTrades(response['result'], market, since, limit));

                            case 9:
                                throw new ExchangeError(this.id + ' fetchTrades() returned undefined response');

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x12) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var timestamp = this.parse8601(ohlcv['T'] + '+00:00');
            return [timestamp, ohlcv['O'], ohlcv['H'], ohlcv['L'], ohlcv['C'], ohlcv['V']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'tickInterval': this.timeframes[timeframe],
                                    'marketName': market['id']
                                };
                                _context8.next = 6;
                                return this.v2GetMarketGetTicks(this.extend(request, params));

                            case 6:
                                response = _context8.sent;

                                if (!('result' in response)) {
                                    _context8.next = 10;
                                    break;
                                }

                                if (!response['result']) {
                                    _context8.next = 10;
                                    break;
                                }

                                return _context8.abrupt('return', this.parseOHLCVs(response['result'], market, timeframe, since, limit));

                            case 10:
                                throw new ExchangeError(this.id + ' returned an empty or unrecognized response: ' + this.json(response));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOHLCV(_x20) {
                return _ref8.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response, orders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['market'] = market['id'];
                                }
                                _context9.next = 7;
                                return this.marketGetOpenorders(this.extend(request, params));

                            case 7:
                                response = _context9.sent;
                                orders = this.parseOrders(response['result'], market, since, limit);
                                return _context9.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOpenOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, order, response, orderIdField, result;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                method = 'marketGet' + this.capitalize(side) + type;
                                order = {
                                    'market': market['id'],
                                    'quantity': this.amountToPrecision(symbol, amount),
                                    'rate': this.priceToPrecision(symbol, price)
                                };
                                // if (type == 'limit')
                                //     order['rate'] = this.priceToPrecision (symbol, price);

                                _context10.next = 9;
                                return this[method](this.extend(order, params));

                            case 9:
                                response = _context10.sent;
                                orderIdField = this.getOrderIdField();
                                result = {
                                    'info': response,
                                    'id': response['result'][orderIdField],
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'status': 'open'
                                };
                                return _context10.abrupt('return', result);

                            case 13:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x29, _x30, _x31, _x32) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'getOrderIdField',
        value: function getOrderIdField() {
            return 'uuid';
        }
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderIdField, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                orderIdField = this.getOrderIdField();
                                request = {};

                                request[orderIdField] = id;
                                _context11.next = 7;
                                return this.marketGetCancel(this.extend(request, params));

                            case 7:
                                response = _context11.sent;
                                return _context11.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function cancelOrder(_x35) {
                return _ref11.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseSymbol',
        value: function parseSymbol(id) {
            var _id$split = id.split('-'),
                _id$split2 = _slicedToArray(_id$split, 2),
                quote = _id$split2[0],
                base = _id$split2[1];

            base = this.commonCurrencyCode(base);
            quote = this.commonCurrencyCode(quote);
            return base + '/' + quote;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = this.safeString(order, 'OrderType');
            if (typeof side === 'undefined') side = this.safeString(order, 'Type');
            var isBuyOrder = side === 'LIMIT_BUY' || side === 'BUY';
            side = isBuyOrder ? 'buy' : 'sell';
            var status = 'open';
            if ('Closed' in order && order['Closed']) status = 'closed';
            if ('CancelInitiated' in order && order['CancelInitiated']) status = 'canceled';
            if ('Status' in order && this.options['parseOrderStatus']) status = this.parseOrderStatus(order['Status']);
            var symbol = undefined;
            if ('Exchange' in order) {
                var marketId = order['Exchange'];
                if (marketId in this.markets_by_id) {
                    market = this.markets_by_id[marketId];
                    symbol = market['symbol'];
                } else {
                    symbol = this.parseSymbol(marketId);
                }
            } else {
                if (typeof market !== 'undefined') {
                    symbol = market['symbol'];
                }
            }
            var timestamp = undefined;
            if ('Opened' in order) timestamp = this.parse8601(order['Opened'] + '+00:00');
            if ('Created' in order) timestamp = this.parse8601(order['Created'] + '+00:00');
            var lastTradeTimestamp = undefined;
            if ('TimeStamp' in order && typeof order['TimeStamp'] !== 'undefined') lastTradeTimestamp = this.parse8601(order['TimeStamp'] + '+00:00');
            if ('Closed' in order && typeof order['Closed'] !== 'undefined') lastTradeTimestamp = this.parse8601(order['Closed'] + '+00:00');
            if (typeof timestamp === 'undefined') timestamp = lastTradeTimestamp;
            var iso8601 = typeof timestamp !== 'undefined' ? this.iso8601(timestamp) : undefined;
            var fee = undefined;
            var commission = undefined;
            if ('Commission' in order) {
                commission = 'Commission';
            } else if ('CommissionPaid' in order) {
                commission = 'CommissionPaid';
            }
            if (commission) {
                fee = {
                    'cost': parseFloat(order[commission])
                };
                if (typeof market !== 'undefined') {
                    fee['currency'] = market['quote'];
                } else if (symbol) {
                    var currencyIds = symbol.split('/');
                    var quoteCurrencyId = currencyIds[1];
                    if (quoteCurrencyId in this.currencies_by_id) fee['currency'] = this.currencies_by_id[quoteCurrencyId]['code'];else fee['currency'] = this.commonCurrencyCode(quoteCurrencyId);
                }
            }
            var price = this.safeFloat(order, 'Limit');
            var cost = this.safeFloat(order, 'Price');
            var amount = this.safeFloat(order, 'Quantity');
            var remaining = this.safeFloat(order, 'QuantityRemaining', 0.0);
            var filled = amount - remaining;
            if (!cost) {
                if (price && amount) cost = price * amount;
            }
            if (!price) {
                if (cost && filled) price = cost / filled;
            }
            var average = this.safeFloat(order, 'PricePerUnit');
            var id = this.safeString(order, 'OrderUuid');
            if (typeof id === 'undefined') id = this.safeString(order, 'OrderId');
            var result = {
                'info': order,
                'id': id,
                'timestamp': timestamp,
                'datetime': iso8601,
                'lastTradeTimestamp': lastTradeTimestamp,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'cost': cost,
                'average': average,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': fee
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderIdField, request, message;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                response = undefined;
                                _context12.prev = 3;
                                orderIdField = this.getOrderIdField();
                                request = {};

                                request[orderIdField] = id;
                                _context12.next = 9;
                                return this.accountGetOrder(this.extend(request, params));

                            case 9:
                                response = _context12.sent;
                                _context12.next = 19;
                                break;

                            case 12:
                                _context12.prev = 12;
                                _context12.t0 = _context12['catch'](3);

                                if (!this.last_json_response) {
                                    _context12.next = 18;
                                    break;
                                }

                                message = this.safeString(this.last_json_response, 'message');

                                if (!(message === 'UUID_INVALID')) {
                                    _context12.next = 18;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' fetchOrder() error: ' + this.last_http_response);

                            case 18:
                                throw _context12.t0;

                            case 19:
                                return _context12.abrupt('return', this.parseOrder(response['result']));

                            case 20:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this, [[3, 12]]);
            }));

            function fetchOrder(_x39) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response, orders;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['market'] = market['id'];
                                }
                                _context13.next = 7;
                                return this.accountGetOrderhistory(this.extend(request, params));

                            case 7:
                                response = _context13.sent;
                                orders = this.parseOrders(response['result'], market, since, limit);

                                if (!symbol) {
                                    _context13.next = 11;
                                    break;
                                }

                                return _context13.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 11:
                                return _context13.abrupt('return', orders);

                            case 12:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchClosedOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, message, status, tag;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context14.next = 5;
                                return this.accountGetDepositaddress(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context14.sent;
                                address = this.safeString(response['result'], 'Address');
                                message = this.safeString(response, 'message');
                                status = 'ok';

                                if (!address || message === 'ADDRESS_GENERATING') status = 'pending';
                                tag = undefined;

                                if (code === 'XRP' || code === 'XLM') {
                                    tag = address;
                                    address = currency['address'];
                                }
                                this.checkAddress(address);
                                return _context14.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': tag,
                                    'status': status,
                                    'info': response
                                });

                            case 14:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchDepositAddress(_x46) {
                return _ref14.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response, id;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                this.checkAddress(address);
                                _context15.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                request = {
                                    'currency': currency['id'],
                                    'quantity': amount,
                                    'address': address
                                };

                                if (tag) request['paymentid'] = tag;
                                _context15.next = 8;
                                return this.accountGetWithdraw(this.extend(request, params));

                            case 8:
                                response = _context15.sent;
                                id = undefined;

                                if ('result' in response) {
                                    if ('uuid' in response['result']) id = response['result']['uuid'];
                                }
                                return _context15.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 12:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function withdraw(_x48, _x49, _x50) {
                return _ref15.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/';
            if (api !== 'v2') url += this.version + '/';
            if (api === 'public') {
                url += api + '/' + method.toLowerCase() + path;
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else if (api === 'v2') {
                url += path;
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                url += api + '/';
                if (api === 'account' && path !== 'withdraw' || path === 'openorders') url += method.toLowerCase();
                url += path + '?' + this.urlencode(this.extend({
                    'nonce': nonce,
                    'apikey': this.apiKey
                }, params));
                var signature = this.hmac(this.encode(url), this.encode(this.secret), 'sha512');
                headers = { 'apisign': signature };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body[0] === '{') {
                var response = JSON.parse(body);
                // { success: false, message: "message" }
                var success = this.safeValue(response, 'success');
                if (typeof success === 'undefined') throw new ExchangeError(this.id + ': malformed response: ' + this.json(response));
                if (typeof success === 'string')
                    // bleutrade uses string instead of boolean
                    success = success === 'true' ? true : false;
                if (!success) {
                    var message = this.safeString(response, 'message');
                    var feedback = this.id + ' ' + this.json(response);
                    var exceptions = this.exceptions;
                    if (message in exceptions) throw new exceptions[message](feedback);
                    if (typeof message !== 'undefined') {
                        if (message.indexOf('throttled. Try again') >= 0) throw new DDoSProtection(feedback);
                        if (message.indexOf('problem') >= 0) throw new ExchangeNotAvailable(feedback); // 'There was a problem processing your request.  If this problem persists, please contact...')
                    }
                    if (message === 'APIKEY_INVALID') {
                        if (this.options['hasAlreadyAuthenticatedSuccessfully']) {
                            throw new DDoSProtection(feedback);
                        } else {
                            throw new AuthenticationError(feedback);
                        }
                    }
                    if (message === 'DUST_TRADE_DISALLOWED_MIN_VALUE_50K_SAT') throw new InvalidOrder(this.id + ' order cost should be over 50k satoshi ' + this.json(response));
                    throw new ExchangeError(this.id + ' ' + this.json(response));
                }
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context16.sent;

                                // a workaround for APIKEY_INVALID
                                if (api === 'account' || api === 'market') this.options['hasAlreadyAuthenticatedSuccessfully'] = true;
                                return _context16.abrupt('return', response);

                            case 5:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function request(_x58) {
                return _ref16.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bittrex;
}(Exchange);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError,
    PermissionDenied = _require.PermissionDenied,
    InvalidNonce = _require.InvalidNonce,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btcbox, _Exchange);

    function btcbox() {
        _classCallCheck(this, btcbox);

        return _possibleConstructorReturn(this, (btcbox.__proto__ || Object.getPrototypeOf(btcbox)).apply(this, arguments));
    }

    _createClass(btcbox, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcbox.prototype.__proto__ || Object.getPrototypeOf(btcbox.prototype), 'describe', this).call(this), {
                'id': 'btcbox',
                'name': 'BtcBox',
                'countries': 'JP',
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/31275803-4df755a8-aaa1-11e7-9abb-11ec2fad9f2d.jpg',
                    'api': 'https://www.btcbox.co.jp/api',
                    'www': 'https://www.btcbox.co.jp/',
                    'doc': 'https://www.btcbox.co.jp/help/asm'
                },
                'api': {
                    'public': {
                        'get': ['depth', 'orders', 'ticker', 'allticker']
                    },
                    'private': {
                        'post': ['balance', 'trade_add', 'trade_cancel', 'trade_list', 'trade_view', 'wallet']
                    }
                },
                'markets': {
                    'BTC/JPY': { 'id': 'BTC/JPY', 'symbol': 'BTC/JPY', 'base': 'BTC', 'quote': 'JPY' }
                },
                'exceptions': {
                    '104': AuthenticationError,
                    '105': PermissionDenied,
                    '106': InvalidNonce,
                    '107': InvalidOrder, // price should be an integer
                    '200': InsufficientFunds,
                    '201': InvalidOrder, // amount too small
                    '202': InvalidOrder, // price should be [0 : 1000000]
                    '203': OrderNotFound,
                    '401': OrderNotFound, // cancel canceled, closed or non-existent order
                    '402': DDoSProtection
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, currency, lowercase, account, free, used;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();

                                    if (lowercase === 'dash') lowercase = 'drk';
                                    account = this.account();
                                    free = lowercase + '_balance';
                                    used = lowercase + '_lock';

                                    if (free in balances) account['free'] = parseFloat(balances[free]);
                                    if (used in balances) account['used'] = parseFloat(balances[used]);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, numSymbols, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {};
                                numSymbols = this.symbols.length;

                                if (numSymbols > 1) request['coin'] = market['id'];
                                _context2.next = 8;
                                return this.publicGetDepth(this.extend(request, params));

                            case 8:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'volume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetAllticker(params);

                            case 4:
                                tickers = _context3.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context3.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, request, numSymbols, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {};
                                numSymbols = this.symbols.length;

                                if (numSymbols > 1) request['coin'] = market['id'];
                                _context4.next = 8;
                                return this.publicGetTicker(this.extend(request, params));

                            case 8:
                                ticker = _context4.sent;
                                return _context4.abrupt('return', this.parseTicker(ticker, market));

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000; // GMT time
            return {
                'info': trade,
                'id': trade['tid'],
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, numSymbols, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {};
                                numSymbols = this.symbols.length;

                                if (numSymbols > 1) request['coin'] = market['id'];
                                _context5.next = 8;
                                return this.publicGetOrders(this.extend(request, params));

                            case 8:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, numSymbols, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'amount': amount,
                                    'price': price,
                                    'type': side
                                };
                                numSymbols = this.symbols.length;

                                if (numSymbols > 1) request['coin'] = market['id'];
                                _context6.next = 8;
                                return this.privatePostTradeAdd(this.extend(request, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostTradeCancel(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                return _context7.abrupt('return', _context7.sent);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x20) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            // {"id":11,"datetime":"2014-10-21 10:47:20","type":"sell","price":42000,"amount_original":1.2,"amount_outstanding":1.2,"status":"closed","trades":[]}
            var id = this.safeString(order, 'id');
            var timestamp = this.parse8601(order['datetime'] + '+09:00'); // Tokyo time
            var amount = this.safeFloat(order, 'amount_original');
            var remaining = this.safeFloat(order, 'amount_outstanding');
            var filled = undefined;
            if (typeof amount !== 'undefined') if (typeof remaining !== 'undefined') filled = amount - remaining;
            var price = this.safeFloat(order, 'price');
            var cost = undefined;
            if (typeof price !== 'undefined') if (typeof filled !== 'undefined') cost = filled * price;
            // status is set by fetchOrder method only
            var statuses = {
                // TODO: complete list
                'part': 'open', // partially or not at all executed
                'all': 'closed', // fully executed
                'cancelled': 'canceled',
                'closed': 'closed' // never encountered, seems to be bug in the doc
            };
            var status = undefined;
            if (order['status'] in statuses) status = statuses[order['status']];
            // fetchOrders do not return status, use heuristic
            if (typeof status === 'undefined') if (typeof remaining !== 'undefined' && remaining === 0) status = 'closed';
            var trades = undefined; // todo: this.parseTrades (order['trades']);
            return {
                'id': id,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'amount': amount,
                'remaining': remaining,
                'filled': filled,
                'side': order['type'],
                'type': undefined,
                'status': status,
                'symbol': 'BTC/JPY',
                'price': price,
                'cost': cost,
                'trades': trades,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privatePostTradeView(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrder(_x23) {
                return _ref8.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostTradeList(this.extend({
                                    'type': 'all' // 'open' or 'all'
                                }, params));

                            case 4:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(response));

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response, orders, i, order;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostTradeList(this.extend({
                                    'type': 'open' // 'open' or 'all'
                                }, params));

                            case 4:
                                response = _context10.sent;
                                orders = this.parseOrders(response);
                                // btcbox does not return status, but we know it's 'open' as we queried for open orders

                                for (i = 0; i < orders.length; i++) {
                                    order = orders[i];

                                    order['status'] = 'open';
                                }
                                return _context10.abrupt('return', orders);

                            case 8:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var query = this.extend({
                    'key': this.apiKey,
                    'nonce': nonce
                }, params);
                var request = this.urlencode(query);
                var secret = this.hash(this.encode(this.secret));
                query['signature'] = this.hmac(this.encode(request), this.encode(secret));
                body = this.urlencode(query);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            // typical error response: {"result":false,"code":"401"}
            if (httpCode >= 400) return; // resort to defaultErrorHandler
            if (body[0] !== '{') return; // not json, resort to defaultErrorHandler
            var response = JSON.parse(body);
            var result = this.safeValue(response, 'result');
            if (typeof result === 'undefined' || result === true) return; // either public API (no error codes expected) or success
            var errorCode = this.safeValue(response, 'code');
            var feedback = this.id + ' ' + this.json(response);
            var exceptions = this.exceptions;
            if (errorCode in exceptions) throw new exceptions[errorCode](feedback);
            throw new ExchangeError(feedback); // unknown message
        }
    }]);

    return btcbox;
}(Exchange);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btcturk, _Exchange);

    function btcturk() {
        _classCallCheck(this, btcturk);

        return _possibleConstructorReturn(this, (btcturk.__proto__ || Object.getPrototypeOf(btcturk)).apply(this, arguments));
    }

    _createClass(btcturk, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcturk.prototype.__proto__ || Object.getPrototypeOf(btcturk.prototype), 'describe', this).call(this), {
                'id': 'btcturk',
                'name': 'BTCTurk',
                'countries': 'TR', // Turkey
                'rateLimit': 1000,
                'has': {
                    'CORS': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true
                },
                'timeframes': {
                    '1d': '1d'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27992709-18e15646-64a3-11e7-9fa2-b0950ec7712f.jpg',
                    'api': 'https://www.btcturk.com/api',
                    'www': 'https://www.btcturk.com',
                    'doc': 'https://github.com/BTCTrader/broker-api-docs'
                },
                'api': {
                    'public': {
                        'get': ['ohlcdata', // ?last=COUNT
                        'orderbook', 'ticker', 'trades']
                    },
                    'private': {
                        'get': ['balance', 'openOrders', 'userTransactions'],
                        'post': ['exchange', 'cancelOrder']
                    }
                },
                'markets': {
                    'BTC/TRY': { 'id': 'BTCTRY', 'symbol': 'BTC/TRY', 'base': 'BTC', 'quote': 'TRY', 'maker': 0.002 * 1.18, 'taker': 0.0035 * 1.18 },
                    'ETH/TRY': { 'id': 'ETHTRY', 'symbol': 'ETH/TRY', 'base': 'ETH', 'quote': 'TRY', 'maker': 0.002 * 1.18, 'taker': 0.0035 * 1.18 },
                    'XRP/TRY': { 'id': 'XRPTRY', 'symbol': 'XRP/TRY', 'base': 'XRP', 'quote': 'TRY', 'maker': 0.002 * 1.18, 'taker': 0.0035 * 1.18 },
                    'ETH/BTC': { 'id': 'ETHBTC', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'maker': 0.002 * 1.18, 'taker': 0.0035 * 1.18 }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, base, quote, symbol, market;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetBalance();

                            case 2:
                                response = _context.sent;
                                result = { 'info': response };
                                base = {
                                    'free': response['bitcoin_available'],
                                    'used': response['bitcoin_reserved'],
                                    'total': response['bitcoin_balance']
                                };
                                quote = {
                                    'free': response['money_available'],
                                    'used': response['money_reserved'],
                                    'total': response['money_balance']
                                };
                                symbol = this.symbols[0];
                                market = this.markets[symbol];

                                result[market['base']] = base;
                                result[market['quote']] = quote;
                                return _context.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetOrderbook(this.extend({
                                    'pairSymbol': market['id']
                                }, params));

                            case 3:
                                orderbook = _context2.sent;
                                timestamp = parseInt(orderbook['timestamp'] * 1000);
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var timestamp = parseInt(ticker['timestamp']) * 1000;
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'average'),
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, i, ticker, symbol, market;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context3.sent;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    symbol = ticker['pair'];
                                    market = undefined;

                                    if (symbol in this.markets_by_id) {
                                        market = this.markets_by_id[symbol];
                                        symbol = market['symbol'];
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context3.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.fetchTickers();

                            case 4:
                                tickers = _context4.sent;
                                result = undefined;

                                if (symbol in tickers) result = tickers[symbol];
                                return _context4.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'id': trade['tid'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                // let maxCount = 50;

                                _context5.next = 3;
                                return this.publicGetTrades(this.extend({
                                    'pairSymbol': market['id']
                                }, params));

                            case 3:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var timestamp = this.parse8601(ohlcv['Time']);
            return [timestamp, ohlcv['Open'], ohlcv['High'], ohlcv['Low'], ohlcv['Close'], ohlcv['Volume']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1d';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {};

                                if (typeof limit !== 'undefined') request['last'] = limit;
                                _context6.next = 7;
                                return this.publicGetOhlcdata(this.extend(request, params));

                            case 7:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOHLCV(_x18) {
                return _ref6.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'PairSymbol': this.marketId(symbol),
                                    'OrderType': side === 'buy' ? 0 : 1,
                                    'OrderMethod': type === 'market' ? 1 : 0
                                };

                                if (!(type === 'market')) {
                                    _context7.next = 8;
                                    break;
                                }

                                if ('Total' in params) {
                                    _context7.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' createOrder requires the "Total" extra parameter for market orders (amount and price are both ignored)');

                            case 6:
                                _context7.next = 10;
                                break;

                            case 8:
                                order['Price'] = price;
                                order['Amount'] = amount;

                            case 10:
                                _context7.next = 12;
                                return this.privatePostExchange(this.extend(order, params));

                            case 12:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 14:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x23, _x24, _x25, _x26) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.privatePostCancelOrder({ 'id': id });

                            case 2:
                                return _context8.abrupt('return', _context8.sent);

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x29) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            if (this.id === 'btctrader') throw new ExchangeError(this.id + ' is an abstract base API for BTCExchange, BTCTurk');
            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                body = this.urlencode(params);
                var secret = this.base64ToBinary(this.secret);
                var auth = this.apiKey + nonce;
                headers = {
                    'X-PCK': this.apiKey,
                    'X-Stamp': nonce,
                    'X-Signature': this.stringToBase64(this.hmac(this.encode(auth), secret, 'sha256', 'binary')),
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return btcturk;
}(Exchange);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(fybse, _Exchange);

    function fybse() {
        _classCallCheck(this, fybse);

        return _possibleConstructorReturn(this, (fybse.__proto__ || Object.getPrototypeOf(fybse)).apply(this, arguments));
    }

    _createClass(fybse, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(fybse.prototype.__proto__ || Object.getPrototypeOf(fybse.prototype), 'describe', this).call(this), {
                'id': 'fybse',
                'name': 'FYB-SE',
                'countries': 'SE', // Sweden
                'has': {
                    'CORS': false
                },
                'rateLimit': 1500,
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766512-31019772-5edb-11e7-8241-2e675e6797f1.jpg',
                    'api': 'https://www.fybse.se/api/SEK',
                    'www': 'https://www.fybse.se',
                    'doc': 'http://docs.fyb.apiary.io'
                },
                'api': {
                    'public': {
                        'get': ['ticker', 'tickerdetailed', 'orderbook', 'trades']
                    },
                    'private': {
                        'post': ['test', 'getaccinfo', 'getpendingorders', 'getorderhistory', 'cancelpendingorder', 'placeorder', 'withdraw']
                    }
                },
                'markets': {
                    'BTC/SEK': { 'id': 'SEK', 'symbol': 'BTC/SEK', 'base': 'BTC', 'quote': 'SEK' }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, btc, symbol, quote, lowercase, fiat, crypto, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostGetaccinfo();

                            case 2:
                                balance = _context.sent;
                                btc = parseFloat(balance['btcBal']);
                                symbol = this.symbols[0];
                                quote = this.markets[symbol]['quote'];
                                lowercase = quote.toLowerCase() + 'Bal';
                                fiat = parseFloat(balance[lowercase]);
                                crypto = {
                                    'free': btc,
                                    'used': 0.0,
                                    'total': btc
                                };
                                result = { 'BTC': crypto };

                                result[quote] = {
                                    'free': fiat,
                                    'used': 0.0,
                                    'total': fiat
                                };
                                result['info'] = balance;
                                return _context.abrupt('return', this.parseBalance(result));

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetOrderbook(params);

                            case 2:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, last, volume;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetTickerdetailed(params);

                            case 2:
                                ticker = _context3.sent;
                                timestamp = this.milliseconds();
                                last = undefined;
                                volume = undefined;

                                if ('last' in ticker) last = this.safeFloat(ticker, 'last');
                                if ('vol' in ticker) volume = this.safeFloat(ticker, 'vol');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': volume,
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'info': trade,
                'id': trade['tid'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTrades(params);

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.privatePostPlaceorder(this.extend({
                                    'qty': amount,
                                    'price': price,
                                    'type': side[0].toUpperCase()
                                }, params));

                            case 2:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['pending_oid']
                                });

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancelpendingorder({ 'orderNo': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                url += '.json';
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({ 'timestamp': nonce }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'key': this.apiKey,
                    'sig': this.hmac(this.encode(body), this.encode(this.secret), 'sha1')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!(api === 'private')) {
                                    _context7.next = 7;
                                    break;
                                }

                                if (!('error' in response)) {
                                    _context7.next = 7;
                                    break;
                                }

                                if (!response['error']) {
                                    _context7.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                                return _context7.abrupt('return', response);

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return fybse;
}(Exchange);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound;

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(hitbtc, _Exchange);

    function hitbtc() {
        _classCallCheck(this, hitbtc);

        return _possibleConstructorReturn(this, (hitbtc.__proto__ || Object.getPrototypeOf(hitbtc)).apply(this, arguments));
    }

    _createClass(hitbtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(hitbtc.prototype.__proto__ || Object.getPrototypeOf(hitbtc.prototype), 'describe', this).call(this), {
                'id': 'hitbtc',
                'name': 'HitBTC',
                'countries': 'HK',
                'rateLimit': 1500,
                'version': '1',
                'has': {
                    'CORS': false,
                    'fetchTrades': true,
                    'fetchTickers': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766555-8eaec20e-5edc-11e7-9c5b-6dc69fc42f5e.jpg',
                    'api': 'http://api.hitbtc.com',
                    'www': 'https://hitbtc.com',
                    'doc': 'https://github.com/hitbtc-com/hitbtc-api/blob/master/APIv1.md',
                    'fees': ['https://hitbtc.com/fees-and-limits', 'https://support.hitbtc.com/hc/en-us/articles/115005148605-Fees-and-limits']
                },
                'api': {
                    'public': {
                        'get': ['{symbol}/orderbook', '{symbol}/ticker', '{symbol}/trades', '{symbol}/trades/recent', 'symbols', 'ticker', 'time']
                    },
                    'trading': {
                        'get': ['balance', 'orders/active', 'orders/recent', 'order', 'trades/by/order', 'trades'],
                        'post': ['new_order', 'cancel_order', 'cancel_orders']
                    },
                    'payment': {
                        'get': ['balance', 'address/{currency}', 'transactions', 'transactions/{transaction}'],
                        'post': ['transfer_to_trading', 'transfer_to_main', 'address/{currency}', 'payout']
                    }
                },
                // hardcoded fees are deprecated and should only be used when there's no other way to get fee info
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': -0.01 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'BCC': 0.0018,
                            'ETH': 0.00215,
                            'BCH': 0.0018,
                            'USDT': 100,
                            'DASH': 0.03,
                            'BTG': 0.0005,
                            'LTC': 0.003,
                            'ZEC': 0.0001,
                            'XMR': 0.09,
                            '1ST': 0.84,
                            'ADX': 5.7,
                            'AE': 6.7,
                            'AEON': 0.01006,
                            'AIR': 565,
                            'AMP': 9,
                            'ANT': 6.7,
                            'ARDR': 1,
                            'ARN': 18.5,
                            'ART': 26,
                            'ATB': 0.0004,
                            'ATL': 27,
                            'ATM': 504,
                            'ATS': 860,
                            'AVT': 1.9,
                            'BAS': 113,
                            'BCN': 0.1,
                            'DAO Casino': 124, // id = 'BET'
                            'BKB': 46,
                            'BMC': 32,
                            'BMT': 100,
                            'BNT': 2.57,
                            'BQX': 4.7,
                            'BTM': 40,
                            'BTX': 0.04,
                            'BUS': 0.004,
                            'CCT': 115,
                            'CDT': 100,
                            'CDX': 30,
                            'CFI': 61,
                            'CLD': 0.88,
                            'CND': 574,
                            'CNX': 0.04,
                            'COSS': 65,
                            'CSNO': 16,
                            'CTR': 15,
                            'CTX': 146,
                            'CVC': 8.46,
                            'DBIX': 0.0168,
                            'DCN': 120000,
                            'DCT': 0.02,
                            'DDF': 342,
                            'DENT': 6240,
                            'DGB': 0.4,
                            'DGD': 0.01,
                            'DICE': 0.32,
                            'DLT': 0.26,
                            'DNT': 0.21,
                            'DOGE': 2,
                            'DOV': 34,
                            'DRPU': 24,
                            'DRT': 240,
                            'DSH': 0.017,
                            'EBET': 84,
                            'EBTC': 20,
                            'EBTCOLD': 6.6,
                            'ECAT': 14,
                            'EDG': 2,
                            'EDO': 2.9,
                            'ELE': 0.00172,
                            'ELM': 0.004,
                            'EMC': 0.03,
                            'EMGO': 14,
                            'ENJ': 163,
                            'EOS': 1.5,
                            'ERO': 34,
                            'ETBS': 15,
                            'ETC': 0.002,
                            'ETP': 0.004,
                            'EVX': 5.4,
                            'EXN': 456,
                            'FRD': 65,
                            'FUEL': 123.00105,
                            'FUN': 202.9598309,
                            'FYN': 1.849,
                            'FYP': 66.13,
                            'GNO': 0.0034,
                            'GUP': 4,
                            'GVT': 1.2,
                            'HAC': 144,
                            'HDG': 7,
                            'HGT': 1082,
                            'HPC': 0.4,
                            'HVN': 120,
                            'ICN': 0.55,
                            'ICO': 34,
                            'ICOS': 0.35,
                            'IND': 76,
                            'INDI': 5913,
                            'ITS': 15.0012,
                            'IXT': 11,
                            'KBR': 143,
                            'KICK': 112,
                            'LA': 41,
                            'LAT': 1.44,
                            'LIFE': 13000,
                            'LRC': 27,
                            'LSK': 0.3,
                            'LUN': 0.34,
                            'MAID': 5,
                            'MANA': 143,
                            'MCAP': 5.44,
                            'MIPS': 43,
                            'MNE': 1.33,
                            'MSP': 121,
                            'MTH': 92,
                            'MYB': 3.9,
                            'NDC': 165,
                            'NEBL': 0.04,
                            'NET': 3.96,
                            'NTO': 998,
                            'NXC': 13.39,
                            'NXT': 3,
                            'OAX': 15,
                            'ODN': 0.004,
                            'OMG': 2,
                            'OPT': 335,
                            'ORME': 2.8,
                            'OTN': 0.57,
                            'PAY': 3.1,
                            'PIX': 96,
                            'PLBT': 0.33,
                            'PLR': 114,
                            'PLU': 0.87,
                            'POE': 784,
                            'POLL': 3.5,
                            'PPT': 2,
                            'PRE': 32,
                            'PRG': 39,
                            'PRO': 41,
                            'PRS': 60,
                            'PTOY': 0.5,
                            'QAU': 63,
                            'QCN': 0.03,
                            'QTUM': 0.04,
                            'QVT': 64,
                            'REP': 0.02,
                            'RKC': 15,
                            'RVT': 14,
                            'SAN': 2.24,
                            'SBD': 0.03,
                            'SCL': 2.6,
                            'SISA': 1640,
                            'SKIN': 407,
                            'SMART': 0.4,
                            'SMS': 0.0375,
                            'SNC': 36,
                            'SNGLS': 4,
                            'SNM': 48,
                            'SNT': 233,
                            'STEEM': 0.01,
                            'STRAT': 0.01,
                            'STU': 14,
                            'STX': 11,
                            'SUB': 17,
                            'SUR': 3,
                            'SWT': 0.51,
                            'TAAS': 0.91,
                            'TBT': 2.37,
                            'TFL': 15,
                            'TIME': 0.03,
                            'TIX': 7.1,
                            'TKN': 1,
                            'TKR': 84,
                            'TNT': 90,
                            'TRST': 1.6,
                            'TRX': 1395,
                            'UET': 480,
                            'UGT': 15,
                            'VEN': 14,
                            'VERI': 0.037,
                            'VIB': 50,
                            'VIBE': 145,
                            'VOISE': 618,
                            'WEALTH': 0.0168,
                            'WINGS': 2.4,
                            'WTC': 0.75,
                            'XAUR': 3.23,
                            'XDN': 0.01,
                            'XEM': 15,
                            'XUC': 0.9,
                            'YOYOW': 140,
                            'ZAP': 24,
                            'ZRX': 23,
                            'ZSC': 191
                        },
                        'deposit': {
                            'BTC': 0.0006,
                            'ETH': 0.003,
                            'BCH': 0,
                            'USDT': 0,
                            'BTG': 0,
                            'LTC': 0,
                            'ZEC': 0,
                            'XMR': 0,
                            '1ST': 0,
                            'ADX': 0,
                            'AE': 0,
                            'AEON': 0,
                            'AIR': 0,
                            'AMP': 0,
                            'ANT': 0,
                            'ARDR': 0,
                            'ARN': 0,
                            'ART': 0,
                            'ATB': 0,
                            'ATL': 0,
                            'ATM': 0,
                            'ATS': 0,
                            'AVT': 0,
                            'BAS': 0,
                            'BCN': 0,
                            'DAO Casino': 0, // id = 'BET'
                            'BKB': 0,
                            'BMC': 0,
                            'BMT': 0,
                            'BNT': 0,
                            'BQX': 0,
                            'BTM': 0,
                            'BTX': 0,
                            'BUS': 0,
                            'CCT': 0,
                            'CDT': 0,
                            'CDX': 0,
                            'CFI': 0,
                            'CLD': 0,
                            'CND': 0,
                            'CNX': 0,
                            'COSS': 0,
                            'CSNO': 0,
                            'CTR': 0,
                            'CTX': 0,
                            'CVC': 0,
                            'DBIX': 0,
                            'DCN': 0,
                            'DCT': 0,
                            'DDF': 0,
                            'DENT': 0,
                            'DGB': 0,
                            'DGD': 0,
                            'DICE': 0,
                            'DLT': 0,
                            'DNT': 0,
                            'DOGE': 0,
                            'DOV': 0,
                            'DRPU': 0,
                            'DRT': 0,
                            'DSH': 0,
                            'EBET': 0,
                            'EBTC': 0,
                            'EBTCOLD': 0,
                            'ECAT': 0,
                            'EDG': 0,
                            'EDO': 0,
                            'ELE': 0,
                            'ELM': 0,
                            'EMC': 0,
                            'EMGO': 0,
                            'ENJ': 0,
                            'EOS': 0,
                            'ERO': 0,
                            'ETBS': 0,
                            'ETC': 0,
                            'ETP': 0,
                            'EVX': 0,
                            'EXN': 0,
                            'FRD': 0,
                            'FUEL': 0,
                            'FUN': 0,
                            'FYN': 0,
                            'FYP': 0,
                            'GNO': 0,
                            'GUP': 0,
                            'GVT': 0,
                            'HAC': 0,
                            'HDG': 0,
                            'HGT': 0,
                            'HPC': 0,
                            'HVN': 0,
                            'ICN': 0,
                            'ICO': 0,
                            'ICOS': 0,
                            'IND': 0,
                            'INDI': 0,
                            'ITS': 0,
                            'IXT': 0,
                            'KBR': 0,
                            'KICK': 0,
                            'LA': 0,
                            'LAT': 0,
                            'LIFE': 0,
                            'LRC': 0,
                            'LSK': 0,
                            'LUN': 0,
                            'MAID': 0,
                            'MANA': 0,
                            'MCAP': 0,
                            'MIPS': 0,
                            'MNE': 0,
                            'MSP': 0,
                            'MTH': 0,
                            'MYB': 0,
                            'NDC': 0,
                            'NEBL': 0,
                            'NET': 0,
                            'NTO': 0,
                            'NXC': 0,
                            'NXT': 0,
                            'OAX': 0,
                            'ODN': 0,
                            'OMG': 0,
                            'OPT': 0,
                            'ORME': 0,
                            'OTN': 0,
                            'PAY': 0,
                            'PIX': 0,
                            'PLBT': 0,
                            'PLR': 0,
                            'PLU': 0,
                            'POE': 0,
                            'POLL': 0,
                            'PPT': 0,
                            'PRE': 0,
                            'PRG': 0,
                            'PRO': 0,
                            'PRS': 0,
                            'PTOY': 0,
                            'QAU': 0,
                            'QCN': 0,
                            'QTUM': 0,
                            'QVT': 0,
                            'REP': 0,
                            'RKC': 0,
                            'RVT': 0,
                            'SAN': 0,
                            'SBD': 0,
                            'SCL': 0,
                            'SISA': 0,
                            'SKIN': 0,
                            'SMART': 0,
                            'SMS': 0,
                            'SNC': 0,
                            'SNGLS': 0,
                            'SNM': 0,
                            'SNT': 0,
                            'STEEM': 0,
                            'STRAT': 0,
                            'STU': 0,
                            'STX': 0,
                            'SUB': 0,
                            'SUR': 0,
                            'SWT': 0,
                            'TAAS': 0,
                            'TBT': 0,
                            'TFL': 0,
                            'TIME': 0,
                            'TIX': 0,
                            'TKN': 0,
                            'TKR': 0,
                            'TNT': 0,
                            'TRST': 0,
                            'TRX': 0,
                            'UET': 0,
                            'UGT': 0,
                            'VEN': 0,
                            'VERI': 0,
                            'VIB': 0,
                            'VIBE': 0,
                            'VOISE': 0,
                            'WEALTH': 0,
                            'WINGS': 0,
                            'WTC': 0,
                            'XAUR': 0,
                            'XDN': 0,
                            'XEM': 0,
                            'XUC': 0,
                            'YOYOW': 0,
                            'ZAP': 0,
                            'ZRX': 0,
                            'ZSC': 0
                        }
                    }
                },
                'commonCurrencies': {
                    'BCC': 'BCC',
                    'BET': 'DAO Casino',
                    'XBT': 'BTC',
                    'DRK': 'DASH',
                    'CAT': 'BitClave',
                    'USD': 'USDT',
                    'EMGO': 'MGO'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, baseId, quoteId, lot, _step, base, quote, symbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetSymbols();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets['symbols'].length; p++) {
                                    market = markets['symbols'][p];
                                    id = market['symbol'];
                                    baseId = market['commodity'];
                                    quoteId = market['currency'];
                                    lot = this.safeFloat(market, 'lot');
                                    _step = this.safeFloat(market, 'step');
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'info': market,
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'lot': lot,
                                        'step': _step,
                                        'active': true,
                                        'maker': this.safeFloat(market, 'provideLiquidityRate'),
                                        'taker': this.safeFloat(market, 'takeLiquidityRate'),
                                        'precision': {
                                            'amount': this.precisionFromString(market['lot']),
                                            'price': this.precisionFromString(market['step'])
                                        },
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': _step,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var method, query, response, balances, result, b, balance, code, currency, free, used, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = this.safeString(params, 'type', 'trading');

                                method += 'GetBalance';
                                query = this.omit(params, 'type');
                                _context2.next = 7;
                                return this[method](query);

                            case 7:
                                response = _context2.sent;
                                balances = response['balance'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    code = balance['currency_code'];
                                    currency = this.commonCurrencyCode(code);
                                    free = this.safeFloat(balance, 'cash', 0.0);

                                    free = this.safeFloat(balance, 'balance', free);
                                    used = this.safeFloat(balance, 'reserved', 0.0);
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': this.sum(free, used)
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetSymbolOrderbook(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['timestamp'];
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': this.safeFloat(ticker, 'volume_quote'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context4.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetSymbolTicker(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;

                                if (!('message' in ticker)) {
                                    _context5.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + ticker['message']);

                            case 8:
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (Array.isArray(trade)) return this.parsePublicTrade(trade, market);
            return this.parseOrderTrade(trade, market);
        }
    }, {
        key: 'parsePublicTrade',
        value: function parsePublicTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'info': trade,
                'id': trade[0].toString(),
                'timestamp': trade[3],
                'datetime': this.iso8601(trade[3]),
                'symbol': symbol,
                'type': undefined,
                'side': trade[4],
                'price': parseFloat(trade[1]),
                'amount': parseFloat(trade[2])
            };
        }
    }, {
        key: 'parseOrderTrade',
        value: function parseOrderTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var amount = this.safeFloat(trade, 'execQuantity');
            if (market) amount *= market['lot'];
            var price = this.safeFloat(trade, 'execPrice');
            var cost = price * amount;
            var fee = {
                'cost': this.safeFloat(trade, 'fee'),
                'currency': undefined,
                'rate': undefined
            };
            var timestamp = trade['timestamp'];
            return {
                'info': trade,
                'id': trade['tradeId'],
                'order': trade['clientOrderId'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': undefined,
                'side': trade['side'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetSymbolTrades(this.extend({
                                    'symbol': market['id'],
                                    // 'from': 0,
                                    // 'till': 100,
                                    // 'by': 'ts', // or by trade_id
                                    // 'sort': 'desc', // or asc
                                    // 'start_index': 0,
                                    // 'max_results': 1000,
                                    // 'format_item': 'object',
                                    // 'format_price': 'number',
                                    // 'format_amount': 'number',
                                    // 'format_tid': 'string',
                                    // 'format_timestamp': 'millisecond',
                                    // 'format_wrap': false,
                                    'side': 'true'
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x13) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, quantity, wholeLots, difference, clientOrderId, order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                // check if amount can be evenly divided into lots
                                // they want integer quantity in lot units

                                quantity = parseFloat(amount) / market['lot'];
                                wholeLots = Math.round(quantity);
                                difference = quantity - wholeLots;

                                if (!(Math.abs(difference) > market['step'])) {
                                    _context7.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' order amount should be evenly divisible by lot unit size of ' + market['lot'].toString());

                            case 8:
                                clientOrderId = this.milliseconds();
                                order = {
                                    'clientOrderId': clientOrderId.toString(),
                                    'symbol': market['id'],
                                    'side': side,
                                    'quantity': wholeLots.toString(), // quantity in integer lot units
                                    'type': type
                                };

                                if (type === 'limit') {
                                    order['price'] = this.priceToPrecision(symbol, price);
                                } else {
                                    order['timeInForce'] = 'FOK';
                                }
                                _context7.next = 13;
                                return this.tradingPostNewOrder(this.extend(order, params));

                            case 13:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOrder(response['ExecutionReport'], market));

                            case 15:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x17, _x18, _x19, _x20) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.tradingPostCancelOrder(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x23) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'new': 'open',
                'partiallyFilled': 'open',
                'filled': 'closed',
                'canceled': 'canceled',
                'rejected': 'rejected',
                'expired': 'expired'
            };
            return this.safeString(statuses, status);
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeInteger(order, 'lastTimestamp');
            if (typeof timestamp === 'undefined') timestamp = this.safeInteger(order, 'timestamp');
            var symbol = undefined;
            if (!market) market = this.markets_by_id[order['symbol']];
            var status = this.safeString(order, 'orderStatus');
            if (status) status = this.parseOrderStatus(status);
            var averagePrice = this.safeFloat(order, 'avgPrice', 0.0);
            var price = this.safeFloat(order, 'orderPrice');
            if (typeof price === 'undefined') price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'orderQuantity');
            if (typeof amount === 'undefined') amount = this.safeFloat(order, 'quantity');
            var remaining = this.safeFloat(order, 'quantityLeaves');
            if (typeof remaining === 'undefined') remaining = this.safeFloat(order, 'leavesQuantity');
            var filled = undefined;
            var cost = undefined;
            var amountDefined = typeof amount !== 'undefined';
            var remainingDefined = typeof remaining !== 'undefined';
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                if (amountDefined) amount *= market['lot'];
                if (remainingDefined) remaining *= market['lot'];
            } else {
                var marketId = this.safeString(order, 'symbol');
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            if (amountDefined) {
                if (remainingDefined) {
                    filled = amount - remaining;
                    cost = averagePrice * filled;
                }
            }
            var feeCost = this.safeFloat(order, 'fee');
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                feeCurrency = market['quote'];
            }
            var fee = {
                'cost': feeCost,
                'currency': feeCurrency,
                'rate': undefined
            };
            return {
                'id': order['clientOrderId'].toString(),
                'info': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['type'],
                'side': order['side'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': fee
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.tradingGetOrder(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 4:
                                response = _context9.sent;

                                if (!response['orders'][0]) {
                                    _context9.next = 7;
                                    break;
                                }

                                return _context9.abrupt('return', this.parseOrder(response['orders'][0]));

                            case 7:
                                throw new OrderNotFound(this.id + ' fetchOrder() error: ' + this.response);

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var statuses, market, request, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                statuses = ['new', 'partiallyFiiled'];
                                market = undefined;
                                request = {
                                    'sort': 'desc',
                                    'statuses': statuses.join(',')
                                };

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['symbols'] = market['id'];
                                }
                                _context10.next = 8;
                                return this.tradingGetOrdersActive(this.extend(request, params));

                            case 8:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(response['orders'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, statuses, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                statuses = ['filled', 'canceled', 'rejected', 'expired'];
                                request = {
                                    'sort': 'desc',
                                    'statuses': statuses.join(','),
                                    'max_results': 1000
                                };

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['symbols'] = market['id'];
                                }
                                _context11.next = 8;
                                return this.tradingGetOrdersRecent(this.extend(request, params));

                            case 8:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response['orders'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchClosedOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrderTrades',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                _context12.next = 6;
                                return this.tradingGetTradesByOrder(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 6:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 8:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrderTrades(_x38) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrderTrades;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.checkAddress(address);
                                _context13.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                request = {
                                    'currency_code': currency['id'],
                                    'amount': amount,
                                    'address': address
                                };

                                if (tag) request['paymentId'] = tag;
                                _context13.next = 8;
                                return this.paymentPostPayout(this.extend(request, params));

                            case 8:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': response['transaction']
                                });

                            case 10:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function withdraw(_x43, _x44, _x45) {
                return _ref13.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/' + 'api' + '/' + this.version + '/' + api + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var payload = { 'nonce': nonce, 'apikey': this.apiKey };
                query = this.extend(payload, query);
                if (method === 'GET') url += '?' + this.urlencode(query);else url += '?' + this.urlencode(payload);
                var auth = url;
                if (method === 'POST') {
                    if (Object.keys(query).length) {
                        body = this.urlencode(query);
                        auth += body;
                    }
                }
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Signature': this.hmac(this.encode(auth), this.encode(this.secret), 'sha512').toLowerCase()
                };
            }
            url = this.urls['api'] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context14.sent;

                                if (!('code' in response)) {
                                    _context14.next = 8;
                                    break;
                                }

                                if (!('ExecutionReport' in response)) {
                                    _context14.next = 7;
                                    break;
                                }

                                if (!(response['ExecutionReport']['orderRejectReason'] === 'orderExceedsLimit')) {
                                    _context14.next = 7;
                                    break;
                                }

                                throw new InsufficientFunds(this.id + ' ' + this.json(response));

                            case 7:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                                return _context14.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function request(_x53) {
                return _ref14.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return hitbtc;
}(Exchange);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    InvalidNonce = _require.InvalidNonce,
    OrderNotFound = _require.OrderNotFound,
    InvalidOrder = _require.InvalidOrder,
    InsufficientFunds = _require.InsufficientFunds,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(qryptos, _Exchange);

    function qryptos() {
        _classCallCheck(this, qryptos);

        return _possibleConstructorReturn(this, (qryptos.__proto__ || Object.getPrototypeOf(qryptos)).apply(this, arguments));
    }

    _createClass(qryptos, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(qryptos.prototype.__proto__ || Object.getPrototypeOf(qryptos.prototype), 'describe', this).call(this), {
                'id': 'qryptos',
                'name': 'QRYPTOS',
                'countries': ['CN', 'TW'],
                'version': '2',
                'rateLimit': 1000,
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30953915-b1611dc0-a436-11e7-8947-c95bd5a42086.jpg',
                    'api': 'https://api.qryptos.com',
                    'www': 'https://www.qryptos.com',
                    'doc': ['https://developers.quoine.com', 'https://developers.quoine.com/v2'],
                    'fees': 'https://qryptos.zendesk.com/hc/en-us/articles/115007858167-Fees'
                },
                'api': {
                    'public': {
                        'get': ['products', 'products/{id}', 'products/{id}/price_levels', 'executions', 'ir_ladders/{currency}']
                    },
                    'private': {
                        'get': ['accounts/balance', 'accounts/main_asset', 'crypto_accounts', 'executions/me', 'fiat_accounts', 'loan_bids', 'loans', 'orders', 'orders/{id}', 'orders/{id}/trades', 'orders/{id}/executions', 'trades', 'trades/{id}/loans', 'trading_accounts', 'trading_accounts/{id}'],
                        'post': ['fiat_accounts', 'loan_bids', 'orders'],
                        'put': ['loan_bids/{id}/close', 'loans/{id}', 'orders/{id}', 'orders/{id}/cancel', 'trades/{id}', 'trades/{id}/close', 'trades/close_all', 'trading_accounts/{id}']
                    }
                },
                'skipJsonOnStatusCodes': [401],
                'exceptions': {
                    'messages': {
                        'API Authentication failed': AuthenticationError,
                        'Nonce is too small': InvalidNonce,
                        'Order not found': OrderNotFound,
                        'user': {
                            'not_enough_free_balance': InsufficientFunds
                        },
                        'price': {
                            'must_be_positive': InvalidOrder
                        },
                        'quantity': {
                            'less_than_order_size': InvalidOrder
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol, maker, taker, active, minAmount, minPrice, limits, precision;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetProducts();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['id'].toString();
                                    base = market['base_currency'];
                                    quote = market['quoted_currency'];
                                    symbol = base + '/' + quote;
                                    maker = this.safeFloat(market, 'maker_fee');
                                    taker = this.safeFloat(market, 'taker_fee');
                                    active = !market['disabled'];
                                    minAmount = undefined;
                                    minPrice = undefined;

                                    if (base === 'BTC') {
                                        minAmount = 0.001;
                                    } else if (base === 'ETH') {
                                        minAmount = 0.01;
                                    }
                                    if (quote === 'BTC') {
                                        minPrice = 0.00000001;
                                    } else if (quote === 'ETH' || quote === 'USD' || quote === 'JPY') {
                                        minPrice = 0.00001;
                                    }
                                    limits = {
                                        'amount': { 'min': minAmount },
                                        'price': { 'min': minPrice },
                                        'cost': { 'min': undefined }
                                    };

                                    if (typeof minPrice !== 'undefined') if (typeof minAmount !== 'undefined') limits['cost']['min'] = minPrice * minAmount;
                                    precision = {
                                        'amount': undefined,
                                        'price': undefined
                                    };

                                    if (typeof minAmount !== 'undefined') precision['amount'] = -Math.log10(minAmount);
                                    if (typeof minPrice !== 'undefined') precision['price'] = -Math.log10(minPrice);
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'maker': maker,
                                        'taker': taker,
                                        'limits': limits,
                                        'precision': precision,
                                        'active': active,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, total, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetAccountsBalance(params);

                            case 4:
                                balances = _context2.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    total = parseFloat(balance['balance']);
                                    account = {
                                        'free': total,
                                        'used': 0.0,
                                        'total': total
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetProductsIdPriceLevels(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy_price_levels', 'sell_price_levels'));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var last = undefined;
            if ('last_traded_price' in ticker) {
                if (ticker['last_traded_price']) {
                    var length = ticker['last_traded_price'].length;
                    if (length > 0) last = this.safeFloat(ticker, 'last_traded_price');
                }
            }
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high_market_ask'),
                'low': this.safeFloat(ticker, 'low_market_bid'),
                'bid': this.safeFloat(ticker, 'market_bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'market_ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume_24h'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, t, ticker, base, quote, symbol, market;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetProducts(params);

                            case 4:
                                tickers = _context4.sent;
                                result = {};

                                for (t = 0; t < tickers.length; t++) {
                                    ticker = tickers[t];
                                    base = ticker['base_currency'];
                                    quote = ticker['quoted_currency'];
                                    symbol = base + '/' + quote;
                                    market = this.markets[symbol];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetProductsId(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            // {             id:  12345,
            //         quantity: "6.789",
            //            price: "98765.4321",
            //       taker_side: "sell",
            //       created_at:  1512345678,
            //          my_side: "buy"           }
            var timestamp = trade['created_at'] * 1000;
            // 'taker_side' gets filled for both fetchTrades and fetchMyTrades
            var takerSide = this.safeString(trade, 'taker_side');
            // 'my_side' gets filled for fetchMyTrades only and may differ from 'taker_side'
            var mySide = this.safeString(trade, 'my_side');
            var side = typeof mySide !== 'undefined' ? mySide : takerSide;
            var takerOrMaker = undefined;
            if (typeof mySide !== 'undefined') takerOrMaker = takerSide === mySide ? 'taker' : 'maker';
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'takerOrMaker': takerOrMaker,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'quantity')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'product_id': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context6.next = 7;
                                return this.publicGetExecutions(this.extend(request, params));

                            case 7:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['models'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'product_id': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context7.next = 7;
                                return this.privateGetExecutionsMe(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['models'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchMyTrades() {
                return _ref7.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'order_type': type,
                                    'product_id': this.marketId(symbol),
                                    'side': side,
                                    'quantity': amount
                                };

                                if (type === 'limit') order['price'] = price;
                                _context8.next = 6;
                                return this.privatePostOrders(this.extend(order, params));

                            case 6:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrder(response));

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x18, _x19, _x20, _x21) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var result, order;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePutOrdersIdCancel(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                result = _context9.sent;
                                order = this.parseOrder(result);

                                if (!(order['status'] === 'closed')) {
                                    _context9.next = 8;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' ' + this.json(order));

                            case 8:
                                return _context9.abrupt('return', order);

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x24) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = order['created_at'] * 1000;
            var marketId = this.safeString(order, 'product_id');
            if (typeof marketId !== 'undefined') {
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            var status = undefined;
            if ('status' in order) {
                if (order['status'] === 'live') {
                    status = 'open';
                } else if (order['status'] === 'filled') {
                    status = 'closed';
                } else if (order['status'] === 'cancelled') {
                    // 'll' intended
                    status = 'canceled';
                }
            }
            var amount = this.safeFloat(order, 'quantity');
            var filled = this.safeFloat(order, 'filled_quantity');
            var price = this.safeFloat(order, 'price');
            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            }
            return {
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'type': order['order_type'],
                'status': status,
                'symbol': symbol,
                'side': order['side'],
                'price': price,
                'amount': amount,
                'filled': filled,
                'remaining': amount - filled,
                'trades': undefined,
                'fee': {
                    'currency': undefined,
                    'cost': this.safeFloat(order, 'order_fee')
                },
                'info': order
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var order;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privateGetOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                order = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(order));

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrder(_x28) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, status, result, orders;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['product_id'] = market['id'];
                                }
                                status = this.safeValue(params, 'status');

                                if (status) {
                                    params = this.omit(params, 'status');
                                    if (status === 'open') {
                                        request['status'] = 'live';
                                    } else if (status === 'closed') {
                                        request['status'] = 'filled';
                                    } else if (status === 'canceled') {
                                        request['status'] = 'cancelled';
                                    }
                                }
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context11.next = 10;
                                return this.privateGetOrders(this.extend(request, params));

                            case 10:
                                result = _context11.sent;
                                orders = result['models'];
                                return _context11.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 13:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function fetchOpenOrders() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return this.fetchOrders(symbol, since, limit, this.extend({ 'status': 'open' }, params));
        }
    }, {
        key: 'fetchClosedOrders',
        value: function fetchClosedOrders() {
            var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return this.fetchOrders(symbol, since, limit, this.extend({ 'status': 'closed' }, params));
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            headers = {
                'X-Quoine-API-Version': this.version,
                'Content-Type': 'application/json'
            };
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                if (method === 'GET') {
                    if (Object.keys(query).length) url += '?' + this.urlencode(query);
                } else if (Object.keys(query).length) {
                    body = this.json(query);
                }
                var nonce = this.nonce();
                var request = {
                    'path': url,
                    'nonce': nonce,
                    'token_id': this.apiKey,
                    'iat': Math.floor(nonce / 1000) // issued at
                };
                headers['X-Quoine-Auth'] = this.jwt(request, this.secret);
            }
            url = this.urls['api'] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            var response = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

            if (code >= 200 && code <= 299) return;
            var messages = this.exceptions['messages'];
            if (code === 401) {
                // expected non-json response
                if (body in messages) throw new messages[body](this.id + ' ' + body);else return;
            }
            if (typeof response === 'undefined') if (body[0] === '{' || body[0] === '[') response = JSON.parse(body);else return;
            var feedback = this.id + ' ' + this.json(response);
            if (code === 404) {
                // { "message": "Order not found" }
                var message = this.safeString(response, 'message');
                if (message in messages) throw new messages[message](feedback);
            } else if (code === 422) {
                // array of error messages is returned in 'user' or 'quantity' property of 'errors' object, e.g.:
                // { "errors": { "user": ["not_enough_free_balance"] }}
                // { "errors": { "quantity": ["less_than_order_size"] }}
                if ('errors' in response) {
                    var errors = response['errors'];
                    var errorTypes = ['user', 'quantity', 'price'];
                    for (var i = 0; i < errorTypes.length; i++) {
                        var errorType = errorTypes[i];
                        if (errorType in errors) {
                            var errorMessages = errors[errorType];
                            for (var j = 0; j < errorMessages.length; j++) {
                                var _message = errorMessages[j];
                                if (_message in messages[errorType]) throw new messages[errorType][_message](feedback);
                            }
                        }
                    }
                }
            }
        }
    }]);

    return qryptos;
}(Exchange);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*

MIT License

Copyright (c) 2017 Igor Kroitor

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/

"use strict";

//-----------------------------------------------------------------------------

var Exchange = __webpack_require__(1),
    functions = __webpack_require__(22),
    errors = __webpack_require__(0);

//-----------------------------------------------------------------------------
// this is updated by vss.js when building

var version = '1.14.10';

Exchange.ccxtVersion = version;

//-----------------------------------------------------------------------------

var exchanges = {
    '_1broker': __webpack_require__(71),
    '_1btcxe': __webpack_require__(30),
    'acx': __webpack_require__(17),
    'allcoin': __webpack_require__(72),
    'anxpro': __webpack_require__(73),
    'bibox': __webpack_require__(74),
    'binance': __webpack_require__(75),
    'bit2c': __webpack_require__(76),
    'bitbank': __webpack_require__(77),
    'bitbay': __webpack_require__(78),
    'bitfinex': __webpack_require__(18),
    'bitfinex2': __webpack_require__(79),
    'bitflyer': __webpack_require__(80),
    'bithumb': __webpack_require__(81),
    'bitkk': __webpack_require__(82),
    'bitlish': __webpack_require__(83),
    'bitmarket': __webpack_require__(84),
    'bitmex': __webpack_require__(85),
    'bitso': __webpack_require__(86),
    'bitstamp': __webpack_require__(87),
    'bitstamp1': __webpack_require__(88),
    'bittrex': __webpack_require__(31),
    'bitz': __webpack_require__(89),
    'bl3p': __webpack_require__(90),
    'bleutrade': __webpack_require__(91),
    'braziliex': __webpack_require__(92),
    'btcbox': __webpack_require__(32),
    'btcchina': __webpack_require__(93),
    'btcexchange': __webpack_require__(94),
    'btcmarkets': __webpack_require__(95),
    'btctradeim': __webpack_require__(96),
    'btctradeua': __webpack_require__(97),
    'btcturk': __webpack_require__(33),
    'btcx': __webpack_require__(98),
    'bxinth': __webpack_require__(99),
    'ccex': __webpack_require__(100),
    'cex': __webpack_require__(101),
    'chbtc': __webpack_require__(102),
    'chilebit': __webpack_require__(103),
    'cobinhood': __webpack_require__(104),
    'coincheck': __webpack_require__(105),
    'coinegg': __webpack_require__(20),
    'coinex': __webpack_require__(106),
    'coinexchange': __webpack_require__(107),
    'coinfloor': __webpack_require__(108),
    'coingi': __webpack_require__(109),
    'coinmarketcap': __webpack_require__(110),
    'coinmate': __webpack_require__(111),
    'coinnest': __webpack_require__(112),
    'coinone': __webpack_require__(113),
    'coinsecure': __webpack_require__(114),
    'coinspot': __webpack_require__(115),
    'cointiger': __webpack_require__(116),
    'coolcoin': __webpack_require__(117),
    'cryptopia': __webpack_require__(118),
    'dsx': __webpack_require__(119),
    'ethfinex': __webpack_require__(120),
    'exmo': __webpack_require__(121),
    'exx': __webpack_require__(122),
    'flowbtc': __webpack_require__(123),
    'foxbit': __webpack_require__(7),
    'fybse': __webpack_require__(34),
    'fybsg': __webpack_require__(124),
    'gatecoin': __webpack_require__(125),
    'gateio': __webpack_require__(126),
    'gdax': __webpack_require__(127),
    'gemini': __webpack_require__(128),
    'getbtc': __webpack_require__(129),
    'hadax': __webpack_require__(130),
    'hitbtc': __webpack_require__(35),
    'hitbtc2': __webpack_require__(131),
    'huobi': __webpack_require__(132),
    'huobicny': __webpack_require__(133),
    'huobipro': __webpack_require__(11),
    'ice3x': __webpack_require__(134),
    'independentreserve': __webpack_require__(135),
    'indodax': __webpack_require__(136),
    'itbit': __webpack_require__(137),
    'jubi': __webpack_require__(138),
    'kraken': __webpack_require__(139),
    'kucoin': __webpack_require__(140),
    'kuna': __webpack_require__(141),
    'lakebtc': __webpack_require__(142),
    'lbank': __webpack_require__(143),
    'liqui': __webpack_require__(8),
    'livecoin': __webpack_require__(144),
    'luno': __webpack_require__(145),
    'lykke': __webpack_require__(146),
    'mercado': __webpack_require__(147),
    'mixcoins': __webpack_require__(148),
    'negociecoins': __webpack_require__(149),
    'nova': __webpack_require__(150),
    'okcoincny': __webpack_require__(151),
    'okcoinusd': __webpack_require__(10),
    'okex': __webpack_require__(152),
    'paymium': __webpack_require__(153),
    'poloniex': __webpack_require__(154),
    'qryptos': __webpack_require__(36),
    'quadrigacx': __webpack_require__(155),
    'quoinex': __webpack_require__(156),
    'southxchange': __webpack_require__(157),
    'surbitcoin': __webpack_require__(158),
    'therock': __webpack_require__(159),
    'tidebit': __webpack_require__(160),
    'tidex': __webpack_require__(161),
    'urdubit': __webpack_require__(162),
    'vaultoro': __webpack_require__(163),
    'vbtc': __webpack_require__(164),
    'virwox': __webpack_require__(165),
    'wex': __webpack_require__(166),
    'xbtce': __webpack_require__(167),
    'yobit': __webpack_require__(168),
    'yunbi': __webpack_require__(169),
    'zaif': __webpack_require__(170),
    'zb': __webpack_require__(19)

    //-----------------------------------------------------------------------------

};module.exports = Object.assign({ version: version, Exchange: Exchange, exchanges: Object.keys(exchanges) }, exchanges, functions, errors);

//-----------------------------------------------------------------------------

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/*  ------------------------------------------------------------------------ */

module.exports = {

    isNode: typeof window === 'undefined' && !(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope),

    isWindows: typeof process !== 'undefined' ? process.platform === "win32" : false

    /*  ------------------------------------------------------------------------ */

};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var _require = __webpack_require__(13),
    isObject = _require.isObject,
    isNumber = _require.isNumber,
    isDictionary = _require.isDictionary,
    isArray = _require.isArray;

/*  ------------------------------------------------------------------------ */

var keys = Object.keys,
    values = function values(x) {
    return !isArray(x) // don't copy arrays if they're already arrays!
    ? Object.values(x) : x;
},
    index = function index(x) {
    return new Set(values(x));
},
    extend = function extend() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    return Object.assign.apply(Object, [{}].concat(args));
} // NB: side-effect free

,
    clone = function clone(x) {
    return isArray(x) ? Array.from(x) // clones arrays
    : extend(x);
}; // clones objects

/*  ------------------------------------------------------------------------ */

module.exports = { keys: keys,
    values: values,
    extend: extend,
    clone: clone,
    index: index,
    ordered: function ordered(x) {
        return x;
    } // a stub to keep assoc keys in order (in JS it does nothing, it's mostly for Python)
    , unique: function unique(x) {
        return Array.from(index(x));
    }

    /*  .............................................   */

    , inArray: function inArray(needle, haystack) {

        return haystack.includes(needle);
    },
    toArray: function toArray(object) {

        return Object.values(object);
    }

    /*  .............................................   */

    ,
    keysort: function keysort(x) {
        var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {

            for (var _iterator = keys(x).sort()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var k = _step.value;

                out[k] = x[k];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    /*
       Accepts a map/array of objects and a key name to be used as an index:
       array = [
          { someKey: 'value1', anotherKey: 'anotherValue1' },
          { someKey: 'value2', anotherKey: 'anotherValue2' },
          { someKey: 'value3', anotherKey: 'anotherValue3' },
       ]
       key = 'someKey'
        Returns a map:
      {
          value1: { someKey: 'value1', anotherKey: 'anotherValue1' },
          value2: { someKey: 'value2', anotherKey: 'anotherValue2' },
          value3: { someKey: 'value3', anotherKey: 'anotherValue3' },
      }
    */

    ,
    indexBy: function indexBy(x, k) {
        var out = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {

            for (var _iterator2 = values(x)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var v = _step2.value;

                if (k in v) out[v[k]] = v;
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    /*
       Accepts a map/array of objects and a key name to be used as a grouping parameter:
       array = [
          { someKey: 'value1', anotherKey: 'anotherValue1' },
          { someKey: 'value1', anotherKey: 'anotherValue2' },
          { someKey: 'value3', anotherKey: 'anotherValue3' },
       ]
       key = 'someKey'
        Returns a map:
      {
          value1: [
            { someKey: 'value1', anotherKey: 'anotherValue1' },
            { someKey: 'value1', anotherKey: 'anotherValue2' },
          ]
          value3: [
            { someKey: 'value3', anotherKey: 'anotherValue3' }
          ],
      }
    */

    ,
    groupBy: function groupBy(x, k) {
        var out = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {

            for (var _iterator3 = values(x)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var v = _step3.value;

                if (k in v) {
                    var p = v[k];
                    out[p] = out[p] || [];
                    out[p].push(v);
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    /*
       Accepts a map/array of objects, a key name and a key value to be used as a filter:
       array = [
          { someKey: 'value1', anotherKey: 'anotherValue1' },
          { someKey: 'value2', anotherKey: 'anotherValue2' },
          { someKey: 'value3', anotherKey: 'anotherValue3' },
       ]
       key = 'someKey'
       value = 'value1'
        Returns an array:
      [
          value1: { someKey: 'value1', anotherKey: 'anotherValue1' },
      ]
    */

    ,
    filterBy: function filterBy(x, k) {
        var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        var out = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {

            for (var _iterator4 = values(x)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var v = _step4.value;

                if (v[k] === value) out.push(v);
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    ,
    sortBy: function sortBy(array, // NB: MUTATES ARRAY!
    key) {
        var descending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var direction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : descending ? -1 : 1;
        return array.sort(function (a, b) {
            return a[key] < b[key] ? -direction : a[key] > b[key] ? direction : 0;
        });
    }

    /*  .............................................   */

    , flatten: function flatten(x) {
        var out = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {

            for (var _iterator5 = x[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var v = _step5.value;

                if (isArray(v)) flatten(v, out);else out.push(v);
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    , pluck: function pluck(x, k) {
        return values(x).filter(function (v) {
            return k in v;
        }).map(function (v) {
            return v[k];
        });
    }

    /*  .............................................   */

    , omit: function omit(x) {

        var out = clone(x);

        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
        }

        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = args[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var k = _step6.value;


                if (isArray(k)) {
                    // omit (x, ['a', 'b'])
                    var _iteratorNormalCompletion7 = true;
                    var _didIteratorError7 = false;
                    var _iteratorError7 = undefined;

                    try {
                        for (var _iterator7 = k[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                            var _kk = _step7.value;

                            delete out[_kk];
                        }
                    } catch (err) {
                        _didIteratorError7 = true;
                        _iteratorError7 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion7 && _iterator7.return) {
                                _iterator7.return();
                            }
                        } finally {
                            if (_didIteratorError7) {
                                throw _iteratorError7;
                            }
                        }
                    }
                } else delete out[k]; // omit (x, 'a', 'b')
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        return out;
    }

    /*  .............................................   */

    ,
    sum: function sum() {
        for (var _len3 = arguments.length, xs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            xs[_key3] = arguments[_key3];
        }

        var ns = xs.filter(isNumber); // leave only numbers

        return ns.length > 0 ? ns.reduce(function (a, b) {
            return a + b;
        }, 0) : undefined;
    }

    /*  .............................................   */

    ,
    deepExtend: function deepExtend() {

        var out = undefined;

        for (var _len4 = arguments.length, xs = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            xs[_key4] = arguments[_key4];
        }

        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = xs[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var x = _step8.value;


                if (isDictionary(x)) {

                    if (!isObject(out)) out = {};

                    for (var k in x) {
                        out[k] = deepExtend(out[k], x[k]);
                    }
                } else out = x;
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }

        return out;
    }

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(25));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(9), __webpack_require__(26));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(9));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(15), __webpack_require__(16));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(4), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(4), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(4), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(4), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(5), __webpack_require__(6), __webpack_require__(4), __webpack_require__(3));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(64);
var parse = __webpack_require__(65);
var formats = __webpack_require__(28);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);
var formats = __webpack_require__(28);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var toISO = Date.prototype.toISOString;

var defaults = {
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        } else {
            values = values.concat(stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        keys = keys.concat(stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(27);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);

    for (var i = 0; i < parts.length; ++i) {
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder);
            val = options.decoder(part.slice(pos + 1), defaults.decoder);
        }
        if (has.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]') {
            obj = [];
            obj = obj.concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

var CryptoJS = __webpack_require__(24);

var _require = __webpack_require__(12),
    capitalize = _require.capitalize;

var _require2 = __webpack_require__(23),
    stringToBase64 = _require2.stringToBase64,
    utf16ToBase64 = _require2.utf16ToBase64,
    urlencodeBase64 = _require2.urlencodeBase64;

/*  ------------------------------------------------------------------------ */

var hash = function hash(request) {
    var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'md5';
    var digest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'hex';

    var result = CryptoJS[hash.toUpperCase()](request);
    return digest === 'binary' ? result : result.toString(CryptoJS.enc[capitalize(digest)]);
};

/*  .............................................   */

var hmac = function hmac(request, secret) {
    var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'sha256';
    var digest = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'hex';

    var encoding = digest === 'binary' ? 'Latin1' : capitalize(digest);
    return CryptoJS['Hmac' + hash.toUpperCase()](request, secret).toString(CryptoJS.enc[capitalize(encoding)]);
};

/*  .............................................   */

var jwt = function JSON_web_token(request, secret) {
    var alg = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'HS256';
    var hash = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'sha256';

    var encodedHeader = urlencodeBase64(stringToBase64(JSON.stringify({ 'alg': alg, 'typ': 'JWT' }))),
        encodedData = urlencodeBase64(stringToBase64(JSON.stringify(request))),
        token = [encodedHeader, encodedData].join('.'),
        signature = urlencodeBase64(utf16ToBase64(hmac(token, secret, hash, 'utf16')));
    return [token, signature].join('.');
};

/*  ------------------------------------------------------------------------ */

module.exports = {

    hash: hash,
    hmac: hmac,
    jwt: jwt

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*  ------------------------------------------------------------------------ */

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var _require = __webpack_require__(29),
    sleep = _require.sleep,
    now = _require.now;

/*  ------------------------------------------------------------------------ */

module.exports = {

    throttle: function throttle(cfg) {
        var _this = this;

        var lastTimestamp = now(),
            numTokens = typeof cfg.numTokens !== 'undefined' ? cfg.numTokens : cfg.capacity,
            running = false,
            counter = 0;

        var queue = [];

        return Object.assign(function (cost) {

            if (queue.length > cfg.maxCapacity) throw new Error('Backlog is over max capacity of ' + cfg.maxCapacity);

            return new Promise(function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
                    var hasEnoughTokens, _queue$, _cost, _resolve, _reject, t, elapsed;

                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.prev = 0;

                                    queue.push({ cost: cost, resolve: resolve, reject: reject });

                                    if (running) {
                                        _context.next = 15;
                                        break;
                                    }

                                    running = true;

                                case 4:
                                    if (!(queue.length > 0)) {
                                        _context.next = 14;
                                        break;
                                    }

                                    hasEnoughTokens = cfg.capacity ? numTokens > 0 : numTokens >= 0;

                                    if (hasEnoughTokens) {
                                        if (queue.length > 0) {
                                            _queue$ = queue[0], _cost = _queue$.cost, _resolve = _queue$.resolve, _reject = _queue$.reject;

                                            _cost = _cost || cfg.defaultCost;
                                            if (numTokens >= Math.min(_cost, cfg.capacity)) {
                                                numTokens -= _cost;
                                                queue.shift();
                                                _resolve();
                                            }
                                        }
                                    }
                                    t = now(), elapsed = t - lastTimestamp;

                                    lastTimestamp = t;
                                    numTokens = Math.min(cfg.capacity, numTokens + elapsed * cfg.refillRate);
                                    _context.next = 12;
                                    return sleep(cfg.delay);

                                case 12:
                                    _context.next = 4;
                                    break;

                                case 14:
                                    running = false;

                                case 15:
                                    _context.next = 20;
                                    break;

                                case 17:
                                    _context.prev = 17;
                                    _context.t0 = _context['catch'](0);

                                    reject(_context.t0);

                                case 20:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this, [[0, 17]]);
                }));

                return function (_x, _x2) {
                    return _ref.apply(this, arguments);
                };
            }());
        }, cfg, { configure: function configure(newCfg) {
                return throttle(Object.assign({}, cfg, newCfg));
            } });
    }

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------
// converts timeframe to seconds

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var parseTimeframe = function parseTimeframe(timeframe) {

    var amount = timeframe.slice(0, -1);
    var unit = timeframe.slice(-1);
    var scale = 60; // 1m by default

    if (unit === 'y') {
        scale = 60 * 60 * 24 * 365;
    } else if (unit === 'M') {
        scale = 60 * 60 * 24 * 30;
    } else if (unit === 'w') {
        scale = 60 * 60 * 24 * 7;
    } else if (unit === 'd') {
        scale = 60 * 60 * 24;
    } else if (unit === 'h') {
        scale = 60 * 60;
    }

    return amount * scale;
};

// given a sorted arrays of trades (recent last) and a timeframe builds an array of OHLCV candles
var buildOHLCVC = function buildOHLCVC(trades) {
    var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
    var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -Infinity;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;

    var ms = parseTimeframe(timeframe) * 1000;
    var ohlcvs = [];
    var _ref = [0, 1, 2, 3, 4, 5, 6],
        timestamp = _ref[0],
        /* open */high = _ref[2],
        low = _ref[3],
        close = _ref[4],
        volume = _ref[5],
        count = _ref[6];

    var oldest = Math.min(trades.length - 1, limit);

    for (var i = 0; i <= oldest; i++) {
        var trade = trades[i];
        if (trade.timestamp < since) continue;
        var openingTime = Math.floor(trade.timestamp / ms) * ms; // shift to the edge of m/h/d (but not M)
        var candle = ohlcvs.length - 1;

        if (candle === -1 || openingTime >= ohlcvs[candle][timestamp] + ms) {
            // moved to a new timeframe -> create a new candle from opening trade
            ohlcvs.push([openingTime, // timestamp
            trade.price, // O
            trade.price, // H
            trade.price, // L
            trade.price, // C
            trade.amount, // V
            1] // count
            );
        } else {
            // still processing the same timeframe -> update opening trade
            ohlcvs[candle][high] = Math.max(ohlcvs[candle][high], trade.price);
            ohlcvs[candle][low] = Math.min(ohlcvs[candle][low], trade.price);
            ohlcvs[candle][close] = trade.price;
            ohlcvs[candle][volume] += trade.amount;
            ohlcvs[candle][count]++;
        } // if
    } // for
    return ohlcvs;
};

/*  ------------------------------------------------------------------------ */

module.exports = {
    aggregate: function aggregate(bidasks) {

        var result = {};

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = bidasks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = _slicedToArray(_step.value, 2),
                    price = _step$value[0],
                    volume = _step$value[1];

                if (volume > 0) result[price] = (result[price] || 0) + volume;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return Object.keys(result).map(function (price) {
            return [parseFloat(price), parseFloat(result[price])];
        });
    },


    parseTimeframe: parseTimeframe,
    buildOHLCVC: buildOHLCVC

    /*  ------------------------------------------------------------------------ */

};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
    function Market(exchange, symbol) {
        _classCallCheck(this, Market);

        this.exchange = exchange;
        this.symbol = symbol;
        this.market = exchange.markets[symbol];
    }

    _createClass(Market, [{
        key: "amountToPrecision",
        value: function amountToPrecision(amount) {
            return this.exchange.amountToPrecision(this.symbol, amount);
        }
    }, {
        key: "createLimitBuyOrder",
        value: function createLimitBuyOrder(amount, price) {
            return this.exchange.createLimitBuyOrder(this.symbol, amount, price);
        }
    }, {
        key: "createLimitSellOrder",
        value: function createLimitSellOrder(amount, price) {
            return this.exchange.createLimitSellOrder(this.symbol, amount, price);
        }
    }]);

    return Market;
}();

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function (self) {
  'use strict';

  function fetchPonyfill(options) {
    var Promise = options && options.Promise || self.Promise;
    var XMLHttpRequest = options && options.XMLHttpRequest || self.XMLHttpRequest;
    var global = self;

    return (function () {
      var self = Object.create(global, {
        fetch: {
          value: undefined,
          writable: true
        }
      });

      (function(self) {
        'use strict';

        if (self.fetch) {
          return
        }

        var support = {
          searchParams: 'URLSearchParams' in self,
          iterable: 'Symbol' in self && 'iterator' in Symbol,
          blob: 'FileReader' in self && 'Blob' in self && (function() {
            try {
              new Blob()
              return true
            } catch(e) {
              return false
            }
          })(),
          formData: 'FormData' in self,
          arrayBuffer: 'ArrayBuffer' in self
        }

        if (support.arrayBuffer) {
          var viewClasses = [
            '[object Int8Array]',
            '[object Uint8Array]',
            '[object Uint8ClampedArray]',
            '[object Int16Array]',
            '[object Uint16Array]',
            '[object Int32Array]',
            '[object Uint32Array]',
            '[object Float32Array]',
            '[object Float64Array]'
          ]

          var isDataView = function(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj)
          }

          var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
          }
        }

        function normalizeName(name) {
          if (typeof name !== 'string') {
            name = String(name)
          }
          if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name')
          }
          return name.toLowerCase()
        }

        function normalizeValue(value) {
          if (typeof value !== 'string') {
            value = String(value)
          }
          return value
        }

        // Build a destructive iterator for the value list
        function iteratorFor(items) {
          var iterator = {
            next: function() {
              var value = items.shift()
              return {done: value === undefined, value: value}
            }
          }

          if (support.iterable) {
            iterator[Symbol.iterator] = function() {
              return iterator
            }
          }

          return iterator
        }

        function Headers(headers) {
          this.map = {}

          if (headers instanceof Headers) {
            headers.forEach(function(value, name) {
              this.append(name, value)
            }, this)
          } else if (Array.isArray(headers)) {
            headers.forEach(function(header) {
              this.append(header[0], header[1])
            }, this)
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function(name) {
              this.append(name, headers[name])
            }, this)
          }
        }

        Headers.prototype.append = function(name, value) {
          name = normalizeName(name)
          value = normalizeValue(value)
          var oldValue = this.map[name]
          this.map[name] = oldValue ? oldValue+','+value : value
        }

        Headers.prototype['delete'] = function(name) {
          delete this.map[normalizeName(name)]
        }

        Headers.prototype.get = function(name) {
          name = normalizeName(name)
          return this.has(name) ? this.map[name] : null
        }

        Headers.prototype.has = function(name) {
          return this.map.hasOwnProperty(normalizeName(name))
        }

        Headers.prototype.set = function(name, value) {
          this.map[normalizeName(name)] = normalizeValue(value)
        }

        Headers.prototype.forEach = function(callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this)
            }
          }
        }

        Headers.prototype.keys = function() {
          var items = []
          this.forEach(function(value, name) { items.push(name) })
          return iteratorFor(items)
        }

        Headers.prototype.values = function() {
          var items = []
          this.forEach(function(value) { items.push(value) })
          return iteratorFor(items)
        }

        Headers.prototype.entries = function() {
          var items = []
          this.forEach(function(value, name) { items.push([name, value]) })
          return iteratorFor(items)
        }

        if (support.iterable) {
          Headers.prototype[Symbol.iterator] = Headers.prototype.entries
        }

        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'))
          }
          body.bodyUsed = true
        }

        function fileReaderReady(reader) {
          return new Promise(function(resolve, reject) {
            reader.onload = function() {
              resolve(reader.result)
            }
            reader.onerror = function() {
              reject(reader.error)
            }
          })
        }

        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader()
          var promise = fileReaderReady(reader)
          reader.readAsArrayBuffer(blob)
          return promise
        }

        function readBlobAsText(blob) {
          var reader = new FileReader()
          var promise = fileReaderReady(reader)
          reader.readAsText(blob)
          return promise
        }

        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf)
          var chars = new Array(view.length)

          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i])
          }
          return chars.join('')
        }

        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0)
          } else {
            var view = new Uint8Array(buf.byteLength)
            view.set(new Uint8Array(buf))
            return view.buffer
          }
        }

        function Body() {
          this.bodyUsed = false

          this._initBody = function(body) {
            this._bodyInit = body
            if (!body) {
              this._bodyText = ''
            } else if (typeof body === 'string') {
              this._bodyText = body
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString()
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer)
              // IE 10-11 can't handle a DataView body.
              this._bodyInit = new Blob([this._bodyArrayBuffer])
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body)
            } else {
              throw new Error('unsupported BodyInit type')
            }

            if (!this.headers.get('content-type')) {
              if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8')
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type)
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
              }
            }
          }

          if (support.blob) {
            this.blob = function() {
              var rejected = consumed(this)
              if (rejected) {
                return rejected
              }

              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob)
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]))
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob')
              } else {
                return Promise.resolve(new Blob([this._bodyText]))
              }
            }

            this.arrayBuffer = function() {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
              } else {
                return this.blob().then(readBlobAsArrayBuffer)
              }
            }
          }

          this.text = function() {
            var rejected = consumed(this)
            if (rejected) {
              return rejected
            }

            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob)
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as text')
            } else {
              return Promise.resolve(this._bodyText)
            }
          }

          if (support.formData) {
            this.formData = function() {
              return this.text().then(decode)
            }
          }

          this.json = function() {
            return this.text().then(JSON.parse)
          }

          return this
        }

        // HTTP methods whose capitalization should be normalized
        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

        function normalizeMethod(method) {
          var upcased = method.toUpperCase()
          return (methods.indexOf(upcased) > -1) ? upcased : method
        }

        function Request(input, options) {
          options = options || {}
          var body = options.body

          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError('Already read')
            }
            this.url = input.url
            this.credentials = input.credentials
            if (!options.headers) {
              this.headers = new Headers(input.headers)
            }
            this.method = input.method
            this.mode = input.mode
            if (!body && input._bodyInit != null) {
              body = input._bodyInit
              input.bodyUsed = true
            }
          } else {
            this.url = String(input)
          }

          this.credentials = options.credentials || this.credentials || 'omit'
          if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers)
          }
          this.method = normalizeMethod(options.method || this.method || 'GET')
          this.mode = options.mode || this.mode || null
          this.referrer = null

          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests')
          }
          this._initBody(body)
        }

        Request.prototype.clone = function() {
          return new Request(this, { body: this._bodyInit })
        }

        function decode(body) {
          var form = new FormData()
          body.trim().split('&').forEach(function(bytes) {
            if (bytes) {
              var split = bytes.split('=')
              var name = split.shift().replace(/\+/g, ' ')
              var value = split.join('=').replace(/\+/g, ' ')
              form.append(decodeURIComponent(name), decodeURIComponent(value))
            }
          })
          return form
        }

        function parseHeaders(rawHeaders) {
          var headers = new Headers()
          rawHeaders.split(/\r?\n/).forEach(function(line) {
            var parts = line.split(':')
            var key = parts.shift().trim()
            if (key) {
              var value = parts.join(':').trim()
              headers.append(key, value)
            }
          })
          return headers
        }

        Body.call(Request.prototype)

        function Response(bodyInit, options) {
          if (!options) {
            options = {}
          }

          this.type = 'default'
          this.status = 'status' in options ? options.status : 200
          this.ok = this.status >= 200 && this.status < 300
          this.statusText = 'statusText' in options ? options.statusText : 'OK'
          this.headers = new Headers(options.headers)
          this.url = options.url || ''
          this._initBody(bodyInit)
        }

        Body.call(Response.prototype)

        Response.prototype.clone = function() {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
          })
        }

        Response.error = function() {
          var response = new Response(null, {status: 0, statusText: ''})
          response.type = 'error'
          return response
        }

        var redirectStatuses = [301, 302, 303, 307, 308]

        Response.redirect = function(url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code')
          }

          return new Response(null, {status: status, headers: {location: url}})
        }

        self.Headers = Headers
        self.Request = Request
        self.Response = Response

        self.fetch = function(input, init) {
          return new Promise(function(resolve, reject) {
            var request = new Request(input, init)
            var xhr = new XMLHttpRequest()

            xhr.onload = function() {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
              }
              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
              var body = 'response' in xhr ? xhr.response : xhr.responseText
              resolve(new Response(body, options))
            }

            xhr.onerror = function() {
              reject(new TypeError('Network request failed'))
            }

            xhr.ontimeout = function() {
              reject(new TypeError('Network request failed'))
            }

            xhr.open(request.method, request.url, true)

            if (request.credentials === 'include') {
              xhr.withCredentials = true
            }

            if ('responseType' in xhr && support.blob) {
              xhr.responseType = 'blob'
            }

            request.headers.forEach(function(value, name) {
              xhr.setRequestHeader(name, value)
            })

            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
          })
        }
        self.fetch.polyfill = true
      })(typeof self !== 'undefined' ? self : this);


      return {
        fetch: self.fetch,
        Headers: self.Headers,
        Request: self.Request,
        Response: self.Response
      };
    }());
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return fetchPonyfill;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = fetchPonyfill;
  } else {
    self.fetchPonyfill = fetchPonyfill;
  }
}(typeof self === 'undefined' ? this : self));



/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(_1broker, _Exchange);

    function _1broker() {
        _classCallCheck(this, _1broker);

        return _possibleConstructorReturn(this, (_1broker.__proto__ || Object.getPrototypeOf(_1broker)).apply(this, arguments));
    }

    _createClass(_1broker, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(_1broker.prototype.__proto__ || Object.getPrototypeOf(_1broker.prototype), 'describe', this).call(this), {
                'id': '_1broker',
                'name': '1Broker',
                'countries': 'US',
                'rateLimit': 1500,
                'version': 'v2',
                'has': {
                    'publicAPI': false,
                    'CORS': true,
                    'fetchTrades': false,
                    'fetchOHLCV': true
                },
                'timeframes': {
                    '1m': '60', // not working for some reason, returns {"server_time":"2018-03-26T03:52:27.912Z","error":true,"warning":false,"response":null,"error_code":-1,"error_message":"Error while trying to fetch historical market data. An invalid resolution was probably used."}
                    '15m': '900',
                    '1h': '3600',
                    '1d': '86400'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766021-420bd9fc-5ecb-11e7-8ed6-56d0081efed2.jpg',
                    'api': 'https://1broker.com/api',
                    'www': 'https://1broker.com',
                    'doc': 'https://1broker.com/?c=en/content/api-documentation'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false
                },
                'api': {
                    'private': {
                        'get': ['market/bars', 'market/categories', 'market/details', 'market/list', 'market/quotes', 'market/ticks', 'order/cancel', 'order/create', 'order/open', 'position/close', 'position/close_cancel', 'position/edit', 'position/history', 'position/open', 'position/shared/get', 'social/profile_statistics', 'social/profile_trades', 'user/bitcoin_deposit_address', 'user/details', 'user/overview', 'user/quota_status', 'user/transaction_log']
                    }
                }
            });
        }
    }, {
        key: 'fetchCategories',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, categories, result, i;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetMarketCategories();

                            case 2:
                                response = _context.sent;

                                // they return an empty string among their categories, wtf?
                                categories = response['response'];
                                result = [];

                                for (i = 0; i < categories.length; i++) {
                                    if (categories[i]) result.push(categories[i]);
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCategories() {
                return _ref.apply(this, arguments);
            }

            return fetchCategories;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var this_, categories, result, c, category, markets, p, market, id, symbol, base, quote, parts;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                this_ = this; // workaround for Babel bug (not passing `this` to _recursive() call)

                                _context2.next = 3;
                                return this.fetchCategories();

                            case 3:
                                categories = _context2.sent;
                                result = [];
                                c = 0;

                            case 6:
                                if (!(c < categories.length)) {
                                    _context2.next = 15;
                                    break;
                                }

                                category = categories[c];
                                _context2.next = 10;
                                return this_.privateGetMarketList({
                                    'category': category.toLowerCase()
                                });

                            case 10:
                                markets = _context2.sent;

                                for (p = 0; p < markets['response'].length; p++) {
                                    market = markets['response'][p];
                                    id = market['symbol'];
                                    symbol = undefined;
                                    base = undefined;
                                    quote = undefined;

                                    if (category === 'FOREX' || category === 'CRYPTO') {
                                        symbol = market['name'];
                                        parts = symbol.split('/');

                                        base = parts[0];
                                        quote = parts[1];
                                    } else {
                                        base = id;
                                        quote = 'USD';
                                        symbol = base + '/' + quote;
                                    }
                                    base = this_.commonCurrencyCode(base);
                                    quote = this_.commonCurrencyCode(quote);
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }

                            case 12:
                                c++;
                                _context2.next = 6;
                                break;

                            case 15:
                                return _context2.abrupt('return', result);

                            case 16:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, response, result, currencies, c, currency, total;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.privateGetUserOverview();

                            case 4:
                                balance = _context3.sent;
                                response = balance['response'];
                                result = {
                                    'info': response
                                };
                                currencies = Object.keys(this.currencies);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];

                                    result[currency] = this.account();
                                }
                                total = this.safeFloat(response, 'balance');

                                result['BTC']['free'] = total;
                                result['BTC']['total'] = total;
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, timestamp, bidPrice, askPrice, bid, ask;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privateGetMarketQuotes(this.extend({
                                    'symbols': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context4.sent;
                                orderbook = response['response'][0];
                                timestamp = this.parse8601(orderbook['updated']);
                                bidPrice = this.safeFloat(orderbook, 'bid');
                                askPrice = this.safeFloat(orderbook, 'ask');
                                bid = [bidPrice, undefined];
                                ask = [askPrice, undefined];
                                return _context4.abrupt('return', {
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'bids': [bid],
                                    'asks': [ask],
                                    'nonce': undefined
                                });

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                throw new NotSupported(this.id + ' fetchTrades () method not implemented yet');

                            case 1:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x5) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var result, ticker, timestamp, open, close, change;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privateGetMarketBars(this.extend({
                                    'symbol': this.marketId(symbol),
                                    'resolution': 60,
                                    'limit': 1
                                }, params));

                            case 4:
                                result = _context6.sent;
                                ticker = result['response'][0];
                                timestamp = this.parse8601(ticker['date']);
                                open = this.safeFloat(ticker, 'o');
                                close = this.safeFloat(ticker, 'c');
                                change = close - open;
                                return _context6.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'h'),
                                    'low': this.safeFloat(ticker, 'l'),
                                    'bid': undefined,
                                    'bidVolume': undefined,
                                    'ask': undefined,
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': open,
                                    'close': close,
                                    'last': close,
                                    'previousClose': undefined,
                                    'change': change,
                                    'percentage': change / open * 100,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x6) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [this.parse8601(ohlcv['date']), parseFloat(ohlcv['o']), parseFloat(ohlcv['h']), parseFloat(ohlcv['l']), parseFloat(ohlcv['c']), undefined];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, result;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'resolution': this.timeframes[timeframe]
                                };

                                if (typeof since !== 'undefined') request['date_start'] = this.iso8601(since); // they also support date_end
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context7.next = 8;
                                return this.privateGetMarketBars(this.extend(request, params));

                            case 8:
                                result = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(result['response'], market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x12) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'symbol': this.marketId(symbol),
                                    'margin': amount,
                                    'direction': side === 'sell' ? 'short' : 'long',
                                    'leverage': 1,
                                    'type': side
                                };

                                if (type === 'limit') order['price'] = price;else order['type'] += '_market';
                                _context8.next = 6;
                                return this.privateGetOrderCreate(this.extend(order, params));

                            case 6:
                                result = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': result,
                                    'id': result['response']['order_id']
                                });

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x17, _x18, _x19, _x20) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostOrderCancel({ 'order_id': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x23) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            this.checkRequiredCredentials();
            var url = this.urls['api'] + '/' + this.version + '/' + path + '.php';
            var query = this.extend({ 'token': this.apiKey }, params);
            url += '?' + this.urlencode(query);
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('warning' in response)) {
                                    _context10.next = 6;
                                    break;
                                }

                                if (!response['warning']) {
                                    _context10.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                if (!('error' in response)) {
                                    _context10.next = 9;
                                    break;
                                }

                                if (!response['error']) {
                                    _context10.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 9:
                                return _context10.abrupt('return', response);

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x31) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return _1broker;
}(Exchange);

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var okcoinusd = __webpack_require__(10);

//  ---------------------------------------------------------------------------

module.exports = function (_okcoinusd) {
    _inherits(allcoin, _okcoinusd);

    function allcoin() {
        _classCallCheck(this, allcoin);

        return _possibleConstructorReturn(this, (allcoin.__proto__ || Object.getPrototypeOf(allcoin)).apply(this, arguments));
    }

    _createClass(allcoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(allcoin.prototype.__proto__ || Object.getPrototypeOf(allcoin.prototype), 'describe', this).call(this), {
                'id': 'allcoin',
                'name': 'Allcoin',
                'countries': 'CA',
                'has': {
                    'CORS': false
                },
                'extension': '',
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/31561809-c316b37c-b061-11e7-8d5a-b547b4d730eb.jpg',
                    'api': {
                        'web': 'https://www.allcoin.com',
                        'public': 'https://api.allcoin.com/api',
                        'private': 'https://api.allcoin.com/api'
                    },
                    'www': 'https://www.allcoin.com',
                    'doc': 'https://www.allcoin.com/About/APIReference'
                },
                'api': {
                    'web': {
                        'get': ['Home/MarketOverViewDetail/']
                    },
                    'public': {
                        'get': ['depth', 'kline', 'ticker', 'trades']
                    },
                    'private': {
                        'post': ['batch_trade', 'cancel_order', 'order_history', 'order_info', 'orders_info', 'repayment', 'trade', 'trade_history', 'userinfo']
                    }
                },
                'markets': undefined
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var result, response, coins, j, markets, k, market, base, quote, baseId, quoteId, id, symbol, active;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                result = [];
                                _context.next = 3;
                                return this.webGetHomeMarketOverViewDetail();

                            case 3:
                                response = _context.sent;
                                coins = response['marketCoins'];

                                for (j = 0; j < coins.length; j++) {
                                    markets = coins[j]['Markets'];

                                    for (k = 0; k < markets.length; k++) {
                                        market = markets[k]['Market'];
                                        base = market['Primary'];
                                        quote = market['Secondary'];
                                        baseId = base.toLowerCase();
                                        quoteId = quote.toLowerCase();
                                        id = baseId + '_' + quoteId;
                                        symbol = base + '/' + quote;
                                        active = market['TradeEnabled'] && market['BuyEnabled'] && market['SellEnabled'];

                                        result.push({
                                            'id': id,
                                            'symbol': symbol,
                                            'base': base,
                                            'quote': quote,
                                            'baseId': baseId,
                                            'quoteId': quoteId,
                                            'active': active,
                                            'type': 'spot',
                                            'spot': true,
                                            'future': false,
                                            'maker': market['AskFeeRate'], // BidFeeRate 0, AskFeeRate 0.002, we use just the AskFeeRate here
                                            'taker': market['AskFeeRate'], // BidFeeRate 0, AskFeeRate 0.002, we use just the AskFeeRate here
                                            'precision': {
                                                'amount': market['PrimaryDigits'],
                                                'price': market['SecondaryDigits']
                                            },
                                            'limits': {
                                                'amount': {
                                                    'min': market['MinTradeAmount'],
                                                    'max': market['MaxTradeAmount']
                                                },
                                                'price': {
                                                    'min': market['MinOrderPrice'],
                                                    'max': market['MaxOrderPrice']
                                                },
                                                'cost': {
                                                    'min': undefined,
                                                    'max': undefined
                                                }
                                            },
                                            'info': market
                                        });
                                    }
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            if (status === -1) return 'canceled';
            if (status === 0) return 'open';
            if (status === 1) return 'open'; // partially filled
            if (status === 2) return 'closed';
            if (status === 10) return 'canceled';
            return status;
        }
    }, {
        key: 'getCreateDateField',
        value: function getCreateDateField() {
            // allcoin typo create_data instead of create_date
            return 'create_data';
        }
    }, {
        key: 'getOrdersField',
        value: function getOrdersField() {
            // allcoin typo order instead of orders (expected based on their API docs)
            return 'order';
        }
    }]);

    return allcoin;
}(okcoinusd);

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(anxpro, _Exchange);

    function anxpro() {
        _classCallCheck(this, anxpro);

        return _possibleConstructorReturn(this, (anxpro.__proto__ || Object.getPrototypeOf(anxpro)).apply(this, arguments));
    }

    _createClass(anxpro, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(anxpro.prototype.__proto__ || Object.getPrototypeOf(anxpro.prototype), 'describe', this).call(this), {
                'id': 'anxpro',
                'name': 'ANXPro',
                'countries': ['JP', 'SG', 'HK', 'NZ'],
                'version': '2',
                'rateLimit': 1500,
                'has': {
                    'CORS': false,
                    'fetchOHLCV': false,
                    'fetchTrades': false,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27765983-fd8595da-5ec9-11e7-82e3-adb3ab8c2612.jpg',
                    'api': 'https://anxpro.com/api',
                    'www': 'https://anxpro.com',
                    'doc': ['http://docs.anxv2.apiary.io', 'https://anxpro.com/pages/api']
                },
                'api': {
                    'public': {
                        'get': ['{currency_pair}/money/ticker', '{currency_pair}/money/depth/full', '{currency_pair}/money/trade/fetch']
                    },
                    'private': {
                        'post': ['{currency_pair}/money/order/add', '{currency_pair}/money/order/cancel', '{currency_pair}/money/order/quote', '{currency_pair}/money/order/result', '{currency_pair}/money/orders', 'money/{currency}/address', 'money/{currency}/send_simple', 'money/info', 'money/trade/list', 'money/wallet/history']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'BTCUSD', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'multiplier': 100000 },
                    'BTC/HKD': { 'id': 'BTCHKD', 'symbol': 'BTC/HKD', 'base': 'BTC', 'quote': 'HKD', 'multiplier': 100000 },
                    'BTC/EUR': { 'id': 'BTCEUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR', 'multiplier': 100000 },
                    'BTC/CAD': { 'id': 'BTCCAD', 'symbol': 'BTC/CAD', 'base': 'BTC', 'quote': 'CAD', 'multiplier': 100000 },
                    'BTC/AUD': { 'id': 'BTCAUD', 'symbol': 'BTC/AUD', 'base': 'BTC', 'quote': 'AUD', 'multiplier': 100000 },
                    'BTC/SGD': { 'id': 'BTCSGD', 'symbol': 'BTC/SGD', 'base': 'BTC', 'quote': 'SGD', 'multiplier': 100000 },
                    'BTC/JPY': { 'id': 'BTCJPY', 'symbol': 'BTC/JPY', 'base': 'BTC', 'quote': 'JPY', 'multiplier': 100000 },
                    'BTC/GBP': { 'id': 'BTCGBP', 'symbol': 'BTC/GBP', 'base': 'BTC', 'quote': 'GBP', 'multiplier': 100000 },
                    'BTC/NZD': { 'id': 'BTCNZD', 'symbol': 'BTC/NZD', 'base': 'BTC', 'quote': 'NZD', 'multiplier': 100000 },
                    'LTC/BTC': { 'id': 'LTCBTC', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'multiplier': 100000 },
                    'STR/BTC': { 'id': 'STRBTC', 'symbol': 'STR/BTC', 'base': 'STR', 'quote': 'BTC', 'multiplier': 100000000 },
                    'XRP/BTC': { 'id': 'XRPBTC', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC', 'multiplier': 100000000 },
                    'DOGE/BTC': { 'id': 'DOGEBTC', 'symbol': 'DOGE/BTC', 'base': 'DOGE', 'quote': 'BTC', 'multiplier': 100000000 }
                },
                'fees': {
                    'trading': {
                        'maker': 0.3 / 100,
                        'taker': 0.6 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, currencies, result, c, currency, account, wallet;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostMoneyInfo();

                            case 2:
                                response = _context.sent;
                                balance = response['data'];
                                currencies = Object.keys(balance['Wallets']);
                                result = { 'info': balance };

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    account = this.account();

                                    if (currency in balance['Wallets']) {
                                        wallet = balance['Wallets'][currency];

                                        account['free'] = parseFloat(wallet['Available_Balance']['value']);
                                        account['total'] = parseFloat(wallet['Balance']['value']);
                                        account['used'] = account['total'] - account['free'];
                                    }
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, t, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetCurrencyPairMoneyDepthFull(this.extend({
                                    'currency_pair': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context2.sent;
                                orderbook = response['data'];
                                t = parseInt(orderbook['dataUpdateTime']);
                                timestamp = parseInt(t / 1000);
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'amount'));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, t, timestamp, bid, ask, baseVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetCurrencyPairMoneyTicker(this.extend({
                                    'currency_pair': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context3.sent;
                                ticker = response['data'];
                                t = parseInt(ticker['dataUpdateTime']);
                                timestamp = parseInt(t / 1000);
                                bid = this.safeFloat(ticker['buy'], 'value');
                                ask = this.safeFloat(ticker['sell'], 'value');
                                baseVolume = parseFloat(ticker['vol']['value']);
                                last = parseFloat(ticker['last']['value']);
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': parseFloat(ticker['high']['value']),
                                    'low': parseFloat(ticker['low']['value']),
                                    'bid': bid,
                                    'bidVolume': undefined,
                                    'ask': ask,
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': parseFloat(ticker['avg']['value']),
                                    'baseVolume': baseVolume,
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                throw new ExchangeError(this.id + ' switched off the trades endpoint, see their docs at http://docs.anxv2.apiary.io/reference/market-data/currencypairmoneytradefetch-disabled');

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, result;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                order = {
                                    'currency_pair': market['id'],
                                    'amount_int': parseInt(amount * 100000000) // 10^8
                                };

                                if (type === 'limit') {
                                    order['price_int'] = parseInt(price * market['multiplier']); // 10^5 or 10^8
                                }
                                order['type'] = side === 'buy' ? 'bid' : 'ask';
                                _context5.next = 6;
                                return this.privatePostCurrencyPairMoneyOrderAdd(this.extend(order, params));

                            case 6:
                                result = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': result,
                                    'id': result['data']
                                });

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCurrencyPairMoneyOrderCancel({ 'oid': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'getAmountMultiplier',
        value: function getAmountMultiplier(currency) {
            if (currency === 'BTC') {
                return 100000000;
            } else if (currency === 'LTC') {
                return 100000000;
            } else if (currency === 'STR') {
                return 100000000;
            } else if (currency === 'XRP') {
                return 100000000;
            } else if (currency === 'DOGE') {
                return 100000000;
            }
            return 100;
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var multiplier, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.checkAddress(address);
                                _context7.next = 3;
                                return this.loadMarkets();

                            case 3:
                                multiplier = this.getAmountMultiplier(currency);
                                _context7.next = 6;
                                return this.privatePostMoneyCurrencySendSimple(this.extend({
                                    'currency': currency,
                                    'amount_int': parseInt(amount * multiplier),
                                    'address': address
                                }, params));

                            case 6:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['data']['transactionId']
                                });

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function withdraw(_x20, _x21, _x22) {
                return _ref7.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + '/' + this.version + '/' + request;
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({ 'nonce': nonce }, query));
                var secret = this.base64ToBinary(this.secret);
                var auth = request + '\0' + body;
                var signature = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Rest-Key': this.apiKey,
                    'Rest-Sign': this.decode(signature)
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context8.sent;

                                if (!(typeof response !== 'undefined')) {
                                    _context8.next = 7;
                                    break;
                                }

                                if (!('result' in response)) {
                                    _context8.next = 7;
                                    break;
                                }

                                if (!(response['result'] === 'success')) {
                                    _context8.next = 7;
                                    break;
                                }

                                return _context8.abrupt('return', response);

                            case 7:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function request(_x30) {
                return _ref8.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return anxpro;
}(Exchange);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    DDoSProtection = _require.DDoSProtection,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    PermissionDenied = _require.PermissionDenied,
    InsufficientFunds = _require.InsufficientFunds;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bibox, _Exchange);

    function bibox() {
        _classCallCheck(this, bibox);

        return _possibleConstructorReturn(this, (bibox.__proto__ || Object.getPrototypeOf(bibox)).apply(this, arguments));
    }

    _createClass(bibox, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bibox.prototype.__proto__ || Object.getPrototypeOf(bibox.prototype), 'describe', this).call(this), {
                'id': 'bibox',
                'name': 'Bibox',
                'countries': ['CN', 'US', 'KR'],
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'publicAPI': false,
                    'fetchBalance': true,
                    'fetchCurrencies': true,
                    'fetchDepositAddress': true,
                    'fetchFundingFees': true,
                    'fetchTickers': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true,
                    'fetchOHLCV': true,
                    'createMarketOrder': false, // or they will return https://github.com/ccxt/ccxt/issues/2338
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '1hour',
                    '8h': '12hour',
                    '1d': 'day',
                    '1w': 'week'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/34902611-2be8bf1a-f830-11e7-91a2-11b2f292e750.jpg',
                    'api': 'https://api.bibox.com',
                    'www': 'https://www.bibox.com',
                    'doc': ['https://github.com/Biboxcom/api_reference/wiki/home_en', 'https://github.com/Biboxcom/api_reference/wiki/api_reference'],
                    'fees': 'https://bibox.zendesk.com/hc/en-us/articles/115004417013-Fee-Structure-on-Bibox'
                },
                'api': {
                    'public': {
                        'post': [
                        // TODO: rework for full endpoint/cmd paths here
                        'mdata'],
                        'get': ['mdata']
                    },
                    'private': {
                        'post': ['user', 'orderpending', 'transfer']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'taker': 0.001,
                        'maker': 0.0
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {},
                        'deposit': {}
                    }
                },
                'exceptions': {
                    '2021': InsufficientFunds, // Insufficient balance available for withdrawal
                    '2015': AuthenticationError, // Google authenticator is wrong
                    '2033': OrderNotFound, // operation failed! Orders have been completed or revoked
                    '2067': InvalidOrder, // Does not support market orders
                    '2068': InvalidOrder, // The number of orders can not be less than
                    '3012': AuthenticationError, // invalid apiKey
                    '3024': PermissionDenied, // wrong apikey permissions
                    '3025': AuthenticationError, // signature failed
                    '4000': ExchangeNotAvailable, // current network is unstable
                    '4003': DDoSProtection // server busy please try again later
                },
                'commonCurrencies': {
                    'KEY': 'Bihu'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, markets, result, i, market, baseId, quoteId, base, quote, symbol, id, precision;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMdata(this.extend({
                                    'cmd': 'marketAll'
                                }, params));

                            case 2:
                                response = _context.sent;
                                markets = response['result'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    baseId = market['coin_symbol'];
                                    quoteId = market['currency_symbol'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    id = base + '_' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': base,
                                        'quoteId': quote,
                                        'active': true,
                                        'info': market,
                                        'lot': Math.pow(10, -precision['amount']),
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision['amount']),
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            // we don't set values that are not defined by the exchange
            var timestamp = this.safeInteger(ticker, 'timestamp');
            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                var base = ticker['coin_symbol'];
                var quote = ticker['currency_symbol'];
                symbol = this.commonCurrencyCode(base) + '/' + this.commonCurrencyCode(quote);
            }
            var last = this.safeFloat(ticker, 'last');
            var change = this.safeFloat(ticker, 'change');
            var baseVolume = undefined;
            if ('vol' in ticker) {
                baseVolume = this.safeFloat(ticker, 'vol');
            } else {
                baseVolume = this.safeFloat(ticker, 'vol24H');
            }
            var open = undefined;
            if (typeof last !== 'undefined' && typeof change !== 'undefined') open = last - change;
            var iso8601 = undefined;
            if (typeof timestamp !== 'undefined') iso8601 = this.iso8601(timestamp);
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': iso8601,
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': open,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': this.safeString(ticker, 'percent'),
                'average': undefined,
                'baseVolume': baseVolume,
                'quoteVolume': this.safeFloat(ticker, 'amount'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetMdata(this.extend({
                                    'cmd': 'ticker',
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(response['result'], market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x3) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTickers',
        value: function parseTickers(rawTickers) {
            var symbols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var tickers = [];
            for (var i = 0; i < rawTickers.length; i++) {
                tickers.push(this.parseTicker(rawTickers[i]));
            }
            return this.filterByArray(tickers, 'symbol', symbols);
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetMdata(this.extend({
                                    'cmd': 'marketAll'
                                }, params));

                            case 2:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTickers(response['result'], symbols));

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['time'];
            var side = this.safeInteger(trade, 'side');
            side = this.safeInteger(trade, 'order_side', side);
            side = side === 1 ? 'buy' : 'sell';
            if (typeof market === 'undefined') {
                var marketId = this.safeString(trade, 'pair');
                if (typeof marketId !== 'undefined') if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            var fee = undefined;
            if ('fee' in trade) {
                fee = {
                    'cost': this.safeFloat(trade, 'fee'),
                    'currency': undefined
                };
            }
            return {
                'id': this.safeString(trade, 'id'),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount'),
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, size, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                size = limit ? limit : 200;
                                _context4.next = 6;
                                return this.publicGetMdata(this.extend({
                                    'cmd': 'deals',
                                    'pair': market['id'],
                                    'size': size
                                }, params));

                            case 6:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response['result'], market, since, limit));

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x9) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'cmd': 'depth',
                                    'pair': market['id']
                                };

                                request['size'] = limit; // default = 200 ?
                                _context5.next = 7;
                                return this.publicGetMdata(this.extend(request, params));

                            case 7:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(response['result'], this.safeFloat(response['result'], 'update_time'), 'bids', 'asks', 'price', 'volume'));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x13) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv['time'], ohlcv['open'], ohlcv['high'], ohlcv['low'], ohlcv['close'], ohlcv['vol']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetMdata(this.extend({
                                    'cmd': 'kline',
                                    'pair': market['id'],
                                    'period': this.timeframes[timeframe],
                                    'size': limit
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOHLCVs(response['result'], market, timeframe, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOHLCV(_x20) {
                return _ref6.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, code, precision, deposit, withdraw, active;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.privatePostTransfer({
                                    'cmd': 'transfer/coinList',
                                    'body': {}
                                });

                            case 2:
                                response = _context7.sent;
                                currencies = response['result'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['symbol'];
                                    code = this.commonCurrencyCode(id);
                                    precision = 8;
                                    deposit = currency['enable_deposit'];
                                    withdraw = currency['enable_withdraw'];
                                    active = deposit && withdraw ? true : false;

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': 'ok',
                                        'fee': undefined,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context7.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchCurrencies() {
                return _ref7.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, indexed, keys, i, id, code, account, balance;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privatePostTransfer({
                                    'cmd': 'transfer/assets',
                                    'body': this.extend({
                                        'select': 1
                                    }, params)
                                });

                            case 4:
                                response = _context8.sent;
                                balances = response['result'];
                                result = { 'info': balances };
                                indexed = undefined;

                                if ('assets_list' in balances) {
                                    indexed = this.indexBy(balances['assets_list'], 'coin_symbol');
                                } else {
                                    indexed = balances;
                                }
                                keys = Object.keys(indexed);

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    code = id.toUpperCase();

                                    if (code.indexOf('TOTAL_') >= 0) {
                                        code = code.slice(6);
                                    }
                                    if (code in this.currencies_by_id) {
                                        code = this.currencies_by_id[code]['code'];
                                    }
                                    account = this.account();
                                    balance = indexed[id];

                                    if (typeof balance === 'string') {
                                        balance = parseFloat(balance);
                                        account['free'] = balance;
                                        account['used'] = 0.0;
                                        account['total'] = balance;
                                    } else {
                                        account['free'] = parseFloat(balance['balance']);
                                        account['used'] = parseFloat(balance['freeze']);
                                        account['total'] = this.sum(account['free'], account['used']);
                                    }
                                    result[code] = account;
                                }
                                return _context8.abrupt('return', this.parseBalance(result));

                            case 12:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchBalance() {
                return _ref8.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, orderType, orderSide, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                orderType = type === 'limit' ? 2 : 1;
                                orderSide = side === 'buy' ? 1 : 2;
                                _context9.next = 7;
                                return this.privatePostOrderpending({
                                    'cmd': 'orderpending/trade',
                                    'body': this.extend({
                                        'pair': market['id'],
                                        'account_type': 0,
                                        'order_type': orderType,
                                        'order_side': orderSide,
                                        'pay_bix': 0,
                                        'amount': amount,
                                        'price': price
                                    }, params)
                                });

                            case 7:
                                response = _context9.sent;
                                return _context9.abrupt('return', {
                                    'info': response,
                                    'id': this.safeString(response, 'result')
                                });

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x27, _x28, _x29, _x30) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.privatePostOrderpending({
                                    'cmd': 'orderpending/cancelTrade',
                                    'body': this.extend({
                                        'orders_id': id
                                    }, params)
                                });

                            case 2:
                                response = _context10.sent;
                                return _context10.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x33) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                symbol = order['coin_symbol'] + '/' + order['currency_symbol'];
            }
            var type = order['order_type'] === 1 ? 'market' : 'limit';
            var timestamp = order['createdAt'];
            var price = this.safeFloat(order, 'price');
            var filled = this.safeFloat(order, 'deal_amount');
            var amount = this.safeFloat(order, 'amount');
            var cost = this.safeFloat(order, 'money');
            var remaining = undefined;
            if (typeof filled !== 'undefined') {
                if (typeof amount !== 'undefined') remaining = amount - filled;
                if (typeof cost === 'undefined') cost = price * filled;
            }
            var side = order['order_side'] === 1 ? 'buy' : 'sell';
            var status = this.safeString(order, 'status');
            if (typeof status !== 'undefined') status = this.parseOrderStatus(status);
            var result = {
                'info': order,
                'id': this.safeString(order, 'id'),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost ? cost : parseFloat(price) * filled,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': this.safeFloat(order, 'fee')
            };
            return result;
        }
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                // original comments from bibox:
                '1': 'pending', // pending
                '2': 'open', // part completed
                '3': 'closed', // completed
                '4': 'canceled', // part canceled
                '5': 'canceled', // canceled
                '6': 'canceled' // canceling
            };
            return this.safeString(statuses, status, status.toLowerCase());
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, pair, size, response, orders;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                market = undefined;
                                pair = undefined;

                                if (!(typeof symbol !== 'undefined')) {
                                    _context11.next = 7;
                                    break;
                                }

                                _context11.next = 5;
                                return this.loadMarkets();

                            case 5:
                                market = this.market(symbol);
                                pair = market['id'];

                            case 7:
                                size = limit ? limit : 200;
                                _context11.next = 10;
                                return this.privatePostOrderpending({
                                    'cmd': 'orderpending/orderPendingList',
                                    'body': this.extend({
                                        'pair': pair,
                                        'account_type': 0, // 0 - regular, 1 - margin
                                        'page': 1,
                                        'size': size
                                    }, params)
                                });

                            case 10:
                                response = _context11.sent;
                                orders = this.safeValue(response['result'], 'items', []);
                                return _context11.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 13:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchClosedOrders requires a symbol argument');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context12.next = 7;
                                return this.privatePostOrderpending({
                                    'cmd': 'orderpending/pendingHistoryList',
                                    'body': this.extend({
                                        'pair': market['id'],
                                        'account_type': 0, // 0 - regular, 1 - margin
                                        'page': 1,
                                        'size': limit
                                    }, params)
                                });

                            case 7:
                                response = _context12.sent;
                                orders = this.safeValue(response['result'], 'items', []);
                                return _context12.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 10:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchClosedOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, size, response, trades;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                if (symbol) {
                                    _context13.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMyTrades requires a symbol argument');

                            case 2:
                                _context13.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                size = limit ? limit : 200;
                                _context13.next = 8;
                                return this.privatePostOrderpending({
                                    'cmd': 'orderpending/orderHistoryList',
                                    'body': this.extend({
                                        'pair': market['id'],
                                        'account_type': 0, // 0 - regular, 1 - margin
                                        'page': 1,
                                        'size': size
                                    }, params)
                                });

                            case 8:
                                response = _context13.sent;
                                trades = this.safeValue(response['result'], 'items', []);
                                return _context13.abrupt('return', this.parseOrders(trades, market, since, limit));

                            case 11:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchMyTrades() {
                return _ref13.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, result;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context14.next = 5;
                                return this.privatePostTransfer({
                                    'cmd': 'transfer/transferIn',
                                    'body': this.extend({
                                        'coin_symbol': currency['id']
                                    }, params)
                                });

                            case 5:
                                response = _context14.sent;
                                address = this.safeString(response, 'result');
                                result = {
                                    'info': response,
                                    'address': address
                                };
                                return _context14.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchDepositAddress(_x49) {
                return _ref14.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, body, response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                this.checkAddress(address);
                                _context15.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);

                                if (!(typeof this.password === 'undefined')) {
                                    _context15.next = 7;
                                    break;
                                }

                                if ('trade_pwd' in params) {
                                    _context15.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' withdraw() requires this.password set on the exchange instance or a trade_pwd parameter');

                            case 7:
                                if ('totp_code' in params) {
                                    _context15.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' withdraw() requires a totp_code parameter for 2FA authentication');

                            case 9:
                                body = {
                                    'trade_pwd': this.password,
                                    'coin_symbol': currency['id'],
                                    'amount': amount,
                                    'addr': address
                                };

                                if (typeof tag !== 'undefined') body['address_remark'] = tag;
                                _context15.next = 13;
                                return this.privatePostTransfer({
                                    'cmd': 'transfer/transferOut',
                                    'body': this.extend(body, params)
                                });

                            case 13:
                                response = _context15.sent;
                                return _context15.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 15:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function withdraw(_x51, _x52, _x53) {
                return _ref15.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'fetchFundingFees',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var withdrawFees, info, i, code, currency, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                withdrawFees = {};
                                info = {};

                                if (typeof codes === 'undefined') codes = Object.keys(this.currencies);
                                i = 0;

                            case 6:
                                if (!(i < codes.length)) {
                                    _context16.next = 17;
                                    break;
                                }

                                code = codes[i];
                                currency = this.currency(code);
                                _context16.next = 11;
                                return this.privatePostTransfer({
                                    'cmd': 'transfer/transferOutInfo',
                                    'body': this.extend({
                                        'coin_symbol': currency['id']
                                    }, params)
                                });

                            case 11:
                                response = _context16.sent;

                                info[code] = response;
                                withdrawFees[code] = response['result']['withdraw_fee'];

                            case 14:
                                i++;
                                _context16.next = 6;
                                break;

                            case 17:
                                return _context16.abrupt('return', {
                                    'info': info,
                                    'withdraw': withdrawFees,
                                    'deposit': {}
                                });

                            case 18:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchFundingFees() {
                return _ref16.apply(this, arguments);
            }

            return fetchFundingFees;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            var cmds = this.json([params]);
            if (api === 'public') {
                if (method !== 'GET') body = { 'cmds': cmds };else if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                body = {
                    'cmds': cmds,
                    'apikey': this.apiKey,
                    'sign': this.hmac(this.encode(cmds), this.encode(this.secret), 'md5')
                };
            }
            if (typeof body !== 'undefined') body = this.json(body, { 'convertArraysToObjects': true });
            headers = { 'Content-Type': 'application/json' };
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body.length > 0) {
                if (body[0] === '{') {
                    var response = JSON.parse(body);
                    if ('error' in response) {
                        if ('code' in response['error']) {
                            var _code = this.safeString(response['error'], 'code');
                            var feedback = this.id + ' ' + body;
                            var exceptions = this.exceptions;
                            if (_code in exceptions) {
                                throw new exceptions[_code](feedback);
                            } else {
                                throw new ExchangeError(feedback);
                            }
                        }
                        throw new ExchangeError(this.id + ': "error" in response: ' + body);
                    }
                    if (!('result' in response)) throw new ExchangeError(this.id + ' ' + body);
                }
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context17.sent;

                                if (!(method === 'GET')) {
                                    _context17.next = 7;
                                    break;
                                }

                                return _context17.abrupt('return', response);

                            case 7:
                                return _context17.abrupt('return', response['result'][0]);

                            case 8:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function request(_x63) {
                return _ref17.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bibox;
}(Exchange);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    InvalidOrder = _require.InvalidOrder,
    DDoSProtection = _require.DDoSProtection,
    InvalidNonce = _require.InvalidNonce,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(binance, _Exchange);

    function binance() {
        _classCallCheck(this, binance);

        return _possibleConstructorReturn(this, (binance.__proto__ || Object.getPrototypeOf(binance)).apply(this, arguments));
    }

    _createClass(binance, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(binance.prototype.__proto__ || Object.getPrototypeOf(binance.prototype), 'describe', this).call(this), {
                'id': 'binance',
                'name': 'Binance',
                'countries': 'JP', // Japan
                'rateLimit': 500,
                // new metainfo interface
                'has': {
                    'fetchDepositAddress': true,
                    'CORS': false,
                    'fetchBidsAsks': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchMyTrades': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'withdraw': true,
                    'fetchFundingFees': true
                },
                'timeframes': {
                    '1m': '1m',
                    '3m': '3m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '2h': '2h',
                    '4h': '4h',
                    '6h': '6h',
                    '8h': '8h',
                    '12h': '12h',
                    '1d': '1d',
                    '3d': '3d',
                    '1w': '1w',
                    '1M': '1M'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/29604020-d5483cdc-87ee-11e7-94c7-d1a8d9169293.jpg',
                    'api': {
                        'web': 'https://www.binance.com',
                        'wapi': 'https://api.binance.com/wapi/v3',
                        'public': 'https://api.binance.com/api/v1',
                        'private': 'https://api.binance.com/api/v3',
                        'v3': 'https://api.binance.com/api/v3',
                        'v1': 'https://api.binance.com/api/v1'
                    },
                    'www': 'https://www.binance.com',
                    'doc': 'https://github.com/binance-exchange/binance-official-api-docs/blob/master/rest-api.md',
                    'fees': ['https://binance.zendesk.com/hc/en-us/articles/115000429332', 'https://support.binance.com/hc/en-us/articles/115000583311']
                },
                'api': {
                    'web': {
                        'get': ['exchange/public/product']
                    },
                    'wapi': {
                        'post': ['withdraw'],
                        'get': ['depositHistory', 'withdrawHistory', 'depositAddress', 'accountStatus', 'systemStatus', 'withdrawFee']
                    },
                    'v3': {
                        'get': ['ticker/price', 'ticker/bookTicker']
                    },
                    'public': {
                        'get': ['exchangeInfo', 'ping', 'time', 'depth', 'aggTrades', 'klines', 'ticker/24hr', 'ticker/allPrices', 'ticker/allBookTickers', 'ticker/price', 'ticker/bookTicker', 'exchangeInfo'],
                        'put': ['userDataStream'],
                        'post': ['userDataStream'],
                        'delete': ['userDataStream']
                    },
                    'private': {
                        'get': ['order', 'openOrders', 'allOrders', 'account', 'myTrades'],
                        'post': ['order', 'order/test'],
                        'delete': ['order']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'taker': 0.001,
                        'maker': 0.001
                    },
                    // should be deleted, these are outdated and inaccurate
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'ADA': 1.0,
                            'ADX': 4.7,
                            'AION': 1.9,
                            'AMB': 11.4,
                            'APPC': 6.5,
                            'ARK': 0.1,
                            'ARN': 3.1,
                            'AST': 10.0,
                            'BAT': 18.0,
                            'BCD': 1.0,
                            'BCH': 0.001,
                            'BCPT': 10.2,
                            'BCX': 1.0,
                            'BNB': 0.7,
                            'BNT': 1.5,
                            'BQX': 1.6,
                            'BRD': 6.4,
                            'BTC': 0.001,
                            'BTG': 0.001,
                            'BTM': 5.0,
                            'BTS': 1.0,
                            'CDT': 67.0,
                            'CMT': 37.0,
                            'CND': 47.0,
                            'CTR': 5.4,
                            'DASH': 0.002,
                            'DGD': 0.06,
                            'DLT': 11.7,
                            'DNT': 51.0,
                            'EDO': 2.5,
                            'ELF': 6.5,
                            'ENG': 2.1,
                            'ENJ': 42.0,
                            'EOS': 1.0,
                            'ETC': 0.01,
                            'ETF': 1.0,
                            'ETH': 0.01,
                            'EVX': 2.5,
                            'FUEL': 45.0,
                            'FUN': 85.0,
                            'GAS': 0,
                            'GTO': 20.0,
                            'GVT': 0.53,
                            'GXS': 0.3,
                            'HCC': 0.0005,
                            'HSR': 0.0001,
                            'ICN': 3.5,
                            'ICX': 1.3,
                            'INS': 1.5,
                            'IOTA': 0.5,
                            'KMD': 0.002,
                            'KNC': 2.6,
                            'LEND': 54.0,
                            'LINK': 12.8,
                            'LLT': 54.0,
                            'LRC': 9.1,
                            'LSK': 0.1,
                            'LTC': 0.01,
                            'LUN': 0.29,
                            'MANA': 74.0,
                            'MCO': 0.86,
                            'MDA': 4.7,
                            'MOD': 2.0,
                            'MTH': 34.0,
                            'MTL': 1.9,
                            'NAV': 0.2,
                            'NEBL': 0.01,
                            'NEO': 0.0,
                            'NULS': 2.1,
                            'OAX': 8.3,
                            'OMG': 0.57,
                            'OST': 17.0,
                            'POE': 88.0,
                            'POWR': 8.6,
                            'PPT': 0.25,
                            'QSP': 21.0,
                            'QTUM': 0.01,
                            'RCN': 35.0,
                            'RDN': 2.2,
                            'REQ': 18.1,
                            'RLC': 4.1,
                            'SALT': 1.3,
                            'SBTC': 1.0,
                            'SNGLS': 42,
                            'SNM': 29.0,
                            'SNT': 32.0,
                            'STORJ': 5.9,
                            'STRAT': 0.1,
                            'SUB': 7.4,
                            'TNB': 82.0,
                            'TNT': 47.0,
                            'TRIG': 6.7,
                            'TRX': 129.0,
                            'USDT': 23.0,
                            'VEN': 1.8,
                            'VIB': 28.0,
                            'VIBE': 7.2,
                            'WABI': 3.5,
                            'WAVES': 0.002,
                            'WINGS': 9.3,
                            'WTC': 0.5,
                            'XLM': 0.01,
                            'XMR': 0.04,
                            'XRP': 0.25,
                            'XVG': 0.1,
                            'XZC': 0.02,
                            'YOYOW': 39.0,
                            'ZEC': 0.005,
                            'ZRX': 5.7
                        },
                        'deposit': {}
                    }
                },
                'commonCurrencies': {
                    'YOYO': 'YOYOW',
                    'BCC': 'BCH',
                    'NANO': 'XRB'
                },
                // exchange-specific options
                'options': {
                    'defaultLimitOrderType': 'limit', // or 'limit_maker'
                    'hasAlreadyAuthenticatedSuccessfully': false,
                    'warnOnFetchOpenOrdersWithoutSymbol': true,
                    'recvWindow': 5 * 1000, // 5 sec, binance default
                    'timeDifference': 0, // the difference between system clock and Binance clock
                    'adjustForTimeDifference': false // controls the adjustment logic upon instantiation
                },
                'exceptions': {
                    '-1000': ExchangeNotAvailable, // {"code":-1000,"msg":"An unknown error occured while processing the request."}
                    '-1013': InvalidOrder, // createOrder -> 'invalid quantity'/'invalid price'/MIN_NOTIONAL
                    '-1021': InvalidNonce, // 'your time is ahead of server'
                    '-1100': InvalidOrder, // createOrder(symbol, 1, asdf) -> 'Illegal characters found in parameter 'price'
                    '-2010': InsufficientFunds, // createOrder -> 'Account has insufficient balance for requested action.'
                    '-2011': OrderNotFound, // cancelOrder(1, 'BTC/USDT') -> 'UNKNOWN_ORDER'
                    '-2013': OrderNotFound, // fetchOrder (1, 'BTC/USDT') -> 'Order does not exist'
                    '-2015': AuthenticationError // "Invalid API-key, IP, or permissions for action."
                }
            });
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds() - this.options['timeDifference'];
        }
    }, {
        key: 'loadTimeDifference',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, after;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTime();

                            case 2:
                                response = _context.sent;
                                after = this.milliseconds();

                                this.options['timeDifference'] = parseInt(after - response['serverTime']);
                                return _context.abrupt('return', this.options['timeDifference']);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadTimeDifference() {
                return _ref.apply(this, arguments);
            }

            return loadTimeDifference;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, markets, result, i, market, id, baseId, quoteId, base, quote, symbol, filters, precision, active, lot, entry, filter, _filter;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetExchangeInfo();

                            case 2:
                                response = _context2.sent;

                                if (!this.options['adjustForTimeDifference']) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return this.loadTimeDifference();

                            case 6:
                                markets = response['symbols'];
                                result = [];
                                i = 0;

                            case 9:
                                if (!(i < markets.length)) {
                                    _context2.next = 31;
                                    break;
                                }

                                market = markets[i];
                                id = market['symbol'];
                                // "123456" is a "test symbol/market"

                                if (!(id === '123456')) {
                                    _context2.next = 14;
                                    break;
                                }

                                return _context2.abrupt('continue', 28);

                            case 14:
                                baseId = market['baseAsset'];
                                quoteId = market['quoteAsset'];
                                base = this.commonCurrencyCode(baseId);
                                quote = this.commonCurrencyCode(quoteId);
                                symbol = base + '/' + quote;
                                filters = this.indexBy(market['filters'], 'filterType');
                                precision = {
                                    'base': market['baseAssetPrecision'],
                                    'quote': market['quotePrecision'],
                                    'amount': market['baseAssetPrecision'],
                                    'price': market['quotePrecision']
                                };
                                active = market['status'] === 'TRADING';
                                // lot size is deprecated as of 2018.02.06

                                lot = -1 * Math.log10(precision['amount']);
                                entry = {
                                    'id': id,
                                    'symbol': symbol,
                                    'base': base,
                                    'quote': quote,
                                    'baseId': baseId,
                                    'quoteId': quoteId,
                                    'info': market,
                                    'lot': lot, // lot size is deprecated as of 2018.02.06
                                    'active': active,
                                    'precision': precision,
                                    'limits': {
                                        'amount': {
                                            'min': Math.pow(10, -precision['amount']),
                                            'max': undefined
                                        },
                                        'price': {
                                            'min': Math.pow(10, -precision['price']),
                                            'max': undefined
                                        },
                                        'cost': {
                                            'min': lot,
                                            'max': undefined
                                        }
                                    }
                                };

                                if ('PRICE_FILTER' in filters) {
                                    filter = filters['PRICE_FILTER'];

                                    entry['precision']['price'] = this.precisionFromString(filter['tickSize']);
                                    entry['limits']['price'] = {
                                        'min': this.safeFloat(filter, 'minPrice'),
                                        'max': this.safeFloat(filter, 'maxPrice')
                                    };
                                }
                                if ('LOT_SIZE' in filters) {
                                    _filter = filters['LOT_SIZE'];

                                    entry['precision']['amount'] = this.precisionFromString(_filter['stepSize']);
                                    entry['lot'] = this.safeFloat(_filter, 'stepSize'); // lot size is deprecated as of 2018.02.06
                                    entry['limits']['amount'] = {
                                        'min': this.safeFloat(_filter, 'minQty'),
                                        'max': this.safeFloat(_filter, 'maxQty')
                                    };
                                }
                                if ('MIN_NOTIONAL' in filters) {
                                    entry['limits']['cost']['min'] = parseFloat(filters['MIN_NOTIONAL']['minNotional']);
                                }
                                result.push(entry);

                            case 28:
                                i++;
                                _context2.next = 9;
                                break;

                            case 31:
                                return _context2.abrupt('return', result);

                            case 32:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var key = 'quote';
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * rate));
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(symbol, cost))
            };
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, i, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.privateGetAccount(params);

                            case 4:
                                response = _context3.sent;
                                result = { 'info': response };
                                balances = response['balances'];

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    currency = balance['asset'];

                                    if (currency in this.currencies_by_id) currency = this.currencies_by_id[currency]['code'];
                                    account = {
                                        'free': parseFloat(balance['free']),
                                        'used': parseFloat(balance['locked']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // default = maximum = 100
                                _context4.next = 7;
                                return this.publicGetDepth(this.extend(request, params));

                            case 7:
                                response = _context4.sent;
                                orderbook = this.parseOrderBook(response);

                                orderbook['nonce'] = this.safeInteger(response, 'lastUpdateId');
                                return _context4.abrupt('return', orderbook);

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeInteger(ticker, 'closeTime');
            var iso8601 = typeof timestamp === 'undefined' ? undefined : this.iso8601(timestamp);
            var symbol = this.findSymbol(this.safeString(ticker, 'symbol'), market);
            var last = this.safeFloat(ticker, 'lastPrice');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': iso8601,
                'high': this.safeFloat(ticker, 'highPrice'),
                'low': this.safeFloat(ticker, 'lowPrice'),
                'bid': this.safeFloat(ticker, 'bidPrice'),
                'bidVolume': this.safeFloat(ticker, 'bidQty'),
                'ask': this.safeFloat(ticker, 'askPrice'),
                'askVolume': this.safeFloat(ticker, 'askQty'),
                'vwap': this.safeFloat(ticker, 'weightedAvgPrice'),
                'open': this.safeFloat(ticker, 'openPrice'),
                'close': last,
                'last': last,
                'previousClose': this.safeFloat(ticker, 'prevClosePrice'), // previous day close
                'change': this.safeFloat(ticker, 'priceChange'),
                'percentage': this.safeFloat(ticker, 'priceChangePercent'),
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': this.safeFloat(ticker, 'quoteVolume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTicker24hr(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(response, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTickers',
        value: function parseTickers(rawTickers) {
            var symbols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var tickers = [];
            for (var i = 0; i < rawTickers.length; i++) {
                tickers.push(this.parseTicker(rawTickers[i]));
            }
            return this.filterByArray(tickers, 'symbol', symbols);
        }
    }, {
        key: 'fetchBidAsks',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rawTickers;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetTickerBookTicker(params);

                            case 4:
                                rawTickers = _context6.sent;
                                return _context6.abrupt('return', this.parseTickers(rawTickers, symbols));

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchBidAsks() {
                return _ref6.apply(this, arguments);
            }

            return fetchBidAsks;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rawTickers;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.publicGetTicker24hr(params);

                            case 4:
                                rawTickers = _context7.sent;
                                return _context7.abrupt('return', this.parseTickers(rawTickers, symbols));

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTickers() {
                return _ref7.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0], parseFloat(ohlcv[1]), parseFloat(ohlcv[2]), parseFloat(ohlcv[3]), parseFloat(ohlcv[4]), parseFloat(ohlcv[5])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'interval': this.timeframes[timeframe]
                                };

                                if (typeof since !== 'undefined') request['startTime'] = since;
                                if (typeof limit !== 'undefined') request['limit'] = limit; // default == max == 500
                                _context8.next = 8;
                                return this.publicGetKlines(this.extend(request, params));

                            case 8:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOHLCV(_x19) {
                return _ref8.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestampField = 'T' in trade ? 'T' : 'time';
            var timestamp = trade[timestampField];
            var priceField = 'p' in trade ? 'p' : 'price';
            var price = parseFloat(trade[priceField]);
            var amountField = 'q' in trade ? 'q' : 'qty';
            var amount = parseFloat(trade[amountField]);
            var idField = 'a' in trade ? 'a' : 'id';
            var id = trade[idField].toString();
            var side = undefined;
            var order = undefined;
            if ('orderId' in trade) order = trade['orderId'].toString();
            if ('m' in trade) {
                side = trade['m'] ? 'sell' : 'buy'; // this is reversed intentionally
            } else {
                side = trade['isBuyer'] ? 'buy' : 'sell'; // this is a true side
            }
            var fee = undefined;
            if ('commission' in trade) {
                fee = {
                    'cost': this.safeFloat(trade, 'commission'),
                    'currency': this.commonCurrencyCode(trade['commissionAsset'])
                };
            }
            var takerOrMaker = undefined;
            if ('isMaker' in trade) takerOrMaker = trade['isMaker'] ? 'maker' : 'taker';
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': id,
                'order': order,
                'type': undefined,
                'takerOrMaker': takerOrMaker,
                'side': side,
                'price': price,
                'cost': price * amount,
                'amount': amount,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof since !== 'undefined') {
                                    request['startTime'] = since;
                                    request['endTime'] = since + 3600000;
                                }
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                // 'fromId': 123,    // ID to get aggregate trades from INCLUSIVE.
                                // 'startTime': 456, // Timestamp in ms to get aggregate trades from INCLUSIVE.
                                // 'endTime': 789,   // Timestamp in ms to get aggregate trades until INCLUSIVE.
                                // 'limit': 500,     // default = maximum = 500
                                _context9.next = 8;
                                return this.publicGetAggTrades(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchTrades(_x25) {
                return _ref9.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'NEW': 'open',
                'PARTIALLY_FILLED': 'open',
                'FILLED': 'closed',
                'CANCELED': 'canceled'
            };
            return status in statuses ? statuses[status] : status.toLowerCase();
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var status = this.safeValue(order, 'status');
            if (typeof status !== 'undefined') status = this.parseOrderStatus(status);
            var symbol = this.findSymbol(this.safeString(order, 'symbol'), market);
            var timestamp = undefined;
            if ('time' in order) timestamp = order['time'];else if ('transactTime' in order) timestamp = order['transactTime'];
            var iso8601 = undefined;
            if (typeof timestamp !== 'undefined') iso8601 = this.iso8601(timestamp);
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'origQty');
            var filled = this.safeFloat(order, 'executedQty', 0.0);
            var remaining = undefined;
            var cost = undefined;
            if (typeof filled !== 'undefined') {
                if (typeof amount !== 'undefined') remaining = Math.max(amount - filled, 0.0);
                if (typeof price !== 'undefined') cost = price * filled;
            }
            var id = this.safeString(order, 'orderId');
            var type = this.safeString(order, 'type');
            if (typeof type !== 'undefined') type = type.toLowerCase();
            var side = this.safeString(order, 'side');
            if (typeof side !== 'undefined') side = side.toLowerCase();
            var result = {
                'info': order,
                'id': id,
                'timestamp': timestamp,
                'datetime': iso8601,
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, test, order, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                // the next 5 lines are added to support for testing orders

                                method = 'privatePostOrder';
                                test = this.safeValue(params, 'test', false);

                                if (test) {
                                    method += 'Test';
                                    params = this.omit(params, 'test');
                                }
                                order = {
                                    'symbol': market['id'],
                                    'quantity': this.amountToString(symbol, amount),
                                    'type': type.toUpperCase(),
                                    'side': side.toUpperCase()
                                };

                                if (type === 'limit') {
                                    order['type'] = this.options['defaultLimitOrderType'].toUpperCase();
                                    order = this.extend(order, {
                                        'price': this.priceToPrecision(symbol, price),
                                        'timeInForce': 'GTC' // 'GTC' = Good To Cancel (default), 'IOC' = Immediate Or Cancel
                                    });
                                } else if (type === 'limit_maker') {
                                    order['price'] = this.priceToPrecision(symbol, price);
                                }
                                _context10.next = 10;
                                return this[method](this.extend(order, params));

                            case 10:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(response));

                            case 12:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x30, _x31, _x32, _x33) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, origClientOrderId, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (symbol) {
                                    _context11.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a symbol param');

                            case 2:
                                _context11.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                origClientOrderId = this.safeValue(params, 'origClientOrderId');
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof origClientOrderId !== 'undefined') request['origClientOrderId'] = origClientOrderId;else request['orderId'] = parseInt(id);
                                _context11.next = 10;
                                return this.privateGetOrder(this.extend(request, params));

                            case 10:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrder(response, market));

                            case 12:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrder(_x36) {
                return _ref11.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (symbol) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol param');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (limit) request['limit'] = limit;
                                _context12.next = 9;
                                return this.privateGetAllOrders(this.extend(request, params));

                            case 9:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, symbols, numSymbols, fetchOpenOrdersRateLimit, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (!(typeof symbol !== 'undefined')) {
                                    _context13.next = 9;
                                    break;
                                }

                                market = this.market(symbol);
                                request['symbol'] = market['id'];
                                _context13.next = 14;
                                break;

                            case 9:
                                if (!this.options['warnOnFetchOpenOrdersWithoutSymbol']) {
                                    _context13.next = 14;
                                    break;
                                }

                                symbols = this.symbols;
                                numSymbols = symbols.length;
                                fetchOpenOrdersRateLimit = parseInt(numSymbols / 2);
                                throw new ExchangeError(this.id + ' fetchOpenOrders WARNING: fetching open orders without specifying a symbol is rate-limited to one call per ' + fetchOpenOrdersRateLimit.toString() + ' seconds. Do not call this method frequently to avoid ban. Set ' + this.id + '.options["warnOnFetchOpenOrdersWithoutSymbol"] = false to suppress this warning message.');

                            case 14:
                                _context13.next = 16;
                                return this.privateGetOpenOrders(this.extend(request, params));

                            case 16:
                                response = _context13.sent;
                                return _context13.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 18:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOpenOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context14.sent;
                                return _context14.abrupt('return', this.filterBy(orders, 'status', 'closed'));

                            case 4:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchClosedOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                if (symbol) {
                                    _context15.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a symbol argument');

                            case 2:
                                _context15.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context15.next = 7;
                                return this.privateDeleteOrder(this.extend({
                                    'symbol': market['id'],
                                    'orderId': parseInt(id)
                                    // 'origClientOrderId': id,
                                }, params));

                            case 7:
                                response = _context15.sent;
                                return _context15.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function cancelOrder(_x51) {
                return _ref15.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                if (symbol) {
                                    _context16.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMyTrades requires a symbol argument');

                            case 2:
                                _context16.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (limit) request['limit'] = limit;
                                _context16.next = 9;
                                return this.privateGetMyTrades(this.extend(request, params));

                            case 9:
                                response = _context16.sent;
                                return _context16.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchMyTrades() {
                return _ref16.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, tag;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context17.next = 5;
                                return this.wapiGetDepositAddress(this.extend({
                                    'asset': currency['id']
                                }, params));

                            case 5:
                                response = _context17.sent;

                                if (!('success' in response)) {
                                    _context17.next = 11;
                                    break;
                                }

                                if (!response['success']) {
                                    _context17.next = 11;
                                    break;
                                }

                                address = this.safeString(response, 'address');
                                tag = this.safeString(response, 'addressTag');
                                return _context17.abrupt('return', {
                                    'currency': code,
                                    'address': this.checkAddress(address),
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 11:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function fetchDepositAddress(_x58) {
                return _ref17.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'fetchFundingFees',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                var codes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var withdrawFees, info, i, code, currency, response;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.loadMarkets();

                            case 2:
                                withdrawFees = {};
                                info = {};

                                if (typeof codes === 'undefined') codes = Object.keys(this.currencies);
                                i = 0;

                            case 6:
                                if (!(i < codes.length)) {
                                    _context18.next = 17;
                                    break;
                                }

                                code = codes[i];
                                currency = this.currency(code);
                                _context18.next = 11;
                                return this.wapiGetWithdrawFee({
                                    'asset': currency['id']
                                });

                            case 11:
                                response = _context18.sent;

                                withdrawFees[code] = this.safeFloat(response, 'withdrawFee');
                                info[code] = response;

                            case 14:
                                i++;
                                _context18.next = 6;
                                break;

                            case 17:
                                return _context18.abrupt('return', {
                                    'withdraw': withdrawFees,
                                    'deposit': {},
                                    'info': info
                                });

                            case 18:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function fetchFundingFees() {
                return _ref18.apply(this, arguments);
            }

            return fetchFundingFees;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, name, request, response;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                this.checkAddress(address);
                                _context19.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                name = address.slice(0, 20);
                                request = {
                                    'asset': currency['id'],
                                    'address': address,
                                    'amount': parseFloat(amount),
                                    'name': name
                                };

                                if (tag) request['addressTag'] = tag;
                                _context19.next = 9;
                                return this.wapiPostWithdraw(this.extend(request, params));

                            case 9:
                                response = _context19.sent;
                                return _context19.abrupt('return', {
                                    'info': response,
                                    'id': this.safeString(response, 'id')
                                });

                            case 11:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function withdraw(_x62, _x63, _x64) {
                return _ref19.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            url += '/' + path;
            if (api === 'wapi') url += '.html';
            // v1 special case for userDataStream
            if (path === 'userDataStream') {
                body = this.urlencode(params);
                headers = {
                    'X-MBX-APIKEY': this.apiKey,
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            } else if (api === 'private' || api === 'wapi') {
                this.checkRequiredCredentials();
                var query = this.urlencode(this.extend({
                    'timestamp': this.nonce(),
                    'recvWindow': this.options['recvWindow']
                }, params));
                var signature = this.hmac(this.encode(query), this.encode(this.secret));
                query += '&' + 'signature=' + signature;
                headers = {
                    'X-MBX-APIKEY': this.apiKey
                };
                if (method === 'GET' || api === 'wapi') {
                    url += '?' + query;
                } else {
                    body = query;
                    headers['Content-Type'] = 'application/x-www-form-urlencoded';
                }
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 418 || code === 429) throw new DDoSProtection(this.id + ' ' + code.toString() + ' ' + reason + ' ' + body);
            // error response in a form: { "code": -1013, "msg": "Invalid quantity." }
            // following block cointains legacy checks against message patterns in "msg" property
            // will switch "code" checks eventually, when we know all of them
            if (code >= 400) {
                if (body.indexOf('Price * QTY is zero or less') >= 0) throw new InvalidOrder(this.id + ' order cost = amount * price is zero or less ' + body);
                if (body.indexOf('LOT_SIZE') >= 0) throw new InvalidOrder(this.id + ' order amount should be evenly divisible by lot size, use this.amountToLots (symbol, amount) ' + body);
                if (body.indexOf('PRICE_FILTER') >= 0) throw new InvalidOrder(this.id + ' order price exceeds allowed price precision or invalid, use this.priceToPrecision (symbol, amount) ' + body);
            }
            if (body.length > 0) {
                if (body[0] === '{') {
                    var response = JSON.parse(body);
                    // check success value for wapi endpoints
                    // response in format {'msg': 'The coin does not exist.', 'success': true/false}
                    var success = this.safeValue(response, 'success', true);
                    if (!success) {
                        if ('msg' in response) try {
                            response = JSON.parse(response['msg']);
                        } catch (e) {
                            response = {};
                        }
                    }
                    // checks against error codes
                    var error = this.safeString(response, 'code');
                    if (typeof error !== 'undefined') {
                        var exceptions = this.exceptions;
                        if (error in exceptions) {
                            // a workaround for {"code":-2015,"msg":"Invalid API-key, IP, or permissions for action."}
                            // despite that their message is very confusing, it is raised by Binance
                            // on a temporary ban (the API key is valid, but disabled for a while)
                            if (error === '-2015' && this.options['hasAlreadyAuthenticatedSuccessfully']) {
                                throw new DDoSProtection(this.id + ' temporary banned: ' + body);
                            }
                            throw new exceptions[error](this.id + ' ' + body);
                        } else {
                            throw new ExchangeError(this.id + ': unknown error code: ' + body + ' ' + error);
                        }
                    }
                    if (!success) {
                        throw new ExchangeError(this.id + ': success value false: ' + body);
                    }
                }
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _context20.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context20.sent;

                                // a workaround for {"code":-2015,"msg":"Invalid API-key, IP, or permissions for action."}
                                if (api === 'private' || api === 'wapi') this.options['hasAlreadyAuthenticatedSuccessfully'] = true;
                                return _context20.abrupt('return', response);

                            case 5:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function request(_x72) {
                return _ref20.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return binance;
}(Exchange);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bit2c, _Exchange);

    function bit2c() {
        _classCallCheck(this, bit2c);

        return _possibleConstructorReturn(this, (bit2c.__proto__ || Object.getPrototypeOf(bit2c)).apply(this, arguments));
    }

    _createClass(bit2c, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bit2c.prototype.__proto__ || Object.getPrototypeOf(bit2c.prototype), 'describe', this).call(this), {
                'id': 'bit2c',
                'name': 'Bit2C',
                'countries': 'IL', // Israel
                'rateLimit': 3000,
                'has': {
                    'CORS': false,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766119-3593220e-5ece-11e7-8b3a-5a041f6bcc3f.jpg',
                    'api': 'https://bit2c.co.il',
                    'www': 'https://www.bit2c.co.il',
                    'doc': ['https://www.bit2c.co.il/home/api', 'https://github.com/OferE/bit2c']
                },
                'api': {
                    'public': {
                        'get': ['Exchanges/{pair}/Ticker', 'Exchanges/{pair}/orderbook', 'Exchanges/{pair}/trades', 'Exchanges/{pair}/lasttrades']
                    },
                    'private': {
                        'post': ['Merchant/CreateCheckout', 'Order/AddCoinFundsRequest', 'Order/AddFund', 'Order/AddOrder', 'Order/AddOrderMarketPriceBuy', 'Order/AddOrderMarketPriceSell', 'Order/CancelOrder', 'Order/AddCoinFundsRequest', 'Order/AddStopOrder', 'Payment/GetMyId', 'Payment/Send', 'Payment/Pay'],
                        'get': ['Account/Balance', 'Account/Balance/v2', 'Order/MyOrders', 'Order/GetById', 'Order/AccountHistory', 'Order/OrderHistory']
                    }
                },
                'markets': {
                    'BTC/NIS': { 'id': 'BtcNis', 'symbol': 'BTC/NIS', 'base': 'BTC', 'quote': 'NIS' },
                    'BCH/NIS': { 'id': 'BchNis', 'symbol': 'BCH/NIS', 'base': 'BCH', 'quote': 'NIS' },
                    'LTC/NIS': { 'id': 'LtcNis', 'symbol': 'LTC/NIS', 'base': 'LTC', 'quote': 'NIS' },
                    'BTG/NIS': { 'id': 'BtgNis', 'symbol': 'BTG/NIS', 'base': 'BTG', 'quote': 'NIS' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.5 / 100,
                        'taker': 0.5 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, result, currencies, i, currency, account, available;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetAccountBalanceV2();

                            case 2:
                                balance = _context.sent;
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    if (currency in balance) {
                                        available = 'AVAILABLE_' + currency;

                                        account['free'] = balance[available];
                                        account['total'] = balance[currency];
                                        account['used'] = account['total'] - account['free'];
                                    }
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetExchangesPairOrderbook(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, averagePrice, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetExchangesPairTicker(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = this.milliseconds();
                                averagePrice = this.safeFloat(ticker, 'av');
                                baseVolume = this.safeFloat(ticker, 'a');
                                quoteVolume = baseVolume * averagePrice;
                                last = this.safeFloat(ticker, 'll');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': this.safeFloat(ticker, 'h'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'l'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': averagePrice,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['date']) * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'id': trade['tid'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': undefined,
                'type': undefined,
                'side': undefined,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetExchangesPairTrades(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, result;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                method = 'privatePostOrderAddOrder';
                                order = {
                                    'Amount': amount,
                                    'Pair': this.marketId(symbol)
                                };

                                if (type === 'market') {
                                    method += 'MarketPrice' + this.capitalize(side);
                                } else {
                                    order['Price'] = price;
                                    order['Total'] = amount * price;
                                    order['IsBid'] = side === 'buy';
                                }
                                _context5.next = 5;
                                return this[method](this.extend(order, params));

                            case 5:
                                result = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': result,
                                    'id': result['NewOrder']['id']
                                });

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostOrderCancelOrder({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x18) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            if (api === 'public') {
                url += '.json';
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var query = this.extend({ 'nonce': nonce }, params);
                body = this.urlencode(query);
                var signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha512', 'base64');
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'key': this.apiKey,
                    'sign': this.decode(signature)
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, orders, asks, bids;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(typeof symbol === 'undefined')) {
                                    _context7.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOpenOrders() requires a symbol argument');

                            case 4:
                                market = this.market(symbol);
                                _context7.next = 7;
                                return this.privateGetOrderMyOrders(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 7:
                                response = _context7.sent;
                                orders = this.safeValue(response, market['id'], {});
                                asks = this.safeValue(orders, 'ask');
                                bids = this.safeValue(orders, 'bid');
                                return _context7.abrupt('return', this.parseOrders(this.arrayConcat(asks, bids), market, since, limit));

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOpenOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = order['created'];
            var price = order['price'];
            var amount = order['amount'];
            var cost = price * amount;
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var side = this.safeValue(order, 'type');
            if (side === 0) {
                side = 'buy';
            } else if (side === 1) {
                side = 'sell';
            }
            var id = this.safeString(order, 'id');
            return {
                'id': id,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': this.safeString(order, 'status'),
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'filled': undefined,
                'remaining': undefined,
                'cost': cost,
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }]);

    return bit2c;
}(Exchange);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    InvalidNonce = _require.InvalidNonce,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    PermissionDenied = _require.PermissionDenied;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitbank, _Exchange);

    function bitbank() {
        _classCallCheck(this, bitbank);

        return _possibleConstructorReturn(this, (bitbank.__proto__ || Object.getPrototypeOf(bitbank)).apply(this, arguments));
    }

    _createClass(bitbank, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitbank.prototype.__proto__ || Object.getPrototypeOf(bitbank.prototype), 'describe', this).call(this), {
                'id': 'bitbank',
                'name': 'bitbank',
                'countries': 'JP',
                'version': 'v1',
                'has': {
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'fetchDepositAddress': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '1hour',
                    '4h': '4hour',
                    '8h': '8hour',
                    '12h': '12hour',
                    '1d': '1day',
                    '1w': '1week'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/37808081-b87f2d9c-2e59-11e8-894d-c1900b7584fe.jpg',
                    'api': {
                        'public': 'https://public.bitbank.cc',
                        'private': 'https://api.bitbank.cc'
                    },
                    'www': 'https://bitbank.cc/',
                    'doc': 'https://docs.bitbank.cc/',
                    'fees': 'https://bitbank.cc/docs/fees/'
                },
                'api': {
                    'public': {
                        'get': ['{pair}/ticker', '{pair}/depth', '{pair}/transactions', '{pair}/transactions/{YYYYMMDD}', '{pair}/candlestick/{candle-type}/{YYYYMMDD}']
                    },
                    'private': {
                        'get': ['user/assets', 'user/spot/order', 'user/spot/active_orders', 'user/spot/trade_history', 'user/withdrawal_account'],
                        'post': ['user/spot/order', 'user/spot/cancel_order', 'user/spot/cancel_orders', 'user/spot/orders_info', 'user/request_withdrawal']
                    }
                },
                'markets': {
                    'BCH/BTC': { 'id': 'bcc_btc', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'baseId': 'bcc', 'quoteId': 'btc' },
                    'BCH/JPY': { 'id': 'bcc_jpy', 'symbol': 'BCH/JPY', 'base': 'BCH', 'quote': 'JPY', 'baseId': 'bcc', 'quoteId': 'jpy' },
                    'MONA/BTC': { 'id': 'mona_btc', 'symbol': 'MONA/BTC', 'base': 'MONA', 'quote': 'BTC', 'baseId': 'mona', 'quoteId': 'btc' },
                    'MONA/JPY': { 'id': 'mona_jpy', 'symbol': 'MONA/JPY', 'base': 'MONA', 'quote': 'JPY', 'baseId': 'mona', 'quoteId': 'jpy' },
                    'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'baseId': 'eth', 'quoteId': 'btc' },
                    'LTC/BTC': { 'id': 'ltc_btc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'baseId': 'ltc', 'quoteId': 'btc' },
                    'XRP/JPY': { 'id': 'xrp_jpy', 'symbol': 'XRP/JPY', 'base': 'XRP', 'quote': 'JPY', 'baseId': 'xrp', 'quoteId': 'jpy' },
                    'BTC/JPY': { 'id': 'btc_jpy', 'symbol': 'BTC/JPY', 'base': 'BTC', 'quote': 'JPY', 'baseId': 'btc', 'quoteId': 'jpy' }
                },
                'fees': {
                    'trading': {
                        // only temporarily
                        'maker': 0.0,
                        'taker': 0.0
                    },
                    'funding': {
                        'withdraw': {
                            // 'JPY': amount => amount > 30000 ? 756 : 540,
                            'BTC': 0.001,
                            'LTC': 0.001,
                            'XRP': 0.15,
                            'ETH': 0.0005,
                            'MONA': 0.001,
                            'BCC': 0.001
                        }
                    }
                },
                'precision': {
                    'price': 8,
                    'amount': 8
                },
                'exceptions': {
                    '20001': AuthenticationError,
                    '20002': AuthenticationError,
                    '20003': AuthenticationError,
                    '20005': AuthenticationError,
                    '20004': InvalidNonce,
                    '40020': InvalidOrder,
                    '40021': InvalidOrder,
                    '40025': ExchangeError,
                    '40013': OrderNotFound,
                    '40014': OrderNotFound,
                    '50008': PermissionDenied,
                    '50009': OrderNotFound,
                    '50010': OrderNotFound,
                    '60001': InsufficientFunds
                }
            });
        }
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = ticker['timestamp'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context.next = 5;
                                return this.publicGetPairTicker(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context.sent;
                                return _context.abrupt('return', this.parseTicker(response['data'], market));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchTicker(_x2) {
                return _ref.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetPairDepth(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context2.sent;
                                orderbook = response['data'];
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, orderbook['timestamp']));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['executed_at'];
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.costToPrecision(symbol, price * amount);
            var id = this.safeString(trade, 'transaction_id');
            if (!id) {
                id = this.safeString(trade, 'trade_id');
            }
            var fee = undefined;
            if ('fee_amount_quote' in trade) {
                fee = {
                    'currency': market['quote'],
                    'cost': this.safeFloat(trade, 'fee_amount_quote')
                };
            }
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': id,
                'order': this.safeString(trade, 'order_id'),
                'type': this.safeString(trade, 'type'),
                'side': trade['side'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetPairTransactions(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                trades = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(trades['data']['transactions'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x8) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[5], parseFloat(ohlcv[0]), parseFloat(ohlcv[1]), parseFloat(ohlcv[2]), parseFloat(ohlcv[3]), parseFloat(ohlcv[4])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '5m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, date, response, ohlcv;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                date = this.milliseconds();

                                date = this.ymd(date);
                                date = date.split('-');
                                _context4.next = 8;
                                return this.publicGetPairCandlestickCandleTypeYYYYMMDD(this.extend({
                                    'pair': market['id'],
                                    'candle-type': this.timeframes[timeframe],
                                    'YYYYMMDD': date.join('')
                                }, params));

                            case 8:
                                response = _context4.sent;
                                ohlcv = response['data']['candlestick'][0]['ohlcv'];
                                return _context4.abrupt('return', this.parseOHLCVs(ohlcv, market, timeframe, since, limit));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOHLCV(_x16) {
                return _ref4.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, i, balance, id, code, account;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privateGetUserAssets(params);

                            case 4:
                                response = _context5.sent;
                                result = { 'info': response };
                                balances = response['data']['assets'];

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    id = balance['asset'];
                                    code = id;

                                    if (id in this.currencies_by_id) {
                                        code = this.currencies_by_id[id]['code'];
                                    }
                                    account = {
                                        'free': parseFloat(balance['free_amount']),
                                        'used': parseFloat(balance['locked_amount']),
                                        'total': parseFloat(balance['onhand_amount'])
                                    };

                                    result[code] = account;
                                }
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var marketId = this.safeString(order, 'pair');
            var symbol = undefined;
            if (marketId && !market && marketId in this.marketsById) {
                market = this.marketsById[marketId];
            }
            if (market) symbol = market['symbol'];
            var timestamp = this.safeInteger(order, 'ordered_at') * 1000;
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'start_amount');
            var filled = this.safeFloat(order, 'executed_amount');
            var remaining = this.safeFloat(order, 'remaining_amount');
            var cost = filled * this.safeFloat(order, 'average_price');
            var status = this.safeString(order, 'status');
            // UNFILLED
            // PARTIALLY_FILLED
            // FULLY_FILLED
            // CANCELED_UNFILLED
            // CANCELED_PARTIALLY_FILLED
            if (status === 'FULLY_FILLED') {
                status = 'closed';
            } else if (status === 'CANCELED_UNFILLED' || status === 'CANCELED_PARTIALLY_FILLED') {
                status = 'canceled';
            } else {
                status = 'open';
            }
            return {
                'id': this.safeString(order, 'order_id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['type'],
                'side': order['side'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, response, id, order;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!(typeof price === 'undefined')) {
                                    _context6.next = 5;
                                    break;
                                }

                                throw new InvalidOrder(this.id + ' createOrder requires a price argument for both market and limit orders');

                            case 5:
                                request = {
                                    'pair': market['id'],
                                    'amount': this.amountToString(symbol, amount),
                                    'price': this.priceToPrecision(symbol, price),
                                    'side': side,
                                    'type': type
                                };
                                _context6.next = 8;
                                return this.privatePostUserSpotOrder(this.extend(request, params));

                            case 8:
                                response = _context6.sent;
                                id = response['data']['order_id'];
                                order = this.parseOrder(response['data'], market);

                                this.orders[id] = order;
                                return _context6.abrupt('return', order);

                            case 13:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x23, _x24, _x25, _x26) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.privatePostUserSpotCancelOrder(this.extend({
                                    'order_id': id,
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', response['data']);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x29) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.privateGetUserSpotOrder(this.extend({
                                    'order_id': id,
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrder(response['data']));

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrder(_x32) {
                return _ref8.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, orders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id']
                                };

                                if (limit) request['count'] = limit;
                                if (since) request['since'] = parseInt(since / 1000);
                                _context9.next = 8;
                                return this.privateGetUserSpotActiveOrders(this.extend(request, params));

                            case 8:
                                orders = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(orders['data']['orders'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOpenOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, trades;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                market = undefined;

                                if (!(typeof symbol !== 'undefined')) {
                                    _context10.next = 5;
                                    break;
                                }

                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);

                            case 5:
                                request = {};

                                if (typeof market !== 'undefined') request['pair'] = market['id'];
                                if (typeof limit !== 'undefined') request['count'] = limit;
                                if (typeof since !== 'undefined') request['since'] = parseInt(since / 1000);
                                _context10.next = 11;
                                return this.privateGetUserSpotTradeHistory(this.extend(request, params));

                            case 11:
                                trades = _context10.sent;
                                return _context10.abrupt('return', this.parseTrades(trades['data']['trades'], market, since, limit));

                            case 13:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchMyTrades() {
                return _ref10.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, accounts, address, status;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context11.next = 5;
                                return this.privateGetUserWithdrawalAccount(this.extend({
                                    'asset': currency['id']
                                }, params));

                            case 5:
                                response = _context11.sent;

                                // Not sure about this if there could be more accounts...
                                accounts = response['data']['accounts'];
                                address = this.safeString(accounts[0], 'address');
                                status = address ? 'ok' : 'none';
                                return _context11.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'tag': undefined,
                                    'status': status,
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchDepositAddress(_x43) {
                return _ref11.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if ('uuid' in params) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' uuid is required for withdrawal');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                currency = this.currency(code);
                                _context12.next = 7;
                                return this.privatePostUserRequestWithdrawal(this.extend({
                                    'asset': currency['id'],
                                    'amount': amount
                                }, params));

                            case 7:
                                response = _context12.sent;
                                return _context12.abrupt('return', {
                                    'info': response,
                                    'id': response['data']['txid']
                                });

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function withdraw(_x45, _x46, _x47) {
                return _ref12.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'][api] + '/';
            if (api === 'public') {
                url += this.implodeParams(path, params);
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce;
                url += this.version + '/' + this.implodeParams(path, params);
                if (method === 'POST') {
                    body = this.json(query);
                    auth += body;
                } else {
                    auth += '/' + this.version + '/' + path;
                    if (Object.keys(query).length) {
                        query = this.urlencode(query);
                        url += '?' + query;
                        auth += '?' + query;
                    }
                }
                headers = {
                    'Content-Type': 'application/json',
                    'ACCESS-KEY': this.apiKey,
                    'ACCESS-NONCE': nonce,
                    'ACCESS-SIGNATURE': this.hmac(this.encode(auth), this.encode(this.secret))
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, success, data, errorMessages, errorClasses, code, message, ErrorClass;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;
                                success = this.safeInteger(response, 'success');
                                data = this.safeValue(response, 'data');

                                if (!(!success || !data)) {
                                    _context13.next = 16;
                                    break;
                                }

                                errorMessages = {
                                    '10000': 'URL does not exist',
                                    '10001': 'A system error occurred. Please contact support',
                                    '10002': 'Invalid JSON format. Please check the contents of transmission',
                                    '10003': 'A system error occurred. Please contact support',
                                    '10005': 'A timeout error occurred. Please wait for a while and try again',
                                    '20001': 'API authentication failed',
                                    '20002': 'Illegal API key',
                                    '20003': 'API key does not exist',
                                    '20004': 'API Nonce does not exist',
                                    '20005': 'API signature does not exist',
                                    '20011': 'Two-step verification failed',
                                    '20014': 'SMS authentication failed',
                                    '30001': 'Please specify the order quantity',
                                    '30006': 'Please specify the order ID',
                                    '30007': 'Please specify the order ID array',
                                    '30009': 'Please specify the stock',
                                    '30012': 'Please specify the order price',
                                    '30013': 'Trade Please specify either',
                                    '30015': 'Please specify the order type',
                                    '30016': 'Please specify asset name',
                                    '30019': 'Please specify uuid',
                                    '30039': 'Please specify the amount to be withdrawn',
                                    '40001': 'The order quantity is invalid',
                                    '40006': 'Count value is invalid',
                                    '40007': 'End time is invalid',
                                    '40008': 'end_id Value is invalid',
                                    '40009': 'The from_id value is invalid',
                                    '40013': 'The order ID is invalid',
                                    '40014': 'The order ID array is invalid',
                                    '40015': 'Too many specified orders',
                                    '40017': 'Incorrect issue name',
                                    '40020': 'The order price is invalid',
                                    '40021': 'The trading classification is invalid',
                                    '40022': 'Start date is invalid',
                                    '40024': 'The order type is invalid',
                                    '40025': 'Incorrect asset name',
                                    '40028': 'uuid is invalid',
                                    '40048': 'The amount of withdrawal is illegal',
                                    '50003': 'Currently, this account is in a state where you can not perform the operation you specified. Please contact support',
                                    '50004': 'Currently, this account is temporarily registered. Please try again after registering your account',
                                    '50005': 'Currently, this account is locked. Please contact support',
                                    '50006': 'Currently, this account is locked. Please contact support',
                                    '50008': 'User identification has not been completed',
                                    '50009': 'Your order does not exist',
                                    '50010': 'Can not cancel specified order',
                                    '50011': 'API not found',
                                    '60001': 'The number of possessions is insufficient',
                                    '60002': 'It exceeds the quantity upper limit of the tender buying order',
                                    '60003': 'The specified quantity exceeds the limit',
                                    '60004': 'The specified quantity is below the threshold',
                                    '60005': 'The specified price is above the limit',
                                    '60006': 'The specified price is below the lower limit',
                                    '70001': 'A system error occurred. Please contact support',
                                    '70002': 'A system error occurred. Please contact support',
                                    '70003': 'A system error occurred. Please contact support',
                                    '70004': 'We are unable to accept orders as the transaction is currently suspended',
                                    '70005': 'Order can not be accepted because purchase order is currently suspended',
                                    '70006': 'We can not accept orders because we are currently unsubscribed '
                                };
                                errorClasses = this.exceptions;
                                code = this.safeString(data, 'code');
                                message = this.safeString(errorMessages, code, 'Error');
                                ErrorClass = this.safeValue(errorClasses, code);

                                if (!(typeof ErrorClass !== 'undefined')) {
                                    _context13.next = 15;
                                    break;
                                }

                                throw new ErrorClass(message);

                            case 15:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 16:
                                return _context13.abrupt('return', response);

                            case 17:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x55) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bitbank;
}(Exchange);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    InvalidNonce = _require.InvalidNonce,
    InsufficientFunds = _require.InsufficientFunds,
    AuthenticationError = _require.AuthenticationError,
    InvalidOrder = _require.InvalidOrder,
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitbay, _Exchange);

    function bitbay() {
        _classCallCheck(this, bitbay);

        return _possibleConstructorReturn(this, (bitbay.__proto__ || Object.getPrototypeOf(bitbay)).apply(this, arguments));
    }

    _createClass(bitbay, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitbay.prototype.__proto__ || Object.getPrototypeOf(bitbay.prototype), 'describe', this).call(this), {
                'id': 'bitbay',
                'name': 'BitBay',
                'countries': ['PL', 'EU'], // Poland
                'rateLimit': 1000,
                'has': {
                    'CORS': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766132-978a7bd8-5ece-11e7-9540-bc96d1e9bbb8.jpg',
                    'www': 'https://bitbay.net',
                    'api': {
                        'public': 'https://bitbay.net/API/Public',
                        'private': 'https://bitbay.net/API/Trading/tradingApi.php'
                    },
                    'doc': ['https://bitbay.net/public-api', 'https://bitbay.net/account/tab-api', 'https://github.com/BitBayNet/API'],
                    'fees': 'https://bitbay.net/en/fees'
                },
                'api': {
                    'public': {
                        'get': ['{id}/all', '{id}/market', '{id}/orderbook', '{id}/ticker', '{id}/trades']
                    },
                    'private': {
                        'post': ['info', 'trade', 'cancel', 'orderbook', 'orders', 'transfer', 'withdraw', 'history', 'transactions']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'BTCUSD', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'baseId': 'BTC', 'quoteId': 'USD' },
                    'BTC/EUR': { 'id': 'BTCEUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR', 'baseId': 'BTC', 'quoteId': 'EUR' },
                    'BTC/PLN': { 'id': 'BTCPLN', 'symbol': 'BTC/PLN', 'base': 'BTC', 'quote': 'PLN', 'baseId': 'BTC', 'quoteId': 'PLN' },
                    'LTC/USD': { 'id': 'LTCUSD', 'symbol': 'LTC/USD', 'base': 'LTC', 'quote': 'USD', 'baseId': 'LTC', 'quoteId': 'USD' },
                    'LTC/EUR': { 'id': 'LTCEUR', 'symbol': 'LTC/EUR', 'base': 'LTC', 'quote': 'EUR', 'baseId': 'LTC', 'quoteId': 'EUR' },
                    'LTC/PLN': { 'id': 'LTCPLN', 'symbol': 'LTC/PLN', 'base': 'LTC', 'quote': 'PLN', 'baseId': 'LTC', 'quoteId': 'PLN' },
                    'LTC/BTC': { 'id': 'LTCBTC', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'baseId': 'LTC', 'quoteId': 'BTC' },
                    'ETH/USD': { 'id': 'ETHUSD', 'symbol': 'ETH/USD', 'base': 'ETH', 'quote': 'USD', 'baseId': 'ETH', 'quoteId': 'USD' },
                    'ETH/EUR': { 'id': 'ETHEUR', 'symbol': 'ETH/EUR', 'base': 'ETH', 'quote': 'EUR', 'baseId': 'ETH', 'quoteId': 'EUR' },
                    'ETH/PLN': { 'id': 'ETHPLN', 'symbol': 'ETH/PLN', 'base': 'ETH', 'quote': 'PLN', 'baseId': 'ETH', 'quoteId': 'PLN' },
                    'ETH/BTC': { 'id': 'ETHBTC', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'baseId': 'ETH', 'quoteId': 'BTC' },
                    'LSK/USD': { 'id': 'LSKUSD', 'symbol': 'LSK/USD', 'base': 'LSK', 'quote': 'USD', 'baseId': 'LSK', 'quoteId': 'USD' },
                    'LSK/EUR': { 'id': 'LSKEUR', 'symbol': 'LSK/EUR', 'base': 'LSK', 'quote': 'EUR', 'baseId': 'LSK', 'quoteId': 'EUR' },
                    'LSK/PLN': { 'id': 'LSKPLN', 'symbol': 'LSK/PLN', 'base': 'LSK', 'quote': 'PLN', 'baseId': 'LSK', 'quoteId': 'PLN' },
                    'LSK/BTC': { 'id': 'LSKBTC', 'symbol': 'LSK/BTC', 'base': 'LSK', 'quote': 'BTC', 'baseId': 'LSK', 'quoteId': 'BTC' },
                    'BCH/USD': { 'id': 'BCCUSD', 'symbol': 'BCH/USD', 'base': 'BCH', 'quote': 'USD', 'baseId': 'BCC', 'quoteId': 'USD' },
                    'BCH/EUR': { 'id': 'BCCEUR', 'symbol': 'BCH/EUR', 'base': 'BCH', 'quote': 'EUR', 'baseId': 'BCC', 'quoteId': 'EUR' },
                    'BCH/PLN': { 'id': 'BCCPLN', 'symbol': 'BCH/PLN', 'base': 'BCH', 'quote': 'PLN', 'baseId': 'BCC', 'quoteId': 'PLN' },
                    'BCH/BTC': { 'id': 'BCCBTC', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'baseId': 'BCC', 'quoteId': 'BTC' },
                    'BTG/USD': { 'id': 'BTGUSD', 'symbol': 'BTG/USD', 'base': 'BTG', 'quote': 'USD', 'baseId': 'BTG', 'quoteId': 'USD' },
                    'BTG/EUR': { 'id': 'BTGEUR', 'symbol': 'BTG/EUR', 'base': 'BTG', 'quote': 'EUR', 'baseId': 'BTG', 'quoteId': 'EUR' },
                    'BTG/PLN': { 'id': 'BTGPLN', 'symbol': 'BTG/PLN', 'base': 'BTG', 'quote': 'PLN', 'baseId': 'BTG', 'quoteId': 'PLN' },
                    'BTG/BTC': { 'id': 'BTGBTC', 'symbol': 'BTG/BTC', 'base': 'BTG', 'quote': 'BTC', 'baseId': 'BTG', 'quoteId': 'BTC' },
                    'DASH/USD': { 'id': 'DASHUSD', 'symbol': 'DASH/USD', 'base': 'DASH', 'quote': 'USD', 'baseId': 'DASH', 'quoteId': 'USD' },
                    'DASH/EUR': { 'id': 'DASHEUR', 'symbol': 'DASH/EUR', 'base': 'DASH', 'quote': 'EUR', 'baseId': 'DASH', 'quoteId': 'EUR' },
                    'DASH/PLN': { 'id': 'DASHPLN', 'symbol': 'DASH/PLN', 'base': 'DASH', 'quote': 'PLN', 'baseId': 'DASH', 'quoteId': 'PLN' },
                    'DASH/BTC': { 'id': 'DASHBTC', 'symbol': 'DASH/BTC', 'base': 'DASH', 'quote': 'BTC', 'baseId': 'DASH', 'quoteId': 'BTC' },
                    'GAME/USD': { 'id': 'GAMEUSD', 'symbol': 'GAME/USD', 'base': 'GAME', 'quote': 'USD', 'baseId': 'GAME', 'quoteId': 'USD' },
                    'GAME/EUR': { 'id': 'GAMEEUR', 'symbol': 'GAME/EUR', 'base': 'GAME', 'quote': 'EUR', 'baseId': 'GAME', 'quoteId': 'EUR' },
                    'GAME/PLN': { 'id': 'GAMEPLN', 'symbol': 'GAME/PLN', 'base': 'GAME', 'quote': 'PLN', 'baseId': 'GAME', 'quoteId': 'PLN' },
                    'GAME/BTC': { 'id': 'GAMEBTC', 'symbol': 'GAME/BTC', 'base': 'GAME', 'quote': 'BTC', 'baseId': 'GAME', 'quoteId': 'BTC' },
                    'XRP/USD': { 'id': 'XRPUSD', 'symbol': 'XRP/USD', 'base': 'XRP', 'quote': 'USD', 'baseId': 'XRP', 'quoteId': 'USD' },
                    'XRP/EUR': { 'id': 'XRPEUR', 'symbol': 'XRP/EUR', 'base': 'XRP', 'quote': 'EUR', 'baseId': 'XRP', 'quoteId': 'EUR' },
                    'XRP/PLN': { 'id': 'XRPPLN', 'symbol': 'XRP/PLN', 'base': 'XRP', 'quote': 'PLN', 'baseId': 'XRP', 'quoteId': 'PLN' },
                    'XRP/BTC': { 'id': 'XRPBTC', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC', 'baseId': 'XRP', 'quoteId': 'BTC' },
                    // 'XIN/USD': { 'id': 'XINUSD', 'symbol': 'XIN/USD', 'base': 'XIN', 'quote': 'USD', 'baseId': 'XIN', 'quoteId': 'USD' },
                    // 'XIN/EUR': { 'id': 'XINEUR', 'symbol': 'XIN/EUR', 'base': 'XIN', 'quote': 'EUR', 'baseId': 'XIN', 'quoteId': 'EUR' },
                    // 'XIN/PLN': { 'id': 'XINPLN', 'symbol': 'XIN/PLN', 'base': 'XIN', 'quote': 'PLN', 'baseId': 'XIN', 'quoteId': 'PLN' },
                    'XIN/BTC': { 'id': 'XINBTC', 'symbol': 'XIN/BTC', 'base': 'XIN', 'quote': 'BTC', 'baseId': 'XIN', 'quoteId': 'BTC' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.3 / 100,
                        'taker': 0.0043
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.0009,
                            'LTC': 0.005,
                            'ETH': 0.00126,
                            'LSK': 0.2,
                            'BCH': 0.0006,
                            'GAME': 0.005,
                            'DASH': 0.001,
                            'BTG': 0.0008,
                            'PLN': 4,
                            'EUR': 1.5
                        }
                    }
                },
                'exceptions': {
                    '400': ExchangeError, // At least one parameter wasn't set
                    '401': InvalidOrder, // Invalid order type
                    '402': InvalidOrder, // No orders with specified currencies
                    '403': InvalidOrder, // Invalid payment currency name
                    '404': InvalidOrder, // Error. Wrong transaction type
                    '405': InvalidOrder, // Order with this id doesn't exist
                    '406': InsufficientFunds, // No enough money or crypto
                    // code 407 not specified are not specified in their docs
                    '408': InvalidOrder, // Invalid currency name
                    '501': AuthenticationError, // Invalid public key
                    '502': AuthenticationError, // Invalid sign
                    '503': InvalidNonce, // Invalid moment parameter. Request time doesn't match current server time
                    '504': ExchangeError, // Invalid method
                    '505': AuthenticationError, // Key has no permission for this action
                    '506': AuthenticationError, // Account locked. Please contact with customer service
                    // codes 507 and 508 are not specified in their docs
                    '509': ExchangeError, // The BIC/SWIFT is required for this currency
                    '510': ExchangeError // Invalid market name
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, result, codes, i, code, currency, id, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostInfo();

                            case 2:
                                response = _context.sent;

                                if (!('balances' in response)) {
                                    _context.next = 9;
                                    break;
                                }

                                balance = response['balances'];
                                result = { 'info': balance };
                                codes = Object.keys(this.currencies);

                                for (i = 0; i < codes.length; i++) {
                                    code = codes[i];
                                    currency = this.currencies[code];
                                    id = currency['id'];
                                    account = this.account();

                                    if (id in balance) {
                                        account['free'] = parseFloat(balance[id]['available']);
                                        account['used'] = parseFloat(balance[id]['locked']);
                                        account['total'] = this.sum(account['free'], account['used']);
                                    }
                                    result[code] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 9:
                                throw new ExchangeError(this.id + ' empty balance response ' + this.json(response));

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetIdOrderbook(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, baseVolume, vwap, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetIdTicker(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = this.milliseconds();
                                baseVolume = this.safeFloat(ticker, 'volume');
                                vwap = this.safeFloat(ticker, 'vwap');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'max'),
                                    'low': this.safeFloat(ticker, 'min'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': this.safeFloat(ticker, 'average'),
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'id': trade['tid'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetIdTrades(this.extend({
                                    'id': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                market = this.market(symbol);
                                return _context5.abrupt('return', this.privatePostTrade(this.extend({
                                    'type': side,
                                    'currency': market['baseId'],
                                    'amount': amount,
                                    'payment_currency': market['quoteId'],
                                    'rate': price
                                }, params)));

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancel({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'isFiat',
        value: function isFiat(currency) {
            var fiatCurrencies = {
                'USD': true,
                'EUR': true,
                'PLN': true
            };
            if (currency in fiatCurrencies) return true;
            return false;
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var method, currency, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                this.checkAddress(address);
                                _context7.next = 3;
                                return this.loadMarkets();

                            case 3:
                                method = undefined;
                                currency = this.currency(code);
                                request = {
                                    'currency': currency['id'],
                                    'quantity': amount
                                };

                                if (this.isFiat(code)) {
                                    method = 'privatePostWithdraw';
                                    // request['account'] = params['account']; // they demand an account number
                                    // request['express'] = params['express']; // whatever it means, they don't explain
                                    // request['bic'] = '';
                                } else {
                                    method = 'privatePostTransfer';
                                    if (typeof tag !== 'undefined') address += '?dt=' + tag.toString();
                                    request['address'] = address;
                                }
                                _context7.next = 9;
                                return this[method](this.extend(request, params));

                            case 9:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function withdraw(_x20, _x21, _x22) {
                return _ref7.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api === 'public') {
                var query = this.omit(params, this.extractParams(path));
                url += '/' + this.implodeParams(path, params) + '.json';
                url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.extend({
                    'method': path,
                    'moment': this.nonce()
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'API-Key': this.apiKey,
                    'API-Hash': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return;
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('code' in response) {
                    //
                    // bitbay returns the integer 'success': 1 key from their private API
                    // or an integer 'code' value from 0 to 510 and an error message
                    //
                    //      { 'success': 1, ... }
                    //      { 'code': 502, 'message': 'Invalid sign' }
                    //      { 'code': 0, 'message': 'offer funds not exceeding minimums' }
                    //
                    //      400 At least one parameter wasn't set
                    //      401 Invalid order type
                    //      402 No orders with specified currencies
                    //      403 Invalid payment currency name
                    //      404 Error. Wrong transaction type
                    //      405 Order with this id doesn't exist
                    //      406 No enough money or crypto
                    //      408 Invalid currency name
                    //      501 Invalid public key
                    //      502 Invalid sign
                    //      503 Invalid moment parameter. Request time doesn't match current server time
                    //      504 Invalid method
                    //      505 Key has no permission for this action
                    //      506 Account locked. Please contact with customer service
                    //      509 The BIC/SWIFT is required for this currency
                    //      510 Invalid market name
                    //
                    var code = response['code']; // always an integer
                    var feedback = this.id + ' ' + this.json(response);
                    var exceptions = this.exceptions;
                    if (code in this.exceptions) {
                        throw new exceptions[code](feedback);
                    } else {
                        throw new ExchangeError(feedback);
                    }
                }
            }
        }
    }]);

    return bitbay;
}(Exchange);

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bitfinex = __webpack_require__(18);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported,
    InsufficientFunds = _require.InsufficientFunds;

// ---------------------------------------------------------------------------

module.exports = function (_bitfinex) {
    _inherits(bitfinex2, _bitfinex);

    function bitfinex2() {
        _classCallCheck(this, bitfinex2);

        return _possibleConstructorReturn(this, (bitfinex2.__proto__ || Object.getPrototypeOf(bitfinex2)).apply(this, arguments));
    }

    _createClass(bitfinex2, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitfinex2.prototype.__proto__ || Object.getPrototypeOf(bitfinex2.prototype), 'describe', this).call(this), {
                'id': 'bitfinex2',
                'name': 'Bitfinex v2',
                'countries': 'VG',
                'version': 'v2',
                // new metainfo interface
                'has': {
                    'CORS': true,
                    'createLimitOrder': false,
                    'createMarketOrder': false,
                    'createOrder': false,
                    'deposit': false,
                    'editOrder': false,
                    'fetchDepositAddress': false,
                    'fetchClosedOrders': false,
                    'fetchFundingFees': false,
                    'fetchMyTrades': false,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': false,
                    'fetchOrder': true,
                    'fetchTickers': true,
                    'fetchTradingFees': false,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '3h': '3h',
                    '6h': '6h',
                    '12h': '12h',
                    '1d': '1D',
                    '1w': '7D',
                    '2w': '14D',
                    '1M': '1M'
                },
                'rateLimit': 1500,
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766244-e328a50c-5ed2-11e7-947b-041416579bb3.jpg',
                    'api': 'https://api.bitfinex.com',
                    'www': 'https://www.bitfinex.com',
                    'doc': ['https://bitfinex.readme.io/v2/docs', 'https://github.com/bitfinexcom/bitfinex-api-node'],
                    'fees': 'https://www.bitfinex.com/fees'
                },
                'api': {
                    'v1': {
                        'get': ['symbols', 'symbols_details']
                    },
                    'public': {
                        'get': ['platform/status', 'tickers', 'ticker/{symbol}', 'trades/{symbol}/hist', 'book/{symbol}/{precision}', 'book/{symbol}/P0', 'book/{symbol}/P1', 'book/{symbol}/P2', 'book/{symbol}/P3', 'book/{symbol}/R0', 'stats1/{key}:{size}:{symbol}/{side}/{section}', 'stats1/{key}:{size}:{symbol}/long/last', 'stats1/{key}:{size}:{symbol}/long/hist', 'stats1/{key}:{size}:{symbol}/short/last', 'stats1/{key}:{size}:{symbol}/short/hist', 'candles/trade:{timeframe}:{symbol}/{section}', 'candles/trade:{timeframe}:{symbol}/last', 'candles/trade:{timeframe}:{symbol}/hist'],
                        'post': ['calc/trade/avg']
                    },
                    'private': {
                        'post': ['auth/r/wallets', 'auth/r/orders/{symbol}', 'auth/r/orders/{symbol}/new', 'auth/r/orders/{symbol}/hist', 'auth/r/order/{symbol}:{id}/trades', 'auth/r/trades/{symbol}/hist', 'auth/r/positions', 'auth/r/funding/offers/{symbol}', 'auth/r/funding/offers/{symbol}/hist', 'auth/r/funding/loans/{symbol}', 'auth/r/funding/loans/{symbol}/hist', 'auth/r/funding/credits/{symbol}', 'auth/r/funding/credits/{symbol}/hist', 'auth/r/funding/trades/{symbol}/hist', 'auth/r/info/margin/{key}', 'auth/r/info/funding/{key}', 'auth/r/movements/{currency}/hist', 'auth/r/stats/perf:{timeframe}/hist', 'auth/r/alerts', 'auth/w/alert/set', 'auth/w/alert/{type}:{symbol}:{price}/del', 'auth/calc/order/avail', 'auth/r/ledgers/{symbol}/hist']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.0005,
                            'BCH': 0.0005,
                            'ETH': 0.01,
                            'EOS': 0.1,
                            'LTC': 0.001,
                            'OMG': 0.1,
                            'IOT': 0.0,
                            'NEO': 0.0,
                            'ETC': 0.01,
                            'XRP': 0.02,
                            'ETP': 0.01,
                            'ZEC': 0.001,
                            'BTG': 0.0,
                            'DASH': 0.01,
                            'XMR': 0.04,
                            'QTM': 0.01,
                            'EDO': 0.5,
                            'DAT': 1.0,
                            'AVT': 0.5,
                            'SAN': 0.1,
                            'USDT': 5.0,
                            'SPK': 9.2784,
                            'BAT': 9.0883,
                            'GNT': 8.2881,
                            'SNT': 14.303,
                            'QASH': 3.2428,
                            'YYW': 18.055
                        }
                    }
                }
            });
        }
    }, {
        key: 'isFiat',
        value: function isFiat(code) {
            var fiat = {
                'USD': 'USD',
                'EUR': 'EUR'
            };
            return code in fiat;
        }
    }, {
        key: 'getCurrencyId',
        value: function getCurrencyId(code) {
            return 'f' + code;
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, baseId, quoteId, base, quote, symbol, precision, limits;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.v1GetSymbolsDetails();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['pair'].toUpperCase();
                                    baseId = id.slice(0, 3);
                                    quoteId = id.slice(3, 6);
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;

                                    id = 't' + id;
                                    baseId = this.getCurrencyId(baseId);
                                    quoteId = this.getCurrencyId(quoteId);
                                    precision = {
                                        'price': market['price_precision'],
                                        'amount': market['price_precision']
                                    };
                                    limits = {
                                        'amount': {
                                            'min': this.safeFloat(market, 'minimum_order_size'),
                                            'max': this.safeFloat(market, 'maximum_order_size')
                                        },
                                        'price': {
                                            'min': Math.pow(10, -precision['price']),
                                            'max': Math.pow(10, precision['price'])
                                        }
                                    };

                                    limits['cost'] = {
                                        'min': limits['amount']['min'] * limits['price']['min'],
                                        'max': undefined
                                    };
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'precision': precision,
                                        'limits': limits,
                                        'lot': Math.pow(10, -precision['amount']),
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balanceType, result, b, balance, accountType, currency, total, available, code, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostAuthRWallets();

                            case 4:
                                response = _context2.sent;
                                balanceType = this.safeString(params, 'type', 'exchange');
                                result = { 'info': response };

                                for (b = 0; b < response.length; b++) {
                                    balance = response[b];
                                    accountType = balance[0];
                                    currency = balance[1];
                                    total = balance[2];
                                    available = balance[4];

                                    if (accountType === balanceType) {
                                        code = currency;

                                        if (currency in this.currencies_by_id) {
                                            code = this.currencies_by_id[currency]['code'];
                                        } else if (currency[0] === 't') {
                                            currency = currency.slice(1);
                                            code = currency.toUpperCase();
                                            code = this.commonCurrencyCode(code);
                                        }
                                        account = this.account();

                                        account['total'] = total;
                                        if (!available) {
                                            if (available === 0) {
                                                account['free'] = 0;
                                                account['used'] = total;
                                            } else {
                                                account['free'] = undefined;
                                            }
                                        } else {
                                            account['free'] = available;
                                            account['used'] = account['total'] - account['free'];
                                        }
                                        result[code] = account;
                                    }
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp, result, i, order, price, amount, side;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetBookSymbolPrecision(this.extend({
                                    'symbol': this.marketId(symbol),
                                    'precision': 'R0'
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                timestamp = this.milliseconds();
                                result = {
                                    'bids': [],
                                    'asks': [],
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'nonce': undefined
                                };

                                for (i = 0; i < orderbook.length; i++) {
                                    order = orderbook[i];
                                    price = order[1];
                                    amount = order[2];
                                    side = amount > 0 ? 'bids' : 'asks';

                                    amount = Math.abs(amount);
                                    result[side].push([price, amount]);
                                }
                                result['bids'] = this.sortBy(result['bids'], 0, true);
                                result['asks'] = this.sortBy(result['asks'], 0);
                                return _context3.abrupt('return', result);

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var length = ticker.length;
            var last = ticker[length - 4];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': ticker[length - 2],
                'low': ticker[length - 1],
                'bid': ticker[length - 10],
                'bidVolume': undefined,
                'ask': ticker[length - 8],
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': ticker[length - 6],
                'percentage': ticker[length - 5],
                'average': undefined,
                'baseVolume': ticker[length - 3],
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, i, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickers(this.extend({
                                    'symbols': this.ids.join(',')
                                }, params));

                            case 4:
                                tickers = _context4.sent;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    id = ticker[0];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.markets[symbol];
                                _context5.next = 5;
                                return this.publicGetTickerSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var _trade = _slicedToArray(trade, 4),
                id = _trade[0],
                timestamp = _trade[1],
                amount = _trade[2],
                price = _trade[3];

            var side = amount < 0 ? 'sell' : 'buy';
            if (amount < 0) {
                amount = -amount;
            }
            return {
                'id': id.toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 120;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'sort': '-1',
                                    'limit': limit // default = max = 120
                                };

                                if (typeof since !== 'undefined') request['start'] = since;
                                _context6.next = 7;
                                return this.publicGetTradesSymbolHist(this.extend(request, params));

                            case 7:
                                response = _context6.sent;
                                trades = this.sortBy(response, 1);
                                return _context6.abrupt('return', this.parseTrades(trades, market, undefined, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (typeof since === 'undefined') since = this.milliseconds() - this.parseTimeframe(timeframe) * limit * 1000;
                                request = {
                                    'symbol': market['id'],
                                    'timeframe': this.timeframes[timeframe],
                                    'sort': 1,
                                    'limit': limit,
                                    'start': since
                                };
                                _context7.next = 7;
                                return this.publicGetCandlesTradeTimeframeSymbolHist(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x14) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                throw new NotSupported(this.id + ' createOrder not implemented yet');

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x19, _x20, _x21, _x22) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function cancelOrder(id) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            throw new NotSupported(this.id + ' cancelOrder not implemented yet');
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                throw new NotSupported(this.id + ' fetchOrder not implemented yet');

                            case 1:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                throw new NotSupported(this.id + ' fetchDepositAddress() not implemented yet.');

                            case 1:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchDepositAddress(_x30) {
                return _ref10.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                throw new NotSupported(this.id + ' withdraw not implemented yet');

                            case 1:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function withdraw(_x32, _x33, _x34) {
                return _ref11.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'limit': limit,
                                    'end': this.seconds()
                                };

                                if (typeof since !== 'undefined') request['start'] = parseInt(since / 1000);
                                _context12.next = 7;
                                return this.privatePostAuthRTradesSymbolHist(this.extend(request, params));

                            case 7:
                                response = _context12.sent;
                                return _context12.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchMyTrades() {
                return _ref12.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'v1') request = api + request;else request = this.version + request;
            var url = this.urls['api'] + '/' + request;
            if (api === 'public') {
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            }
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                body = this.json(query);
                var auth = '/api' + '/' + request + nonce + body;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha384');
                headers = {
                    'bfx-nonce': nonce,
                    'bfx-apikey': this.apiKey,
                    'bfx-signature': signature,
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;

                                if (!response) {
                                    _context13.next = 11;
                                    break;
                                }

                                if (!('message' in response)) {
                                    _context13.next = 8;
                                    break;
                                }

                                if (!(response['message'].indexOf('not enough exchange balance') >= 0)) {
                                    _context13.next = 7;
                                    break;
                                }

                                throw new InsufficientFunds(this.id + ' ' + this.json(response));

                            case 7:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                                return _context13.abrupt('return', response);

                            case 11:
                                if (!(response === '')) {
                                    _context13.next = 13;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' returned empty response');

                            case 13:
                                return _context13.abrupt('return', response);

                            case 14:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x46) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bitfinex2;
}(bitfinex);

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    OrderNotFound = _require.OrderNotFound;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitflyer, _Exchange);

    function bitflyer() {
        _classCallCheck(this, bitflyer);

        return _possibleConstructorReturn(this, (bitflyer.__proto__ || Object.getPrototypeOf(bitflyer)).apply(this, arguments));
    }

    _createClass(bitflyer, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitflyer.prototype.__proto__ || Object.getPrototypeOf(bitflyer.prototype), 'describe', this).call(this), {
                'id': 'bitflyer',
                'name': 'bitFlyer',
                'countries': 'JP',
                'version': 'v1',
                'rateLimit': 1000, // their nonce-timestamp is in seconds...
                'has': {
                    'CORS': false,
                    'withdraw': true,
                    'fetchMyTrades': true,
                    'fetchOrders': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': 'emulated',
                    'fetchClosedOrders': 'emulated'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28051642-56154182-660e-11e7-9b0d-6042d1e6edd8.jpg',
                    'api': 'https://api.bitflyer.jp',
                    'www': 'https://bitflyer.jp',
                    'doc': 'https://bitflyer.jp/API'
                },
                'api': {
                    'public': {
                        'get': ['getmarkets/usa', // new (wip)
                        'getmarkets/eu', // new (wip)
                        'getmarkets', // or 'markets'
                        'getboard', // ...
                        'getticker', 'getexecutions', 'gethealth', 'getboardstate', 'getchats']
                    },
                    'private': {
                        'get': ['getpermissions', 'getbalance', 'getcollateral', 'getcollateralaccounts', 'getaddresses', 'getcoinins', 'getcoinouts', 'getbankaccounts', 'getdeposits', 'getwithdrawals', 'getchildorders', 'getparentorders', 'getparentorder', 'getexecutions', 'getpositions', 'gettradingcommission'],
                        'post': ['sendcoin', 'withdraw', 'sendchildorder', 'cancelchildorder', 'sendparentorder', 'cancelparentorder', 'cancelallchildorders']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.25 / 100,
                        'taker': 0.25 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var jp_markets, us_markets, eu_markets, markets, result, p, market, id, currencies, base, quote, symbol, numCurrencies;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetGetmarkets();

                            case 2:
                                jp_markets = _context.sent;
                                _context.next = 5;
                                return this.publicGetGetmarketsUsa();

                            case 5:
                                us_markets = _context.sent;
                                _context.next = 8;
                                return this.publicGetGetmarketsEu();

                            case 8:
                                eu_markets = _context.sent;
                                markets = this.arrayConcat(jp_markets, us_markets);

                                markets = this.arrayConcat(markets, eu_markets);
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['product_code'];
                                    currencies = id.split('_');
                                    base = undefined;
                                    quote = undefined;
                                    symbol = id;
                                    numCurrencies = currencies.length;

                                    if (numCurrencies === 1) {
                                        base = symbol.slice(0, 3);
                                        quote = symbol.slice(3, 6);
                                    } else if (numCurrencies === 2) {
                                        base = currencies[0];
                                        quote = currencies[1];
                                        symbol = base + '/' + quote;
                                    } else {
                                        base = currencies[1];
                                        quote = currencies[2];
                                    }
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 14:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var response, balances, b, account, currency, result, currencies, i, _currency, _account;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetGetbalance();

                            case 4:
                                response = _context2.sent;
                                balances = {};

                                for (b = 0; b < response.length; b++) {
                                    account = response[b];
                                    currency = account['currency_code'];

                                    balances[currency] = account;
                                }
                                result = { 'info': response };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    _currency = currencies[i];
                                    _account = this.account();

                                    if (_currency in balances) {
                                        _account['total'] = balances[_currency]['amount'];
                                        _account['free'] = balances[_currency]['available'];
                                        _account['used'] = _account['total'] - _account['free'];
                                    }
                                    result[_currency] = _account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetGetboard(this.extend({
                                    'product_code': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'size'));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetGetticker(this.extend({
                                    'product_code': this.marketId(symbol)
                                }, params));

                            case 4:
                                ticker = _context4.sent;
                                timestamp = this.parse8601(ticker['timestamp']);
                                last = this.safeFloat(ticker, 'ltp');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': this.safeFloat(ticker, 'best_bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'best_ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'volume_by_product'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            var order = undefined;
            if ('side' in trade) if (trade['side']) {
                side = trade['side'].toLowerCase();
                var id = side + '_child_order_acceptance_id';
                if (id in trade) order = trade[id];
            }
            if (typeof order === 'undefined') order = this.safeString(trade, 'child_order_acceptance_id');
            var timestamp = this.parse8601(trade['exec_date']);
            return {
                'id': trade['id'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': order,
                'type': undefined,
                'side': side,
                'price': trade['price'],
                'amount': trade['size']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetGetexecutions(this.extend({
                                    'product_code': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, result;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'product_code': this.marketId(symbol),
                                    'child_order_type': type.toUpperCase(),
                                    'side': side.toUpperCase(),
                                    'price': price,
                                    'size': amount
                                };
                                _context6.next = 5;
                                return this.privatePostSendchildorder(this.extend(order, params));

                            case 5:
                                result = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': result,
                                    'id': result['child_order_acceptance_id']
                                });

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder() requires a symbol argument');

                            case 2:
                                _context7.next = 4;
                                return this.loadMarkets();

                            case 4:
                                _context7.next = 6;
                                return this.privatePostCancelchildorder(this.extend({
                                    'product_code': this.marketId(symbol),
                                    'child_order_acceptance_id': id
                                }, params));

                            case 6:
                                return _context7.abrupt('return', _context7.sent);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x18) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'ACTIVE': 'open',
                'COMPLETED': 'closed',
                'CANCELED': 'canceled',
                'EXPIRED': 'canceled',
                'REJECTED': 'canceled'
            };
            if (status in statuses) return statuses[status];
            return status.toLowerCase();
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(order['child_order_date']);
            var amount = this.safeFloat(order, 'size');
            var remaining = this.safeFloat(order, 'outstanding_size');
            var filled = this.safeFloat(order, 'executed_size');
            var price = this.safeFloat(order, 'price');
            var cost = price * filled;
            var status = this.parseOrderStatus(order['child_order_state']);
            var type = order['child_order_type'].toLowerCase();
            var side = order['side'].toLowerCase();
            var symbol = undefined;
            if (typeof market === 'undefined') {
                var marketId = this.safeString(order, 'product_code');
                if (typeof marketId !== 'undefined') {
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                }
            }
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var fee = undefined;
            var feeCost = this.safeFloat(order, 'total_commission');
            if (typeof feeCost !== 'undefined') {
                fee = {
                    'cost': feeCost,
                    'currency': undefined,
                    'rate': undefined
                };
            }
            return {
                'id': order['child_order_acceptance_id'],
                'info': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': fee
            };
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, orders;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders() requires a symbol argument');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'product_code': market['id'],
                                    'count': limit
                                };
                                _context8.next = 8;
                                return this.privateGetGetchildorders(this.extend(request, params));

                            case 8:
                                response = _context8.sent;
                                orders = this.parseOrders(response, market, since, limit);

                                if (symbol) orders = this.filterBy(orders, 'symbol', symbol);
                                return _context8.abrupt('return', orders);

                            case 12:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                params['child_order_state'] = 'ACTIVE';
                                return _context9.abrupt('return', this.fetchOrders(symbol, since, limit, params));

                            case 2:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOpenOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                params['child_order_state'] = 'COMPLETED';
                                return _context10.abrupt('return', this.fetchOrders(symbol, since, limit, params));

                            case 2:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchClosedOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orders, ordersById;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context11.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder() requires a symbol argument');

                            case 2:
                                _context11.next = 4;
                                return this.fetchOrders(symbol);

                            case 4:
                                orders = _context11.sent;
                                ordersById = this.indexBy(orders, 'id');

                                if (!(id in ordersById)) {
                                    _context11.next = 8;
                                    break;
                                }

                                return _context11.abrupt('return', ordersById[id]);

                            case 8:
                                throw new OrderNotFound(this.id + ' No order found with id ' + id);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrder(_x34) {
                return _ref11.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMyTrades requires a symbol argument');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'product_code': market['id']
                                };

                                if (limit) request['count'] = limit;
                                _context12.next = 9;
                                return this.privateGetGetexecutions(this.extend(request, params));

                            case 9:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchMyTrades() {
                return _ref12.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.checkAddress(address);
                                _context13.next = 3;
                                return this.loadMarkets();

                            case 3:
                                if (!(code !== 'JPY' && code !== 'USD' && code !== 'EUR')) {
                                    _context13.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows withdrawing JPY, USD, EUR only, ' + code + ' is not supported');

                            case 5:
                                currency = this.currency(code);
                                _context13.next = 8;
                                return this.privatePostWithdraw(this.extend({
                                    'currency_code': currency['id'],
                                    'amount': amount
                                    // 'bank_account_id': 1234,
                                }, params));

                            case 8:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': response['message_id']
                                });

                            case 10:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function withdraw(_x41, _x42, _x43) {
                return _ref13.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = '/' + this.version + '/';
            if (api === 'private') request += 'me/';
            request += path;
            if (method === 'GET') {
                if (Object.keys(params).length) request += '?' + this.urlencode(params);
            }
            var url = this.urls['api'] + request;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = [nonce, method, request].join('');
                if (Object.keys(params).length) {
                    if (method !== 'GET') {
                        body = this.json(params);
                        auth += body;
                    }
                }
                headers = {
                    'ACCESS-KEY': this.apiKey,
                    'ACCESS-TIMESTAMP': nonce,
                    'ACCESS-SIGN': this.hmac(this.encode(auth), this.encode(this.secret)),
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return bitflyer;
}(Exchange);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bithumb, _Exchange);

    function bithumb() {
        _classCallCheck(this, bithumb);

        return _possibleConstructorReturn(this, (bithumb.__proto__ || Object.getPrototypeOf(bithumb)).apply(this, arguments));
    }

    _createClass(bithumb, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bithumb.prototype.__proto__ || Object.getPrototypeOf(bithumb.prototype), 'describe', this).call(this), {
                'id': 'bithumb',
                'name': 'Bithumb',
                'countries': 'KR', // South Korea
                'rateLimit': 500,
                'has': {
                    'CORS': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30597177-ea800172-9d5e-11e7-804c-b9d4fa9b56b0.jpg',
                    'api': {
                        'public': 'https://api.bithumb.com/public',
                        'private': 'https://api.bithumb.com'
                    },
                    'www': 'https://www.bithumb.com',
                    'doc': 'https://www.bithumb.com/u1/US127'
                },
                'api': {
                    'public': {
                        'get': ['ticker/{currency}', 'ticker/all', 'orderbook/{currency}', 'orderbook/all', 'recent_transactions/{currency}', 'recent_transactions/all']
                    },
                    'private': {
                        'post': ['info/account', 'info/balance', 'info/wallet_address', 'info/ticker', 'info/orders', 'info/user_transactions', 'trade/place', 'info/order_detail', 'trade/cancel', 'trade/btc_withdrawal', 'trade/krw_deposit', 'trade/krw_withdrawal', 'trade/market_buy', 'trade/market_sell']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.15 / 100,
                        'taker': 0.15 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, currencies, result, i, id, market, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTickerAll();

                            case 2:
                                markets = _context.sent;
                                currencies = Object.keys(markets['data']);
                                result = [];

                                for (i = 0; i < currencies.length; i++) {
                                    id = currencies[i];

                                    if (id !== 'date') {
                                        market = markets['data'][id];
                                        base = id;
                                        quote = 'KRW';
                                        symbol = id + '/' + quote;

                                        result.push({
                                            'id': id,
                                            'symbol': symbol,
                                            'base': base,
                                            'quote': quote,
                                            'info': market,
                                            'lot': undefined,
                                            'active': true,
                                            'precision': {
                                                'amount': undefined,
                                                'price': undefined
                                            },
                                            'limits': {
                                                'amount': {
                                                    'min': undefined,
                                                    'max': undefined
                                                },
                                                'price': {
                                                    'min': undefined,
                                                    'max': undefined
                                                },
                                                'cost': {
                                                    'min': undefined,
                                                    'max': undefined
                                                }
                                            }
                                        });
                                    }
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, currencies, i, currency, account, lowercase;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostInfoBalance(this.extend({
                                    'currency': 'ALL'
                                }, params));

                            case 4:
                                response = _context2.sent;
                                result = { 'info': response };
                                balances = response['data'];
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();
                                    lowercase = currency.toLowerCase();

                                    account['total'] = this.safeFloat(balances, 'total_' + lowercase);
                                    account['used'] = this.safeFloat(balances, 'in_use_' + lowercase);
                                    account['free'] = this.safeFloat(balances, 'available_' + lowercase);
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'currency': market['base']
                                };

                                if (typeof limit !== 'undefined') request['count'] = limit; // max = 50
                                _context3.next = 7;
                                return this.publicGetOrderbookCurrency(this.extend(request, params));

                            case 7:
                                response = _context3.sent;
                                orderbook = response['data'];
                                timestamp = parseInt(orderbook['timestamp']);
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'quantity'));

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(ticker['date']);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var open = this.safeFloat(ticker, 'opening_price');
            var close = this.safeFloat(ticker, 'closing_price');
            var change = close - open;
            var vwap = this.safeFloat(ticker, 'average_price');
            var baseVolume = this.safeFloat(ticker, 'volume_1day');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'max_price'),
                'low': this.safeFloat(ticker, 'min_price'),
                'bid': this.safeFloat(ticker, 'buy_price'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell_price'),
                'askVolume': undefined,
                'vwap': vwap,
                'open': open,
                'close': close,
                'last': close,
                'previousClose': undefined,
                'change': change,
                'percentage': change / open * 100,
                'average': this.sum(open, close) / 2,
                'baseVolume': baseVolume,
                'quoteVolume': baseVolume * vwap,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, timestamp, tickers, ids, i, id, symbol, market, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickerAll(params);

                            case 4:
                                response = _context4.sent;
                                result = {};
                                timestamp = response['data']['date'];
                                tickers = this.omit(response['data'], 'date');
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    symbol = id;
                                    market = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    }
                                    ticker = tickers[id];

                                    ticker['date'] = timestamp;
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTickerCurrency(this.extend({
                                    'currency': market['base']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(response['data'], market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            // a workaround for their bug in date format, hours are not 0-padded
            var _trade$transaction_da = trade['transaction_date'].split(' '),
                _trade$transaction_da2 = _slicedToArray(_trade$transaction_da, 2),
                transaction_date = _trade$transaction_da2[0],
                transaction_time = _trade$transaction_da2[1];

            if (transaction_time.length < 8) transaction_time = '0' + transaction_time;
            var timestamp = this.parse8601(transaction_date + ' ' + transaction_time);
            timestamp -= 9 * 3600000; // they report UTC + 9 hours (server in Korean timezone)
            var side = trade['type'] === 'ask' ? 'sell' : 'buy';
            return {
                'id': undefined,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': undefined,
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'units_traded')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetRecentTransactionsCurrency(this.extend({
                                    'currency': market['base'],
                                    'count': 100 // max = 100
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, method, response, id;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = undefined;
                                method = 'privatePostTrade';

                                if (type === 'limit') {
                                    request = {
                                        'order_currency': market['id'],
                                        'Payment_currency': market['quote'],
                                        'units': amount,
                                        'price': price,
                                        'type': side === 'buy' ? 'bid' : 'ask'
                                    };
                                    method += 'Place';
                                } else if (type === 'market') {
                                    request = {
                                        'currency': market['id'],
                                        'units': amount
                                    };
                                    method += 'Market' + this.capitalize(side);
                                }
                                _context7.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                response = _context7.sent;
                                id = undefined;

                                if ('order_id' in response) {
                                    if (response['order_id']) id = response['order_id'].toString();
                                }
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var side_in_params, currency, side;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                side_in_params = 'side' in params;

                                if (side_in_params) {
                                    _context8.next = 3;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a side parameter (sell or buy) and a currency parameter');

                            case 3:
                                currency = 'currency' in params;

                                if (currency) {
                                    _context8.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a currency parameter');

                            case 6:
                                side = params['side'] === 'buy' ? 'bid' : 'ask';
                                _context8.next = 9;
                                return this.privatePostTradeCancel({
                                    'order_id': id,
                                    'type': side,
                                    'currency': params['currency']
                                });

                            case 9:
                                return _context8.abrupt('return', _context8.sent);

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x20) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, destination, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                this.checkAddress(address);
                                request = {
                                    'units': amount,
                                    'address': address,
                                    'currency': currency
                                };

                                if (!(currency === 'XRP' || currency === 'XMR')) {
                                    _context9.next = 6;
                                    break;
                                }

                                destination = 'destination' in params;

                                if (destination) {
                                    _context9.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + currency + ' withdraw requires an extra destination param');

                            case 6:
                                _context9.next = 8;
                                return this.privatePostTradeBtcWithdrawal(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function withdraw(_x23, _x24, _x25) {
                return _ref9.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var endpoint = '/' + this.implodeParams(path, params);
            var url = this.urls['api'][api] + endpoint;
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.extend({
                    'endpoint': endpoint
                }, query));
                var nonce = this.nonce().toString();
                var auth = endpoint + '\0' + body + '\0' + nonce;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                var signature64 = this.decode(this.stringToBase64(this.encode(signature)));
                headers = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Api-Key': this.apiKey,
                    'Api-Sign': signature64.toString(),
                    'Api-Nonce': nonce
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('status' in response)) {
                                    _context10.next = 7;
                                    break;
                                }

                                if (!(response['status'] === '0000')) {
                                    _context10.next = 6;
                                    break;
                                }

                                return _context10.abrupt('return', response);

                            case 6:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                                return _context10.abrupt('return', response);

                            case 8:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x33) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bithumb;
}(Exchange);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var zb = __webpack_require__(19);

//  ---------------------------------------------------------------------------

module.exports = function (_zb) {
    _inherits(bitkk, _zb);

    function bitkk() {
        _classCallCheck(this, bitkk);

        return _possibleConstructorReturn(this, (bitkk.__proto__ || Object.getPrototypeOf(bitkk)).apply(this, arguments));
    }

    _createClass(bitkk, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitkk.prototype.__proto__ || Object.getPrototypeOf(bitkk.prototype), 'describe', this).call(this), {
                'id': 'bitkk',
                'name': 'bitkk',
                'comment': 'a Chinese ZB clone',
                'urls': {
                    'api': {
                        'public': 'http://api.bitkk.com/data', // no https for public API
                        'private': 'https://trade.bitkk.com/api'
                    },
                    'www': 'https://www.bitkk.com',
                    'doc': 'https://www.bitkk.com/i/developer',
                    'fees': 'https://www.bitkk.com/i/rate'
                }
            });
        }
    }]);

    return bitkk;
}(zb);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitlish, _Exchange);

    function bitlish() {
        _classCallCheck(this, bitlish);

        return _possibleConstructorReturn(this, (bitlish.__proto__ || Object.getPrototypeOf(bitlish)).apply(this, arguments));
    }

    _createClass(bitlish, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitlish.prototype.__proto__ || Object.getPrototypeOf(bitlish.prototype), 'describe', this).call(this), {
                'id': 'bitlish',
                'name': 'Bitlish',
                'countries': ['GB', 'EU', 'RU'],
                'rateLimit': 1500,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1h': 3600
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766275-dcfc6c30-5ed3-11e7-839d-00a846385d0b.jpg',
                    'api': 'https://bitlish.com/api',
                    'www': 'https://bitlish.com',
                    'doc': 'https://bitlish.com/api'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'taker': 0.3 / 100, // anonymous 0.3%, verified 0.2%
                        'maker': 0
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'LTC': 0.001,
                            'DOGE': 0.001,
                            'ETH': 0.001,
                            'XMR': 0,
                            'ZEC': 0.001,
                            'DASH': 0.0001,
                            'EUR': 50
                        },
                        'deposit': {
                            'BTC': 0,
                            'LTC': 0,
                            'DOGE': 0,
                            'ETH': 0,
                            'XMR': 0,
                            'ZEC': 0,
                            'DASH': 0,
                            'EUR': 0
                        }
                    }
                },
                'api': {
                    'public': {
                        'get': ['instruments', 'ohlcv', 'pairs', 'tickers', 'trades_depth', 'trades_history'],
                        'post': ['instruments', 'ohlcv', 'pairs', 'tickers', 'trades_depth', 'trades_history']
                    },
                    'private': {
                        'post': ['accounts_operations', 'balance', 'cancel_trade', 'cancel_trades_by_ids', 'cancel_all_trades', 'create_bcode', 'create_template_wallet', 'create_trade', 'deposit', 'list_accounts_operations_from_ts', 'list_active_trades', 'list_bcodes', 'list_my_matches_from_ts', 'list_my_trades', 'list_my_trads_from_ts', 'list_payment_methods', 'list_payments', 'redeem_code', 'resign', 'signin', 'signout', 'trade_details', 'trade_options', 'withdraw', 'withdraw_by_id']
                    }
                },
                'commonCurrencies': {
                    'DSH': 'DASH',
                    'XDG': 'DOGE'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, keys, p, market, id, symbol, _symbol$split, _symbol$split2, base, quote;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetPairs();

                            case 2:
                                markets = _context.sent;
                                result = [];
                                keys = Object.keys(markets);

                                for (p = 0; p < keys.length; p++) {
                                    market = markets[keys[p]];
                                    id = market['id'];
                                    symbol = market['name'];
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker, market) {
            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'high': this.safeFloat(ticker, 'max'),
                'low': this.safeFloat(ticker, 'min'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'first'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': this.safeFloat(ticker, 'prc') * 100,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'sum'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                tickers = _context2.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context2.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTickers() {
                return _ref2.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, tickers, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetTickers(params);

                            case 5:
                                tickers = _context3.sent;
                                ticker = tickers[market['id']];
                                return _context3.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1h';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var now, start, interval;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                // let market = this.market (symbol);
                                now = this.seconds();
                                start = now - 86400 * 30; // last 30 days

                                if (typeof since !== 'undefined') start = parseInt(since / 1000);
                                interval = [start.toString(), undefined];
                                _context4.next = 8;
                                return this.publicPostOhlcv(this.extend({
                                    'time_range': interval
                                }, params));

                            case 8:
                                return _context4.abrupt('return', _context4.sent);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOHLCV(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp, last;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetTradesDepth(this.extend({
                                    'pair_id': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context5.sent;
                                timestamp = undefined;
                                last = this.safeInteger(orderbook, 'last');

                                if (last) timestamp = parseInt(last / 1000);
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bid', 'ask', 'price', 'volume'));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = trade['dir'] === 'bid' ? 'buy' : 'sell';
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var timestamp = parseInt(trade['created'] / 1000);
            return {
                'id': undefined,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': undefined,
                'type': undefined,
                'side': side,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTradesHistory(this.extend({
                                    'pair_id': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['list'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x14) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var response, result, currencies, balance, c, currency, account, i, _currency, _account;

                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                response = _context7.sent;
                                result = { 'info': response };
                                currencies = Object.keys(response);
                                balance = {};

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    account = response[currency];

                                    currency = currency.toUpperCase();
                                    // issue #4 bitlish names Dash as DSH, instead of DASH
                                    if (currency === 'DSH') currency = 'DASH';
                                    if (currency === 'XDG') currency = 'DOGE';
                                    balance[currency] = account;
                                }
                                currencies = Object.keys(this.currencies);
                                for (i = 0; i < currencies.length; i++) {
                                    _currency = currencies[i];
                                    _account = this.account();

                                    if (_currency in balance) {
                                        _account['free'] = parseFloat(balance[_currency]['funds']);
                                        _account['used'] = parseFloat(balance[_currency]['holded']);
                                        _account['total'] = this.sum(_account['free'], _account['used']);
                                    }
                                    result[_currency] = _account;
                                }
                                return _context7.abrupt('return', this.parseBalance(result));

                            case 12:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchBalance() {
                return _ref7.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'signIn',
        value: function signIn() {
            return this.privatePostSignin({
                'login': this.login,
                'passwd': this.password
            });
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'pair_id': this.marketId(symbol),
                                    'dir': side === 'buy' ? 'bid' : 'ask',
                                    'amount': amount
                                };

                                if (type === 'limit') order['price'] = price;
                                _context8.next = 6;
                                return this.privatePostCreateTrade(this.extend(order, params));

                            case 6:
                                result = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': result,
                                    'id': result['id']
                                });

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x19, _x20, _x21, _x22) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostCancelTrade({ 'id': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x25) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this.checkAddress(address);
                                _context10.next = 3;
                                return this.loadMarkets();

                            case 3:
                                if (!(currency !== 'BTC')) {
                                    _context10.next = 5;
                                    break;
                                }

                                throw new NotSupported(this.id + ' currently supports BTC withdrawals only, until they document other currencies...');

                            case 5:
                                _context10.next = 7;
                                return this.privatePostWithdraw(this.extend({
                                    'currency': currency.toLowerCase(),
                                    'amount': parseFloat(amount),
                                    'account': address,
                                    'payment_method': 'bitcoin' // they did not document other types...
                                }, params));

                            case 7:
                                response = _context10.sent;
                                return _context10.abrupt('return', {
                                    'info': response,
                                    'id': response['message_id']
                                });

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function withdraw(_x28, _x29, _x30) {
                return _ref10.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                if (method === 'GET') {
                    if (Object.keys(params).length) url += '?' + this.urlencode(params);
                } else {
                    body = this.json(params);
                    headers = { 'Content-Type': 'application/json' };
                }
            } else {
                this.checkRequiredCredentials();
                body = this.json(this.extend({ 'token': this.apiKey }, params));
                headers = { 'Content-Type': 'application/json' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return bitlish;
}(Exchange);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitmarket, _Exchange);

    function bitmarket() {
        _classCallCheck(this, bitmarket);

        return _possibleConstructorReturn(this, (bitmarket.__proto__ || Object.getPrototypeOf(bitmarket)).apply(this, arguments));
    }

    _createClass(bitmarket, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitmarket.prototype.__proto__ || Object.getPrototypeOf(bitmarket.prototype), 'describe', this).call(this), {
                'id': 'bitmarket',
                'name': 'BitMarket',
                'countries': ['PL', 'EU'],
                'rateLimit': 1500,
                'has': {
                    'CORS': false,
                    'fetchOHLCV': true,
                    'withdraw': true
                },
                'timeframes': {
                    '90m': '90m',
                    '6h': '6h',
                    '1d': '1d',
                    '1w': '7d',
                    '1M': '1m',
                    '3M': '3m',
                    '6M': '6m',
                    '1y': '1y'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27767256-a8555200-5ef9-11e7-96fd-469a65e2b0bd.jpg',
                    'api': {
                        'public': 'https://www.bitmarket.net',
                        'private': 'https://www.bitmarket.pl/api2/' // last slash is critical
                    },
                    'www': ['https://www.bitmarket.pl', 'https://www.bitmarket.net'],
                    'doc': ['https://www.bitmarket.net/docs.php?file=api_public.html', 'https://www.bitmarket.net/docs.php?file=api_private.html', 'https://github.com/bitmarket-net/api']
                },
                'api': {
                    'public': {
                        'get': ['json/{market}/ticker', 'json/{market}/orderbook', 'json/{market}/trades', 'json/ctransfer', 'graphs/{market}/90m', 'graphs/{market}/6h', 'graphs/{market}/1d', 'graphs/{market}/7d', 'graphs/{market}/1m', 'graphs/{market}/3m', 'graphs/{market}/6m', 'graphs/{market}/1y']
                    },
                    'private': {
                        'post': ['info', 'trade', 'cancel', 'orders', 'trades', 'history', 'withdrawals', 'tradingdesk', 'tradingdeskStatus', 'tradingdeskConfirm', 'cryptotradingdesk', 'cryptotradingdeskStatus', 'cryptotradingdeskConfirm', 'withdraw', 'withdrawFiat', 'withdrawPLNPP', 'withdrawFiatFast', 'deposit', 'transfer', 'transfers', 'marginList', 'marginOpen', 'marginClose', 'marginCancel', 'marginModify', 'marginBalanceAdd', 'marginBalanceRemove', 'swapList', 'swapOpen', 'swapClose']
                    }
                },
                'markets': {
                    'BCH/PLN': { 'id': 'BCCPLN', 'symbol': 'BCH/PLN', 'base': 'BCH', 'quote': 'PLN' },
                    'BTG/PLN': { 'id': 'BTGPLN', 'symbol': 'BTG/PLN', 'base': 'BTG', 'quote': 'PLN' },
                    'BTC/PLN': { 'id': 'BTCPLN', 'symbol': 'BTC/PLN', 'base': 'BTC', 'quote': 'PLN' },
                    'BTC/EUR': { 'id': 'BTCEUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' },
                    'LTC/PLN': { 'id': 'LTCPLN', 'symbol': 'LTC/PLN', 'base': 'LTC', 'quote': 'PLN' },
                    'LTC/BTC': { 'id': 'LTCBTC', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC' },
                    'LiteMineX/BTC': { 'id': 'LiteMineXBTC', 'symbol': 'LiteMineX/BTC', 'base': 'LiteMineX', 'quote': 'BTC' }
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'taker': 0.45 / 100,
                        'maker': 0.15 / 100,
                        'tiers': {
                            'taker': [[0, 0.45 / 100], [99.99, 0.44 / 100], [299.99, 0.43 / 100], [499.99, 0.42 / 100], [999.99, 0.41 / 100], [1999.99, 0.40 / 100], [2999.99, 0.39 / 100], [4999.99, 0.38 / 100], [9999.99, 0.37 / 100], [19999.99, 0.36 / 100], [29999.99, 0.35 / 100], [49999.99, 0.34 / 100], [99999.99, 0.33 / 100], [199999.99, 0.32 / 100], [299999.99, 0.31 / 100], [499999.99, 0.0 / 100]],
                            'maker': [[0, 0.15 / 100], [99.99, 0.14 / 100], [299.99, 0.13 / 100], [499.99, 0.12 / 100], [999.99, 0.11 / 100], [1999.99, 0.10 / 100], [2999.99, 0.9 / 100], [4999.99, 0.8 / 100], [9999.99, 0.7 / 100], [19999.99, 0.6 / 100], [29999.99, 0.5 / 100], [49999.99, 0.4 / 100], [99999.99, 0.3 / 100], [199999.99, 0.2 / 100], [299999.99, 0.1 / 100], [499999.99, 0.0 / 100]]
                        }
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.0008,
                            'LTC': 0.005,
                            'BCH': 0.0008,
                            'BTG': 0.0008,
                            'DOGE': 1,
                            'EUR': 2,
                            'PLN': 2
                        },
                        'deposit': {
                            'BTC': 0,
                            'LTC': 0,
                            'BCH': 0,
                            'BTG': 0,
                            'DOGE': 25,
                            'EUR': 2, // SEPA. Transfer INT (SHA): 5 EUR
                            'PLN': 0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, data, balance, result, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostInfo();

                            case 4:
                                response = _context.sent;
                                data = response['data'];
                                balance = data['balances'];
                                result = { 'info': data };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    if (currency in balance['available']) account['free'] = balance['available'][currency];
                                    if (currency in balance['blocked']) account['used'] = balance['blocked'][currency];
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetJsonMarketOrderbook(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetJsonMarketTicker(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = this.milliseconds();
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = trade['type'] === 'bid' ? 'buy' : 'sell';
            var timestamp = trade['date'] * 1000;
            return {
                'id': trade['tid'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': undefined,
                'type': undefined,
                'side': side,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetJsonMarketTrades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '90m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv['time'] * 1000, parseFloat(ohlcv['open']), parseFloat(ohlcv['high']), parseFloat(ohlcv['low']), parseFloat(ohlcv['close']), parseFloat(ohlcv['vol'])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '90m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var method, market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'publicGetGraphsMarket' + this.timeframes[timeframe];
                                market = this.market(symbol);
                                _context5.next = 6;
                                return this[method](this.extend({
                                    'market': market['id']
                                }, params));

                            case 6:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x16) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response, result;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostTrade(this.extend({
                                    'market': this.marketId(symbol),
                                    'type': side,
                                    'amount': amount,
                                    'rate': price
                                }, params));

                            case 2:
                                response = _context6.sent;
                                result = {
                                    'info': response
                                };

                                if ('id' in response['order']) result['id'] = response['id'];
                                return _context6.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x21, _x22, _x23, _x24) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.privatePostCancel({ 'id': id });

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x27) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'isFiat',
        value: function isFiat(currency) {
            if (currency === 'EUR') return true;
            if (currency === 'PLN') return true;
            return false;
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var method, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this.checkAddress(address);
                                _context8.next = 3;
                                return this.loadMarkets();

                            case 3:
                                method = undefined;
                                request = {
                                    'currency': currency,
                                    'quantity': amount
                                };

                                if (!this.isFiat(currency)) {
                                    _context8.next = 26;
                                    break;
                                }

                                method = 'privatePostWithdrawFiat';

                                if (!('account' in params)) {
                                    _context8.next = 11;
                                    break;
                                }

                                request['account'] = params['account']; // bank account code for withdrawal
                                _context8.next = 12;
                                break;

                            case 11:
                                throw new ExchangeError(this.id + ' requires account parameter to withdraw fiat currency');

                            case 12:
                                if (!('account2' in params)) {
                                    _context8.next = 16;
                                    break;
                                }

                                request['account2'] = params['account2']; // bank SWIFT code (EUR only)
                                _context8.next = 18;
                                break;

                            case 16:
                                if (!(currency === 'EUR')) {
                                    _context8.next = 18;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' requires account2 parameter to withdraw EUR');

                            case 18:
                                if (!('withdrawal_note' in params)) {
                                    _context8.next = 22;
                                    break;
                                }

                                request['withdrawal_note'] = params['withdrawal_note']; // a 10-character user-specified withdrawal note (PLN only)
                                _context8.next = 24;
                                break;

                            case 22:
                                if (!(currency === 'PLN')) {
                                    _context8.next = 24;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' requires withdrawal_note parameter to withdraw PLN');

                            case 24:
                                _context8.next = 28;
                                break;

                            case 26:
                                method = 'privatePostWithdraw';
                                request['address'] = address;

                            case 28:
                                _context8.next = 30;
                                return this[method](this.extend(request, params));

                            case 30:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response
                                });

                            case 32:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function withdraw(_x30, _x31, _x32) {
                return _ref8.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api === 'public') {
                url += '/' + this.implodeParams(path + '.json', params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var query = this.extend({
                    'tonce': nonce,
                    'method': path
                }, params);
                body = this.urlencode(query);
                headers = {
                    'API-Key': this.apiKey,
                    'API-Hash': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return bitmarket;
}(Exchange);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    DDoSProtection = _require.DDoSProtection,
    OrderNotFound = _require.OrderNotFound,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitmex, _Exchange);

    function bitmex() {
        _classCallCheck(this, bitmex);

        return _possibleConstructorReturn(this, (bitmex.__proto__ || Object.getPrototypeOf(bitmex)).apply(this, arguments));
    }

    _createClass(bitmex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitmex.prototype.__proto__ || Object.getPrototypeOf(bitmex.prototype), 'describe', this).call(this), {
                'id': 'bitmex',
                'name': 'BitMEX',
                'countries': 'SC', // Seychelles
                'version': 'v1',
                'userAgent': undefined,
                'rateLimit': 2000,
                'has': {
                    'CORS': false,
                    'fetchOHLCV': true,
                    'withdraw': true,
                    'editOrder': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true
                },
                'timeframes': {
                    '1m': '1m',
                    '5m': '5m',
                    '1h': '1h',
                    '1d': '1d'
                },
                'urls': {
                    'test': 'https://testnet.bitmex.com',
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766319-f653c6e6-5ed4-11e7-933d-f0bc3699ae8f.jpg',
                    'api': 'https://www.bitmex.com',
                    'www': 'https://www.bitmex.com',
                    'doc': ['https://www.bitmex.com/app/apiOverview', 'https://github.com/BitMEX/api-connectors/tree/master/official-http'],
                    'fees': 'https://www.bitmex.com/app/fees'
                },
                'api': {
                    'public': {
                        'get': ['announcement', 'announcement/urgent', 'funding', 'instrument', 'instrument/active', 'instrument/activeAndIndices', 'instrument/activeIntervals', 'instrument/compositeIndex', 'instrument/indices', 'insurance', 'leaderboard', 'liquidation', 'orderBook', 'orderBook/L2', 'quote', 'quote/bucketed', 'schema', 'schema/websocketHelp', 'settlement', 'stats', 'stats/history', 'trade', 'trade/bucketed']
                    },
                    'private': {
                        'get': ['apiKey', 'chat', 'chat/channels', 'chat/connected', 'execution', 'execution/tradeHistory', 'notification', 'order', 'position', 'user', 'user/affiliateStatus', 'user/checkReferralCode', 'user/commission', 'user/depositAddress', 'user/margin', 'user/minWithdrawalFee', 'user/wallet', 'user/walletHistory', 'user/walletSummary'],
                        'post': ['apiKey', 'apiKey/disable', 'apiKey/enable', 'chat', 'order', 'order/bulk', 'order/cancelAllAfter', 'order/closePosition', 'position/isolate', 'position/leverage', 'position/riskLimit', 'position/transferMargin', 'user/cancelWithdrawal', 'user/confirmEmail', 'user/confirmEnableTFA', 'user/confirmWithdrawal', 'user/disableTFA', 'user/logout', 'user/logoutAll', 'user/preferences', 'user/requestEnableTFA', 'user/requestWithdrawal'],
                        'put': ['order', 'order/bulk', 'user'],
                        'delete': ['apiKey', 'order', 'order/all']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, active, id, base, quote, type, future, prediction, basequote, swap, symbol, precision;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetInstrumentActiveAndIndices();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    active = market['state'] !== 'Unlisted';
                                    id = market['symbol'];
                                    base = market['underlying'];
                                    quote = market['quoteCurrency'];
                                    type = undefined;
                                    future = false;
                                    prediction = false;
                                    basequote = base + quote;

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    swap = id === basequote;
                                    symbol = id;

                                    if (swap) {
                                        type = 'swap';
                                        symbol = base + '/' + quote;
                                    } else if (id.indexOf('B_') >= 0) {
                                        prediction = true;
                                        type = 'prediction';
                                    } else {
                                        future = true;
                                        type = 'future';
                                    }
                                    precision = {
                                        'amount': undefined,
                                        'price': undefined
                                    };

                                    if (market['lotSize']) precision['amount'] = this.precisionFromString(this.truncate_to_string(market['lotSize'], 16));
                                    if (market['tickSize']) precision['price'] = this.precisionFromString(this.truncate_to_string(market['tickSize'], 16));
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': active,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': market['lotSize'],
                                                'max': market['maxOrderQty']
                                            },
                                            'price': {
                                                'min': market['tickSize'],
                                                'max': market['maxPrice']
                                            }
                                        },
                                        'taker': market['takerFee'],
                                        'maker': market['makerFee'],
                                        'type': type,
                                        'spot': false,
                                        'swap': swap,
                                        'future': future,
                                        'prediction': prediction,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetUserMargin({ 'currency': 'all' });

                            case 4:
                                response = _context2.sent;
                                result = { 'info': response };

                                for (b = 0; b < response.length; b++) {
                                    balance = response[b];
                                    currency = balance['currency'].toUpperCase();

                                    currency = this.commonCurrencyCode(currency);
                                    account = {
                                        'free': balance['availableMargin'],
                                        'used': 0.0,
                                        'total': balance['marginBalance']
                                    };

                                    if (currency === 'BTC') {
                                        account['free'] = account['free'] * 0.00000001;
                                        account['total'] = account['total'] * 0.00000001;
                                    }
                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, orderbook, result, o, order, side, amount, price;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['depth'] = limit;
                                _context3.next = 7;
                                return this.publicGetOrderBookL2(this.extend(request, params));

                            case 7:
                                orderbook = _context3.sent;
                                result = {
                                    'bids': [],
                                    'asks': [],
                                    'timestamp': undefined,
                                    'datetime': undefined,
                                    'nonce': undefined
                                };

                                for (o = 0; o < orderbook.length; o++) {
                                    order = orderbook[o];
                                    side = order['side'] === 'Sell' ? 'asks' : 'bids';
                                    amount = order['size'];
                                    price = order['price'];

                                    result[side].push([price, amount]);
                                }
                                result['bids'] = this.sortBy(result['bids'], 0, true);
                                result['asks'] = this.sortBy(result['asks'], 0);
                                return _context3.abrupt('return', result);

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var filter, result, numResults;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                filter = { 'filter': { 'orderID': id } };
                                _context4.next = 3;
                                return this.fetchOrders(symbol, undefined, undefined, this.deepExtend(filter, params));

                            case 3:
                                result = _context4.sent;
                                numResults = result.length;

                                if (!(numResults === 1)) {
                                    _context4.next = 7;
                                    break;
                                }

                                return _context4.abrupt('return', result[0]);

                            case 7:
                                throw new OrderNotFound(this.id + ': The order ' + id + ' not found.');

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrder(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['symbol'] = market['id'];
                                }
                                if (typeof since !== 'undefined') request['startTime'] = this.iso8601(since);
                                if (typeof limit !== 'undefined') request['count'] = limit;
                                request = this.deepExtend(request, params);
                                // why the hassle? urlencode in python is kinda broken for nested dicts.
                                // E.g. self.urlencode({"filter": {"open": True}}) will return "filter={'open':+True}"
                                // Bitmex doesn't like that. Hence resorting to this hack.
                                if ('filter' in request) request['filter'] = this.json(request['filter']);
                                _context5.next = 11;
                                return this.privateGetOrder(request);

                            case 11:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 13:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrders() {
                return _ref5.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var filter_params;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                filter_params = { 'filter': { 'open': true } };
                                _context6.next = 3;
                                return this.fetchOrders(symbol, since, limit, this.deepExtend(filter_params, params));

                            case 3:
                                return _context6.abrupt('return', _context6.sent);

                            case 4:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOpenOrders() {
                return _ref6.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context7.sent;
                                return _context7.abrupt('return', this.filterBy(orders, 'status', 'closed'));

                            case 4:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchClosedOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, request, quotes, quotesLength, quote, tickers, ticker, timestamp, open, close, change;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (market['active']) {
                                    _context8.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ': symbol ' + symbol + ' is delisted');

                            case 5:
                                request = this.extend({
                                    'symbol': market['id'],
                                    'binSize': '1d',
                                    'partial': true,
                                    'count': 1,
                                    'reverse': true
                                }, params);
                                _context8.next = 8;
                                return this.publicGetQuoteBucketed(request);

                            case 8:
                                quotes = _context8.sent;
                                quotesLength = quotes.length;
                                quote = quotes[quotesLength - 1];
                                _context8.next = 13;
                                return this.publicGetTradeBucketed(request);

                            case 13:
                                tickers = _context8.sent;
                                ticker = tickers[0];
                                timestamp = this.milliseconds();
                                open = this.safeFloat(ticker, 'open');
                                close = this.safeFloat(ticker, 'close');
                                change = close - open;
                                return _context8.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(quote, 'bidPrice'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(quote, 'askPrice'),
                                    'askVolume': undefined,
                                    'vwap': this.safeFloat(ticker, 'vwap'),
                                    'open': open,
                                    'close': close,
                                    'last': close,
                                    'previousClose': undefined,
                                    'change': change,
                                    'percentage': change / open * 100,
                                    'average': this.sum(open, close) / 2,
                                    'baseVolume': this.safeFloat(ticker, 'homeNotional'),
                                    'quoteVolume': this.safeFloat(ticker, 'foreignNotional'),
                                    'info': ticker
                                });

                            case 20:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTicker(_x20) {
                return _ref8.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var timestamp = this.parse8601(ohlcv['timestamp']) - this.parseTimeframe(timeframe) * 1000;
            return [timestamp, ohlcv['open'], ohlcv['high'], ohlcv['low'], ohlcv['close'], ohlcv['volume']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, ymdhms, ymdhm, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                // send JSON key/value pairs, such as {"key": "value"}
                                // filter by individual fields and do advanced queries on timestamps
                                // let filter = { 'key': 'value' };
                                // send a bare series (e.g. XBU) to nearest expiring contract in that series
                                // you can also send a timeframe, e.g. XBU:monthly
                                // timeframes: daily, weekly, monthly, quarterly, and biquarterly
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'binSize': this.timeframes[timeframe],
                                    'partial': true // true == include yet-incomplete current bins
                                    // 'filter': filter, // filter by individual fields and do advanced queries
                                    // 'columns': [],    // will return all columns if omitted
                                    // 'start': 0,       // starting point for results (wtf?)
                                    // 'reverse': false, // true == newest first
                                    // 'endTime': '',    // ending date filter for results
                                };

                                if (typeof limit !== 'undefined') request['count'] = limit; // default 100, max 500
                                // if since is not set, they will return candles starting from 2017-01-01
                                if (typeof since !== 'undefined') {
                                    ymdhms = this.ymdhms(since);
                                    ymdhm = ymdhms.slice(0, 16);

                                    request['startTime'] = ymdhm; // starting date filter for results
                                }
                                _context9.next = 8;
                                return this.publicGetTradeBucketed(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOHLCV(_x26) {
                return _ref9.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['timestamp']);
            var symbol = undefined;
            if (!market) {
                if ('symbol' in trade) market = this.markets_by_id[trade['symbol']];
            }
            if (market) symbol = market['symbol'];
            return {
                'id': trade['trdMatchID'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': undefined,
                'type': undefined,
                'side': trade['side'].toLowerCase(),
                'price': trade['price'],
                'amount': trade['size']
            };
        }
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'new': 'open',
                'partiallyfilled': 'open',
                'filled': 'closed',
                'canceled': 'canceled',
                'rejected': 'rejected',
                'expired': 'expired'
            };
            return this.safeString(statuses, status.toLowerCase());
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var status = this.safeValue(order, 'ordStatus');
            if (typeof status !== 'undefined') status = this.parseOrderStatus(status);
            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                var id = order['symbol'];
                if (id in this.markets_by_id) {
                    market = this.markets_by_id[id];
                    symbol = market['symbol'];
                }
            }
            var datetime_value = undefined;
            var timestamp = undefined;
            var iso8601 = undefined;
            if ('timestamp' in order) datetime_value = order['timestamp'];else if ('transactTime' in order) datetime_value = order['transactTime'];
            if (typeof datetime_value !== 'undefined') {
                timestamp = this.parse8601(datetime_value);
                iso8601 = this.iso8601(timestamp);
            }
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'orderQty');
            var filled = this.safeFloat(order, 'cumQty', 0.0);
            var remaining = Math.max(amount - filled, 0.0);
            var cost = undefined;
            if (typeof price !== 'undefined') if (typeof filled !== 'undefined') cost = price * filled;
            var result = {
                'info': order,
                'id': order['orderID'].toString(),
                'timestamp': timestamp,
                'datetime': iso8601,
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': order['ordType'].toLowerCase(),
                'side': order['side'].toLowerCase(),
                'price': price,
                'amount': amount,
                'cost': cost,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof since !== 'undefined') request['startTime'] = this.iso8601(since);
                                if (typeof limit !== 'undefined') request['count'] = limit;
                                _context10.next = 8;
                                return this.publicGetTrade(this.extend(request, params));

                            case 8:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseTrades(response, market));

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchTrades(_x33) {
                return _ref10.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var request, response, order, id;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'symbol': this.marketId(symbol),
                                    'side': this.capitalize(side),
                                    'orderQty': amount,
                                    'ordType': this.capitalize(type)
                                };

                                if (typeof price !== 'undefined') request['price'] = price;
                                _context11.next = 6;
                                return this.privatePostOrder(this.extend(request, params));

                            case 6:
                                response = _context11.sent;
                                order = this.parseOrder(response);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context11.abrupt('return', this.extend({ 'info': response }, order));

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function createOrder(_x37, _x38, _x39, _x40) {
                return _ref11.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'editOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id, symbol, type, side) {
                var amount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var price = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
                var request, response, order;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'orderID': id
                                };

                                if (typeof amount !== 'undefined') request['orderQty'] = amount;
                                if (typeof price !== 'undefined') request['price'] = price;
                                _context12.next = 7;
                                return this.privatePutOrder(this.extend(request, params));

                            case 7:
                                response = _context12.sent;
                                order = this.parseOrder(response);

                                this.orders[order['id']] = order;
                                return _context12.abrupt('return', this.extend({ 'info': response }, order));

                            case 11:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function editOrder(_x43, _x44, _x45, _x46) {
                return _ref12.apply(this, arguments);
            }

            return editOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, order, error;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context13.next = 4;
                                return this.privateDeleteOrder(this.extend({ 'orderID': id }, params));

                            case 4:
                                response = _context13.sent;
                                order = response[0];
                                error = this.safeString(order, 'error');

                                if (!(typeof error !== 'undefined')) {
                                    _context13.next = 10;
                                    break;
                                }

                                if (!(error.indexOf('Unable to cancel order due to existing state') >= 0)) {
                                    _context13.next = 10;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' cancelOrder() failed: ' + error);

                            case 10:
                                order = this.parseOrder(order);
                                this.orders[order['id']] = order;
                                return _context13.abrupt('return', this.extend({ 'info': response }, order));

                            case 13:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function cancelOrder(_x50) {
                return _ref13.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'isFiat',
        value: function isFiat(currency) {
            if (currency === 'EUR') return true;
            if (currency === 'PLN') return true;
            return false;
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                this.checkAddress(address);
                                _context14.next = 3;
                                return this.loadMarkets();

                            case 3:
                                if (!(currency !== 'BTC')) {
                                    _context14.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' supoprts BTC withdrawals only, other currencies coming soon...');

                            case 5:
                                request = {
                                    'currency': 'XBt', // temporarily
                                    'amount': amount,
                                    'address': address
                                    // 'otpToken': '123456', // requires if two-factor auth (OTP) is enabled
                                    // 'fee': 0.001, // bitcoin network fee
                                };
                                _context14.next = 8;
                                return this.privatePostUserRequestWithdrawal(this.extend(request, params));

                            case 8:
                                response = _context14.sent;
                                return _context14.abrupt('return', {
                                    'info': response,
                                    'id': response['transactID']
                                });

                            case 10:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function withdraw(_x53, _x54, _x55) {
                return _ref14.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 429) throw new DDoSProtection(this.id + ' ' + body);
            if (code >= 400) {
                if (body) {
                    if (body[0] === '{') {
                        var response = JSON.parse(body);
                        if ('error' in response) {
                            if ('message' in response['error']) {
                                var message = this.safeValue(response['error'], 'message');
                                if (typeof message !== 'undefined') {
                                    if (message === 'Invalid API Key.') throw new AuthenticationError(this.id + ' ' + this.json(response));
                                }
                                // stub code, need proper handling
                                throw new ExchangeError(this.id + ' ' + this.json(response));
                            }
                        }
                    }
                }
            }
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var query = '/api' + '/' + this.version + '/' + path;
            if (method !== 'PUT') if (Object.keys(params).length) query += '?' + this.urlencode(params);
            var url = this.urls['api'] + query;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = method + query + nonce;
                if (method === 'POST' || method === 'PUT') {
                    if (Object.keys(params).length) {
                        body = this.json(params);
                        auth += body;
                    }
                }
                headers = {
                    'Content-Type': 'application/json',
                    'api-nonce': nonce,
                    'api-key': this.apiKey,
                    'api-signature': this.hmac(this.encode(auth), this.encode(this.secret))
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return bitmex;
}(Exchange);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidNonce = _require.InvalidNonce,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitso, _Exchange);

    function bitso() {
        _classCallCheck(this, bitso);

        return _possibleConstructorReturn(this, (bitso.__proto__ || Object.getPrototypeOf(bitso)).apply(this, arguments));
    }

    _createClass(bitso, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitso.prototype.__proto__ || Object.getPrototypeOf(bitso.prototype), 'describe', this).call(this), {
                'id': 'bitso',
                'name': 'Bitso',
                'countries': 'MX', // Mexico
                'rateLimit': 2000, // 30 requests per minute
                'version': 'v3',
                'has': {
                    'CORS': true,
                    'fetchMyTrades': true,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766335-715ce7aa-5ed5-11e7-88a8-173a27bb30fe.jpg',
                    'api': 'https://api.bitso.com',
                    'www': 'https://bitso.com',
                    'doc': 'https://bitso.com/api_info',
                    'fees': 'https://bitso.com/fees?l=es'
                },
                'api': {
                    'public': {
                        'get': ['available_books', 'ticker', 'order_book', 'trades']
                    },
                    'private': {
                        'get': ['account_status', 'balance', 'fees', 'fundings', 'fundings/{fid}', 'funding_destination', 'kyc_documents', 'ledger', 'ledger/trades', 'ledger/fees', 'ledger/fundings', 'ledger/withdrawals', 'mx_bank_codes', 'open_orders', 'order_trades/{oid}', 'orders/{oid}', 'user_trades', 'user_trades/{tid}', 'withdrawals/', 'withdrawals/{wid}'],
                        'post': ['bitcoin_withdrawal', 'debit_card_withdrawal', 'ether_withdrawal', 'orders', 'phone_number', 'phone_verification', 'phone_withdrawal', 'spei_withdrawal'],
                        'delete': ['orders/{oid}', 'orders/all']
                    }
                },
                'exceptions': {
                    '0201': AuthenticationError, // Invalid Nonce or Invalid Credentials
                    '104': InvalidNonce // Cannot perform request - nonce must be higher than 1520307203724237
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, i, market, id, symbol, _symbol$split, _symbol$split2, base, quote, limits, precision, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetAvailableBooks();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (i = 0; i < markets['payload'].length; i++) {
                                    market = markets['payload'][i];
                                    id = market['book'];
                                    symbol = id.toUpperCase().replace('_', '/');
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];
                                    limits = {
                                        'amount': {
                                            'min': this.safeFloat(market, 'minimum_amount'),
                                            'max': this.safeFloat(market, 'maximum_amount')
                                        },
                                        'price': {
                                            'min': this.safeFloat(market, 'minimum_price'),
                                            'max': this.safeFloat(market, 'maximum_price')
                                        },
                                        'cost': {
                                            'min': this.safeFloat(market, 'minimum_value'),
                                            'max': this.safeFloat(market, 'maximum_value')
                                        }
                                    };
                                    precision = {
                                        'amount': this.precisionFromString(market['minimum_amount']),
                                        'price': this.precisionFromString(market['minimum_price'])
                                    };
                                    lot = limits['amount']['min'];

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market,
                                        'lot': lot,
                                        'limits': limits,
                                        'precision': precision
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetBalance();

                            case 4:
                                response = _context2.sent;
                                balances = response['payload']['balances'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'].toUpperCase();
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': parseFloat(balance['locked']),
                                        'total': parseFloat(balance['total'])
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderBook(this.extend({
                                    'book': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context3.sent;
                                orderbook = response['payload'];
                                timestamp = this.parse8601(orderbook['updated_at']);
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'amount'));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTicker(this.extend({
                                    'book': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context4.sent;
                                ticker = response['payload'];
                                timestamp = this.parse8601(ticker['created_at']);
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['created_at']);
            var symbol = undefined;
            if (typeof market === 'undefined') {
                var marketId = this.safeString(trade, 'book');
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var side = this.safeString(trade, 'side');
            if (typeof side === 'undefined') side = this.safeString(trade, 'maker_side');
            var amount = this.safeFloat(trade, 'amount');
            if (typeof amount === 'undefined') amount = this.safeFloat(trade, 'major');
            if (typeof amount !== 'undefined') amount = Math.abs(amount);
            var fee = undefined;
            var feeCost = this.safeFloat(trade, 'fees_amount');
            if (typeof feeCost !== 'undefined') {
                var feeCurrency = this.safeString(trade, 'fees_currency');
                if (typeof feeCurrency !== 'undefined') {
                    if (feeCurrency in this.currencies_by_id) feeCurrency = this.currencies_by_id[feeCurrency]['code'];
                }
                fee = {
                    'cost': feeCost,
                    'currency': feeCurrency
                };
            }
            var cost = this.safeFloat(trade, 'minor');
            if (typeof cost !== 'undefined') cost = Math.abs(cost);
            var price = this.safeFloat(trade, 'price');
            var orderId = this.safeString(trade, 'oid');
            return {
                'id': trade['tid'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': orderId,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'book': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response['payload'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, markerInParams, request, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                // the don't support fetching trades starting from a date yet
                                // use the `marker` extra param for that
                                // this is not a typo, the variable name is 'marker' (don't confuse with 'market')

                                markerInParams = 'marker' in params;
                                // warn the user with an exception if the user wants to filter
                                // starting from since timestamp, but does not set the trade id with an extra 'marker' param

                                if (!(typeof since !== 'undefined' && !markerInParams)) {
                                    _context6.next = 6;
                                    break;
                                }

                                throw ExchangeError(this.id + ' fetchMyTrades does not support fetching trades starting from a timestamp with the `since` argument, use the `marker` extra param to filter starting from an integer trade id');

                            case 6:
                                // convert it to an integer unconditionally
                                if (markerInParams) params = this.extend(params, {
                                    'marker': parseInt(params['marker'])
                                });
                                request = {
                                    'book': market['id'],
                                    'limit': limit // default = 25, max = 100
                                    // 'sort': 'desc', // default = desc
                                    // 'marker': id, // integer id to start from
                                };
                                _context6.next = 10;
                                return this.privateGetUserTrades(this.extend(request, params));

                            case 10:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['payload'], market, since, limit));

                            case 12:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchMyTrades() {
                return _ref6.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'book': this.marketId(symbol),
                                    'side': side,
                                    'type': type,
                                    'major': this.amountToPrecision(symbol, amount)
                                };

                                if (type === 'limit') order['price'] = this.priceToPrecision(symbol, price);
                                _context7.next = 6;
                                return this.privatePostOrders(this.extend(order, params));

                            case 6:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['payload']['oid']
                                });

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x16, _x17, _x18, _x19) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateDeleteOrdersOid({ 'oid': id });

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x22) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'partial-fill': 'open' // this is a common substitution in ccxt
            };
            if (status in statuses) return statuses['status'];
            return status;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['side'];
            var status = this.parseOrderStatus(order['status']);
            var symbol = undefined;
            if (typeof market === 'undefined') {
                var marketId = order['book'];
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            if (market) symbol = market['symbol'];
            var orderType = order['type'];
            var timestamp = this.parse8601(order['created_at']);
            var amount = this.safeFloat(order, 'original_amount');
            var remaining = this.safeFloat(order, 'unfilled_amount');
            var filled = amount - remaining;
            var result = {
                'info': order,
                'id': order['oid'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': orderType,
                'side': side,
                'price': this.safeFloat(order, 'price'),
                'amount': amount,
                'cost': undefined,
                'remaining': remaining,
                'filled': filled,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, markerInParams, request, response, orders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                // the don't support fetching trades starting from a date yet
                                // use the `marker` extra param for that
                                // this is not a typo, the variable name is 'marker' (don't confuse with 'market')

                                markerInParams = 'marker' in params;
                                // warn the user with an exception if the user wants to filter
                                // starting from since timestamp, but does not set the trade id with an extra 'marker' param

                                if (!(typeof since !== 'undefined' && !markerInParams)) {
                                    _context9.next = 6;
                                    break;
                                }

                                throw ExchangeError(this.id + ' fetchOpenOrders does not support fetching orders starting from a timestamp with the `since` argument, use the `marker` extra param to filter starting from an integer trade id');

                            case 6:
                                // convert it to an integer unconditionally
                                if (markerInParams) params = this.extend(params, {
                                    'marker': parseInt(params['marker'])
                                });
                                request = {
                                    'book': market['id'],
                                    'limit': limit // default = 25, max = 100
                                    // 'sort': 'desc', // default = desc
                                    // 'marker': id, // integer id to start from
                                };
                                _context9.next = 10;
                                return this.privateGetOpenOrders(this.extend(request, params));

                            case 10:
                                response = _context9.sent;
                                orders = this.parseOrders(response['payload'], market, since, limit);
                                return _context9.abrupt('return', orders);

                            case 13:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOpenOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var endpoint = '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (method === 'GET') {
                if (Object.keys(query).length) endpoint += '?' + this.urlencode(query);
            }
            var url = this.urls['api'] + endpoint;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var request = [nonce, method, endpoint].join('');
                if (method !== 'GET') {
                    if (Object.keys(query).length) {
                        body = this.json(query);
                        request += body;
                    }
                }
                var signature = this.hmac(this.encode(request), this.encode(this.secret));
                var auth = this.apiKey + ':' + nonce + ':' + signature;
                headers = {
                    'Authorization': 'Bitso ' + auth,
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('success' in response) {
                    //
                    //     {"success":false,"error":{"code":104,"message":"Cannot perform request - nonce must be higher than 1520307203724237"}}
                    //
                    var success = this.safeValue(response, 'success', false);
                    if (typeof success === 'string') {
                        if (success === 'true' || success === '1') success = true;else success = false;
                    }
                    if (!success) {
                        var feedback = this.id + ' ' + this.json(response);
                        var error = this.safeValue(response, 'error');
                        if (typeof error === 'undefined') throw new ExchangeError(feedback);
                        var code = this.safeString(error, 'code');
                        var exceptions = this.exceptions;
                        if (code in exceptions) {
                            throw new exceptions[code](feedback);
                        } else {
                            throw new ExchangeError(feedback);
                        }
                    }
                }
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('success' in response)) {
                                    _context10.next = 6;
                                    break;
                                }

                                if (!response['success']) {
                                    _context10.next = 6;
                                    break;
                                }

                                return _context10.abrupt('return', response);

                            case 6:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x35) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bitso;
}(Exchange);

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    AuthenticationError = _require.AuthenticationError,
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitstamp, _Exchange);

    function bitstamp() {
        _classCallCheck(this, bitstamp);

        return _possibleConstructorReturn(this, (bitstamp.__proto__ || Object.getPrototypeOf(bitstamp)).apply(this, arguments));
    }

    _createClass(bitstamp, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitstamp.prototype.__proto__ || Object.getPrototypeOf(bitstamp.prototype), 'describe', this).call(this), {
                'id': 'bitstamp',
                'name': 'Bitstamp',
                'countries': 'GB',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'CORS': true,
                    'fetchDepositAddress': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27786377-8c8ab57e-5fe9-11e7-8ea4-2b05b6bcceec.jpg',
                    'api': 'https://www.bitstamp.net/api',
                    'www': 'https://www.bitstamp.net',
                    'doc': 'https://www.bitstamp.net/api'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['order_book/{pair}/', 'ticker_hour/{pair}/', 'ticker/{pair}/', 'transactions/{pair}/', 'trading-pairs-info/']
                    },
                    'private': {
                        'post': ['balance/', 'balance/{pair}/', 'bch_withdrawal/', 'bch_address/', 'user_transactions/', 'user_transactions/{pair}/', 'open_orders/all/', 'open_orders/{pair}/', 'order_status/', 'cancel_order/', 'buy/{pair}/', 'buy/market/{pair}/', 'sell/{pair}/', 'sell/market/{pair}/', 'ltc_withdrawal/', 'ltc_address/', 'eth_withdrawal/', 'eth_address/', 'xrp_withdrawal/', 'xrp_address/', 'transfer-to-main/', 'transfer-from-main/', 'withdrawal-requests/', 'withdrawal/open/', 'withdrawal/status/', 'withdrawal/cancel/', 'liquidation_address/new/', 'liquidation_address/info/']
                    },
                    'v1': {
                        'post': ['bitcoin_deposit_address/', 'unconfirmed_btc/', 'bitcoin_withdrawal/', 'ripple_withdrawal/', 'ripple_address/']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'taker': 0.25 / 100,
                        'maker': 0.25 / 100,
                        'tiers': {
                            'taker': [[0, 0.25 / 100], [20000, 0.24 / 100], [100000, 0.22 / 100], [400000, 0.20 / 100], [600000, 0.15 / 100], [1000000, 0.14 / 100], [2000000, 0.13 / 100], [4000000, 0.12 / 100], [20000000, 0.11 / 100], [20000001, 0.10 / 100]],
                            'maker': [[0, 0.25 / 100], [20000, 0.24 / 100], [100000, 0.22 / 100], [400000, 0.20 / 100], [600000, 0.15 / 100], [1000000, 0.14 / 100], [2000000, 0.13 / 100], [4000000, 0.12 / 100], [20000000, 0.11 / 100], [20000001, 0.10 / 100]]
                        }
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0,
                            'BCH': 0,
                            'LTC': 0,
                            'ETH': 0,
                            'XRP': 0,
                            'USD': 25,
                            'EUR': 0.90
                        },
                        'deposit': {
                            'BTC': 0,
                            'BCH': 0,
                            'LTC': 0,
                            'ETH': 0,
                            'XRP': 0,
                            'USD': 25,
                            'EUR': 0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, i, market, symbol, _symbol$split, _symbol$split2, base, quote, baseId, quoteId, symbolId, id, precision, parts, cost, active, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTradingPairsInfo();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    symbol = market['name'];
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];
                                    baseId = base.toLowerCase();
                                    quoteId = quote.toLowerCase();
                                    symbolId = baseId + '_' + quoteId;
                                    id = market['url_symbol'];
                                    precision = {
                                        'amount': market['base_decimals'],
                                        'price': market['counter_decimals']
                                    };
                                    parts = market['minimum_order'].split(' ');
                                    cost = parts[0];
                                    // let [ cost, currency ] = market['minimum_order'].split (' ');

                                    active = market['trading'] === 'Enabled';
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'symbolId': symbolId,
                                        'info': market,
                                        'lot': lot,
                                        'active': active,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': parseFloat(cost),
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetOrderBookPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context2.sent;
                                timestamp = parseInt(orderbook['timestamp']) * 1000;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTickerPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                ticker = _context3.sent;
                                timestamp = parseInt(ticker['timestamp']) * 1000;
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'getMarketFromTrade',
        value: function getMarketFromTrade(trade) {
            trade = this.omit(trade, ['fee', 'price', 'datetime', 'tid', 'type', 'order_id', 'side']);
            var currencyIds = Object.keys(trade);
            var numCurrencyIds = currencyIds.length;
            if (numCurrencyIds > 2) throw new ExchangeError(this.id + ' getMarketFromTrade too many keys: ' + this.json(currencyIds) + ' in the trade: ' + this.json(trade));
            if (numCurrencyIds === 2) {
                var marketId = currencyIds[0] + currencyIds[1];
                if (marketId in this.markets_by_id) return this.markets_by_id[marketId];
                marketId = currencyIds[1] + currencyIds[0];
                if (marketId in this.markets_by_id) return this.markets_by_id[marketId];
            }
            return undefined;
        }
    }, {
        key: 'getMarketFromTrades',
        value: function getMarketFromTrades(trades) {
            var tradesBySymbol = this.indexBy(trades, 'symbol');
            var symbols = Object.keys(tradesBySymbol);
            var numSymbols = symbols.length;
            if (numSymbols === 1) return this.markets[symbols[0]];
            return undefined;
        }
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            var symbol = undefined;
            if ('date' in trade) {
                timestamp = parseInt(trade['date']) * 1000;
            } else if ('datetime' in trade) {
                timestamp = this.parse8601(trade['datetime']);
            }
            // only if overrided externally
            var side = this.safeString(trade, 'side');
            var orderId = this.safeString(trade, 'order_id');
            if (typeof orderId === 'undefined') if (typeof side === 'undefined') {
                side = this.safeInteger(trade, 'type');
                if (side === 0) side = 'buy';else side = 'sell';
            }
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var id = this.safeString(trade, 'tid');
            id = this.safeString(trade, 'id', id);
            if (typeof market === 'undefined') {
                var keys = Object.keys(trade);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i].indexOf('_') >= 0) {
                        var marketId = keys[i].replace('_', '');
                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                    }
                }
                // if the market is still not defined
                // try to deduce it from used keys
                if (typeof market === 'undefined') market = this.getMarketFromTrade(trade);
            }
            var feeCost = this.safeFloat(trade, 'fee');
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                price = this.safeFloat(trade, market['symbolId'], price);
                amount = this.safeFloat(trade, market['baseId'], amount);
                feeCurrency = market['quote'];
                symbol = market['symbol'];
            }
            var cost = undefined;
            if (typeof price !== 'undefined') if (typeof amount !== 'undefined') cost = price * amount;
            return {
                'id': id,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': orderId,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': {
                    'cost': feeCost,
                    'currency': feeCurrency
                }
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetTransactionsPair(this.extend({
                                    'pair': market['id'],
                                    'time': 'hour'
                                }, params));

                            case 5:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, result, currencies, i, currency, lowercase, total, free, used, account;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                balance = _context5.sent;
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    total = lowercase + '_balance';
                                    free = lowercase + '_available';
                                    used = lowercase + '_reserved';
                                    account = this.account();

                                    if (free in balance) account['free'] = parseFloat(balance[free]);
                                    if (used in balance) account['used'] = parseFloat(balance[used]);
                                    if (total in balance) account['total'] = parseFloat(balance[total]);
                                    result[currency] = account;
                                }
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePost' + this.capitalize(side);
                                order = {
                                    'pair': this.marketId(symbol),
                                    'amount': amount
                                };

                                if (type === 'market') method += 'Market';else order['price'] = price;
                                method += 'Pair';
                                _context6.next = 8;
                                return this[method](this.extend(order, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostCancelOrder({ 'id': id });

                            case 4:
                                return _context7.abrupt('return', _context7.sent);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x18) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(order) {
            if (order['status'] === 'Queue' || order['status'] === 'Open') return 'open';
            if (order['status'] === 'Finished') return 'closed';
            return order['status'];
        }
    }, {
        key: 'fetchOrderStatus',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privatePostOrderStatus(this.extend({ 'id': id }, params));

                            case 4:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrderStatus(response));

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrderStatus(_x21) {
                return _ref8.apply(this, arguments);
            }

            return fetchOrderStatus;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                _context9.next = 6;
                                return this.privatePostOrderStatus(this.extend({ 'id': id }, params));

                            case 6:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(response, market));

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x24) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, method, market, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                method = 'privatePostUserTransactions';
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                    method += 'Pair';
                                }
                                _context10.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchMyTrades() {
                return _ref10.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var id = this.safeString(order, 'id');
            var timestamp = undefined;
            var iso8601 = undefined;
            var side = this.safeString(order, 'type');
            if (typeof side !== 'undefined') side = side === '1' ? 'sell' : 'buy';
            var datetimeString = this.safeString(order, 'datetime');
            if (typeof datetimeString !== 'undefined') {
                timestamp = this.parse8601(datetimeString);
                iso8601 = this.iso8601(timestamp);
            }
            var symbol = undefined;
            if (typeof market === 'undefined') {
                if ('currency_pair' in order) {
                    var marketId = order['currency_pair'];
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                }
            }
            var amount = this.safeFloat(order, 'amount');
            var filled = 0.0;
            var trades = [];
            var transactions = this.safeValue(order, 'transactions');
            var feeCost = undefined;
            var cost = undefined;
            if (typeof transactions !== 'undefined') {
                if (Array.isArray(transactions)) {
                    for (var i = 0; i < transactions.length; i++) {
                        var trade = this.parseTrade(this.extend({
                            'order_id': id,
                            'side': side
                        }, transactions[i]), market);
                        filled += trade['amount'];
                        if (typeof feeCost === 'undefined') feeCost = 0.0;
                        feeCost += trade['fee']['cost'];
                        if (typeof cost === 'undefined') cost = 0.0;
                        cost += trade['cost'];
                        trades.push(trade);
                    }
                }
            }
            var status = this.safeString(order, 'status');
            if (status === 'In Queue' || status === 'Open') status = 'open';else if (status === 'Finished') {
                status = 'closed';
                if (typeof amount === 'undefined') amount = filled;
            }
            var remaining = undefined;
            if (typeof amount !== 'undefined') remaining = amount - filled;
            var price = this.safeFloat(order, 'price');
            if (typeof market === 'undefined') market = this.getMarketFromTrades(trades);
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                feeCurrency = market['quote'];
            }
            if (typeof cost === 'undefined') {
                if (typeof price !== 'undefined') cost = price * filled;
            } else if (typeof price === 'undefined') {
                if (filled > 0) price = cost / filled;
            }
            var fee = {
                'cost': feeCost,
                'currency': feeCurrency
            };
            return {
                'id': id,
                'datetime': iso8601,
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': trades,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, orders;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                market = undefined;

                                if (!(typeof symbol !== 'undefined')) {
                                    _context11.next = 5;
                                    break;
                                }

                                _context11.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);

                            case 5:
                                _context11.next = 7;
                                return this.privatePostOpenOrdersAll();

                            case 7:
                                orders = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'getCurrencyName',
        value: function getCurrencyName(code) {
            if (code === 'BTC') return 'bitcoin';
            return code.toLowerCase();
        }
    }, {
        key: 'isFiat',
        value: function isFiat(code) {
            if (code === 'USD') return true;
            if (code === 'EUR') return true;
            return false;
        }
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var name, v1, method, response, address, tag;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (!this.isFiat(code)) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fiat fetchDepositAddress() for ' + code + ' is not implemented yet');

                            case 2:
                                name = this.getCurrencyName(code);
                                v1 = code === 'BTC';
                                method = v1 ? 'v1' : 'private'; // v1 or v2

                                method += 'Post' + this.capitalize(name);
                                method += v1 ? 'Deposit' : '';
                                method += 'Address';
                                _context12.next = 10;
                                return this[method](params);

                            case 10:
                                response = _context12.sent;
                                address = v1 ? response : this.safeString(response, 'address');
                                tag = v1 ? undefined : this.safeString(response, 'destination_tag');

                                this.checkAddress(address);
                                return _context12.abrupt('return', {
                                    'currency': code,
                                    'status': 'ok',
                                    'address': address,
                                    'tag': tag,
                                    'info': response
                                });

                            case 15:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchDepositAddress(_x36) {
                return _ref12.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var name, request, v1, method, query, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.checkAddress(address);

                                if (!this.isFiat(code)) {
                                    _context13.next = 3;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fiat withdraw() for ' + code + ' is not implemented yet');

                            case 3:
                                name = this.getCurrencyName(code);
                                request = {
                                    'amount': amount,
                                    'address': address
                                };
                                v1 = code === 'BTC';
                                method = v1 ? 'v1' : 'private'; // v1 or v2

                                method += 'Post' + this.capitalize(name) + 'Withdrawal';
                                query = params;

                                if (!(code === 'XRP')) {
                                    _context13.next = 16;
                                    break;
                                }

                                if (!(typeof tag !== 'undefined')) {
                                    _context13.next = 15;
                                    break;
                                }

                                request['destination_tag'] = tag;
                                query = this.omit(params, 'destination_tag');
                                _context13.next = 16;
                                break;

                            case 15:
                                throw new ExchangeError(this.id + ' withdraw() requires a destination_tag param for ' + code);

                            case 16:
                                _context13.next = 18;
                                return this[method](this.extend(request, query));

                            case 18:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 20:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function withdraw(_x38, _x39, _x40) {
                return _ref13.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/';
            if (api !== 'v1') url += this.version + '/';
            url += this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + this.uid + this.apiKey;
                var signature = this.encode(this.hmac(this.encode(auth), this.encode(this.secret)));
                query = this.extend({
                    'key': this.apiKey,
                    'signature': signature.toUpperCase(),
                    'nonce': nonce
                }, query);
                body = this.urlencode(query);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                var status = this.safeString(response, 'status');
                if (status === 'error') {
                    var code = this.safeString(response, 'code');
                    if (typeof code !== 'undefined') {
                        if (code === 'API0005') throw new AuthenticationError(this.id + ' invalid signature, use the uid for the main account if you have subaccounts');
                    }
                    throw new ExchangeError(this.id + ' ' + this.json(response));
                }
            }
        }
    }]);

    return bitstamp;
}(Exchange);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitstamp1, _Exchange);

    function bitstamp1() {
        _classCallCheck(this, bitstamp1);

        return _possibleConstructorReturn(this, (bitstamp1.__proto__ || Object.getPrototypeOf(bitstamp1)).apply(this, arguments));
    }

    _createClass(bitstamp1, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitstamp1.prototype.__proto__ || Object.getPrototypeOf(bitstamp1.prototype), 'describe', this).call(this), {
                'id': 'bitstamp1',
                'name': 'Bitstamp v1',
                'countries': 'GB',
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27786377-8c8ab57e-5fe9-11e7-8ea4-2b05b6bcceec.jpg',
                    'api': 'https://www.bitstamp.net/api',
                    'www': 'https://www.bitstamp.net',
                    'doc': 'https://www.bitstamp.net/api'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['ticker', 'ticker_hour', 'order_book', 'transactions', 'eur_usd']
                    },
                    'private': {
                        'post': ['balance', 'user_transactions', 'open_orders', 'order_status', 'cancel_order', 'cancel_all_orders', 'buy', 'sell', 'bitcoin_deposit_address', 'unconfirmed_btc', 'ripple_withdrawal', 'ripple_address', 'withdrawal_requests', 'bitcoin_withdrawal']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'btcusd', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'maker': 0.0025, 'taker': 0.0025 },
                    'BTC/EUR': { 'id': 'btceur', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 },
                    'EUR/USD': { 'id': 'eurusd', 'symbol': 'EUR/USD', 'base': 'EUR', 'quote': 'USD', 'maker': 0.0025, 'taker': 0.0025 },
                    'XRP/USD': { 'id': 'xrpusd', 'symbol': 'XRP/USD', 'base': 'XRP', 'quote': 'USD', 'maker': 0.0025, 'taker': 0.0025 },
                    'XRP/EUR': { 'id': 'xrpeur', 'symbol': 'XRP/EUR', 'base': 'XRP', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 },
                    'XRP/BTC': { 'id': 'xrpbtc', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC', 'maker': 0.0025, 'taker': 0.0025 },
                    'LTC/USD': { 'id': 'ltcusd', 'symbol': 'LTC/USD', 'base': 'LTC', 'quote': 'USD', 'maker': 0.0025, 'taker': 0.0025 },
                    'LTC/EUR': { 'id': 'ltceur', 'symbol': 'LTC/EUR', 'base': 'LTC', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 },
                    'LTC/BTC': { 'id': 'ltcbtc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'maker': 0.0025, 'taker': 0.0025 },
                    'ETH/USD': { 'id': 'ethusd', 'symbol': 'ETH/USD', 'base': 'ETH', 'quote': 'USD', 'maker': 0.0025, 'taker': 0.0025 },
                    'ETH/EUR': { 'id': 'etheur', 'symbol': 'ETH/EUR', 'base': 'ETH', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 },
                    'ETH/BTC': { 'id': 'ethbtc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'maker': 0.0025, 'taker': 0.0025 }
                }
            });
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(symbol !== 'BTC/USD')) {
                                    _context.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.version + " fetchOrderBook doesn't support " + symbol + ', use it for BTC/USD only');

                            case 2:
                                _context.next = 4;
                                return this.publicGetOrderBook(params);

                            case 4:
                                orderbook = _context.sent;
                                timestamp = parseInt(orderbook['timestamp']) * 1000;
                                return _context.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOrderBook(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(symbol !== 'BTC/USD')) {
                                    _context2.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.version + " fetchTicker doesn't support " + symbol + ', use it for BTC/USD only');

                            case 2:
                                _context2.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                ticker = _context2.sent;
                                timestamp = parseInt(ticker['timestamp']) * 1000;
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context2.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            if ('date' in trade) {
                timestamp = parseInt(trade['date']) * 1000;
            } else if ('datetime' in trade) {
                // timestamp = this.parse8601 (trade['datetime']);
                timestamp = parseInt(trade['datetime']) * 1000;
            }
            var side = trade['type'] === 0 ? 'buy' : 'sell';
            var order = undefined;
            if ('order_id' in trade) order = trade['order_id'].toString();
            if ('currency_pair' in trade) {
                if (trade['currency_pair'] in this.markets_by_id) market = this.markets_by_id[trade['currency_pair']];
            }
            return {
                'id': trade['tid'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': order,
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(symbol !== 'BTC/USD')) {
                                    _context3.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.version + " fetchTrades doesn't support " + symbol + ', use it for BTC/USD only');

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetTransactions(this.extend({
                                    'time': 'minute'
                                }, params));

                            case 5:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x7) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, result, currencies, i, currency, lowercase, total, free, used, account;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.privatePostBalance();

                            case 2:
                                balance = _context4.sent;
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    total = lowercase + '_balance';
                                    free = lowercase + '_available';
                                    used = lowercase + '_reserved';
                                    account = this.account();

                                    account['free'] = this.safeFloat(balance, free, 0.0);
                                    account['used'] = this.safeFloat(balance, used, 0.0);
                                    account['total'] = this.safeFloat(balance, total, 0.0);
                                    result[currency] = account;
                                }
                                return _context4.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchBalance() {
                return _ref4.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.version + ' accepts limit orders only');

                            case 2:
                                if (!(symbol !== 'BTC/USD')) {
                                    _context5.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' v1 supports BTC/USD orders only');

                            case 4:
                                method = 'privatePost' + this.capitalize(side);
                                order = {
                                    'amount': amount,
                                    'price': price
                                };
                                _context5.next = 8;
                                return this[method](this.extend(order, params));

                            case 8:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancelOrder({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x18) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(order) {
            if (order['status'] === 'Queue' || order['status'] === 'Open') return 'open';
            if (order['status'] === 'Finished') return 'closed';
            return order['status'];
        }
    }, {
        key: 'fetchOrderStatus',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostOrderStatus({ 'id': id });

                            case 4:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOrderStatus(response));

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOrderStatus(_x21) {
                return _ref7.apply(this, arguments);
            }

            return fetchOrderStatus;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, pair, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (symbol) market = this.market(symbol);
                                pair = market ? market['id'] : 'all';
                                request = this.extend({ 'id': pair }, params);
                                _context8.next = 8;
                                return this.privatePostOpenOrdersId(request);

                            case 8:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchMyTrades() {
                return _ref8.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                throw new NotSupported(this.id + ' fetchOrder is not implemented yet');

                            case 1:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + this.uid + this.apiKey;
                var signature = this.encode(this.hmac(this.encode(auth), this.encode(this.secret)));
                query = this.extend({
                    'key': this.apiKey,
                    'signature': signature.toUpperCase(),
                    'nonce': nonce
                }, query);
                body = this.urlencode(query);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('status' in response)) {
                                    _context10.next = 6;
                                    break;
                                }

                                if (!(response['status'] === 'error')) {
                                    _context10.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context10.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x35) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bitstamp1;
}(Exchange);

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    InvalidNonce = _require.InvalidNonce,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bitz, _Exchange);

    function bitz() {
        _classCallCheck(this, bitz);

        return _possibleConstructorReturn(this, (bitz.__proto__ || Object.getPrototypeOf(bitz)).apply(this, arguments));
    }

    _createClass(bitz, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bitz.prototype.__proto__ || Object.getPrototypeOf(bitz.prototype), 'describe', this).call(this), {
                'id': 'bitz',
                'name': 'Bit-Z',
                'countries': 'HK',
                'rateLimit': 1000,
                'version': 'v1',
                'userAgent': this.userAgents['chrome'],
                'has': {
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true
                },
                'timeframes': {
                    '1m': '1m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '1d': '1d'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/35862606-4f554f14-0b5d-11e8-957d-35058c504b6f.jpg',
                    'api': 'https://www.bit-z.com/api_v1',
                    'www': 'https://www.bit-z.com',
                    'doc': 'https://www.bit-z.com/api.html',
                    'fees': 'https://www.bit-z.com/about/fee'
                },
                'api': {
                    'public': {
                        'get': ['ticker', 'tickerall', 'depth', 'orders', 'kline']
                    },
                    'private': {
                        'post': ['balances', 'tradeAdd', 'tradeCancel', 'openOrders']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.001,
                        'taker': 0.001
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': '0.5%',
                            'DKKT': '0.5%',
                            'ETH': 0.01,
                            'USDT': '0.5%',
                            'LTC': '0.5%',
                            'FCT': '0.5%',
                            'LSK': '0.5%',
                            'HXI': '0.8%',
                            'ZEC': '0.5%',
                            'DOGE': '0.5%',
                            'MZC': '0.5%',
                            'ETC': '0.5%',
                            'GXS': '0.5%',
                            'XPM': '0.5%',
                            'PPC': '0.5%',
                            'BLK': '0.5%',
                            'XAS': '0.5%',
                            'HSR': '0.5%',
                            'NULS': 5.0,
                            'VOISE': 350.0,
                            'PAY': 1.5,
                            'EOS': 0.6,
                            'YBCT': 35.0,
                            'OMG': 0.3,
                            'OTN': 0.4,
                            'BTX': '0.5%',
                            'QTUM': '0.5%',
                            'DASH': '0.5%',
                            'GAME': '0.5%',
                            'BCH': '0.5%',
                            'GNT': 9.0,
                            'SSS': 1500.0,
                            'ARK': '0.5%',
                            'PART': '0.5%',
                            'LEO': '0.5%',
                            'DGB': '0.5%',
                            'ZSC': 130.0,
                            'VIU': 350.0,
                            'BTG': '0.5%',
                            'ARN': 10.0,
                            'VTC': '0.5%',
                            'BCD': '0.5%',
                            'TRX': 200.0,
                            'HWC': '0.5%',
                            'UNIT': '0.5%',
                            'OXY': '0.5%',
                            'MCO': 0.3500,
                            'SBTC': '0.5%',
                            'BCX': '0.5%',
                            'ETF': '0.5%',
                            'PYLNT': 0.4000,
                            'XRB': '0.5%',
                            'ETP': '0.5%'
                        }
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                },
                'options': {
                    'lastNonceTimestamp': 0
                },
                'commonCurrencies': {
                    'PXC': 'Pixiecoin'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, ids, result, i, id, market, _id$split, _id$split2, baseId, quoteId, base, quote, symbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTickerall();

                            case 2:
                                response = _context.sent;
                                markets = response['data'];
                                ids = Object.keys(markets);
                                result = [];

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = markets[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, data, balances, result, keys, i, id, idHasUnderscore, code, account, usedField;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostBalances(params);

                            case 4:
                                response = _context2.sent;
                                data = response['data'];
                                balances = this.omit(data, 'uid');
                                result = { 'info': response };
                                keys = Object.keys(balances);

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    idHasUnderscore = id.indexOf('_') >= 0;

                                    if (!idHasUnderscore) {
                                        code = id.toUpperCase();

                                        if (id in this.currencies_by_id) {
                                            code = this.currencies_by_id[id]['code'];
                                        }
                                        account = this.account();
                                        usedField = id + '_lock';

                                        account['used'] = this.safeFloat(balances, usedField);
                                        account['total'] = this.safeFloat(balances, id);
                                        account['free'] = account['total'] - account['used'];
                                        result[code] = account;
                                    }
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['date'] * 1000;
            var symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetTicker(this.extend({
                                    'coin': market['id']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTicker(response['data'], market));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, ids, i, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickerall(params);

                            case 4:
                                response = _context4.sent;
                                tickers = response['data'];
                                result = {};
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(tickers[id], market);
                                }
                                return _context4.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetDepth(this.extend({
                                    'coin': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context5.sent;
                                orderbook = response['data'];
                                timestamp = orderbook['date'] * 1000;
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var hkt = this.sum(this.milliseconds(), 28800000);
            var utcDate = this.iso8601(hkt);
            utcDate = utcDate.split('T');
            utcDate = utcDate[0] + ' ' + trade['t'] + '+08';
            var timestamp = this.parse8601(utcDate);
            var price = this.safeFloat(trade, 'p');
            var amount = this.safeFloat(trade, 'n');
            var symbol = market['symbol'];
            var cost = this.priceToPrecision(symbol, amount * price);
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': undefined,
                'order': undefined,
                'type': 'limit',
                'side': trade['s'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetOrders(this.extend({
                                    'coin': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                trades = response['data']['d'];
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response, ohlcv;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetKline(this.extend({
                                    'coin': market['id'],
                                    'type': this.timeframes[timeframe]
                                }, params));

                            case 5:
                                response = _context7.sent;
                                ohlcv = JSON.parse(response['data']['datas']['data']);
                                return _context7.abrupt('return', this.parseOHLCVs(ohlcv, market, timeframe, since, limit));

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x15) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var side = this.safeString(order, 'side');
            if (typeof side === 'undefined') {
                side = this.safeString(order, 'type');
                if (typeof side !== 'undefined') side = side === 'in' ? 'buy' : 'sell';
                if (typeof side === 'undefined') side = this.safeString(order, 'flag');
            }
            var amount = this.safeFloat(order, 'number');
            var filled = this.safeFloat(order, 'numberover');
            var remaining = undefined;
            if (typeof amount !== 'undefined') if (typeof filled !== 'undefined') remaining = amount - filled;
            var timestamp = undefined;
            var iso8601 = undefined;
            if ('datetime' in order) {
                timestamp = this.parse8601(order['datetime']);
                iso8601 = this.iso8601(timestamp);
            }
            return {
                'id': order['id'],
                'datetime': iso8601,
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': 'open',
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': order['price'],
                'cost': undefined,
                'amount': order['number'],
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, orderType, request, response, id, order;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                orderType = side === 'buy' ? 'in' : 'out';

                                if (this.password) {
                                    _context8.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' createOrder() requires you to set exchange.password = "YOUR_TRADING_PASSWORD" (a trade password is NOT THE SAME as your login password)');

                            case 6:
                                request = {
                                    'coin': market['id'],
                                    'type': orderType,
                                    'price': this.priceToPrecision(symbol, price),
                                    'number': this.amountToString(symbol, amount),
                                    'tradepwd': this.password
                                };
                                _context8.next = 9;
                                return this.privatePostTradeAdd(this.extend(request, params));

                            case 9:
                                response = _context8.sent;
                                id = response['data']['id'];
                                order = this.parseOrder({
                                    'id': id,
                                    'price': price,
                                    'number': amount,
                                    'side': side
                                }, market);

                                this.orders[id] = order;
                                return _context8.abrupt('return', order);

                            case 14:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x21, _x22, _x23, _x24) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostTradeCancel(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context9.sent;
                                return _context9.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context10.next = 5;
                                return this.privatePostOpenOrders(this.extend({
                                    'coin': market['id']
                                }, params));

                            case 5:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(response['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            var currentTimestamp = this.seconds();
            if (currentTimestamp > this.options['lastNonceTimestamp']) {
                this.options['lastNonceTimestamp'] = currentTimestamp;
                this.options['lastNonce'] = 100000;
            }
            this.options['lastNonce'] += 1;
            return this.options['lastNonce'];
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            var query = undefined;
            if (api === 'public') {
                query = this.urlencode(params);
                if (query.length) url += '?' + query;
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.keysort(this.extend({
                    'api_key': this.apiKey,
                    'timestamp': this.seconds(),
                    'nonce': this.nonce()
                }, params)));
                body += '&sign=' + this.hash(this.encode(body + this.secret));
                headers = { 'Content-type': 'application/x-www-form-urlencoded' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, code, ErrorClass, message;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context11.sent;
                                code = this.safeString(response, 'code');

                                if (!(code !== '0')) {
                                    _context11.next = 8;
                                    break;
                                }

                                ErrorClass = this.safeValue({
                                    '103': AuthenticationError,
                                    '104': AuthenticationError,
                                    '200': AuthenticationError,
                                    '202': AuthenticationError,
                                    '401': AuthenticationError,
                                    '406': AuthenticationError,
                                    '203': InvalidNonce,
                                    '201': OrderNotFound,
                                    '408': InsufficientFunds,
                                    '106': DDoSProtection
                                }, code, ExchangeError);
                                message = this.safeString(response, 'msg', 'Error');
                                throw new ErrorClass(message);

                            case 8:
                                return _context11.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function request(_x39) {
                return _ref11.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bitz;
}(Exchange);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bl3p, _Exchange);

    function bl3p() {
        _classCallCheck(this, bl3p);

        return _possibleConstructorReturn(this, (bl3p.__proto__ || Object.getPrototypeOf(bl3p)).apply(this, arguments));
    }

    _createClass(bl3p, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bl3p.prototype.__proto__ || Object.getPrototypeOf(bl3p.prototype), 'describe', this).call(this), {
                'id': 'bl3p',
                'name': 'BL3P',
                'countries': ['NL', 'EU'], // Netherlands, EU
                'rateLimit': 1000,
                'version': '1',
                'comment': 'An exchange market by BitonicNL',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28501752-60c21b82-6feb-11e7-818b-055ee6d0e754.jpg',
                    'api': 'https://api.bl3p.eu',
                    'www': ['https://bl3p.eu', 'https://bitonic.nl'],
                    'doc': ['https://github.com/BitonicNL/bl3p-api/tree/master/docs', 'https://bl3p.eu/api', 'https://bitonic.nl/en/api']
                },
                'api': {
                    'public': {
                        'get': ['{market}/ticker', '{market}/orderbook', '{market}/trades']
                    },
                    'private': {
                        'post': ['{market}/money/depth/full', '{market}/money/order/add', '{market}/money/order/cancel', '{market}/money/order/result', '{market}/money/orders', '{market}/money/orders/history', '{market}/money/trades/fetch', 'GENMKT/money/info', 'GENMKT/money/deposit_address', 'GENMKT/money/new_deposit_address', 'GENMKT/money/wallet/history', 'GENMKT/money/withdraw']
                    }
                },
                'markets': {
                    'BTC/EUR': { 'id': 'BTCEUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 },
                    'LTC/EUR': { 'id': 'LTCEUR', 'symbol': 'LTC/EUR', 'base': 'LTC', 'quote': 'EUR', 'maker': 0.0025, 'taker': 0.0025 }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, data, balance, result, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostGENMKTMoneyInfo();

                            case 2:
                                response = _context.sent;
                                data = response['data'];
                                balance = data['wallets'];
                                result = { 'info': data };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    if (currency in balance) {
                                        if ('available' in balance[currency]) {
                                            account['free'] = parseFloat(balance[currency]['available']['value']);
                                        }
                                    }
                                    if (currency in balance) {
                                        if ('balance' in balance[currency]) {
                                            account['total'] = parseFloat(balance[currency]['balance']['value']);
                                        }
                                    }
                                    if (account['total']) {
                                        if (account['free']) {
                                            account['used'] = account['total'] - account['free'];
                                        }
                                    }
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseBidAsk',
        value: function parseBidAsk(bidask) {
            var priceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var amountKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            return [bidask[priceKey] / 100000.0, bidask[amountKey] / 100000000.0];
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetMarketOrderbook(this.extend({
                                    'market': market['id']
                                }, params));

                            case 3:
                                response = _context2.sent;
                                orderbook = response['data'];
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price_int', 'amount_int'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetMarketTicker(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = ticker['timestamp'] * 1000;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': parseFloat(ticker['volume']['24h']),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x7) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            return {
                'id': trade['trade_id'].toString(),
                'timestamp': trade['date'],
                'datetime': this.iso8601(trade['date']),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': trade['price_int'] / 100000.0,
                'amount': trade['amount_int'] / 100000000.0,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, result;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetMarketTrades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                result = this.parseTrades(response['data']['trades'], market, since, limit);
                                return _context4.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x9) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                order = {
                                    'market': market['id'],
                                    'amount_int': parseInt(amount * 100000000),
                                    'fee_currency': market['quote'],
                                    'type': side === 'buy' ? 'bid' : 'ask'
                                };

                                if (type === 'limit') order['price_int'] = parseInt(price * 100000.0);
                                _context5.next = 5;
                                return this.privatePostMarketMoneyOrderAdd(this.extend(order, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['data']['order_id'].toString()
                                });

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x13, _x14, _x15, _x16) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostMarketMoneyOrderCancel({ 'order_id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x19) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = this.implodeParams(path, params);
            var url = this.urls['api'] + '/' + this.version + '/' + request;
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({ 'nonce': nonce }, query));
                var secret = this.base64ToBinary(this.secret);
                // eslint-disable-next-line quotes
                var auth = request + "\0" + body;
                var signature = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Rest-Key': this.apiKey,
                    'Rest-Sign': this.decode(signature)
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return bl3p;
}(Exchange);

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bittrex = __webpack_require__(31);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    InvalidOrder = _require.InvalidOrder,
    InsufficientFunds = _require.InsufficientFunds;

// ---------------------------------------------------------------------------

module.exports = function (_bittrex) {
    _inherits(bleutrade, _bittrex);

    function bleutrade() {
        _classCallCheck(this, bleutrade);

        return _possibleConstructorReturn(this, (bleutrade.__proto__ || Object.getPrototypeOf(bleutrade)).apply(this, arguments));
    }

    _createClass(bleutrade, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bleutrade.prototype.__proto__ || Object.getPrototypeOf(bleutrade.prototype), 'describe', this).call(this), {
                'id': 'bleutrade',
                'name': 'Bleutrade',
                'countries': 'BR', // Brazil
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'CORS': true,
                    'fetchTickers': true,
                    'fetchOrders': true,
                    'fetchClosedOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30303000-b602dbe6-976d-11e7-956d-36c5049c01e7.jpg',
                    'api': {
                        'public': 'https://bleutrade.com/api',
                        'account': 'https://bleutrade.com/api',
                        'market': 'https://bleutrade.com/api'
                    },
                    'www': 'https://bleutrade.com',
                    'doc': 'https://bleutrade.com/help/API',
                    'fees': 'https://bleutrade.com/help/fees_and_deadlines'
                },
                'fees': {
                    'funding': {
                        'withdraw': {
                            'ADC': 0.1,
                            'BTA': 0.1,
                            'BITB': 0.1,
                            'BTC': 0.001,
                            'BCC': 0.001,
                            'BTCD': 0.001,
                            'BTG': 0.001,
                            'BLK': 0.1,
                            'CDN': 0.1,
                            'CLAM': 0.01,
                            'DASH': 0.001,
                            'DCR': 0.05,
                            'DGC': 0.1,
                            'DP': 0.1,
                            'DPC': 0.1,
                            'DOGE': 10.0,
                            'EFL': 0.1,
                            'ETH': 0.01,
                            'EXP': 0.1,
                            'FJC': 0.1,
                            'BSTY': 0.001,
                            'GB': 0.1,
                            'NLG': 0.1,
                            'HTML': 1.0,
                            'LTC': 0.001,
                            'MONA': 0.01,
                            'MOON': 1.0,
                            'NMC': 0.015,
                            'NEOS': 0.1,
                            'NVC': 0.05,
                            'OK': 0.1,
                            'PPC': 0.1,
                            'POT': 0.1,
                            'XPM': 0.001,
                            'QTUM': 0.1,
                            'RDD': 0.1,
                            'SLR': 0.1,
                            'START': 0.1,
                            'SLG': 0.1,
                            'TROLL': 0.1,
                            'UNO': 0.01,
                            'VRC': 0.1,
                            'VTC': 0.1,
                            'XVP': 0.1,
                            'WDC': 0.001,
                            'ZET': 0.1
                        }
                    }
                },
                'exceptions': {
                    'Insufficient funds!': InsufficientFunds,
                    'Invalid Order ID': InvalidOrder,
                    'Invalid apikey or apisecret': AuthenticationError
                },
                'options': {
                    'parseOrderStatus': true
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol, precision, active;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets['result'].length; p++) {
                                    market = markets['result'][p];
                                    id = market['MarketName'];
                                    base = market['MarketCurrency'];
                                    quote = market['BaseCurrency'];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    active = market['IsActive'];

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': active,
                                        'info': market,
                                        'lot': Math.pow(10, -precision['amount']),
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': market['MinTradeSize'],
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': 0,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'OK': 'closed',
                'OPEN': 'open',
                'CANCELED': 'canceled'
            };
            if (status in statuses) {
                return statuses[status];
            } else {
                return status;
            }
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (!symbol) {
                                    _context2.next = 9;
                                    break;
                                }

                                _context2.next = 6;
                                return this.loadMarkets();

                            case 6:
                                market = this.market(symbol);
                                _context2.next = 10;
                                break;

                            case 9:
                                market = undefined;

                            case 10:
                                _context2.next = 12;
                                return this.accountGetOrders(this.extend({ 'market': 'ALL', 'orderstatus': 'ALL' }, params));

                            case 12:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseOrders(response['result'], market, since, limit));

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrders() {
                return _ref2.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.filterBy(response, 'status', 'closed'));

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchClosedOrders() {
                return _ref3.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'getOrderIdField',
        value: function getOrderIdField() {
            return 'orderid';
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'market': this.marketId(symbol),
                                    'type': 'ALL'
                                };

                                if (typeof limit !== 'undefined') request['depth'] = limit; // 50
                                _context4.next = 6;
                                return this.publicGetOrderbook(this.extend(request, params));

                            case 6:
                                response = _context4.sent;
                                orderbook = this.safeValue(response, 'result');

                                if (orderbook) {
                                    _context4.next = 10;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' publicGetOrderbook() returneded no result ' + this.json(response));

                            case 10:
                                return _context4.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy', 'sell', 'Rate', 'Quantity'));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x9) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }]);

    return bleutrade;
}(bittrex);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(braziliex, _Exchange);

    function braziliex() {
        _classCallCheck(this, braziliex);

        return _possibleConstructorReturn(this, (braziliex.__proto__ || Object.getPrototypeOf(braziliex)).apply(this, arguments));
    }

    _createClass(braziliex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(braziliex.prototype.__proto__ || Object.getPrototypeOf(braziliex.prototype), 'describe', this).call(this), {
                'id': 'braziliex',
                'name': 'Braziliex',
                'countries': 'BR',
                'rateLimit': 1000,
                'has': {
                    'fetchCurrencies': true,
                    'fetchTickers': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'fetchDepositAddress': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/34703593-c4498674-f504-11e7-8d14-ff8e44fb78c1.jpg',
                    'api': 'https://braziliex.com/api/v1',
                    'www': 'https://braziliex.com/',
                    'doc': 'https://braziliex.com/exchange/api.php',
                    'fees': 'https://braziliex.com/exchange/fees.php'
                },
                'api': {
                    'public': {
                        'get': ['currencies', 'ticker', 'ticker/{market}', 'orderbook/{market}', 'tradehistory/{market}']
                    },
                    'private': {
                        'post': ['balance', 'complete_balance', 'open_orders', 'trade_history', 'deposit_address', 'sell', 'buy', 'cancel_order']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.005,
                        'taker': 0.005
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                }
            });
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var currencies, ids, result, i, id, currency, precision, uppercase, code, active, status, maintenance, canWithdraw, canDeposit;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetCurrencies(params);

                            case 2:
                                currencies = _context.sent;
                                ids = Object.keys(currencies);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    currency = currencies[id];
                                    precision = this.safeInteger(currency, 'decimal');
                                    uppercase = id.toUpperCase();
                                    code = this.commonCurrencyCode(uppercase);
                                    active = this.safeInteger(currency, 'active') === 1;
                                    status = 'ok';
                                    maintenance = this.safeInteger(currency, 'under_maintenance');

                                    if (maintenance !== 0) {
                                        active = false;
                                        status = 'maintenance';
                                    }
                                    canWithdraw = this.safeInteger(currency, 'is_withdrawal_active') === 1;
                                    canDeposit = this.safeInteger(currency, 'is_deposit_active') === 1;

                                    if (!canWithdraw || !canDeposit) active = false;
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': status,
                                        'precision': precision,
                                        'funding': {
                                            'withdraw': {
                                                'active': canWithdraw,
                                                'fee': currency['txWithdrawalFee']
                                            },
                                            'deposit': {
                                                'active': canDeposit,
                                                'fee': currency['txDepositFee']
                                            }
                                        },
                                        'limits': {
                                            'amount': {
                                                'min': currency['minAmountTrade'],
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['MinWithdrawal'],
                                                'max': Math.pow(10, precision)
                                            },
                                            'deposit': {
                                                'min': currency['minDeposit'],
                                                'max': undefined
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCurrencies() {
                return _ref.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var markets, ids, result, i, id, market, _id$split, _id$split2, baseId, quoteId, base, quote, symbol, active, precision, lot;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetTicker();

                            case 2:
                                markets = _context2.sent;
                                ids = Object.keys(markets);
                                result = [];

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = markets[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    active = this.safeInteger(market, 'active') === 1;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol.toUpperCase(),
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': active,
                                        'lot': lot,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': Math.pow(10, precision['price'])
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = ticker['date'];
            ticker = ticker['ticker'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'highestBid24'),
                'low': this.safeFloat(ticker, 'lowestAsk24'),
                'bid': this.safeFloat(ticker, 'highestBid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'lowestAsk'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'percentChange'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'baseVolume24'),
                'quoteVolume': this.safeFloat(ticker, 'quoteVolume24'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetTickerMarket(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                ticker = _context3.sent;

                                ticker = {
                                    'date': this.milliseconds(),
                                    'ticker': ticker
                                };
                                return _context3.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, timestamp, ids, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context4.sent;
                                result = {};
                                timestamp = this.milliseconds();
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = {
                                        'date': timestamp,
                                        'ticker': tickers[id]
                                    };

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetOrderbookMarket(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            if ('date_exec' in trade) {
                timestamp = this.parse8601(trade['date_exec']);
            } else {
                timestamp = this.parse8601(trade['date']);
            }
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.safeFloat(trade, 'total');
            var orderId = this.safeString(trade, 'order_number');
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, '_id'),
                'order': orderId,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTradehistoryMarket(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                trades = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, id, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostCompleteBalance(params);

                            case 4:
                                balances = _context7.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(balances);

                                for (i = 0; i < currencies.length; i++) {
                                    id = currencies[i];
                                    balance = balances[id];
                                    currency = this.commonCurrencyCode(id);
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': 0.0,
                                        'total': parseFloat(balance['total'])
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context7.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchBalance() {
                return _ref7.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (!market) {
                var marketId = this.safeString(order, 'market');
                if (marketId) if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            if (market) symbol = market['symbol'];
            var timestamp = this.safeValue(order, 'timestamp');
            if (!timestamp) timestamp = this.parse8601(order['date']);
            var price = this.safeFloat(order, 'price');
            var cost = this.safeFloat(order, 'total', 0.0);
            var amount = this.safeFloat(order, 'amount');
            var filledPercentage = this.safeFloat(order, 'progress');
            var filled = amount * filledPercentage;
            var remaining = this.amountToPrecision(symbol, amount - filled);
            var info = order;
            if ('info' in info) info = order['info'];
            return {
                'id': order['order_number'],
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': 'open',
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': this.safeValue(order, 'fee'),
                'info': info
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, response, success, parts, feeParts, order, id;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'privatePost' + this.capitalize(side);
                                _context8.next = 6;
                                return this[method](this.extend({
                                    'market': market['id'],
                                    // 'price': this.priceToPrecision (symbol, price),
                                    // 'amount': this.amountToPrecision (symbol, amount),
                                    'price': price,
                                    'amount': amount
                                }, params));

                            case 6:
                                response = _context8.sent;
                                success = this.safeInteger(response, 'success');

                                if (!(success !== 1)) {
                                    _context8.next = 10;
                                    break;
                                }

                                throw new InvalidOrder(this.id + ' ' + this.json(response));

                            case 10:
                                parts = response['message'].split(' / ');

                                parts = parts.slice(1);
                                feeParts = parts[5].split(' ');
                                order = this.parseOrder({
                                    'timestamp': this.milliseconds(),
                                    'order_number': response['order_number'],
                                    'type': parts[0].toLowerCase(),
                                    'market': parts[0].toLowerCase(),
                                    'amount': parts[2].split(' ')[1],
                                    'price': parts[3].split(' ')[1],
                                    'total': parts[4].split(' ')[1],
                                    'fee': {
                                        'cost': parseFloat(feeParts[1]),
                                        'currency': feeParts[2]
                                    },
                                    'progress': '0.0',
                                    'info': response
                                }, market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context8.abrupt('return', order);

                            case 17:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x17, _x18, _x19, _x20) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, result;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context9.next = 5;
                                return this.privatePostCancelOrder(this.extend({
                                    'order_number': id,
                                    'market': market['id']
                                }, params));

                            case 5:
                                result = _context9.sent;
                                return _context9.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x23) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, orders;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context10.next = 5;
                                return this.privatePostOpenOrders(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                orders = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(orders['order_open'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context11.next = 5;
                                return this.privatePostTradeHistory(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                trades = _context11.sent;
                                return _context11.abrupt('return', this.parseTrades(trades['trade_history'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchMyTrades() {
                return _ref11.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, tag;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context12.next = 5;
                                return this.privatePostDepositAddress(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context12.sent;
                                address = this.safeString(response, 'deposit_address');

                                this.checkAddress(address);
                                tag = this.safeString(response, 'payment_id');
                                return _context12.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchDepositAddress(_x34) {
                return _ref12.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + api;
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                url += '/' + this.implodeParams(path, params);
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                query = this.extend({
                    'command': path,
                    'nonce': this.nonce()
                }, query);
                body = this.urlencode(query);
                var signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha512');
                headers = {
                    'Content-type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.decode(signature)
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, success, message;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;

                                if (!('success' in response)) {
                                    _context13.next = 10;
                                    break;
                                }

                                success = this.safeInteger(response, 'success');

                                if (!(success === 0)) {
                                    _context13.next = 10;
                                    break;
                                }

                                message = this.safeString(response, 'message');

                                if (!(message === 'Invalid APIKey')) {
                                    _context13.next = 9;
                                    break;
                                }

                                throw new AuthenticationError(message);

                            case 9:
                                throw new ExchangeError(message);

                            case 10:
                                return _context13.abrupt('return', response);

                            case 11:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x41) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return braziliex;
}(Exchange);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btcchina, _Exchange);

    function btcchina() {
        _classCallCheck(this, btcchina);

        return _possibleConstructorReturn(this, (btcchina.__proto__ || Object.getPrototypeOf(btcchina)).apply(this, arguments));
    }

    _createClass(btcchina, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcchina.prototype.__proto__ || Object.getPrototypeOf(btcchina.prototype), 'describe', this).call(this), {
                'id': 'btcchina',
                'name': 'BTCChina',
                'countries': 'CN',
                'rateLimit': 1500,
                'version': 'v1',
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766368-465b3286-5ed6-11e7-9a11-0f6467e1d82b.jpg',
                    'api': {
                        'plus': 'https://plus-api.btcchina.com/market',
                        'public': 'https://data.btcchina.com/data',
                        'private': 'https://api.btcchina.com/api_trade_v1.php'
                    },
                    'www': 'https://www.btcchina.com',
                    'doc': 'https://www.btcchina.com/apidocs'
                },
                'api': {
                    'plus': {
                        'get': ['orderbook', 'ticker', 'trade']
                    },
                    'public': {
                        'get': ['historydata', 'orderbook', 'ticker', 'trades']
                    },
                    'private': {
                        'post': ['BuyIcebergOrder', 'BuyOrder', 'BuyOrder2', 'BuyStopOrder', 'CancelIcebergOrder', 'CancelOrder', 'CancelStopOrder', 'GetAccountInfo', 'getArchivedOrder', 'getArchivedOrders', 'GetDeposits', 'GetIcebergOrder', 'GetIcebergOrders', 'GetMarketDepth', 'GetMarketDepth2', 'GetOrder', 'GetOrders', 'GetStopOrder', 'GetStopOrders', 'GetTransactions', 'GetWithdrawal', 'GetWithdrawals', 'RequestWithdrawal', 'SellIcebergOrder', 'SellOrder', 'SellOrder2', 'SellStopOrder']
                    }
                },
                'markets': {
                    'BTC/CNY': { 'id': 'btccny', 'symbol': 'BTC/CNY', 'base': 'BTC', 'quote': 'CNY', 'api': 'public', 'plus': false },
                    'LTC/CNY': { 'id': 'ltccny', 'symbol': 'LTC/CNY', 'base': 'LTC', 'quote': 'CNY', 'api': 'public', 'plus': false },
                    'LTC/BTC': { 'id': 'ltcbtc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'api': 'public', 'plus': false },
                    'BCH/CNY': { 'id': 'bcccny', 'symbol': 'BCH/CNY', 'base': 'BCH', 'quote': 'CNY', 'api': 'plus', 'plus': true },
                    'ETH/CNY': { 'id': 'ethcny', 'symbol': 'ETH/CNY', 'base': 'ETH', 'quote': 'CNY', 'api': 'plus', 'plus': true }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, keys, p, key, market, parts, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTicker({
                                    'market': 'all'
                                });

                            case 2:
                                markets = _context.sent;
                                result = [];
                                keys = Object.keys(markets);

                                for (p = 0; p < keys.length; p++) {
                                    key = keys[p];
                                    market = markets[key];
                                    parts = key.split('_');
                                    id = parts[1];
                                    base = id.slice(0, 3);
                                    quote = id.slice(3, 6);

                                    base = base.toUpperCase();
                                    quote = quote.toUpperCase();
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencies, i, currency, lowercase, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetAccountInfo();

                            case 4:
                                response = _context2.sent;
                                balances = response['result'];
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();

                                    if (lowercase in balances['balance']) account['total'] = parseFloat(balances['balance'][lowercase]['amount']);
                                    if (lowercase in balances['frozen']) account['used'] = parseFloat(balances['frozen'][lowercase]['amount']);
                                    account['free'] = account['total'] - account['used'];
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createMarketRequest',
        value: function createMarketRequest(market) {
            var request = {};
            var field = market['plus'] ? 'symbol' : 'market';
            request[field] = market['id'];
            return request;
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, method, request, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = market['api'] + 'GetOrderbook';
                                request = this.createMarketRequest(market);
                                _context3.next = 7;
                                return this[method](this.extend(request, params));

                            case 7:
                                orderbook = _context3.sent;
                                timestamp = orderbook['date'] * 1000;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker, market) {
            var timestamp = ticker['date'] * 1000;
            var last = this.safeFloat(ticker, 'last');
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'ask': this.safeFloat(ticker, 'sell'),
                'vwap': this.safeFloat(ticker, 'vwap'),
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'parseTickerPlus',
        value: function parseTickerPlus(ticker, market) {
            var timestamp = ticker['Timestamp'];
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'High'),
                'low': this.safeFloat(ticker, 'Low'),
                'bid': this.safeFloat(ticker, 'BidPrice'),
                'ask': this.safeFloat(ticker, 'AskPrice'),
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'Open'),
                'last': this.safeFloat(ticker, 'Last'),
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'Volume24H'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, method, request, tickers, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = market['api'] + 'GetTicker';
                                request = this.createMarketRequest(market);
                                _context4.next = 7;
                                return this[method](this.extend(request, params));

                            case 7:
                                tickers = _context4.sent;
                                ticker = tickers['ticker'];

                                if (!market['plus']) {
                                    _context4.next = 11;
                                    break;
                                }

                                return _context4.abrupt('return', this.parseTickerPlus(ticker, market));

                            case 11:
                                return _context4.abrupt('return', this.parseTicker(ticker, market));

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'id': trade['tid'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'parseTradePlus',
        value: function parseTradePlus(trade, market) {
            var timestamp = this.parse8601(trade['timestamp']);
            return {
                'id': undefined,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['side'].toLowerCase(),
                'price': trade['price'],
                'amount': trade['size']
            };
        }
    }, {
        key: 'parseTradesPlus',
        value: function parseTradesPlus(trades) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var result = [];
            for (var i = 0; i < trades.length; i++) {
                result.push(this.parseTradePlus(trades[i], market));
            }
            return result;
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, method, request, now, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = market['api'] + 'GetTrade';
                                request = this.createMarketRequest(market);

                                if (market['plus']) {
                                    now = this.milliseconds();

                                    request['start_time'] = now - 86400 * 1000;
                                    request['end_time'] = now;
                                } else {
                                    method += 's'; // trades vs trade
                                }
                                _context5.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                response = _context5.sent;

                                if (!market['plus']) {
                                    _context5.next = 11;
                                    break;
                                }

                                return _context5.abrupt('return', this.parseTradesPlus(response['trades'], market));

                            case 11:
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, order, id, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'privatePost' + this.capitalize(side) + 'Order2';
                                order = {};
                                id = market['id'].toUpperCase();

                                if (type === 'market') {
                                    order['params'] = [undefined, amount, id];
                                } else {
                                    order['params'] = [price, amount, id];
                                }
                                _context6.next = 9;
                                return this[method](this.extend(order, params));

                            case 9:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = params['market']; // TODO fixme

                                _context7.next = 5;
                                return this.privatePostCancelOrder(this.extend({
                                    'params': [id, market]
                                }, params));

                            case 5:
                                return _context7.abrupt('return', _context7.sent);

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x18) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.microseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + path;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var p = [];
                if ('params' in params) p = params['params'];
                var nonce = this.nonce();
                var request = {
                    'method': path,
                    'id': nonce,
                    'params': p
                };
                p = p.join(',');
                body = this.json(request);
                var query = 'tonce=' + nonce + '&accesskey=' + this.apiKey + '&requestmethod=' + method.toLowerCase() + '&id=' + nonce + '&method=' + path + '&params=' + p;
                var signature = this.hmac(this.encode(query), this.encode(this.secret), 'sha1');
                var auth = this.encode(this.apiKey + ':' + signature);
                headers = {
                    'Authorization': 'Basic ' + this.stringToBase64(auth),
                    'Json-Rpc-Tonce': nonce
                };
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return btcchina;
}(Exchange);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var btcturk = __webpack_require__(33);

// ---------------------------------------------------------------------------

module.exports = function (_btcturk) {
    _inherits(btcexchange, _btcturk);

    function btcexchange() {
        _classCallCheck(this, btcexchange);

        return _possibleConstructorReturn(this, (btcexchange.__proto__ || Object.getPrototypeOf(btcexchange)).apply(this, arguments));
    }

    _createClass(btcexchange, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcexchange.prototype.__proto__ || Object.getPrototypeOf(btcexchange.prototype), 'describe', this).call(this), {
                'id': 'btcexchange',
                'name': 'BTCExchange',
                'countries': 'PH', // Philippines
                'rateLimit': 1500,
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27993052-4c92911a-64aa-11e7-96d8-ec6ac3435757.jpg',
                    'api': 'https://www.btcexchange.ph/api',
                    'www': 'https://www.btcexchange.ph',
                    'doc': 'https://github.com/BTCTrader/broker-api-docs'
                },
                'markets': {
                    'BTC/PHP': { 'id': 'BTC/PHP', 'symbol': 'BTC/PHP', 'base': 'BTC', 'quote': 'PHP' }
                }
            });
        }
    }]);

    return btcexchange;
}(btcturk);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    OrderNotFound = _require.OrderNotFound,
    NotSupported = _require.NotSupported,
    InvalidOrder = _require.InvalidOrder,
    DDoSProtection = _require.DDoSProtection;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btcmarkets, _Exchange);

    function btcmarkets() {
        _classCallCheck(this, btcmarkets);

        return _possibleConstructorReturn(this, (btcmarkets.__proto__ || Object.getPrototypeOf(btcmarkets)).apply(this, arguments));
    }

    _createClass(btcmarkets, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcmarkets.prototype.__proto__ || Object.getPrototypeOf(btcmarkets.prototype), 'describe', this).call(this), {
                'id': 'btcmarkets',
                'name': 'BTC Markets',
                'countries': 'AU', // Australia
                'rateLimit': 1000, // market data cached for 1 second (trades cached for 2 seconds)
                'has': {
                    'CORS': false,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchClosedOrders': 'emulated',
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'cancelOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/29142911-0e1acfc2-7d5c-11e7-98c4-07d9532b29d7.jpg',
                    'api': {
                        'public': 'https://api.btcmarkets.net',
                        'private': 'https://api.btcmarkets.net',
                        'web': 'https://btcmarkets.net/data'
                    },
                    'www': 'https://btcmarkets.net/',
                    'doc': 'https://github.com/BTCMarkets/API'
                },
                'api': {
                    'public': {
                        'get': ['market/{id}/tick', 'market/{id}/orderbook', 'market/{id}/trades']
                    },
                    'private': {
                        'get': ['account/balance', 'account/{id}/tradingfee'],
                        'post': ['fundtransfer/withdrawCrypto', 'fundtransfer/withdrawEFT', 'order/create', 'order/cancel', 'order/history', 'order/open', 'order/trade/history', 'order/createBatch', // they promise it's coming soon...
                        'order/detail']
                    },
                    'web': {
                        'get': ['market/BTCMarkets/{id}/tickByTime']
                    }
                },
                'markets': {
                    'BTC/AUD': { 'id': 'BTC/AUD', 'symbol': 'BTC/AUD', 'base': 'BTC', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'LTC/AUD': { 'id': 'LTC/AUD', 'symbol': 'LTC/AUD', 'base': 'LTC', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'ETH/AUD': { 'id': 'ETH/AUD', 'symbol': 'ETH/AUD', 'base': 'ETH', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'ETC/AUD': { 'id': 'ETC/AUD', 'symbol': 'ETC/AUD', 'base': 'ETC', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'XRP/AUD': { 'id': 'XRP/AUD', 'symbol': 'XRP/AUD', 'base': 'XRP', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'BCH/AUD': { 'id': 'BCH/AUD', 'symbol': 'BCH/AUD', 'base': 'BCH', 'quote': 'AUD', 'maker': 0.0085, 'taker': 0.0085, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } }, 'precision': { 'price': 2 } },
                    'LTC/BTC': { 'id': 'LTC/BTC', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'maker': 0.0022, 'taker': 0.0022, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'ETH/BTC': { 'id': 'ETH/BTC', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'maker': 0.0022, 'taker': 0.0022, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'ETC/BTC': { 'id': 'ETC/BTC', 'symbol': 'ETC/BTC', 'base': 'ETC', 'quote': 'BTC', 'maker': 0.0022, 'taker': 0.0022, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'XRP/BTC': { 'id': 'XRP/BTC', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC', 'maker': 0.0022, 'taker': 0.0022, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'BCH/BTC': { 'id': 'BCH/BTC', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'maker': 0.0022, 'taker': 0.0022, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } }
                },
                'timeframes': {
                    '1m': 'minute',
                    '1h': 'hour',
                    '1d': 'day'
                },
                'exceptions': {
                    '3': InvalidOrder,
                    '6': DDoSProtection
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, multiplier, total, used, free, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privateGetAccountBalance();

                            case 4:
                                balances = _context.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    multiplier = 100000000;
                                    total = parseFloat(balance['balance'] / multiplier);
                                    used = parseFloat(balance['pendingFunds'] / multiplier);
                                    free = total - used;
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };

                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var multiplier = 100000000; // for price and volume
            return [ohlcv[0], parseFloat(ohlcv[1]) / multiplier, parseFloat(ohlcv[2]) / multiplier, parseFloat(ohlcv[3]) / multiplier, parseFloat(ohlcv[4]) / multiplier, parseFloat(ohlcv[5]) / multiplier];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.load_markets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'id': market['id'],
                                    'timeWindow': this.timeframes[timeframe]
                                };

                                if (typeof since !== 'undefined') request['since'] = since;
                                _context2.next = 7;
                                return this.webGetMarketBTCMarketsIdTickByTime(this.extend(request, params));

                            case 7:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseOHLCVs(response['ticks'], market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOHLCV(_x6) {
                return _ref2.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetMarketIdOrderbook(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                orderbook = _context3.sent;
                                timestamp = orderbook['timestamp'] * 1000;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x11) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['timestamp'] * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'lastPrice');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': this.safeFloat(ticker, 'bestBid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'bestAsk'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume24h'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetMarketIdTick(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                ticker = _context4.sent;
                                return _context4.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x15) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'info': trade,
                'id': trade['tid'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetMarketIdTrades(this.extend({
                                    // 'since': 59868345231,
                                    'id': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x17) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, multiplier, orderSide, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                multiplier = 100000000; // for price and volume

                                orderSide = side === 'buy' ? 'Bid' : 'Ask';
                                order = this.ordered({
                                    'currency': market['quote']
                                });

                                order['currency'] = market['quote'];
                                order['instrument'] = market['base'];
                                order['price'] = parseInt(price * multiplier);
                                order['volume'] = parseInt(amount * multiplier);
                                order['orderSide'] = orderSide;
                                order['ordertype'] = this.capitalize(type);
                                order['clientRequestId'] = this.nonce().toString();
                                _context6.next = 15;
                                return this.privatePostOrderCreate(order);

                            case 15:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['id'].toString()
                                });

                            case 17:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x21, _x22, _x23, _x24) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(ids) {
                var i;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                for (i = 0; i < ids.length; i++) {
                                    ids[i] = parseInt(ids[i]);
                                }
                                _context7.next = 5;
                                return this.privatePostOrderCancel({ 'orderIds': ids });

                            case 5:
                                return _context7.abrupt('return', _context7.sent);

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrders(_x27) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrders;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.cancelOrders([id]);

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x28) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseMyTrade',
        value: function parseMyTrade(trade, market) {
            var multiplier = 100000000;
            var timestamp = trade['creationTime'];
            var side = trade['side'] === 'Bid' ? 'buy' : 'sell';
            // BTCMarkets always charge in AUD for AUD-related transactions.
            var currency = market['quote'] === 'AUD' ? market['quote'] : market['base'];
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': trade['price'] / multiplier,
                'fee': {
                    'currency': currency,
                    'cost': trade['fee'] / multiplier
                },
                'amount': trade['volume'] / multiplier,
                'order': this.safeString(trade, 'orderId')
            };
        }
    }, {
        key: 'parseMyTrades',
        value: function parseMyTrades(trades) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var result = [];
            for (var i = 0; i < trades.length; i++) {
                var trade = this.parseMyTrade(trades[i], market);
                result.push(trade);
            }
            return result;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var multiplier = 100000000;
            var side = order['orderSide'] === 'Bid' ? 'buy' : 'sell';
            var type = order['ordertype'] === 'Limit' ? 'limit' : 'market';
            var timestamp = order['creationTime'];
            if (!market) {
                market = this.market(order['instrument'] + '/' + order['currency']);
            }
            var status = 'open';
            if (order['status'] === 'Failed' || order['status'] === 'Cancelled' || order['status'] === 'Partially Cancelled' || order['status'] === 'Error') {
                status = 'canceled';
            } else if (order['status'] === 'Fully Matched' || order['status'] === 'Partially Matched') {
                status = 'closed';
            }
            var price = this.safeFloat(order, 'price') / multiplier;
            var amount = this.safeFloat(order, 'volume') / multiplier;
            var remaining = this.safeFloat(order, 'openVolume', 0.0) / multiplier;
            var filled = amount - remaining;
            var cost = price * amount;
            var trades = this.parseMyTrades(order['trades'], market);
            var result = {
                'info': order,
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': market['symbol'],
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'trades': trades,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var ids, response, numOrders, order;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                ids = [parseInt(id)];
                                _context9.next = 5;
                                return this.privatePostOrderDetail(this.extend({
                                    'orderIds': ids
                                }, params));

                            case 5:
                                response = _context9.sent;
                                numOrders = response['orders'].length;

                                if (!(numOrders < 1)) {
                                    _context9.next = 9;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' No matching order found: ' + id);

                            case 9:
                                order = response['orders'][0];
                                return _context9.abrupt('return', this.parseOrder(order));

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x35) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'prepareHistoryRequest',
        value: function prepareHistoryRequest(market) {
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

            var request = this.ordered({
                'currency': market['quote'],
                'instrument': market['base']
            });
            if (typeof limit !== 'undefined') request['limit'] = limit;else request['limit'] = 100;
            if (typeof since !== 'undefined') request['since'] = since;else request['since'] = 0;
            return request;
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (symbol) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ': fetchOrders requires a `symbol` parameter.');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = this.prepareHistoryRequest(market, since, limit);
                                _context10.next = 8;
                                return this.privatePostOrderHistory(this.extend(request, params));

                            case 8:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(response['orders'], market));

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (symbol) {
                                    _context11.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ': fetchOpenOrders requires a `symbol` parameter.');

                            case 2:
                                _context11.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = this.prepareHistoryRequest(market, since, limit);
                                _context11.next = 8;
                                return this.privatePostOrderOpen(this.extend(request, params));

                            case 8:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response['orders'], market));

                            case 10:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context12.sent;
                                return _context12.abrupt('return', this.filterBy(orders, 'status', 'closed'));

                            case 4:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchClosedOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                if (symbol) {
                                    _context13.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ': fetchMyTrades requires a `symbol` parameter.');

                            case 2:
                                _context13.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = this.prepareHistoryRequest(market, since, limit);
                                _context13.next = 8;
                                return this.privatePostOrderTradeHistory(this.extend(request, params));

                            case 8:
                                response = _context13.sent;
                                return _context13.abrupt('return', this.parseMyTrades(response['trades'], market));

                            case 10:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchMyTrades() {
                return _ref13.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var uri = '/' + this.implodeParams(path, params);
            var url = this.urls['api'][api] + uri;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                // eslint-disable-next-line quotes
                var auth = uri + "\n" + nonce + "\n";
                headers = {
                    'Content-Type': 'application/json',
                    'apikey': this.apiKey,
                    'timestamp': nonce
                };
                if (method === 'POST') {
                    body = this.json(params);
                    auth += body;
                }
                var secret = this.base64ToBinary(this.secret);
                var signature = this.hmac(this.encode(auth), secret, 'sha512', 'base64');
                headers['signature'] = this.decode(signature);
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if ('success' in response) {
                    if (!response['success']) {
                        var error = this.safeString(response, 'errorCode');
                        var message = this.id + ' ' + this.json(response);
                        if (error in this.exceptions) {
                            var ExceptionClass = this.exceptions[error];
                            throw new ExceptionClass(message);
                        } else {
                            throw new ExchangeError(message);
                        }
                    }
                }
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context14.sent;
                                return _context14.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function request(_x61) {
                return _ref14.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return btcmarkets;
}(Exchange);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var coinegg = __webpack_require__(20);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_coinegg) {
    _inherits(btctradeim, _coinegg);

    function btctradeim() {
        _classCallCheck(this, btctradeim);

        return _possibleConstructorReturn(this, (btctradeim.__proto__ || Object.getPrototypeOf(btctradeim)).apply(this, arguments));
    }

    _createClass(btctradeim, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btctradeim.prototype.__proto__ || Object.getPrototypeOf(btctradeim.prototype), 'describe', this).call(this), {
                'id': 'btctradeim',
                'name': 'BtcTrade.im',
                'countries': 'HK',
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/36770531-c2142444-1c5b-11e8-91e2-a4d90dc85fe8.jpg',
                    'api': {
                        'web': 'https://api.btctrade.im/coin',
                        'rest': 'https://api.btctrade.im/api/v1'
                    },
                    'www': 'https://www.btctrade.im',
                    'doc': 'https://www.btctrade.im/help.api.html',
                    'fees': 'https://www.btctrade.im/spend.price.html'
                },
                'fees': {
                    'trading': {
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.001
                        }
                    }
                }
            });
        }
    }, {
        key: 'request',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, data, code, message;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context.sent;

                                if (!(api === 'web')) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return', response);

                            case 5:
                                data = this.safeValue(response, 'data');

                                if (!data) {
                                    _context.next = 12;
                                    break;
                                }

                                code = this.safeString(response, 'code');

                                if (!(code !== '0')) {
                                    _context.next = 11;
                                    break;
                                }

                                message = this.safeString(response, 'msg', 'Error');
                                throw new ExchangeError(message);

                            case 11:
                                return _context.abrupt('return', data);

                            case 12:
                                return _context.abrupt('return', response);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function request(_x) {
                return _ref.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return btctradeim;
}(coinegg);

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btctradeua, _Exchange);

    function btctradeua() {
        _classCallCheck(this, btctradeua);

        return _possibleConstructorReturn(this, (btctradeua.__proto__ || Object.getPrototypeOf(btctradeua)).apply(this, arguments));
    }

    _createClass(btctradeua, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btctradeua.prototype.__proto__ || Object.getPrototypeOf(btctradeua.prototype), 'describe', this).call(this), {
                'id': 'btctradeua',
                'name': 'BTC Trade UA',
                'countries': 'UA', // Ukraine,
                'rateLimit': 3000,
                'has': {
                    'CORS': true,
                    'createMarketOrder': false,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27941483-79fc7350-62d9-11e7-9f61-ac47f28fcd96.jpg',
                    'api': 'https://btc-trade.com.ua/api',
                    'www': 'https://btc-trade.com.ua',
                    'doc': 'https://docs.google.com/document/d/1ocYA0yMy_RXd561sfG3qEPZ80kyll36HUxvCRe5GbhE/edit'
                },
                'api': {
                    'public': {
                        'get': ['deals/{symbol}', 'trades/sell/{symbol}', 'trades/buy/{symbol}', 'japan_stat/high/{symbol}']
                    },
                    'private': {
                        'post': ['auth', 'ask/{symbol}', 'balance', 'bid/{symbol}', 'buy/{symbol}', 'my_orders/{symbol}', 'order/status/{id}', 'remove/order/{id}', 'sell/{symbol}']
                    }
                },
                'markets': {
                    'BCH/UAH': { 'id': 'bch_uah', 'symbol': 'BCH/UAH', 'base': 'BCH', 'quote': 'UAH' },
                    'BTC/UAH': { 'id': 'btc_uah', 'symbol': 'BTC/UAH', 'base': 'BTC', 'quote': 'UAH', 'precision': { 'price': 1 }, 'limits': { 'amount': { 'min': 0.0000000001 } } },
                    'DASH/BTC': { 'id': 'dash_btc', 'symbol': 'DASH/BTC', 'base': 'DASH', 'quote': 'BTC' },
                    'DASH/UAH': { 'id': 'dash_uah', 'symbol': 'DASH/UAH', 'base': 'DASH', 'quote': 'UAH' },
                    'DOGE/BTC': { 'id': 'doge_btc', 'symbol': 'DOGE/BTC', 'base': 'DOGE', 'quote': 'BTC' },
                    'DOGE/UAH': { 'id': 'doge_uah', 'symbol': 'DOGE/UAH', 'base': 'DOGE', 'quote': 'UAH' },
                    'ETH/UAH': { 'id': 'eth_uah', 'symbol': 'ETH/UAH', 'base': 'ETH', 'quote': 'UAH' },
                    'ITI/UAH': { 'id': 'iti_uah', 'symbol': 'ITI/UAH', 'base': 'ITI', 'quote': 'UAH' },
                    'KRB/UAH': { 'id': 'krb_uah', 'symbol': 'KRB/UAH', 'base': 'KRB', 'quote': 'UAH' },
                    'LTC/BTC': { 'id': 'ltc_btc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC' },
                    'LTC/UAH': { 'id': 'ltc_uah', 'symbol': 'LTC/UAH', 'base': 'LTC', 'quote': 'UAH' },
                    'NVC/BTC': { 'id': 'nvc_btc', 'symbol': 'NVC/BTC', 'base': 'NVC', 'quote': 'BTC' },
                    'NVC/UAH': { 'id': 'nvc_uah', 'symbol': 'NVC/UAH', 'base': 'NVC', 'quote': 'UAH' },
                    'PPC/BTC': { 'id': 'ppc_btc', 'symbol': 'PPC/BTC', 'base': 'PPC', 'quote': 'BTC' },
                    'SIB/UAH': { 'id': 'sib_uah', 'symbol': 'SIB/UAH', 'base': 'SIB', 'quote': 'UAH' },
                    'XMR/UAH': { 'id': 'xmr_uah', 'symbol': 'XMR/UAH', 'base': 'XMR', 'quote': 'UAH' },
                    'ZEC/UAH': { 'id': 'zec_uah', 'symbol': 'ZEC/UAH', 'base': 'ZEC', 'quote': 'UAH' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.0006,
                            'LTC': 0.01,
                            'NVC': 0.01,
                            'DOGE': 10
                        }
                    }
                }
            });
        }
    }, {
        key: 'signIn',
        value: function signIn() {
            return this.privatePostAuth();
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, accounts, b, account, currency, balance;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostBalance();

                            case 2:
                                response = _context.sent;
                                result = { 'info': response };

                                if ('accounts' in response) {
                                    accounts = response['accounts'];

                                    for (b = 0; b < accounts.length; b++) {
                                        account = accounts[b];
                                        currency = account['currency'];
                                        balance = parseFloat(account['balance']);

                                        result[currency] = {
                                            'free': balance,
                                            'used': 0.0,
                                            'total': balance
                                        };
                                    }
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, bids, asks, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetTradesBuySymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 3:
                                bids = _context2.sent;
                                _context2.next = 6;
                                return this.publicGetTradesSellSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 6:
                                asks = _context2.sent;
                                orderbook = {
                                    'bids': [],
                                    'asks': []
                                };

                                if (bids) {
                                    if ('list' in bids) orderbook['bids'] = bids['list'];
                                }
                                if (asks) {
                                    if ('list' in asks) orderbook['asks'] = asks['list'];
                                }
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'currency_trade'));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, result, tickerLength, start, t, candle, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetJapanStatHighSymbol(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context3.sent;
                                ticker = response['trades'];
                                timestamp = this.milliseconds();
                                result = {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': undefined,
                                    'bidVolume': undefined,
                                    'ask': undefined,
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': undefined,
                                    'last': undefined,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': undefined,
                                    'info': ticker
                                };
                                tickerLength = ticker.length;

                                if (tickerLength > 0) {
                                    start = Math.max(tickerLength - 48, 0);

                                    for (t = start; t < ticker.length; t++) {
                                        candle = ticker[t];

                                        if (typeof result['open'] === 'undefined') result['open'] = candle[1];
                                        if (typeof result['high'] === 'undefined' || result['high'] < candle[2]) result['high'] = candle[2];
                                        if (typeof result['low'] === 'undefined' || result['low'] > candle[3]) result['low'] = candle[3];
                                        if (typeof result['baseVolume'] === 'undefined') result['baseVolume'] = -candle[5];else result['baseVolume'] -= candle[5];
                                    }
                                    last = tickerLength - 1;

                                    result['last'] = ticker[last][4];
                                    result['close'] = result['last'];
                                    result['baseVolume'] = -1 * result['baseVolume'];
                                }
                                return _context3.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'convertCyrillicMonthNameToString',
        value: function convertCyrillicMonthNameToString(cyrillic) {
            var months = {
                'января': '01',
                'февраля': '02',
                'марта': '03',
                'апреля': '04',
                'мая': '05',
                'июня': '06',
                'июля': '07',
                'августа': '08',
                'сентября': '09',
                'октября': '10',
                'ноября': '11',
                'декабря': '12'
            };
            var month = undefined;
            if (cyrillic in months) month = months[cyrillic];
            return month;
        }
    }, {
        key: 'parseCyrillicDatetime',
        value: function parseCyrillicDatetime(cyrillic) {
            var parts = cyrillic.split(' ');
            var day = parts[0];
            var month = this.convertCyrillicMonthNameToString(parts[1]);
            if (!month) throw new ExchangeError(this.id + ' parseTrade() undefined month name: ' + cyrillic);
            var year = parts[2];
            var hms = parts[4];
            var hmsLength = hms.length;
            if (hmsLength === 7) {
                hms = '0' + hms;
            }
            if (day.length === 1) {
                day = '0' + day;
            }
            var ymd = [year, month, day].join('-');
            var ymdhms = ymd + 'T' + hms;
            var timestamp = this.parse8601(ymdhms);
            // server reports local time, adjust to UTC
            var md = [month, day].join('');
            md = parseInt(md);
            // a special case for DST
            // subtract 2 hours during winter
            if (md < 325 || md > 1028) return timestamp - 7200000;
            // subtract 3 hours during summer
            return timestamp - 10800000;
        }
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parseCyrillicDatetime(trade['pub_date']);
            return {
                'id': trade['id'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': 'limit',
                'side': trade['type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amnt_trade')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, trades, i;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetDealsSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;

                                // they report each trade twice (once for both of the two sides of the fill)
                                // deduplicate trades for that reason
                                trades = [];

                                for (i = 0; i < response.length; i++) {
                                    if (response[i]['id'] % 2) {
                                        trades.push(response[i]);
                                    }
                                }
                                return _context4.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, order;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                market = this.market(symbol);
                                method = 'privatePost' + this.capitalize(side) + 'Id';
                                order = {
                                    'count': amount,
                                    'currency1': market['quote'],
                                    'currency': market['base'],
                                    'price': price
                                };
                                return _context5.abrupt('return', this[method](this.extend(order, params)));

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostRemoveOrderId({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(trade, market) {
            var timestamp = this.milliseconds;
            return {
                'id': trade['id'],
                'timestamp': timestamp, // until they fix their timestamp
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': 'open',
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': trade['price'],
                'amount': trade['amnt_trade'],
                'filled': 0,
                'remaining': trade['amnt_trade'],
                'trades': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, orders;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOpenOrders requires a symbol argument');

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.privatePostMyOrdersSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                orders = response['your_open_orders'];
                                return _context7.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOpenOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += this.implodeParams(path, query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'out_order_id': nonce,
                    'nonce': nonce
                }, query));
                var auth = body + this.secret;
                headers = {
                    'public-key': this.apiKey,
                    'api-sign': this.hash(this.encode(auth), 'sha256'),
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return btctradeua;
}(Exchange);

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(btcx, _Exchange);

    function btcx() {
        _classCallCheck(this, btcx);

        return _possibleConstructorReturn(this, (btcx.__proto__ || Object.getPrototypeOf(btcx)).apply(this, arguments));
    }

    _createClass(btcx, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(btcx.prototype.__proto__ || Object.getPrototypeOf(btcx.prototype), 'describe', this).call(this), {
                'id': 'btcx',
                'name': 'BTCX',
                'countries': ['IS', 'US', 'EU'],
                'rateLimit': 1500, // support in english is very poor, unable to tell rate limits
                'version': 'v1',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766385-9fdcc98c-5ed6-11e7-8f14-66d5e5cd47e6.jpg',
                    'api': 'https://btc-x.is/api',
                    'www': 'https://btc-x.is',
                    'doc': 'https://btc-x.is/custom/api-document.html'
                },
                'api': {
                    'public': {
                        'get': ['depth/{id}/{limit}', 'ticker/{id}', 'trade/{id}/{limit}']
                    },
                    'private': {
                        'post': ['balance', 'cancel', 'history', 'order', 'redeem', 'trade', 'withdraw']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'btc/usd', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD' },
                    'BTC/EUR': { 'id': 'btc/eur', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, c, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostBalance();

                            case 2:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(balances);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    uppercase = currency.toUpperCase();
                                    account = {
                                        'free': balances[currency],
                                        'used': 0.0,
                                        'total': balances[currency]
                                    };

                                    result[uppercase] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                request = {
                                    'id': this.marketId(symbol)
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // 1000
                                _context2.next = 4;
                                return this.publicGetDepthIdLimit(this.extend(request, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetTickerId(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = ticker['time'] * 1000;
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'sell'),
                                    'ask': this.safeFloat(ticker, 'buy'),
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': undefined,
                                    'first': undefined,
                                    'last': this.safeFloat(ticker, 'last'),
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': this.safeFloat(ticker, 'volume'),
                                    'info': ticker
                                });

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            var side = trade['type'] === 'ask' ? 'sell' : 'buy';
            return {
                'id': trade['id'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTradeIdLimit(this.extend({
                                    'id': market['id'],
                                    'limit': 1000
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.privatePostTrade(this.extend({
                                    'type': side.toUpperCase(),
                                    'market': this.marketId(symbol),
                                    'amount': amount,
                                    'price': price
                                }, params));

                            case 2:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['order']['id']
                                });

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancel({ 'order': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/';
            if (api === 'public') {
                url += this.implodeParams(path, params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                url += api;
                body = this.urlencode(this.extend({
                    'Method': path.toUpperCase(),
                    'Nonce': nonce
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Signature': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('error' in response)) {
                                    _context7.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context7.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return btcx;
}(Exchange);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(bxinth, _Exchange);

    function bxinth() {
        _classCallCheck(this, bxinth);

        return _possibleConstructorReturn(this, (bxinth.__proto__ || Object.getPrototypeOf(bxinth)).apply(this, arguments));
    }

    _createClass(bxinth, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(bxinth.prototype.__proto__ || Object.getPrototypeOf(bxinth.prototype), 'describe', this).call(this), {
                'id': 'bxinth',
                'name': 'BX.in.th',
                'countries': 'TH', // Thailand
                'rateLimit': 1500,
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766412-567b1eb4-5ed7-11e7-94a8-ff6a3884f6c5.jpg',
                    'api': 'https://bx.in.th/api',
                    'www': 'https://bx.in.th',
                    'doc': 'https://bx.in.th/info/api'
                },
                'api': {
                    'public': {
                        'get': ['', // ticker
                        'options', 'optionbook', 'orderbook', 'pairing', 'trade', 'tradehistory']
                    },
                    'private': {
                        'post': ['balance', 'biller', 'billgroup', 'billpay', 'cancel', 'deposit', 'getorders', 'history', 'option-issue', 'option-bid', 'option-sell', 'option-myissue', 'option-mybid', 'option-myoptions', 'option-exercise', 'option-cancel', 'option-history', 'order', 'withdrawal', 'withdrawal-history']
                    }
                },
                'fees': {
                    'trading': {
                        'taker': 0.25 / 100,
                        'maker': 0.25 / 100
                    }
                },
                'commonCurrencies': {
                    'DAS': 'DASH',
                    'DOG': 'DOGE'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, keys, result, p, market, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetPairing();

                            case 2:
                                markets = _context.sent;
                                keys = Object.keys(markets);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    market = markets[keys[p]];
                                    id = market['pairing_id'].toString();
                                    base = market['secondary_currency'];
                                    quote = market['primary_currency'];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, result, currencies, c, currency, code, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                response = _context2.sent;
                                balance = response['balance'];
                                result = { 'info': balance };
                                currencies = Object.keys(balance);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    code = this.commonCurrencyCode(currency);
                                    account = {
                                        'free': parseFloat(balance[currency]['available']),
                                        'used': 0.0,
                                        'total': parseFloat(balance[currency]['total'])
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderbook(this.extend({
                                    'pairing': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last_price');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': parseFloat(ticker['orderbook']['bids']['highbid']),
                'bidVolume': undefined,
                'ask': parseFloat(ticker['orderbook']['asks']['highbid']),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'change'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume_24hours'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, ids, i, id, ticker, market, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGet(params);

                            case 4:
                                tickers = _context4.sent;
                                result = {};
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    ticker = tickers[id];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, tickers, id, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGet(this.extend({
                                    'pairing': market['id']
                                }, params));

                            case 5:
                                tickers = _context5.sent;
                                id = market['id'].toString();
                                ticker = tickers[id];
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parse8601(trade['trade_date']);
            return {
                'id': trade['trade_id'],
                'info': trade,
                'order': trade['order_id'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['trade_type'],
                'price': this.safeFloat(trade, 'rate'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTrade(this.extend({
                                    'pairing': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostOrder(this.extend({
                                    'pairing': this.marketId(symbol),
                                    'type': side,
                                    'amount': amount,
                                    'rate': price
                                }, params));

                            case 4:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['order_id'].toString()
                                });

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var pairing;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                pairing = undefined; // TODO fixme

                                _context8.next = 5;
                                return this.privatePostCancel({
                                    'order_id': id,
                                    'pairing': pairing
                                });

                            case 5:
                                return _context8.abrupt('return', _context8.sent);

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x20) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(order) {
                var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var side, symbol, marketId, timestamp, price, amount;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                side = this.safeString(order, 'order_type');
                                symbol = undefined;

                                if (typeof market === 'undefined') {
                                    marketId = this.safeString(order, 'pairing_id');

                                    if (typeof marketId !== 'undefined') if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                                }
                                if (typeof market !== 'undefined') symbol = market['symbol'];
                                timestamp = this.parse8601(order['date']);
                                price = this.safeFloat(order, 'rate');
                                amount = this.safeFloat(order, 'amount');
                                return _context9.abrupt('return', {
                                    'info': order,
                                    'id': order['order_id'],
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'symbol': symbol,
                                    'type': 'limit',
                                    'side': side,
                                    'price': price,
                                    'amount': amount
                                });

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function parseOrder(_x23) {
                return _ref9.apply(this, arguments);
            }

            return parseOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response, orders;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['pairing'] = market['id'];
                                }
                                response = this.privatePostGetorders(this.extend(request, params));
                                orders = this.parseOrders(response['orders'], market, since, limit);
                                return _context10.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 8:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/';
            if (path) url += path + '/';
            if (Object.keys(params).length) url += '?' + this.urlencode(params);
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var auth = this.apiKey + nonce.toString() + this.secret;
                var signature = this.hash(this.encode(auth), 'sha256');
                body = this.urlencode(this.extend({
                    'key': this.apiKey,
                    'nonce': nonce,
                    'signature': signature
                    // twofa: this.twofa,
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context11.sent;

                                if (!(api === 'public')) {
                                    _context11.next = 5;
                                    break;
                                }

                                return _context11.abrupt('return', response);

                            case 5:
                                if (!('success' in response)) {
                                    _context11.next = 8;
                                    break;
                                }

                                if (!response['success']) {
                                    _context11.next = 8;
                                    break;
                                }

                                return _context11.abrupt('return', response);

                            case 8:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function request(_x34) {
                return _ref11.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return bxinth;
}(Exchange);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(ccex, _Exchange);

    function ccex() {
        _classCallCheck(this, ccex);

        return _possibleConstructorReturn(this, (ccex.__proto__ || Object.getPrototypeOf(ccex)).apply(this, arguments));
    }

    _createClass(ccex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(ccex.prototype.__proto__ || Object.getPrototypeOf(ccex.prototype), 'describe', this).call(this), {
                'id': 'ccex',
                'name': 'C-CEX',
                'countries': ['DE', 'EU'],
                'rateLimit': 1500,
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOrderBooks': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766433-16881f90-5ed8-11e7-92f8-3d92cc747a6c.jpg',
                    'api': {
                        'web': 'https://c-cex.com/t',
                        'public': 'https://c-cex.com/t/api_pub.html',
                        'private': 'https://c-cex.com/t/api.html'
                    },
                    'www': 'https://c-cex.com',
                    'doc': 'https://c-cex.com/?id=api'
                },
                'api': {
                    'web': {
                        'get': ['coinnames', '{market}', 'pairs', 'prices', 'volume_{coin}']
                    },
                    'public': {
                        'get': ['balancedistribution', 'markethistory', 'markets', 'marketsummaries', 'orderbook', 'fullorderbook']
                    },
                    'private': {
                        'get': ['buylimit', 'cancel', 'getbalance', 'getbalances', 'getopenorders', 'getorder', 'getorderhistory', 'mytrades', 'selllimit']
                    }
                },
                'fees': {
                    'trading': {
                        'taker': 0.2 / 100,
                        'maker': 0.2 / 100
                    }
                },
                'commonCurrencies': {
                    'IOT': 'IoTcoin',
                    'BLC': 'Cryptobullcoin',
                    'XID': 'InternationalDiamond',
                    'LUX': 'Luxmi',
                    'CRC': 'CoreCoin'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var result, response, markets, i, id, _id$split, _id$split2, baseId, quoteId, base, quote, symbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                result = {};
                                _context.next = 3;
                                return this.webGetPairs();

                            case 3:
                                response = _context.sent;
                                markets = response['pairs'];

                                for (i = 0; i < markets.length; i++) {
                                    id = markets[i];
                                    _id$split = id.split('-'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;

                                    result[symbol] = {
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'info': id
                                    };
                                }
                                // an alternative documented parser
                                //     let markets = await this.publicGetMarkets ();
                                //     for (let p = 0; p < markets['result'].length; p++) {
                                //         let market = markets['result'][p];
                                //         let id = market['MarketName'];
                                //         let base = market['MarketCurrency'];
                                //         let quote = market['BaseCurrency'];
                                //         base = this.commonCurrencyCode (base);
                                //         quote = this.commonCurrencyCode (quote);
                                //         let symbol = base + '/' + quote;
                                //         result.push ({
                                //             'id': id,
                                //             'symbol': symbol,
                                //             'base': base,
                                //             'quote': quote,
                                //             'info': market,
                                //         });
                                //     }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, code, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetGetbalances();

                            case 4:
                                response = _context2.sent;
                                balances = response['result'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    code = balance['Currency'];
                                    currency = this.commonCurrencyCode(code);
                                    account = {
                                        'free': balance['Available'],
                                        'used': balance['Pending'],
                                        'total': balance['Balance']
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'market': this.marketId(symbol),
                                    'type': 'both'
                                };

                                if (typeof limit !== 'undefined') request['depth'] = limit; // 100
                                _context3.next = 6;
                                return this.publicGetOrderbook(this.extend(request, params));

                            case 6:
                                response = _context3.sent;
                                orderbook = response['result'];
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy', 'sell', 'Rate', 'Quantity'));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchOrderBooks',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var orderbooks, response, types, i, type, bidasks, bidasksByMarketId, marketIds, j, marketId, symbol, side, market, _symbol$split, _symbol$split2, base, quote, invertedId, _market, result, keys, k, key;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                orderbooks = {};
                                _context4.next = 5;
                                return this.publicGetFullorderbook();

                            case 5:
                                response = _context4.sent;
                                types = Object.keys(response['result']);

                                for (i = 0; i < types.length; i++) {
                                    type = types[i];
                                    bidasks = response['result'][type];
                                    bidasksByMarketId = this.groupBy(bidasks, 'Market');
                                    marketIds = Object.keys(bidasksByMarketId);

                                    for (j = 0; j < marketIds.length; j++) {
                                        marketId = marketIds[j];
                                        symbol = marketId.toUpperCase();
                                        side = type;

                                        if (symbol in this.markets_by_id) {
                                            market = this.markets_by_id[symbol];

                                            symbol = market['symbol'];
                                        } else {
                                            _symbol$split = symbol.split('-'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];
                                            invertedId = quote + '-' + base;

                                            if (invertedId in this.markets_by_id) {
                                                _market = this.markets_by_id[invertedId];

                                                symbol = _market['symbol'];
                                            }
                                        }
                                        if (!(symbol in orderbooks)) orderbooks[symbol] = {};
                                        orderbooks[symbol][side] = bidasksByMarketId[marketId];
                                    }
                                }
                                result = {};
                                keys = Object.keys(orderbooks);

                                for (k = 0; k < keys.length; k++) {
                                    key = keys[k];

                                    result[key] = this.parseOrderBook(orderbooks[key], undefined, 'buy', 'sell', 'Rate', 'Quantity');
                                }
                                return _context4.abrupt('return', result);

                            case 12:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBooks() {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBooks;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['updated'] * 1000;
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'lastprice');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'avg'),
                'baseVolume': undefined,
                'quoteVolume': this.safeFloat(ticker, 'buysupport'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var tickers, result, ids, i, id, ticker, market, symbol, uppercase, _uppercase$split, _uppercase$split2, base, quote;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.webGetPrices(params);

                            case 4:
                                tickers = _context5.sent;
                                result = {};
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    ticker = tickers[id];
                                    market = undefined;
                                    symbol = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    } else {
                                        uppercase = id.toUpperCase();
                                        _uppercase$split = uppercase.split('-'), _uppercase$split2 = _slicedToArray(_uppercase$split, 2), base = _uppercase$split2[0], quote = _uppercase$split2[1];

                                        base = this.commonCurrencyCode(base);
                                        quote = this.commonCurrencyCode(quote);
                                        symbol = base + '/' + quote;
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.webGetMarket(this.extend({
                                    'market': market['id'].toLowerCase()
                                }, params));

                            case 5:
                                response = _context6.sent;
                                ticker = response['ticker'];
                                return _context6.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parse8601(trade['TimeStamp']);
            return {
                'id': trade['Id'].toString(),
                'info': trade,
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['OrderType'].toLowerCase(),
                'price': trade['Price'],
                'amount': trade['Quantity']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetMarkethistory(this.extend({
                                    'market': market['id'],
                                    'type': 'both',
                                    'depth': 100
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['result'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x12) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privateGet' + this.capitalize(side) + type;
                                _context8.next = 5;
                                return this[method](this.extend({
                                    'market': this.marketId(symbol),
                                    'quantity': amount,
                                    'rate': price
                                }, params));

                            case 5:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['result']['uuid']
                                });

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x16, _x17, _x18, _x19) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privateGetCancel({ 'uuid': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x22) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var query = this.keysort(this.extend({
                    'a': path,
                    'apikey': this.apiKey,
                    'nonce': nonce
                }, params));
                url += '?' + this.urlencode(query);
                headers = { 'apisign': this.hmac(this.encode(url), this.encode(this.secret), 'sha512') };
            } else if (api === 'public') {
                url += '?' + this.urlencode(this.extend({
                    'a': 'get' + path
                }, params));
            } else {
                url += '/' + this.implodeParams(path, params) + '.json';
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!(api === 'web')) {
                                    _context10.next = 5;
                                    break;
                                }

                                return _context10.abrupt('return', response);

                            case 5:
                                if (!('success' in response)) {
                                    _context10.next = 8;
                                    break;
                                }

                                if (!response['success']) {
                                    _context10.next = 8;
                                    break;
                                }

                                return _context10.abrupt('return', response);

                            case 8:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x30) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return ccex;
}(Exchange);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidOrder = _require.InvalidOrder,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(cex, _Exchange);

    function cex() {
        _classCallCheck(this, cex);

        return _possibleConstructorReturn(this, (cex.__proto__ || Object.getPrototypeOf(cex)).apply(this, arguments));
    }

    _createClass(cex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(cex.prototype.__proto__ || Object.getPrototypeOf(cex.prototype), 'describe', this).call(this), {
                'id': 'cex',
                'name': 'CEX.IO',
                'countries': ['GB', 'EU', 'CY', 'RU'],
                'rateLimit': 1500,
                'has': {
                    'CORS': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchDepositAddress': true
                },
                'timeframes': {
                    '1m': '1m'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766442-8ddc33b0-5ed8-11e7-8b98-f786aef0f3c9.jpg',
                    'api': 'https://cex.io/api',
                    'www': 'https://cex.io',
                    'doc': 'https://cex.io/cex-api',
                    'fees': ['https://cex.io/fee-schedule', 'https://cex.io/limits-commissions']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['currency_limits/', 'last_price/{pair}/', 'last_prices/{currencies}/', 'ohlcv/hd/{yyyymmdd}/{pair}', 'order_book/{pair}/', 'ticker/{pair}/', 'tickers/{currencies}/', 'trade_history/{pair}/'],
                        'post': ['convert/{pair}', 'price_stats/{pair}']
                    },
                    'private': {
                        'post': ['active_orders_status/', 'archived_orders/{pair}/', 'balance/', 'cancel_order/', 'cancel_orders/{pair}/', 'cancel_replace_order/{pair}/', 'close_position/{pair}/', 'get_address/', 'get_myfee/', 'get_order/', 'get_order_tx/', 'open_orders/{pair}/', 'open_orders/', 'open_position/{pair}/', 'open_positions/{pair}/', 'place_order/{pair}/']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.16 / 100,
                        'taker': 0.25 / 100
                    },
                    'funding': {
                        'withdraw': {
                            // 'USD': undefined,
                            // 'EUR': undefined,
                            // 'RUB': undefined,
                            // 'GBP': undefined,
                            'BTC': 0.001,
                            'ETH': 0.01,
                            'BCH': 0.001,
                            'DASH': 0.01,
                            'BTG': 0.001,
                            'ZEC': 0.001,
                            'XRP': 0.02
                        },
                        'deposit': {
                            // 'USD': amount => amount * 0.035 + 0.25,
                            // 'EUR': amount => amount * 0.035 + 0.24,
                            // 'RUB': amount => amount * 0.05 + 15.57,
                            // 'GBP': amount => amount * 0.035 + 0.2,
                            'BTC': 0.0,
                            'ETH': 0.0,
                            'BCH': 0.0,
                            'DASH': 0.0,
                            'BTG': 0.0,
                            'ZEC': 0.0,
                            'XRP': 0.0,
                            'XLM': 0.0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, symbol, _symbol$split, _symbol$split2, base, quote;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetCurrencyLimits();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets['data']['pairs'].length; p++) {
                                    market = markets['data']['pairs'][p];
                                    id = market['symbol1'] + '/' + market['symbol2'];
                                    symbol = id;
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];

                                    result.push({
                                        'id': id,
                                        'info': market,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'lot': market['minLotSize'],
                                        'precision': {
                                            'price': this.precisionFromString(market['minPrice']),
                                            'amount': -1 * Math.log10(market['minLotSize'])
                                        },
                                        'limits': {
                                            'amount': {
                                                'min': market['minLotSize'],
                                                'max': market['maxLotSize']
                                            },
                                            'price': {
                                                'min': this.safeFloat(market, 'minPrice'),
                                                'max': this.safeFloat(market, 'maxPrice')
                                            },
                                            'cost': {
                                                'min': market['minLotSizeS2'],
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, ommited, balances, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                response = _context2.sent;
                                result = { 'info': response };
                                ommited = ['username', 'timestamp'];
                                balances = this.omit(response, ommited);
                                currencies = Object.keys(balances);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];

                                    if (currency in balances) {
                                        account = {
                                            'free': this.safeFloat(balances[currency], 'available', 0.0),
                                            'used': this.safeFloat(balances[currency], 'orders', 0.0),
                                            'total': 0.0
                                        };

                                        account['total'] = this.sum(account['free'], account['used']);
                                        result[currency] = account;
                                    }
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderBookPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                timestamp = orderbook['timestamp'] * 1000;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0] * 1000, ohlcv[1], ohlcv[2], ohlcv[3], ohlcv[4], ohlcv[5]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, ymd, request, response, key, ohlcvs;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!since) since = this.milliseconds() - 86400000; // yesterday
                                ymd = this.ymd(since);

                                ymd = ymd.split('-');
                                ymd = ymd.join('');
                                request = {
                                    'pair': market['id'],
                                    'yyyymmdd': ymd
                                };
                                _context4.next = 10;
                                return this.publicGetOhlcvHdYyyymmddPair(this.extend(request, params));

                            case 10:
                                response = _context4.sent;
                                key = 'data' + this.timeframes[timeframe];
                                ohlcvs = JSON.parse(response[key]);
                                return _context4.abrupt('return', this.parseOHLCVs(ohlcvs, market, timeframe, since, limit));

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOHLCV(_x9) {
                return _ref4.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            var iso8601 = undefined;
            if ('timestamp' in ticker) {
                timestamp = parseInt(ticker['timestamp']) * 1000;
                iso8601 = this.iso8601(timestamp);
            }
            var volume = this.safeFloat(ticker, 'volume');
            var high = this.safeFloat(ticker, 'high');
            var low = this.safeFloat(ticker, 'low');
            var bid = this.safeFloat(ticker, 'bid');
            var ask = this.safeFloat(ticker, 'ask');
            var last = this.safeFloat(ticker, 'last');
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': iso8601,
                'high': high,
                'low': low,
                'bid': bid,
                'bidVolume': undefined,
                'ask': ask,
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': volume,
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currencies, response, tickers, result, t, ticker, symbol, market;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currencies = Object.keys(this.currencies);
                                _context5.next = 5;
                                return this.publicGetTickersCurrencies(this.extend({
                                    'currencies': currencies.join('/')
                                }, params));

                            case 5:
                                response = _context5.sent;
                                tickers = response['data'];
                                result = {};

                                for (t = 0; t < tickers.length; t++) {
                                    ticker = tickers[t];
                                    symbol = ticker['pair'].replace(':', '/');
                                    market = this.markets[symbol];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTickerPair(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                ticker = _context6.sent;
                                return _context6.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x17) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'info': trade,
                'id': trade['tid'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetTradeHistoryPair(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x20) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'pair': this.marketId(symbol),
                                    'type': side,
                                    'amount': amount
                                };

                                if (!(type === 'limit')) {
                                    _context8.next = 7;
                                    break;
                                }

                                order['price'] = price;
                                _context8.next = 12;
                                break;

                            case 7:
                                if (!(side === 'buy')) {
                                    _context8.next = 11;
                                    break;
                                }

                                if (price) {
                                    _context8.next = 10;
                                    break;
                                }

                                throw new InvalidOrder('For market buy orders ' + this.id + " requires the amount of quote currency to spend, to calculate proper costs call createOrder (symbol, 'market', 'buy', amount, price)");

                            case 10:
                                order['amount'] = amount * price;

                            case 11:
                                order['order_type'] = type;

                            case 12:
                                _context8.next = 14;
                                return this.privatePostPlaceOrderPair(this.extend(order, params));

                            case 14:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 16:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x24, _x25, _x26, _x27) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostCancelOrder({ 'id': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x30) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            // Depending on the call, 'time' can be a unix int, unix string or ISO string
            // Yes, really
            var timestamp = order['time'];
            if (typeof order['time'] === 'string' && order['time'].indexOf('T') >= 0) {
                // ISO8601 string
                timestamp = this.parse8601(timestamp);
            } else {
                // either integer or string integer
                timestamp = parseInt(timestamp);
            }
            var symbol = undefined;
            if (!market) {
                var _symbol = order['symbol1'] + '/' + order['symbol2'];
                if (_symbol in this.markets) market = this.market(_symbol);
            }
            var status = order['status'];
            if (status === 'a') {
                status = 'open'; // the unified status
            } else if (status === 'cd') {
                status = 'canceled';
            } else if (status === 'c') {
                status = 'canceled';
            } else if (status === 'd') {
                status = 'closed';
            }
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'amount');
            var remaining = this.safeFloat(order, 'pending');
            if (!remaining) remaining = this.safeFloat(order, 'remains');
            var filled = amount - remaining;
            var fee = undefined;
            var cost = undefined;
            if (market) {
                symbol = market['symbol'];
                cost = this.safeFloat(order, 'ta:' + market['quote']);
                if (typeof cost === 'undefined') cost = this.safeFloat(order, 'tta:' + market['quote']);
                var baseFee = 'fa:' + market['base'];
                var baseTakerFee = 'tfa:' + market['base'];
                var quoteFee = 'fa:' + market['quote'];
                var quoteTakerFee = 'tfa:' + market['quote'];
                var feeRate = this.safeFloat(order, 'tradingFeeMaker');
                if (!feeRate) feeRate = this.safeFloat(order, 'tradingFeeTaker', feeRate);
                if (feeRate) feeRate /= 100.0; // convert to mathematically-correct percentage coefficients: 1.0 = 100%
                if (baseFee in order || baseTakerFee in order) {
                    var baseFeeCost = this.safeFloat(order, baseFee);
                    if (typeof baseFeeCost === 'undefined') baseFeeCost = this.safeFloat(order, baseTakerFee);
                    fee = {
                        'currency': market['base'],
                        'rate': feeRate,
                        'cost': baseFeeCost
                    };
                } else if (quoteFee in order || quoteTakerFee in order) {
                    var quoteFeeCost = this.safeFloat(order, quoteFee);
                    if (typeof quoteFeeCost === 'undefined') quoteFeeCost = this.safeFloat(order, quoteTakerFee);
                    fee = {
                        'currency': market['quote'],
                        'rate': feeRate,
                        'cost': quoteFeeCost
                    };
                }
            }
            if (!cost) cost = price * filled;
            return {
                'id': order['id'],
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': undefined,
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, method, market, orders, i;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                method = 'privatePostOpenOrders';
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                    method += 'Pair';
                                }
                                _context10.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                orders = _context10.sent;

                                for (i = 0; i < orders.length; i++) {
                                    orders[i] = this.extend(orders[i], { 'status': 'open' });
                                }
                                return _context10.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 11:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var method, market, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePostArchivedOrdersPair';

                                if (!(typeof symbol === 'undefined')) {
                                    _context11.next = 5;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchClosedOrders requires a symbol argument');

                            case 5:
                                market = this.market(symbol);
                                request = { 'pair': market['id'] };
                                _context11.next = 9;
                                return this[method](this.extend(request, params));

                            case 9:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchClosedOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context12.next = 4;
                                return this.privatePostGetOrder(this.extend({
                                    'id': id.toString()
                                }, params));

                            case 4:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrder(_x42) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + this.uid + this.apiKey;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret));
                body = this.urlencode(this.extend({
                    'key': this.apiKey,
                    'signature': signature.toUpperCase(),
                    'nonce': nonce
                }, query));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;

                                if (response) {
                                    _context13.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' returned ' + this.json(response));

                            case 7:
                                if (!(response === true)) {
                                    _context13.next = 11;
                                    break;
                                }

                                return _context13.abrupt('return', response);

                            case 11:
                                if (!('e' in response)) {
                                    _context13.next = 18;
                                    break;
                                }

                                if (!('ok' in response)) {
                                    _context13.next = 15;
                                    break;
                                }

                                if (!(response['ok'] === 'ok')) {
                                    _context13.next = 15;
                                    break;
                                }

                                return _context13.abrupt('return', response);

                            case 15:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 18:
                                if (!('error' in response)) {
                                    _context13.next = 21;
                                    break;
                                }

                                if (!response['error']) {
                                    _context13.next = 21;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 21:
                                return _context13.abrupt('return', response);

                            case 22:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x50) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, request, response, address;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                if (!(code === 'XRP')) {
                                    _context14.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchDepositAddress does not support XRP addresses yet (awaiting docs from CEX.io)');

                            case 2:
                                _context14.next = 4;
                                return this.loadMarkets();

                            case 4:
                                currency = this.currency(code);
                                request = {
                                    'currency': currency['id']
                                };
                                _context14.next = 8;
                                return this.privatePostGetAddress(this.extend(request, params));

                            case 8:
                                response = _context14.sent;
                                address = this.safeString(response, 'data');

                                this.checkAddress(address);
                                return _context14.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': undefined,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 12:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchDepositAddress(_x56) {
                return _ref14.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }]);

    return cex;
}(Exchange);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var zb = __webpack_require__(19);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

// ---------------------------------------------------------------------------

module.exports = function (_zb) {
    _inherits(chbtc, _zb);

    function chbtc() {
        _classCallCheck(this, chbtc);

        return _possibleConstructorReturn(this, (chbtc.__proto__ || Object.getPrototypeOf(chbtc)).apply(this, arguments));
    }

    _createClass(chbtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(chbtc.prototype.__proto__ || Object.getPrototypeOf(chbtc.prototype), 'describe', this).call(this), {
                'id': 'chbtc',
                'name': 'CHBTC',
                'countries': 'CN',
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchOrder': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28555659-f0040dc2-7109-11e7-9d99-688a438bf9f4.jpg',
                    'api': {
                        'public': 'http://api.chbtc.com/data', // no https for public API
                        'private': 'https://trade.chbtc.com/api'
                    },
                    'www': 'https://trade.chbtc.com/api',
                    'doc': 'https://www.chbtc.com/i/developer'
                },
                'markets': {
                    'BTC/CNY': { 'id': 'btc_cny', 'symbol': 'BTC/CNY', 'base': 'BTC', 'quote': 'CNY' },
                    'LTC/CNY': { 'id': 'ltc_cny', 'symbol': 'LTC/CNY', 'base': 'LTC', 'quote': 'CNY' },
                    'ETH/CNY': { 'id': 'eth_cny', 'symbol': 'ETH/CNY', 'base': 'ETH', 'quote': 'CNY' },
                    'ETC/CNY': { 'id': 'etc_cny', 'symbol': 'ETC/CNY', 'base': 'ETC', 'quote': 'CNY' },
                    'BTS/CNY': { 'id': 'bts_cny', 'symbol': 'BTS/CNY', 'base': 'BTS', 'quote': 'CNY' },
                    // 'EOS/CNY': { 'id': 'eos_cny', 'symbol': 'EOS/CNY', 'base': 'EOS', 'quote': 'CNY' },
                    'BCH/CNY': { 'id': 'bcc_cny', 'symbol': 'BCH/CNY', 'base': 'BCH', 'quote': 'CNY' },
                    'HSR/CNY': { 'id': 'hsr_cny', 'symbol': 'HSR/CNY', 'base': 'HSR', 'quote': 'CNY' },
                    'QTUM/CNY': { 'id': 'qtum_cny', 'symbol': 'QTUM/CNY', 'base': 'QTUM', 'quote': 'CNY' }
                }
            });
        }
    }, {
        key: 'getMarketFieldName',
        value: function getMarketFieldName() {
            return 'currency';
        }
    }, {
        key: 'request',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context.sent;

                                if (!(api === 'private')) {
                                    _context.next = 6;
                                    break;
                                }

                                if (!('code' in response)) {
                                    _context.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                if (!('result' in response)) {
                                    _context.next = 9;
                                    break;
                                }

                                if (response['result']) {
                                    _context.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 9:
                                return _context.abrupt('return', response);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function request(_x) {
                return _ref.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return chbtc;
}(zb);

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var foxbit = __webpack_require__(7);

// ---------------------------------------------------------------------------

module.exports = function (_foxbit) {
    _inherits(chilebit, _foxbit);

    function chilebit() {
        _classCallCheck(this, chilebit);

        return _possibleConstructorReturn(this, (chilebit.__proto__ || Object.getPrototypeOf(chilebit)).apply(this, arguments));
    }

    _createClass(chilebit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(chilebit.prototype.__proto__ || Object.getPrototypeOf(chilebit.prototype), 'describe', this).call(this), {
                'id': 'chilebit',
                'name': 'ChileBit',
                'countries': 'CL',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27991414-1298f0d8-647f-11e7-9c40-d56409266336.jpg',
                    'api': {
                        'public': 'https://api.blinktrade.com/api',
                        'private': 'https://api.blinktrade.com/tapi'
                    },
                    'www': 'https://chilebit.net',
                    'doc': 'https://blinktrade.com/docs'
                },
                'options': {
                    'brokerId': '9' // https://blinktrade.com/docs/#brokers
                }
            });
        }
    }]);

    return chilebit;
}(foxbit);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(cobinhood, _Exchange);

    function cobinhood() {
        _classCallCheck(this, cobinhood);

        return _possibleConstructorReturn(this, (cobinhood.__proto__ || Object.getPrototypeOf(cobinhood)).apply(this, arguments));
    }

    _createClass(cobinhood, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(cobinhood.prototype.__proto__ || Object.getPrototypeOf(cobinhood.prototype), 'describe', this).call(this), {
                'id': 'cobinhood',
                'name': 'COBINHOOD',
                'countries': 'TW',
                'rateLimit': 1000 / 10,
                'has': {
                    'fetchCurrencies': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchOrder': true,
                    'fetchDepositAddress': true,
                    'createDepositAddress': true,
                    'withdraw': true
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false
                },
                'timeframes': {
                    // the first two don't seem to work at all
                    '1m': '1m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '3h': '3h',
                    '6h': '6h',
                    '12h': '12h',
                    '1d': '1D',
                    '7d': '7D',
                    '14d': '14D',
                    '1M': '1M'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/35755576-dee02e5c-0878-11e8-989f-1595d80ba47f.jpg',
                    'api': {
                        'web': 'https://api.cobinhood.com/v1',
                        'ws': 'wss://feed.cobinhood.com'
                    },
                    'www': 'https://cobinhood.com',
                    'doc': 'https://cobinhood.github.io/api-public'
                },
                'api': {
                    'system': {
                        'get': ['info', 'time', 'messages', 'messages/{message_id}']
                    },
                    'admin': {
                        'get': ['system/messages', 'system/messages/{message_id}'],
                        'post': ['system/messages'],
                        'patch': ['system/messages/{message_id}'],
                        'delete': ['system/messages/{message_id}']
                    },
                    'public': {
                        'get': ['market/tickers', 'market/currencies', 'market/trading_pairs', 'market/orderbooks/{trading_pair_id}', 'market/stats', 'market/tickers/{trading_pair_id}', 'market/trades/{trading_pair_id}', 'chart/candles/{trading_pair_id}']
                    },
                    'private': {
                        'get': ['trading/orders/{order_id}', 'trading/orders/{order_id}/trades', 'trading/orders', 'trading/order_history', 'trading/trades/{trade_id}', 'wallet/balances', 'wallet/ledger', 'wallet/deposit_addresses', 'wallet/withdrawal_addresses', 'wallet/withdrawals/{withdrawal_id}', 'wallet/withdrawals', 'wallet/deposits/{deposit_id}', 'wallet/deposits'],
                        'post': ['trading/orders', 'wallet/deposit_addresses', 'wallet/withdrawal_addresses', 'wallet/withdrawals'],
                        'delete': ['trading/orders/{order_id}']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0,
                        'taker': 0.0
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                },
                'exceptions': {
                    'insufficient_balance': InsufficientFunds
                }
            });
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, code, minUnit;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarketCurrencies(params);

                            case 2:
                                response = _context.sent;
                                currencies = response['result']['currencies'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['currency'];
                                    code = this.commonCurrencyCode(id);
                                    minUnit = this.safeFloat(currency, 'min_unit');

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'name': currency['name'],
                                        'active': true,
                                        'status': 'ok',
                                        'fiat': false,
                                        'precision': this.precisionFromString(currency['min_unit']),
                                        'limits': {
                                            'amount': {
                                                'min': minUnit,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': minUnit,
                                                'max': undefined
                                            },
                                            'deposit': {
                                                'min': minUnit,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': minUnit,
                                                'max': undefined
                                            }
                                        },
                                        'funding': {
                                            'withdraw': {
                                                'fee': this.safeFloat(currency, 'withdrawal_fee')
                                            },
                                            'deposit': {
                                                'fee': this.safeFloat(currency, 'deposit_fee')
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCurrencies() {
                return _ref.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, markets, result, i, market, id, _id$split, _id$split2, baseId, quoteId, base, quote, symbol, precision, active;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetMarketTradingPairs();

                            case 2:
                                response = _context2.sent;
                                markets = response['result']['trading_pairs'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['id'];
                                    _id$split = id.split('-'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': this.precisionFromString(market['quote_increment'])
                                    };
                                    active = this.safeValue(market, 'is_active', true);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': active,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': this.safeFloat(market, 'base_min_size'),
                                                'max': this.safeFloat(market, 'base_max_size')
                                            },
                                            'price': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (typeof market === 'undefined') {
                var marketId = this.safeString(ticker, 'trading_pair_id');
                market = this.findMarket(marketId);
            }
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var timestamp = this.safeInteger(ticker, 'timestamp');
            var last = this.safeFloat(ticker, 'last_trade_price');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, '24h_high'),
                'low': this.safeFloat(ticker, '24h_low'),
                'bid': this.safeFloat(ticker, 'highest_bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'lowest_ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'percentChanged24hr'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, '24h_volume'),
                'quoteVolume': this.safeFloat(ticker, 'quote_volume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetMarketTickersTradingPairId(this.extend({
                                    'trading_pair_id': market['id']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                ticker = response['result']['ticker'];
                                return _context3.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, i;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetMarketTickers(params);

                            case 4:
                                response = _context4.sent;
                                tickers = response['result']['tickers'];
                                result = [];

                                for (i = 0; i < tickers.length; i++) {
                                    result.push(this.parseTicker(tickers[i]));
                                }
                                return _context4.abrupt('return', this.indexBy(result, 'symbol'));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'trading_pair_id': this.marketId(symbol)
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // 100
                                _context5.next = 6;
                                return this.publicGetMarketOrderbooksTradingPairId(this.extend(request, params));

                            case 6:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(response['result']['orderbook'], undefined, 'bids', 'asks', 0, 2));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var timestamp = trade['timestamp'];
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'size');
            var cost = parseFloat(this.costToPrecision(symbol, price * amount));
            var side = trade['maker_side'] === 'bid' ? 'sell' : 'buy';
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': trade['id'],
                'order': undefined,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetMarketTradesTradingPairId(this.extend({
                                    'trading_pair_id': market['id'],
                                    'limit': limit // default 20, but that seems too little
                                }, params));

                            case 5:
                                response = _context6.sent;
                                trades = response['result']['trades'];
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [
            // they say that timestamps are Unix Timestamps in seconds, but in fact those are milliseconds
            ohlcv['timestamp'], parseFloat(ohlcv['open']), parseFloat(ohlcv['high']), parseFloat(ohlcv['low']), parseFloat(ohlcv['close']), parseFloat(ohlcv['volume'])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, endTime, request, response, ohlcv;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                //
                                // they say in their docs that end_time defaults to current server time
                                // but if you don't specify it, their range limits does not allow you to query anything
                                //
                                // they also say that start_time defaults to 0,
                                // but most calls fail if you do not specify any of end_time
                                //
                                // to make things worse, their docs say it should be a Unix Timestamp
                                // but with seconds it fails, so we set milliseconds (somehow it works that way)
                                //

                                endTime = this.milliseconds();
                                request = {
                                    'trading_pair_id': market['id'],
                                    'timeframe': this.timeframes[timeframe],
                                    'end_time': endTime
                                };

                                if (typeof since !== 'undefined') request['start_time'] = since;
                                _context7.next = 8;
                                return this.publicGetChartCandlesTradingPairId(this.extend(request, params));

                            case 8:
                                response = _context7.sent;
                                ohlcv = response['result']['candles'];
                                return _context7.abrupt('return', this.parseOHLCVs(ohlcv, market, timeframe, since, limit));

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x19) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, i, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateGetWalletBalances(params);

                            case 4:
                                response = _context8.sent;
                                result = { 'info': response };
                                balances = response['result']['balances'];

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    currency = balance['currency'];

                                    if (currency in this.currencies_by_id) currency = this.currencies_by_id[currency]['code'];
                                    account = {
                                        'used': parseFloat(balance['on_order']),
                                        'total': parseFloat(balance['total'])
                                    };

                                    account['free'] = parseFloat(account['total'] - account['used']);
                                    result[currency] = account;
                                }
                                return _context8.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchBalance() {
                return _ref8.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (typeof market === 'undefined') {
                var marketId = this.safeString(order, 'trading_pair');
                if (typeof marketId === 'undefined') marketId = this.safeString(order, 'trading_pair_id');
                market = this.markets_by_id[marketId];
            }
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var timestamp = order['timestamp'];
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'size');
            var filled = this.safeFloat(order, 'filled');
            var remaining = amount - filled;
            // new, queued, open, partially_filled, filled, cancelled
            var status = order['state'];
            if (status === 'filled') {
                status = 'closed';
            } else if (status === 'cancelled') {
                status = 'canceled';
            } else {
                status = 'open';
            }
            var side = order['side'] === 'bid' ? 'buy' : 'sell';
            return {
                'id': order['id'],
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['type'], // market, limit, stop, stop_limit, trailing_stop, fill_or_kill
                'side': side,
                'price': price,
                'cost': price * amount,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, response, order, id;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                side = side === 'sell' ? 'ask' : 'bid';
                                request = {
                                    'trading_pair_id': market['id'],
                                    'type': type, // market, limit, stop, stop_limit
                                    'side': side,
                                    'size': this.amountToString(symbol, amount)
                                };

                                if (type !== 'market') request['price'] = this.priceToPrecision(symbol, price);
                                _context9.next = 8;
                                return this.privatePostTradingOrders(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                order = this.parseOrder(response['result']['order'], market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context9.abrupt('return', order);

                            case 13:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x26, _x27, _x28, _x29) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.privateDeleteTradingOrdersOrderId(this.extend({
                                    'order_id': id
                                }, params));

                            case 2:
                                response = _context10.sent;
                                return _context10.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x32) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.privateGetTradingOrdersOrderId(this.extend({
                                    'order_id': id.toString()
                                }, params));

                            case 4:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrder(response['result']['order']));

                            case 6:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrder(_x35) {
                return _ref11.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var result, orders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context12.next = 4;
                                return this.privateGetTradingOrders(params);

                            case 4:
                                result = _context12.sent;
                                orders = this.parseOrders(result['result']['orders'], undefined, since, limit);

                                if (!(typeof symbol !== 'undefined')) {
                                    _context12.next = 8;
                                    break;
                                }

                                return _context12.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 8:
                                return _context12.abrupt('return', orders);

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOpenOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchOrderTrades',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, market;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context13.next = 4;
                                return this.privateGetTradingOrdersOrderIdTrades(this.extend({
                                    'order_id': id
                                }, params));

                            case 4:
                                response = _context13.sent;
                                market = typeof symbol === 'undefined' ? undefined : this.market(symbol);
                                return _context13.abrupt('return', this.parseTrades(response['result']['trades'], market));

                            case 7:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOrderTrades(_x42) {
                return _ref13.apply(this, arguments);
            }

            return fetchOrderTrades;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context14.next = 5;
                                return this.privatePostWalletDepositAddresses({
                                    'currency': currency['id']
                                });

                            case 5:
                                response = _context14.sent;
                                address = this.safeString(response['result']['deposit_address'], 'address');

                                this.checkAddress(address);
                                return _context14.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function createDepositAddress(_x45) {
                return _ref14.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, addresses, address;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context15.next = 5;
                                return this.privateGetWalletDepositAddresses(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context15.sent;
                                addresses = this.safeValue(response['result'], 'deposit_addresses', []);
                                address = undefined;

                                if (addresses.length > 0) {
                                    address = this.safeString(addresses[0], 'address');
                                }
                                this.checkAddress(address);
                                return _context15.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 11:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchDepositAddress(_x47) {
                return _ref15.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(code, amount, address) {
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context16.next = 5;
                                return this.privatePostWalletWithdrawals(this.extend({
                                    'currency': currency['id'],
                                    'amount': amount,
                                    'address': address
                                }, params));

                            case 5:
                                response = _context16.sent;
                                return _context16.abrupt('return', {
                                    'id': response['result']['withdrawal_id'],
                                    'info': response
                                });

                            case 7:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function withdraw(_x49, _x50, _x51) {
                return _ref16.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api']['web'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            headers = {};
            if (api === 'private') {
                this.checkRequiredCredentials();
                // headers['device_id'] = this.apiKey;
                headers['nonce'] = this.nonce().toString();
                headers['Authorization'] = this.apiKey;
            }
            if (method === 'GET') {
                query = this.urlencode(query);
                if (query.length) url += '?' + query;
            } else {
                headers['Content-type'] = 'application/json; charset=UTF-8';
                body = this.json(query);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code < 400 || code >= 600) {
                return;
            }
            if (body[0] !== '{') {
                throw new ExchangeError(this.id + ' ' + body);
            }
            var response = JSON.parse(body);
            var errorCode = this.safeValue(response['error'], 'error_code');
            var feedback = this.id + ' ' + this.json(response);
            var exceptions = this.exceptions;
            if (errorCode in exceptions) {
                throw new exceptions[errorCode](feedback);
            }
            throw new ExchangeError(feedback);
        }
    }]);

    return cobinhood;
}(Exchange);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coincheck, _Exchange);

    function coincheck() {
        _classCallCheck(this, coincheck);

        return _possibleConstructorReturn(this, (coincheck.__proto__ || Object.getPrototypeOf(coincheck)).apply(this, arguments));
    }

    _createClass(coincheck, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coincheck.prototype.__proto__ || Object.getPrototypeOf(coincheck.prototype), 'describe', this).call(this), {
                'id': 'coincheck',
                'name': 'coincheck',
                'countries': ['JP', 'ID'],
                'rateLimit': 1500,
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766464-3b5c3c74-5ed9-11e7-840e-31b32968e1da.jpg',
                    'api': 'https://coincheck.com/api',
                    'www': 'https://coincheck.com',
                    'doc': 'https://coincheck.com/documents/exchange/api'
                },
                'api': {
                    'public': {
                        'get': ['exchange/orders/rate', 'order_books', 'rate/{pair}', 'ticker', 'trades']
                    },
                    'private': {
                        'get': ['accounts', 'accounts/balance', 'accounts/leverage_balance', 'bank_accounts', 'deposit_money', 'exchange/orders/opens', 'exchange/orders/transactions', 'exchange/orders/transactions_pagination', 'exchange/leverage/positions', 'lending/borrows/matches', 'send_money', 'withdraws'],
                        'post': ['bank_accounts', 'deposit_money/{id}/fast', 'exchange/orders', 'exchange/transfers/to_leverage', 'exchange/transfers/from_leverage', 'lending/borrows', 'lending/borrows/{id}/repay', 'send_money', 'withdraws'],
                        'delete': ['bank_accounts/{id}', 'exchange/orders/{id}', 'withdraws/{id}']
                    }
                },
                'markets': {
                    'BTC/JPY': { 'id': 'btc_jpy', 'symbol': 'BTC/JPY', 'base': 'BTC', 'quote': 'JPY' } // the only real pair
                    // 'ETH/JPY': { 'id': 'eth_jpy', 'symbol': 'ETH/JPY', 'base': 'ETH', 'quote': 'JPY' },
                    // 'ETC/JPY': { 'id': 'etc_jpy', 'symbol': 'ETC/JPY', 'base': 'ETC', 'quote': 'JPY' },
                    // 'DAO/JPY': { 'id': 'dao_jpy', 'symbol': 'DAO/JPY', 'base': 'DAO', 'quote': 'JPY' },
                    // 'LSK/JPY': { 'id': 'lsk_jpy', 'symbol': 'LSK/JPY', 'base': 'LSK', 'quote': 'JPY' },
                    // 'FCT/JPY': { 'id': 'fct_jpy', 'symbol': 'FCT/JPY', 'base': 'FCT', 'quote': 'JPY' },
                    // 'XMR/JPY': { 'id': 'xmr_jpy', 'symbol': 'XMR/JPY', 'base': 'XMR', 'quote': 'JPY' },
                    // 'REP/JPY': { 'id': 'rep_jpy', 'symbol': 'REP/JPY', 'base': 'REP', 'quote': 'JPY' },
                    // 'XRP/JPY': { 'id': 'xrp_jpy', 'symbol': 'XRP/JPY', 'base': 'XRP', 'quote': 'JPY' },
                    // 'ZEC/JPY': { 'id': 'zec_jpy', 'symbol': 'ZEC/JPY', 'base': 'ZEC', 'quote': 'JPY' },
                    // 'XEM/JPY': { 'id': 'xem_jpy', 'symbol': 'XEM/JPY', 'base': 'XEM', 'quote': 'JPY' },
                    // 'LTC/JPY': { 'id': 'ltc_jpy', 'symbol': 'LTC/JPY', 'base': 'LTC', 'quote': 'JPY' },
                    // 'DASH/JPY': { 'id': 'dash_jpy', 'symbol': 'DASH/JPY', 'base': 'DASH', 'quote': 'JPY' },
                    // 'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC' },
                    // 'ETC/BTC': { 'id': 'etc_btc', 'symbol': 'ETC/BTC', 'base': 'ETC', 'quote': 'BTC' },
                    // 'LSK/BTC': { 'id': 'lsk_btc', 'symbol': 'LSK/BTC', 'base': 'LSK', 'quote': 'BTC' },
                    // 'FCT/BTC': { 'id': 'fct_btc', 'symbol': 'FCT/BTC', 'base': 'FCT', 'quote': 'BTC' },
                    // 'XMR/BTC': { 'id': 'xmr_btc', 'symbol': 'XMR/BTC', 'base': 'XMR', 'quote': 'BTC' },
                    // 'REP/BTC': { 'id': 'rep_btc', 'symbol': 'REP/BTC', 'base': 'REP', 'quote': 'BTC' },
                    // 'XRP/BTC': { 'id': 'xrp_btc', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC' },
                    // 'ZEC/BTC': { 'id': 'zec_btc', 'symbol': 'ZEC/BTC', 'base': 'ZEC', 'quote': 'BTC' },
                    // 'XEM/BTC': { 'id': 'xem_btc', 'symbol': 'XEM/BTC', 'base': 'XEM', 'quote': 'BTC' },
                    // 'LTC/BTC': { 'id': 'ltc_btc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC' },
                    // 'DASH/BTC': { 'id': 'dash_btc', 'symbol': 'DASH/BTC', 'base': 'DASH', 'quote': 'BTC' },
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, currency, lowercase, account, reserved;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetAccountsBalance();

                            case 2:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();

                                    if (lowercase in balances) account['free'] = parseFloat(balances[lowercase]);
                                    reserved = lowercase + '_reserved';

                                    if (reserved in balances) account['used'] = parseFloat(balances[reserved]);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(symbol !== 'BTC/JPY')) {
                                    _context2.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchOrderBook () supports BTC/JPY only');

                            case 2:
                                _context2.next = 4;
                                return this.publicGetOrderBooks(params);

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(symbol !== 'BTC/JPY')) {
                                    _context3.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchTicker () supports BTC/JPY only');

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                ticker = _context3.sent;
                                timestamp = ticker['timestamp'] * 1000;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'volume'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parse8601(trade['created_at']);
            return {
                'id': trade['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['order_type'],
                'price': this.safeFloat(trade, 'rate'),
                'amount': this.safeFloat(trade, 'amount'),
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(symbol !== 'BTC/JPY')) {
                                    _context4.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchTrades () supports BTC/JPY only');

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context4.sent;

                                if (!('success' in response)) {
                                    _context4.next = 10;
                                    break;
                                }

                                if (!response['success']) {
                                    _context4.next = 10;
                                    break;
                                }

                                if (!(typeof response['data'] !== 'undefined')) {
                                    _context4.next = 10;
                                    break;
                                }

                                return _context4.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 10:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, order_type, prefix, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                order = {
                                    'pair': this.marketId(symbol)
                                };

                                if (type === 'market') {
                                    order_type = type + '_' + side;

                                    order['order_type'] = order_type;
                                    prefix = side === 'buy' ? order_type + '_' : '';

                                    order[prefix + 'amount'] = amount;
                                } else {
                                    order['order_type'] = side;
                                    order['rate'] = price;
                                    order['amount'] = amount;
                                }
                                _context5.next = 4;
                                return this.privatePostExchangeOrders(this.extend(order, params));

                            case 4:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['id'].toString()
                                });

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privateDeleteExchangeOrdersId({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var queryString = '';
                if (method === 'GET') {
                    if (Object.keys(query).length) url += '?' + this.urlencode(this.keysort(query));
                } else {
                    if (Object.keys(query).length) {
                        body = this.urlencode(this.keysort(query));
                        queryString = body;
                    }
                }
                var auth = nonce + url + queryString;
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'ACCESS-KEY': this.apiKey,
                    'ACCESS-NONCE': nonce,
                    'ACCESS-SIGNATURE': this.hmac(this.encode(auth), this.encode(this.secret))
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!(api === 'public')) {
                                    _context7.next = 5;
                                    break;
                                }

                                return _context7.abrupt('return', response);

                            case 5:
                                if (!('success' in response)) {
                                    _context7.next = 8;
                                    break;
                                }

                                if (!response['success']) {
                                    _context7.next = 8;
                                    break;
                                }

                                return _context7.abrupt('return', response);

                            case 8:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coincheck;
}(Exchange);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinex, _Exchange);

    function coinex() {
        _classCallCheck(this, coinex);

        return _possibleConstructorReturn(this, (coinex.__proto__ || Object.getPrototypeOf(coinex)).apply(this, arguments));
    }

    _createClass(coinex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinex.prototype.__proto__ || Object.getPrototypeOf(coinex.prototype), 'describe', this).call(this), {
                'id': 'coinex',
                'name': 'CoinEx',
                'version': 'v1',
                'countries': 'CN',
                'rateLimit': 1000,
                'has': {
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true
                },
                'timeframes': {
                    '1m': '1min',
                    '3m': '3min',
                    '5m': '5min',
                    '15m': '15min',
                    '30m': '30min',
                    '1h': '1hour',
                    '2h': '2hour',
                    '4h': '4hour',
                    '6h': '6hour',
                    '12h': '12hour',
                    '1d': '1day',
                    '3d': '3day',
                    '1w': '1week'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38046312-0b450aac-32c8-11e8-99ab-bc6b136b6cc7.jpg',
                    'api': {
                        'public': 'https://api.coinex.com',
                        'private': 'https://api.coinex.com',
                        'web': 'https://www.coinex.com'
                    },
                    'www': 'https://www.coinex.com',
                    'doc': 'https://github.com/coinexcom/coinex_exchange_api/wiki',
                    'fees': 'https://www.coinex.com/fees'
                },
                'api': {
                    'web': {
                        'get': ['res/market']
                    },
                    'public': {
                        'get': ['market/list', 'market/ticker', 'market/ticker/all', 'market/depth', 'market/deals', 'market/kline']
                    },
                    'private': {
                        'get': ['balance', 'order', 'order/pending', 'order/finished', 'order/finished/{id}', 'order/user/deals'],
                        'post': ['order/limit', 'order/market'],
                        'delete': ['order/pending']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0,
                        'taker': 0.001
                    },
                    'funding': {
                        'withdraw': {
                            'BCH': 0.0,
                            'BTC': 0.001,
                            'LTC': 0.001,
                            'ETH': 0.001,
                            'ZEC': 0.0001,
                            'DASH': 0.0001
                        }
                    }
                },
                'limits': {
                    'amount': {
                        'min': 0.001,
                        'max': undefined
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, keys, i, key, market, id, quoteId, baseId, base, quote, symbol, precision, numMergeLevels;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.webGetResMarket();

                            case 2:
                                response = _context.sent;
                                markets = response['data']['market_info'];
                                result = [];
                                keys = Object.keys(markets);

                                for (i = 0; i < keys.length; i++) {
                                    key = keys[i];
                                    market = markets[key];
                                    id = market['market'];
                                    quoteId = market['buy_asset_type'];
                                    baseId = market['sell_asset_type'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': market['sell_asset_type_places'],
                                        'price': market['buy_asset_type_places']
                                    };
                                    numMergeLevels = market['merge'].length;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'taker': this.safeFloat(market, 'taker_fee_rate'),
                                        'maker': this.safeFloat(market, 'maker_fee_rate'),
                                        'info': market,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': this.safeFloat(market, 'least_amount'),
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': parseFloat(market['merge'][numMergeLevels - 1]),
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['date'];
            var symbol = market['symbol'];
            ticker = ticker['ticker'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetMarketTicker(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(response['data'], market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, data, timestamp, tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetMarketTickerAll(params);

                            case 4:
                                response = _context3.sent;
                                data = response['data'];
                                timestamp = data['date'];
                                tickers = data['ticker'];
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = {
                                        'date': timestamp,
                                        'ticker': tickers[id]
                                    };

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context3.abrupt('return', result);

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetMarketDepth(this.extend({
                                    'market': this.marketId(symbol),
                                    'merge': '0.00000001'
                                }, params));

                            case 4:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseOrderBook(response['data']));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeInteger(trade, 'create_time');
            var tradeId = this.safeString(trade, 'id');
            var orderId = this.safeString(trade, 'id');
            if (!timestamp) {
                timestamp = trade['date'];
                orderId = undefined;
            } else {
                tradeId = undefined;
            }
            timestamp *= 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.safeFloat(trade, 'deal_money');
            if (!cost) cost = parseFloat(this.costToPrecision(symbol, price * amount));
            var fee = this.safeFloat(trade, 'fee');
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': tradeId,
                'order': orderId,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetMarketDeals(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x9) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0], parseFloat(ohlcv[1]), parseFloat(ohlcv[3]), parseFloat(ohlcv[4]), parseFloat(ohlcv[2]), parseFloat(ohlcv[5])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '5m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetMarketKline(this.extend({
                                    'market': market['id'],
                                    'type': this.timeframes[timeframe]
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOHLCVs(response['data'], market, timeframe, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOHLCV(_x17) {
                return _ref6.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, currencies, i, id, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privateGetBalance(params);

                            case 4:
                                response = _context7.sent;
                                result = { 'info': response };
                                balances = response['data'];
                                currencies = Object.keys(balances);

                                for (i = 0; i < currencies.length; i++) {
                                    id = currencies[i];
                                    balance = balances[id];
                                    currency = this.commonCurrencyCode(id);
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': parseFloat(balance['frozen']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context7.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchBalance() {
                return _ref7.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            // TODO: check if it's actually milliseconds, since examples were in seconds
            var timestamp = this.safeInteger(order, 'create_time') * 1000;
            var price = this.safeFloat(order, 'price');
            var cost = this.safeFloat(order, 'deal_money');
            var amount = this.safeFloat(order, 'amount');
            var filled = this.safeFloat(order, 'deal_amount');
            var symbol = market['symbol'];
            var remaining = this.amountToPrecision(symbol, amount - filled);
            var status = order['status'];
            if (status === 'done') {
                status = 'closed';
            } else {
                // not_deal
                // part_deal
                status = 'open';
            }
            return {
                'id': this.safeString(order, 'id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['order_type'],
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': {
                    'currency': market['quote'],
                    'cost': this.safeFloat(order, 'deal_fee')
                },
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, market, request, response, order, id;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePostOrder' + this.capitalize(type);
                                market = this.market(symbol);

                                amount = parseFloat(amount);
                                request = {
                                    'market': market['id'],
                                    'amount': this.amountToPrecision(symbol, amount),
                                    'type': side
                                };

                                if (type === 'limit') {
                                    price = parseFloat(price);
                                    request['price'] = this.priceToPrecision(symbol, price);
                                }
                                _context8.next = 9;
                                return this[method](this.extend(request, params));

                            case 9:
                                response = _context8.sent;
                                order = this.parseOrder(response['data'], market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context8.abrupt('return', order);

                            case 14:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x24, _x25, _x26, _x27) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context9.next = 5;
                                return this.privateDeleteOrderPending(this.extend({
                                    'id': id,
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(response['data'], market));

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x30) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context10.next = 5;
                                return this.privateGetOrder(this.extend({
                                    'id': id,
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(response['data'], market));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrder(_x33) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'market': market['id']
                                };

                                if (limit) request['limit'] = limit;
                                _context11.next = 7;
                                return this.privateGetOrderPending(this.extend(request, params));

                            case 7:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response['data']['data'], market));

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'market': market['id']
                                };

                                if (limit) request['limit'] = limit;
                                _context12.next = 7;
                                return this.privateGetOrderFinished(this.extend(request, params));

                            case 7:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseOrders(response['data']['data'], market));

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchClosedOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context13.next = 5;
                                return this.privateGetOrderUserDeals(this.extend({
                                    'market': market['id'],
                                    'page': 1,
                                    'limit': 100
                                }, params));

                            case 5:
                                response = _context13.sent;
                                return _context13.abrupt('return', this.parseTrades(response['data']['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchMyTrades() {
                return _ref13.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            path = this.implodeParams(path, params);
            var url = this.urls['api'][api] + '/' + this.version + '/' + path;
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else if (api === 'web') {
                url = this.urls['api'][api] + '/' + path;
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                query = this.extend({
                    'access_id': this.apiKey,
                    'tonce': nonce.toString()
                }, query);
                query = this.keysort(query);
                var urlencoded = this.urlencode(query);
                var signature = this.hash(this.encode(urlencoded + '&secret_key=' + this.secret));
                headers = {
                    'Authorization': signature.toUpperCase(),
                    'Content-Type': 'application/json'
                };
                if (method === 'GET' || method === 'DELETE') {
                    url += '?' + urlencoded;
                } else {
                    body = this.json(query);
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, code, data, responseCodes, ErrorClass;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context14.sent;
                                code = this.safeString(response, 'code');
                                data = this.safeValue(response, 'data');

                                if (!(code !== '0' || !data)) {
                                    _context14.next = 9;
                                    break;
                                }

                                responseCodes = {
                                    '24': AuthenticationError,
                                    '25': AuthenticationError,
                                    '107': InsufficientFunds,
                                    '600': OrderNotFound,
                                    '601': InvalidOrder,
                                    '602': InvalidOrder,
                                    '606': InvalidOrder
                                };
                                ErrorClass = this.safeValue(responseCodes, code, ExchangeError);
                                throw new ErrorClass(response['message']);

                            case 9:
                                return _context14.abrupt('return', response);

                            case 10:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function request(_x53) {
                return _ref14.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coinex;
}(Exchange);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinexchange, _Exchange);

    function coinexchange() {
        _classCallCheck(this, coinexchange);

        return _possibleConstructorReturn(this, (coinexchange.__proto__ || Object.getPrototypeOf(coinexchange)).apply(this, arguments));
    }

    _createClass(coinexchange, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinexchange.prototype.__proto__ || Object.getPrototypeOf(coinexchange.prototype), 'describe', this).call(this), {
                'id': 'coinexchange',
                'name': 'CoinExchange',
                'countries': ['IN', 'JP', 'KR', 'VN', 'US'],
                'rateLimit': 1000,
                // new metainfo interface
                'has': {
                    'privateAPI': false,
                    'createOrder': false,
                    'createMarketOrder': false,
                    'createLimitOrder': false,
                    'cancelOrder': false,
                    'editOrder': false,
                    'fetchTrades': false,
                    'fetchOHLCV': false,
                    'fetchCurrencies': true,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/34842303-29c99fca-f71c-11e7-83c1-09d900cb2334.jpg',
                    'api': 'https://www.coinexchange.io/api/v1',
                    'www': 'https://www.coinexchange.io',
                    'doc': 'https://coinexchangeio.github.io/slate/',
                    'fees': 'https://www.coinexchange.io/fees'
                },
                'api': {
                    'public': {
                        'get': ['getcurrency', 'getcurrencies', 'getmarkets', 'getmarketsummaries', 'getmarketsummary', 'getorderbook']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0015,
                        'taker': 0.0015
                    },
                    'funding': {
                        'withdraw': {
                            '1337': 0.01,
                            '420G': 0.01,
                            '611': 0.1,
                            'ACC': 0.01,
                            'ACES': 0.01,
                            'ACO': 0.01,
                            'ACP': 0.01,
                            'ADCN': 500.0,
                            'ADST': 1.0,
                            'ADZ': 0.1,
                            'AGRI': 0.01,
                            'AI': 1.0,
                            'AKY': 0.01,
                            'ALIS': 1.0,
                            'ALL': 0.2,
                            'AMC': 0.1,
                            'AMMO': 0.01,
                            'AMS': 0.01,
                            'ANTX': 0.01,
                            'ANY': 1.0,
                            'ARG': 0.1,
                            'ARGUS': 0.01,
                            'ARGUSOLD': 0.01,
                            'ASN': 0.01,
                            'ATOM': 0.01,
                            'ATX': 0.01,
                            'AU': 0.01,
                            'B2B': 1.0,
                            'B3': 0.01,
                            'BAKED': 0.01,
                            'BCC': 0.01,
                            'BCH': 0.001,
                            'BCM': 0.01,
                            'BDL': 0.01,
                            'BEER': 0.01,
                            'BELA': 0.01,
                            'BENJI': 0.05,
                            'BET': 0.01,
                            'BFI': 1.0,
                            'BIGUP': 1.0,
                            'BIRDS': 0.01,
                            'BITB': 0.1,
                            'BIXC': 0.01,
                            'BIZ': 0.01,
                            'BLAS': 0.1,
                            'BLAZR': 0.2,
                            'BLK': 0.01,
                            'BLN': 1.0,
                            'BLUE': 1.0,
                            'BOAT': 1.0,
                            'BON': 0.01,
                            'BONPAY': 1.0,
                            'BOPS': 0.01,
                            'BPOK': 0.1,
                            'BQ': 1.0,
                            'BRAT': 0.01,
                            'BRC': 1.0,
                            'BRIT': 0.01,
                            'BSN': 1.0,
                            'BSR': 0.01,
                            'BTBc': 0.01,
                            'BTC': 0.001,
                            'BTCRED': 1.0,
                            'BTCRF': 0.01,
                            'BTDX': 0.1,
                            'BTE': 1.0,
                            'BTPL': 0.01,
                            'BULLS': 0.01,
                            'BUZZ': 0.01,
                            'BXT': 0.01,
                            'C47': 1.0,
                            'CACH': 0.2,
                            'CALC': 0.01,
                            'CANN': 0.01,
                            'CBANK': 1.0,
                            'CDX': 1.0,
                            'CHEAP': 0.01,
                            'CHESS': 0.01,
                            'CHILI': 0.01,
                            'CHIPS': 0.1,
                            'CJ': 0.1,
                            'CLT': 0.1,
                            'CMPCO': 0.2,
                            'CMX': 0.01,
                            'CNNC': 0.02,
                            'CNT': 0.01,
                            'CO2': 1.0,
                            'COOC': 0.01,
                            'COUPE': 0.01,
                            'CQST': 0.1,
                            'CRACKERS': 0.01,
                            'CRDNC': 0.01,
                            'CREA': 0.02,
                            'CREAK': 0.01,
                            'CREVA2': 0.01,
                            'CRMSN': 0.01,
                            'CRN': 0.01,
                            'CRW': 0.01,
                            'CTIC2': 0.01,
                            'CUBE': 0.01,
                            'CXT': 0.01,
                            'CYCLONE': 0.01,
                            'CYDER': 0.01,
                            'DAG': 0.01,
                            'DALC': 1.0,
                            'DARI': 0.01,
                            'DASH': 0.01,
                            'DAV': 0.01,
                            'DBIC': 0.1,
                            'DCN': 1.0,
                            'DEM': 0.01,
                            'DFS': 0.01,
                            'DGB': 0.1,
                            'DGC': 0.1,
                            'DIME': 0.01,
                            'DMB': 0.01,
                            'DMC': 0.1,
                            'DNCV2': 0.01,
                            'DNE': 1.0,
                            'DNR': 0.01,
                            'DOGE': 2.0,
                            'DOGEJ': 1.0,
                            'DP': 0.01,
                            'DRGN': 1.0,
                            'DRS': 0.1,
                            'DSE': 0.01,
                            'DSR': 0.01,
                            'DTCT': 1.0,
                            'DUTCH': 0.01,
                            'EBC': 0.01,
                            'EBT': 0.01,
                            'ECC': 0.1,
                            'ECN': 0.01,
                            'EDRC': 0.01,
                            'EECN': 0.01,
                            'EGC': 0.1,
                            'ELCO': 0.1,
                            'ELIX': 1.0,
                            'ELS': 0.01,
                            'ELT': 1.0,
                            'EMC': 0.01,
                            'EMIRG': 0.01,
                            'ENTRC': 1.0,
                            'ENZO': 0.1,
                            'EQL': 1.0,
                            'EQT': 0.1,
                            'ERSO': 0.01,
                            'ERT': 1.0,
                            'ERY': 0.01,
                            'ESP': 0.1,
                            'ETBS': 1.0,
                            'ETC': 0.1,
                            'ETG': 1.0,
                            'ETH': 0.01,
                            'ETHD': 0.01,
                            'ETHOS': 1.0,
                            'ETN': 2.0,
                            'EUROP': 0.1,
                            'EXCL': 0.1,
                            'EXTN': 0.01,
                            'FAIR': 0.01,
                            'FAP': 1.0,
                            'FAZZ': 0.01,
                            'FCH': 0.01,
                            'FGZ': 0.1,
                            'FLASH': 0.01,
                            'FLIK': 1.0,
                            'FRT': 0.1,
                            'FSX': 0.1,
                            'FTC': 0.01,
                            'FXE': 2.0,
                            'GAIN': 1.0,
                            'GB': 0.1,
                            'GBX': 0.01,
                            'GDC': 1.0,
                            'GEERT': 0.01,
                            'GET': 0.01,
                            'GFC': 1.0,
                            'GLS': 0.01,
                            'GLT': 0.01,
                            'GLTC': 0.01,
                            'GMB': 0.01,
                            'GMX': 0.01,
                            'GOKUOLD': 0.1,
                            'GOLD': 0.01,
                            'GOLF': 0.1,
                            'GOOD': 2.0,
                            'GP': 0.01,
                            'GRE': 0.01,
                            'GREENF': 0.01,
                            'GRMD': 1.0,
                            'GRS': 0.01,
                            'GRX': 1.0,
                            'GTC': 0.01,
                            'GWC': 0.2,
                            'HALLO': 0.01,
                            'HBC': 0.01,
                            'HC': 0.01,
                            'HEALTHY': 0.01,
                            'HIGH': 0.01,
                            'HMC': 0.01,
                            'HNC': 0.01,
                            'HOC': 0.01,
                            'HODL': 0.01,
                            'HOLLY': 1.0,
                            'HONEY': 0.01,
                            'HOPE': 0.01,
                            'HPC': 0.01,
                            'HUB': 1.0,
                            'HYP': 0.01,
                            'HYPER': 0.01,
                            'IBC': 1.0,
                            'ICE': 1.0,
                            'ICOT': 1.0,
                            'IFT': 1.0,
                            'ILC': 0.01,
                            'IMX': 0.01,
                            'INDIA': 0.01,
                            'INFO': 0.01,
                            'INSN': 0.01,
                            'INXT': 1.0,
                            'IOE': 0.01,
                            'IQT': 1.0,
                            'IXC': 0.01,
                            'JAPAN': 0.01,
                            'JEDI': 0.01,
                            'JET': 1.0,
                            'JIN': 0.2,
                            'KAYI': 0.01,
                            'KB3': 0.01,
                            'KGB': 0.01,
                            'KLC': 0.1,
                            'KMD': 0.01,
                            'KOBO': 1.0,
                            'KOI': 0.01,
                            'KORUNA': 0.1,
                            'KRA': 0.01,
                            'KUBO': 0.01,
                            'KURT': 0.01,
                            'LA': 1.0,
                            'LAMBO': 0.01,
                            'LCT': 1.0,
                            'LDC': 0.01,
                            'LEVO': 0.1,
                            'LIFE': 1.0,
                            'LINDA': 0.01,
                            'LINX': 0.01,
                            'LIZ': 0.01,
                            'LMC': 0.1,
                            'LNK': 0.05,
                            'LRC': 1.0,
                            'LTC': 0.01,
                            'LTG': 1.0,
                            'LUCK': 0.01,
                            'LUNA': 0.01,
                            'LVPS': 0.01,
                            'MAC': 2.0,
                            'MAG': 0.01,
                            'MALC': 0.01,
                            'MARS': 0.01,
                            'MARS2': 0.01,
                            'MAXI': 0.01,
                            'MAY': 0.01,
                            'MBC': 0.01,
                            'MBIT': 0.01,
                            'MCB': 1.0,
                            'MEC': 0.1,
                            'MENTAL': 0.1,
                            'MER': 0.1,
                            'MET': 0.01,
                            'MGM': 0.01,
                            'MGT': 0.01,
                            'MILO': 0.5,
                            'MINEX': 1.0,
                            'MINT': 1.0,
                            'MIPS': 1.0,
                            'MNX': 0.01,
                            'MOIN': 0.1,
                            'MOON': 0.1,
                            'MSCN': 0.01,
                            'MSP': 1.0,
                            'MST': 0.1,
                            'MTH': 1.0,
                            'MUE': 0.1,
                            'MUX': 1.0,
                            'MXC': 0.01,
                            'MXT': 0.1,
                            'MYB': 1.0,
                            'NBIT': 0.1,
                            'NBX': 0.01,
                            'NEOG': 1.0,
                            'NEON': 0.01,
                            'NLC2': 0.01,
                            'NLG': 0.1,
                            'NRN': 0.01,
                            'NRO': 0.01,
                            'NTC': 1.0,
                            'NTO': 1.0,
                            'NUA': 1.0,
                            'NUMUS': 0.01,
                            'OC': 0.01,
                            'OGN': 0.01,
                            'ORO': 0.01,
                            'PARIS': 0.01,
                            'PAYU': 0.1,
                            'PCN': 1.0,
                            'PCS': 0.01,
                            'PDG': 0.01,
                            'PEC': 0.01,
                            'PGL': 1.0,
                            'PHN': 1.0,
                            'PICO': 0.1,
                            'PIE': 0.01,
                            'PIGGY': 0.1,
                            'PIVX': 0.2,
                            'PIX': 1.0,
                            'PKT': 1.0,
                            'PLACO': 0.01,
                            'PLX': 1.0,
                            'POL': 0.01,
                            'POLOB': 0.1,
                            'POS': 1.0,
                            'POST': 1.0,
                            'POSW': 0.01,
                            'POT': 0.1,
                            'PRE': 1.0,
                            'PRIMU': 0.01,
                            'PRL': 1.0,
                            'PRN': 1.0,
                            'PRX': 0.01,
                            'PT': 1.0,
                            'PTS': 1.0,
                            'PURA': 1.0,
                            'PURE': 0.01,
                            'PUT': 0.1,
                            'PWC': 0.01,
                            'PWR': 0.1,
                            'QTUM': 0.01,
                            'QUANT': 0.01,
                            'RAIN': 0.5,
                            'RBL': 0.01,
                            'RDC': 0.01,
                            'REC': 0.01,
                            'REGA': 0.1,
                            'REX': 1.0,
                            'RHO': 0.1,
                            'RIYA': 1.0,
                            'RMC': 2.0,
                            'RNS': 0.01,
                            'ROC': 0.0,
                            'ROOFS': 0.01,
                            'RUB': 0.01,
                            'RUNE': 0.01,
                            'RUNNERS': 0.01,
                            'RUP': 0.01,
                            'SBIT': 0.01,
                            'SCL': 1.0,
                            'SCORE': 0.01,
                            'SCOREOLD': 0.01,
                            'SDASH': 0.01,
                            'SFC': 0.01,
                            'SFE': 0.01,
                            'SGR': 1.0,
                            'SHIT': 0.1,
                            'SHM': 0.1,
                            'SHND': 0.1,
                            'SHOT': 0.1,
                            'SIC': 0.1,
                            'SILK2': 0.01,
                            'SIMP': 0.001,
                            'SISA': 1.0,
                            'SKOIN': 0.01,
                            'SKULL': 0.01,
                            'SLEVIN': 0.01,
                            'SLR': 0.01,
                            'SMART': 0.01,
                            'SMS': 0.002,
                            'SNOW': 0.01,
                            'SOLAR': 0.01,
                            'SPRTS': 1.0,
                            'SRC': 0.01,
                            'SST': 0.1,
                            'STARS': 0.01,
                            'STN': 0.01,
                            'STO': 0.01,
                            'STX': 1.0,
                            'SUPER': 0.01,
                            'SUPERMAN': 0.01,
                            'SURGE': 0.01,
                            'SWC': 0.1,
                            'SYNQ': 0.01,
                            'SYNX': 0.01,
                            'TAAS': 2.0,
                            'TBS': 0.01,
                            'TCOIN': 0.01,
                            'TELL': 0.1,
                            'TER': 0.005,
                            'TGT': 1.0,
                            'TIGER': 0.01,
                            'TIPS': 0.01,
                            'TLE': 0.01,
                            'TOPAZ': 0.01,
                            'TOR': 0.01,
                            'TPC': 0.01,
                            'TPG': 0.01,
                            'TPI': 1.0,
                            'TRANCE': 0.01,
                            'TRC': 0.01,
                            'TRUX': 0.01,
                            'TSE': 0.1,
                            'TSTR': 0.01,
                            'TURBO': 0.01,
                            'UFO': 0.01,
                            'UK': 0.01,
                            'ULA': 0.01,
                            'UNIFY': 0.0,
                            'UNIT': 0.1,
                            'UNO': 0.001,
                            'UP': 0.01,
                            'UQC': 1.0,
                            'USA': 0.01,
                            'VC': 0.01,
                            'VGS': 0.01,
                            'VIDZ': 0.01,
                            'VISIO': 0.05,
                            'VLTC': 0.1,
                            'VOISE': 1.0,
                            'VONE': 0.01,
                            'VOX': 0.01,
                            'VSX': 0.01,
                            'VULCANO': 0.01,
                            'WASH': 0.1,
                            'WCL': 1.0,
                            'WINK': 0.01,
                            'WOMEN': 0.01,
                            'WORM': 0.01,
                            'WOW': 0.1,
                            'WRP': 0.01,
                            'WYV': 0.01,
                            'XBC': 0.01,
                            'XBL': 1.0,
                            'XBU': 1.0,
                            'XCHE': 0.1,
                            'XCS': 0.01,
                            'XCT': 0.01,
                            'XCXT': 0.01,
                            'XDE2': 0.01,
                            'XEV': 0.1,
                            'XGOX': 0.01,
                            'XGTC': 0.01,
                            'XLR': 0.1,
                            'XMCC': 0.01,
                            'XP': 1.0,
                            'XPASC': 0.01,
                            'XQN': 0.01,
                            'XSA': 0.1,
                            'XSTC': 2.0,
                            'XTD': 0.01,
                            'XVS': 0.01,
                            'XXX': 0.1,
                            'XYOC': 1.0,
                            'XYZ': 0.01,
                            'XZC': 0.1,
                            'XZCD': 0.01,
                            'YHC': 0.01,
                            'ZCC': 0.01,
                            'ZCG': 1.0,
                            'ZCL': 0.001,
                            'ZEC': 0.001,
                            'ZEIT': 0.1,
                            'ZENI': 0.01,
                            'ZERO': 0.01,
                            'ZMC': 0.1,
                            'ZOI': 0.01,
                            'ZSE': 0.01,
                            'ZURMO': 0.1,
                            'ZZC': 0.01
                        }
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                },
                'commonCurrencies': {
                    'BON': 'BonPeKaO',
                    'ETN': 'Ethernex',
                    'GDC': 'GoldenCryptoCoin',
                    'GTC': 'GlobalTourCoin',
                    'HNC': 'Huncoin',
                    'MARS': 'MarsBux',
                    'MER': 'TheMermaidCoin',
                    'RUB': 'RubbleCoin',
                    'UP': 'UpscaleToken'
                }
            });
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, precision, result, i, currency, id, code, active, status;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetGetcurrencies(params);

                            case 2:
                                response = _context.sent;
                                currencies = response['result'];
                                precision = this.precision['amount'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['CurrencyID'];
                                    code = this.commonCurrencyCode(currency['TickerCode']);
                                    active = currency['WalletStatus'] === 'online';
                                    status = 'ok';

                                    if (!active) status = 'disabled';
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'name': currency['Name'],
                                        'active': active,
                                        'status': status,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCurrencies() {
                return _ref.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, markets, result, i, market, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetGetmarkets();

                            case 2:
                                response = _context2.sent;
                                markets = response['result'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['MarketID'];
                                    base = this.commonCurrencyCode(market['MarketAssetCode']);
                                    quote = this.commonCurrencyCode(market['BaseCurrencyCode']);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': market['MarketAssetID'],
                                        'quoteId': market['BaseCurrencyID'],
                                        'active': market['Active'],
                                        'lot': undefined,
                                        'info': market
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (!market) {
                var marketId = ticker['MarketID'];
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];else symbol = marketId;
            }
            if (market) symbol = market['symbol'];
            var timestamp = this.milliseconds();
            var last = this.safeFloat(ticker, 'LastPrice');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'HighPrice'),
                'low': this.safeFloat(ticker, 'LowPrice'),
                'bid': this.safeFloat(ticker, 'BidPrice'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'AskPrice'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'Change'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': undefined,
                'quoteVolume': this.safeFloat(ticker, 'Volume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetGetmarketsummary(this.extend({
                                    'market_id': market['id']
                                }, params));

                            case 5:
                                ticker = _context3.sent;
                                return _context3.abrupt('return', this.parseTicker(ticker['result'], market));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, i, ticker, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetGetmarketsummaries(params);

                            case 4:
                                response = _context4.sent;
                                tickers = response['result'];
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = this.parseTicker(tickers[i]);
                                    symbol = ticker['symbol'];

                                    result[symbol] = ticker;
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetGetorderbook(this.extend({
                                    'market_id': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(orderbook['result'], undefined, 'BuyOrders', 'SellOrders', 'Price', 'Quantity'));

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                params = this.urlencode(params);
                if (params.length) url += '?' + params;
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, success, message;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context6.sent;
                                success = this.safeInteger(response, 'success');

                                if (!(success !== 1)) {
                                    _context6.next = 7;
                                    break;
                                }

                                message = this.safeString(response, 'message', 'Error');
                                throw new ExchangeError(message);

                            case 7:
                                return _context6.abrupt('return', response);

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function request(_x15) {
                return _ref6.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coinexchange;
}(Exchange);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinfloor, _Exchange);

    function coinfloor() {
        _classCallCheck(this, coinfloor);

        return _possibleConstructorReturn(this, (coinfloor.__proto__ || Object.getPrototypeOf(coinfloor)).apply(this, arguments));
    }

    _createClass(coinfloor, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinfloor.prototype.__proto__ || Object.getPrototypeOf(coinfloor.prototype), 'describe', this).call(this), {
                'id': 'coinfloor',
                'name': 'coinfloor',
                'rateLimit': 1000,
                'countries': 'UK',
                'has': {
                    'CORS': false,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28246081-623fc164-6a1c-11e7-913f-bac0d5576c90.jpg',
                    'api': 'https://webapi.coinfloor.co.uk:8090/bist',
                    'www': 'https://www.coinfloor.co.uk',
                    'doc': ['https://github.com/coinfloor/api', 'https://www.coinfloor.co.uk/api']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false,
                    'password': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['{id}/ticker/', '{id}/order_book/', '{id}/transactions/']
                    },
                    'private': {
                        'post': ['{id}/balance/', '{id}/user_transactions/', '{id}/open_orders/', '{id}/cancel_order/', '{id}/buy/', '{id}/sell/', '{id}/buy_market/', '{id}/sell_market/', '{id}/estimate_sell_market/', '{id}/estimate_buy_market/']
                    }
                },
                'markets': {
                    'BTC/GBP': { 'id': 'XBT/GBP', 'symbol': 'BTC/GBP', 'base': 'BTC', 'quote': 'GBP' },
                    'BTC/EUR': { 'id': 'XBT/EUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' },
                    'BTC/USD': { 'id': 'XBT/USD', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD' },
                    'BTC/PLN': { 'id': 'XBT/PLN', 'symbol': 'BTC/PLN', 'base': 'BTC', 'quote': 'PLN' },
                    'BCH/GBP': { 'id': 'BCH/GBP', 'symbol': 'BCH/GBP', 'base': 'BCH', 'quote': 'GBP' }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function fetchBalance() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var symbol = undefined;
            if ('symbol' in params) symbol = params['symbol'];
            if ('id' in params) symbol = params['id'];
            if (!symbol) throw new ExchangeError(this.id + ' fetchBalance requires a symbol param');
            // todo parse balance
            return this.privatePostIdBalance({
                'id': this.marketId(symbol)
            });
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetIdOrderBook(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context.sent;
                                return _context.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            // rewrite to get the timestamp from HTTP headers
            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var vwap = this.safeFloat(ticker, 'vwap');
            var baseVolume = this.safeFloat(ticker, 'volume');
            var quoteVolume = undefined;
            if (typeof vwap !== 'undefined') {
                quoteVolume = baseVolume * vwap;
            }
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': vwap,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetIdTicker(this.extend({
                                    'id': market['id']
                                }, params));

                            case 3:
                                ticker = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(ticker, market));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x6) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'info': trade,
                'id': trade['tid'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                market = this.market(symbol);
                                _context3.next = 3;
                                return this.publicGetIdTransactions(this.extend({
                                    'id': market['id']
                                }, params));

                            case 3:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x8) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, method;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                order = { 'id': this.marketId(symbol) };
                                method = 'privatePostId' + this.capitalize(side);

                                if (type === 'market') {
                                    order['quantity'] = amount;
                                    method += 'Market';
                                } else {
                                    order['price'] = price;
                                    order['amount'] = amount;
                                }
                                return _context4.abrupt('return', this[method](this.extend(order, params)));

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref4.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.privatePostIdCancelOrder({ 'id': id });

                            case 2:
                                return _context5.abrupt('return', _context5.sent);

                            case 3:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function cancelOrder(_x18) {
                return _ref5.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parseDate(order['datetime']);
            var datetime = this.iso8601(timestamp);
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'amount');
            var cost = price * amount;
            var side = undefined;
            var status = this.safeString(order, 'status');
            if (order['type'] === 0) side = 'buy';else if (order['type'] === 1) side = 'sell';
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var id = order['id'].toString();
            return {
                'info': order,
                'id': id,
                'datetime': datetime,
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'amount': amount,
                'filled': undefined,
                'remaining': undefined,
                'cost': cost,
                'fee': undefined
            };
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, orders, i;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (symbol) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new NotSupported(this.id + ' fetchOpenOrders requires a symbol param');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context6.next = 7;
                                return this.privatePostIdOpenOrders({
                                    'id': market['id']
                                });

                            case 7:
                                orders = _context6.sent;

                                for (i = 0; i < orders.length; i++) {
                                    // Coinfloor open orders would always be limit orders
                                    orders[i] = this.extend(orders[i], { 'status': 'open' });
                                }
                                return _context6.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOpenOrders() {
                return _ref6.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            // curl -k -u '[User ID]/[API key]:[Passphrase]' https://webapi.coinfloor.co.uk:8090/bist/XBT/GBP/balance/
            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({ 'nonce': nonce }, query));
                var auth = this.uid + '/' + this.apiKey + ':' + this.password;
                var signature = this.decode(this.stringToBase64(this.encode(auth)));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Basic ' + signature
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return coinfloor;
}(Exchange);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coingi, _Exchange);

    function coingi() {
        _classCallCheck(this, coingi);

        return _possibleConstructorReturn(this, (coingi.__proto__ || Object.getPrototypeOf(coingi)).apply(this, arguments));
    }

    _createClass(coingi, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coingi.prototype.__proto__ || Object.getPrototypeOf(coingi.prototype), 'describe', this).call(this), {
                'id': 'coingi',
                'name': 'Coingi',
                'rateLimit': 1000,
                'countries': ['PA', 'BG', 'CN', 'US'], // Panama, Bulgaria, China, US
                'has': {
                    'CORS': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28619707-5c9232a8-7212-11e7-86d6-98fe5d15cc6e.jpg',
                    'api': {
                        'www': 'https://coingi.com',
                        'current': 'https://api.coingi.com',
                        'user': 'https://api.coingi.com'
                    },
                    'www': 'https://coingi.com',
                    'doc': 'http://docs.coingi.apiary.io/'
                },
                'api': {
                    'www': {
                        'get': ['']
                    },
                    'current': {
                        'get': ['order-book/{pair}/{askCount}/{bidCount}/{depth}', 'transactions/{pair}/{maxCount}', '24hour-rolling-aggregation']
                    },
                    'user': {
                        'post': ['balance', 'add-order', 'cancel-order', 'orders', 'transactions', 'create-crypto-withdrawal']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'taker': 0.2 / 100,
                        'maker': 0.2 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'LTC': 0.01,
                            'DOGE': 2,
                            'PPC': 0.02,
                            'VTC': 0.2,
                            'NMC': 2,
                            'DASH': 0.002,
                            'USD': 10,
                            'EUR': 10
                        },
                        'deposit': {
                            'BTC': 0,
                            'LTC': 0,
                            'DOGE': 0,
                            'PPC': 0,
                            'VTC': 0,
                            'NMC': 0,
                            'DASH': 0,
                            'USD': 5,
                            'EUR': 1
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, parts, currencyParts, result, i, currencyPart, idParts, id, symbol, _symbol$split, _symbol$split2, base, quote, precision, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                response = undefined;
                                _context.prev = 1;

                                this.parseJsonResponse = false;
                                _context.next = 5;
                                return this.wwwGet();

                            case 5:
                                response = _context.sent;

                                this.parseJsonResponse = true;
                                _context.next = 13;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                this.parseJsonResponse = true;
                                throw _context.t0;

                            case 13:
                                parts = response.split('do=currencyPairSelector-selectCurrencyPair" class="active">');
                                currencyParts = parts[1].split('<div class="currency-pair-label">');
                                result = [];

                                for (i = 1; i < currencyParts.length; i++) {
                                    currencyPart = currencyParts[i];
                                    idParts = currencyPart.split('</div>');
                                    id = idParts[0];
                                    symbol = id;

                                    id = id.replace('/', '-');
                                    id = id.toLowerCase();
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': id,
                                        'lot': lot,
                                        'active': true,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': 0,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 18:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 9]]);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var lowercaseCurrencies, currencies, i, currency, balances, result, b, balance, _currency, account;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                lowercaseCurrencies = [];
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];

                                    lowercaseCurrencies.push(currency.toLowerCase());
                                }
                                _context2.next = 7;
                                return this.userPostBalance({
                                    'currencies': lowercaseCurrencies.join(',')
                                });

                            case 7:
                                balances = _context2.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    _currency = balance['currency']['name'];

                                    _currency = _currency.toUpperCase();
                                    account = {
                                        'free': balance['available'],
                                        'used': balance['blocked'] + balance['inOrders'] + balance['withdrawing'],
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[_currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 512;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.currentGetOrderBookPairAskCountBidCountDepth(this.extend({
                                    'pair': market['id'],
                                    'depth': 32, // maximum number of depth range steps 1-32
                                    'askCount': limit, // maximum returned number of asks 1-512
                                    'bidCount': limit // maximum returned number of bids 1-512
                                }, params));

                            case 5:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'baseAmount'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': ticker['high'],
                'low': ticker['low'],
                'bid': ticker['highestBid'],
                'bidVolume': undefined,
                'ask': ticker['lowestAsk'],
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': undefined,
                'last': undefined,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': ticker['baseVolume'],
                'quoteVolume': ticker['counterVolume'],
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, t, ticker, base, quote, symbol, market;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.currentGet24hourRollingAggregation(params);

                            case 4:
                                response = _context4.sent;
                                result = {};

                                for (t = 0; t < response.length; t++) {
                                    ticker = response[t];
                                    base = ticker['currencyPair']['base'].toUpperCase();
                                    quote = ticker['currencyPair']['counter'].toUpperCase();
                                    symbol = base + '/' + quote;
                                    market = undefined;

                                    if (symbol in this.markets) {
                                        market = this.markets[symbol];
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.fetchTickers(undefined, params);

                            case 4:
                                tickers = _context5.sent;

                                if (!(symbol in tickers)) {
                                    _context5.next = 7;
                                    break;
                                }

                                return _context5.abrupt('return', tickers[symbol]);

                            case 7:
                                throw new ExchangeError(this.id + ' return did not contain ' + symbol);

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (!market) market = this.markets_by_id[trade['currencyPair']];
            return {
                'id': trade['id'],
                'info': trade,
                'timestamp': trade['timestamp'],
                'datetime': this.iso8601(trade['timestamp']),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined, // type
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.currentGetTransactionsPairMaxCount(this.extend({
                                    'pair': market['id'],
                                    'maxCount': 128
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'currencyPair': this.marketId(symbol),
                                    'volume': amount,
                                    'price': price,
                                    'orderType': side === 'buy' ? 0 : 1
                                };
                                _context7.next = 5;
                                return this.userPostAddOrder(this.extend(order, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['result']
                                });

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x15, _x16, _x17, _x18) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.userPostCancelOrder({ 'orderId': id });

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x21) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'current';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api !== 'www') {
                url += '/' + api + '/' + this.implodeParams(path, params);
            }
            var query = this.omit(params, this.extractParams(path));
            if (api === 'current') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else if (api === 'user') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var request = this.extend({
                    'token': this.apiKey,
                    'nonce': nonce
                }, query);
                var auth = nonce.toString() + '$' + this.apiKey;
                request['signature'] = this.hmac(this.encode(auth), this.encode(this.secret));
                body = this.json(request);
                headers = {
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'current';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context9.sent;

                                if (!(typeof response !== 'string')) {
                                    _context9.next = 6;
                                    break;
                                }

                                if (!('errors' in response)) {
                                    _context9.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context9.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function request(_x29) {
                return _ref9.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coingi;
}(Exchange);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinmarketcap, _Exchange);

    function coinmarketcap() {
        _classCallCheck(this, coinmarketcap);

        return _possibleConstructorReturn(this, (coinmarketcap.__proto__ || Object.getPrototypeOf(coinmarketcap)).apply(this, arguments));
    }

    _createClass(coinmarketcap, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinmarketcap.prototype.__proto__ || Object.getPrototypeOf(coinmarketcap.prototype), 'describe', this).call(this), {
                'id': 'coinmarketcap',
                'name': 'CoinMarketCap',
                'rateLimit': 10000,
                'version': 'v1',
                'countries': 'US',
                'has': {
                    'CORS': true,
                    'privateAPI': false,
                    'createOrder': false,
                    'createMarketOrder': false,
                    'createLimitOrder': false,
                    'cancelOrder': false,
                    'editOrder': false,
                    'fetchBalance': false,
                    'fetchOrderBook': false,
                    'fetchOHLCV': false,
                    'fetchTrades': false,
                    'fetchTickers': true,
                    'fetchCurrencies': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28244244-9be6312a-69ed-11e7-99c1-7c1797275265.jpg',
                    'api': {
                        'public': 'https://api.coinmarketcap.com',
                        'files': 'https://files.coinmarketcap.com',
                        'charts': 'https://graph.coinmarketcap.com'
                    },
                    'www': 'https://coinmarketcap.com',
                    'doc': 'https://coinmarketcap.com/api'
                },
                'requiredCredentials': {
                    'apiKey': false,
                    'secret': false
                },
                'api': {
                    'files': {
                        'get': ['generated/stats/global.json']
                    },
                    'graphs': {
                        'get': ['currencies/{name}/']
                    },
                    'public': {
                        'get': ['ticker/', 'ticker/{id}/', 'global/']
                    }
                },
                'currencyCodes': ['AUD', 'BRL', 'CAD', 'CHF', 'CNY', 'EUR', 'GBP', 'HKD', 'IDR', 'INR', 'JPY', 'KRW', 'MXN', 'RUB', 'USD']
            });
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                throw new ExchangeError('Fetching order books is not supported by the API of ' + this.id);

                            case 1:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOrderBook(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'currencyCode',
        value: function currencyCode(base, name) {
            var currencies = {
                'ACChain': 'ACChain',
                'AdCoin': 'AdCoin',
                'BatCoin': 'BatCoin',
                'Bitgem': 'Bitgem',
                'BlazeCoin': 'BlazeCoin',
                'BlockCAT': 'BlockCAT',
                'Catcoin': 'Catcoin',
                'Hi Mutual Society': 'Hi Mutual Society',
                'iCoin': 'iCoin',
                'Maggie': 'Maggie',
                'MIOTA': 'IOTA', // a special case, most exchanges list it as IOTA, therefore we change just the Coinmarketcap instead of changing them all
                'NetCoin': 'NetCoin',
                'Polcoin': 'Polcoin'
            };
            if (name in currencies) return currencies[name];
            return base;
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var markets, result, p, market, currencies, i, quote, quoteId, baseId, base, symbol, id;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetTicker({
                                    'limit': 0
                                });

                            case 2:
                                markets = _context2.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    currencies = this.currencyCodes;

                                    for (i = 0; i < currencies.length; i++) {
                                        quote = currencies[i];
                                        quoteId = quote.toLowerCase();
                                        baseId = market['id'];
                                        base = this.currencyCode(market['symbol'], market['name']);
                                        symbol = base + '/' + quote;
                                        id = baseId + '/' + quoteId;

                                        result.push({
                                            'id': id,
                                            'symbol': symbol,
                                            'base': base,
                                            'quote': quote,
                                            'baseId': baseId,
                                            'quoteId': quoteId,
                                            'info': market
                                        });
                                    }
                                }
                                return _context2.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchGlobal',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'USD';
                var request;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};

                                if (currency) request['convert'] = currency;
                                _context3.next = 6;
                                return this.publicGetGlobal(request);

                            case 6:
                                return _context3.abrupt('return', _context3.sent);

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchGlobal() {
                return _ref3.apply(this, arguments);
            }

            return fetchGlobal;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            if ('last_updated' in ticker) if (ticker['last_updated']) timestamp = parseInt(ticker['last_updated']) * 1000;
            var change = undefined;
            if ('percent_change_24h' in ticker) if (ticker['percent_change_24h']) change = this.safeFloat(ticker, 'percent_change_24h');
            var last = undefined;
            var symbol = undefined;
            var volume = undefined;
            if (market) {
                var priceKey = 'price_' + market['quoteId'];
                if (priceKey in ticker) if (ticker[priceKey]) last = this.safeFloat(ticker, priceKey);
                symbol = market['symbol'];
                var volumeKey = '24h_volume_' + market['quoteId'];
                if (volumeKey in ticker) if (ticker[volumeKey]) volume = this.safeFloat(ticker, volumeKey);
            }
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': undefined,
                'bidVolume': undefined,
                'ask': undefined,
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': undefined,
                'quoteVolume': volume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var currency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'USD';
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, response, tickers, t, ticker, currencyId, id, symbol, market;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'limit': 10000
                                };

                                if (currency) request['convert'] = currency;
                                _context4.next = 6;
                                return this.publicGetTicker(this.extend(request, params));

                            case 6:
                                response = _context4.sent;
                                tickers = {};

                                for (t = 0; t < response.length; t++) {
                                    ticker = response[t];
                                    currencyId = currency in this.currencies ? this.currencies[currency]['id'] : currency.toLowerCase();
                                    id = ticker['id'] + '/' + currencyId;
                                    symbol = id;
                                    market = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    }
                                    tickers[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', tickers);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, request, response, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = this.extend({
                                    'convert': market['quote'],
                                    'id': market['baseId']
                                }, params);
                                _context5.next = 6;
                                return this.publicGetTickerId(request);

                            case 6:
                                response = _context5.sent;
                                ticker = response[0];
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var currencies, result, i, currency, id, name, precision, code;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.publicGetTicker(this.extend({
                                    'limit': 0
                                }, params));

                            case 2:
                                currencies = _context6.sent;
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['symbol'];
                                    name = currency['name'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    precision = 8; // default precision, todo: fix "magic constants"

                                    code = this.currencyCode(id, name);

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': name,
                                        'active': true,
                                        'status': 'ok',
                                        'fee': undefined, // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        }
                                    };
                                }
                                return _context6.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchCurrencies() {
                return _ref6.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (Object.keys(query).length) url += '?' + this.urlencode(query);
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('error' in response)) {
                                    _context7.next = 6;
                                    break;
                                }

                                if (!response['error']) {
                                    _context7.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context7.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x16) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coinmarketcap;
}(Exchange);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinmate, _Exchange);

    function coinmate() {
        _classCallCheck(this, coinmate);

        return _possibleConstructorReturn(this, (coinmate.__proto__ || Object.getPrototypeOf(coinmate)).apply(this, arguments));
    }

    _createClass(coinmate, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinmate.prototype.__proto__ || Object.getPrototypeOf(coinmate.prototype), 'describe', this).call(this), {
                'id': 'coinmate',
                'name': 'CoinMate',
                'countries': ['GB', 'CZ', 'EU'], // UK, Czech Republic
                'rateLimit': 1000,
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27811229-c1efb510-606c-11e7-9a36-84ba2ce412d8.jpg',
                    'api': 'https://coinmate.io/api',
                    'www': 'https://coinmate.io',
                    'doc': ['http://docs.coinmate.apiary.io', 'https://coinmate.io/developers']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['orderBook', 'ticker', 'transactions']
                    },
                    'private': {
                        'post': ['balances', 'bitcoinWithdrawal', 'bitcoinDepositAddresses', 'buyInstant', 'buyLimit', 'cancelOrder', 'cancelOrderWithInfo', 'createVoucher', 'openOrders', 'redeemVoucher', 'sellInstant', 'sellLimit', 'transactionHistory', 'unconfirmedBitcoinDeposits']
                    }
                },
                'markets': {
                    'BTC/EUR': { 'id': 'BTC_EUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR', 'precision': { 'amount': 4, 'price': 2 } },
                    'BTC/CZK': { 'id': 'BTC_CZK', 'symbol': 'BTC/CZK', 'base': 'BTC', 'quote': 'CZK', 'precision': { 'amount': 4, 'price': 2 } },
                    'LTC/BTC': { 'id': 'LTC_BTC', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'precision': { 'amount': 4, 'price': 5 } }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0005,
                        'taker': 0.0035
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostBalances();

                            case 2:
                                response = _context.sent;
                                balances = response['data'];
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    if (currency in balances) {
                                        account['free'] = balances[currency]['available'];
                                        account['used'] = balances[currency]['reserved'];
                                        account['total'] = balances[currency]['balance'];
                                    }
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetOrderBook(this.extend({
                                    'currencyPair': this.marketId(symbol),
                                    'groupByPriceLimit': 'False'
                                }, params));

                            case 2:
                                response = _context2.sent;
                                orderbook = response['data'];
                                timestamp = orderbook['timestamp'] * 1000;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'amount'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetTicker(this.extend({
                                    'currencyPair': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context3.sent;
                                ticker = response['data'];
                                timestamp = ticker['timestamp'] * 1000;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'vwap': undefined,
                                    'askVolume': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'amount'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (!market) market = this.markets_by_id[trade['currencyPair']];
            return {
                'id': trade['transactionId'],
                'info': trade,
                'timestamp': trade['timestamp'],
                'datetime': this.iso8601(trade['timestamp']),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTransactions(this.extend({
                                    'currencyPair': market['id'],
                                    'minutesIntoHistory': 10
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                method = 'privatePost' + this.capitalize(side);
                                order = {
                                    'currencyPair': this.marketId(symbol)
                                };

                                if (type === 'market') {
                                    if (side === 'buy') order['total'] = amount; // amount in fiat
                                    else order['amount'] = amount; // amount in fiat
                                    method += 'Instant';
                                } else {
                                    order['amount'] = amount; // amount in crypto
                                    order['price'] = price;
                                    method += this.capitalize(type);
                                }
                                _context5.next = 5;
                                return this[method](this.extend(order, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['data'].toString()
                                });

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancelOrder({ 'orderId': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x18) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + this.uid + this.apiKey;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret));
                body = this.urlencode(this.extend({
                    'clientId': this.uid,
                    'nonce': nonce,
                    'publicKey': this.apiKey,
                    'signature': signature.toUpperCase()
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('error' in response)) {
                                    _context7.next = 6;
                                    break;
                                }

                                if (!response['error']) {
                                    _context7.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context7.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x26) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coinmate;
}(Exchange);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    DDoSProtection = _require.DDoSProtection;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinnest, _Exchange);

    function coinnest() {
        _classCallCheck(this, coinnest);

        return _possibleConstructorReturn(this, (coinnest.__proto__ || Object.getPrototypeOf(coinnest)).apply(this, arguments));
    }

    _createClass(coinnest, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinnest.prototype.__proto__ || Object.getPrototypeOf(coinnest.prototype), 'describe', this).call(this), {
                'id': 'coinnest',
                'name': 'coinnest',
                'countries': 'KR',
                'rateLimit': 1000,
                'has': {
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38065728-7289ff5c-330d-11e8-9cc1-cf0cbcb606bc.jpg',
                    'api': {
                        'public': 'https://api.coinnest.co.kr/api',
                        'private': 'https://api.coinnest.co.kr/api',
                        'web': 'https://www.coinnest.co.kr'
                    },
                    'www': 'https://www.coinnest.co.kr',
                    'doc': 'https://www.coinnest.co.kr/doc/intro.html',
                    'fees': ['https://coinnesthelp.zendesk.com/hc/ko/articles/115002110252-%EA%B1%B0%EB%9E%98-%EC%88%98%EC%88%98%EB%A3%8C%EB%8A%94-%EC%96%BC%EB%A7%88%EC%9D%B8%EA%B0%80%EC%9A%94-', 'https://coinnesthelp.zendesk.com/hc/ko/articles/115002110272-%EB%B9%84%ED%8A%B8%EC%BD%94%EC%9D%B8-%EC%88%98%EC%88%98%EB%A3%8C%EB%A5%BC-%EC%84%A0%ED%83%9D%ED%95%98%EB%8A%94-%EC%9D%B4%EC%9C%A0%EA%B0%80-%EB%AC%B4%EC%97%87%EC%9D%B8%EA%B0%80%EC%9A%94-']
                },
                'api': {
                    'web': {
                        'get': ['coin/allcoin']
                    },
                    'public': {
                        'get': ['pub/ticker', 'pub/depth', 'pub/trades']
                    },
                    'private': {
                        'post': ['account/balance', 'trade/add', 'trade/cancel', 'trade/fetchtrust', 'trade/trust']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': '0.002'
                        }
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var quote, quoteId, coins, result, i, baseId, id, base, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                quote = 'KRW';
                                quoteId = quote.toLowerCase();
                                // todo: rewrite this for web endpoint

                                coins = ['btc', 'bch', 'btg', 'bcd', 'ubtc', 'btn', 'kst', 'ltc', 'act', 'eth', 'etc', 'ada', 'qtum', 'xlm', 'neo', 'gas', 'rpx', 'hsr', 'knc', 'tsl', 'tron', 'omg', 'wtc', 'mco', 'storm', 'gto', 'pxs', 'chat', 'ink', 'oc', 'hlc', 'ent', 'qbt', 'spc', 'put'];
                                result = [];

                                for (i = 0; i < coins.length; i++) {
                                    baseId = coins[i];
                                    id = baseId + '/' + quoteId;
                                    base = this.commonCurrencyCode(baseId.toUpperCase());
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'info': undefined
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['time'] * 1000;
            var symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetPubTicker(this.extend({
                                    'coin': market['baseId']
                                }, params));

                            case 5:
                                ticker = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetPubDepth(this.extend({
                                    'coin': market['baseId']
                                }, params));

                            case 5:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['date']) * 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.priceToPrecision(symbol, amount * price);
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tid'),
                'order': undefined,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': parseFloat(cost),
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetPubTrades(this.extend({
                                    'coin': market['baseId']
                                }, params));

                            case 5:
                                trades = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balancKeys, i, key, parts, type, currency, otherType;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privatePostAccountBalance(params);

                            case 4:
                                response = _context5.sent;
                                result = { 'info': response };
                                balancKeys = Object.keys(response);
                                i = 0;

                            case 8:
                                if (!(i < balancKeys.length)) {
                                    _context5.next = 26;
                                    break;
                                }

                                key = balancKeys[i];
                                parts = key.split('_');

                                if (!(parts.length !== 2)) {
                                    _context5.next = 13;
                                    break;
                                }

                                return _context5.abrupt('continue', 23);

                            case 13:
                                type = parts[1];

                                if (!(type !== 'reserved' && type !== 'balance')) {
                                    _context5.next = 16;
                                    break;
                                }

                                return _context5.abrupt('continue', 23);

                            case 16:
                                currency = parts[0].toUpperCase();

                                currency = this.commonCurrencyCode(currency);
                                if (!(currency in result)) {
                                    result[currency] = {
                                        'free': 0.0,
                                        'used': 0.0,
                                        'total': 0.0
                                    };
                                }
                                type = type === 'reserved' ? 'used' : 'free';
                                result[currency][type] = parseFloat(response[key]);
                                otherType = type === 'used' ? 'free' : 'used';

                                if (otherType in result[currency]) result[currency]['total'] = this.sum(result[currency]['free'], result[currency]['used']);

                            case 23:
                                i++;
                                _context5.next = 8;
                                break;

                            case 26:
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 27:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order, market) {
            var symbol = market['symbol'];
            var timestamp = parseInt(order['time']) * 1000;
            var status = parseInt(order['status']);
            // 1: newly created, 2: ready for dealing, 3: canceled, 4: completed.
            if (status === 4) {
                status = 'closed';
            } else if (status === 3) {
                status = 'canceled';
            } else {
                status = 'open';
            }
            var amount = this.safeFloat(order, 'amount_total');
            var remaining = this.safeFloat(order, 'amount_over');
            var filled = this.safeValue(order, 'deals');
            if (filled) {
                filled = this.safeFloat(filled, 'sum_amount');
            } else {
                filled = amount - remaining;
            }
            return {
                'id': this.safeString(order, 'id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': this.safeFloat(order, 'price'),
                'cost': undefined,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': undefined,
                'info': this.safeValue(order, 'info', order)
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, response, order, id;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.privatePostTradeAdd(this.extend({
                                    'coin': market['baseId'],
                                    'type': side,
                                    'number': amount,
                                    'price': price
                                }, params));

                            case 5:
                                response = _context6.sent;
                                order = {
                                    'id': response['id'],
                                    'time': this.seconds(),
                                    'type': side,
                                    'price': price,
                                    'amount_total': amount,
                                    'amount_over': amount,
                                    'info': response
                                };
                                id = order['id'];

                                this.orders[id] = this.parseOrder(order, market);
                                return _context6.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x13, _x14, _x15, _x16) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.privatePostTradeCancel(this.extend({
                                    'id': id,
                                    'coin': market['baseId']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x19) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, order;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.privatePostTradeFetchtrust(this.extend({
                                    'id': id,
                                    'coin': market['baseId']
                                }, params));

                            case 5:
                                order = _context8.sent;
                                return _context8.abrupt('return', this.parseOrder(order, market));

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrder(_x22) {
                return _ref8.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'coin': market['baseId']
                                };

                                if (since) request['since'] = parseInt(since / 1000);
                                if (limit) request['limit'] = limit;
                                _context9.next = 8;
                                return this.privatePostTradeTrust(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(response, market));

                            case 10:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'type': '1'
                                }, params));

                            case 2:
                                return _context10.abrupt('return', _context10.sent);

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + path;
            var query = undefined;
            if (api === 'public') {
                query = this.urlencode(params);
                if (query.length) url += '?' + query;
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.extend(params, {
                    'key': this.apiKey,
                    'nonce': this.nonce()
                }));
                var secret = this.hash(this.secret);
                body += '&signature=' + this.hmac(this.encode(body), this.encode(secret));
                headers = { 'Content-type': 'application/x-www-form-urlencoded' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, status, ErrorClass, message;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context11.sent;
                                status = this.safeString(response, 'status');

                                if (!(!response || response === 'nil' || status)) {
                                    _context11.next = 8;
                                    break;
                                }

                                ErrorClass = this.safeValue({
                                    '100': DDoSProtection,
                                    '101': DDoSProtection,
                                    '104': AuthenticationError,
                                    '105': AuthenticationError,
                                    '106': DDoSProtection
                                }, status, ExchangeError);
                                message = this.safeString(response, 'msg', this.json(response));
                                throw new ErrorClass(message);

                            case 8:
                                return _context11.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function request(_x38) {
                return _ref11.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return coinnest;
}(Exchange);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinone, _Exchange);

    function coinone() {
        _classCallCheck(this, coinone);

        return _possibleConstructorReturn(this, (coinone.__proto__ || Object.getPrototypeOf(coinone)).apply(this, arguments));
    }

    _createClass(coinone, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinone.prototype.__proto__ || Object.getPrototypeOf(coinone.prototype), 'describe', this).call(this), {
                'id': 'coinone',
                'name': 'CoinOne',
                'countries': 'KR', // Korea
                'rateLimit': 667,
                'version': 'v2',
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38003300-adc12fba-323f-11e8-8525-725f53c4a659.jpg',
                    'api': 'https://api.coinone.co.kr',
                    'www': 'https://coinone.co.kr',
                    'doc': 'https://doc.coinone.co.kr'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true
                },
                'api': {
                    'public': {
                        'get': ['orderbook/', 'trades/', 'ticker/']
                    },
                    'private': {
                        'post': ['account/btc_deposit_address/', 'account/balance/', 'account/daily_balance/', 'account/user_info/', 'account/virtual_account/', 'order/cancel_all/', 'order/cancel/', 'order/limit_buy/', 'order/limit_sell/', 'order/complete_orders/', 'order/limit_orders/', 'order/order_info/', 'transaction/auth_number/', 'transaction/history/', 'transaction/krw/history/', 'transaction/btc/', 'transaction/coin/']
                    }
                },
                'markets': {
                    'BCH/KRW': { 'id': 'bch', 'symbol': 'BCH/KRW', 'base': 'BCH', 'quote': 'KRW', 'baseId': 'bch', 'quoteId': 'krw' },
                    'BTC/KRW': { 'id': 'btc', 'symbol': 'BTC/KRW', 'base': 'BTC', 'quote': 'KRW', 'baseId': 'btc', 'quoteId': 'krw' },
                    'BTG/KRW': { 'id': 'btg', 'symbol': 'BTG/KRW', 'base': 'BTG', 'quote': 'KRW', 'baseId': 'btg', 'quoteId': 'krw' },
                    'ETC/KRW': { 'id': 'etc', 'symbol': 'ETC/KRW', 'base': 'ETC', 'quote': 'KRW', 'baseId': 'etc', 'quoteId': 'krw' },
                    'ETH/KRW': { 'id': 'eth', 'symbol': 'ETH/KRW', 'base': 'ETH', 'quote': 'KRW', 'baseId': 'eth', 'quoteId': 'krw' },
                    'IOTA/KRW': { 'id': 'iota', 'symbol': 'IOTA/KRW', 'base': 'IOTA', 'quote': 'KRW', 'baseId': 'iota', 'quoteId': 'krw' },
                    'LTC/KRW': { 'id': 'ltc', 'symbol': 'LTC/KRW', 'base': 'LTC', 'quote': 'KRW', 'baseId': 'ltc', 'quoteId': 'krw' },
                    'OMG/KRW': { 'id': 'omg', 'symbol': 'OMG/KRW', 'base': 'OMG', 'quote': 'KRW', 'baseId': 'omg', 'quoteId': 'krw' },
                    'QTUM/KRW': { 'id': 'qtum', 'symbol': 'QTUM/KRW', 'base': 'QTUM', 'quote': 'KRW', 'baseId': 'qtum', 'quoteId': 'krw' },
                    'XRP/KRW': { 'id': 'xrp', 'symbol': 'XRP/KRW', 'base': 'XRP', 'quote': 'KRW', 'baseId': 'xrp', 'quoteId': 'krw' }
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'taker': 0.001,
                        'maker': 0.001,
                        'tiers': {
                            'taker': [[0, 0.001], [100000000, 0.0009], [1000000000, 0.0008], [5000000000, 0.0007], [10000000000, 0.0006], [20000000000, 0.0005], [30000000000, 0.0004], [40000000000, 0.0003], [50000000000, 0.0002]],
                            'maker': [[0, 0.001], [100000000, 0.0008], [1000000000, 0.0006], [5000000000, 0.0004], [10000000000, 0.0002], [20000000000, 0], [30000000000, 0], [40000000000, 0], [50000000000, 0]]
                        }
                    }
                },
                'exceptions': {
                    '405': ExchangeNotAvailable
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, ids, i, id, balance, code, free, total, used, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostAccountBalance();

                            case 2:
                                response = _context.sent;
                                result = { 'info': response };
                                ids = Object.keys(response);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    balance = response[id];
                                    code = id.toUpperCase();

                                    if (id in this.currencies_by_id) code = this.currencies_by_id[id]['code'];
                                    free = parseFloat(balance['avail']);
                                    total = parseFloat(balance['balance']);
                                    used = total - free;
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };

                                    result[code] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetOrderbook(this.extend({
                                    'currency': market['id'],
                                    'format': 'json'
                                }, params));

                            case 3:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(response, undefined, 'bid', 'ask', 'price', 'qty'));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, tickers, ids, i, id, symbol, market, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTicker(this.extend({
                                    'currency': 'all',
                                    'format': 'json'
                                }, params));

                            case 4:
                                response = _context3.sent;
                                result = {};
                                tickers = response;
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    symbol = id;
                                    market = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                        ticker = tickers[id];

                                        result[symbol] = this.parseTicker(ticker, market);
                                    }
                                }
                                return _context3.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTicker(this.extend({
                                    'currency': market['id'],
                                    'format': 'json'
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTicker(response, market));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var last = this.safeFloat(ticker, 'last');
            var previousClose = this.safeFloat(ticker, 'yesterday_last');
            var change = undefined;
            if (typeof last !== 'undefined' && typeof previousClose !== 'undefined') change = previousClose - last;
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': undefined,
                'bidVolume': undefined,
                'ask': undefined,
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'first'),
                'close': last,
                'last': last,
                'previousClose': previousClose,
                'change': change,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['timestamp']) * 1000;
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            return {
                'id': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'order': undefined,
                'symbol': symbol,
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'qty'),
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                _context5.next = 3;
                                return this.publicGetTrades(this.extend({
                                    'currency': market['id'],
                                    'period': 'hour',
                                    'format': 'json'
                                }, params));

                            case 3:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response['completeOrders'], market, since, limit));

                            case 5:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x11) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, method, response, orderId;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                order = {
                                    'price': price,
                                    'currency': this.marketId(symbol),
                                    'qty': amount
                                };
                                method = 'privatePostOrder' + this.capitalize(type) + this.capitalize(side);
                                _context6.next = 8;
                                return this[method](this.extend(order, params));

                            case 8:
                                response = _context6.sent;

                                // todo: return the full order structure
                                // return this.parseOrder (response, market);
                                orderId = this.safeString(response, 'orderId');
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': orderId
                                });

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x15, _x16, _x17, _x18) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.privatePostOrderCancel({ 'orderID': id });

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x21) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + '/';
            if (api === 'public') {
                url += request;
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            } else {
                this.checkRequiredCredentials();
                url += this.version + '/' + request;
                var nonce = this.nonce().toString();
                var json = this.json({
                    'access_token': this.apiKey,
                    'nonce': nonce
                });
                var payload = this.stringToBase64(this.encode(json));
                body = this.decode(payload);
                var secret = this.secret.toUpperCase();
                var signature = this.hmac(payload, this.encode(secret), 'sha512');
                headers = {
                    'content-type': 'application/json',
                    'X-COINONE-PAYLOAD': payload,
                    'X-COINONE-SIGNATURE': signature
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('result' in response) {
                    var result = response['result'];
                    if (result !== 'success') {
                        //
                        //    {  "errorCode": "405",  "status": "maintenance",  "result": "error"}
                        //
                        var _code = this.safeString(response, 'errorCode');
                        var feedback = this.id + ' ' + this.json(response);
                        var exceptions = this.exceptions;
                        if (_code in exceptions) {
                            throw new exceptions[_code](feedback);
                        } else {
                            throw new ExchangeError(feedback);
                        }
                    }
                } else {
                    throw new ExchangeError(this.id + ' ' + body);
                }
            }
        }
    }]);

    return coinone;
}(Exchange);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinsecure, _Exchange);

    function coinsecure() {
        _classCallCheck(this, coinsecure);

        return _possibleConstructorReturn(this, (coinsecure.__proto__ || Object.getPrototypeOf(coinsecure)).apply(this, arguments));
    }

    _createClass(coinsecure, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinsecure.prototype.__proto__ || Object.getPrototypeOf(coinsecure.prototype), 'describe', this).call(this), {
                'id': 'coinsecure',
                'name': 'Coinsecure',
                'countries': 'IN', // India
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766472-9cbd200a-5ed9-11e7-9551-2267ad7bac08.jpg',
                    'api': 'https://api.coinsecure.in',
                    'www': 'https://coinsecure.in',
                    'doc': ['https://api.coinsecure.in', 'https://github.com/coinsecure/plugins']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false
                },
                'api': {
                    'public': {
                        'get': ['bitcoin/search/confirmation/{txid}', 'exchange/ask/low', 'exchange/ask/orders', 'exchange/bid/high', 'exchange/bid/orders', 'exchange/lastTrade', 'exchange/max24Hr', 'exchange/min24Hr', 'exchange/ticker', 'exchange/trades']
                    },
                    'private': {
                        'get': ['mfa/authy/call', 'mfa/authy/sms', 'netki/search/{netkiName}', 'user/bank/otp/{number}', 'user/kyc/otp/{number}', 'user/profile/phone/otp/{number}', 'user/wallet/coin/address/{id}', 'user/wallet/coin/deposit/confirmed/all', 'user/wallet/coin/deposit/confirmed/{id}', 'user/wallet/coin/deposit/unconfirmed/all', 'user/wallet/coin/deposit/unconfirmed/{id}', 'user/wallet/coin/wallets', 'user/exchange/bank/fiat/accounts', 'user/exchange/bank/fiat/balance/available', 'user/exchange/bank/fiat/balance/pending', 'user/exchange/bank/fiat/balance/total', 'user/exchange/bank/fiat/deposit/cancelled', 'user/exchange/bank/fiat/deposit/unverified', 'user/exchange/bank/fiat/deposit/verified', 'user/exchange/bank/fiat/withdraw/cancelled', 'user/exchange/bank/fiat/withdraw/completed', 'user/exchange/bank/fiat/withdraw/unverified', 'user/exchange/bank/fiat/withdraw/verified', 'user/exchange/ask/cancelled', 'user/exchange/ask/completed', 'user/exchange/ask/pending', 'user/exchange/bid/cancelled', 'user/exchange/bid/completed', 'user/exchange/bid/pending', 'user/exchange/bank/coin/addresses', 'user/exchange/bank/coin/balance/available', 'user/exchange/bank/coin/balance/pending', 'user/exchange/bank/coin/balance/total', 'user/exchange/bank/coin/deposit/cancelled', 'user/exchange/bank/coin/deposit/unverified', 'user/exchange/bank/coin/deposit/verified', 'user/exchange/bank/coin/withdraw/cancelled', 'user/exchange/bank/coin/withdraw/completed', 'user/exchange/bank/coin/withdraw/unverified', 'user/exchange/bank/coin/withdraw/verified', 'user/exchange/bank/summary', 'user/exchange/coin/fee', 'user/exchange/fiat/fee', 'user/exchange/kycs', 'user/exchange/referral/coin/paid', 'user/exchange/referral/coin/successful', 'user/exchange/referral/fiat/paid', 'user/exchange/referrals', 'user/exchange/trade/summary', 'user/login/token/{token}', 'user/summary', 'user/wallet/summary', 'wallet/coin/withdraw/cancelled', 'wallet/coin/withdraw/completed', 'wallet/coin/withdraw/unverified', 'wallet/coin/withdraw/verified'],
                        'post': ['login', 'login/initiate', 'login/password/forgot', 'mfa/authy/initiate', 'mfa/ga/initiate', 'signup', 'user/netki/update', 'user/profile/image/update', 'user/exchange/bank/coin/withdraw/initiate', 'user/exchange/bank/coin/withdraw/newVerifycode', 'user/exchange/bank/fiat/withdraw/initiate', 'user/exchange/bank/fiat/withdraw/newVerifycode', 'user/password/change', 'user/password/reset', 'user/wallet/coin/withdraw/initiate', 'wallet/coin/withdraw/newVerifycode'],
                        'put': ['signup/verify/{token}', 'user/exchange/kyc', 'user/exchange/bank/fiat/deposit/new', 'user/exchange/ask/new', 'user/exchange/bid/new', 'user/exchange/instant/buy', 'user/exchange/instant/sell', 'user/exchange/bank/coin/withdraw/verify', 'user/exchange/bank/fiat/account/new', 'user/exchange/bank/fiat/withdraw/verify', 'user/mfa/authy/initiate/enable', 'user/mfa/ga/initiate/enable', 'user/netki/create', 'user/profile/phone/new', 'user/wallet/coin/address/new', 'user/wallet/coin/new', 'user/wallet/coin/withdraw/sendToExchange', 'user/wallet/coin/withdraw/verify'],
                        'delete': ['user/gcm/{code}', 'user/logout', 'user/exchange/bank/coin/withdraw/unverified/cancel/{withdrawID}', 'user/exchange/bank/fiat/deposit/cancel/{depositID}', 'user/exchange/ask/cancel/{orderID}', 'user/exchange/bid/cancel/{orderID}', 'user/exchange/bank/fiat/withdraw/unverified/cancel/{withdrawID}', 'user/mfa/authy/disable/{code}', 'user/mfa/ga/disable/{code}', 'user/profile/phone/delete', 'user/profile/image/delete/{netkiName}', 'user/wallet/coin/withdraw/unverified/cancel/{withdrawID}']
                    }
                },
                'markets': {
                    'BTC/INR': { 'id': 'BTC/INR', 'symbol': 'BTC/INR', 'base': 'BTC', 'quote': 'INR' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.4 / 100,
                        'taker': 0.4 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, coin, fiat, result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privateGetUserExchangeBankSummary();

                            case 4:
                                response = _context.sent;
                                balance = response['message'];
                                coin = {
                                    'free': balance['availableCoinBalance'],
                                    'used': balance['pendingCoinBalance'],
                                    'total': balance['totalCoinBalance']
                                };
                                fiat = {
                                    'free': balance['availableFiatBalance'],
                                    'used': balance['pendingFiatBalance'],
                                    'total': balance['totalFiatBalance']
                                };
                                result = {
                                    'info': balance,
                                    'BTC': coin,
                                    'INR': fiat
                                };
                                return _context.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var bids, asks, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetExchangeBidOrders(params);

                            case 4:
                                bids = _context2.sent;
                                _context2.next = 7;
                                return this.publicGetExchangeAskOrders(params);

                            case 7:
                                asks = _context2.sent;
                                orderbook = {
                                    'bids': bids['message'],
                                    'asks': asks['message']
                                };
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'rate', 'vol'));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, baseVolume, satoshi, quoteVolume, vwap, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetExchangeTicker(params);

                            case 4:
                                response = _context3.sent;
                                ticker = response['message'];
                                timestamp = ticker['timestamp'];
                                baseVolume = this.safeFloat(ticker, 'coinvolume');

                                if (symbol === 'BTC/INR') {
                                    satoshi = 0.00000001;

                                    baseVolume = baseVolume * satoshi;
                                }
                                quoteVolume = this.safeFloat(ticker, 'fiatvolume') / 100;
                                vwap = quoteVolume / baseVolume;
                                last = this.safeFloat(ticker, 'lastPrice') / 100;
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high') / 100,
                                    'low': this.safeFloat(ticker, 'low') / 100,
                                    'bid': this.safeFloat(ticker, 'bid') / 100,
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask') / 100,
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': this.safeFloat(ticker, 'open') / 100,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 13:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['time'];
            var side = trade['ordType'] === 'bid' ? 'buy' : 'sell';
            return {
                'id': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'order': undefined,
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'rate') / 100,
                'amount': this.safeFloat(trade, 'vol') / 100000000,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, result, trades;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetExchangeTrades(params);

                            case 5:
                                result = _context4.sent;

                                if (!('message' in result)) {
                                    _context4.next = 9;
                                    break;
                                }

                                trades = result['message'];
                                return _context4.abrupt('return', this.parseTrades(trades, market));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, direction, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePutUserExchange';
                                order = {};

                                if (type === 'market') {
                                    method += 'Instant' + this.capitalize(side);
                                    if (side === 'buy') order['maxFiat'] = amount;else order['maxVol'] = amount;
                                } else {
                                    direction = side === 'buy' ? 'Bid' : 'Ask';

                                    method += direction + 'New';
                                    order['rate'] = price;
                                    order['vol'] = amount;
                                }
                                _context5.next = 7;
                                return this[method](this.extend(order, params));

                            case 7:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['message']['orderID']
                                });

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                throw new NotSupported(this.id + ' cancelOrder () is not fully implemented yet');

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x18) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                headers = { 'Authorization': this.apiKey };
                if (Object.keys(query).length) {
                    body = this.json(query);
                    headers['Content-Type'] = 'application/json';
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 200) {
                if (body[0] === '{' || body[0] === '[') {
                    var response = JSON.parse(body);
                    if ('success' in response) {
                        var success = response['success'];
                        if (!success) {
                            throw new ExchangeError(this.id + ' error returned: ' + body);
                        }
                        if (!('message' in response)) {
                            throw new ExchangeError(this.id + ' malformed response: no "message" in response: ' + body);
                        }
                    } else {
                        throw new ExchangeError(this.id + ' malformed response: no "success" in response: ' + body);
                    }
                } else {
                    // if not a JSON response
                    throw new ExchangeError(this.id + ' returned a non-JSON reply: ' + body);
                }
            }
        }
    }]);

    return coinsecure;
}(Exchange);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    NotSupported = _require.NotSupported;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(coinspot, _Exchange);

    function coinspot() {
        _classCallCheck(this, coinspot);

        return _possibleConstructorReturn(this, (coinspot.__proto__ || Object.getPrototypeOf(coinspot)).apply(this, arguments));
    }

    _createClass(coinspot, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coinspot.prototype.__proto__ || Object.getPrototypeOf(coinspot.prototype), 'describe', this).call(this), {
                'id': 'coinspot',
                'name': 'CoinSpot',
                'countries': 'AU', // Australia
                'rateLimit': 1000,
                'has': {
                    'CORS': false,
                    'createMarketOrder': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28208429-3cacdf9a-6896-11e7-854e-4c79a772a30f.jpg',
                    'api': {
                        'public': 'https://www.coinspot.com.au/pubapi',
                        'private': 'https://www.coinspot.com.au/api'
                    },
                    'www': 'https://www.coinspot.com.au',
                    'doc': 'https://www.coinspot.com.au/api'
                },
                'api': {
                    'public': {
                        'get': ['latest']
                    },
                    'private': {
                        'post': ['orders', 'orders/history', 'my/coin/deposit', 'my/coin/send', 'quote/buy', 'quote/sell', 'my/balances', 'my/orders', 'my/buy', 'my/sell', 'my/buy/cancel', 'my/sell/cancel']
                    }
                },
                'markets': {
                    'BTC/AUD': { 'id': 'BTC', 'symbol': 'BTC/AUD', 'base': 'BTC', 'quote': 'AUD' },
                    'LTC/AUD': { 'id': 'LTC', 'symbol': 'LTC/AUD', 'base': 'LTC', 'quote': 'AUD' },
                    'DOGE/AUD': { 'id': 'DOGE', 'symbol': 'DOGE/AUD', 'base': 'DOGE', 'quote': 'AUD' }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, currencies, c, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostMyBalances();

                            case 2:
                                response = _context.sent;
                                result = { 'info': response };

                                if ('balance' in response) {
                                    balances = response['balance'];
                                    currencies = Object.keys(balances);

                                    for (c = 0; c < currencies.length; c++) {
                                        currency = currencies[c];
                                        uppercase = currency.toUpperCase();
                                        account = {
                                            'free': balances[currency],
                                            'used': 0.0,
                                            'total': balances[currency]
                                        };

                                        if (uppercase === 'DRK') uppercase = 'DASH';
                                        result[uppercase] = account;
                                    }
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.privatePostOrders(this.extend({
                                    'cointype': market['id']
                                }, params));

                            case 3:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buyorders', 'sellorders', 'rate', 'amount'));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, id, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetLatest(params);

                            case 2:
                                response = _context3.sent;
                                id = this.marketId(symbol);

                                id = id.toLowerCase();
                                ticker = response['prices'][id];
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTrades',
        value: function fetchTrades(symbol) {
            var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

            return this.privatePostOrdersHistory(this.extend({
                'cointype': this.marketId(symbol)
            }, params));
        }
    }, {
        key: 'createOrder',
        value: function createOrder(symbol, type, side, amount) {
            var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

            var method = 'privatePostMy' + this.capitalize(side);
            if (type === 'market') throw new ExchangeError(this.id + ' allows limit orders only');
            var order = {
                'cointype': this.marketId(symbol),
                'amount': amount,
                'rate': price
            };
            return this[method](this.extend(order, params));
        }
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                throw new NotSupported(this.id + ' cancelOrder () is not fully implemented yet');

                            case 1:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function cancelOrder(_x12) {
                return _ref4.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            if (!this.apiKey) throw new AuthenticationError(this.id + ' requires apiKey for all requests');
            var url = this.urls['api'][api] + '/' + path;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.json(this.extend({ 'nonce': nonce }, params));
                headers = {
                    'Content-Type': 'application/json',
                    'key': this.apiKey,
                    'sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return coinspot;
}(Exchange);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var huobipro = __webpack_require__(11);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    AuthenticationError = _require.AuthenticationError,
    InvalidOrder = _require.InvalidOrder,
    InsufficientFunds = _require.InsufficientFunds;

// ---------------------------------------------------------------------------

module.exports = function (_huobipro) {
    _inherits(cointiger, _huobipro);

    function cointiger() {
        _classCallCheck(this, cointiger);

        return _possibleConstructorReturn(this, (cointiger.__proto__ || Object.getPrototypeOf(cointiger)).apply(this, arguments));
    }

    _createClass(cointiger, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(cointiger.prototype.__proto__ || Object.getPrototypeOf(cointiger.prototype), 'describe', this).call(this), {
                'id': 'cointiger',
                'name': 'CoinTiger',
                'countries': 'CN',
                'hostname': 'api.cointiger.com',
                'has': {
                    'fetchCurrencies': false,
                    'fetchTickers': true,
                    'fetchOrder': false
                },
                'headers': {
                    'Language': 'en_US'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/39797261-d58df196-5363-11e8-9880-2ec78ec5bd25.jpg',
                    'api': {
                        'public': 'https://api.cointiger.com/exchange/trading/api/market',
                        'private': 'https://api.cointiger.com/exchange/trading/api',
                        'exchange': 'https://www.cointiger.com/exchange'
                    },
                    'www': 'https://www.cointiger.com/exchange/register.html?refCode=FfvDtt',
                    'doc': 'https://github.com/cointiger/api-docs-en/wiki'
                },
                'api': {
                    'public': {
                        'get': ['history/kline', // 获取K线数据
                        'detail/merged', // 获取聚合行情(Ticker)
                        'depth', // 获取 Market Depth 数据
                        'trade', // 获取 Trade Detail 数据
                        'history/trade', // 批量获取最近的交易记录
                        'detail']
                    },
                    'exchange': {
                        'get': ['footer/tradingrule.html', 'api/public/market/detail']
                    },
                    'private': {
                        'get': ['user/balance', 'order/new', 'order/history', 'order/trade'],
                        'post': ['order'],
                        'delete': ['order']
                    }
                },
                'exceptions': {
                    '1': InsufficientFunds,
                    '2': ExchangeError,
                    '5': InvalidOrder,
                    '16': AuthenticationError, // funding password not set
                    '100001': ExchangeError,
                    '100002': ExchangeNotAvailable,
                    '100003': ExchangeError,
                    '100005': AuthenticationError
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, rows, numRows, limit, result, i, row, parts, numParts, id, minAmount, minPrice, precision, _id$split, _id$split2, baseId, quoteId, base, quote, symbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.parseJsonResponse = false;
                                _context.next = 3;
                                return this.exchangeGetFooterTradingruleHtml();

                            case 3:
                                response = _context.sent;

                                this.parseJsonResponse = true;
                                rows = response.split('<tr>');
                                numRows = rows.length;
                                limit = numRows - 1;
                                result = [];
                                i = 1;

                            case 10:
                                if (!(i < limit)) {
                                    _context.next = 32;
                                    break;
                                }

                                row = rows[i];
                                parts = row.split('<span style="color:#ffffff">');
                                numParts = parts.length;

                                if (!(numParts < 6 || parts[1].indexOf('Kind&nbsp') >= 0)) {
                                    _context.next = 16;
                                    break;
                                }

                                return _context.abrupt('continue', 29);

                            case 16:
                                id = parts[1].split('</span>')[0];
                                minAmount = parts[2].split('</span>')[0];
                                minPrice = parts[4].split('</span>')[0];
                                precision = {
                                    'amount': this.precisionFromString(minAmount),
                                    'price': this.precisionFromString(minPrice)
                                };

                                id = id.split('&nbsp')[0];
                                _id$split = id.split('/'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                base = this.commonCurrencyCode(baseId);
                                quote = this.commonCurrencyCode(quoteId);

                                baseId = baseId.toLowerCase();
                                quoteId = quoteId.toLowerCase();
                                id = baseId + quoteId;
                                symbol = base + '/' + quote;

                                result.push({
                                    'id': id,
                                    'uppercaseId': id.toUpperCase(),
                                    'symbol': symbol,
                                    'base': base,
                                    'quote': quote,
                                    'baseId': baseId,
                                    'quoteId': quoteId,
                                    'active': true,
                                    'precision': precision,
                                    'taker': 0.001,
                                    'maker': 0.001,
                                    'limits': {
                                        'amount': {
                                            'min': parseFloat(minAmount),
                                            'max': undefined
                                        },
                                        'price': {
                                            'min': parseFloat(minPrice),
                                            'max': undefined
                                        },
                                        'cost': {
                                            'min': 0,
                                            'max': undefined
                                        }
                                    },
                                    'info': undefined
                                });

                            case 29:
                                i++;
                                _context.next = 10;
                                break;

                            case 32:
                                this.options['marketsByUppercaseId'] = this.indexBy(result, 'uppercaseId');
                                return _context.abrupt('return', result);

                            case 34:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var timestamp = this.safeInteger(ticker, 'id');
            var close = this.safeFloat(ticker, 'last');
            var percentage = this.safeFloat(ticker, 'percentChange');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high24hr'),
                'low': this.safeFloat(ticker, 'low24hr'),
                'bid': this.safeFloat(ticker, 'highestBid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'lowestAsk'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': close,
                'last': close,
                'previousClose': undefined,
                'change': undefined,
                'percentage': percentage,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'baseVolume'),
                'quoteVolume': this.safeFloat(ticker, 'quoteVolume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, data, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetDepth(this.extend({
                                    'symbol': market['id'], // this endpoint requires a lowercase market id
                                    'type': 'step0'
                                }, params));

                            case 5:
                                response = _context2.sent;
                                data = response['data']['depth_data'];

                                if (!('tick' in data)) {
                                    _context2.next = 13;
                                    break;
                                }

                                if (data['tick']) {
                                    _context2.next = 10;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrderBook() returned empty response: ' + this.json(response));

                            case 10:
                                orderbook = data['tick'];
                                timestamp = data['ts'];
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'buys'));

                            case 13:
                                throw new ExchangeError(this.id + ' fetchOrderBook() returned unrecognized response: ' + this.json(response));

                            case 14:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, marketId, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                marketId = market['id'];
                                _context3.next = 6;
                                return this.exchangeGetApiPublicMarketDetail(params);

                            case 6:
                                response = _context3.sent;

                                if (marketId in response) {
                                    _context3.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchTicker symbol ' + symbol + ' (' + marketId + ') not found');

                            case 9:
                                return _context3.abrupt('return', this.parseTicker(response[marketId], market));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, ids, i, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.exchangeGetApiPublicMarketDetail(params);

                            case 4:
                                response = _context4.sent;
                                result = {};
                                ids = Object.keys(response);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = undefined;
                                    symbol = id;

                                    if (id in this.options['marketsByUppercaseId']) {
                                        // this endpoint returns uppercase ids
                                        symbol = this.options['marketsByUppercaseId'][id]['symbol'];
                                    }
                                    result[symbol] = this.parseTicker(response[id], market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            //
            //     {
            //         "volume": {
            //             "amount": "1.000",
            //             "icon": "",
            //             "title": "成交量"
            //                   },
            //         "price": {
            //             "amount": "0.04978883",
            //             "icon": "",
            //             "title": "委托价格"
            //                  },
            //         "created_at": 1513245134000,
            //         "deal_price": {
            //             "amount": 0.04978883000000000000000000000000,
            //             "icon": "",
            //             "title": "成交价格"
            //                       },
            //         "id": 138
            //     }
            //
            var side = this.safeString(trade, 'side');
            var amount = undefined;
            var price = undefined;
            var cost = undefined;
            if (typeof side !== 'undefined') {
                side = side.toLowerCase();
                price = this.safeFloat(trade, 'price');
                amount = this.safeFloat(trade, 'amount');
            } else {
                price = this.safeFloat(trade['price'], 'amount');
                amount = this.safeFloat(trade['volume'], 'amount');
                cost = this.safeFloat(trade['deal_price'], 'amount');
            }
            if (typeof amount !== 'undefined') if (typeof price !== 'undefined') if (typeof cost === 'undefined') cost = amount * price;
            var timestamp = this.safeValue(trade, 'created_at');
            if (typeof timestamp === 'undefined') timestamp = this.safeValue(trade, 'ts');
            var iso8601 = typeof timestamp !== 'undefined' ? this.iso8601(timestamp) : undefined;
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': iso8601,
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['size'] = limit;
                                _context5.next = 7;
                                return this.publicGetHistoryTrade(this.extend(request, params));

                            case 7:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response['data']['trade_data'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol argument');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);

                                if (typeof limit === 'undefined') limit = 100;
                                _context6.next = 8;
                                return this.privateGetOrderTrade(this.extend({
                                    'symbol': market['id'],
                                    'offset': 1,
                                    'limit': limit
                                }, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['data']['list'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchMyTrades() {
                return _ref6.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'period': this.timeframes[timeframe]
                                };

                                if (typeof limit !== 'undefined') {
                                    request['size'] = limit;
                                }
                                _context7.next = 7;
                                return this.publicGetHistoryKline(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(response['data']['kline_data'], market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x18) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, i, balance, id, code, account;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateGetUserBalance(params);

                            case 4:
                                response = _context8.sent;

                                //
                                //     {
                                //         "code": "0",
                                //         "msg": "suc",
                                //         "data": [{
                                //             "normal": "1813.01144179",
                                //             "lock": "1325.42036785",
                                //             "coin": "btc"
                                //         }, {
                                //             "normal": "9551.96692244",
                                //             "lock": "547.06506717",
                                //             "coin": "eth"
                                //         }]
                                //     }
                                //
                                balances = response['data'];
                                result = { 'info': response };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    id = balance['coin'];
                                    code = id.toUpperCase();

                                    code = this.commonCurrencyCode(code);
                                    if (id in this.currencies_by_id) {
                                        code = this.currencies_by_id[id]['code'];
                                    }
                                    account = this.account();

                                    account['used'] = parseFloat(balance['lock']);
                                    account['free'] = balance['normal'];
                                    account['total'] = this.sum(account['used'], account['free']);
                                    result[code] = account;
                                }
                                return _context8.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchBalance() {
                return _ref8.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrdersByStatus',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, method, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context9.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol argument');

                            case 2:
                                _context9.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);

                                if (typeof limit === 'undefined') limit = 100;
                                method = status === 'open' ? 'privateGetOrderNew' : 'privateGetOrderHistory';
                                _context9.next = 9;
                                return this[method](this.extend({
                                    'symbol': market['id'],
                                    'offset': 1,
                                    'limit': limit
                                }, params));

                            case 9:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(response['data']['list'], market, since, limit));

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrdersByStatus() {
                return _ref9.apply(this, arguments);
            }

            return fetchOrdersByStatus;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                return _context10.abrupt('return', this.fetchOrdersByStatus('open', symbol, since, limit, params));

                            case 1:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                return _context11.abrupt('return', this.fetchOrdersByStatus('closed', symbol, since, limit, params));

                            case 1:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchClosedOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = this.safeString(order, 'side');
            side = side.toLowerCase();
            //
            //      {
            //            volume: { "amount": "0.054", "icon": "", "title": "volume" },
            //         age_price: { "amount": "0.08377697", "icon": "", "title": "Avg price" },
            //              side:   "BUY",
            //             price: { "amount": "0.00000000", "icon": "", "title": "price" },
            //        created_at:   1525569480000,
            //       deal_volume: { "amount": "0.64593598", "icon": "", "title": "Deal volume" },
            //   "remain_volume": { "amount": "1.00000000", "icon": "", "title": "尚未成交"
            //                id:   26834207,
            //             label: { go: "trade", title: "Traded", click: 1 },
            //          side_msg:   "Buy"
            //      },
            //
            var type = undefined;
            var status = undefined;
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var timestamp = order['created_at'];
            var amount = this.safeFloat(order['volume'], 'amount');
            var remaining = 'remain_volume' in order ? this.safeFloat(order['remain_volume'], 'amount') : undefined;
            var filled = 'deal_volume' in order ? this.safeFloat(order['deal_volume'], 'amount') : undefined;
            var price = 'age_price' in order ? this.safeFloat(order['age_price'], 'amount') : undefined;
            if (typeof price === 'undefined') price = 'price' in order ? this.safeFloat(order['price'], 'amount') : undefined;
            var cost = undefined;
            var average = undefined;
            if (typeof amount !== 'undefined') {
                if (typeof remaining !== 'undefined') {
                    if (typeof filled === 'undefined') filled = amount - remaining;
                } else if (typeof filled !== 'undefined') {
                    cost = filled * price;
                    average = parseFloat(cost / filled);
                    if (typeof remaining === 'undefined') remaining = amount - filled;
                }
            }
            if (typeof remaining !== 'undefined' && remaining > 0) status = 'open';
            var result = {
                'info': order,
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'average': average,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, orderType, order, response, timestamp;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (this.password) {
                                    _context12.next = 4;
                                    break;
                                }

                                throw new AuthenticationError(this.id + ' createOrder requires exchange.password to be set to user trading password (not login password!)');

                            case 4:
                                this.checkRequiredCredentials();
                                market = this.market(symbol);
                                orderType = type === 'limit' ? 1 : 2;
                                order = {
                                    'symbol': market['id'],
                                    'side': side.toUpperCase(),
                                    'type': orderType,
                                    'volume': this.amountToPrecision(symbol, amount),
                                    'capital_password': this.password
                                };

                                if (!(type === 'market' && side === 'buy')) {
                                    _context12.next = 12;
                                    break;
                                }

                                if (!(typeof price === 'undefined')) {
                                    _context12.next = 11;
                                    break;
                                }

                                throw new InvalidOrder(this.id + ' createOrder requires price argument for market buy orders to calculate total cost according to exchange rules');

                            case 11:
                                order['volume'] = this.amountToPrecision(symbol, amount * price);

                            case 12:
                                if (type === 'limit') order['price'] = this.priceToPrecision(symbol, price);
                                _context12.next = 15;
                                return this.privatePostOrder(this.extend(order, params));

                            case 15:
                                response = _context12.sent;

                                //
                                //     {"order_id":34343}
                                //
                                timestamp = this.milliseconds();
                                return _context12.abrupt('return', {
                                    'info': response,
                                    'id': response['order_id'].toString(),
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': undefined,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'amount': amount,
                                    'filled': undefined,
                                    'remaining': undefined,
                                    'cost': undefined,
                                    'trades': undefined,
                                    'fee': undefined
                                });

                            case 18:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function createOrder(_x38, _x39, _x40, _x41) {
                return _ref12.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(typeof symbol === 'undefined')) {
                                    _context13.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a symbol argument');

                            case 4:
                                market = this.market(symbol);
                                _context13.next = 7;
                                return this.privateDeleteOrder(this.extend({
                                    'symbol': market['id'],
                                    'order_id': id
                                }, params));

                            case 7:
                                return _context13.abrupt('return', _context13.sent);

                            case 8:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function cancelOrder(_x44) {
                return _ref13.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            this.checkRequiredCredentials();
            var url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
            if (api === 'private') {
                var timestamp = this.milliseconds().toString();
                var query = this.keysort(this.extend({
                    'time': timestamp
                }, params));
                var keys = Object.keys(query);
                var auth = '';
                for (var i = 0; i < keys.length; i++) {
                    auth += keys[i] + query[keys[i]];
                }
                auth += this.secret;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha512');
                var isCreateOrderMethod = path === 'order' && method === 'POST';
                var urlParams = isCreateOrderMethod ? {} : query;
                url += '?' + this.urlencode(this.keysort(this.extend({
                    'api_key': this.apiKey,
                    'time': timestamp
                }, urlParams)));
                url += '&sign=' + this.decode(signature);
                if (method === 'POST') {
                    body = this.urlencode(query);
                    headers = {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    };
                }
            } else if (api === 'public') {
                url += '?' + this.urlencode(this.extend({
                    'api_key': this.apiKey
                }, params));
            } else {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('code' in response) {
                    //
                    //     {"code":"100005","msg":"request sign illegal","data":null}
                    //
                    var code = this.safeString(response, 'code');
                    if (typeof code !== 'undefined' && code !== '0') {
                        var message = this.safeString(response, 'msg');
                        var feedback = this.id + ' ' + this.json(response);
                        var exceptions = this.exceptions;
                        if (code in exceptions) {
                            if (code === 2) {
                                if (message === 'offsetNot Null') {
                                    throw new ExchangeError(feedback);
                                } else if (message === 'Parameter error') {
                                    throw new ExchangeError(feedback);
                                }
                            }
                            throw new exceptions[code](feedback);
                        } else {
                            throw new ExchangeError(this.id + ' unknown "error" value: ' + this.json(response));
                        }
                    }
                }
            }
        }
    }]);

    return cointiger;
}(huobipro);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var coinegg = __webpack_require__(20);

//  ---------------------------------------------------------------------------

module.exports = function (_coinegg) {
    _inherits(coolcoin, _coinegg);

    function coolcoin() {
        _classCallCheck(this, coolcoin);

        return _possibleConstructorReturn(this, (coolcoin.__proto__ || Object.getPrototypeOf(coolcoin)).apply(this, arguments));
    }

    _createClass(coolcoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(coolcoin.prototype.__proto__ || Object.getPrototypeOf(coolcoin.prototype), 'describe', this).call(this), {
                'id': 'coolcoin',
                'name': 'CoolCoin',
                'countries': 'HK',
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/36770529-be7b1a04-1c5b-11e8-9600-d11f1996b539.jpg',
                    'api': {
                        'web': 'https://www.coolcoin.com/coin',
                        'rest': 'https://www.coolcoin.com/api/v1'
                    },
                    'www': 'https://www.coolcoin.com',
                    'doc': 'https://www.coolcoin.com/help.api.html',
                    'fees': 'https://www.coolcoin.com/spend.price.html'
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.001,
                            'BCH': 0.002,
                            'ETH': 0.01,
                            'ETC': 0.01,
                            'LTC': 0.001,
                            'TBC': '1%',
                            'HSR': '1%',
                            'NEO': '1%',
                            'SDC': '1%',
                            'EOS': '1%',
                            'BTM': '1%',
                            'XAS': '1%',
                            'ACT': '1%',
                            'SAK': '1%',
                            'GCS': '1%',
                            'HCC': '1%',
                            'QTUM': '1%',
                            'GEC': '1%',
                            'TRX': '1%',
                            'IFC': '1%',
                            'PAY': '1%',
                            'PGC': '1%',
                            'KTC': '1%',
                            'INT': '1%',
                            'LSK': '0.5%',
                            'SKT': '1%',
                            'SSS': '1%',
                            'BT1': '1%',
                            'BT2': '1%'
                        }
                    }
                }
            });
        }
    }]);

    return coolcoin;
}(coinegg);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    OrderNotCached = _require.OrderNotCached;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(cryptopia, _Exchange);

    function cryptopia() {
        _classCallCheck(this, cryptopia);

        return _possibleConstructorReturn(this, (cryptopia.__proto__ || Object.getPrototypeOf(cryptopia)).apply(this, arguments));
    }

    _createClass(cryptopia, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(cryptopia.prototype.__proto__ || Object.getPrototypeOf(cryptopia.prototype), 'describe', this).call(this), {
                'id': 'cryptopia',
                'name': 'Cryptopia',
                'rateLimit': 1500,
                'countries': 'NZ', // New Zealand
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchClosedOrders': 'emulated',
                    'fetchCurrencies': true,
                    'fetchDepositAddress': true,
                    'fetchMyTrades': true,
                    'fetchOrder': 'emulated',
                    'fetchOrderBooks': true,
                    'fetchOrders': 'emulated',
                    'fetchOpenOrders': true,
                    'fetchTickers': true,
                    'deposit': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/29484394-7b4ea6e2-84c6-11e7-83e5-1fccf4b2dc81.jpg',
                    'api': 'https://www.cryptopia.co.nz/api',
                    'www': 'https://www.cryptopia.co.nz/Register?referrer=kroitor',
                    'doc': ['https://www.cryptopia.co.nz/Forum/Category/45', 'https://www.cryptopia.co.nz/Forum/Thread/255', 'https://www.cryptopia.co.nz/Forum/Thread/256']
                },
                'api': {
                    'public': {
                        'get': ['GetCurrencies', 'GetTradePairs', 'GetMarkets', 'GetMarkets/{id}', 'GetMarkets/{hours}', 'GetMarkets/{id}/{hours}', 'GetMarket/{id}', 'GetMarket/{id}/{hours}', 'GetMarketHistory/{id}', 'GetMarketHistory/{id}/{hours}', 'GetMarketOrders/{id}', 'GetMarketOrders/{id}/{count}', 'GetMarketOrderGroups/{ids}', 'GetMarketOrderGroups/{ids}/{count}']
                    },
                    'private': {
                        'post': ['CancelTrade', 'GetBalance', 'GetDepositAddress', 'GetOpenOrders', 'GetTradeHistory', 'GetTransactions', 'SubmitTip', 'SubmitTrade', 'SubmitTransfer', 'SubmitWithdraw']
                    }
                },
                'commonCurrencies': {
                    'ACC': 'AdCoin',
                    'BAT': 'BatCoin',
                    'BLZ': 'BlazeCoin',
                    'BTG': 'Bitgem',
                    'CC': 'CCX',
                    'CMT': 'Comet',
                    'FCN': 'Facilecoin',
                    'FUEL': 'FC2', // FuelCoin != FUEL
                    'HAV': 'Havecoin',
                    'LDC': 'LADACoin',
                    'MARKS': 'Bitmark',
                    'NET': 'NetCoin',
                    'QBT': 'Cubits',
                    'WRC': 'WarCoin'
                },
                'options': {
                    'fetchTickersErrors': true
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, result, markets, i, market, id, symbol, baseId, quoteId, base, quote, precision, lot, priceLimits, amountLimits, limits, active;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetGetTradePairs();

                            case 2:
                                response = _context.sent;
                                result = [];
                                markets = response['Data'];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['Id'];
                                    symbol = market['Label'];
                                    baseId = market['Symbol'];
                                    quoteId = market['BaseSymbol'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);

                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    lot = market['MinimumTrade'];
                                    priceLimits = {
                                        'min': market['MinimumPrice'],
                                        'max': market['MaximumPrice']
                                    };
                                    amountLimits = {
                                        'min': lot,
                                        'max': market['MaximumTrade']
                                    };
                                    limits = {
                                        'amount': amountLimits,
                                        'price': priceLimits,
                                        'cost': {
                                            'min': market['MinimumBaseTrade'],
                                            'max': undefined
                                        }
                                    };
                                    active = market['Status'] === 'OK';

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'label': market['Label'],
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'info': market,
                                        'maker': market['TradeFee'] / 100,
                                        'taker': market['TradeFee'] / 100,
                                        'lot': limits['amount']['min'],
                                        'active': active,
                                        'precision': precision,
                                        'limits': limits
                                    });
                                }
                                this.options['marketsByLabel'] = this.indexBy(result, 'label');
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetGetMarketOrdersId(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context2.sent;
                                orderbook = response['Data'];
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'Buy', 'Sell', 'Price', 'Volume'));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'joinMarketIds',
        value: function joinMarketIds(ids) {
            var glue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

            var result = ids[0].toString();
            for (var i = 1; i < ids.length; i++) {
                result += glue + ids[i].toString();
            }
            return result;
        }
    }, {
        key: 'fetchOrderBooks',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ids, numIds, response, orderbooks, result, i, orderbook, id, symbol, market;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                ids = undefined;

                                if (symbols) {
                                    _context3.next = 10;
                                    break;
                                }

                                numIds = this.ids.length;
                                // max URL length is 2083 characters, including http schema, hostname, tld, etc...

                                if (!(numIds > 2048)) {
                                    _context3.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');

                            case 7:
                                ids = this.joinMarketIds(this.ids);
                                _context3.next = 11;
                                break;

                            case 10:
                                ids = this.joinMarketIds(this.marketIds(symbols));

                            case 11:
                                _context3.next = 13;
                                return this.publicGetGetMarketOrderGroupsIds(this.extend({
                                    'ids': ids
                                }, params));

                            case 13:
                                response = _context3.sent;
                                orderbooks = response['Data'];
                                result = {};

                                for (i = 0; i < orderbooks.length; i++) {
                                    orderbook = orderbooks[i];
                                    id = this.safeInteger(orderbook, 'TradePairId');
                                    symbol = id;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];

                                        symbol = market['symbol'];
                                    }
                                    result[symbol] = this.parseOrderBook(orderbook, undefined, 'Buy', 'Sell', 'Price', 'Volume');
                                }
                                return _context3.abrupt('return', result);

                            case 18:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBooks() {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBooks;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var open = this.safeFloat(ticker, 'Open');
            var last = this.safeFloat(ticker, 'LastPrice');
            var change = last - open;
            var baseVolume = this.safeFloat(ticker, 'Volume');
            var quoteVolume = this.safeFloat(ticker, 'BaseVolume');
            var vwap = undefined;
            if (typeof quoteVolume !== 'undefined') if (typeof baseVolume !== 'undefined') if (baseVolume > 0) vwap = quoteVolume / baseVolume;
            return {
                'symbol': symbol,
                'info': ticker,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'High'),
                'low': this.safeFloat(ticker, 'Low'),
                'bid': this.safeFloat(ticker, 'BidPrice'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'AskPrice'),
                'askVolume': undefined,
                'vwap': vwap,
                'open': open,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': this.safeFloat(ticker, 'Change'),
                'average': this.sum(last, open) / 2,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetGetMarketId(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                response = _context4.sent;
                                ticker = response['Data'];
                                return _context4.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x8) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, tickers, i, ticker, id, recognized, market, symbol;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetGetMarkets(params);

                            case 4:
                                response = _context5.sent;
                                result = {};
                                tickers = response['Data'];
                                i = 0;

                            case 8:
                                if (!(i < tickers.length)) {
                                    _context5.next = 23;
                                    break;
                                }

                                ticker = tickers[i];
                                id = ticker['TradePairId'];
                                recognized = id in this.markets_by_id;

                                if (recognized) {
                                    _context5.next = 17;
                                    break;
                                }

                                if (!this.options['fetchTickersErrors']) {
                                    _context5.next = 15;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchTickers() returned unrecognized pair id ' + id.toString());

                            case 15:
                                _context5.next = 20;
                                break;

                            case 17:
                                market = this.markets_by_id[id];
                                symbol = market['symbol'];

                                result[symbol] = this.parseTicker(ticker, market);

                            case 20:
                                i++;
                                _context5.next = 8;
                                break;

                            case 23:
                                return _context5.abrupt('return', this.filterByArray(result, 'symbol', symbols));

                            case 24:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            if ('Timestamp' in trade) {
                timestamp = trade['Timestamp'] * 1000;
            } else if ('TimeStamp' in trade) {
                timestamp = this.parse8601(trade['TimeStamp']);
            }
            var price = this.safeFloat(trade, 'Price');
            if (!price) price = this.safeFloat(trade, 'Rate');
            var cost = this.safeFloat(trade, 'Total');
            var id = this.safeString(trade, 'TradeId');
            if (!market) {
                if ('TradePairId' in trade) if (trade['TradePairId'] in this.markets_by_id) market = this.markets_by_id[trade['TradePairId']];
            }
            var symbol = undefined;
            var fee = undefined;
            if (market) {
                symbol = market['symbol'];
                if ('Fee' in trade) {
                    fee = {
                        'currency': market['quote'],
                        'cost': trade['Fee']
                    };
                }
            }
            return {
                'id': id,
                'info': trade,
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': 'limit',
                'side': trade['Type'].toLowerCase(),
                'price': price,
                'cost': cost,
                'amount': trade['Amount'],
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, hours, elapsed, hour, request, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                hours = 24; // the default

                                if (typeof since !== 'undefined') {
                                    elapsed = this.milliseconds() - since;
                                    hour = 1000 * 60 * 60;

                                    hours = parseInt(Math.ceil(elapsed / hour));
                                }
                                request = {
                                    'id': market['id'],
                                    'hours': hours
                                };
                                _context6.next = 8;
                                return this.publicGetGetMarketHistoryIdHours(this.extend(request, params));

                            case 8:
                                response = _context6.sent;
                                trades = response['Data'];
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 11:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x13) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['TradePairId'] = market['id'];
                                }
                                if (typeof limit !== 'undefined') {
                                    request['Count'] = limit; // default 100
                                }
                                _context7.next = 8;
                                return this.privatePostGetTradeHistory(this.extend(request, params));

                            case 8:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['Data'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchMyTrades() {
                return _ref7.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, precision, code, active, status;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.publicGetGetCurrencies(params);

                            case 2:
                                response = _context8.sent;
                                currencies = response['Data'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['Symbol'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    precision = 8; // default precision, todo: fix "magic constants"

                                    code = this.commonCurrencyCode(id);
                                    active = currency['ListingStatus'] === 'Active';
                                    status = currency['Status'].toLowerCase();

                                    if (status !== 'ok') active = false;
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': currency['Name'],
                                        'active': active,
                                        'status': status,
                                        'fee': currency['WithdrawFee'],
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': currency['MinBaseTrade'],
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['MinWithdraw'],
                                                'max': currency['MaxWithdraw']
                                            }
                                        }
                                    };
                                }
                                return _context8.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchCurrencies() {
                return _ref8.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, i, balance, code, currency, account;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostGetBalance(params);

                            case 4:
                                response = _context9.sent;
                                balances = response['Data'];
                                result = { 'info': response };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    code = balance['Symbol'];
                                    currency = this.commonCurrencyCode(code);
                                    account = {
                                        'free': balance['Available'],
                                        'used': 0.0,
                                        'total': balance['Total']
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context9.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchBalance() {
                return _ref9.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, request, response, id, filled, status, timestamp, order;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                // price = parseFloat (price);
                                // amount = parseFloat (amount);

                                request = {
                                    'TradePairId': market['id'],
                                    'Type': this.capitalize(side),
                                    // 'Rate': this.priceToPrecision (symbol, price),
                                    // 'Amount': this.amountToPrecision (symbol, amount),
                                    'Rate': price,
                                    'Amount': amount
                                };
                                _context10.next = 8;
                                return this.privatePostSubmitTrade(this.extend(request, params));

                            case 8:
                                response = _context10.sent;

                                if (response) {
                                    _context10.next = 11;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' createOrder returned unknown error: ' + this.json(response));

                            case 11:
                                id = undefined;
                                filled = 0.0;
                                status = 'open';

                                if ('Data' in response) {
                                    if ('OrderId' in response['Data']) {
                                        if (response['Data']['OrderId']) {
                                            id = response['Data']['OrderId'].toString();
                                        } else {
                                            filled = amount;
                                            status = 'closed';
                                        }
                                    }
                                }
                                timestamp = this.milliseconds();
                                order = {
                                    'id': id,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': status,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'cost': price * amount,
                                    'amount': amount,
                                    'remaining': amount - filled,
                                    'filled': filled,
                                    'fee': undefined
                                    // 'trades': this.parseTrades (order['trades'], market),
                                };

                                if (id) this.orders[id] = order;
                                return _context10.abrupt('return', this.extend({ 'info': response }, order));

                            case 19:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x23, _x24, _x25, _x26) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, message;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                response = undefined;
                                _context11.prev = 3;
                                _context11.next = 6;
                                return this.privatePostCancelTrade(this.extend({
                                    'Type': 'Trade',
                                    'OrderId': id
                                }, params));

                            case 6:
                                response = _context11.sent;

                                if (id in this.orders) this.orders[id]['status'] = 'canceled';
                                _context11.next = 18;
                                break;

                            case 10:
                                _context11.prev = 10;
                                _context11.t0 = _context11['catch'](3);

                                if (!this.last_json_response) {
                                    _context11.next = 17;
                                    break;
                                }

                                message = this.safeString(this.last_json_response, 'Error');

                                if (!message) {
                                    _context11.next = 17;
                                    break;
                                }

                                if (!(message.indexOf('does not exist') >= 0)) {
                                    _context11.next = 17;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' cancelOrder() error: ' + this.last_http_response);

                            case 17:
                                throw _context11.t0;

                            case 18:
                                return _context11.abrupt('return', response);

                            case 19:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[3, 10]]);
            }));

            function cancelOrder(_x29) {
                return _ref11.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else if ('Market' in order) {
                var id = order['Market'];
                if (id in this.markets_by_id) {
                    market = this.markets_by_id[id];
                    symbol = market['symbol'];
                } else {
                    if (id in this.options['marketsByLabel']) {
                        market = this.options['marketsByLabel'][id];
                        symbol = market['symbol'];
                    }
                }
            }
            var timestamp = this.parse8601(order['TimeStamp']);
            var amount = this.safeFloat(order, 'Amount');
            var remaining = this.safeFloat(order, 'Remaining');
            var filled = amount - remaining;
            return {
                'id': order['OrderId'].toString(),
                'info': this.omit(order, 'status'),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': order['status'],
                'symbol': symbol,
                'type': 'limit',
                'side': order['Type'].toLowerCase(),
                'price': this.safeFloat(order, 'Rate'),
                'cost': this.safeFloat(order, 'Total'),
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': undefined
                // 'trades': this.parseTrades (order['trades'], market),
            };
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                var market, request, response, orders, i, openOrders, j, openOrdersIndexedById, cachedOrderIds, result, k, id, _order, order;

                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {
                                    // 'Market': market['id'],
                                    // 'TradePairId': market['id'], // Cryptopia identifier (not required if 'Market' supplied)
                                    // 'Count': 100, // default = 100
                                };

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['TradePairId'] = market['id'];
                                }
                                _context12.next = 7;
                                return this.privatePostGetOpenOrders(this.extend(request, params));

                            case 7:
                                response = _context12.sent;
                                orders = [];

                                for (i = 0; i < response['Data'].length; i++) {
                                    orders.push(this.extend(response['Data'][i], { 'status': 'open' }));
                                }
                                openOrders = this.parseOrders(orders, market);

                                for (j = 0; j < openOrders.length; j++) {
                                    this.orders[openOrders[j]['id']] = openOrders[j];
                                }
                                openOrdersIndexedById = this.indexBy(openOrders, 'id');
                                cachedOrderIds = Object.keys(this.orders);
                                result = [];

                                for (k = 0; k < cachedOrderIds.length; k++) {
                                    id = cachedOrderIds[k];

                                    if (id in openOrdersIndexedById) {
                                        this.orders[id] = this.extend(this.orders[id], openOrdersIndexedById[id]);
                                    } else {
                                        _order = this.orders[id];

                                        if (_order['status'] === 'open') {
                                            if (typeof symbol === 'undefined' || _order['symbol'] === symbol) {
                                                this.orders[id] = this.extend(_order, {
                                                    'status': 'closed',
                                                    'cost': _order['amount'] * _order['price'],
                                                    'filled': _order['amount'],
                                                    'remaining': 0.0
                                                });
                                            }
                                        }
                                    }
                                    order = this.orders[id];

                                    if (typeof symbol === 'undefined' || order['symbol'] === symbol) result.push(order);
                                }
                                return _context12.abrupt('return', this.filterBySinceLimit(result, since, limit));

                            case 17:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orders, i;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                id = id.toString();
                                _context13.next = 3;
                                return this.fetchOrders(symbol, undefined, undefined, params);

                            case 3:
                                orders = _context13.sent;
                                i = 0;

                            case 5:
                                if (!(i < orders.length)) {
                                    _context13.next = 11;
                                    break;
                                }

                                if (!(orders[i]['id'] === id)) {
                                    _context13.next = 8;
                                    break;
                                }

                                return _context13.abrupt('return', orders[i]);

                            case 8:
                                i++;
                                _context13.next = 5;
                                break;

                            case 11:
                                throw new OrderNotCached(this.id + ' order ' + id + ' not found in cached .orders, fetchOrder requires .orders (de)serialization implemented for this method to work properly');

                            case 12:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOrder(_x37) {
                return _ref13.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders, result, i;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context14.sent;
                                result = [];

                                for (i = 0; i < orders.length; i++) {
                                    if (orders[i]['status'] === 'open') result.push(orders[i]);
                                }
                                return _context14.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchOpenOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders, result, i;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context15.sent;
                                result = [];

                                for (i = 0; i < orders.length; i++) {
                                    if (orders[i]['status'] === 'closed') result.push(orders[i]);
                                }
                                return _context15.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchClosedOrders() {
                return _ref15.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                currency = this.currency(code);
                                _context16.next = 3;
                                return this.privatePostGetDepositAddress(this.extend({
                                    'Currency': currency['id']
                                }, params));

                            case 3:
                                response = _context16.sent;
                                address = this.safeString(response['Data'], 'BaseAddress');

                                if (!address) address = this.safeString(response['Data'], 'Address');
                                this.checkAddress(address);
                                return _context16.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 8:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchDepositAddress(_x48) {
                return _ref16.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                currency = this.currency(code);

                                this.checkAddress(address);
                                request = {
                                    'Currency': currency['id'],
                                    'Amount': amount,
                                    'Address': address // Address must exist in you AddressBook in security settings
                                };

                                if (tag) request['PaymentId'] = tag;
                                _context17.next = 6;
                                return this.privatePostSubmitWithdraw(this.extend(request, params));

                            case 6:
                                response = _context17.sent;
                                return _context17.abrupt('return', {
                                    'info': response,
                                    'id': response['Data']
                                });

                            case 8:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function withdraw(_x50, _x51, _x52) {
                return _ref17.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                body = this.json(query, { 'convertArraysToObjects': true });
                var hash = this.hash(this.encode(body), 'md5', 'base64');
                var secret = this.base64ToBinary(this.secret);
                var uri = this.encodeURIComponent(url);
                var lowercase = uri.toLowerCase();
                hash = this.binaryToString(hash);
                var payload = this.apiKey + method + lowercase + nonce + hash;
                var signature = this.hmac(this.encode(payload), secret, 'sha256', 'base64');
                var auth = 'amx ' + this.apiKey + ':' + this.binaryToString(signature) + ':' + nonce;
                headers = {
                    'Content-Type': 'application/json',
                    'Authorization': auth
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, error;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context18.sent;

                                if (!response) {
                                    _context18.next = 14;
                                    break;
                                }

                                if (!('Success' in response)) {
                                    _context18.next = 14;
                                    break;
                                }

                                if (!response['Success']) {
                                    _context18.next = 9;
                                    break;
                                }

                                return _context18.abrupt('return', response);

                            case 9:
                                if (!('Error' in response)) {
                                    _context18.next = 14;
                                    break;
                                }

                                error = this.safeString(response, 'error');

                                if (!(typeof error !== 'undefined')) {
                                    _context18.next = 14;
                                    break;
                                }

                                if (!(error.indexOf('Insufficient Funds') >= 0)) {
                                    _context18.next = 14;
                                    break;
                                }

                                throw new InsufficientFunds(this.id + ' ' + this.json(response));

                            case 14:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 15:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function request(_x60) {
                return _ref18.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return cryptopia;
}(Exchange);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var liqui = __webpack_require__(8);

// ---------------------------------------------------------------------------

module.exports = function (_liqui) {
    _inherits(dsx, _liqui);

    function dsx() {
        _classCallCheck(this, dsx);

        return _possibleConstructorReturn(this, (dsx.__proto__ || Object.getPrototypeOf(dsx)).apply(this, arguments));
    }

    _createClass(dsx, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(dsx.prototype.__proto__ || Object.getPrototypeOf(dsx.prototype), 'describe', this).call(this), {
                'id': 'dsx',
                'name': 'DSX',
                'countries': 'UK',
                'rateLimit': 1500,
                'has': {
                    'CORS': false,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchTickers': true,
                    'fetchMyTrades': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27990275-1413158a-645a-11e7-931c-94717f7510e3.jpg',
                    'api': {
                        'public': 'https://dsx.uk/mapi', // market data
                        'private': 'https://dsx.uk/tapi', // trading
                        'dwapi': 'https://dsx.uk/dwapi' // deposit/withdraw
                    },
                    'www': 'https://dsx.uk',
                    'doc': ['https://api.dsx.uk', 'https://dsx.uk/api_docs/public', 'https://dsx.uk/api_docs/private', '']
                },
                'api': {
                    // market data (public)
                    'public': {
                        'get': ['barsFromMoment/{id}/{period}/{start}', // empty reply :\
                        'depth/{pair}', 'info', 'lastBars/{id}/{period}/{amount}', // period is (m, h or d)
                        'periodBars/{id}/{period}/{start}/{end}', 'ticker/{pair}', 'trades/{pair}']
                    },
                    // trading (private)
                    'private': {
                        'post': ['getInfo', 'TransHistory', 'TradeHistory', 'OrderHistory', 'ActiveOrders', 'Trade', 'CancelOrder']
                    },
                    // deposit / withdraw (private)
                    'dwapi': {
                        'post': ['getCryptoDepositAddress', 'cryptoWithdraw', 'fiatWithdraw', 'getTransactionStatus', 'getTransactions']
                    }
                }
            });
        }
    }, {
        key: 'getBaseQuoteFromMarketId',
        value: function getBaseQuoteFromMarketId(id) {
            var uppercase = id.toUpperCase();
            var base = uppercase.slice(0, 3);
            var quote = uppercase.slice(3, 6);
            base = this.commonCurrencyCode(base);
            quote = this.commonCurrencyCode(quote);
            return [base, quote];
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, funds, currencies, c, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostGetInfo();

                            case 4:
                                response = _context.sent;
                                balances = response['return'];
                                result = { 'info': balances };
                                funds = balances['funds'];
                                currencies = Object.keys(funds);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    uppercase = currency.toUpperCase();

                                    uppercase = this.commonCurrencyCode(uppercase);
                                    account = {
                                        'free': funds[currency],
                                        'used': 0.0,
                                        'total': balances['total'][currency]
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[uppercase] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['updated'] * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var average = this.safeFloat(ticker, 'avg');
            if (typeof average !== 'undefined') if (average > 0) average = 1 / average;
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': average,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'vol_cur'),
                'info': ticker
            };
        }
    }, {
        key: 'getOrderIdKey',
        value: function getOrderIdKey() {
            return 'orderId';
        }
    }, {
        key: 'signBodyWithSecret',
        value: function signBodyWithSecret(body) {
            return this.decode(this.hmac(this.encode(body), this.encode(this.secret), 'sha512', 'base64'));
        }
    }, {
        key: 'getVersionString',
        value: function getVersionString() {
            return ''; // they don't prepend version number to public URLs as other BTC-e clones do
        }
    }]);

    return dsx;
}(liqui);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bitfinex = __webpack_require__(18);

//  ---------------------------------------------------------------------------

module.exports = function (_bitfinex) {
    _inherits(ethfinex, _bitfinex);

    function ethfinex() {
        _classCallCheck(this, ethfinex);

        return _possibleConstructorReturn(this, (ethfinex.__proto__ || Object.getPrototypeOf(ethfinex)).apply(this, arguments));
    }

    _createClass(ethfinex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(ethfinex.prototype.__proto__ || Object.getPrototypeOf(ethfinex.prototype), 'describe', this).call(this), {
                'id': 'ethfinex',
                'name': 'Ethfinex',
                'countries': 'VG',
                'version': 'v1',
                'rateLimit': 1500,
                // new metainfo interface
                'has': {
                    'CORS': false,
                    'createDepositAddress': true,
                    'deposit': true,
                    'fetchClosedOrders': true,
                    'fetchDepositAddress': true,
                    'fetchFees': true,
                    'fetchFundingFees': true,
                    'fetchMyTrades': true,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true,
                    'fetchOrder': true,
                    'fetchTickers': true,
                    'fetchTradingFees': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1m',
                    '5m': '5m',
                    '15m': '15m',
                    '30m': '30m',
                    '1h': '1h',
                    '3h': '3h',
                    '6h': '6h',
                    '12h': '12h',
                    '1d': '1D',
                    '1w': '7D',
                    '2w': '14D',
                    '1M': '1M'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/37555526-7018a77c-29f9-11e8-8835-8e415c038a18.jpg',
                    'api': 'https://api.ethfinex.com',
                    'www': 'https://www.ethfinex.com',
                    'doc': ['https://bitfinex.readme.io/v1/docs', 'https://github.com/bitfinexcom/bitfinex-api-node', 'https://www.ethfinex.com/api_docs']
                }
            });
        }
    }]);

    return ethfinex;
}(bitfinex);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    OrderNotFound = _require.OrderNotFound,
    AuthenticationError = _require.AuthenticationError,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    InvalidNonce = _require.InvalidNonce;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(exmo, _Exchange);

    function exmo() {
        _classCallCheck(this, exmo);

        return _possibleConstructorReturn(this, (exmo.__proto__ || Object.getPrototypeOf(exmo)).apply(this, arguments));
    }

    _createClass(exmo, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(exmo.prototype.__proto__ || Object.getPrototypeOf(exmo.prototype), 'describe', this).call(this), {
                'id': 'exmo',
                'name': 'EXMO',
                'countries': ['ES', 'RU'], // Spain, Russia
                'rateLimit': 350, // once every 350 ms ≈ 180 requests per minute ≈ 3 requests per second
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchClosedOrders': 'emulated',
                    'fetchOpenOrders': true,
                    'fetchOrder': 'emulated',
                    'fetchOrders': 'emulated',
                    'fetchOrderTrades': true,
                    'fetchOrderBooks': true,
                    'fetchMyTrades': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766491-1b0ea956-5eda-11e7-9225-40d67b481b8d.jpg',
                    'api': 'https://api.exmo.com',
                    'www': 'https://exmo.me/?ref=131685',
                    'doc': ['https://exmo.me/en/api_doc?ref=131685', 'https://github.com/exmo-dev/exmo_api_lib/tree/master/nodejs'],
                    'fees': 'https://exmo.com/en/docs/fees'
                },
                'api': {
                    'public': {
                        'get': ['currency', 'order_book', 'pair_settings', 'ticker', 'trades']
                    },
                    'private': {
                        'post': ['user_info', 'order_create', 'order_cancel', 'user_open_orders', 'user_trades', 'user_cancelled_orders', 'order_trades', 'required_amount', 'deposit_address', 'withdraw_crypt', 'withdraw_get_txid', 'excode_create', 'excode_load', 'wallet_history']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.001,
                            'LTC': 0.01,
                            'DOGE': 1,
                            'DASH': 0.01,
                            'ETH': 0.01,
                            'WAVES': 0.001,
                            'ZEC': 0.001,
                            'USDT': 25,
                            'XMR': 0.05,
                            'XRP': 0.02,
                            'KICK': 350,
                            'ETC': 0.01,
                            'BCH': 0.001
                        },
                        'deposit': {
                            'USDT': 15,
                            'KICK': 50
                        }
                    }
                },
                'exceptions': {
                    '40005': AuthenticationError, // Authorization error, incorrect signature
                    '40009': InvalidNonce, //
                    '40015': ExchangeError, // API function do not exist
                    '40016': ExchangeNotAvailable, // Maintenance work in progress
                    '40017': AuthenticationError, // Wrong API Key
                    '50052': InsufficientFunds,
                    '50054': InsufficientFunds,
                    '50304': OrderNotFound, // "Order was not found '123456789'" (fetching order trades for an order that does not have trades yet)
                    '50173': OrderNotFound, // "Order with id X was not found." (cancelling non-existent, closed and cancelled order)
                    '50319': InvalidOrder, // Price by order is less than permissible minimum for this pair
                    '50321': InvalidOrder // Price by order is more than permissible maximum for this pair
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, keys, result, p, id, market, symbol, _symbol$split, _symbol$split2, base, quote;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetPairSettings();

                            case 2:
                                markets = _context.sent;
                                keys = Object.keys(markets);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    id = keys[p];
                                    market = markets[id];
                                    symbol = id.replace('_', '/');
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': true,
                                        'limits': {
                                            'amount': {
                                                'min': this.safeFloat(market, 'min_quantity'),
                                                'max': this.safeFloat(market, 'max_quantity')
                                            },
                                            'price': {
                                                'min': this.safeFloat(market, 'min_price'),
                                                'max': this.safeFloat(market, 'max_price')
                                            },
                                            'cost': {
                                                'min': this.safeFloat(market, 'min_amount'),
                                                'max': this.safeFloat(market, 'max_amount')
                                            }
                                        },
                                        'precision': {
                                            'amount': 8,
                                            'price': 8
                                        },
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, currencies, i, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostUserInfo();

                            case 4:
                                response = _context2.sent;
                                result = { 'info': response };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    account = this.account();

                                    if (currency in response['balances']) account['free'] = parseFloat(response['balances'][currency]);
                                    if (currency in response['reserved']) account['used'] = parseFloat(response['reserved'][currency]);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response, result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = this.extend({
                                    'pair': market['id']
                                }, params);

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context3.next = 7;
                                return this.publicGetOrderBook(request);

                            case 7:
                                response = _context3.sent;
                                result = response[market['id']];
                                return _context3.abrupt('return', this.parseOrderBook(result, undefined, 'bid', 'ask'));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchOrderBooks',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ids, numIds, response, result, i, id, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                ids = undefined;

                                if (symbols) {
                                    _context4.next = 10;
                                    break;
                                }

                                ids = this.ids.join(',');
                                // max URL length is 2083 symbols, including http schema, hostname, tld, etc...

                                if (!(ids.length > 2048)) {
                                    _context4.next = 8;
                                    break;
                                }

                                numIds = this.ids.length;
                                throw new ExchangeError(this.id + ' has ' + numIds.toString() + ' symbols exceeding max URL length, you are required to specify a list of symbols in the first argument to fetchOrderBooks');

                            case 8:
                                _context4.next = 12;
                                break;

                            case 10:
                                ids = this.marketIds(symbols);
                                ids = ids.join(',');

                            case 12:
                                _context4.next = 14;
                                return this.publicGetOrderBook(this.extend({
                                    'pair': ids
                                }, params));

                            case 14:
                                response = _context4.sent;
                                result = {};

                                ids = Object.keys(response);
                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    symbol = this.findSymbol(id);

                                    result[symbol] = this.parseOrderBook(response[id], undefined, 'bid', 'ask');
                                }
                                return _context4.abrupt('return', result);

                            case 19:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBooks() {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBooks;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['updated'] * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last_trade');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy_price'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell_price'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'avg'),
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'vol_curr'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result, ids, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                response = _context5.sent;
                                result = {};
                                ids = Object.keys(response);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = response[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, market;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                response = _context6.sent;
                                market = this.market(symbol);
                                return _context6.abrupt('return', this.parseTicker(response[market['id']], market));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'id': trade['trade_id'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': this.safeString(trade, 'order_id'),
                'type': undefined,
                'side': trade['type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'quantity'),
                'cost': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response[market['id']], market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x12) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                }
                                _context8.next = 7;
                                return this.privatePostUserTrades(this.extend(request, params));

                            case 7:
                                response = _context8.sent;

                                if (typeof market !== 'undefined') response = response[market['id']];
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchMyTrades() {
                return _ref8.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var prefix, market, request, response, id, timestamp, status, order;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                prefix = type === 'market' ? type + '_' : '';
                                market = this.market(symbol);

                                if (type === 'market' && typeof price === 'undefined') {
                                    price = 0;
                                }
                                request = {
                                    'pair': market['id'],
                                    'quantity': this.amountToString(symbol, amount),
                                    'type': prefix + side,
                                    'price': this.priceToPrecision(symbol, price)
                                };
                                _context9.next = 8;
                                return this.privatePostOrderCreate(this.extend(request, params));

                            case 8:
                                response = _context9.sent;
                                id = this.safeString(response, 'order_id');
                                timestamp = this.milliseconds();

                                amount = parseFloat(amount);
                                price = parseFloat(price);
                                status = 'open';
                                order = {
                                    'id': id,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'lastTradeTimestamp': undefined,
                                    'status': status,
                                    'symbol': symbol,
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'cost': price * amount,
                                    'amount': amount,
                                    'remaining': amount,
                                    'filled': 0.0,
                                    'fee': undefined,
                                    'trades': undefined
                                };

                                this.orders[id] = order;
                                return _context9.abrupt('return', this.extend({ 'info': response }, order));

                            case 17:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x20, _x21, _x22, _x23) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostOrderCancel({ 'order_id': id });

                            case 4:
                                response = _context10.sent;

                                if (id in this.orders) this.orders[id]['status'] = 'canceled';
                                return _context10.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x26) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.prev = 2;
                                _context11.next = 5;
                                return this.privatePostOrderTrades({
                                    'order_id': id.toString()
                                });

                            case 5:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrder(response));

                            case 9:
                                _context11.prev = 9;
                                _context11.t0 = _context11['catch'](2);

                                if (!(_context11.t0 instanceof OrderNotFound)) {
                                    _context11.next = 14;
                                    break;
                                }

                                if (!(id in this.orders)) {
                                    _context11.next = 14;
                                    break;
                                }

                                return _context11.abrupt('return', this.orders[id]);

                            case 14:
                                throw new OrderNotFound(this.id + ' fetchOrder order id ' + id.toString() + ' not found in cache.');

                            case 15:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[2, 9]]);
            }));

            function fetchOrder(_x29) {
                return _ref11.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrderTrades',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                _context12.next = 4;
                                return this.privatePostOrderTrades({
                                    'order_id': id.toString()
                                });

                            case 4:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 6:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrderTrades(_x32) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrderTrades;
        }()
    }, {
        key: 'updateCachedOrders',
        value: function updateCachedOrders(openOrders, symbol) {
            // update local cache with open orders
            for (var j = 0; j < openOrders.length; j++) {
                var id = openOrders[j]['id'];
                this.orders[id] = openOrders[j];
            }
            var openOrdersIndexedById = this.indexBy(openOrders, 'id');
            var cachedOrderIds = Object.keys(this.orders);
            for (var k = 0; k < cachedOrderIds.length; k++) {
                // match each cached order to an order in the open orders array
                // possible reasons why a cached order may be missing in the open orders array:
                // - order was closed or canceled -> update cache
                // - symbol mismatch (e.g. cached BTC/USDT, fetched ETH/USDT) -> skip
                var _id = cachedOrderIds[k];
                var order = this.orders[_id];
                if (!(_id in openOrdersIndexedById)) {
                    // cached order is not in open orders array
                    // if we fetched orders by symbol and it doesn't match the cached order -> won't update the cached order
                    if (typeof symbol !== 'undefined' && symbol !== order['symbol']) continue;
                    // order is cached but not present in the list of open orders -> mark the cached order as closed
                    if (order['status'] === 'open') {
                        order = this.extend(order, {
                            'status': 'closed', // likewise it might have been canceled externally (unnoticed by "us")
                            'cost': undefined,
                            'filled': order['amount'],
                            'remaining': 0.0
                        });
                        if (typeof order['cost'] === 'undefined') {
                            if (typeof order['filled'] !== 'undefined') order['cost'] = order['filled'] * order['price'];
                        }
                        this.orders[_id] = order;
                    }
                }
            }
            return this.toArray(this.orders);
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response, marketIds, orders, i, marketId, market, parsedOrders;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context13.next = 4;
                                return this.privatePostUserOpenOrders(params);

                            case 4:
                                response = _context13.sent;
                                marketIds = Object.keys(response);
                                orders = [];

                                for (i = 0; i < marketIds.length; i++) {
                                    marketId = marketIds[i];
                                    market = undefined;

                                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                                    parsedOrders = this.parseOrders(response[marketId], market);

                                    orders = this.arrayConcat(orders, parsedOrders);
                                }
                                this.updateCachedOrders(orders, symbol);
                                return _context13.abrupt('return', this.filterBySymbolSinceLimit(this.toArray(this.orders), symbol, since, limit));

                            case 10:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = this.filterBy(this.orders, 'status', 'open');
                                return _context14.abrupt('return', this.filterBySymbolSinceLimit(orders, symbol, since, limit));

                            case 4:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchOpenOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = this.filterBy(this.orders, 'status', 'closed');
                                return _context15.abrupt('return', this.filterBySymbolSinceLimit(orders, symbol, since, limit));

                            case 4:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchClosedOrders() {
                return _ref15.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var id = this.safeString(order, 'order_id');
            var timestamp = this.safeInteger(order, 'created');
            if (typeof timestamp !== 'undefined') timestamp *= 1000;
            var iso8601 = undefined;
            var symbol = undefined;
            var side = this.safeString(order, 'type');
            if (typeof market === 'undefined') {
                var marketId = undefined;
                if ('pair' in order) {
                    marketId = order['pair'];
                } else if ('in_currency' in order && 'out_currency' in order) {
                    if (side === 'buy') marketId = order['in_currency'] + '_' + order['out_currency'];else marketId = order['out_currency'] + '_' + order['in_currency'];
                }
                if (typeof marketId !== 'undefined' && marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            var amount = this.safeFloat(order, 'quantity');
            if (typeof amount === 'undefined') {
                var amountField = side === 'buy' ? 'in_amount' : 'out_amount';
                amount = this.safeFloat(order, amountField);
            }
            var price = this.safeFloat(order, 'price');
            var cost = this.safeFloat(order, 'amount');
            var filled = 0.0;
            var trades = [];
            var transactions = this.safeValue(order, 'trades');
            var feeCost = undefined;
            if (typeof transactions !== 'undefined') {
                if (Array.isArray(transactions)) {
                    for (var i = 0; i < transactions.length; i++) {
                        var trade = this.parseTrade(transactions[i], market);
                        if (typeof id === 'undefined') id = trade['order'];
                        if (typeof timestamp === 'undefined') timestamp = trade['timestamp'];
                        if (timestamp > trade['timestamp']) timestamp = trade['timestamp'];
                        filled += trade['amount'];
                        if (typeof feeCost === 'undefined') feeCost = 0.0;
                        // feeCost += trade['fee']['cost'];
                        if (typeof cost === 'undefined') cost = 0.0;
                        cost += trade['cost'];
                        trades.push(trade);
                    }
                }
            }
            if (typeof timestamp !== 'undefined') iso8601 = this.iso8601(timestamp);
            var remaining = undefined;
            if (typeof amount !== 'undefined') remaining = amount - filled;
            var status = this.safeString(order, 'status'); // in case we need to redefine it for canceled orders
            if (filled >= amount) status = 'closed';else status = 'open';
            if (typeof market === 'undefined') market = this.getMarketFromTrades(trades);
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                feeCurrency = market['quote'];
            }
            if (typeof cost === 'undefined') {
                if (typeof price !== 'undefined') cost = price * filled;
            } else if (typeof price === 'undefined') {
                if (filled > 0) price = cost / filled;
            }
            var fee = {
                'cost': feeCost,
                'currency': feeCurrency
            };
            return {
                'id': id,
                'datetime': iso8601,
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': trades,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'getMarketFromTrades',
        value: function getMarketFromTrades(trades) {
            var tradesBySymbol = this.indexBy(trades, 'pair');
            var symbols = Object.keys(tradesBySymbol);
            var numSymbols = symbols.length;
            if (numSymbols === 1) return this.markets[symbols[0]];
            return undefined;
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * rate));
            var key = 'quote';
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(symbol, cost))
            };
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, result;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'amount': amount,
                                    'currency': currency,
                                    'address': address
                                };

                                if (typeof tag !== 'undefined') request['invoice'] = tag;
                                _context16.next = 6;
                                return this.privatePostWithdrawCrypt(this.extend(request, params));

                            case 6:
                                result = _context16.sent;
                                return _context16.abrupt('return', {
                                    'info': result,
                                    'id': result['task_id']
                                });

                            case 8:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function withdraw(_x52, _x53, _x54) {
                return _ref16.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({ 'nonce': nonce }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(httpCode, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{' || body[0] === '[') {
                var response = JSON.parse(body);
                if ('result' in response) {
                    //
                    //     {"result":false,"error":"Error 50052: Insufficient funds"}
                    //
                    var success = this.safeValue(response, 'result', false);
                    if (typeof success === 'string') {
                        if (success === 'true' || success === '1') success = true;else success = false;
                    }
                    if (!success) {
                        var code = undefined;
                        var message = this.safeString(response, 'error');
                        var errorParts = message.split(':');
                        var numParts = errorParts.length;
                        if (numParts > 1) {
                            var errorSubParts = errorParts[0].split(' ');
                            var numSubParts = errorSubParts.length;
                            code = numSubParts > 1 ? errorSubParts[1] : errorSubParts[0];
                        }
                        var feedback = this.id + ' ' + this.json(response);
                        var exceptions = this.exceptions;
                        if (code in exceptions) {
                            throw new exceptions[code](feedback);
                        } else {
                            throw new ExchangeError(feedback);
                        }
                    }
                }
            }
        }
    }]);

    return exmo;
}(Exchange);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(exx, _Exchange);

    function exx() {
        _classCallCheck(this, exx);

        return _possibleConstructorReturn(this, (exx.__proto__ || Object.getPrototypeOf(exx)).apply(this, arguments));
    }

    _createClass(exx, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(exx.prototype.__proto__ || Object.getPrototypeOf(exx.prototype), 'describe', this).call(this), {
                'id': 'exx',
                'name': 'EXX',
                'countries': 'CN',
                'rateLimit': 1000 / 10,
                'has': {
                    'fetchOrder': true,
                    'fetchTickers': true,
                    'fetchOpenOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/37770292-fbf613d0-2de4-11e8-9f79-f2dc451b8ccb.jpg',
                    'api': {
                        'public': 'https://api.exx.com/data/v1',
                        'private': 'https://trade.exx.com/api'
                    },
                    'www': 'https://www.exx.com/',
                    'doc': 'https://www.exx.com/help/restApi',
                    'fees': 'https://www.exx.com/help/rate'
                },
                'api': {
                    'public': {
                        'get': ['markets', 'tickers', 'ticker', 'depth', 'trades']
                    },
                    'private': {
                        'get': ['order', 'cancel', 'getOrder', 'getOpenOrders', 'getBalance']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BCC': 0.0003,
                            'BCD': 0.0,
                            'BOT': 10.0,
                            'BTC': 0.001,
                            'BTG': 0.0,
                            'BTM': 25.0,
                            'BTS': 3.0,
                            'EOS': 1.0,
                            'ETC': 0.01,
                            'ETH': 0.01,
                            'ETP': 0.012,
                            'HPY': 0.0,
                            'HSR': 0.001,
                            'INK': 20.0,
                            'LTC': 0.005,
                            'MCO': 0.6,
                            'MONA': 0.01,
                            'QASH': 5.0,
                            'QCASH': 5.0,
                            'QTUM': 0.01,
                            'USDT': 5.0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, ids, result, i, id, market, _id$split, _id$split2, baseId, quoteId, upper, _upper$split, _upper$split2, base, quote, symbol, active, precision, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                markets = _context.sent;
                                ids = Object.keys(markets);
                                result = [];

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = markets[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    upper = id.toUpperCase();
                                    _upper$split = upper.split('_'), _upper$split2 = _slicedToArray(_upper$split, 2), base = _upper$split2[0], quote = _upper$split2[1];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    active = market['isOpen'] === true;
                                    precision = {
                                        'amount': parseInt(market['amountScale']),
                                        'price': parseInt(market['priceScale'])
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': active,
                                        'lot': lot,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': Math.pow(10, precision['price'])
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = parseInt(ticker['date']);
            ticker = ticker['ticker'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'riseRate'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetTicker(this.extend({
                                    'currency': market['id']
                                }, params));

                            case 5:
                                ticker = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, timestamp, ids, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                tickers = _context3.sent;
                                result = {};
                                timestamp = this.milliseconds();
                                ids = Object.keys(tickers);
                                i = 0;

                            case 9:
                                if (!(i < ids.length)) {
                                    _context3.next = 20;
                                    break;
                                }

                                id = ids[i];

                                if (id in this.marketsById) {
                                    _context3.next = 13;
                                    break;
                                }

                                return _context3.abrupt('continue', 17);

                            case 13:
                                market = this.marketsById[id];
                                symbol = market['symbol'];
                                ticker = {
                                    'date': timestamp,
                                    'ticker': tickers[id]
                                };

                                result[symbol] = this.parseTicker(ticker, market);

                            case 17:
                                i++;
                                _context3.next = 9;
                                break;

                            case 20:
                                return _context3.abrupt('return', result);

                            case 21:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetDepth(this.extend({
                                    'currency': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context4.sent;
                                return _context4.abrupt('return', this.parseOrderBook(orderbook, orderbook['timestamp']));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['date'] * 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = this.costToPrecision(symbol, price * amount);
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tid'),
                'order': undefined,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, trades;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'currency': market['id']
                                }, params));

                            case 5:
                                trades = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, id, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privateGetGetBalance(params);

                            case 4:
                                balances = _context6.sent;
                                result = { 'info': balances };

                                balances = balances['funds'];
                                currencies = Object.keys(balances);

                                for (i = 0; i < currencies.length; i++) {
                                    id = currencies[i];
                                    balance = balances[id];
                                    currency = this.commonCurrencyCode(id);
                                    account = {
                                        'free': parseFloat(balance['balance']),
                                        'used': parseFloat(balance['freeze']),
                                        'total': parseFloat(balance['total'])
                                    };

                                    result[currency] = account;
                                }
                                return _context6.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchBalance() {
                return _ref6.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = parseInt(order['trade_date']);
            var price = this.safeFloat(order, 'price');
            var cost = this.safeFloat(order, 'trade_money');
            var amount = this.safeFloat(order, 'total_amount');
            var filled = this.safeFloat(order, 'trade_amount', 0.0);
            var remaining = this.amountToPrecision(symbol, amount - filled);
            var status = this.safeInteger(order, 'status');
            if (status === 1) {
                status = 'canceled';
            } else if (status === 2) {
                status = 'closed';
            } else {
                status = 'open';
            }
            var fee = undefined;
            if ('fees' in order) {
                fee = {
                    'cost': this.safeFloat(order, 'fees'),
                    'currency': market['quote']
                };
            }
            return {
                'id': this.safeString(order, 'id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': 'open',
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, response, id, order;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.privateGetOrder(this.extend({
                                    'currency': market['id'],
                                    'type': side,
                                    'price': price,
                                    'amount': amount
                                }, params));

                            case 5:
                                response = _context7.sent;
                                id = response['id'];
                                order = this.parseOrder({
                                    'id': id,
                                    'trade_date': this.milliseconds(),
                                    'total_amount': amount,
                                    'price': price,
                                    'type': side,
                                    'info': response
                                }, market);

                                this.orders[id] = order;
                                return _context7.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x16, _x17, _x18, _x19) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.privateGetCancel(this.extend({
                                    'id': id,
                                    'currency': market['id']
                                }, params));

                            case 5:
                                result = _context8.sent;
                                return _context8.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x22) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, order;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context9.next = 5;
                                return this.privateGetGetOrder(this.extend({
                                    'id': id,
                                    'currency': market['id']
                                }, params));

                            case 5:
                                order = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(order, market));

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x25) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, orders;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context10.next = 5;
                                return this.privateGetOpenOrders(this.extend({
                                    'currency': market['id']
                                }, params));

                            case 5:
                                orders = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var query = this.urlencode(this.keysort(this.extend({
                    'accesskey': this.apiKey,
                    'nonce': this.nonce()
                }, params)));
                var signature = this.hmac(this.encode(query), this.encode(this.secret), 'sha512');
                url += '?' + query + '&signature=' + signature;
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, code, message;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context11.sent;
                                code = this.safeInteger(response, 'code');
                                message = this.safeString(response, 'message');

                                if (!(code && code !== 100 && message)) {
                                    _context11.next = 9;
                                    break;
                                }

                                if (!(code === 103)) {
                                    _context11.next = 8;
                                    break;
                                }

                                throw new AuthenticationError(message);

                            case 8:
                                throw new ExchangeError(message);

                            case 9:
                                return _context11.abrupt('return', response);

                            case 10:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function request(_x37) {
                return _ref11.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return exx;
}(Exchange);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

var _require2 = __webpack_require__(14),
    ROUND = _require2.ROUND;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(flowbtc, _Exchange);

    function flowbtc() {
        _classCallCheck(this, flowbtc);

        return _possibleConstructorReturn(this, (flowbtc.__proto__ || Object.getPrototypeOf(flowbtc)).apply(this, arguments));
    }

    _createClass(flowbtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(flowbtc.prototype.__proto__ || Object.getPrototypeOf(flowbtc.prototype), 'describe', this).call(this), {
                'id': 'flowbtc',
                'name': 'flowBTC',
                'countries': 'BR', // Brazil
                'version': 'v1',
                'rateLimit': 1000,
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28162465-cd815d4c-67cf-11e7-8e57-438bea0523a2.jpg',
                    'api': 'https://api.flowbtc.com:8405/ajax',
                    'www': 'https://trader.flowbtc.com',
                    'doc': 'http://www.flowbtc.com.br/api/'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'post': ['GetTicker', 'GetTrades', 'GetTradesByDate', 'GetOrderBook', 'GetProductPairs', 'GetProducts']
                    },
                    'private': {
                        'post': ['CreateAccount', 'GetUserInfo', 'SetUserInfo', 'GetAccountInfo', 'GetAccountTrades', 'GetDepositAddresses', 'Withdraw', 'CreateOrder', 'ModifyOrder', 'CancelOrder', 'CancelAllOrders', 'GetAccountOpenOrders', 'GetOrderFee']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.0035,
                        'taker': 0.0035
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, p, market, id, base, quote, precision, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicPostGetProductPairs();

                            case 2:
                                response = _context.sent;
                                markets = response['productPairs'];
                                result = {};

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['name'];
                                    base = market['product1Label'];
                                    quote = market['product2Label'];
                                    precision = {
                                        'amount': this.safeInteger(market, 'product1DecimalPlaces'),
                                        'price': this.safeInteger(market, 'product2DecimalPlaces')
                                    };
                                    symbol = base + '/' + quote;

                                    result[symbol] = {
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetAccountInfo();

                            case 4:
                                response = _context2.sent;
                                balances = response['currencies'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['name'];
                                    account = {
                                        'free': balance['balance'],
                                        'used': balance['hold'],
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicPostGetOrderBook(this.extend({
                                    'productPair': market['id']
                                }, params));

                            case 5:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'px', 'qty'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicPostGetTicker(this.extend({
                                    'productPair': market['id']
                                }, params));

                            case 5:
                                ticker = _context4.sent;
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'last');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'volume24hr'),
                                    'quoteVolume': this.safeFloat(ticker, 'volume24hrProduct2'),
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['unixtime'] * 1000;
            var side = trade['incomingOrderSide'] === 0 ? 'buy' : 'sell';
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': trade['tid'].toString(),
                'order': undefined,
                'type': undefined,
                'side': side,
                'price': trade['px'],
                'amount': trade['qty']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicPostGetTrades(this.extend({
                                    'ins': market['id'],
                                    'startIndex': -1
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'priceToPrecision',
        value: function priceToPrecision(symbol, price) {
            return this.decimalToPrecision(price, ROUND, this.markets[symbol]['precision']['price'], this.precisionMode);
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var orderType, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                orderType = type === 'market' ? 1 : 0;
                                order = {
                                    'ins': this.marketId(symbol),
                                    'side': side,
                                    'orderType': orderType,
                                    'qty': amount,
                                    'px': this.priceToPrecision(symbol, price)
                                };
                                _context6.next = 6;
                                return this.privatePostCreateOrder(this.extend(order, params));

                            case 6:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['serverOrderId']
                                });

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!('ins' in params)) {
                                    _context7.next = 6;
                                    break;
                                }

                                _context7.next = 5;
                                return this.privatePostCancelOrder(this.extend({
                                    'serverOrderId': id
                                }, params));

                            case 5:
                                return _context7.abrupt('return', _context7.sent);

                            case 6:
                                throw new ExchangeError(this.id + ' requires `ins` symbol parameter for cancelling an order');

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x17) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) {
                    body = this.json(params);
                }
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var auth = nonce.toString() + this.uid + this.apiKey;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret));
                body = this.json(this.extend({
                    'apiKey': this.apiKey,
                    'apiNonce': nonce,
                    'apiSig': signature.toUpperCase()
                }, params));
                headers = {
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context8.sent;

                                if (!('isAccepted' in response)) {
                                    _context8.next = 6;
                                    break;
                                }

                                if (!response['isAccepted']) {
                                    _context8.next = 6;
                                    break;
                                }

                                return _context8.abrupt('return', response);

                            case 6:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function request(_x25) {
                return _ref8.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return flowbtc;
}(Exchange);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var fybse = __webpack_require__(34);

// ---------------------------------------------------------------------------

module.exports = function (_fybse) {
    _inherits(fybsg, _fybse);

    function fybsg() {
        _classCallCheck(this, fybsg);

        return _possibleConstructorReturn(this, (fybsg.__proto__ || Object.getPrototypeOf(fybsg)).apply(this, arguments));
    }

    _createClass(fybsg, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(fybsg.prototype.__proto__ || Object.getPrototypeOf(fybsg.prototype), 'describe', this).call(this), {
                'id': 'fybsg',
                'name': 'FYB-SG',
                'countries': 'SG', // Singapore
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766513-3364d56a-5edb-11e7-9e6b-d5898bb89c81.jpg',
                    'api': 'https://www.fybsg.com/api/SGD',
                    'www': 'https://www.fybsg.com',
                    'doc': 'http://docs.fyb.apiary.io'
                },
                'markets': {
                    'BTC/SGD': { 'id': 'SGD', 'symbol': 'BTC/SGD', 'base': 'BTC', 'quote': 'SGD' }
                }
            });
        }
    }]);

    return fybsg;
}(fybse);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    InvalidAddress = _require.InvalidAddress,
    InsufficientFunds = _require.InsufficientFunds;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(gatecoin, _Exchange);

    function gatecoin() {
        _classCallCheck(this, gatecoin);

        return _possibleConstructorReturn(this, (gatecoin.__proto__ || Object.getPrototypeOf(gatecoin)).apply(this, arguments));
    }

    _createClass(gatecoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(gatecoin.prototype.__proto__ || Object.getPrototypeOf(gatecoin.prototype), 'describe', this).call(this), {
                'id': 'gatecoin',
                'name': 'Gatecoin',
                'rateLimit': 2000,
                'countries': 'HK', // Hong Kong
                'comment': 'a regulated/licensed exchange',
                'has': {
                    'CORS': false,
                    'createDepositAddress': true,
                    'fetchDepositAddress': true,
                    'fetchOHLCV': true,
                    'fetchOpenOrders': true,
                    'fetchOrder': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1m',
                    '15m': '15m',
                    '1h': '1h',
                    '6h': '6h',
                    '1d': '24h'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28646817-508457f2-726c-11e7-9eeb-3528d2413a58.jpg',
                    'api': 'https://api.gatecoin.com',
                    'www': 'https://gatecoin.com',
                    'doc': ['https://gatecoin.com/api', 'https://github.com/Gatecoin/RESTful-API-Implementation', 'https://api.gatecoin.com/swagger-ui/index.html']
                },
                'api': {
                    'public': {
                        'get': ['Public/ExchangeRate', // Get the exchange rates
                        'Public/LiveTicker', // Get live ticker for all currency
                        'Public/LiveTicker/{CurrencyPair}', // Get live ticker by currency
                        'Public/LiveTickers', // Get live ticker for all currency
                        'Public/MarketDepth/{CurrencyPair}', // Gets prices and market depth for the currency pair.
                        'Public/NetworkStatistics/{DigiCurrency}', // Get the network status of a specific digital currency
                        'Public/StatisticHistory/{DigiCurrency}/{Typeofdata}', // Get the historical data of a specific digital currency
                        'Public/TickerHistory/{CurrencyPair}/{Timeframe}', // Get ticker history
                        'Public/Transactions/{CurrencyPair}', // Gets recent transactions
                        'Public/TransactionsHistory/{CurrencyPair}', // Gets all transactions
                        'Reference/BusinessNatureList', // Get the business nature list.
                        'Reference/Countries', // Get the country list.
                        'Reference/Currencies', // Get the currency list.
                        'Reference/CurrencyPairs', // Get the currency pair list.
                        'Reference/CurrentStatusList', // Get the current status list.
                        'Reference/IdentydocumentTypes', // Get the different types of identity documents possible.
                        'Reference/IncomeRangeList', // Get the income range list.
                        'Reference/IncomeSourceList', // Get the income source list.
                        'Reference/VerificationLevelList', // Get the verif level list.
                        'Stream/PublicChannel'],
                        'post': ['Export/Transactions', // Request a export of all trades from based on currencypair, start date and end date
                        'Ping', // Post a string, then get it back.
                        'Public/Unsubscribe/{EmailCode}', // Lets the user unsubscribe from emails
                        'RegisterUser']
                    },
                    'private': {
                        'get': ['Account/CorporateData', // Get corporate account data
                        'Account/DocumentAddress', // Check if residence proof uploaded
                        'Account/DocumentCorporation', // Check if registered document uploaded
                        'Account/DocumentID', // Check if ID document copy uploaded
                        'Account/DocumentInformation', // Get Step3 Data
                        'Account/Email', // Get user email
                        'Account/FeeRate', // Get fee rate of logged in user
                        'Account/Level', // Get verif level of logged in user
                        'Account/PersonalInformation', // Get Step1 Data
                        'Account/Phone', // Get user phone number
                        'Account/Profile', // Get trader profile
                        'Account/Questionnaire', // Fill the questionnaire
                        'Account/Referral', // Get referral information
                        'Account/ReferralCode', // Get the referral code of the logged in user
                        'Account/ReferralNames', // Get names of referred traders
                        'Account/ReferralReward', // Get referral reward information
                        'Account/ReferredCode', // Get referral code
                        'Account/ResidentInformation', // Get Step2 Data
                        'Account/SecuritySettings', // Get verif details of logged in user
                        'Account/User', // Get all user info
                        'APIKey/APIKey', // Get API Key for logged in user
                        'Auth/ConnectionHistory', // Gets connection history of logged in user
                        'Balance/Balances', // Gets the available balance for each currency for the logged in account.
                        'Balance/Balances/{Currency}', // Gets the available balance for s currency for the logged in account.
                        'Balance/Deposits', // Get all account deposits, including wire and digital currency, of the logged in user
                        'Balance/Withdrawals', // Get all account withdrawals, including wire and digital currency, of the logged in user
                        'Bank/Accounts/{Currency}/{Location}', // Get internal bank account for deposit
                        'Bank/Transactions', // Get all account transactions of the logged in user
                        'Bank/UserAccounts', // Gets all the bank accounts related to the logged in user.
                        'Bank/UserAccounts/{Currency}', // Gets all the bank accounts related to the logged in user.
                        'ElectronicWallet/DepositWallets', // Gets all crypto currency addresses related deposits to the logged in user.
                        'ElectronicWallet/DepositWallets/{DigiCurrency}', // Gets all crypto currency addresses related deposits to the logged in user by currency.
                        'ElectronicWallet/Transactions', // Get all digital currency transactions of the logged in user
                        'ElectronicWallet/Transactions/{DigiCurrency}', // Get all digital currency transactions of the logged in user
                        'ElectronicWallet/UserWallets', // Gets all external digital currency addresses related to the logged in user.
                        'ElectronicWallet/UserWallets/{DigiCurrency}', // Gets all external digital currency addresses related to the logged in user by currency.
                        'Info/ReferenceCurrency', // Get user's reference currency
                        'Info/ReferenceLanguage', // Get user's reference language
                        'Notification/Messages', // Get from oldest unread + 3 read message to newest messages
                        'Trade/Orders', // Gets open orders for the logged in trader.
                        'Trade/Orders/{OrderID}', // Gets an order for the logged in trader.
                        'Trade/StopOrders', // Gets all stop orders for the logged in trader. Max 1000 record.
                        'Trade/StopOrdersHistory', // Gets all stop orders for the logged in trader. Max 1000 record.
                        'Trade/Trades', // Gets all transactions of logged in user
                        'Trade/UserTrades'],
                        'post': ['Account/DocumentAddress', // Upload address proof document
                        'Account/DocumentCorporation', // Upload registered document document
                        'Account/DocumentID', // Upload ID document copy
                        'Account/Email/RequestVerify', // Request for verification email
                        'Account/Email/Verify', // Verification email
                        'Account/GoogleAuth', // Enable google auth
                        'Account/Level', // Request verif level of logged in user
                        'Account/Questionnaire', // Fill the questionnaire
                        'Account/Referral', // Post a referral email
                        'APIKey/APIKey', // Create a new API key for logged in user
                        'Auth/ChangePassword', // Change password.
                        'Auth/ForgotPassword', // Request reset password
                        'Auth/ForgotUserID', // Request user id
                        'Auth/Login', // Trader session log in.
                        'Auth/Logout', // Logout from the current session.
                        'Auth/LogoutOtherSessions', // Logout other sessions.
                        'Auth/ResetPassword', // Reset password
                        'Bank/Transactions', // Request a transfer from the traders account of the logged in user. This is only available for bank account
                        'Bank/UserAccounts', // Add an account the logged in user
                        'ElectronicWallet/DepositWallets/{DigiCurrency}', // Add an digital currency addresses to the logged in user.
                        'ElectronicWallet/Transactions/Deposits/{DigiCurrency}', // Get all internal digital currency transactions of the logged in user
                        'ElectronicWallet/Transactions/Withdrawals/{DigiCurrency}', // Get all external digital currency transactions of the logged in user
                        'ElectronicWallet/UserWallets/{DigiCurrency}', // Add an external digital currency addresses to the logged in user.
                        'ElectronicWallet/Withdrawals/{DigiCurrency}', // Request a transfer from the traders account to an external address. This is only available for crypto currencies.
                        'Notification/Messages', // Mark all as read
                        'Notification/Messages/{ID}', // Mark as read
                        'Trade/Orders', // Place an order at the exchange.
                        'Trade/StopOrders'],
                        'put': ['Account/CorporateData', // Update user company data for corporate account
                        'Account/DocumentID', // Update ID document meta data
                        'Account/DocumentInformation', // Update Step3 Data
                        'Account/Email', // Update user email
                        'Account/PersonalInformation', // Update Step1 Data
                        'Account/Phone', // Update user phone number
                        'Account/Questionnaire', // update the questionnaire
                        'Account/ReferredCode', // Update referral code
                        'Account/ResidentInformation', // Update Step2 Data
                        'Account/SecuritySettings', // Update verif details of logged in user
                        'Account/User', // Update all user info
                        'Bank/UserAccounts', // Update the label of existing user bank accounnt
                        'ElectronicWallet/DepositWallets/{DigiCurrency}/{AddressName}', // Update the name of an address
                        'ElectronicWallet/UserWallets/{DigiCurrency}', // Update the name of an external address
                        'Info/ReferenceCurrency', // User's reference currency
                        'Info/ReferenceLanguage'],
                        'delete': ['APIKey/APIKey/{PublicKey}', // Remove an API key
                        'Bank/Transactions/{RequestID}', // Delete pending account withdraw of the logged in user
                        'Bank/UserAccounts/{Currency}/{Label}', // Delete an account of the logged in user
                        'ElectronicWallet/DepositWallets/{DigiCurrency}/{AddressName}', // Delete an digital currency addresses related to the logged in user.
                        'ElectronicWallet/UserWallets/{DigiCurrency}/{AddressName}', // Delete an external digital currency addresses related to the logged in user.
                        'Trade/Orders', // Cancels all existing order
                        'Trade/Orders/{OrderID}', // Cancels an existing order
                        'Trade/StopOrders', // Cancels all existing stop orders
                        'Trade/StopOrders/{ID}']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0025,
                        'taker': 0.0035
                    }
                },
                'commonCurrencies': {
                    'BCP': 'BCPT',
                    'FLI': 'FLIXX',
                    'MAN': 'MANA',
                    'SLT': 'SALT',
                    'TRA': 'TRAC',
                    'WGS': 'WINGS'
                },
                'exceptions': {
                    '1005': InsufficientFunds
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, i, market, id, baseId, quoteId, base, quote, symbol, precision, limits;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetReferenceCurrencyPairs();

                            case 2:
                                response = _context.sent;
                                markets = response['currencyPairs'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['tradingCode'];
                                    baseId = market['baseCurrency'];
                                    quoteId = market['quoteCurrency'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': market['priceDecimalPlaces']
                                    };
                                    limits = {
                                        'amount': {
                                            'min': Math.pow(10, -precision['amount']),
                                            'max': undefined
                                        },
                                        'price': {
                                            'min': Math.pow(10, -precision['amount']),
                                            'max': undefined
                                        },
                                        'cost': {
                                            'min': undefined,
                                            'max': undefined
                                        }
                                    };

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'precision': precision,
                                        'limits': limits,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currencyId, code, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetBalanceBalances();

                            case 4:
                                response = _context2.sent;
                                balances = response['balances'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currencyId = balance['currency'];
                                    code = currencyId;

                                    if (currencyId in this.currencies_by_id) code = this.currencies_by_id[currencyId]['code'];
                                    account = {
                                        'free': balance['availableBalance'],
                                        'used': this.sum(balance['pendingIncoming'], balance['pendingOutgoing'], balance['openOrder']),
                                        'total': balance['balance']
                                    };

                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetPublicMarketDepthCurrencyPair(this.extend({
                                    'CurrencyPair': market['id']
                                }, params));

                            case 5:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'volume'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privateGetTradeOrdersOrderID(this.extend({
                                    'OrderID': id
                                }, params));

                            case 4:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseOrder(response.order));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrder(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(ticker['createDateTime']) * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var baseVolume = this.safeFloat(ticker, 'volume');
            var vwap = this.safeFloat(ticker, 'vwap');
            var quoteVolume = baseVolume * vwap;
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': vwap,
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, t, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetPublicLiveTickers(params);

                            case 4:
                                response = _context5.sent;
                                tickers = response['tickers'];
                                result = {};

                                for (t = 0; t < tickers.length; t++) {
                                    ticker = tickers[t];
                                    id = ticker['currencyPair'];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetPublicLiveTickerCurrencyPair(this.extend({
                                    'CurrencyPair': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                ticker = response['ticker'];
                                return _context6.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            var orderId = undefined;
            if ('way' in trade) {
                side = trade['way'] === 'bid' ? 'buy' : 'sell';
                var orderIdField = trade['way'] + 'OrderId';
                orderId = this.safeString(trade, orderIdField);
            }
            var timestamp = parseInt(trade['transactionTime']) * 1000;
            if (typeof market === 'undefined') {
                var marketId = this.safeString(trade, 'currencyPair');
                if (typeof marketId !== 'undefined') market = this.findMarket(marketId);
            }
            var fee = undefined;
            var feeCost = this.safeFloat(trade, 'feeAmount');
            var price = trade['price'];
            var amount = trade['quantity'];
            var cost = price * amount;
            var feeCurrency = undefined;
            var symbol = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                feeCurrency = market['quote'];
            }
            if (typeof feeCost !== 'undefined') {
                fee = {
                    'cost': feeCost,
                    'currency': feeCurrency,
                    'rate': this.safeFloat(trade, 'feeRate')
                };
            }
            return {
                'info': trade,
                'id': this.safeString(trade, 'transactionId'),
                'order': orderId,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetPublicTransactionsCurrencyPair(this.extend({
                                    'CurrencyPair': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['transactions'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x14) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [parseInt(ohlcv['createDateTime']) * 1000, ohlcv['open'], ohlcv['high'], ohlcv['low'], undefined, ohlcv['volume']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response, ohlcvs;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'CurrencyPair': market['id'],
                                    'Timeframe': this.timeframes[timeframe]
                                };

                                if (typeof limit !== 'undefined') request['Count'] = limit;
                                request = this.extend(request, params);
                                _context8.next = 8;
                                return this.publicGetPublicTickerHistoryCurrencyPairTimeframe(request);

                            case 8:
                                response = _context8.sent;
                                ohlcvs = this.parseOHLCVs(response['tickers'], market, timeframe, since, limit);
                                return _context8.abrupt('return', this.sortBy(ohlcvs, 0));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOHLCV(_x22) {
                return _ref8.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'Code': this.marketId(symbol),
                                    'Way': side === 'buy' ? 'Bid' : 'Ask',
                                    'Amount': amount
                                };

                                if (type === 'limit') order['Price'] = price;

                                if (!this.twofa) {
                                    _context9.next = 10;
                                    break;
                                }

                                if (!('ValidationCode' in params)) {
                                    _context9.next = 9;
                                    break;
                                }

                                order['ValidationCode'] = params['ValidationCode'];
                                _context9.next = 10;
                                break;

                            case 9:
                                throw new AuthenticationError(this.id + ' two-factor authentication requires a missing ValidationCode parameter');

                            case 10:
                                _context9.next = 12;
                                return this.privatePostTradeOrders(this.extend(order, params));

                            case 12:
                                response = _context9.sent;
                                return _context9.abrupt('return', {
                                    'info': response,
                                    'id': response['clOrderId']
                                });

                            case 14:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x27, _x28, _x29, _x30) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privateDeleteTradeOrdersOrderID({ 'OrderID': id });

                            case 4:
                                return _context10.abrupt('return', _context10.sent);

                            case 5:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x33) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                '6': 'closed'
            };
            if (status in statuses) return statuses[status];
            return status;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['side'] === 0 ? 'buy' : 'sell';
            var type = order['type'] === 0 ? 'limit' : 'market';
            var symbol = undefined;
            if (typeof market === 'undefined') {
                var marketId = this.safeString(order, 'code');
                if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
            }
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var timestamp = parseInt(order['date']) * 1000;
            var amount = order['initialQuantity'];
            var remaining = order['remainingQuantity'];
            var filled = amount - remaining;
            var price = order['price'];
            var cost = price * filled;
            var id = order['clOrderId'];
            var status = this.parseOrderStatus(this.safeString(order, 'status'));
            var trades = undefined;
            var fee = undefined;
            if (status === 'closed') {
                var tradesFilled = undefined;
                var tradesCost = undefined;
                trades = [];
                var transactions = this.safeValue(order, 'trades');
                var feeCost = undefined;
                var feeCurrency = undefined;
                var feeRate = undefined;
                if (typeof transactions !== 'undefined') {
                    if (Array.isArray(transactions)) {
                        for (var i = 0; i < transactions.length; i++) {
                            var trade = this.parseTrade(transactions[i]);
                            if (typeof tradesFilled === 'undefined') tradesFilled = 0.0;
                            if (typeof tradesCost === 'undefined') tradesCost = 0.0;
                            tradesFilled += trade['amount'];
                            tradesCost += trade['amount'] * trade['price'];
                            if ('fee' in trade) {
                                if (typeof trade['fee']['cost'] !== 'undefined') {
                                    if (typeof feeCost === 'undefined') feeCost = 0.0;
                                    feeCost += trade['fee']['cost'];
                                }
                                feeCurrency = trade['fee']['currency'];
                                if (typeof trade['fee']['rate'] !== 'undefined') {
                                    if (typeof feeRate === 'undefined') feeRate = 0.0;
                                    feeRate += trade['fee']['rate'];
                                }
                            }
                            trades.push(trade);
                        }
                        if (typeof tradesFilled !== 'undefined' && tradesFilled > 0) price = tradesCost / tradesFilled;
                        if (typeof feeRate !== 'undefined') {
                            var numTrades = trades.length;
                            if (numTrades > 0) feeRate = feeRate / numTrades;
                        }
                        if (typeof feeCost !== 'undefined') {
                            fee = {
                                'cost': feeCost,
                                'currency': feeCurrency,
                                'rate': feeRate
                            };
                        }
                    }
                }
            }
            var result = {
                'id': id,
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'cost': cost,
                'trades': trades,
                'fee': fee,
                'info': order
            };
            return result;
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response, orders;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.privateGetTradeOrders();

                            case 4:
                                response = _context11.sent;
                                orders = this.parseOrders(response['orders'], undefined, since, limit);

                                if (!(typeof symbol !== 'undefined')) {
                                    _context11.next = 8;
                                    break;
                                }

                                return _context11.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 8:
                                return _context11.abrupt('return', orders);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var nonceString = nonce.toString();
                var contentType = method === 'GET' ? '' : 'application/json';
                var auth = method + url + contentType + nonceString;
                auth = auth.toLowerCase();
                var signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256', 'base64');
                headers = {
                    'API_PUBLIC_KEY': this.apiKey,
                    'API_REQUEST_SIGNATURE': this.decode(signature),
                    'API_REQUEST_DATE': nonceString
                };
                if (method !== 'GET') {
                    headers['Content-Type'] = contentType;
                    body = this.json(this.extend({ 'nonce': nonce }, params));
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context12.sent;

                                if (!('responseStatus' in response)) {
                                    _context12.next = 7;
                                    break;
                                }

                                if (!('message' in response['responseStatus'])) {
                                    _context12.next = 7;
                                    break;
                                }

                                if (!(response['responseStatus']['message'] === 'OK')) {
                                    _context12.next = 7;
                                    break;
                                }

                                return _context12.abrupt('return', response);

                            case 7:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function request(_x46) {
                return _ref12.apply(this, arguments);
            }

            return request;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                this.checkAddress(address);
                                _context13.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                request = {
                                    'DigiCurrency': currency['id'],
                                    'Address': address,
                                    'Amount': amount
                                };
                                _context13.next = 7;
                                return this.privatePostElectronicWalletWithdrawalsDigiCurrency(this.extend(request, params));

                            case 7:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': this.safeString(response, 'id')
                                });

                            case 9:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function withdraw(_x52, _x53, _x54) {
                return _ref13.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, request, response, result, numResults, address;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                request = {
                                    'DigiCurrency': currency['id']
                                };
                                _context14.next = 6;
                                return this.privateGetElectronicWalletDepositWalletsDigiCurrency(this.extend(request, params));

                            case 6:
                                response = _context14.sent;
                                result = response['addresses'];
                                numResults = result.length;

                                if (!(numResults < 1)) {
                                    _context14.next = 11;
                                    break;
                                }

                                throw new InvalidAddress(this.id + ' privateGetElectronicWalletDepositWalletsDigiCurrency() returned no addresses');

                            case 11:
                                address = this.safeString(result[0], 'address');

                                this.checkAddress(address);
                                return _context14.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 14:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchDepositAddress(_x57) {
                return _ref14.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, request, response, address;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                request = {
                                    'DigiCurrency': currency['id']
                                };
                                _context15.next = 6;
                                return this.privatePostElectronicWalletDepositWalletsDigiCurrency(this.extend(request, params));

                            case 6:
                                response = _context15.sent;
                                address = response['address'];

                                this.checkAddress(address);
                                return _context15.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function createDepositAddress(_x59) {
                return _ref15.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return; // fallback to default error handler
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if ('responseStatus' in response) {
                    var errorCode = this.safeString(response['responseStatus'], 'errorCode');
                    if (typeof errorCode !== 'undefined') {
                        var feedback = this.id + ' ' + body;
                        var exceptions = this.exceptions;
                        if (errorCode in exceptions) {
                            throw new exceptions[errorCode](feedback);
                        }
                        throw new ExchangeError(feedback);
                    }
                }
            }
        }
    }]);

    return gatecoin;
}(Exchange);

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidAddress = _require.InvalidAddress;

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(gateio, _Exchange);

    function gateio() {
        _classCallCheck(this, gateio);

        return _possibleConstructorReturn(this, (gateio.__proto__ || Object.getPrototypeOf(gateio)).apply(this, arguments));
    }

    _createClass(gateio, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(gateio.prototype.__proto__ || Object.getPrototypeOf(gateio.prototype), 'describe', this).call(this), {
                'id': 'gateio',
                'name': 'Gate.io',
                'countries': 'CN',
                'version': '2',
                'rateLimit': 1000,
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchTickers': true,
                    'withdraw': true,
                    'createDepositAddress': true,
                    'fetchDepositAddress': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/31784029-0313c702-b509-11e7-9ccc-bc0da6a0e435.jpg',
                    'api': {
                        'public': 'https://data.gate.io/api',
                        'private': 'https://data.gate.io/api'
                    },
                    'www': 'https://gate.io/',
                    'doc': 'https://gate.io/api2',
                    'fees': ['https://gate.io/fee', 'https://support.gate.io/hc/en-us/articles/115003577673']
                },
                'api': {
                    'public': {
                        'get': ['pairs', 'marketinfo', 'marketlist', 'tickers', 'ticker/{id}', 'orderBook/{id}', 'trade/{id}', 'tradeHistory/{id}', 'tradeHistory/{id}/{tid}']
                    },
                    'private': {
                        'post': ['balances', 'depositAddress', 'newAddress', 'depositsWithdrawals', 'buy', 'sell', 'cancelOrder', 'cancelAllOrders', 'getOrder', 'openOrders', 'tradeHistory', 'withdraw']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'maker': 0.002,
                        'taker': 0.002
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, i, market, keys, id, details, _id$split, _id$split2, base, quote, symbol, precision, amountLimits, priceLimits, costLimits, limits;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarketinfo();

                            case 2:
                                response = _context.sent;
                                markets = this.safeValue(response, 'pairs');

                                if (markets) {
                                    _context.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMarkets got an unrecognized response');

                            case 6:
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    keys = Object.keys(market);
                                    id = keys[0];
                                    details = market[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), base = _id$split2[0], quote = _id$split2[1];

                                    base = base.toUpperCase();
                                    quote = quote.toUpperCase();
                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': details['decimal_places']
                                    };
                                    amountLimits = {
                                        'min': details['min_amount'],
                                        'max': undefined
                                    };
                                    priceLimits = {
                                        'min': Math.pow(10, -details['decimal_places']),
                                        'max': undefined
                                    };
                                    costLimits = {
                                        'min': amountLimits['min'] * priceLimits['min'],
                                        'max': undefined
                                    };
                                    limits = {
                                        'amount': amountLimits,
                                        'price': priceLimits,
                                        'cost': costLimits
                                    };

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market,
                                        'maker': details['fee'] / 100,
                                        'taker': details['fee'] / 100,
                                        'precision': precision,
                                        'limits': limits
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balance, result, currencies, i, currency, code, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostBalances();

                            case 4:
                                balance = _context2.sent;
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    code = this.commonCurrencyCode(currency);
                                    account = this.account();

                                    if ('available' in balance) {
                                        if (currency in balance['available']) {
                                            account['free'] = parseFloat(balance['available'][currency]);
                                        }
                                    }
                                    if ('locked' in balance) {
                                        if (currency in balance['locked']) {
                                            account['used'] = parseFloat(balance['locked'][currency]);
                                        }
                                    }
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderBookId(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high24hr'),
                'low': this.safeFloat(ticker, 'low24hr'),
                'bid': this.safeFloat(ticker, 'highestBid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'lowestAsk'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'percentChange'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'quoteVolume'),
                'quoteVolume': this.safeFloat(ticker, 'baseVolume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var tickers, result, ids, i, id, _id$split3, _id$split4, baseId, quoteId, base, quote, symbol, ticker, market;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                tickers = _context4.sent;
                                result = {};
                                ids = Object.keys(tickers);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    _id$split3 = id.split('_'), _id$split4 = _slicedToArray(_id$split3, 2), baseId = _id$split4[0], quoteId = _id$split4[1];
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    ticker = tickers[id];
                                    market = undefined;

                                    if (symbol in this.markets) market = this.markets[symbol];
                                    if (id in this.markets_by_id) market = this.markets_by_id[id];
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTickerId(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            // exchange reports local time (UTC+8)
            var timestamp = this.parse8601(trade['date']) - 8 * 60 * 60 * 1000;
            return {
                'id': trade['tradeID'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': this.safeFloat(trade, 'rate'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTradeHistoryId(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context7.next = 4;
                                return this.loadMarkets();

                            case 4:
                                method = 'privatePost' + this.capitalize(side);
                                order = {
                                    'currencyPair': this.marketId(symbol),
                                    'rate': price,
                                    'amount': amount
                                };
                                _context7.next = 8;
                                return this[method](this.extend(order, params));

                            case 8:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['orderNumber']
                                });

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privatePostCancelOrder({ 'orderNumber': id });

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x20) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'queryDepositAddress',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(method, currency) {
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, address;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                method = 'privatePost' + method + 'Address';
                                _context9.next = 3;
                                return this[method](this.extend({
                                    'currency': currency
                                }, params));

                            case 3:
                                response = _context9.sent;
                                address = undefined;

                                if ('addr' in response) address = this.safeString(response, 'addr');

                                if (!(typeof address !== 'undefined' && address.indexOf('address') >= 0)) {
                                    _context9.next = 8;
                                    break;
                                }

                                throw new InvalidAddress(this.id + ' queryDepositAddress ' + address);

                            case 8:
                                return _context9.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'status': typeof address !== 'undefined' ? 'ok' : 'none',
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function queryDepositAddress(_x23, _x24) {
                return _ref9.apply(this, arguments);
            }

            return queryDepositAddress;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.queryDepositAddress('New', currency, params);

                            case 2:
                                return _context10.abrupt('return', _context10.sent);

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createDepositAddress(_x26) {
                return _ref10.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.queryDepositAddress('Deposit', currency, params);

                            case 2:
                                return _context11.abrupt('return', _context11.sent);

                            case 3:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchDepositAddress(_x28) {
                return _ref11.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                this.checkAddress(address);
                                _context12.next = 3;
                                return this.loadMarkets();

                            case 3:
                                _context12.next = 5;
                                return this.privatePostWithdraw(this.extend({
                                    'currency': currency.toLowerCase(),
                                    'amount': amount,
                                    'address': address // Address must exist in you AddressBook in security settings
                                }, params));

                            case 5:
                                response = _context12.sent;
                                return _context12.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 7:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function withdraw(_x30, _x31, _x32) {
                return _ref12.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var prefix = api === 'private' ? api + '/' : '';
            var url = this.urls['api'][api] + this.version + '/1/' + prefix + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var request = { 'nonce': nonce };
                body = this.urlencode(this.extend(request, query));
                var signature = this.hmac(this.encode(body), this.encode(this.secret), 'sha512');
                headers = {
                    'Key': this.apiKey,
                    'Sign': signature,
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, result, message;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;

                                if (!('result' in response)) {
                                    _context13.next = 15;
                                    break;
                                }

                                result = response['result'];
                                message = this.id + ' ' + this.json(response);

                                if (!(typeof result === 'undefined')) {
                                    _context13.next = 8;
                                    break;
                                }

                                throw new ExchangeError(message);

                            case 8:
                                if (!(typeof result === 'string')) {
                                    _context13.next = 13;
                                    break;
                                }

                                if (!(result !== 'true')) {
                                    _context13.next = 11;
                                    break;
                                }

                                throw new ExchangeError(message);

                            case 11:
                                _context13.next = 15;
                                break;

                            case 13:
                                if (result) {
                                    _context13.next = 15;
                                    break;
                                }

                                throw new ExchangeError(message);

                            case 15:
                                return _context13.abrupt('return', response);

                            case 16:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x40) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return gateio;
}(Exchange);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    InsufficientFunds = _require.InsufficientFunds,
    ExchangeError = _require.ExchangeError,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError,
    NotSupported = _require.NotSupported,
    OrderNotFound = _require.OrderNotFound;

// ----------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(gdax, _Exchange);

    function gdax() {
        _classCallCheck(this, gdax);

        return _possibleConstructorReturn(this, (gdax.__proto__ || Object.getPrototypeOf(gdax)).apply(this, arguments));
    }

    _createClass(gdax, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(gdax.prototype.__proto__ || Object.getPrototypeOf(gdax.prototype), 'describe', this).call(this), {
                'id': 'gdax',
                'name': 'GDAX',
                'countries': 'US',
                'rateLimit': 1000,
                'userAgent': this.userAgents['chrome'],
                'has': {
                    'CORS': true,
                    'fetchOHLCV': true,
                    'deposit': true,
                    'withdraw': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true
                },
                'timeframes': {
                    '1m': 60,
                    '5m': 300,
                    '15m': 900,
                    '1h': 3600,
                    '6h': 21600,
                    '1d': 86400
                },
                'urls': {
                    'test': 'https://api-public.sandbox.gdax.com',
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766527-b1be41c6-5edb-11e7-95f6-5b496c469e2c.jpg',
                    'api': 'https://api.gdax.com',
                    'www': 'https://www.gdax.com',
                    'doc': 'https://docs.gdax.com',
                    'fees': ['https://www.gdax.com/fees', 'https://support.gdax.com/customer/en/portal/topics/939402-depositing-and-withdrawing-funds/articles']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'password': true
                },
                'api': {
                    'public': {
                        'get': ['currencies', 'products', 'products/{id}/book', 'products/{id}/candles', 'products/{id}/stats', 'products/{id}/ticker', 'products/{id}/trades', 'time']
                    },
                    'private': {
                        'get': ['accounts', 'accounts/{id}', 'accounts/{id}/holds', 'accounts/{id}/ledger', 'accounts/{id}/transfers', 'coinbase-accounts', 'fills', 'funding', 'orders', 'orders/{id}', 'payment-methods', 'position', 'reports/{id}', 'users/self/trailing-volume'],
                        'post': ['deposits/coinbase-account', 'deposits/payment-method', 'coinbase-accounts/{id}/addresses', 'funding/repay', 'orders', 'position/close', 'profiles/margin-transfer', 'reports', 'withdrawals/coinbase', 'withdrawals/crypto', 'withdrawals/payment-method'],
                        'delete': ['orders', 'orders/{id}']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': true, // complicated tier system per coin
                        'percentage': true,
                        'maker': 0.0,
                        'taker': 0.3 / 100 // tiered fee starts at 0.3%
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BCH': 0,
                            'BTC': 0,
                            'LTC': 0,
                            'ETH': 0,
                            'EUR': 0.15,
                            'USD': 25
                        },
                        'deposit': {
                            'BCH': 0,
                            'BTC': 0,
                            'LTC': 0,
                            'ETH': 0,
                            'EUR': 0.15,
                            'USD': 10
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol, priceLimits, precision, taker, active;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetProducts();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['id'];
                                    base = market['base_currency'];
                                    quote = market['quote_currency'];
                                    symbol = base + '/' + quote;
                                    priceLimits = {
                                        'min': this.safeFloat(market, 'quote_increment'),
                                        'max': undefined
                                    };
                                    precision = {
                                        'amount': 8,
                                        'price': this.precisionFromString(this.safeString(market, 'quote_increment'))
                                    };
                                    taker = this.fees['trading']['taker']; // does not seem right

                                    if (base === 'ETH' || base === 'LTC') {
                                        taker = 0.003;
                                    }
                                    active = market['status'] === 'online';

                                    result.push(this.extend(this.fees['trading'], {
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': this.safeFloat(market, 'base_min_size'),
                                                'max': this.safeFloat(market, 'base_max_size')
                                            },
                                            'price': priceLimits,
                                            'cost': {
                                                'min': this.safeFloat(market, 'min_market_funds'),
                                                'max': this.safeFloat(market, 'max_market_funds')
                                            }
                                        },
                                        'taker': taker,
                                        'active': active,
                                        'info': market
                                    }));
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetAccounts();

                            case 4:
                                balances = _context2.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    account = {
                                        'free': this.safeFloat(balance, 'available'),
                                        'used': this.safeFloat(balance, 'hold'),
                                        'total': this.safeFloat(balance, 'balance')
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetProductsIdBook(this.extend({
                                    'id': this.marketId(symbol),
                                    'level': 2 // 1 best bidask, 2 aggregated, 3 full
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, request, ticker, timestamp, bid, ask, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = this.extend({
                                    'id': market['id']
                                }, params);
                                _context4.next = 6;
                                return this.publicGetProductsIdTicker(request);

                            case 6:
                                ticker = _context4.sent;
                                timestamp = this.parse8601(ticker['time']);
                                bid = undefined;
                                ask = undefined;

                                if ('bid' in ticker) bid = this.safeFloat(ticker, 'bid');
                                if ('ask' in ticker) ask = this.safeFloat(ticker, 'ask');
                                last = this.safeFloat(ticker, 'price');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': bid,
                                    'bidVolume': undefined,
                                    'ask': ask,
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'volume'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            if ('time' in trade) {
                timestamp = this.parse8601(trade['time']);
            } else if ('created_at' in trade) {
                timestamp = this.parse8601(trade['created_at']);
            }
            var iso8601 = undefined;
            if (typeof timestamp !== 'undefined') iso8601 = this.iso8601(timestamp);
            var symbol = undefined;
            if (!market) {
                if ('product_id' in trade) {
                    var marketId = trade['product_id'];
                    if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                }
            }
            if (market) symbol = market['symbol'];
            var feeRate = undefined;
            var feeCurrency = undefined;
            if (market) {
                feeCurrency = market['quote'];
                if ('liquidity' in trade) {
                    var rateType = trade['liquidity'] === 'T' ? 'taker' : 'maker';
                    feeRate = market[rateType];
                }
            }
            var feeCost = this.safeFloat(trade, 'fill_fees');
            if (typeof feeCost === 'undefined') feeCost = this.safeFloat(trade, 'fee');
            var fee = {
                'cost': feeCost,
                'currency': feeCurrency,
                'rate': feeRate
            };
            var type = undefined;
            var id = this.safeString(trade, 'trade_id');
            var side = trade['side'] === 'buy' ? 'sell' : 'buy';
            var orderId = this.safeString(trade, 'order_id');
            // GDAX returns inverted side to fetchMyTrades vs fetchTrades
            if (typeof orderId !== 'undefined') side = trade['side'] === 'buy' ? 'buy' : 'sell';
            return {
                'id': id,
                'order': orderId,
                'info': trade,
                'timestamp': timestamp,
                'datetime': iso8601,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'size'),
                'fee': fee
            };
        }
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['product_id'] = market['id'];
                                }
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context5.next = 8;
                                return this.privateGetFills(this.extend(request, params));

                            case 8:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchMyTrades() {
                return _ref5.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetProductsIdTrades(this.extend({
                                    'id': market['id'] // fixes issue #2
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x12) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0] * 1000, ohlcv[3], ohlcv[2], ohlcv[1], ohlcv[4], ohlcv[5]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, granularity, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                granularity = this.timeframes[timeframe];
                                request = {
                                    'id': market['id'],
                                    'granularity': granularity
                                };

                                if (typeof since !== 'undefined') {
                                    request['start'] = this.ymdhms(since);
                                    if (typeof limit === 'undefined') {
                                        // https://docs.gdax.com/#get-historic-rates
                                        limit = 300; // max = 300
                                    }
                                    request['end'] = this.ymdhms(this.sum(limit * granularity * 1000, since));
                                }
                                _context7.next = 8;
                                return this.publicGetProductsIdCandles(this.extend(request, params));

                            case 8:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x20) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchTime',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.publicGetTime();

                            case 2:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parse8601(response['iso']));

                            case 4:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTime() {
                return _ref8.apply(this, arguments);
            }

            return fetchTime;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'pending': 'open',
                'active': 'open',
                'open': 'open',
                'done': 'closed',
                'canceled': 'canceled'
            };
            return this.safeString(statuses, status, status);
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(order['created_at']);
            var symbol = undefined;
            if (!market) {
                if (order['product_id'] in this.markets_by_id) market = this.markets_by_id[order['product_id']];
            }
            var status = this.parseOrderStatus(order['status']);
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'size');
            if (typeof amount === 'undefined') amount = this.safeFloat(order, 'funds');
            if (typeof amount === 'undefined') amount = this.safeFloat(order, 'specified_funds');
            var filled = this.safeFloat(order, 'filled_size');
            var remaining = undefined;
            if (typeof amount !== 'undefined') if (typeof filled !== 'undefined') remaining = amount - filled;
            var cost = this.safeFloat(order, 'executed_value');
            var fee = {
                'cost': this.safeFloat(order, 'fill_fees'),
                'currency': undefined,
                'rate': undefined
            };
            if (market) symbol = market['symbol'];
            return {
                'id': order['id'],
                'info': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['type'],
                'side': order['side'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': fee
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privateGetOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrder(_x26) {
                return _ref9.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'status': 'all'
                                };
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['product_id'] = market['id'];
                                }
                                _context10.next = 7;
                                return this.privateGetOrders(this.extend(request, params));

                            case 7:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['product_id'] = market['id'];
                                }
                                _context11.next = 7;
                                return this.privateGetOrders(this.extend(request, params));

                            case 7:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'status': 'done'
                                };
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['product_id'] = market['id'];
                                }
                                _context12.next = 7;
                                return this.privateGetOrders(this.extend(request, params));

                            case 7:
                                response = _context12.sent;
                                return _context12.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchClosedOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                // let oid = this.nonce ().toString ();
                                order = {
                                    'product_id': this.marketId(symbol),
                                    'side': side,
                                    'size': amount,
                                    'type': type
                                };

                                if (type === 'limit') order['price'] = price;
                                _context13.next = 6;
                                return this.privatePostOrders(this.extend(order, params));

                            case 6:
                                response = _context13.sent;
                                return _context13.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 8:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function createOrder(_x41, _x42, _x43, _x44) {
                return _ref13.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context14.next = 4;
                                return this.privateDeleteOrdersId({ 'id': id });

                            case 4:
                                return _context14.abrupt('return', _context14.sent);

                            case 5:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function cancelOrder(_x47) {
                return _ref14.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(currency, fee) {
            var cost = parseFloat(fee);
            return cost.toFixed(this.currencies[currency]['precision']);
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var rate = market[takerOrMaker];
            var cost = amount * price;
            var currency = market['quote'];
            return {
                'type': takerOrMaker,
                'currency': currency,
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(currency, rate * cost))
            };
        }
    }, {
        key: 'getPaymentMethods',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.privateGetPaymentMethods();

                            case 2:
                                response = _context15.sent;
                                return _context15.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function getPaymentMethods() {
                return _ref15.apply(this, arguments);
            }

            return getPaymentMethods;
        }()
    }, {
        key: 'deposit',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(currency, amount, address) {
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, method, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'currency': currency,
                                    'amount': amount
                                };
                                method = 'privatePostDeposits';

                                if (!('payment_method_id' in params)) {
                                    _context16.next = 8;
                                    break;
                                }

                                // deposit from a payment_method, like a bank account
                                method += 'PaymentMethod';
                                _context16.next = 13;
                                break;

                            case 8:
                                if (!('coinbase_account_id' in params)) {
                                    _context16.next = 12;
                                    break;
                                }

                                // deposit into GDAX account from a Coinbase account
                                method += 'CoinbaseAccount';
                                _context16.next = 13;
                                break;

                            case 12:
                                throw new NotSupported(this.id + ' deposit() requires one of `coinbase_account_id` or `payment_method_id` extra params');

                            case 13:
                                _context16.next = 15;
                                return this[method](this.extend(request, params));

                            case 15:
                                response = _context16.sent;

                                if (response) {
                                    _context16.next = 18;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' deposit() error: ' + this.json(response));

                            case 18:
                                return _context16.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 19:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function deposit(_x52, _x53, _x54) {
                return _ref16.apply(this, arguments);
            }

            return deposit;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, method, response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                this.checkAddress(address);
                                _context17.next = 3;
                                return this.loadMarkets();

                            case 3:
                                request = {
                                    'currency': currency,
                                    'amount': amount
                                };
                                method = 'privatePostWithdrawals';

                                if ('payment_method_id' in params) {
                                    method += 'PaymentMethod';
                                } else if ('coinbase_account_id' in params) {
                                    method += 'CoinbaseAccount';
                                } else {
                                    method += 'Crypto';
                                    request['crypto_address'] = address;
                                }
                                _context17.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                response = _context17.sent;

                                if (response) {
                                    _context17.next = 11;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' withdraw() error: ' + this.json(response));

                            case 11:
                                return _context17.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 12:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function withdraw(_x56, _x57, _x58) {
                return _ref17.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (method === 'GET') {
                if (Object.keys(query).length) request += '?' + this.urlencode(query);
            }
            var url = this.urls['api'] + request;
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var payload = '';
                if (method !== 'GET') {
                    if (Object.keys(query).length) {
                        body = this.json(query);
                        payload = body;
                    }
                }
                // let payload = (body) ? body : '';
                var what = nonce + method + request + payload;
                var secret = this.base64ToBinary(this.secret);
                var signature = this.hmac(this.encode(what), secret, 'sha256', 'base64');
                headers = {
                    'CB-ACCESS-KEY': this.apiKey,
                    'CB-ACCESS-SIGN': this.decode(signature),
                    'CB-ACCESS-TIMESTAMP': nonce,
                    'CB-ACCESS-PASSPHRASE': this.password,
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 400 || code === 404) {
                if (body[0] === '{') {
                    var response = JSON.parse(body);
                    var message = response['message'];
                    var error = this.id + ' ' + message;
                    if (message.indexOf('price too small') >= 0) {
                        throw new InvalidOrder(error);
                    } else if (message.indexOf('price too precise') >= 0) {
                        throw new InvalidOrder(error);
                    } else if (message === 'Insufficient funds') {
                        throw new InsufficientFunds(error);
                    } else if (message === 'NotFound') {
                        throw new OrderNotFound(error);
                    } else if (message === 'Invalid API Key') {
                        throw new AuthenticationError(error);
                    }
                    throw new ExchangeError(this.id + ' ' + message);
                }
                throw new ExchangeError(this.id + ' ' + body);
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context18.sent;

                                if (!('message' in response)) {
                                    _context18.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context18.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function request(_x66) {
                return _ref18.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return gdax;
}(Exchange);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(gemini, _Exchange);

    function gemini() {
        _classCallCheck(this, gemini);

        return _possibleConstructorReturn(this, (gemini.__proto__ || Object.getPrototypeOf(gemini)).apply(this, arguments));
    }

    _createClass(gemini, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(gemini.prototype.__proto__ || Object.getPrototypeOf(gemini.prototype), 'describe', this).call(this), {
                'id': 'gemini',
                'name': 'Gemini',
                'countries': 'US',
                'rateLimit': 1500, // 200 for private API
                'version': 'v1',
                'has': {
                    'fetchDepositAddress': false,
                    'createDepositAddress': true,
                    'CORS': false,
                    'fetchBidsAsks': false,
                    'fetchTickers': false,
                    'fetchMyTrades': true,
                    'fetchOrder': false,
                    'fetchOrders': false,
                    'fetchOpenOrders': false,
                    'fetchClosedOrders': false,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27816857-ce7be644-6096-11e7-82d6-3c257263229c.jpg',
                    'api': 'https://api.gemini.com',
                    'www': 'https://gemini.com',
                    'doc': ['https://docs.gemini.com/rest-api', 'https://docs.sandbox.gemini.com'],
                    'test': 'https://api.sandbox.gemini.com',
                    'fees': ['https://gemini.com/fee-schedule/', 'https://gemini.com/transfer-fees/']
                },
                'api': {
                    'public': {
                        'get': ['symbols', 'pubticker/{symbol}', 'book/{symbol}', 'trades/{symbol}', 'auction/{symbol}', 'auction/{symbol}/history']
                    },
                    'private': {
                        'post': ['order/new', 'order/cancel', 'order/cancel/session', 'order/cancel/all', 'order/status', 'orders', 'mytrades', 'tradevolume', 'balances', 'deposit/{currency}/newAddress', 'withdraw/{currency}', 'heartbeat']
                    }
                },
                'fees': {
                    'trading': {
                        'taker': 0.0025,
                        'maker': 0.0025
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, id, market, uppercase, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetSymbols();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    id = markets[p];
                                    market = id;
                                    uppercase = market.toUpperCase();
                                    base = uppercase.slice(0, 3);
                                    quote = uppercase.slice(3, 6);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetBookSymbol(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker, timestamp, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetPubtickerSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context3.sent;
                                timestamp = ticker['volume']['timestamp'];
                                baseVolume = market['base'];
                                quoteVolume = market['quote'];
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': undefined,
                                    'low': undefined,
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': parseFloat(ticker['volume'][baseVolume]),
                                    'quoteVolume': parseFloat(ticker['volume'][quoteVolume]),
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['timestampms'];
            var order = undefined;
            if ('order_id' in trade) order = trade['order_id'].toString();
            var fee = this.safeFloat(trade, 'fee_amount');
            if (typeof fee !== 'undefined') {
                var currency = this.safeString(trade, 'fee_currency');
                if (typeof currency !== 'undefined') {
                    if (currency in this.currencies_by_id) currency = this.currencies_by_id[currency]['code'];
                    currency = this.commonCurrencyCode(currency);
                }
                fee = {
                    'cost': this.safeFloat(trade, 'fee_amount'),
                    'currency': currency
                };
            }
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            return {
                'id': trade['tid'].toString(),
                'order': order,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': price,
                'cost': price * amount,
                'amount': amount,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetTradesSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privatePostBalances();

                            case 4:
                                balances = _context5.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': 0.0,
                                        'total': parseFloat(balance['amount'])
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var nonce, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(type === 'market')) {
                                    _context6.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 4:
                                nonce = this.nonce();
                                order = {
                                    'client_order_id': nonce.toString(),
                                    'symbol': this.marketId(symbol),
                                    'amount': amount.toString(),
                                    'price': price.toString(),
                                    'side': side,
                                    'type': 'exchange limit' // gemini allows limit orders only
                                };
                                _context6.next = 8;
                                return this.privatePostOrderNew(this.extend(order, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['order_id']
                                });

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostOrderCancel({ 'order_id': id });

                            case 4:
                                return _context7.abrupt('return', _context7.sent);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x17) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMyTrades requires a symbol argument');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context8.next = 9;
                                return this.privatePostMytrades(this.extend(request, params));

                            case 9:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchMyTrades() {
                return _ref8.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                this.checkAddress(address);
                                _context9.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                _context9.next = 6;
                                return this.privatePostWithdrawCurrency(this.extend({
                                    'currency': currency['id'],
                                    'amount': amount,
                                    'address': address
                                }, params));

                            case 6:
                                response = _context9.sent;
                                return _context9.abrupt('return', {
                                    'info': response,
                                    'id': this.safeString(response, 'txHash')
                                });

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function withdraw(_x24, _x25, _x26) {
                return _ref9.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var request = this.extend({
                    'request': url,
                    'nonce': nonce
                }, query);
                var payload = this.json(request);
                payload = this.stringToBase64(this.encode(payload));
                var signature = this.hmac(payload, this.encode(this.secret), 'sha384');
                headers = {
                    'Content-Type': 'text/plain',
                    'X-GEMINI-APIKEY': this.apiKey,
                    'X-GEMINI-PAYLOAD': this.decode(payload),
                    'X-GEMINI-SIGNATURE': signature
                };
            }
            url = this.urls['api'] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('result' in response)) {
                                    _context10.next = 6;
                                    break;
                                }

                                if (!(response['result'] === 'error')) {
                                    _context10.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context10.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x34) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context11.next = 5;
                                return this.privatePostDepositCurrencyNewAddress(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context11.sent;
                                address = this.safeString(response, 'address');

                                this.checkAddress(address);
                                return _context11.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function createDepositAddress(_x40) {
                return _ref11.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }]);

    return gemini;
}(Exchange);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _1btcxe = __webpack_require__(30);

// ---------------------------------------------------------------------------

module.exports = function (_btcxe) {
    _inherits(getbtc, _btcxe);

    function getbtc() {
        _classCallCheck(this, getbtc);

        return _possibleConstructorReturn(this, (getbtc.__proto__ || Object.getPrototypeOf(getbtc)).apply(this, arguments));
    }

    _createClass(getbtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(getbtc.prototype.__proto__ || Object.getPrototypeOf(getbtc.prototype), 'describe', this).call(this), {
                'id': 'getbtc',
                'name': 'GetBTC',
                'countries': ['VC', 'RU'], // Saint Vincent and the Grenadines, Russia, CIS
                'rateLimit': 1000,
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/33801902-03c43462-dd7b-11e7-992e-077e4cd015b9.jpg',
                    'api': 'https://getbtc.org/api',
                    'www': 'https://getbtc.org',
                    'doc': 'https://getbtc.org/api-docs.php'
                },
                'has': {
                    'fetchTrades': false,
                    'fetchOHLCV': false
                },
                'fees': {
                    'trading': {
                        'taker': 0.20 / 100,
                        'maker': 0.20 / 100
                    }
                },
                'markets': {
                    'BTC/USD': { 'lot': 1e-08, 'symbol': 'BTC/USD', 'quote': 'USD', 'base': 'BTC', 'precision': { 'amount': 8, 'price': 8 }, 'id': 'USD', 'limits': { 'amount': { 'max': undefined, 'min': 1e-08 }, 'price': { 'max': 'undefined', 'min': 1e-08 } } },
                    'BTC/EUR': { 'lot': 1e-08, 'symbol': 'BTC/EUR', 'quote': 'EUR', 'base': 'BTC', 'precision': { 'amount': 8, 'price': 8 }, 'id': 'EUR', 'limits': { 'amount': { 'max': undefined, 'min': 1e-08 }, 'price': { 'max': 'undefined', 'min': 1e-08 } } },
                    'BTC/RUB': { 'lot': 1e-08, 'symbol': 'BTC/RUB', 'quote': 'RUB', 'base': 'BTC', 'precision': { 'amount': 8, 'price': 8 }, 'id': 'RUB', 'limits': { 'amount': { 'max': undefined, 'min': 1e-08 }, 'price': { 'max': 'undefined', 'min': 1e-08 } } }
                }
            });
        }
    }]);

    return getbtc;
}(_1btcxe);

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var huobipro = __webpack_require__(11);

// ---------------------------------------------------------------------------

module.exports = function (_huobipro) {
    _inherits(hadax, _huobipro);

    function hadax() {
        _classCallCheck(this, hadax);

        return _possibleConstructorReturn(this, (hadax.__proto__ || Object.getPrototypeOf(hadax)).apply(this, arguments));
    }

    _createClass(hadax, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(hadax.prototype.__proto__ || Object.getPrototypeOf(hadax.prototype), 'describe', this).call(this), {
                'id': 'hadax',
                'name': 'HADAX',
                'countries': 'CN',
                'hostname': 'api.hadax.com',
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38059952-4756c49e-32f1-11e8-90b9-45c1eccba9cd.jpg',
                    'api': 'https://api.hadax.com',
                    'www': 'https://www.hadax.com',
                    'doc': 'https://github.com/huobiapi/API_Docs/wiki'
                },
                'has': {
                    'fetchCurrencies': false
                },
                'api': {
                    'public': {
                        'get': ['hadax/common/symbols', // 查询系统支持的所有交易对
                        'hadax/common/currencys', // 查询系统支持的所有币种
                        'common/timestamp', // 查询系统当前时间
                        'hadax/settings/currencys']
                    }
                },
                'options': {
                    'fetchMarketsMethod': 'publicGetHadaxCommonSymbols'
                }
            });
        }
    }]);

    return hadax;
}(huobipro);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hitbtc = __webpack_require__(35);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    OrderNotFound = _require.OrderNotFound,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder;

// ---------------------------------------------------------------------------

module.exports = function (_hitbtc) {
    _inherits(hitbtc2, _hitbtc);

    function hitbtc2() {
        _classCallCheck(this, hitbtc2);

        return _possibleConstructorReturn(this, (hitbtc2.__proto__ || Object.getPrototypeOf(hitbtc2)).apply(this, arguments));
    }

    _createClass(hitbtc2, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(hitbtc2.prototype.__proto__ || Object.getPrototypeOf(hitbtc2.prototype), 'describe', this).call(this), {
                'id': 'hitbtc2',
                'name': 'HitBTC v2',
                'countries': 'HK',
                'rateLimit': 1500,
                'version': '2',
                'has': {
                    'createDepositAddress': true,
                    'fetchDepositAddress': true,
                    'CORS': true,
                    'editOrder': true,
                    'fetchCurrencies': true,
                    'fetchOHLCV': true,
                    'fetchTickers': true,
                    'fetchOrder': true,
                    'fetchOrders': false,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': 'M1',
                    '3m': 'M3',
                    '5m': 'M5',
                    '15m': 'M15',
                    '30m': 'M30', // default
                    '1h': 'H1',
                    '4h': 'H4',
                    '1d': 'D1',
                    '1w': 'D7',
                    '1M': '1M'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766555-8eaec20e-5edc-11e7-9c5b-6dc69fc42f5e.jpg',
                    'api': 'https://api.hitbtc.com',
                    'www': 'https://hitbtc.com/?ref_id=5a5d39a65d466',
                    'doc': 'https://api.hitbtc.com',
                    'fees': ['https://hitbtc.com/fees-and-limits', 'https://support.hitbtc.com/hc/en-us/articles/115005148605-Fees-and-limits']
                },
                'api': {
                    'public': {
                        'get': ['symbol', // Available Currency Symbols
                        'symbol/{symbol}', // Get symbol info
                        'currency', // Available Currencies
                        'currency/{currency}', // Get currency info
                        'ticker', // Ticker list for all symbols
                        'ticker/{symbol}', // Ticker for symbol
                        'trades/{symbol}', // Trades
                        'orderbook/{symbol}', // Orderbook
                        'candles/{symbol}']
                    },
                    'private': {
                        'get': ['order', // List your current open orders
                        'order/{clientOrderId}', // Get a single order by clientOrderId
                        'trading/balance', // Get trading balance
                        'trading/fee/{symbol}', // Get trading fee rate
                        'history/trades', // Get historical trades
                        'history/order', // Get historical orders
                        'history/order/{id}/trades', // Get historical trades by specified order
                        'account/balance', // Get main acccount balance
                        'account/transactions', // Get account transactions
                        'account/transactions/{id}', // Get account transaction by id
                        'account/crypto/address/{currency}'],
                        'post': ['order', // Create new order
                        'account/crypto/withdraw', // Withdraw crypro
                        'account/crypto/address/{currency}', // Create new deposit crypro address
                        'account/transfer'],
                        'put': ['order/{clientOrderId}', // Create new order
                        'account/crypto/withdraw/{id}'],
                        'delete': ['order', // Cancel all open orders
                        'order/{clientOrderId}', // Cancel order
                        'account/crypto/withdraw/{id}'],
                        'patch': ['order/{clientOrderId}']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': -0.01 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'BCC': 0.0018,
                            'ETH': 0.00958,
                            'BCH': 0.0018,
                            'USDT': 100,
                            'DASH': 0.03,
                            'BTG': 0.0005,
                            'XRP': 0.509,
                            'LTC': 0.003,
                            'ZEC': 0.0001,
                            'XMR': 0.09,
                            '1ST': 0.84,
                            'ADX': 5.7,
                            'AE': 6.7,
                            'AEON': 0.01006,
                            'AIR': 565,
                            'AMM': 14,
                            'AMP': 342,
                            'ANT': 6.7,
                            'ARDR': 1,
                            'ARN': 18.5,
                            'ART': 26,
                            'ATB': 0.0004,
                            'ATL': 27,
                            'ATM': 504,
                            'ATS': 860,
                            'AVT': 1.9,
                            'BAS': 113,
                            'BCN': 0.1,
                            'BET': 124,
                            'BKB': 46,
                            'BMC': 32,
                            'BMT': 100,
                            'BNT': 2.57,
                            'BQX': 4.7,
                            'BTCA': 351.21,
                            'BTM': 40,
                            'BTX': 0.04,
                            'BUS': 0.004,
                            'CAPP': 97,
                            'CCT': 6,
                            'CDT': 100,
                            'CDX': 30,
                            'CFI': 61,
                            'CL': 13.85,
                            'CLD': 0.88,
                            'CND': 574,
                            'CNX': 0.04,
                            'COSS': 65,
                            'CPAY': 5.487,
                            'CSNO': 16,
                            'CTR': 15,
                            'CTX': 146,
                            'CVC': 8.46,
                            'DATA': 12.949,
                            'DBIX': 0.0168,
                            'DCN': 1280,
                            'DCT': 0.02,
                            'DDF': 342,
                            'DENT': 1000,
                            'DGB': 0.4,
                            'DGD': 0.01,
                            'DICE': 0.32,
                            'DLT': 0.26,
                            'DNT': 0.21,
                            'DOGE': 2,
                            'DOV': 34,
                            'DRPU': 24,
                            'DRT': 240,
                            'DSH': 0.017,
                            'EBET': 84,
                            'EBTC': 20,
                            'EBTCOLD': 6.6,
                            'ECAT': 14,
                            'EDG': 2,
                            'EDO': 2.9,
                            'EKO': 1136.36,
                            'ELE': 0.00172,
                            'ELM': 0.004,
                            'EMC': 0.03,
                            'MGO': 14,
                            'ENJ': 163,
                            'EOS': 1.5,
                            'ERO': 34,
                            'ETBS': 15,
                            'ETC': 0.002,
                            'ETP': 0.004,
                            'EVX': 5.4,
                            'EXN': 456,
                            'FCN': 0.000005,
                            'FRD': 65,
                            'FUEL': 123.00105,
                            'FUN': 202.9598309,
                            'FYN': 1.849,
                            'FYP': 66.13,
                            'GAME': 0.004,
                            'GNO': 0.0034,
                            'GUP': 4,
                            'GVT': 1.2,
                            'HSR': 0.04,
                            'HAC': 144,
                            'HDG': 7,
                            'HGT': 1082,
                            'HPC': 0.4,
                            'HVN': 120,
                            'ICN': 0.55,
                            'ICO': 34,
                            'ICOS': 0.35,
                            'IND': 76,
                            'INDI': 790,
                            'ITS': 15.0012,
                            'IXT': 11,
                            'KBR': 143,
                            'KICK': 112,
                            'KMD': 4,
                            'LA': 41,
                            'LEND': 388,
                            'LAT': 1.44,
                            'LIFE': 13000,
                            'LRC': 27,
                            'LSK': 0.3,
                            'LOC': 11.076,
                            'LUN': 0.34,
                            'MAID': 5,
                            'MANA': 143,
                            'MCAP': 5.44,
                            'MIPS': 43,
                            'MNE': 1.33,
                            'MSP': 121,
                            'MCO': 0.357,
                            'MTH': 92,
                            'MYB': 3.9,
                            'NDC': 165,
                            'NEBL': 0.04,
                            'NET': 3.96,
                            'NTO': 998,
                            'NGC': 2.368,
                            'NXC': 13.39,
                            'NXT': 3,
                            'OAX': 15,
                            'ODN': 0.004,
                            'OMG': 2,
                            'OPT': 335,
                            'ORME': 2.8,
                            'OTN': 0.57,
                            'PAY': 3.1,
                            'PIX': 96,
                            'PLBT': 0.33,
                            'PLR': 114,
                            'PLU': 0.87,
                            'POE': 784,
                            'POLL': 3.5,
                            'PPT': 2,
                            'PRE': 32,
                            'PRG': 39,
                            'PRO': 41,
                            'PRS': 60,
                            'PTOY': 0.5,
                            'QAU': 63,
                            'QCN': 0.03,
                            'QTUM': 0.04,
                            'QVT': 64,
                            'REP': 0.02,
                            'RKC': 15,
                            'RLC': 1.21,
                            'RVT': 14,
                            'SC': 30,
                            'SAN': 2.24,
                            'SBD': 0.03,
                            'SCL': 2.6,
                            'SISA': 1640,
                            'SKIN': 407,
                            'SWFTC': 352.94,
                            'SMART': 0.4,
                            'SMS': 0.0375,
                            'SNC': 36,
                            'SNGLS': 4,
                            'SNM': 48,
                            'SNT': 233,
                            'STAR': 0.144,
                            'STORM': 153.19,
                            'STEEM': 0.01,
                            'STRAT': 0.01,
                            'SPF': 14.4,
                            'STU': 14,
                            'STX': 11,
                            'SUB': 17,
                            'SUR': 3,
                            'SWT': 0.51,
                            'TAAS': 0.91,
                            'TBT': 2.37,
                            'TFL': 15,
                            'TIME': 0.03,
                            'TIX': 7.1,
                            'TKN': 1,
                            'TGT': 173,
                            'TKR': 84,
                            'TNT': 90,
                            'TRST': 1.6,
                            'TRX': 270,
                            'UET': 480,
                            'UGT': 15,
                            'UTT': 3,
                            'VEN': 14,
                            'VERI': 0.037,
                            'VIB': 50,
                            'VIBE': 145,
                            'VOISE': 618,
                            'WEALTH': 0.0168,
                            'WINGS': 2.4,
                            'WTC': 0.75,
                            'WRC': 48,
                            'XAUR': 3.23,
                            'XDN': 0.01,
                            'XEM': 15,
                            'XUC': 0.9,
                            'YOYOW': 140,
                            'ZAP': 24,
                            'ZRX': 23,
                            'ZSC': 191
                        },
                        'deposit': {
                            'BTC': 0.0006,
                            'ETH': 0.003,
                            'BCH': 0,
                            'USDT': 0,
                            'BTG': 0,
                            'LTC': 0,
                            'ZEC': 0,
                            'XMR': 0,
                            '1ST': 0,
                            'ADX': 0,
                            'AE': 0,
                            'AEON': 0,
                            'AIR': 0,
                            'AMP': 0,
                            'ANT': 0,
                            'ARDR': 0,
                            'ARN': 0,
                            'ART': 0,
                            'ATB': 0,
                            'ATL': 0,
                            'ATM': 0,
                            'ATS': 0,
                            'AVT': 0,
                            'BAS': 0,
                            'BCN': 0,
                            'BET': 0,
                            'BKB': 0,
                            'BMC': 0,
                            'BMT': 0,
                            'BNT': 0,
                            'BQX': 0,
                            'BTM': 0,
                            'BTX': 0,
                            'BUS': 0,
                            'CCT': 0,
                            'CDT': 0,
                            'CDX': 0,
                            'CFI': 0,
                            'CLD': 0,
                            'CND': 0,
                            'CNX': 0,
                            'COSS': 0,
                            'CSNO': 0,
                            'CTR': 0,
                            'CTX': 0,
                            'CVC': 0,
                            'DBIX': 0,
                            'DCN': 0,
                            'DCT': 0,
                            'DDF': 0,
                            'DENT': 0,
                            'DGB': 0,
                            'DGD': 0,
                            'DICE': 0,
                            'DLT': 0,
                            'DNT': 0,
                            'DOGE': 0,
                            'DOV': 0,
                            'DRPU': 0,
                            'DRT': 0,
                            'DSH': 0,
                            'EBET': 0,
                            'EBTC': 0,
                            'EBTCOLD': 0,
                            'ECAT': 0,
                            'EDG': 0,
                            'EDO': 0,
                            'ELE': 0,
                            'ELM': 0,
                            'EMC': 0,
                            'EMGO': 0,
                            'ENJ': 0,
                            'EOS': 0,
                            'ERO': 0,
                            'ETBS': 0,
                            'ETC': 0,
                            'ETP': 0,
                            'EVX': 0,
                            'EXN': 0,
                            'FRD': 0,
                            'FUEL': 0,
                            'FUN': 0,
                            'FYN': 0,
                            'FYP': 0,
                            'GNO': 0,
                            'GUP': 0,
                            'GVT': 0,
                            'HAC': 0,
                            'HDG': 0,
                            'HGT': 0,
                            'HPC': 0,
                            'HVN': 0,
                            'ICN': 0,
                            'ICO': 0,
                            'ICOS': 0,
                            'IND': 0,
                            'INDI': 0,
                            'ITS': 0,
                            'IXT': 0,
                            'KBR': 0,
                            'KICK': 0,
                            'LA': 0,
                            'LAT': 0,
                            'LIFE': 0,
                            'LRC': 0,
                            'LSK': 0,
                            'LUN': 0,
                            'MAID': 0,
                            'MANA': 0,
                            'MCAP': 0,
                            'MIPS': 0,
                            'MNE': 0,
                            'MSP': 0,
                            'MTH': 0,
                            'MYB': 0,
                            'NDC': 0,
                            'NEBL': 0,
                            'NET': 0,
                            'NTO': 0,
                            'NXC': 0,
                            'NXT': 0,
                            'OAX': 0,
                            'ODN': 0,
                            'OMG': 0,
                            'OPT': 0,
                            'ORME': 0,
                            'OTN': 0,
                            'PAY': 0,
                            'PIX': 0,
                            'PLBT': 0,
                            'PLR': 0,
                            'PLU': 0,
                            'POE': 0,
                            'POLL': 0,
                            'PPT': 0,
                            'PRE': 0,
                            'PRG': 0,
                            'PRO': 0,
                            'PRS': 0,
                            'PTOY': 0,
                            'QAU': 0,
                            'QCN': 0,
                            'QTUM': 0,
                            'QVT': 0,
                            'REP': 0,
                            'RKC': 0,
                            'RVT': 0,
                            'SAN': 0,
                            'SBD': 0,
                            'SCL': 0,
                            'SISA': 0,
                            'SKIN': 0,
                            'SMART': 0,
                            'SMS': 0,
                            'SNC': 0,
                            'SNGLS': 0,
                            'SNM': 0,
                            'SNT': 0,
                            'STEEM': 0,
                            'STRAT': 0,
                            'STU': 0,
                            'STX': 0,
                            'SUB': 0,
                            'SUR': 0,
                            'SWT': 0,
                            'TAAS': 0,
                            'TBT': 0,
                            'TFL': 0,
                            'TIME': 0,
                            'TIX': 0,
                            'TKN': 0,
                            'TKR': 0,
                            'TNT': 0,
                            'TRST': 0,
                            'TRX': 0,
                            'UET': 0,
                            'UGT': 0,
                            'VEN': 0,
                            'VERI': 0,
                            'VIB': 0,
                            'VIBE': 0,
                            'VOISE': 0,
                            'WEALTH': 0,
                            'WINGS': 0,
                            'WTC': 0,
                            'XAUR': 0,
                            'XDN': 0,
                            'XEM': 0,
                            'XUC': 0,
                            'YOYOW': 0,
                            'ZAP': 0,
                            'ZRX': 0,
                            'ZSC': 0
                        }
                    }
                }
            });
        }
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(symbol, fee) {
            return this.truncate(fee, 8);
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, i, market, id, baseId, quoteId, base, quote, symbol, lot, _step, precision, taker, maker;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetSymbol();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['id'];
                                    baseId = market['baseCurrency'];
                                    quoteId = market['quoteCurrency'];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    lot = this.safeFloat(market, 'quantityIncrement');
                                    _step = this.safeFloat(market, 'tickSize');
                                    precision = {
                                        'price': this.precisionFromString(market['tickSize']),
                                        'amount': this.precisionFromString(market['quantityIncrement'])
                                    };
                                    taker = this.safeFloat(market, 'takeLiquidityRate');
                                    maker = this.safeFloat(market, 'provideLiquidityRate');

                                    result.push(this.extend(this.fees['trading'], {
                                        'info': market,
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'lot': lot,
                                        'step': _step,
                                        'taker': taker,
                                        'maker': maker,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': _step,
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': lot * _step,
                                                'max': undefined
                                            }
                                        }
                                    }));
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var currencies, result, i, currency, id, precision, code, payin, payout, transfer, active, status, type;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetCurrency(params);

                            case 2:
                                currencies = _context2.sent;
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['id'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    precision = 8; // default precision, todo: fix "magic constants"

                                    code = this.commonCurrencyCode(id);
                                    payin = this.safeValue(currency, 'payinEnabled');
                                    payout = this.safeValue(currency, 'payoutEnabled');
                                    transfer = this.safeValue(currency, 'transferEnabled');
                                    active = payin && payout && transfer;
                                    status = 'ok';

                                    if ('disabled' in currency) if (currency['disabled']) status = 'disabled';
                                    type = 'fiat';

                                    if ('crypto' in currency && currency['crypto']) type = 'crypto';
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'type': type,
                                        'payin': payin,
                                        'payout': payout,
                                        'transfer': transfer,
                                        'info': currency,
                                        'name': currency['fullName'],
                                        'active': active,
                                        'status': status,
                                        'fee': this.safeFloat(currency, 'payoutFee'), // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context2.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchCurrencies() {
                return _ref2.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var type, method, balances, result, b, balance, code, currency, account;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                type = this.safeString(params, 'type', 'trading');
                                method = 'privateGet' + this.capitalize(type) + 'Balance';
                                _context3.next = 6;
                                return this[method]();

                            case 6:
                                balances = _context3.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    code = balance['currency'];
                                    currency = this.commonCurrencyCode(code);
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': parseFloat(balance['reserved']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1d';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var timestamp = this.parse8601(ohlcv['timestamp']);
            return [timestamp, parseFloat(ohlcv['open']), parseFloat(ohlcv['max']), parseFloat(ohlcv['min']), parseFloat(ohlcv['close']), parseFloat(ohlcv['volume'])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'period': this.timeframes[timeframe]
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context4.next = 7;
                                return this.publicGetCandlesSymbol(this.extend(request, params));

                            case 7:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOHLCV(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'symbol': this.marketId(symbol)
                                };

                                if (typeof limit !== 'undefined') request['limit'] = limit; // default = 100, 0 = unlimited
                                _context5.next = 6;
                                return this.publicGetOrderbookSymbol(this.extend(request, params));

                            case 6:
                                orderbook = _context5.sent;
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bid', 'ask', 'price', 'size'));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(ticker['timestamp']);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var baseVolume = this.safeFloat(ticker, 'volume');
            var quoteVolume = this.safeFloat(ticker, 'volumeQuote');
            var open = this.safeFloat(ticker, 'open');
            var last = this.safeFloat(ticker, 'last');
            var change = undefined;
            var percentage = undefined;
            var average = undefined;
            if (typeof last !== 'undefined' && typeof open !== 'undefined') {
                change = last - open;
                average = this.sum(last, open) / 2;
                if (open > 0) percentage = change / open * 100;
            }
            var vwap = undefined;
            if (typeof quoteVolume !== 'undefined') if (typeof baseVolume !== 'undefined') if (baseVolume > 0) vwap = quoteVolume / baseVolume;
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': vwap,
                'open': open,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': percentage,
                'average': average,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, i, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context6.sent;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    id = ticker['symbol'];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context6.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTickers() {
                return _ref6.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetTickerSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context7.sent;

                                if (!('message' in ticker)) {
                                    _context7.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + ticker['message']);

                            case 8:
                                return _context7.abrupt('return', this.parseTicker(ticker, market));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTicker(_x18) {
                return _ref7.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['timestamp']);
            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                var id = trade['symbol'];
                if (id in this.markets_by_id) {
                    market = this.markets_by_id[id];
                    symbol = market['symbol'];
                } else {
                    symbol = id;
                }
            }
            var fee = undefined;
            if ('fee' in trade) {
                var currency = market ? market['quote'] : undefined;
                fee = {
                    'cost': this.safeFloat(trade, 'fee'),
                    'currency': currency
                };
            }
            var orderId = undefined;
            if ('clientOrderId' in trade) orderId = trade['clientOrderId'];
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'quantity');
            var cost = price * amount;
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': orderId,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': undefined,
                'side': trade['side'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.publicGetTradesSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTrades(_x21) {
                return _ref8.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, uuid, parts, clientOrderId, request, response, order, id;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                // their max accepted length is 32 characters

                                uuid = this.uuid();
                                parts = uuid.split('-');
                                clientOrderId = parts.join('');

                                clientOrderId = clientOrderId.slice(0, 32);
                                amount = parseFloat(amount);
                                request = {
                                    'clientOrderId': clientOrderId,
                                    'symbol': market['id'],
                                    'side': side,
                                    'quantity': this.amountToPrecision(symbol, amount),
                                    'type': type
                                };

                                if (type === 'limit') {
                                    request['price'] = this.priceToPrecision(symbol, price);
                                } else {
                                    request['timeInForce'] = 'FOK';
                                }
                                _context9.next = 12;
                                return this.privatePostOrder(this.extend(request, params));

                            case 12:
                                response = _context9.sent;
                                order = this.parseOrder(response);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context9.abrupt('return', order);

                            case 17:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x25, _x26, _x27, _x28) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'editOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id, symbol, type, side) {
                var amount = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var price = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
                var uuid, parts, requestClientId, request, response, order;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                // their max accepted length is 32 characters
                                uuid = this.uuid();
                                parts = uuid.split('-');
                                requestClientId = parts.join('');

                                requestClientId = requestClientId.slice(0, 32);
                                request = {
                                    'clientOrderId': id,
                                    'requestClientId': requestClientId
                                };

                                if (typeof amount !== 'undefined') request['quantity'] = this.amountToPrecision(symbol, parseFloat(amount));
                                if (typeof price !== 'undefined') request['price'] = this.priceToPrecision(symbol, price);
                                _context10.next = 11;
                                return this.privatePatchOrderClientOrderId(this.extend(request, params));

                            case 11:
                                response = _context10.sent;
                                order = this.parseOrder(response);

                                this.orders[order['id']] = order;
                                return _context10.abrupt('return', order);

                            case 15:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function editOrder(_x31, _x32, _x33, _x34) {
                return _ref10.apply(this, arguments);
            }

            return editOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.privateDeleteOrderClientOrderId(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 4:
                                return _context11.abrupt('return', _context11.sent);

                            case 5:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function cancelOrder(_x38) {
                return _ref11.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var created = undefined;
            if ('createdAt' in order) created = this.parse8601(order['createdAt']);
            var updated = undefined;
            if ('updatedAt' in order) updated = this.parse8601(order['updatedAt']);
            if (!market) market = this.markets_by_id[order['symbol']];
            var symbol = market['symbol'];
            var amount = this.safeFloat(order, 'quantity');
            var filled = this.safeFloat(order, 'cumQuantity');
            var status = order['status'];
            if (status === 'new') {
                status = 'open';
            } else if (status === 'suspended') {
                status = 'open';
            } else if (status === 'partiallyFilled') {
                status = 'open';
            } else if (status === 'filled') {
                status = 'closed';
            }
            var id = order['clientOrderId'].toString();
            var price = this.safeFloat(order, 'price');
            if (typeof price === 'undefined') {
                if (id in this.orders) price = this.orders[id]['price'];
            }
            var remaining = undefined;
            var cost = undefined;
            if (typeof amount !== 'undefined') {
                if (typeof filled !== 'undefined') {
                    remaining = amount - filled;
                    if (typeof price !== 'undefined') {
                        cost = filled * price;
                    }
                }
            }
            return {
                'id': id,
                'timestamp': created,
                'datetime': this.iso8601(created),
                'lastTradeTimestamp': updated,
                'status': status,
                'symbol': symbol,
                'type': order['type'],
                'side': order['side'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'filled': filled,
                'remaining': remaining,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, numOrders;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context12.next = 4;
                                return this.privateGetHistoryOrder(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 4:
                                response = _context12.sent;
                                numOrders = response.length;

                                if (!(numOrders > 0)) {
                                    _context12.next = 8;
                                    break;
                                }

                                return _context12.abrupt('return', this.parseOrder(response[0]));

                            case 8:
                                throw new OrderNotFound(this.id + ' order ' + id + ' not found');

                            case 9:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrder(_x42) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context13.next = 4;
                                return this.privateGetOrderClientOrderId(this.extend({
                                    'clientOrderId': id
                                }, params));

                            case 4:
                                response = _context13.sent;
                                return _context13.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOpenOrder(_x45) {
                return _ref13.apply(this, arguments);
            }

            return fetchOpenOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['symbol'] = market['id'];
                                }
                                _context14.next = 7;
                                return this.privateGetOrder(this.extend(request, params));

                            case 7:
                                response = _context14.sent;
                                return _context14.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchOpenOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, orders;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['symbol'] = market['id'];
                                }
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                if (typeof since !== 'undefined') request['from'] = this.iso8601(since);
                                _context15.next = 9;
                                return this.privateGetHistoryOrder(this.extend(request, params));

                            case 9:
                                response = _context15.sent;
                                orders = this.parseOrders(response, market);

                                orders = this.filterBy(orders, 'status', 'closed');
                                return _context15.abrupt('return', this.filterBySinceLimit(orders, since, limit));

                            case 13:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchClosedOrders() {
                return _ref15.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    // 'symbol': 'BTC/USD', // optional
                                    // 'sort':   'DESC', // or 'ASC'
                                    // 'by':     'timestamp', // or 'id' String timestamp by default, or id
                                    // 'from':   'Datetime or Number', // ISO 8601
                                    // 'till':   'Datetime or Number',
                                    // 'limit':  100,
                                    // 'offset': 0,
                                };
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['symbol'] = market['id'];
                                }
                                if (typeof since !== 'undefined') request['from'] = this.iso8601(since);
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context16.next = 9;
                                return this.privateGetHistoryTrades(this.extend(request, params));

                            case 9:
                                response = _context16.sent;
                                return _context16.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchMyTrades() {
                return _ref16.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchOrderTrades',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, response, numOrders;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                _context17.next = 6;
                                return this.privateGetHistoryOrderIdTrades(this.extend({
                                    'id': id
                                }, params));

                            case 6:
                                response = _context17.sent;
                                numOrders = response.length;

                                if (!(numOrders > 0)) {
                                    _context17.next = 10;
                                    break;
                                }

                                return _context17.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                                throw new OrderNotFound(this.id + ' order ' + id + ' not found, ' + this.id + '.fetchOrderTrades() requires an exchange-specific order id, you need to grab it from order["info"]["id"]');

                            case 11:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function fetchOrderTrades(_x60) {
                return _ref17.apply(this, arguments);
            }

            return fetchOrderTrades;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, tag;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context18.next = 5;
                                return this.privatePostAccountCryptoAddressCurrency({
                                    'currency': currency['id']
                                });

                            case 5:
                                response = _context18.sent;
                                address = response['address'];

                                this.checkAddress(address);
                                tag = this.safeString(response, 'paymentId');
                                return _context18.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function createDepositAddress(_x65) {
                return _ref18.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, tag;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context19.next = 5;
                                return this.privateGetAccountCryptoAddressCurrency({
                                    'currency': currency['id']
                                });

                            case 5:
                                response = _context19.sent;
                                address = response['address'];

                                this.checkAddress(address);
                                tag = this.safeString(response, 'paymentId');
                                return _context19.abrupt('return', {
                                    'currency': currency.code,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function fetchDepositAddress(_x67) {
                return _ref19.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, response;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                this.checkAddress(address);
                                currency = this.currency(code);
                                request = {
                                    'currency': currency['id'],
                                    'amount': parseFloat(amount),
                                    'address': address
                                };

                                if (tag) request['paymentId'] = tag;
                                _context20.next = 6;
                                return this.privatePostAccountCryptoWithdraw(this.extend(request, params));

                            case 6:
                                response = _context20.sent;
                                return _context20.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 8:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function withdraw(_x69, _x70, _x71) {
                return _ref20.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/api' + '/' + this.version + '/';
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                url += api + '/' + this.implodeParams(path, params);
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                url += this.implodeParams(path, params);
                if (method === 'GET') {
                    if (Object.keys(query).length) url += '?' + this.urlencode(query);
                } else {
                    if (Object.keys(query).length) body = this.json(query);
                }
                var payload = this.encode(this.apiKey + ':' + this.secret);
                var auth = this.stringToBase64(payload);
                headers = {
                    'Authorization': 'Basic ' + this.decode(auth),
                    'Content-Type': 'application/json'
                };
            }
            url = this.urls['api'] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (typeof body !== 'string') return;
            if (code >= 400) {
                var feedback = this.id + ' ' + body;
                // {"code":504,"message":"Gateway Timeout","description":""}
                if (code === 503 || code === 504) throw new ExchangeNotAvailable(feedback);
                if (body[0] === '{') {
                    var response = JSON.parse(body);
                    if ('error' in response) {
                        if ('message' in response['error']) {
                            var message = response['error']['message'];
                            if (message === 'Order not found') {
                                throw new OrderNotFound(this.id + ' order not found in active orders');
                            } else if (message === 'Quantity not a valid number') {
                                throw new InvalidOrder(feedback);
                            } else if (message === 'Insufficient funds') {
                                throw new InsufficientFunds(feedback);
                            } else if (message === 'Duplicate clientOrderId') {
                                throw new InvalidOrder(feedback);
                            }
                        }
                    }
                }
                throw new ExchangeError(feedback);
            }
        }
    }]);

    return hitbtc2;
}(hitbtc);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(huobi, _Exchange);

    function huobi() {
        _classCallCheck(this, huobi);

        return _possibleConstructorReturn(this, (huobi.__proto__ || Object.getPrototypeOf(huobi)).apply(this, arguments));
    }

    _createClass(huobi, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(huobi.prototype.__proto__ || Object.getPrototypeOf(huobi.prototype), 'describe', this).call(this), {
                'id': 'huobi',
                'name': 'Huobi',
                'countries': 'CN',
                'rateLimit': 2000,
                'version': 'v3',
                'has': {
                    'CORS': false,
                    'fetchOHLCV': true
                },
                'timeframes': {
                    '1m': '001',
                    '5m': '005',
                    '15m': '015',
                    '30m': '030',
                    '1h': '060',
                    '1d': '100',
                    '1w': '200',
                    '1M': '300',
                    '1y': '400'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766569-15aa7b9a-5edd-11e7-9e7f-44791f4ee49c.jpg',
                    'api': 'http://api.huobi.com',
                    'www': 'https://www.huobi.com',
                    'doc': 'https://github.com/huobiapi/API_Docs_en/wiki'
                },
                'api': {
                    'staticmarket': {
                        'get': ['{id}_kline_{period}', 'ticker_{id}', 'depth_{id}', 'depth_{id}_{length}', 'detail_{id}']
                    },
                    'usdmarket': {
                        'get': ['{id}_kline_{period}', 'ticker_{id}', 'depth_{id}', 'depth_{id}_{length}', 'detail_{id}']
                    },
                    'trade': {
                        'post': ['get_account_info', 'get_orders', 'order_info', 'buy', 'sell', 'buy_market', 'sell_market', 'cancel_order', 'get_new_deal_orders', 'get_order_id_by_trade_id', 'withdraw_coin', 'cancel_withdraw_coin', 'get_withdraw_coin_result', 'transfer', 'loan', 'repayment', 'get_loan_available', 'get_loans']
                    }
                },
                'markets': {
                    'BTC/CNY': { 'id': 'btc', 'symbol': 'BTC/CNY', 'base': 'BTC', 'quote': 'CNY', 'type': 'staticmarket', 'coinType': 1 },
                    'LTC/CNY': { 'id': 'ltc', 'symbol': 'LTC/CNY', 'base': 'LTC', 'quote': 'CNY', 'type': 'staticmarket', 'coinType': 2 }
                    // 'BTC/USD': { 'id': 'btc', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'type': 'usdmarket',    'coinType': 1 },
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, currency, lowercase, account, available, frozen, loan;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.tradePostGetAccountInfo();

                            case 2:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();
                                    available = 'available_' + lowercase + '_display';
                                    frozen = 'frozen_' + lowercase + '_display';
                                    loan = 'loan_' + lowercase + '_display';

                                    if (available in balances) account['free'] = parseFloat(balances[available]);
                                    if (frozen in balances) account['used'] = parseFloat(balances[frozen]);
                                    if (loan in balances) account['used'] = this.sum(account['used'], parseFloat(balances[loan]));
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, method, orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                method = market['type'] + 'GetDepthId';
                                _context2.next = 4;
                                return this[method](this.extend({ 'id': market['id'] }, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, method, response, ticker, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                market = this.market(symbol);
                                method = market['type'] + 'GetTickerId';
                                _context3.next = 4;
                                return this[method](this.extend({
                                    'id': market['id']
                                }, params));

                            case 4:
                                response = _context3.sent;
                                ticker = response['ticker'];
                                timestamp = parseInt(response['time']) * 1000;
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'vwap': undefined,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': undefined,
                                    'first': undefined,
                                    'last': this.safeFloat(ticker, 'last'),
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': this.safeFloat(ticker, 'vol'),
                                    'info': ticker
                                });

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['ts'];
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['direction'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, method, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                method = market['type'] + 'GetDetailId';
                                _context4.next = 4;
                                return this[method](this.extend({
                                    'id': market['id']
                                }, params));

                            case 4:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            // not implemented yet
            return [ohlcv[0], ohlcv[1], ohlcv[2], ohlcv[3], ohlcv[4], ohlcv[6]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, method, ohlcvs;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                market = this.market(symbol);
                                method = market['type'] + 'GetIdKlinePeriod';
                                _context5.next = 4;
                                return this[method](this.extend({
                                    'id': market['id'],
                                    'period': this.timeframes[timeframe]
                                }, params));

                            case 4:
                                ohlcvs = _context5.sent;
                                return _context5.abrupt('return', ohlcvs);

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOHLCV(_x15) {
                return _ref5.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                market = this.market(symbol);
                                method = 'tradePost' + this.capitalize(side);
                                order = {
                                    'coin_type': market['coinType'],
                                    'amount': amount,
                                    'market': market['quote'].toLowerCase()
                                };

                                if (type === 'limit') order['price'] = price;else method += this.capitalize(type);
                                response = this[method](this.extend(order, params));
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x20, _x21, _x22, _x23) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.tradePostCancelOrder({ 'id': id });

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x26) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'];
            if (api === 'trade') {
                this.checkRequiredCredentials();
                url += '/api' + this.version;
                var query = this.keysort(this.extend({
                    'method': path,
                    'access_key': this.apiKey,
                    'created': this.nonce()
                }, params));
                var queryString = this.urlencode(this.omit(query, 'market'));
                // secret key must be appended to the query before signing
                queryString += '&secret_key=' + this.secret;
                query['sign'] = this.hash(this.encode(queryString));
                body = this.urlencode(query);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            } else {
                url += '/' + api + '/' + this.implodeParams(path, params) + '_json.js';
                var _query = this.omit(params, this.extractParams(path));
                if (Object.keys(_query).length) url += '?' + this.urlencode(_query);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'trade';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context8.sent;

                                if (!('status' in response)) {
                                    _context8.next = 6;
                                    break;
                                }

                                if (!(response['status'] === 'error')) {
                                    _context8.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                if (!('code' in response)) {
                                    _context8.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                                return _context8.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function request(_x34) {
                return _ref8.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return huobi;
}(Exchange);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var huobipro = __webpack_require__(11);

// ---------------------------------------------------------------------------

module.exports = function (_huobipro) {
    _inherits(huobicny, _huobipro);

    function huobicny() {
        _classCallCheck(this, huobicny);

        return _possibleConstructorReturn(this, (huobicny.__proto__ || Object.getPrototypeOf(huobicny)).apply(this, arguments));
    }

    _createClass(huobicny, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(huobicny.prototype.__proto__ || Object.getPrototypeOf(huobicny.prototype), 'describe', this).call(this), {
                'id': 'huobicny',
                'name': 'Huobi CNY',
                'hostname': 'be.huobi.com',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766569-15aa7b9a-5edd-11e7-9e7f-44791f4ee49c.jpg',
                    'api': 'https://be.huobi.com',
                    'www': 'https://www.huobi.com',
                    'doc': 'https://github.com/huobiapi/API_Docs/wiki/REST_api_reference'
                }
            });
        }
    }]);

    return huobicny;
}(huobipro);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(ice3x, _Exchange);

    function ice3x() {
        _classCallCheck(this, ice3x);

        return _possibleConstructorReturn(this, (ice3x.__proto__ || Object.getPrototypeOf(ice3x)).apply(this, arguments));
    }

    _createClass(ice3x, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(ice3x.prototype.__proto__ || Object.getPrototypeOf(ice3x.prototype), 'describe', this).call(this), {
                'id': 'ice3x',
                'name': 'ICE3X',
                'countries': 'ZA', // South Africa
                'rateLimit': 1000,
                'has': {
                    'fetchCurrencies': true,
                    'fetchTickers': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'fetchDepositAddress': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38012176-11616c32-3269-11e8-9f05-e65cf885bb15.jpg',
                    'api': 'https://ice3x.com/api/v1',
                    'www': ['https://ice3x.com', 'https://ice3x.co.za'],
                    'doc': 'https://ice3x.co.za/ice-cubed-bitcoin-exchange-api-documentation-1-june-2017',
                    'fees': ['https://help.ice3.com/support/solutions/articles/11000033293-trading-fees', 'https://help.ice3.com/support/solutions/articles/11000033288-fees-explained', 'https://help.ice3.com/support/solutions/articles/11000008131-what-are-your-fiat-deposit-and-withdrawal-fees-', 'https://help.ice3.com/support/solutions/articles/11000033289-deposit-fees']
                },
                'api': {
                    'public': {
                        'get': ['currency/list', 'currency/info', 'pair/list', 'pair/info', 'stats/marketdepthfull', 'stats/marketdepthbtcav', 'stats/marketdepth', 'orderbook/info', 'trade/list', 'trade/info']
                    },
                    'private': {
                        'post': ['balance/list', 'balance/info', 'order/new', 'order/cancel', 'order/list', 'order/info', 'trade/list', 'trade/info', 'transaction/list', 'transaction/info', 'invoice/list', 'invoice/info', 'invoice/pdf']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.01,
                        'taker': 0.01
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                }
            });
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, precision, result, i, currency, id, code;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetCurrencyList(params);

                            case 2:
                                response = _context.sent;
                                currencies = response['response']['entities'];
                                precision = this.precision['amount'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['currency_id'];
                                    code = this.commonCurrencyCode(currency['iso'].toUpperCase());

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'name': currency['name'],
                                        'active': true,
                                        'status': 'ok',
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCurrencies() {
                return _ref.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, markets, result, i, market, id, baseId, quoteId, baseCurrency, quoteCurrency, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (Object.keys(this.currencies).length) {
                                    _context2.next = 4;
                                    break;
                                }

                                _context2.next = 3;
                                return this.fetchCurrencies();

                            case 3:
                                this.currencies = _context2.sent;

                            case 4:
                                this.currencies_by_id = this.indexBy(this.currencies, 'id');
                                _context2.next = 7;
                                return this.publicGetPairList();

                            case 7:
                                response = _context2.sent;
                                markets = response['response']['entities'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['pair_id'];
                                    baseId = market['currency_id_from'].toString();
                                    quoteId = market['currency_id_to'].toString();
                                    baseCurrency = this.currencies_by_id[baseId];
                                    quoteCurrency = this.currencies_by_id[quoteId];
                                    base = this.commonCurrencyCode(baseCurrency['code']);
                                    quote = this.commonCurrencyCode(quoteCurrency['code']);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'lot': undefined,
                                        'info': market
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last_price');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'max'),
                'low': this.safeFloat(ticker, 'min'),
                'bid': this.safeFloat(ticker, 'max_bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'min_ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'avg'),
                'baseVolume': undefined,
                'quoteVolume': this.safeFloat(ticker, 'vol'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetStatsMarketdepthfull(this.extend({
                                    'pair_id': market['id']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTicker(response['response']['entity'], market));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x3) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, i, ticker, market, symbol;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetStatsMarketdepthfull(params);

                            case 4:
                                response = _context4.sent;
                                tickers = response['response']['entities'];
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    market = this.marketsById[ticker['pair_id']];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetOrderbookInfo(this.extend({
                                    'pair_id': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context5.sent;
                                orderbook = response['response']['entities'];
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = parseInt(trade['created']) * 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'volume');
            var symbol = market['symbol'];
            var cost = parseFloat(this.costToPrecision(symbol, price * amount));
            var fee = this.safeFloat(trade, 'fee');
            if (fee) {
                fee = {
                    'cost': fee,
                    'currency': market['quote']
                };
            }
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'trade_id'),
                'order': undefined,
                'type': 'limit',
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': fee,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTradeList(this.extend({
                                    'pair_id': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                trades = response['response']['entities'];
                                return _context6.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, balances, i, balance, id, currency, code;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostBalanceList(params);

                            case 4:
                                response = _context7.sent;
                                result = { 'info': response };
                                balances = response['response']['entities'];

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    id = balance['currency_id'];

                                    if (id in this.currencies_by_id) {
                                        currency = this.currencies_by_id[id];
                                        code = currency['code'];

                                        result[code] = {
                                            'free': 0.0,
                                            'used': 0.0,
                                            'total': parseFloat(balance['balance'])
                                        };
                                    }
                                }
                                return _context7.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchBalance() {
                return _ref7.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var pairId = this.safeInteger(order, 'pair_id');
            var symbol = undefined;
            if (pairId && !market && pairId in this.marketsById) {
                market = this.marketsById[pairId];
                symbol = market['symbol'];
            }
            var timestamp = this.safeInteger(order, 'created') * 1000;
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'volume');
            var status = this.safeInteger(order, 'active');
            var remaining = this.safeFloat(order, 'remaining');
            var filled = undefined;
            if (status === 1) {
                status = 'open';
            } else {
                status = 'closed';
                remaining = 0;
                filled = amount;
            }
            var fee = this.safeFloat(order, 'fee');
            if (fee) {
                fee = { 'cost': fee };
                if (market) fee['currency'] = market['quote'];
            }
            return {
                'id': this.safeString(order, 'order_id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': undefined,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': undefined,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, response, order, id;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.privatePostOrderNew(this.extend({
                                    'pair_id': market['id'],
                                    'type': side,
                                    'amount': amount,
                                    'price': price
                                }, params));

                            case 5:
                                response = _context8.sent;
                                order = this.parseOrder({
                                    'order_id': response['response']['entity']['order_id'],
                                    'created': this.seconds(),
                                    'active': 1,
                                    'type': side,
                                    'price': price,
                                    'volume': amount,
                                    'remaining': amount,
                                    'info': response
                                }, market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context8.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x16, _x17, _x18, _x19) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.privatePostOrderCancel(this.extend({
                                    'order_id': id
                                }, params));

                            case 2:
                                response = _context9.sent;
                                return _context9.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x22) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostOrderInfo(this.extend({
                                    'order _id': id
                                }, params));

                            case 4:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(response['response']['entity']));

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrder(_x25) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response, orders;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context11.next = 4;
                                return this.privatePostOrderList();

                            case 4:
                                response = _context11.sent;
                                orders = response['response']['entities'];
                                return _context11.abrupt('return', this.parseOrders(orders, undefined, since, limit));

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOpenOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, trades;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair_id': market['id']
                                };

                                if (limit) request['items_per_page'] = limit;
                                if (since) request['date_from'] = parseInt(since / 1000);
                                _context12.next = 8;
                                return this.privatePostTradeList(this.extend(request, params));

                            case 8:
                                response = _context12.sent;
                                trades = response['response']['entities'];
                                return _context12.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 11:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchMyTrades() {
                return _ref12.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, balance, address, status;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context13.next = 5;
                                return this.privatePostBalanceInfo(this.extend({
                                    'currency_id': currency['id']
                                }, params));

                            case 5:
                                response = _context13.sent;
                                balance = response['response']['entity'];
                                address = this.safeString(balance, 'address');
                                status = address ? 'ok' : 'none';
                                return _context13.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': undefined,
                                    'status': status,
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchDepositAddress(_x36) {
                return _ref13.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            if (api === 'public') {
                params = this.urlencode(params);
                if (params.length) url += '?' + params;
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.extend({
                    'nonce': this.nonce()
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, errors, data, authErrorKeys, i, errorKey, errorMessage;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context14.sent;
                                errors = this.safeValue(response, 'errors');
                                data = this.safeValue(response, 'response');

                                if (!(errors || !data)) {
                                    _context14.next = 20;
                                    break;
                                }

                                authErrorKeys = ['Key', 'user_id', 'Sign'];
                                i = 0;

                            case 8:
                                if (!(i < authErrorKeys.length)) {
                                    _context14.next = 19;
                                    break;
                                }

                                errorKey = authErrorKeys[i];
                                errorMessage = this.safeString(errors, errorKey);

                                if (errorMessage) {
                                    _context14.next = 13;
                                    break;
                                }

                                return _context14.abrupt('continue', 16);

                            case 13:
                                if (!(errorKey === 'user_id' && errorMessage.indexOf('authorization') < 0)) {
                                    _context14.next = 15;
                                    break;
                                }

                                return _context14.abrupt('continue', 16);

                            case 15:
                                throw new AuthenticationError(errorMessage);

                            case 16:
                                i++;
                                _context14.next = 8;
                                break;

                            case 19:
                                throw new ExchangeError(this.json(errors));

                            case 20:
                                return _context14.abrupt('return', response);

                            case 21:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function request(_x43) {
                return _ref14.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return ice3x;
}(Exchange);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(independentreserve, _Exchange);

    function independentreserve() {
        _classCallCheck(this, independentreserve);

        return _possibleConstructorReturn(this, (independentreserve.__proto__ || Object.getPrototypeOf(independentreserve)).apply(this, arguments));
    }

    _createClass(independentreserve, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(independentreserve.prototype.__proto__ || Object.getPrototypeOf(independentreserve.prototype), 'describe', this).call(this), {
                'id': 'independentreserve',
                'name': 'Independent Reserve',
                'countries': ['AU', 'NZ'], // Australia, New Zealand
                'rateLimit': 1000,
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30521662-cf3f477c-9bcb-11e7-89bc-d1ac85012eda.jpg',
                    'api': {
                        'public': 'https://api.independentreserve.com/Public',
                        'private': 'https://api.independentreserve.com/Private'
                    },
                    'www': 'https://www.independentreserve.com',
                    'doc': 'https://www.independentreserve.com/API'
                },
                'api': {
                    'public': {
                        'get': ['GetValidPrimaryCurrencyCodes', 'GetValidSecondaryCurrencyCodes', 'GetValidLimitOrderTypes', 'GetValidMarketOrderTypes', 'GetValidOrderTypes', 'GetValidTransactionTypes', 'GetMarketSummary', 'GetOrderBook', 'GetTradeHistorySummary', 'GetRecentTrades', 'GetFxRates']
                    },
                    'private': {
                        'post': ['PlaceLimitOrder', 'PlaceMarketOrder', 'CancelOrder', 'GetOpenOrders', 'GetClosedOrders', 'GetClosedFilledOrders', 'GetOrderDetails', 'GetAccounts', 'GetTransactions', 'GetDigitalCurrencyDepositAddress', 'GetDigitalCurrencyDepositAddresses', 'SynchDigitalCurrencyDepositAddressWithBlockchain', 'WithdrawDigitalCurrency', 'RequestFiatWithdrawal', 'GetTrades']
                    }
                },
                'fees': {
                    'trading': {
                        'taker': 0.5 / 100,
                        'maker': 0.5 / 100,
                        'percentage': true,
                        'tierBased': false
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var baseCurrencies, quoteCurrencies, result, i, baseId, baseIdUppercase, base, j, quoteId, quoteIdUppercase, quote, id, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetGetValidPrimaryCurrencyCodes();

                            case 2:
                                baseCurrencies = _context.sent;
                                _context.next = 5;
                                return this.publicGetGetValidSecondaryCurrencyCodes();

                            case 5:
                                quoteCurrencies = _context.sent;
                                result = [];

                                for (i = 0; i < baseCurrencies.length; i++) {
                                    baseId = baseCurrencies[i];
                                    baseIdUppercase = baseId.toUpperCase();
                                    base = this.commonCurrencyCode(baseIdUppercase);

                                    for (j = 0; j < quoteCurrencies.length; j++) {
                                        quoteId = quoteCurrencies[j];
                                        quoteIdUppercase = quoteId.toUpperCase();
                                        quote = this.commonCurrencyCode(quoteIdUppercase);
                                        id = baseId + '/' + quoteId;
                                        symbol = base + '/' + quote;

                                        result.push({
                                            'id': id,
                                            'symbol': symbol,
                                            'base': base,
                                            'quote': quote,
                                            'baseId': baseId,
                                            'quoteId': quoteId,
                                            'info': id
                                        });
                                    }
                                }
                                return _context.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, i, balance, currencyCode, uppercase, currency, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetAccounts();

                            case 4:
                                balances = _context2.sent;
                                result = { 'info': balances };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    currencyCode = balance['CurrencyCode'];
                                    uppercase = currencyCode.toUpperCase();
                                    currency = this.commonCurrencyCode(uppercase);
                                    account = this.account();

                                    account['free'] = balance['AvailableBalance'];
                                    account['total'] = balance['TotalBalance'];
                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetGetOrderBook(this.extend({
                                    'primaryCurrencyCode': market['baseId'],
                                    'secondaryCurrencyCode': market['quoteId']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                timestamp = this.parse8601(response['CreatedTimestampUtc']);
                                return _context3.abrupt('return', this.parseOrderBook(response, timestamp, 'BuyOrders', 'SellOrders', 'Price', 'Volume'));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(ticker['CreatedTimestampUtc']);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = ticker['LastPrice'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': ticker['DayHighestPrice'],
                'low': ticker['DayLowestPrice'],
                'bid': ticker['CurrentHighestBidPrice'],
                'bidVolume': undefined,
                'ask': ticker['CurrentLowestOfferPrice'],
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': ticker['DayAvgPrice'],
                'baseVolume': ticker['DayVolumeXbtInSecondaryCurrrency'],
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetGetMarketSummary(this.extend({
                                    'primaryCurrencyCode': market['baseId'],
                                    'secondaryCurrencyCode': market['quoteId']
                                }, params));

                            case 5:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTicker(response, market));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (typeof market === 'undefined') {
                symbol = market['symbol'];
            } else {
                market = this.findMarket(order['PrimaryCurrencyCode'] + '/' + order['SecondaryCurrencyCode']);
            }
            var orderType = this.safeValue(order, 'Type');
            if (orderType.indexOf('Market') >= 0) orderType = 'market';else if (orderType.indexOf('Limit') >= 0) orderType = 'limit';
            var side = undefined;
            if (orderType.indexOf('Bid') >= 0) side = 'buy';else if (orderType.indexOf('Offer') >= 0) side = 'sell';
            var timestamp = this.parse8601(order['CreatedTimestampUtc']);
            var amount = this.safeFloat(order, 'VolumeOrdered');
            if (typeof amount === 'undefined') amount = this.safeFloat(order, 'Volume');
            var filled = this.safeFloat(order, 'VolumeFilled');
            var remaining = undefined;
            var feeRate = this.safeFloat(order, 'FeePercent');
            var feeCost = undefined;
            if (typeof amount !== 'undefined') {
                if (typeof filled !== 'undefined') {
                    remaining = amount - filled;
                    if (typeof feeRate !== 'undefined') feeCost = feeRate * filled;
                }
            }
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                feeCurrency = market['base'];
            }
            var fee = {
                'rate': feeRate,
                'cost': feeCost,
                'currency': feeCurrency
            };
            var id = order['OrderGuid'];
            var status = this.parseOrderStatus(order['Status']);
            var cost = this.safeFloat(order, 'Value');
            var average = this.safeFloat(order, 'AvgPrice');
            var price = this.safeFloat(order, 'Price', average);
            return {
                'info': order,
                'id': id,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': orderType,
                'side': side,
                'price': price,
                'cost': cost,
                'average': average,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': fee
            };
        }
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                'Open': 'open',
                'PartiallyFilled': 'open',
                'Filled': 'closed',
                'PartiallyFilledAndCancelled': 'canceled',
                'Cancelled': 'canceled',
                'PartiallyFilledAndExpired': 'canceled',
                'Expired': 'canceled'
            };
            if (status in statuses) return statuses[status];
            return status;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, market;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privatePostGetOrderDetails(this.extend({
                                    'orderGuid': id
                                }, params));

                            case 4:
                                response = _context5.sent;
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                return _context5.abrupt('return', this.parseOrder(response, market));

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrder(_x9) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var pageIndex, request, response, market;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                pageIndex = this.safeInteger(params, 'pageIndex', 1);
                                request = this.ordered({
                                    'pageIndex': pageIndex,
                                    'pageSize': limit
                                });
                                _context6.next = 6;
                                return this.privatePostGetTrades(this.extend(request, params));

                            case 6:
                                response = _context6.sent;
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                }
                                return _context6.abrupt('return', this.parseTrades(response['Data'], market, since, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchMyTrades() {
                return _ref6.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['TradeTimestampUtc']);
            var id = this.safeString(trade, 'TradeGuid');
            var orderId = this.safeString(trade, 'OrderGuid');
            var price = this.safeFloat(trade, 'Price');
            if (typeof price === 'undefined') {
                price = this.safeFloat(trade, 'SecondaryCurrencyTradePrice');
            }
            var amount = this.safeFloat(trade, 'VolumeTraded');
            if (typeof amount === 'undefined') {
                amount = this.safeFloat(trade, 'PrimaryCurrencyAmount');
            }
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var side = this.safeString(trade, 'OrderType');
            if (typeof side !== 'undefined') {
                if (side.indexOf('Bid') >= 0) side = 'buy';else if (side.indexOf('Offer') >= 0) side = 'sell';
            }
            return {
                'id': id,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'order': orderId,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'fee': undefined
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetGetRecentTrades(this.extend({
                                    'primaryCurrencyCode': market['baseId'],
                                    'secondaryCurrencyCode': market['quoteId'],
                                    'numberOfRecentTradesToRetrieve': 50 // max = 50
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['Trades'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x17) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, capitalizedOrderType, method, orderType, order, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                capitalizedOrderType = this.capitalize(type);
                                method = 'privatePostPlace' + capitalizedOrderType + 'Order';
                                orderType = capitalizedOrderType;

                                orderType += side === 'sell' ? 'Offer' : 'Bid';
                                order = this.ordered({
                                    'primaryCurrencyCode': market['baseId'],
                                    'secondaryCurrencyCode': market['quoteId'],
                                    'orderType': orderType
                                });

                                if (type === 'limit') order['price'] = price;
                                order['volume'] = amount;
                                _context8.next = 12;
                                return this[method](this.extend(order, params));

                            case 12:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['OrderGuid']
                                });

                            case 14:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x21, _x22, _x23, _x24) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostCancelOrder({ 'orderGuid': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var auth = [url, 'apiKey=' + this.apiKey, 'nonce=' + nonce.toString()];
                // remove this crap
                var keys = Object.keys(params);
                var payload = [];
                for (var i = 0; i < keys.length; i++) {
                    var key = keys[i];
                    payload.push(key + '=' + params[key]);
                }
                auth = this.arrayConcat(auth, payload);
                var message = auth.join(',');
                var signature = this.hmac(this.encode(message), this.encode(this.secret));
                body = this.json({
                    'apiKey': this.apiKey,
                    'nonce': nonce,
                    'signature': signature
                });
                headers = { 'Content-Type': 'application/json' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return independentreserve;
}(Exchange);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(indodax, _Exchange);

    function indodax() {
        _classCallCheck(this, indodax);

        return _possibleConstructorReturn(this, (indodax.__proto__ || Object.getPrototypeOf(indodax)).apply(this, arguments));
    }

    _createClass(indodax, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(indodax.prototype.__proto__ || Object.getPrototypeOf(indodax.prototype), 'describe', this).call(this), {
                'id': 'indodax',
                'name': 'INDODAX',
                'countries': 'ID', // Indonesia
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchTickers': false,
                    'fetchOrder': true,
                    'fetchOrders': false,
                    'fetchClosedOrders': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': false,
                    'fetchCurrencies': false,
                    'withdraw': true
                },
                'version': '1.7', // as of 6 November 2017
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/37443283-2fddd0e4-281c-11e8-9741-b4f1419001b5.jpg',
                    'api': {
                        'public': 'https://vip.bitcoin.co.id/api',
                        'private': 'https://vip.bitcoin.co.id/tapi'
                    },
                    'www': 'https://www.indodax.com',
                    'doc': 'https://indodax.com/downloads/BITCOINCOID-API-DOCUMENTATION.pdf'
                },
                'api': {
                    'public': {
                        'get': ['{pair}/ticker', '{pair}/trades', '{pair}/depth']
                    },
                    'private': {
                        'post': ['getInfo', 'transHistory', 'trade', 'tradeHistory', 'getOrder', 'openOrders', 'cancelOrder', 'orderHistory', 'withdrawCoin']
                    }
                },
                'markets': {
                    'BTC/IDR': { 'id': 'btc_idr', 'symbol': 'BTC/IDR', 'base': 'BTC', 'quote': 'IDR', 'baseId': 'btc', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.0001, 'max': undefined } } },
                    'BCH/IDR': { 'id': 'bch_idr', 'symbol': 'BCH/IDR', 'base': 'BCH', 'quote': 'IDR', 'baseId': 'bch', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'BTG/IDR': { 'id': 'btg_idr', 'symbol': 'BTG/IDR', 'base': 'BTG', 'quote': 'IDR', 'baseId': 'btg', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'ETH/IDR': { 'id': 'eth_idr', 'symbol': 'ETH/IDR', 'base': 'ETH', 'quote': 'IDR', 'baseId': 'eth', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'ETC/IDR': { 'id': 'etc_idr', 'symbol': 'ETC/IDR', 'base': 'ETC', 'quote': 'IDR', 'baseId': 'etc', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.1, 'max': undefined } } },
                    'IGNIS/IDR': { 'id': 'ignis_idr', 'symbol': 'IGNIS/IDR', 'base': 'IGNIS', 'quote': 'IDR', 'baseId': 'ignis', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 1, 'max': undefined } } },
                    'LTC/IDR': { 'id': 'ltc_idr', 'symbol': 'LTC/IDR', 'base': 'LTC', 'quote': 'IDR', 'baseId': 'ltc', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'NXT/IDR': { 'id': 'nxt_idr', 'symbol': 'NXT/IDR', 'base': 'NXT', 'quote': 'IDR', 'baseId': 'nxt', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 5, 'max': undefined } } },
                    'TEN/IDR': { 'id': 'ten_idr', 'symbol': 'TEN/IDR', 'base': 'TEN', 'quote': 'IDR', 'baseId': 'ten', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 5, 'max': undefined } } },
                    'WAVES/IDR': { 'id': 'waves_idr', 'symbol': 'WAVES/IDR', 'base': 'WAVES', 'quote': 'IDR', 'baseId': 'waves', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.1, 'max': undefined } } },
                    'XRP/IDR': { 'id': 'xrp_idr', 'symbol': 'XRP/IDR', 'base': 'XRP', 'quote': 'IDR', 'baseId': 'xrp', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 10, 'max': undefined } } },
                    'XZC/IDR': { 'id': 'xzc_idr', 'symbol': 'XZC/IDR', 'base': 'XZC', 'quote': 'IDR', 'baseId': 'xzc', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 0.1, 'max': undefined } } },
                    'XLM/IDR': { 'id': 'str_idr', 'symbol': 'XLM/IDR', 'base': 'XLM', 'quote': 'IDR', 'baseId': 'str', 'quoteId': 'idr', 'precision': { 'amount': 8, 'price': 0 }, 'limits': { 'amount': { 'min': 20, 'max': undefined } } },
                    'BTS/BTC': { 'id': 'bts_btc', 'symbol': 'BTS/BTC', 'base': 'BTS', 'quote': 'BTC', 'baseId': 'bts', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'DASH/BTC': { 'id': 'drk_btc', 'symbol': 'DASH/BTC', 'base': 'DASH', 'quote': 'BTC', 'baseId': 'drk', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 6 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'DOGE/BTC': { 'id': 'doge_btc', 'symbol': 'DOGE/BTC', 'base': 'DOGE', 'quote': 'BTC', 'baseId': 'doge', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 1, 'max': undefined } } },
                    'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'baseId': 'eth', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 5 }, 'limits': { 'amount': { 'min': 0.001, 'max': undefined } } },
                    'LTC/BTC': { 'id': 'ltc_btc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'baseId': 'ltc', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 6 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'NXT/BTC': { 'id': 'nxt_btc', 'symbol': 'NXT/BTC', 'base': 'NXT', 'quote': 'BTC', 'baseId': 'nxt', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'TEN/BTC': { 'id': 'ten_btc', 'symbol': 'TEN/BTC', 'base': 'TEN', 'quote': 'BTC', 'baseId': 'ten', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'XLM/BTC': { 'id': 'str_btc', 'symbol': 'XLM/BTC', 'base': 'XLM', 'quote': 'BTC', 'baseId': 'str', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } },
                    'XEM/BTC': { 'id': 'nem_btc', 'symbol': 'XEM/BTC', 'base': 'XEM', 'quote': 'BTC', 'baseId': 'nem', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 1, 'max': undefined } } },
                    'XRP/BTC': { 'id': 'xrp_btc', 'symbol': 'XRP/BTC', 'base': 'XRP', 'quote': 'BTC', 'baseId': 'xrp', 'quoteId': 'btc', 'precision': { 'amount': 8, 'price': 8 }, 'limits': { 'amount': { 'min': 0.01, 'max': undefined } } }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0,
                        'taker': 0.003
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, result, codes, i, code, currency, lowercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostGetInfo();

                            case 4:
                                response = _context.sent;
                                balance = response['return'];
                                result = { 'info': balance };
                                codes = Object.keys(this.currencies);

                                for (i = 0; i < codes.length; i++) {
                                    code = codes[i];
                                    currency = this.currencies[code];
                                    lowercase = currency['id'];
                                    account = this.account();

                                    account['free'] = this.safeFloat(balance['balance'], lowercase, 0.0);
                                    account['used'] = this.safeFloat(balance['balance_hold'], lowercase, 0.0);
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[code] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetPairDepth(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy', 'sell'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker, timestamp, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.publicGetPairTicker(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                ticker = response['ticker'];
                                timestamp = this.safeFloat(ticker, 'server_time') * 1000;
                                baseVolume = 'vol_' + market['baseId'].toLowerCase();
                                quoteVolume = 'vol_' + market['quoteId'].toLowerCase();
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': parseFloat(ticker[baseVolume]),
                                    'quoteVolume': parseFloat(ticker[quoteVolume]),
                                    'info': ticker
                                });

                            case 12:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'id': trade['tid'],
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['type'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetPairTrades(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            if ('type' in order) side = order['type'];
            var status = this.safeString(order, 'status', 'open');
            if (status === 'filled') {
                status = 'closed';
            } else if (status === 'calcelled') {
                status = 'canceled';
            }
            var symbol = undefined;
            var cost = undefined;
            var price = this.safeFloat(order, 'price');
            var amount = undefined;
            var remaining = undefined;
            var filled = undefined;
            if (market) {
                symbol = market['symbol'];
                var quoteId = market['quoteId'];
                var baseId = market['baseId'];
                if (market['quoteId'] === 'idr' && 'order_rp' in order) quoteId = 'rp';
                if (market['baseId'] === 'idr' && 'remain_rp' in order) baseId = 'rp';
                cost = this.safeFloat(order, 'order_' + quoteId);
                if (cost) {
                    amount = cost / price;
                    var remainingCost = this.safeFloat(order, 'remain_' + quoteId);
                    if (typeof remainingCost !== 'undefined') {
                        remaining = remainingCost / price;
                        filled = amount - remaining;
                    }
                } else {
                    amount = this.safeFloat(order, 'order_' + baseId);
                    cost = price * amount;
                    remaining = this.safeFloat(order, 'remain_' + baseId);
                    filled = amount - remaining;
                }
            }
            var average = undefined;
            if (filled) average = cost / filled;
            var timestamp = parseInt(order['submit_time']);
            var fee = undefined;
            var result = {
                'info': order,
                'id': order['order_id'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'cost': cost,
                'average': average,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': fee
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, orders, order;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (symbol) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a symbol');

                            case 2:
                                _context5.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context5.next = 7;
                                return this.privatePostGetOrder(this.extend({
                                    'pair': market['id'],
                                    'order_id': id
                                }, params));

                            case 7:
                                response = _context5.sent;
                                orders = response['return'];
                                order = this.parseOrder(this.extend({ 'id': id }, orders['order']), market);
                                return _context5.abrupt('return', this.extend({ 'info': response }, order));

                            case 11:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrder(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, rawOrders, marketIds, exchangeOrders, i, marketId, marketOrders, parsedOrders;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                }
                                _context6.next = 7;
                                return this.privatePostOpenOrders(this.extend(request, params));

                            case 7:
                                response = _context6.sent;
                                rawOrders = response['return']['orders'];
                                // { success: 1, return: { orders: null }} if no orders

                                if (rawOrders) {
                                    _context6.next = 11;
                                    break;
                                }

                                return _context6.abrupt('return', []);

                            case 11:
                                if (!(typeof symbol !== 'undefined')) {
                                    _context6.next = 13;
                                    break;
                                }

                                return _context6.abrupt('return', this.parseOrders(rawOrders, market, since, limit));

                            case 13:
                                // { success: 1, return: { orders: { marketid: [ ... objects ] }}} if all orders are fetched
                                marketIds = Object.keys(rawOrders);
                                exchangeOrders = [];

                                for (i = 0; i < marketIds.length; i++) {
                                    marketId = marketIds[i];
                                    marketOrders = rawOrders[marketId];

                                    market = this.markets_by_id[marketId];
                                    parsedOrders = this.parseOrders(marketOrders, market, since, limit);

                                    exchangeOrders = this.arrayConcat(exchangeOrders, parsedOrders);
                                }
                                return _context6.abrupt('return', exchangeOrders);

                            case 17:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOpenOrders() {
                return _ref6.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response, orders;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (symbol) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a symbol');

                            case 2:
                                _context7.next = 4;
                                return this.loadMarkets();

                            case 4:
                                request = {};
                                market = undefined;

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['pair'] = market['id'];
                                }
                                _context7.next = 9;
                                return this.privatePostOrderHistory(this.extend(request, params));

                            case 9:
                                response = _context7.sent;
                                orders = this.parseOrders(response['return']['orders'], market, since, limit);

                                orders = this.filterBy(orders, 'status', 'closed');

                                if (!symbol) {
                                    _context7.next = 14;
                                    break;
                                }

                                return _context7.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 14:
                                return _context7.abrupt('return', orders);

                            case 15:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchClosedOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, currency, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                order = {
                                    'pair': market['id'],
                                    'type': side,
                                    'price': price
                                };
                                currency = market['baseId'];

                                if (side === 'buy') {
                                    order[market['quoteId']] = amount * price;
                                } else {
                                    order[market['baseId']] = amount;
                                }
                                order[currency] = amount;
                                _context8.next = 11;
                                return this.privatePostTrade(this.extend(order, params));

                            case 11:
                                result = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': result,
                                    'id': result['return']['order_id'].toString()
                                });

                            case 13:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x23, _x24, _x25, _x26) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var side, market;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context9.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a symbol argument');

                            case 2:
                                side = this.safeValue(params, 'side');

                                if (!(typeof side === 'undefined')) {
                                    _context9.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires an extra "side" param');

                            case 5:
                                _context9.next = 7;
                                return this.loadMarkets();

                            case 7:
                                market = this.market(symbol);
                                _context9.next = 10;
                                return this.privatePostCancelOrder(this.extend({
                                    'order_id': id,
                                    'pair': market['id'],
                                    'type': params['side']
                                }, params));

                            case 10:
                                return _context9.abrupt('return', _context9.sent);

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x29) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, requestId, request, response, id;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this.checkAddress(address);
                                _context10.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                // Custom string you need to provide to identify each withdrawal request.
                                // Will be passed to callback URL (assigned via website to the API key)
                                // so your system can identify the request and confirm it.
                                // Alphanumeric, max length 255.

                                requestId = this.milliseconds();
                                // alternatively:
                                // let requestId = this.uuid ();

                                request = {
                                    'currency': currency['id'],
                                    'withdraw_amount': amount,
                                    'withdraw_address': address,
                                    'request_id': requestId.toString()
                                };

                                if (tag) request['withdraw_memo'] = tag;
                                _context10.next = 9;
                                return this.privatePostWithdrawCoin(this.extend(request, params));

                            case 9:
                                response = _context10.sent;

                                //
                                //     {
                                //         "success": 1,
                                //         "status": "approved",
                                //         "withdraw_currency": "xrp",
                                //         "withdraw_address": "rwWr7KUZ3ZFwzgaDGjKBysADByzxvohQ3C",
                                //         "withdraw_amount": "10000.00000000",
                                //         "fee": "2.00000000",
                                //         "amount_after_fee": "9998.00000000",
                                //         "submit_time": "1509469200",
                                //         "withdraw_id": "xrp-12345",
                                //         "txid": "",
                                //         "withdraw_memo": "123123"
                                //     }
                                //
                                id = undefined;

                                if ('txid' in response && response['txid'].length > 0) id = response['txid'];
                                return _context10.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 13:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function withdraw(_x32, _x33, _x34) {
                return _ref10.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            if (api === 'public') {
                url += '/' + this.implodeParams(path, params);
            } else {
                this.checkRequiredCredentials();
                body = this.urlencode(this.extend({
                    'method': path,
                    'nonce': this.nonce()
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            var response = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

            if (typeof body !== 'string') return;
            // { success: 0, error: "invalid order." }
            // or
            // [{ data, ... }, { ... }, ... ]
            if (typeof response === 'undefined') if (body[0] === '{' || body[0] === '[') response = JSON.parse(body);
            if (Array.isArray(response)) return; // public endpoints may return []-arrays
            if (!('success' in response)) return; // no 'success' property on public responses
            if (response['success'] === 1) {
                // { success: 1, return: { orders: [] }}
                if (!('return' in response)) throw new ExchangeError(this.id + ': malformed response: ' + this.json(response));else return;
            }
            var message = response['error'];
            var feedback = this.id + ' ' + this.json(response);
            if (message === 'Insufficient balance.') {
                throw new InsufficientFunds(feedback);
            } else if (message === 'invalid order.') {
                throw new OrderNotFound(feedback); // cancelOrder(1)
            } else if (message.indexOf('Minimum price ') >= 0) {
                throw new InvalidOrder(feedback); // price < limits.price.min, on createLimitBuyOrder ('ETH/BTC', 1, 0)
            } else if (message.indexOf('Minimum order ') >= 0) {
                throw new InvalidOrder(feedback); // cost < limits.cost.min on createLimitBuyOrder ('ETH/BTC', 0, 1)
            } else if (message === 'Invalid credentials. API not found or session has expired.') {
                throw new AuthenticationError(feedback); // on bad apiKey
            } else if (message === 'Invalid credentials. Bad sign.') {
                throw new AuthenticationError(feedback); // on bad secret
            }
            throw new ExchangeError(this.id + ': unknown error: ' + this.json(response));
        }
    }]);

    return indodax;
}(Exchange);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

var _require2 = __webpack_require__(0),
    AuthenticationError = _require2.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(itbit, _Exchange);

    function itbit() {
        _classCallCheck(this, itbit);

        return _possibleConstructorReturn(this, (itbit.__proto__ || Object.getPrototypeOf(itbit)).apply(this, arguments));
    }

    _createClass(itbit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(itbit.prototype.__proto__ || Object.getPrototypeOf(itbit.prototype), 'describe', this).call(this), {
                'id': 'itbit',
                'name': 'itBit',
                'countries': 'US',
                'rateLimit': 2000,
                'version': 'v1',
                'has': {
                    'CORS': true,
                    'createMarketOrder': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27822159-66153620-60ad-11e7-89e7-005f6d7f3de0.jpg',
                    'api': 'https://api.itbit.com',
                    'www': 'https://www.itbit.com',
                    'doc': ['https://api.itbit.com/docs', 'https://www.itbit.com/api']
                },
                'api': {
                    'public': {
                        'get': ['markets/{symbol}/ticker', 'markets/{symbol}/order_book', 'markets/{symbol}/trades']
                    },
                    'private': {
                        'get': ['wallets', 'wallets/{walletId}', 'wallets/{walletId}/balances/{currencyCode}', 'wallets/{walletId}/funding_history', 'wallets/{walletId}/trades', 'wallets/{walletId}/orders', 'wallets/{walletId}/orders/{id}'],
                        'post': ['wallet_transfers', 'wallets', 'wallets/{walletId}/cryptocurrency_deposits', 'wallets/{walletId}/cryptocurrency_withdrawals', 'wallets/{walletId}/orders', 'wire_withdrawal'],
                        'delete': ['wallets/{walletId}/orders/{id}']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'XBTUSD', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD' },
                    'BTC/SGD': { 'id': 'XBTSGD', 'symbol': 'BTC/SGD', 'base': 'BTC', 'quote': 'SGD' },
                    'BTC/EUR': { 'id': 'XBTEUR', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' }
                },
                'fees': {
                    'trading': {
                        'maker': 0,
                        'taker': 0.2 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarketsSymbolOrderBook(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context.sent;
                                return _context.abrupt('return', this.parseOrderBook(orderbook));

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOrderBook(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, serverTimeUTC, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetMarketsSymbolTicker(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context2.sent;
                                serverTimeUTC = 'serverTimeUTC' in ticker;

                                if (serverTimeUTC) {
                                    _context2.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchTicker returned a bad response: ' + this.json(ticker));

                            case 6:
                                timestamp = this.parse8601(ticker['serverTimeUTC']);
                                vwap = this.safeFloat(ticker, 'vwap24h');
                                baseVolume = this.safeFloat(ticker, 'volume24h');
                                quoteVolume = undefined;

                                if (typeof baseVolume !== 'undefined' && typeof vwap !== 'undefined') quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'lastPrice');
                                return _context2.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high24h'),
                                    'low': this.safeFloat(ticker, 'low24h'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': this.safeFloat(ticker, 'openToday'),
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 13:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parse8601(trade['timestamp']);
            var id = trade['matchNumber'].toString();
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': id,
                'order': id,
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                market = this.market(symbol);
                                _context3.next = 3;
                                return this.publicGetMarketsSymbolTrades(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 3:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(response['recentTrades'], market, since, limit));

                            case 5:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x6) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.fetchWallets();

                            case 2:
                                response = _context4.sent;
                                balances = response[0]['balances'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    account = {
                                        'free': parseFloat(balance['availableBalance']),
                                        'used': 0.0,
                                        'total': parseFloat(balance['totalBalance'])
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context4.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchBalance() {
                return _ref4.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchWallets',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (this.userId) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new AuthenticationError(this.id + ' fetchWallets requires userId in API settings');

                            case 2:
                                params = {
                                    'userId': this.userId
                                };
                                return _context5.abrupt('return', this.privateGetWallets(params));

                            case 4:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchWallets() {
                return _ref5.apply(this, arguments);
            }

            return fetchWallets;
        }()
    }, {
        key: 'fetchWallet',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(walletId) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var wallet;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                wallet = {
                                    'walletId': walletId
                                };
                                return _context6.abrupt('return', this.privateGetWalletsWalletId(this.extend(wallet, params)));

                            case 2:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchWallet(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchWallet;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                return _context7.abrupt('return', this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': 'open'
                                }, params)));

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOpenOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                return _context8.abrupt('return', this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': 'filled'
                                }, params)));

                            case 1:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchClosedOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var walletIdInParams, walletId, response, orders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                walletIdInParams = 'walletId' in params;

                                if (walletIdInParams) {
                                    _context9.next = 3;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrders requires a walletId parameter');

                            case 3:
                                walletId = params['walletId'];
                                _context9.next = 6;
                                return this.privateGetWalletsWalletIdOrders(this.extend({
                                    'walletId': walletId
                                }, params));

                            case 6:
                                response = _context9.sent;
                                orders = this.parseOrders(response, undefined, since, limit);
                                return _context9.abrupt('return', orders);

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['side'];
            var type = order['type'];
            var symbol = this.markets_by_id[order['instrument']]['symbol'];
            var timestamp = this.parse8601(order['createdTime']);
            var amount = this.safeFloat(order, 'amount');
            var filled = this.safeFloat(order, 'amountFilled');
            var remaining = amount - filled;
            var fee = undefined;
            var price = this.safeFloat(order, 'price');
            var cost = price * this.safeFloat(order, 'volumeWeightedAveragePrice');
            return {
                'id': order['id'],
                'info': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': order['status'],
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': fee
                // 'trades': this.parseTrades (order['trades'], market),
            };
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var walletIdInParams, market, order, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                walletIdInParams = 'walletId' in params;

                                if (walletIdInParams) {
                                    _context10.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' createOrder requires a walletId parameter');

                            case 5:
                                amount = amount.toString();
                                price = price.toString();
                                market = this.market(symbol);
                                order = {
                                    'side': side,
                                    'type': type,
                                    'currency': market['id'].replace(market['quote'], ''),
                                    'amount': amount,
                                    'display': amount,
                                    'price': price,
                                    'instrument': market['id']
                                };
                                _context10.next = 11;
                                return this.privatePostWalletsWalletIdOrders(this.extend(order, params));

                            case 11:
                                response = _context10.sent;
                                return _context10.abrupt('return', {
                                    'info': response,
                                    'id': response['id']
                                });

                            case 13:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x26, _x27, _x28, _x29) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var walletIdInParams;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                walletIdInParams = 'walletId' in params;

                                if (walletIdInParams) {
                                    _context11.next = 3;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a walletId parameter');

                            case 3:
                                _context11.next = 5;
                                return this.privateGetWalletsWalletIdOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 5:
                                return _context11.abrupt('return', _context11.sent);

                            case 6:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrder(_x32) {
                return _ref11.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var walletIdInParams;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                walletIdInParams = 'walletId' in params;

                                if (walletIdInParams) {
                                    _context12.next = 3;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a walletId parameter');

                            case 3:
                                _context12.next = 5;
                                return this.privateDeleteWalletsWalletIdOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 5:
                                return _context12.abrupt('return', _context12.sent);

                            case 6:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function cancelOrder(_x35) {
                return _ref12.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (method === 'GET' && Object.keys(query).length) url += '?' + this.urlencode(query);
            if (method === 'POST' && Object.keys(query).length) body = this.json(query);else body = '';
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var timestamp = nonce;
                var auth = [method, url, body, nonce, timestamp];
                var message = nonce + this.json(auth).replace('\\/', '/');
                var hash = this.hash(this.encode(message), 'sha256', 'binary');
                var binhash = this.binaryConcat(url, hash);
                var signature = this.hmac(binhash, this.encode(this.secret), 'sha512', 'base64');
                headers = {
                    'Authorization': this.apiKey + ':' + signature,
                    'Content-Type': 'application/json',
                    'X-Auth-Timestamp': timestamp,
                    'X-Auth-Nonce': nonce
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context13.sent;

                                if (!('code' in response)) {
                                    _context13.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context13.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function request(_x43) {
                return _ref13.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return itbit;
}(Exchange);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var btcbox = __webpack_require__(32);

// ---------------------------------------------------------------------------

module.exports = function (_btcbox) {
    _inherits(jubi, _btcbox);

    function jubi() {
        _classCallCheck(this, jubi);

        return _possibleConstructorReturn(this, (jubi.__proto__ || Object.getPrototypeOf(jubi)).apply(this, arguments));
    }

    _createClass(jubi, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(jubi.prototype.__proto__ || Object.getPrototypeOf(jubi.prototype), 'describe', this).call(this), {
                'id': 'jubi',
                'name': 'jubi.com',
                'countries': 'CN',
                'rateLimit': 1500,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766581-9d397d9a-5edd-11e7-8fb9-5d8236c0e692.jpg',
                    'api': 'https://www.jubi.com/api',
                    'www': 'https://www.jubi.com',
                    'doc': 'https://www.jubi.com/help/api.html'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, keys, result, p, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetAllticker();

                            case 2:
                                markets = _context.sent;
                                keys = Object.keys(markets);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    id = keys[p];
                                    base = id.toUpperCase();
                                    quote = 'CNY'; // todo

                                    symbol = base + '/' + quote;

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': id
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }]);

    return jubi;
}(btcbox);

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    ExchangeError = _require.ExchangeError,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection,
    InvalidNonce = _require.InvalidNonce,
    InsufficientFunds = _require.InsufficientFunds,
    CancelPending = _require.CancelPending,
    InvalidOrder = _require.InvalidOrder,
    InvalidAddress = _require.InvalidAddress;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(kraken, _Exchange);

    function kraken() {
        _classCallCheck(this, kraken);

        return _possibleConstructorReturn(this, (kraken.__proto__ || Object.getPrototypeOf(kraken)).apply(this, arguments));
    }

    _createClass(kraken, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(kraken.prototype.__proto__ || Object.getPrototypeOf(kraken.prototype), 'describe', this).call(this), {
                'id': 'kraken',
                'name': 'Kraken',
                'countries': 'US',
                'version': '0',
                'rateLimit': 3000,
                'has': {
                    'createDepositAddress': true,
                    'fetchDepositAddress': true,
                    'fetchTradingFees': true,
                    'CORS': false,
                    'fetchCurrencies': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchMyTrades': true,
                    'withdraw': true
                },
                'marketsByAltname': {},
                'timeframes': {
                    '1m': '1',
                    '5m': '5',
                    '15m': '15',
                    '30m': '30',
                    '1h': '60',
                    '4h': '240',
                    '1d': '1440',
                    '1w': '10080',
                    '2w': '21600'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766599-22709304-5ede-11e7-9de1-9f33732e1509.jpg',
                    'api': {
                        'public': 'https://api.kraken.com',
                        'private': 'https://api.kraken.com',
                        'zendesk': 'https://support.kraken.com/hc/en-us/articles'
                    },
                    'www': 'https://www.kraken.com',
                    'doc': ['https://www.kraken.com/en-us/help/api', 'https://github.com/nothingisdead/npm-kraken-api'],
                    'fees': 'https://www.kraken.com/en-us/help/fees'
                },
                'fees': {
                    'trading': {
                        'tierBased': true,
                        'percentage': true,
                        'taker': 0.26 / 100,
                        'maker': 0.16 / 100,
                        'tiers': {
                            'taker': [[0, 0.0026], [50000, 0.0024], [100000, 0.0022], [250000, 0.0020], [500000, 0.0018], [1000000, 0.0016], [2500000, 0.0014], [5000000, 0.0012], [10000000, 0.0001]],
                            'maker': [[0, 0.0016], [50000, 0.0014], [100000, 0.0012], [250000, 0.0010], [500000, 0.0008], [1000000, 0.0006], [2500000, 0.0004], [5000000, 0.0002], [10000000, 0.0]]
                        }
                    },
                    // this is a bad way of hardcoding fees that change on daily basis
                    // hardcoding is now considered obsolete, we will remove all of it eventually
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001,
                            'ETH': 0.005,
                            'XRP': 0.02,
                            'XLM': 0.00002,
                            'LTC': 0.02,
                            'DOGE': 2,
                            'ZEC': 0.00010,
                            'ICN': 0.02,
                            'REP': 0.01,
                            'ETC': 0.005,
                            'MLN': 0.003,
                            'XMR': 0.05,
                            'DASH': 0.005,
                            'GNO': 0.01,
                            'EOS': 0.5,
                            'BCH': 0.001,
                            'USD': 5, // if domestic wire
                            'EUR': 5, // if domestic wire
                            'CAD': 10, // CAD EFT Withdrawal
                            'JPY': 300 // if domestic wire
                        },
                        'deposit': {
                            'BTC': 0,
                            'ETH': 0,
                            'XRP': 0,
                            'XLM': 0,
                            'LTC': 0,
                            'DOGE': 0,
                            'ZEC': 0,
                            'ICN': 0,
                            'REP': 0,
                            'ETC': 0,
                            'MLN': 0,
                            'XMR': 0,
                            'DASH': 0,
                            'GNO': 0,
                            'EOS': 0,
                            'BCH': 0,
                            'USD': 5, // if domestic wire
                            'EUR': 0, // free deposit if EUR SEPA Deposit
                            'CAD': 5, // if domestic wire
                            'JPY': 0 // Domestic Deposit (Free, ¥5,000 deposit minimum)
                        }
                    }
                },
                'api': {
                    'zendesk': {
                        'get': [
                        // we should really refrain from putting fixed fee numbers and stop hardcoding
                        // we will be using their web APIs to scrape all numbers from these articles
                        '205893708-What-is-the-minimum-order-size-', '201396777-What-are-the-deposit-fees-', '201893608-What-are-the-withdrawal-fees-']
                    },
                    'public': {
                        'get': ['Assets', 'AssetPairs', 'Depth', 'OHLC', 'Spread', 'Ticker', 'Time', 'Trades']
                    },
                    'private': {
                        'post': ['AddOrder', 'Balance', 'CancelOrder', 'ClosedOrders', 'DepositAddresses', 'DepositMethods', 'DepositStatus', 'Ledgers', 'OpenOrders', 'OpenPositions', 'QueryLedgers', 'QueryOrders', 'QueryTrades', 'TradeBalance', 'TradesHistory', 'TradeVolume', 'Withdraw', 'WithdrawCancel', 'WithdrawInfo', 'WithdrawStatus']
                    }
                },
                'options': {
                    'cacheDepositMethodsOnFetchDepositAddress': true, // will issue up to two calls in fetchDepositAddress
                    'depositMethods': {}
                },
                'exceptions': {
                    'EFunding:Unknown withdraw key': ExchangeError,
                    'EFunding:Invalid amount': InsufficientFunds,
                    'EService:Unavailable': ExchangeNotAvailable,
                    'EDatabase:Internal error': ExchangeNotAvailable,
                    'EService:Busy': ExchangeNotAvailable,
                    'EAPI:Rate limit exceeded': DDoSProtection,
                    'EQuery:Unknown asset': ExchangeError
                }
            });
        }
    }, {
        key: 'costToPrecision',
        value: function costToPrecision(symbol, cost) {
            return this.truncate(parseFloat(cost), this.markets[symbol]['precision']['price']);
        }
    }, {
        key: 'feeToPrecision',
        value: function feeToPrecision(symbol, fee) {
            return this.truncate(parseFloat(fee), this.markets[symbol]['precision']['amount']);
        }
    }, {
        key: 'fetchMinOrderSizes',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var html, parts, ul, listItems, result, separator, l, listItem, chunks, numChunks, limit, name, currency;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                html = undefined;
                                _context.prev = 1;

                                this.parseJsonResponse = false;
                                _context.next = 5;
                                return this.zendeskGet205893708WhatIsTheMinimumOrderSize();

                            case 5:
                                html = _context.sent;

                                this.parseJsonResponse = true;
                                _context.next = 13;
                                break;

                            case 9:
                                _context.prev = 9;
                                _context.t0 = _context['catch'](1);

                                // ensure parseJsonResponse is restored no matter what
                                this.parseJsonResponse = true;
                                throw _context.t0;

                            case 13:
                                parts = html.split('ul>');
                                ul = parts[1];
                                listItems = ul.split('</li');
                                result = {};
                                separator = '):' + ' ';

                                for (l = 0; l < listItems.length; l++) {
                                    listItem = listItems[l];
                                    chunks = listItem.split(separator);
                                    numChunks = chunks.length;

                                    if (numChunks > 1) {
                                        limit = parseFloat(chunks[1]);
                                        name = chunks[0];

                                        chunks = name.split('(');
                                        currency = chunks[1];

                                        result[currency] = limit;
                                    }
                                }
                                return _context.abrupt('return', result);

                            case 20:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[1, 9]]);
            }));

            function fetchMinOrderSizes() {
                return _ref.apply(this, arguments);
            }

            return fetchMinOrderSizes;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var markets, limits, keys, result, i, id, market, baseId, quoteId, base, quote, darkpool, symbol, maker, precision, minAmount;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetAssetPairs();

                            case 2:
                                markets = _context2.sent;
                                _context2.next = 5;
                                return this.fetchMinOrderSizes();

                            case 5:
                                limits = _context2.sent;
                                keys = Object.keys(markets['result']);
                                result = [];

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    market = markets['result'][id];
                                    baseId = market['base'];
                                    quoteId = market['quote'];
                                    base = baseId;
                                    quote = quoteId;

                                    if (base[0] === 'X' || base[0] === 'Z') base = base.slice(1);
                                    if (quote[0] === 'X' || quote[0] === 'Z') quote = quote.slice(1);
                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    darkpool = id.indexOf('.d') >= 0;
                                    symbol = darkpool ? market['altname'] : base + '/' + quote;
                                    maker = undefined;

                                    if ('fees_maker' in market) {
                                        maker = parseFloat(market['fees_maker'][0][1]) / 100;
                                    }
                                    precision = {
                                        'amount': market['lot_decimals'],
                                        'price': market['pair_decimals']
                                    };
                                    minAmount = Math.pow(10, -precision['amount']);

                                    if (base in limits) minAmount = limits[base];
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'darkpool': darkpool,
                                        'info': market,
                                        'altname': market['altname'],
                                        'maker': maker,
                                        'taker': parseFloat(market['fees'][0][1]) / 100,
                                        'active': true,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': minAmount,
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': 0,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                result = this.appendInactiveMarkets(result);
                                this.marketsByAltname = this.indexBy(result, 'altname');
                                return _context2.abrupt('return', result);

                            case 12:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'appendInactiveMarkets',
        value: function appendInactiveMarkets() {
            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var precision = { 'amount': 8, 'price': 8 };
            var costLimits = { 'min': 0, 'max': undefined };
            var priceLimits = { 'min': Math.pow(10, -precision['price']), 'max': undefined };
            var amountLimits = { 'min': Math.pow(10, -precision['amount']), 'max': Math.pow(10, precision['amount']) };
            var limits = { 'amount': amountLimits, 'price': priceLimits, 'cost': costLimits };
            var defaults = {
                'darkpool': false,
                'info': undefined,
                'maker': undefined,
                'taker': undefined,
                'active': false,
                'precision': precision,
                'limits': limits
            };
            var markets = [
                // { 'id': 'XXLMZEUR', 'symbol': 'XLM/EUR', 'base': 'XLM', 'quote': 'EUR', 'altname': 'XLMEUR' },
            ];
            for (var i = 0; i < markets.length; i++) {
                result.push(this.extend(defaults, markets[i]));
            }
            return result;
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, ids, result, i, id, currency, code, precision;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetAssets(params);

                            case 2:
                                response = _context3.sent;
                                currencies = response['result'];
                                ids = Object.keys(currencies);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    currency = currencies[id];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    code = this.commonCurrencyCode(currency['altname']);
                                    precision = currency['decimals'];

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': code,
                                        'active': true,
                                        'status': 'ok',
                                        'fee': undefined,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context3.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchCurrencies() {
                return _ref3.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchTradingFees',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                var response, tradedVolume, tiers, taker, maker, i, _i;

                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                this.checkRequiredCredentials();
                                _context4.next = 5;
                                return this.privatePostTradeVolume(params);

                            case 5:
                                response = _context4.sent;
                                tradedVolume = this.safeFloat(response['result'], 'volume');
                                tiers = this.fees['trading']['tiers'];
                                taker = tiers['taker'][1];
                                maker = tiers['maker'][1];

                                for (i = 0; i < tiers['taker'].length; i++) {
                                    if (tradedVolume >= tiers['taker'][i][0]) taker = tiers['taker'][i][1];
                                }
                                for (_i = 0; _i < tiers['maker'].length; _i++) {
                                    if (tradedVolume >= tiers['maker'][_i][0]) maker = tiers['maker'][_i][1];
                                }
                                return _context4.abrupt('return', {
                                    'info': response,
                                    'maker': maker,
                                    'taker': taker
                                });

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTradingFees() {
                return _ref4.apply(this, arguments);
            }

            return fetchTradingFees;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!market['darkpool']) {
                                    _context5.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' does not provide an order book for darkpool symbol ' + symbol);

                            case 5:
                                request = {
                                    'pair': market['id']
                                };

                                if (typeof limit !== 'undefined') request['count'] = limit; // 100
                                _context5.next = 9;
                                return this.publicGetDepth(this.extend(request, params));

                            case 9:
                                response = _context5.sent;
                                orderbook = response['result'][market['id']];
                                return _context5.abrupt('return', this.parseOrderBook(orderbook));

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var baseVolume = parseFloat(ticker['v'][1]);
            var vwap = parseFloat(ticker['p'][1]);
            var quoteVolume = baseVolume * vwap;
            var last = parseFloat(ticker['c'][0]);
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': parseFloat(ticker['h'][1]),
                'low': parseFloat(ticker['l'][1]),
                'bid': parseFloat(ticker['b'][0]),
                'bidVolume': undefined,
                'ask': parseFloat(ticker['a'][0]),
                'askVolume': undefined,
                'vwap': vwap,
                'open': this.safeFloat(ticker, 'o'),
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                var pairs, s, symbol, market, filter, response, tickers, ids, result, i, id, _market, _symbol, ticker;

                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                pairs = [];

                                for (s = 0; s < this.symbols.length; s++) {
                                    symbol = this.symbols[s];
                                    market = this.markets[symbol];

                                    if (market['active']) if (!market['darkpool']) pairs.push(market['id']);
                                }
                                filter = pairs.join(',');
                                _context6.next = 7;
                                return this.publicGetTicker(this.extend({
                                    'pair': filter
                                }, params));

                            case 7:
                                response = _context6.sent;
                                tickers = response['result'];
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    _market = this.markets_by_id[id];
                                    _symbol = _market['symbol'];
                                    ticker = tickers[id];

                                    result[_symbol] = this.parseTicker(ticker, _market);
                                }
                                return _context6.abrupt('return', result);

                            case 13:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTickers() {
                return _ref6.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var darkpool, market, response, ticker;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                darkpool = symbol.indexOf('.d') >= 0;

                                if (!darkpool) {
                                    _context7.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' does not provide a ticker for darkpool symbol ' + symbol);

                            case 5:
                                market = this.market(symbol);
                                _context7.next = 8;
                                return this.publicGetTicker(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 8:
                                response = _context7.sent;
                                ticker = response['result'][market['id']];
                                return _context7.abrupt('return', this.parseTicker(ticker, market));

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTicker(_x10) {
                return _ref7.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0] * 1000, parseFloat(ohlcv[1]), parseFloat(ohlcv[2]), parseFloat(ohlcv[3]), parseFloat(ohlcv[4]), parseFloat(ohlcv[6])];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response, ohlcvs;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id'],
                                    'interval': this.timeframes[timeframe]
                                };

                                if (typeof since !== 'undefined') request['since'] = parseInt(since / 1000);
                                _context8.next = 7;
                                return this.publicGetOHLC(this.extend(request, params));

                            case 7:
                                response = _context8.sent;
                                ohlcvs = response['result'][market['id']];
                                return _context8.abrupt('return', this.parseOHLCVs(ohlcvs, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOHLCV(_x16) {
                return _ref8.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = undefined;
            var side = undefined;
            var type = undefined;
            var price = undefined;
            var amount = undefined;
            var id = undefined;
            var order = undefined;
            var fee = undefined;
            if (!market) market = this.findMarketByAltnameOrId(trade['pair']);
            if ('ordertxid' in trade) {
                order = trade['ordertxid'];
                id = trade['id'];
                timestamp = parseInt(trade['time'] * 1000);
                side = trade['type'];
                type = trade['ordertype'];
                price = this.safeFloat(trade, 'price');
                amount = this.safeFloat(trade, 'vol');
                if ('fee' in trade) {
                    var currency = undefined;
                    if (market) currency = market['quote'];
                    fee = {
                        'cost': this.safeFloat(trade, 'fee'),
                        'currency': currency
                    };
                }
            } else {
                timestamp = parseInt(trade[2] * 1000);
                side = trade[3] === 's' ? 'sell' : 'buy';
                type = trade[4] === 'l' ? 'limit' : 'market';
                price = parseFloat(trade[0]);
                amount = parseFloat(trade[1]);
                var tradeLength = trade.length;
                if (tradeLength > 6) id = trade[6]; // artificially added as per #1794
            }
            var symbol = market ? market['symbol'] : undefined;
            return {
                'id': id,
                'order': order,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'amount': amount,
                'cost': price * amount,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, id, response, result, trades, length, lastTrade, lastTradeId;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                id = market['id'];
                                _context9.next = 6;
                                return this.publicGetTrades(this.extend({
                                    'pair': id
                                }, params));

                            case 6:
                                response = _context9.sent;

                                // { result: { marketid: [ ... trades ] }, last: "last_trade_id"}
                                result = response['result'];
                                trades = result[id];
                                // trades is a sorted array: last (most recent trade) goes last

                                length = trades.length;

                                if (!(length <= 0)) {
                                    _context9.next = 12;
                                    break;
                                }

                                return _context9.abrupt('return', []);

                            case 12:
                                lastTrade = trades[length - 1];
                                lastTradeId = this.safeString(result, 'last');

                                lastTrade.push(lastTradeId);
                                return _context9.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 16:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchTrades(_x22) {
                return _ref9.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencies, c, currency, code, balance, account;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostBalance();

                            case 4:
                                response = _context10.sent;
                                balances = this.safeValue(response, 'result');

                                if (!(typeof balances === 'undefined')) {
                                    _context10.next = 8;
                                    break;
                                }

                                throw new ExchangeNotAvailable(this.id + ' fetchBalance failed due to a malformed response ' + this.json(response));

                            case 8:
                                result = { 'info': balances };
                                currencies = Object.keys(balances);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    code = currency;

                                    if (code in this.currencies_by_id) {
                                        code = this.currencies_by_id[code]['code'];
                                    } else {
                                        // X-ISO4217-A3 standard currency codes
                                        if (code[0] === 'X') {
                                            code = code.slice(1);
                                        } else if (code[0] === 'Z') {
                                            code = code.slice(1);
                                        }
                                        code = this.commonCurrencyCode(code);
                                    }
                                    balance = parseFloat(balances[currency]);
                                    account = {
                                        'free': balance,
                                        'used': 0.0,
                                        'total': balance
                                    };

                                    result[code] = account;
                                }
                                return _context10.abrupt('return', this.parseBalance(result));

                            case 12:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchBalance() {
                return _ref10.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response, id, length;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                order = {
                                    'pair': market['id'],
                                    'type': side,
                                    'ordertype': type,
                                    'volume': this.amountToPrecision(symbol, amount)
                                };

                                if (type === 'limit') order['price'] = this.priceToPrecision(symbol, price);
                                _context11.next = 7;
                                return this.privatePostAddOrder(this.extend(order, params));

                            case 7:
                                response = _context11.sent;
                                id = this.safeValue(response['result'], 'txid');

                                if (typeof id !== 'undefined') {
                                    if (Array.isArray(id)) {
                                        length = id.length;

                                        id = length > 1 ? id : id[0];
                                    }
                                }
                                return _context11.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 11:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function createOrder(_x27, _x28, _x29, _x30) {
                return _ref11.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'findMarketByAltnameOrId',
        value: function findMarketByAltnameOrId(id) {
            if (id in this.marketsByAltname) {
                return this.marketsByAltname[id];
            } else if (id in this.markets_by_id) {
                return this.markets_by_id[id];
            }
            return undefined;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var description = order['descr'];
            var side = description['type'];
            var type = description['ordertype'];
            var symbol = undefined;
            if (typeof market === 'undefined') market = this.findMarketByAltnameOrId(description['pair']);
            var timestamp = parseInt(order['opentm'] * 1000);
            var amount = this.safeFloat(order, 'vol');
            var filled = this.safeFloat(order, 'vol_exec');
            var remaining = amount - filled;
            var fee = undefined;
            var cost = this.safeFloat(order, 'cost');
            var price = this.safeFloat(description, 'price');
            if (!price) price = this.safeFloat(order, 'price');
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
                if ('fee' in order) {
                    var flags = order['oflags'];
                    var feeCost = this.safeFloat(order, 'fee');
                    fee = {
                        'cost': feeCost,
                        'rate': undefined
                    };
                    if (flags.indexOf('fciq') >= 0) {
                        fee['currency'] = market['quote'];
                    } else if (flags.indexOf('fcib') >= 0) {
                        fee['currency'] = market['base'];
                    }
                }
            }
            return {
                'id': order['id'],
                'info': order,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': order['status'],
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'fee': fee
                // 'trades': this.parseTrades (order['trades'], market),
            };
        }
    }, {
        key: 'parseOrders',
        value: function parseOrders(orders) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var result = [];
            var ids = Object.keys(orders);
            for (var i = 0; i < ids.length; i++) {
                var id = ids[i];
                var order = this.extend({ 'id': id }, orders[id]);
                result.push(this.parseOrder(order, market));
            }
            return this.filterBySinceLimit(result, since, limit);
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orders, order;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context12.next = 4;
                                return this.privatePostQueryOrders(this.extend({
                                    'trades': true, // whether or not to include trades in output (optional, default false)
                                    'txid': id // comma delimited list of transaction ids to query info about (20 maximum)
                                    // 'userref': 'optional', // restrict results to given user reference id (optional)
                                }, params));

                            case 4:
                                response = _context12.sent;
                                orders = response['result'];
                                order = this.parseOrder(this.extend({ 'id': id }, orders[id]));
                                return _context12.abrupt('return', this.extend({ 'info': response }, order));

                            case 8:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrder(_x37) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, response, trades, ids, i, result;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    // 'type': 'all', // any position, closed position, closing position, no position
                                    // 'trades': false, // whether or not to include trades related to position in output
                                    // 'start': 1234567890, // starting unix timestamp or trade tx id of results (exclusive)
                                    // 'end': 1234567890, // ending unix timestamp or trade tx id of results (inclusive)
                                    // 'ofs' = result offset
                                };

                                if (typeof since !== 'undefined') request['start'] = parseInt(since / 1000);
                                _context13.next = 6;
                                return this.privatePostTradesHistory(this.extend(request, params));

                            case 6:
                                response = _context13.sent;
                                trades = response['result']['trades'];
                                ids = Object.keys(trades);

                                for (i = 0; i < ids.length; i++) {
                                    trades[ids[i]]['id'] = ids[i];
                                }
                                result = this.parseTrades(trades, undefined, since, limit);

                                if (!(typeof symbol === 'undefined')) {
                                    _context13.next = 13;
                                    break;
                                }

                                return _context13.abrupt('return', result);

                            case 13:
                                return _context13.abrupt('return', this.filterBySymbol(result, symbol));

                            case 14:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchMyTrades() {
                return _ref13.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                response = undefined;
                                _context14.prev = 3;
                                _context14.next = 6;
                                return this.privatePostCancelOrder(this.extend({
                                    'txid': id
                                }, params));

                            case 6:
                                response = _context14.sent;
                                _context14.next = 15;
                                break;

                            case 9:
                                _context14.prev = 9;
                                _context14.t0 = _context14['catch'](3);

                                if (!this.last_http_response) {
                                    _context14.next = 14;
                                    break;
                                }

                                if (!(this.last_http_response.indexOf('EOrder:Unknown order') >= 0)) {
                                    _context14.next = 14;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' cancelOrder() error ' + this.last_http_response);

                            case 14:
                                throw _context14.t0;

                            case 15:
                                return _context14.abrupt('return', response);

                            case 16:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this, [[3, 9]]);
            }));

            function cancelOrder(_x44) {
                return _ref14.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, response, orders;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};

                                if (typeof since !== 'undefined') request['start'] = parseInt(since / 1000);
                                _context15.next = 6;
                                return this.privatePostOpenOrders(this.extend(request, params));

                            case 6:
                                response = _context15.sent;
                                orders = this.parseOrders(response['result']['open'], undefined, since, limit);

                                if (!(typeof symbol === 'undefined')) {
                                    _context15.next = 10;
                                    break;
                                }

                                return _context15.abrupt('return', orders);

                            case 10:
                                return _context15.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 11:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchOpenOrders() {
                return _ref15.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, response, orders;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};

                                if (typeof since !== 'undefined') request['start'] = parseInt(since / 1000);
                                _context16.next = 6;
                                return this.privatePostClosedOrders(this.extend(request, params));

                            case 6:
                                response = _context16.sent;
                                orders = this.parseOrders(response['result']['closed'], undefined, since, limit);

                                if (!(typeof symbol === 'undefined')) {
                                    _context16.next = 10;
                                    break;
                                }

                                return _context16.abrupt('return', orders);

                            case 10:
                                return _context16.abrupt('return', this.filterBySymbol(orders, symbol));

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchClosedOrders() {
                return _ref16.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchDepositMethods',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context17.next = 5;
                                return this.privatePostDepositMethods(this.extend({
                                    'asset': currency['id']
                                }, params));

                            case 5:
                                response = _context17.sent;
                                return _context17.abrupt('return', response['result']);

                            case 7:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function fetchDepositMethods(_x55) {
                return _ref17.apply(this, arguments);
            }

            return fetchDepositMethods;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, response, address;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                request = {
                                    'new': 'true'
                                };
                                _context18.next = 3;
                                return this.fetchDepositAddress(code, this.extend(request, params));

                            case 3:
                                response = _context18.sent;
                                address = this.safeString(response, 'address');

                                this.checkAddress(address);
                                return _context18.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 7:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function createDepositAddress(_x57) {
                return _ref18.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, method, request, response, result, numResults, address;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                // eslint-disable-next-line quotes

                                method = this.safeString(params, 'method');

                                if (!(typeof method === 'undefined')) {
                                    _context19.next = 14;
                                    break;
                                }

                                if (!this.options['cacheDepositMethodsOnFetchDepositAddress']) {
                                    _context19.next = 13;
                                    break;
                                }

                                if (code in this.options['depositMethods']) {
                                    _context19.next = 10;
                                    break;
                                }

                                _context19.next = 9;
                                return this.fetchDepositMethods(code);

                            case 9:
                                this.options['depositMethods'][code] = _context19.sent;

                            case 10:
                                method = this.options['depositMethods'][code][0]['method'];
                                _context19.next = 14;
                                break;

                            case 13:
                                throw new ExchangeError(this.id + ' fetchDepositAddress() requires an extra `method` parameter. Use fetchDepositMethods ("' + code + '") to get a list of available deposit methods or enable the exchange property .options["cacheDepositMethodsOnFetchDepositAddress"] = true');

                            case 14:
                                request = {
                                    'asset': currency['id'],
                                    'method': method
                                };
                                _context19.next = 17;
                                return this.privatePostDepositAddresses(this.extend(request, params));

                            case 17:
                                response = _context19.sent;
                                // overwrite methods
                                result = response['result'];
                                numResults = result.length;

                                if (!(numResults < 1)) {
                                    _context19.next = 22;
                                    break;
                                }

                                throw new InvalidAddress(this.id + ' privatePostDepositAddresses() returned no addresses');

                            case 22:
                                address = this.safeString(result[0], 'address');

                                this.checkAddress(address);
                                return _context19.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 25:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function fetchDepositAddress(_x59) {
                return _ref19.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                this.checkAddress(address);

                                if (!('key' in params)) {
                                    _context20.next = 8;
                                    break;
                                }

                                _context20.next = 4;
                                return this.loadMarkets();

                            case 4:
                                _context20.next = 6;
                                return this.privatePostWithdraw(this.extend({
                                    'asset': currency,
                                    'amount': amount
                                    // 'address': address, // they don't allow withdrawals to direct addresses
                                }, params));

                            case 6:
                                response = _context20.sent;
                                return _context20.abrupt('return', {
                                    'info': response,
                                    'id': response['result']
                                });

                            case 8:
                                throw new ExchangeError(this.id + " withdraw requires a 'key' parameter (withdrawal key name, as set up on your account)");

                            case 9:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function withdraw(_x61, _x62, _x63) {
                return _ref20.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = '/' + this.version + '/' + api + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                body = this.urlencode(this.extend({ 'nonce': nonce }, params));
                var auth = this.encode(nonce + body);
                var hash = this.hash(auth, 'sha256', 'binary');
                var binary = this.stringToBinary(this.encode(url));
                var binhash = this.binaryConcat(binary, hash);
                var secret = this.base64ToBinary(this.secret);
                var signature = this.hmac(binhash, secret, 'sha512', 'base64');
                headers = {
                    'API-Key': this.apiKey,
                    'API-Sign': this.decode(signature),
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            } else {
                url = '/' + path;
            }
            url = this.urls['api'][api] + url;
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body.indexOf('Invalid order') >= 0) throw new InvalidOrder(this.id + ' ' + body);
            if (body.indexOf('Invalid nonce') >= 0) throw new InvalidNonce(this.id + ' ' + body);
            if (body.indexOf('Insufficient funds') >= 0) throw new InsufficientFunds(this.id + ' ' + body);
            if (body.indexOf('Cancel pending') >= 0) throw new CancelPending(this.id + ' ' + body);
            if (body.indexOf('Invalid arguments:volume') >= 0) throw new InvalidOrder(this.id + ' ' + body);
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if (typeof response !== 'string') {
                    if ('error' in response) {
                        var numErrors = response['error'].length;
                        if (numErrors) {
                            var message = this.id + ' ' + this.json(response);
                            for (var i = 0; i < response['error'].length; i++) {
                                if (response['error'][i] in this.exceptions) {
                                    throw new this.exceptions[response['error'][i]](message);
                                }
                            }
                            throw new ExchangeError(message);
                        }
                    }
                }
            }
        }
    }]);

    return kraken;
}(Exchange);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InvalidNonce = _require.InvalidNonce,
    InvalidOrder = _require.InvalidOrder,
    AuthenticationError = _require.AuthenticationError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(kucoin, _Exchange);

    function kucoin() {
        _classCallCheck(this, kucoin);

        return _possibleConstructorReturn(this, (kucoin.__proto__ || Object.getPrototypeOf(kucoin)).apply(this, arguments));
    }

    _createClass(kucoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(kucoin.prototype.__proto__ || Object.getPrototypeOf(kucoin.prototype), 'describe', this).call(this), {
                'id': 'kucoin',
                'name': 'Kucoin',
                'countries': 'HK', // Hong Kong
                'version': 'v1',
                'rateLimit': 2000,
                'userAgent': this.userAgents['chrome'],
                'has': {
                    'CORS': false,
                    'cancelOrders': true,
                    'createMarketOrder': false,
                    'fetchDepositAddress': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true, // see the method implementation below
                    'fetchOrder': true,
                    'fetchOrders': false,
                    'fetchClosedOrders': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': 'emulated', // this method is to be deleted, see implementation and comments below
                    'fetchCurrencies': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': 1,
                    '5m': 5,
                    '15m': 15,
                    '30m': 30,
                    '1h': 60,
                    '8h': 480,
                    '1d': 'D',
                    '1w': 'W'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/33795655-b3c46e48-dcf6-11e7-8abe-dc4588ba7901.jpg',
                    'api': {
                        'public': 'https://api.kucoin.com',
                        'private': 'https://api.kucoin.com',
                        'kitchen': 'https://kitchen.kucoin.com',
                        'kitchen-2': 'https://kitchen-2.kucoin.com'
                    },
                    'www': 'https://www.kucoin.com/?r=E5wkqe',
                    'doc': 'https://kucoinapidocs.docs.apiary.io',
                    'fees': 'https://news.kucoin.com/en/fee'
                },
                'api': {
                    'kitchen': {
                        'get': ['open/chart/history']
                    },
                    'public': {
                        'get': ['open/chart/config', 'open/chart/history', 'open/chart/symbol', 'open/currencies', 'open/deal-orders', 'open/kline', 'open/lang-list', 'open/orders', 'open/orders-buy', 'open/orders-sell', 'open/tick', 'market/open/coin-info', 'market/open/coins', 'market/open/coins-trending', 'market/open/symbols']
                    },
                    'private': {
                        'get': ['account/balance', 'account/{coin}/wallet/address', 'account/{coin}/wallet/records', 'account/{coin}/balance', 'account/promotion/info', 'account/promotion/sum', 'deal-orders', 'order/active', 'order/active-map', 'order/dealt', 'order/detail', 'referrer/descendant/count', 'user/info'],
                        'post': ['account/{coin}/withdraw/apply', 'account/{coin}/withdraw/cancel', 'account/promotion/draw', 'cancel-order', 'order', 'order/cancel-all', 'user/change-lang']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.001,
                        'taker': 0.001
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'KCS': 2.0,
                            'BTC': 0.0005,
                            'USDT': 10.0,
                            'ETH': 0.01,
                            'LTC': 0.001,
                            'NEO': 0.0,
                            'GAS': 0.0,
                            'KNC': 0.5,
                            'BTM': 5.0,
                            'QTUM': 0.1,
                            'EOS': 0.5,
                            'CVC': 3.0,
                            'OMG': 0.1,
                            'PAY': 0.5,
                            'SNT': 20.0,
                            'BHC': 1.0,
                            'HSR': 0.01,
                            'WTC': 0.1,
                            'VEN': 2.0,
                            'MTH': 10.0,
                            'RPX': 1.0,
                            'REQ': 20.0,
                            'EVX': 0.5,
                            'MOD': 0.5,
                            'NEBL': 0.1,
                            'DGB': 0.5,
                            'CAG': 2.0,
                            'CFD': 0.5,
                            'RDN': 0.5,
                            'UKG': 5.0,
                            'BCPT': 5.0,
                            'PPT': 0.1,
                            'BCH': 0.0005,
                            'STX': 2.0,
                            'NULS': 1.0,
                            'GVT': 0.1,
                            'HST': 2.0,
                            'PURA': 0.5,
                            'SUB': 2.0,
                            'QSP': 5.0,
                            'POWR': 1.0,
                            'FLIXX': 10.0,
                            'LEND': 20.0,
                            'AMB': 3.0,
                            'RHOC': 2.0,
                            'R': 2.0,
                            'DENT': 50.0,
                            'DRGN': 1.0,
                            'ACT': 0.1
                        },
                        'deposit': {}
                    }
                },
                // exchange-specific options
                'options': {
                    'timeDifference': 0, // the difference between system clock and Kucoin clock
                    'adjustForTimeDifference': false // controls the adjustment logic upon instantiation
                }
            });
        }
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds() - this.options['timeDifference'];
        }
    }, {
        key: 'loadTimeDifference',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, after;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetOpenTick();

                            case 2:
                                response = _context.sent;
                                after = this.milliseconds();

                                this.options['timeDifference'] = parseInt(after - response['timestamp']);
                                return _context.abrupt('return', this.options['timeDifference']);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function loadTimeDifference() {
                return _ref.apply(this, arguments);
            }

            return loadTimeDifference;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var response, markets, result, i, market, id, base, quote, symbol, precision, active;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetMarketOpenSymbols();

                            case 2:
                                response = _context2.sent;

                                if (!this.options['adjustForTimeDifference']) {
                                    _context2.next = 6;
                                    break;
                                }

                                _context2.next = 6;
                                return this.loadTimeDifference();

                            case 6:
                                markets = response['data'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['symbol'];
                                    base = market['coinType'];
                                    quote = market['coinTypePair'];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    active = market['trading'];

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': active,
                                        'taker': this.safeFloat(market, 'feeRate'),
                                        'maker': this.safeFloat(market, 'feeRate'),
                                        'info': market,
                                        'lot': Math.pow(10, -precision['amount']),
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision['amount']),
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        }
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, data, address, tag;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context3.next = 5;
                                return this.privateGetAccountCoinWalletAddress(this.extend({
                                    'coin': currency['id']
                                }, params));

                            case 5:
                                response = _context3.sent;
                                data = response['data'];
                                address = this.safeString(data, 'address');

                                this.checkAddress(address);
                                tag = this.safeString(data, 'userOid');
                                return _context3.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 11:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchDepositAddress(_x) {
                return _ref3.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, code, precision, deposit, withdraw, active;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.publicGetMarketOpenCoins(params);

                            case 2:
                                response = _context4.sent;
                                currencies = response['data'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['coin'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    code = this.commonCurrencyCode(id);
                                    precision = currency['tradePrecision'];
                                    deposit = currency['enableDeposit'];
                                    withdraw = currency['enableWithdraw'];
                                    active = deposit && withdraw;

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': 'ok',
                                        'fee': currency['withdrawMinFee'], // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['withdrawMinAmount'],
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context4.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchCurrencies() {
                return _ref4.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, indexed, keys, i, id, currency, account, balance, used, free, total;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privateGetAccountBalance(this.extend({
                                    'limit': 20, // default 12, max 20
                                    'page': 1
                                }, params));

                            case 4:
                                response = _context5.sent;
                                balances = response['data'];
                                result = { 'info': balances };
                                indexed = this.indexBy(balances, 'coinType');
                                keys = Object.keys(indexed);

                                for (i = 0; i < keys.length; i++) {
                                    id = keys[i];
                                    currency = this.commonCurrencyCode(id);
                                    account = this.account();
                                    balance = indexed[id];
                                    used = parseFloat(balance['freezeBalance']);
                                    free = parseFloat(balance['balance']);
                                    total = this.sum(free, used);

                                    account['free'] = free;
                                    account['used'] = used;
                                    account['total'] = total;
                                    result[currency] = account;
                                }
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response, orderbook;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetOpenOrders(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                orderbook = response['data'];
                                return _context6.abrupt('return', this.parseOrderBook(orderbook, undefined, 'BUY', 'SELL'));

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOrderBook(_x5) {
                return _ref6.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = this.safeValue(order, 'direction');
            if (typeof side === 'undefined') side = order['type'];
            if (typeof side !== 'undefined') side = side.toLowerCase();
            var orderId = this.safeString(order, 'orderOid');
            if (typeof orderId === 'undefined') orderId = this.safeString(order, 'oid');
            // do not confuse trades with orders
            var trades = undefined;
            if ('dealOrders' in order) trades = this.safeValue(order['dealOrders'], 'datas');
            if (typeof trades !== 'undefined') {
                trades = this.parseTrades(trades, market);
                for (var i = 0; i < trades.length; i++) {
                    trades[i]['side'] = side;
                    trades[i]['order'] = orderId;
                }
            }
            var symbol = undefined;
            if (typeof market !== 'undefined') {
                symbol = market['symbol'];
            } else {
                symbol = order['coinType'] + '/' + order['coinTypePair'];
            }
            var timestamp = this.safeValue(order, 'createdAt');
            var remaining = this.safeFloat(order, 'pendingAmount');
            var status = this.safeValue(order, 'status');
            var filled = this.safeFloat(order, 'dealAmount');
            var amount = this.safeFloat(order, 'amount');
            var cost = this.safeFloat(order, 'dealValue');
            if (typeof cost === 'undefined') cost = this.safeFloat(order, 'dealValueTotal');
            if (typeof status === 'undefined') {
                if (typeof remaining !== 'undefined') if (remaining > 0) status = 'open';else status = 'closed';
            }
            if (typeof filled === 'undefined') {
                if (typeof status !== 'undefined') if (status === 'closed') filled = this.safeFloat(order, 'amount');
            } else if (filled === 0.0) {
                if (typeof trades !== 'undefined') {
                    cost = 0;
                    for (var _i = 0; _i < trades.length; _i++) {
                        filled += trades[_i]['amount'];
                        cost += trades[_i]['cost'];
                    }
                }
            }
            // kucoin price and amount fields have varying names
            // thus the convoluted spaghetti code below
            var price = undefined;
            if (typeof filled !== 'undefined') {
                // if the order was filled at least for some part
                if (filled > 0.0) {
                    price = this.safeFloat(order, 'price');
                    if (typeof price === 'undefined') price = this.safeFloat(order, 'dealPrice');
                    if (typeof price === 'undefined') price = this.safeFloat(order, 'dealPriceAverage');
                } else {
                    // it's an open order, not filled yet, use the initial price
                    price = this.safeFloat(order, 'orderPrice');
                    if (typeof price === 'undefined') price = this.safeFloat(order, 'price');
                }
                if (typeof price !== 'undefined') {
                    if (typeof cost === 'undefined') cost = price * filled;
                }
                if (typeof amount === 'undefined') {
                    if (typeof remaining !== 'undefined') amount = this.sum(filled, remaining);
                } else if (typeof remaining === 'undefined') {
                    remaining = amount - filled;
                }
            }
            if (status === 'open') {
                if (typeof cost === 'undefined' || cost === 0.0) if (typeof price !== 'undefined') if (typeof amount !== 'undefined') cost = amount * price;
            }
            var feeCurrency = undefined;
            if (typeof market !== 'undefined') {
                feeCurrency = side === 'sell' ? market['quote'] : market['base'];
            } else {
                var feeCurrencyField = side === 'sell' ? 'coinTypePair' : 'coinType';
                var _feeCurrency = this.safeString(order, feeCurrencyField);
                if (typeof _feeCurrency !== 'undefined') {
                    if (_feeCurrency in this.currencies_by_id) _feeCurrency = this.currencies_by_id[_feeCurrency]['code'];
                }
            }
            var feeCost = this.safeFloat(order, 'fee');
            var fee = {
                'cost': this.safeFloat(order, 'feeTotal', feeCost),
                'rate': this.safeFloat(order, 'feeRate'),
                'currency': feeCurrency
            };
            var result = {
                'info': order,
                'id': orderId,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'amount': amount,
                'cost': cost,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': fee,
                'trades': trades
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderType, market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a symbol argument');

                            case 2:
                                orderType = this.safeValue(params, 'type');

                                if (!(typeof orderType === 'undefined')) {
                                    _context7.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOrder requires a type parameter ("BUY" or "SELL")');

                            case 5:
                                _context7.next = 7;
                                return this.loadMarkets();

                            case 7:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'type': orderType,
                                    'orderOid': id
                                };
                                _context7.next = 11;
                                return this.privateGetOrderDetail(this.extend(request, params));

                            case 11:
                                response = _context7.sent;

                                if (response['data']) {
                                    _context7.next = 14;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' ' + this.json(response));

                            case 14:
                                return _context7.abrupt('return', this.parseOrder(response['data'], market));

                            case 15:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOrder(_x9) {
                return _ref7.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'parseOrdersByStatus',
        value: function parseOrdersByStatus(orders, market, since, limit, status) {
            var result = [];
            for (var i = 0; i < orders.length; i++) {
                var order = this.parseOrder(this.extend(orders[i], {
                    'status': status
                }), market);
                result.push(order);
            }
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            return this.filterBySymbolSinceLimit(result, symbol, since, limit);
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, sell, buy, orders;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (symbol) {
                                    _context8.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOpenOrders requires a symbol');

                            case 2:
                                _context8.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };
                                _context8.next = 8;
                                return this.privateGetOrderActiveMap(this.extend(request, params));

                            case 8:
                                response = _context8.sent;
                                sell = this.safeValue(response['data'], 'SELL');

                                if (typeof sell === 'undefined') sell = [];
                                buy = this.safeValue(response['data'], 'BUY');

                                if (typeof buy === 'undefined') buy = [];
                                orders = this.arrayConcat(sell, buy);
                                //
                                // the caching part to be removed
                                //
                                //     for (let i = 0; i < orders.length; i++) {
                                //         let order = this.parseOrder (this.extend (orders[i], {
                                //             'status': 'open',
                                //         }), market);
                                //         let orderId = order['id'];
                                //         if (orderId in this.orders)
                                //             if (this.orders[orderId]['status'] !== 'open')
                                //                 order['status'] = this.orders[orderId]['status'];
                                //         this.orders[order['id']] = order;
                                //     }
                                //     let openOrders = this.filterBy (this.orders, 'status', 'open');
                                //     return this.filterBySymbolSinceLimit (openOrders, symbol, since, limit);
                                //

                                return _context8.abrupt('return', this.parseOrdersByStatus(orders, market, since, limit, 'open'));

                            case 15:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOpenOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var request, market, response, orders;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                request = {};
                                _context9.next = 3;
                                return this.loadMarkets();

                            case 3:
                                market = undefined;

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['symbol'] = market['id'];
                                }
                                if (typeof since !== 'undefined') request['since'] = since;
                                if (typeof limit !== 'undefined') request['limit'] = limit;
                                _context9.next = 9;
                                return this.privateGetOrderDealt(this.extend(request, params));

                            case 9:
                                response = _context9.sent;
                                orders = response['data']['datas'];
                                //
                                // the caching part to be removed
                                //
                                //     for (let i = 0; i < orders.length; i++) {
                                //         let order = this.parseOrder (this.extend (orders[i], {
                                //             'status': 'closed',
                                //         }), market);
                                //         let orderId = order['id'];
                                //         if (orderId in this.orders)
                                //             if (this.orders[orderId]['status'] === 'canceled')
                                //                 order['status'] = this.orders[orderId]['status'];
                                //         this.orders[order['id']] = order;
                                //     }
                                //     let closedOrders = this.filterBy (this.orders, 'status', 'closed');
                                //     return this.filterBySymbolSinceLimit (closedOrders, symbol, since, limit);
                                //

                                return _context9.abrupt('return', this.parseOrdersByStatus(orders, market, since, limit, 'closed'));

                            case 12:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchClosedOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, quote, base, request, cost, response, orderId, timestamp, iso8601, order;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                if (!(type !== 'limit')) {
                                    _context10.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context10.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                quote = market['quote'];
                                base = market['base'];
                                request = {
                                    'symbol': market['id'],
                                    'type': side.toUpperCase(),
                                    'price': this.truncate(price, this.currencies[quote]['precision']),
                                    'amount': this.truncate(amount, this.currencies[base]['precision'])
                                };

                                price = parseFloat(price);
                                amount = parseFloat(amount);
                                cost = price * amount;
                                _context10.next = 13;
                                return this.privatePostOrder(this.extend(request, params));

                            case 13:
                                response = _context10.sent;
                                orderId = this.safeString(response['data'], 'orderOid');
                                timestamp = this.safeInteger(response, 'timestamp');
                                iso8601 = undefined;

                                if (typeof timestamp !== 'undefined') iso8601 = this.iso8601(timestamp);
                                order = {
                                    'info': response,
                                    'id': orderId,
                                    'timestamp': timestamp,
                                    'datetime': iso8601,
                                    'lastTradeTimestamp': undefined,
                                    'symbol': market['symbol'],
                                    'type': type,
                                    'side': side,
                                    'amount': amount,
                                    'filled': undefined,
                                    'remaining': undefined,
                                    'price': price,
                                    'cost': cost,
                                    'status': 'open',
                                    'fee': undefined,
                                    'trades': undefined
                                };

                                this.orders[orderId] = order;
                                return _context10.abrupt('return', order);

                            case 21:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createOrder(_x20, _x21, _x22, _x23) {
                return _ref10.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, market;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                // https://kucoinapidocs.docs.apiary.io/#reference/0/trading/cancel-all-orders
                                // docs say symbol is required, but it seems to be optional
                                // you can cancel all orders, or filter by symbol or type or both
                                request = {};

                                if (!symbol) {
                                    _context11.next = 6;
                                    break;
                                }

                                _context11.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);

                                request['symbol'] = market['id'];

                            case 6:
                                if ('type' in params) {
                                    request['type'] = params['type'].toUpperCase();
                                    params = this.omit(params, 'type');
                                }
                                //
                                // the caching part to be removed
                                //
                                //     let response = await this.privatePostOrderCancelAll (this.extend (request, params));
                                //     let openOrders = this.filterBy (this.orders, 'status', 'open');
                                //     for (let i = 0; i < openOrders.length; i++) {
                                //         let order = openOrders[i];
                                //         let orderId = order['id'];
                                //         this.orders[orderId]['status'] = 'canceled';
                                //     }
                                //     return response;
                                //
                                _context11.next = 9;
                                return this.privatePostOrderCancelAll(this.extend(request, params));

                            case 9:
                                return _context11.abrupt('return', _context11.sent);

                            case 10:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function cancelOrders() {
                return _ref11.apply(this, arguments);
            }

            return cancelOrders;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                if (!(typeof symbol === 'undefined')) {
                                    _context12.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a symbol');

                            case 2:
                                _context12.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'orderOid': id
                                };

                                if (!('type' in params)) {
                                    _context12.next = 11;
                                    break;
                                }

                                request['type'] = params['type'].toUpperCase();
                                params = this.omit(params, 'type');
                                _context12.next = 12;
                                break;

                            case 11:
                                throw new ExchangeError(this.id + ' cancelOrder requires parameter type=["BUY"|"SELL"]');

                            case 12:
                                _context12.next = 14;
                                return this.privatePostCancelOrder(this.extend(request, params));

                            case 14:
                                return _context12.abrupt('return', _context12.sent);

                            case 15:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function cancelOrder(_x28) {
                return _ref12.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['datetime'];
            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                symbol = ticker['coinType'] + '/' + ticker['coinTypePair'];
            }
            // TNC coin doesn't have changerate for some reason
            var change = this.safeFloat(ticker, 'change');
            var last = this.safeFloat(ticker, 'lastDealPrice');
            var open = undefined;
            if (typeof last !== 'undefined') if (typeof change !== 'undefined') open = last - change;
            var changePercentage = this.safeFloat(ticker, 'changeRate');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': open,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': changePercentage,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'volValue'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, result, t, ticker, symbol;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.publicGetMarketOpenSymbols(params);

                            case 2:
                                response = _context13.sent;
                                tickers = response['data'];
                                result = {};

                                for (t = 0; t < tickers.length; t++) {
                                    ticker = this.parseTicker(tickers[t]);
                                    symbol = ticker['symbol'];

                                    result[symbol] = ticker;
                                }
                                return _context13.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchTickers() {
                return _ref13.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context14.next = 5;
                                return this.publicGetOpenTick(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context14.sent;
                                ticker = response['data'];
                                return _context14.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchTicker(_x34) {
                return _ref14.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var id = undefined;
            var order = undefined;
            var info = trade;
            var timestamp = undefined;
            var type = undefined;
            var side = undefined;
            var price = undefined;
            var cost = undefined;
            var amount = undefined;
            var fee = undefined;
            if (Array.isArray(trade)) {
                timestamp = trade[0];
                type = 'limit';
                if (trade[1] === 'BUY') {
                    side = 'buy';
                } else if (trade[1] === 'SELL') {
                    side = 'sell';
                }
                price = trade[2];
                amount = trade[3];
            } else {
                timestamp = this.safeValue(trade, 'createdAt');
                order = this.safeString(trade, 'orderOid');
                id = this.safeString(trade, 'oid');
                side = this.safeString(trade, 'direction');
                if (typeof side !== 'undefined') side = side.toLowerCase();
                price = this.safeFloat(trade, 'dealPrice');
                amount = this.safeFloat(trade, 'amount');
                cost = this.safeFloat(trade, 'dealValue');
                var feeCurrency = undefined;
                if (typeof market !== 'undefined') {
                    feeCurrency = side === 'sell' ? market['quote'] : market['base'];
                } else {
                    var feeCurrencyField = side === 'sell' ? 'coinTypePair' : 'coinType';
                    var _feeCurrency2 = this.safeString(order, feeCurrencyField);
                    if (typeof _feeCurrency2 !== 'undefined') {
                        if (_feeCurrency2 in this.currencies_by_id) _feeCurrency2 = this.currencies_by_id[_feeCurrency2]['code'];
                    }
                }
                fee = {
                    'cost': this.safeFloat(trade, 'fee'),
                    'currency': feeCurrency
                };
            }
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            return {
                'id': id,
                'order': order,
                'info': info,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context15.next = 5;
                                return this.publicGetOpenDealOrders(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context15.sent;
                                return _context15.abrupt('return', this.parseTrades(response['data'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchTrades(_x37) {
                return _ref15.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                if (symbol) {
                                    _context16.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchMyTrades is deprecated and requires a symbol argument');

                            case 2:
                                _context16.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id']
                                };

                                if (limit) request['limit'] = limit;
                                _context16.next = 9;
                                return this.privateGetDealOrders(this.extend(request, params));

                            case 9:
                                response = _context16.sent;
                                return _context16.abrupt('return', this.parseTrades(response['data']['datas'], market, since, limit));

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function fetchMyTrades() {
                return _ref16.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'parseTradingViewOHLCV',
        value: function parseTradingViewOHLCV(ohlcvs) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            var result = this.convertTradingViewToOHLCV(ohlcvs);
            return this.parseOHLCVs(result, market, timeframe, since, limit);
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, end, resolution, minutes, start, request, response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                end = this.seconds();
                                resolution = this.timeframes[timeframe];
                                // convert 'resolution' to minutes in order to calculate 'from' later

                                minutes = resolution;

                                if (minutes === 'D') {
                                    if (typeof limit === 'undefined') limit = 30; // 30 days, 1 month
                                    minutes = 1440;
                                } else if (minutes === 'W') {
                                    if (typeof limit === 'undefined') limit = 52; // 52 weeks, 1 year
                                    minutes = 10080;
                                } else if (typeof limit === 'undefined') {
                                    // last 1440 periods, whatever the duration of the period is
                                    // for 1m it equals 1 day (24 hours)
                                    // for 5m it equals 5 days
                                    // ...
                                    limit = 1440;
                                }
                                start = end - limit * minutes * 60;
                                // if 'since' has been supplied by user

                                if (typeof since !== 'undefined') {
                                    start = parseInt(since / 1000); // convert milliseconds to seconds
                                    end = Math.min(end, this.sum(start, limit * minutes * 60));
                                }
                                request = {
                                    'symbol': market['id'],
                                    'resolution': resolution,
                                    'from': start,
                                    'to': end
                                };
                                _context17.next = 12;
                                return this.publicGetOpenChartHistory(this.extend(request, params));

                            case 12:
                                response = _context17.sent;
                                return _context17.abrupt('return', this.parseTradingViewOHLCV(response, market, timeframe, since, limit));

                            case 14:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this);
            }));

            function fetchOHLCV(_x49) {
                return _ref17.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                this.checkAddress(address);
                                _context18.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);

                                this.checkAddress(address);
                                _context18.next = 7;
                                return this.privatePostAccountCoinWithdrawApply(this.extend({
                                    'coin': currency['id'],
                                    'amount': amount,
                                    'address': address
                                }, params));

                            case 7:
                                response = _context18.sent;
                                return _context18.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 9:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function withdraw(_x54, _x55, _x56) {
                return _ref18.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var endpoint = '/' + this.version + '/' + this.implodeParams(path, params);
            var url = this.urls['api'][api] + endpoint;
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                // their nonce is always a calibrated synched milliseconds-timestamp
                var nonce = this.nonce();
                var queryString = '';
                nonce = nonce.toString();
                if (Object.keys(query).length) {
                    queryString = this.rawencode(this.keysort(query));
                    url += '?' + queryString;
                    if (method !== 'GET') {
                        body = queryString;
                    }
                }
                var auth = endpoint + '/' + nonce + '/' + queryString;
                var payload = this.stringToBase64(this.encode(auth));
                // payload should be "encoded" as returned from stringToBase64
                var signature = this.hmac(payload, this.encode(this.secret), 'sha256');
                headers = {
                    'KC-API-KEY': this.apiKey,
                    'KC-API-NONCE': nonce,
                    'KC-API-SIGNATURE': signature
                };
            } else {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'throwExceptionOnError',
        value: function throwExceptionOnError(response) {
            //
            // API endpoints return the following formats
            //     { success: false, code: "ERROR", msg: "Min price:100.0" }
            //     { success: true,  code: "OK",    msg: "Operation succeeded." }
            //
            // Web OHLCV endpoint returns this:
            //     { s: "ok", o: [], h: [], l: [], c: [], v: [] }
            //
            // This particular method handles API responses only
            //
            if (!('success' in response)) return;
            if (response['success'] === true) return; // not an error
            if (!('code' in response) || !('msg' in response)) throw new ExchangeError(this.id + ': malformed response: ' + this.json(response));
            var code = this.safeString(response, 'code');
            var message = this.safeString(response, 'msg');
            var feedback = this.id + ' ' + this.json(response);
            if (code === 'UNAUTH') {
                if (message === 'Invalid nonce') throw new InvalidNonce(feedback);
                throw new AuthenticationError(feedback);
            } else if (code === 'ERROR') {
                if (message.indexOf('The precision of amount') >= 0) throw new InvalidOrder(feedback); // amount violates precision.amount
                if (message.indexOf('Min amount each order') >= 0) throw new InvalidOrder(feedback); // amount < limits.amount.min
                if (message.indexOf('Min price:') >= 0) throw new InvalidOrder(feedback); // price < limits.price.min
                if (message.indexOf('Max price:') >= 0) throw new InvalidOrder(feedback); // price > limits.price.max
                if (message.indexOf('The precision of price') >= 0) throw new InvalidOrder(feedback); // price violates precision.price
            } else if (code === 'NO_BALANCE') {
                if (message.indexOf('Insufficient balance') >= 0) throw new InsufficientFunds(feedback);
            }
            throw new ExchangeError(this.id + ': unknown response: ' + this.json(response));
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            var response = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;

            if (typeof response !== 'undefined') {
                // JS callchain parses body beforehand
                this.throwExceptionOnError(response);
            } else if (body && body[0] === '{') {
                // Python/PHP callchains don't have json available at this step
                this.throwExceptionOnError(JSON.parse(body));
            }
        }
    }]);

    return kucoin;
}(Exchange);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var acx = __webpack_require__(17);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

// ---------------------------------------------------------------------------

module.exports = function (_acx) {
    _inherits(kuna, _acx);

    function kuna() {
        _classCallCheck(this, kuna);

        return _possibleConstructorReturn(this, (kuna.__proto__ || Object.getPrototypeOf(kuna)).apply(this, arguments));
    }

    _createClass(kuna, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(kuna.prototype.__proto__ || Object.getPrototypeOf(kuna.prototype), 'describe', this).call(this), {
                'id': 'kuna',
                'name': 'Kuna',
                'countries': 'UA',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOpenOrders': true,
                    'fetchMyTrades': true,
                    'withdraw': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/31697638-912824fa-b3c1-11e7-8c36-cf9606eb94ac.jpg',
                    'api': 'https://kuna.io',
                    'www': 'https://kuna.io',
                    'doc': 'https://kuna.io/documents/api',
                    'fees': 'https://kuna.io/documents/api'
                },
                'fees': {
                    'trading': {
                        'taker': 0.25 / 100,
                        'maker': 0.25 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'UAH': '1%',
                            'BTC': 0.001,
                            'BCH': 0.001,
                            'ETH': 0.01,
                            'WAVES': 0.01,
                            'GOL': 0.0,
                            'GBG': 0.0
                            // 'RMC': 0.001 BTC
                            // 'ARN': 0.01 ETH
                            // 'R': 0.01 ETH
                            // 'EVR': 0.01 ETH
                        },
                        'deposit': {
                            // 'UAH': (amount) => amount * 0.001 + 5
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var predefinedMarkets, markets, tickers, i, market, marketsById, ids, _i, id, baseId, baseIdLength, quoteId, base, quote, symbol;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                predefinedMarkets = [{ 'id': 'btcuah', 'symbol': 'BTC/UAH', 'base': 'BTC', 'quote': 'UAH', 'baseId': 'btc', 'quoteId': 'uah', 'precision': { 'amount': 6, 'price': 0 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 1, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'ethuah', 'symbol': 'ETH/UAH', 'base': 'ETH', 'quote': 'UAH', 'baseId': 'eth', 'quoteId': 'uah', 'precision': { 'amount': 6, 'price': 0 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 1, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'gbguah', 'symbol': 'GBG/UAH', 'base': 'GBG', 'quote': 'UAH', 'baseId': 'gbg', 'quoteId': 'uah', 'precision': { 'amount': 3, 'price': 2 }, 'lot': 0.001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 0.01, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, // Golos Gold (GBG != GOLOS)
                                { 'id': 'kunbtc', 'symbol': 'KUN/BTC', 'base': 'KUN', 'quote': 'BTC', 'baseId': 'kun', 'quoteId': 'btc', 'precision': { 'amount': 6, 'price': 6 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 0.000001, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'bchbtc', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'baseId': 'bch', 'quoteId': 'btc', 'precision': { 'amount': 6, 'price': 6 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 0.000001, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'bchuah', 'symbol': 'BCH/UAH', 'base': 'BCH', 'quote': 'UAH', 'baseId': 'bch', 'quoteId': 'uah', 'precision': { 'amount': 6, 'price': 0 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 1, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'wavesuah', 'symbol': 'WAVES/UAH', 'base': 'WAVES', 'quote': 'UAH', 'baseId': 'waves', 'quoteId': 'uah', 'precision': { 'amount': 6, 'price': 0 }, 'lot': 0.000001, 'limits': { 'amount': { 'min': 0.000001, 'max': undefined }, 'price': { 'min': 1, 'max': undefined }, 'cost': { 'min': 0.000001, 'max': undefined } } }, { 'id': 'arnbtc', 'symbol': 'ARN/BTC', 'base': 'ARN', 'quote': 'BTC', 'baseId': 'arn', 'quoteId': 'btc' }, { 'id': 'b2bbtc', 'symbol': 'B2B/BTC', 'base': 'B2B', 'quote': 'BTC', 'baseId': 'b2b', 'quoteId': 'btc' }, { 'id': 'evrbtc', 'symbol': 'EVR/BTC', 'base': 'EVR', 'quote': 'BTC', 'baseId': 'evr', 'quoteId': 'btc' }, { 'id': 'golgbg', 'symbol': 'GOL/GBG', 'base': 'GOL', 'quote': 'GBG', 'baseId': 'gol', 'quoteId': 'gbg' }, { 'id': 'rbtc', 'symbol': 'R/BTC', 'base': 'R', 'quote': 'BTC', 'baseId': 'r', 'quoteId': 'btc' }, { 'id': 'rmcbtc', 'symbol': 'RMC/BTC', 'base': 'RMC', 'quote': 'BTC', 'baseId': 'rmc', 'quoteId': 'btc' }];
                                markets = [];
                                _context.next = 4;
                                return this.publicGetTickers();

                            case 4:
                                tickers = _context.sent;

                                for (i = 0; i < predefinedMarkets.length; i++) {
                                    market = predefinedMarkets[i];

                                    if (market['id'] in tickers) markets.push(market);
                                }
                                marketsById = this.indexBy(markets, 'id');
                                ids = Object.keys(tickers);

                                for (_i = 0; _i < ids.length; _i++) {
                                    id = ids[_i];

                                    if (!(id in marketsById)) {
                                        baseId = id.replace('btc', '');

                                        baseId = baseId.replace('uah', '');
                                        baseId = baseId.replace('gbg', '');
                                        if (baseId.length > 0) {
                                            baseIdLength = baseId.length - 0; // a transpiler workaround

                                            quoteId = id.slice(baseIdLength);
                                            base = baseId.toUpperCase();
                                            quote = quoteId.toUpperCase();

                                            base = this.commonCurrencyCode(base);
                                            quote = this.commonCurrencyCode(quote);
                                            symbol = base + '/' + quote;

                                            markets.push({
                                                'id': id,
                                                'symbol': symbol,
                                                'base': base,
                                                'quote': quote,
                                                'baseId': baseId,
                                                'quoteId': quoteId
                                            });
                                        }
                                    }
                                }
                                return _context.abrupt('return', markets);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderBook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetOrderBook(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                orderBook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderBook, undefined, 'bids', 'asks', 'price', 'remaining_volume'));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchL3OrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                return _context3.abrupt('return', this.fetchOrderBook(symbol, limit, params));

                            case 1:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchL3OrderBook(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchL3OrderBook;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, orders;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (symbol) {
                                    _context4.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOpenOrders requires a symbol argument');

                            case 2:
                                _context4.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context4.next = 7;
                                return this.privateGetOrders(this.extend({
                                    'market': market['id']
                                }, params));

                            case 7:
                                orders = _context4.sent;
                                return _context4.abrupt('return', this.parseOrders(orders, market, since, limit));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOpenOrders() {
                return _ref4.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['created_at']);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var side = this.safeString(trade, 'side');
            var sideMap = {
                'ask': 'sell',
                'bid': 'buy'
            };
            side = sideMap[side];
            var cost = this.safeFloat(trade, 'funds');
            var order = this.safeString(trade, 'order_id');
            return {
                'id': trade['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'volume'),
                'cost': cost,
                'order': order,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTrades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (symbol) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchOpenOrders requires a symbol argument');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context6.next = 7;
                                return this.privateGetTradesMy({ 'market': market['id'] });

                            case 7:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchMyTrades() {
                return _ref6.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }]);

    return kuna;
}(acx);

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(lakebtc, _Exchange);

    function lakebtc() {
        _classCallCheck(this, lakebtc);

        return _possibleConstructorReturn(this, (lakebtc.__proto__ || Object.getPrototypeOf(lakebtc)).apply(this, arguments));
    }

    _createClass(lakebtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(lakebtc.prototype.__proto__ || Object.getPrototypeOf(lakebtc.prototype), 'describe', this).call(this), {
                'id': 'lakebtc',
                'name': 'LakeBTC',
                'countries': 'US',
                'version': 'api_v2',
                'has': {
                    'CORS': true,
                    'createMarketOrder': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28074120-72b7c38a-6660-11e7-92d9-d9027502281d.jpg',
                    'api': 'https://api.lakebtc.com',
                    'www': 'https://www.lakebtc.com',
                    'doc': ['https://www.lakebtc.com/s/api_v2', 'https://www.lakebtc.com/s/api']
                },
                'api': {
                    'public': {
                        'get': ['bcorderbook', 'bctrades', 'ticker']
                    },
                    'private': {
                        'post': ['buyOrder', 'cancelOrders', 'getAccountInfo', 'getExternalAccounts', 'getOrders', 'getTrades', 'openOrders', 'sellOrder']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.15 / 100,
                        'taker': 0.2 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, keys, k, id, market, baseId, quoteId, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTicker();

                            case 2:
                                markets = _context.sent;
                                result = [];
                                keys = Object.keys(markets);

                                for (k = 0; k < keys.length; k++) {
                                    id = keys[k];
                                    market = markets[id];
                                    baseId = id.slice(0, 3);
                                    quoteId = id.slice(3, 6);
                                    base = baseId.toUpperCase();
                                    quote = quoteId.toUpperCase();
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, ids, i, id, code, currency, balance, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetAccountInfo();

                            case 4:
                                response = _context2.sent;
                                balances = response['balance'];
                                result = { 'info': response };
                                ids = Object.keys(balances);

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    code = id;

                                    if (id in this.currencies_by_id) {
                                        currency = this.currencies_by_id[id];

                                        code = currency['code'];
                                    }
                                    balance = parseFloat(balances[id]);
                                    account = {
                                        'free': balance,
                                        'used': 0.0,
                                        'total': balance
                                    };

                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetBcorderbook(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, symbol, ticker, market;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context4.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    symbol = ids[i];
                                    ticker = tickers[symbol];
                                    market = undefined;

                                    if (symbol in this.markets_by_id) {
                                        market = this.markets_by_id[symbol];
                                        symbol = market['symbol'];
                                    }
                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, tickers;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTicker(params);

                            case 5:
                                tickers = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(tickers[market['id']], market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': trade['tid'].toString(),
                'order': undefined,
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetBctrades(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, market, order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(type === 'market')) {
                                    _context7.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 4:
                                method = 'privatePost' + this.capitalize(side) + 'Order';
                                market = this.market(symbol);
                                order = {
                                    'params': [price, amount, market['id']]
                                };
                                _context7.next = 9;
                                return this[method](this.extend(order, params));

                            case 9:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['id'].toString()
                                });

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privatePostCancelOrder({ 'params': id });

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x20) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.microseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version;
            if (api === 'public') {
                url += '/' + path;
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                if (Object.keys(params).length) params = params.join(',');else params = '';
                var query = this.urlencode({
                    'tonce': nonce,
                    'accesskey': this.apiKey,
                    'requestmethod': method.toLowerCase(),
                    'id': nonce,
                    'method': path,
                    'params': params
                });
                body = this.json({
                    'method': path,
                    'params': params,
                    'id': nonce
                });
                var signature = this.hmac(this.encode(query), this.encode(this.secret), 'sha1');
                var auth = this.encode(this.apiKey + ':' + signature);
                headers = {
                    'Json-Rpc-Tonce': nonce.toString(),
                    'Authorization': 'Basic ' + this.decode(this.stringToBase64(auth)),
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context9.sent;

                                if (!('error' in response)) {
                                    _context9.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context9.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function request(_x28) {
                return _ref9.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return lakebtc;
}(Exchange);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    DDoSProtection = _require.DDoSProtection,
    AuthenticationError = _require.AuthenticationError,
    InvalidOrder = _require.InvalidOrder;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(lbank, _Exchange);

    function lbank() {
        _classCallCheck(this, lbank);

        return _possibleConstructorReturn(this, (lbank.__proto__ || Object.getPrototypeOf(lbank)).apply(this, arguments));
    }

    _createClass(lbank, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(lbank.prototype.__proto__ || Object.getPrototypeOf(lbank.prototype), 'describe', this).call(this), {
                'id': 'lbank',
                'name': 'LBank',
                'countries': 'CN',
                'version': 'v1',
                'has': {
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true
                },
                'timeframes': {
                    '1m': 'minute1',
                    '5m': 'minute5',
                    '15m': 'minute15',
                    '30m': 'minute30',
                    '1h': 'hour1',
                    '2h': 'hour2',
                    '4h': 'hour4',
                    '6h': 'hour6',
                    '8h': 'hour8',
                    '12h': 'hour12',
                    '1d': 'day1',
                    '1w': 'week1'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38063602-9605e28a-3302-11e8-81be-64b1e53c4cfb.jpg',
                    'api': 'https://api.lbank.info',
                    'www': 'https://www.lbank.info',
                    'doc': 'https://www.lbank.info/api/api-overview',
                    'fees': 'https://lbankinfo.zendesk.com/hc/zh-cn/articles/115002295114--%E8%B4%B9%E7%8E%87%E8%AF%B4%E6%98%8E'
                },
                'api': {
                    'public': {
                        'get': ['currencyPairs', 'ticker', 'depth', 'trades', 'kline']
                    },
                    'private': {
                        'post': ['user_info', 'create_order', 'cancel_order', 'orders_info', 'orders_info_history']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.1 / 100,
                        'taker': 0.1 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': undefined,
                            'ZEC': 0.01,
                            'ETH': 0.01,
                            'ETC': 0.01,
                            // 'QTUM': amount => Math.max (0.01, amount * (0.1 / 100)),
                            'VEN': 10.0,
                            'BCH': 0.0002,
                            'SC': 50.0,
                            'BTM': 20.0,
                            'NAS': 1.0,
                            'EOS': 1.0,
                            'XWC': 5.0,
                            'BTS': 1.0,
                            'INK': 10.0,
                            'BOT': 3.0,
                            'YOYOW': 15.0,
                            'TGC': 10.0,
                            'NEO': 0.0,
                            'CMT': 20.0,
                            'SEER': 2000.0,
                            'FIL': undefined,
                            'BTG': undefined
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, i, id, _id$split, _id$split2, baseId, quoteId, base, quote, symbol, precision, lot;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetCurrencyPairs();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    id = markets[i];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), baseId = _id$split2[0], quoteId = _id$split2[1];
                                    base = this.commonCurrencyCode(baseId.toUpperCase());
                                    quote = this.commonCurrencyCode(quoteId.toUpperCase());
                                    symbol = [base, quote].join('/');
                                    precision = {
                                        'amount': 8,
                                        'price': 8
                                    };
                                    lot = Math.pow(10, -precision['amount']);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'lot': lot,
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': lot,
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': Math.pow(10, precision['price'])
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': id
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = this.safeInteger(ticker, 'timestamp');
            var info = ticker;
            ticker = info['ticker'];
            var last = this.safeFloat(ticker, 'latest');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': undefined,
                'bidVolume': undefined,
                'ask': undefined,
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'change'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': this.safeFloat(ticker, 'turnover'),
                'info': info
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context2.next = 5;
                                return this.publicGetTicker(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseTicker(response, market));

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, result, i, ticker, id, market, symbol;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetTicker(this.extend({
                                    'symbol': 'all'
                                }, params));

                            case 4:
                                tickers = _context3.sent;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    id = ticker['symbol'];
                                    market = this.marketsById[id];
                                    symbol = market['symbol'];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context3.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTickers() {
                return _ref3.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetDepth(this.extend({
                                    'symbol': this.marketId(symbol),
                                    'size': Math.min(limit, 60)
                                }, params));

                            case 4:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseOrderBook(response));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = market['symbol'];
            var timestamp = parseInt(trade['date_ms']);
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var cost = this.costToPrecision(symbol, price * amount);
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tid'),
                'order': undefined,
                'type': undefined,
                'side': trade['type'],
                'price': price,
                'amount': amount,
                'cost': parseFloat(cost),
                'fee': undefined,
                'info': this.safeValue(trade, 'info', trade)
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'size': 100
                                };

                                if (since) request['time'] = parseInt(since / 1000);
                                if (limit) request['size'] = limit;
                                _context5.next = 8;
                                return this.publicGetTrades(this.extend(request, params));

                            case 8:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x10) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '5m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'symbol': market['id'],
                                    'type': this.timeframes[timeframe],
                                    'size': 1000
                                };

                                if (since) request['time'] = parseInt(since / 1000);
                                if (limit) request['size'] = limit;
                                _context6.next = 8;
                                return this.publicGetKline(this.extend(request, params));

                            case 8:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOHLCV(_x14) {
                return _ref6.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, result, ids, i, id, code, free, used, account;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostUserInfo(params);

                            case 4:
                                response = _context7.sent;
                                result = { 'info': response };
                                ids = Object.keys(this.extend(response['info']['free'], response['info']['freeze']));

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    code = id;

                                    if (id in this.currencies_by_id) code = this.currencies_by_id[id]['code'];
                                    free = this.safeFloat(response['info']['free'], id, 0.0);
                                    used = this.safeFloat(response['info']['freeze'], id, 0.0);
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[code] = account;
                                }
                                return _context7.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchBalance() {
                return _ref7.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = this.safeValue(this.marketsById, order['symbol'], { 'symbol': undefined });
            var timestamp = this.safeInteger(order, 'create_time');
            // Limit Order Request Returns: Order Price
            // Market Order Returns: cny amount of market order
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'amount');
            var filled = this.safeFloat(order, 'deal_amount');
            var cost = filled * this.safeFloat(order, 'avg_price');
            var status = this.safeInteger(order, 'status');
            if (status === -1 || status === 4) {
                status = 'canceled';
            } else if (status === 2) {
                status = 'closed';
            } else {
                status = 'open';
            }
            return {
                'id': this.safeString(order, 'order_id'),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': this.safeString(order, 'order_type'),
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': undefined,
                'remaining': undefined,
                'trades': undefined,
                'fee': undefined,
                'info': this.safeValue(order, 'info', order)
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response, id;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                order = {
                                    'symbol': market['id'],
                                    'type': side,
                                    'amount': amount
                                };

                                if (type === 'market') {
                                    order['type'] += '_market';
                                } else {
                                    order['price'] = price;
                                }
                                _context8.next = 7;
                                return this.privatePostCreateOrder(this.extend(order, params));

                            case 7:
                                response = _context8.sent;

                                order = this.omit(order, 'type');
                                order['order_id'] = response['order_id'];
                                order['type'] = side;
                                order['order_type'] = type;
                                order['create_time'] = this.milliseconds();
                                order['info'] = response;
                                order = this.parseOrder(order, market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context8.abrupt('return', order);

                            case 18:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x21, _x22, _x23, _x24) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context9.next = 5;
                                return this.privatePostCancelOrder(this.extend({
                                    'symbol': market['id'],
                                    'order_id': id
                                }, params));

                            case 5:
                                response = _context9.sent;
                                return _context9.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x27) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context10.next = 5;
                                return this.privatePostOrdersInfo(this.extend({
                                    'symbol': market['id'],
                                    'order_id': id
                                }, params));

                            case 5:
                                response = _context10.sent;
                                return _context10.abrupt('return', this.parseOrder(response['orders'][0], market));

                            case 7:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrder(_x30) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context11.next = 5;
                                return this.privatePostOrdersInfoHistory(this.extend({
                                    'symbol': market['id'],
                                    'current_page': 1,
                                    'page_length': 100
                                }, params));

                            case 5:
                                response = _context11.sent;
                                return _context11.abrupt('return', this.parseOrders(response['orders'], undefined, since, limit));

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.fetchOrders(this.extend({
                                    'status': 0
                                }, params));

                            case 2:
                                response = _context12.sent;
                                return _context12.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOpenOrders() {
                return _ref12.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetchOrders(this.extend({
                                    'status': 1
                                }, params));

                            case 2:
                                response = _context13.sent;
                                return _context13.abrupt('return', response);

                            case 4:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchClosedOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            // Every endpoint ends with ".do"
            url += '.do';
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var _query = this.keysort(this.extend({
                    'api_key': this.apiKey
                }, params));
                var queryString = this.rawencode(_query) + '&secret_key=' + this.secret;
                _query['sign'] = this.hash(this.encode(queryString)).toUpperCase();
                body = this.urlencode(_query);
                headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response, success, errorCode, message, ErrorClass;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context14.sent;
                                success = this.safeString(response, 'result');

                                if (!(success === 'false')) {
                                    _context14.next = 9;
                                    break;
                                }

                                errorCode = this.safeString(response, 'error_code');
                                message = this.safeString({
                                    '10000': 'Internal error',
                                    '10001': 'The required parameters can not be empty',
                                    '10002': 'verification failed',
                                    '10003': 'Illegal parameters',
                                    '10004': 'User requests are too frequent',
                                    '10005': 'Key does not exist',
                                    '10006': 'user does not exist',
                                    '10007': 'Invalid signature',
                                    '10008': 'This currency pair is not supported',
                                    '10009': 'Limit orders can not be missing orders and the number of orders',
                                    '10010': 'Order price or order quantity must be greater than 0',
                                    '10011': 'Market orders can not be missing the amount of the order',
                                    '10012': 'market sell orders can not be missing orders',
                                    '10013': 'is less than the minimum trading position 0.001',
                                    '10014': 'Account number is not enough',
                                    '10015': 'The order type is wrong',
                                    '10016': 'Account balance is not enough',
                                    '10017': 'Abnormal server',
                                    '10018': 'order inquiry can not be more than 50 less than one',
                                    '10019': 'withdrawal orders can not be more than 3 less than one',
                                    '10020': 'less than the minimum amount of the transaction limit of 0.001'
                                }, errorCode, this.json(response));
                                ErrorClass = this.safeValue({
                                    '10002': AuthenticationError,
                                    '10004': DDoSProtection,
                                    '10005': AuthenticationError,
                                    '10006': AuthenticationError,
                                    '10007': AuthenticationError,
                                    '10009': InvalidOrder,
                                    '10010': InvalidOrder,
                                    '10011': InvalidOrder,
                                    '10012': InvalidOrder,
                                    '10013': InvalidOrder,
                                    '10014': InvalidOrder,
                                    '10015': InvalidOrder,
                                    '10016': InvalidOrder
                                }, errorCode, ExchangeError);
                                throw new ErrorClass(message);

                            case 9:
                                return _context14.abrupt('return', response);

                            case 10:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function request(_x50) {
                return _ref14.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return lbank;
}(Exchange);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError,
    NotSupported = _require.NotSupported,
    InvalidOrder = _require.InvalidOrder,
    OrderNotFound = _require.OrderNotFound,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    DDoSProtection = _require.DDoSProtection,
    InsufficientFunds = _require.InsufficientFunds;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(livecoin, _Exchange);

    function livecoin() {
        _classCallCheck(this, livecoin);

        return _possibleConstructorReturn(this, (livecoin.__proto__ || Object.getPrototypeOf(livecoin)).apply(this, arguments));
    }

    _createClass(livecoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(livecoin.prototype.__proto__ || Object.getPrototypeOf(livecoin.prototype), 'describe', this).call(this), {
                'id': 'livecoin',
                'name': 'LiveCoin',
                'countries': ['US', 'UK', 'RU'],
                'rateLimit': 1000,
                'userAgent': this.userAgents['chrome'],
                'has': {
                    'fetchDepositAddress': true,
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchCurrencies': true,
                    'fetchTradingFees': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27980768-f22fc424-638a-11e7-89c9-6010a54ff9be.jpg',
                    'api': 'https://api.livecoin.net',
                    'www': 'https://www.livecoin.net',
                    'doc': 'https://www.livecoin.net/api?lang=en'
                },
                'api': {
                    'public': {
                        'get': ['exchange/all/order_book', 'exchange/last_trades', 'exchange/maxbid_minask', 'exchange/order_book', 'exchange/restrictions', 'exchange/ticker', // omit params to get all tickers at once
                        'info/coinInfo']
                    },
                    'private': {
                        'get': ['exchange/client_orders', 'exchange/order', 'exchange/trades', 'exchange/commission', 'exchange/commissionCommonInfo', 'payment/balances', 'payment/balance', 'payment/get/address', 'payment/history/size', 'payment/history/transactions'],
                        'post': ['exchange/buylimit', 'exchange/buymarket', 'exchange/cancellimit', 'exchange/selllimit', 'exchange/sellmarket', 'payment/out/capitalist', 'payment/out/card', 'payment/out/coin', 'payment/out/okpay', 'payment/out/payeer', 'payment/out/perfectmoney', 'payment/voucher/amount', 'payment/voucher/make', 'payment/voucher/redeem']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.18 / 100,
                        'taker': 0.18 / 100
                    }
                },
                'commonCurrencies': {
                    'CPC': 'Capricoin',
                    'CRC': 'CryCash',
                    'ORE': 'Orectic',
                    'RUR': 'RUB',
                    'XBT': 'Bricktox'
                },
                'exceptions': {
                    '1': ExchangeError,
                    '10': AuthenticationError,
                    '100': ExchangeError, // invalid parameters
                    '101': AuthenticationError,
                    '102': AuthenticationError,
                    '103': InvalidOrder, // invalid currency
                    '104': InvalidOrder, // invalid amount
                    '105': InvalidOrder, // unable to block funds
                    '11': AuthenticationError,
                    '12': AuthenticationError,
                    '2': AuthenticationError, // "User not found"
                    '20': AuthenticationError,
                    '30': AuthenticationError,
                    '31': NotSupported,
                    '32': ExchangeError,
                    '429': DDoSProtection,
                    '503': ExchangeNotAvailable
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, restrictions, restrictionsById, result, p, market, id, symbol, _symbol$split, _symbol$split2, baseId, quoteId, base, quote, coinRestrictions, precision, limits;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetExchangeTicker();

                            case 2:
                                markets = _context.sent;
                                _context.next = 5;
                                return this.publicGetExchangeRestrictions();

                            case 5:
                                restrictions = _context.sent;
                                restrictionsById = this.indexBy(restrictions['restrictions'], 'currencyPair');
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['symbol'];
                                    symbol = id;
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), baseId = _symbol$split2[0], quoteId = _symbol$split2[1];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    coinRestrictions = this.safeValue(restrictionsById, symbol);
                                    precision = {
                                        'price': 5,
                                        'amount': 8,
                                        'cost': 8
                                    };
                                    limits = {
                                        'amount': {
                                            'min': Math.pow(10, -precision['amount']),
                                            'max': Math.pow(10, precision['amount'])
                                        }
                                    };

                                    if (coinRestrictions) {
                                        precision['price'] = this.safeInteger(coinRestrictions, 'priceScale', 5);
                                        limits['amount']['min'] = this.safeFloat(coinRestrictions, 'minLimitQuantity', limits['amount']['min']);
                                    }
                                    limits['price'] = {
                                        'min': Math.pow(10, -precision['price']),
                                        'max': Math.pow(10, precision['price'])
                                    };
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'active': true,
                                        'precision': precision,
                                        'limits': limits,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, currencies, result, i, currency, id, code, precision, active;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetInfoCoinInfo(params);

                            case 2:
                                response = _context2.sent;
                                currencies = response['info'];
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['symbol'];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    code = this.commonCurrencyCode(id);
                                    precision = 8; // default precision, todo: fix "magic constants"

                                    active = currency['walletStatus'] === 'normal';

                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': 'ok',
                                        'fee': currency['withdrawFee'], // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': currency['minOrderAmount'],
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': currency['minOrderAmount'],
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['minWithdrawAmount'],
                                                'max': Math.pow(10, precision)
                                            },
                                            'deposit': {
                                                'min': currency['minDepositAmount'],
                                                'max': undefined
                                            }
                                        }
                                    };
                                }
                                result = this.appendFiatCurrencies(result);
                                return _context2.abrupt('return', result);

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchCurrencies() {
                return _ref2.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'appendFiatCurrencies',
        value: function appendFiatCurrencies() {
            var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

            var precision = 8;
            var defaults = {
                'info': undefined,
                'active': true,
                'status': 'ok',
                'fee': undefined,
                'precision': precision,
                'limits': {
                    'withdraw': { 'min': undefined, 'max': undefined },
                    'deposit': { 'min': undefined, 'max': undefined },
                    'amount': { 'min': undefined, 'max': undefined },
                    'cost': { 'min': undefined, 'max': undefined },
                    'price': {
                        'min': Math.pow(10, -precision),
                        'max': Math.pow(10, precision)
                    }
                }
            };
            var currencies = [{ 'id': 'USD', 'code': 'USD', 'name': 'US Dollar' }, { 'id': 'EUR', 'code': 'EUR', 'name': 'Euro' }];
            currencies.push({
                'id': 'RUR',
                'code': this.commonCurrencyCode('RUR'),
                'name': 'Russian ruble'
            });
            for (var i = 0; i < currencies.length; i++) {
                var currency = currencies[i];
                var code = currency['code'];
                result[code] = this.extend(defaults, currency);
            }
            return result;
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.privateGetPaymentBalances();

                            case 4:
                                balances = _context3.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    account = undefined;

                                    if (currency in result) account = result[currency];else account = this.account();
                                    if (balance['type'] === 'total') account['total'] = parseFloat(balance['value']);
                                    if (balance['type'] === 'available') account['free'] = parseFloat(balance['value']);
                                    if (balance['type'] === 'trade') account['used'] = parseFloat(balance['value']);
                                    result[currency] = account;
                                }
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchTradingFees',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, commission;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privateGetExchangeCommissionCommonInfo(params);

                            case 4:
                                response = _context4.sent;
                                commission = this.safeFloat(response, 'commission');
                                return _context4.abrupt('return', {
                                    'info': response,
                                    'maker': commission,
                                    'taker': commission
                                });

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTradingFees() {
                return _ref4.apply(this, arguments);
            }

            return fetchTradingFees;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'currencyPair': this.marketId(symbol),
                                    'groupByPrice': 'false'
                                };

                                if (typeof limit !== 'undefined') request['depth'] = limit; // 100
                                _context5.next = 6;
                                return this.publicGetExchangeOrderBook(this.extend(request, params));

                            case 6:
                                orderbook = _context5.sent;
                                timestamp = orderbook['timestamp'];
                                return _context5.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x5) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var vwap = this.safeFloat(ticker, 'vwap');
            var baseVolume = this.safeFloat(ticker, 'volume');
            var quoteVolume = baseVolume * vwap;
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'best_bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'best_ask'),
                'askVolume': undefined,
                'vwap': this.safeFloat(ticker, 'vwap'),
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': baseVolume,
                'quoteVolume': quoteVolume,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetExchangeTicker(params);

                            case 4:
                                response = _context6.sent;
                                tickers = this.indexBy(response, 'symbol');
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context6.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTickers() {
                return _ref6.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetExchangeTicker(this.extend({
                                    'currencyPair': market['id']
                                }, params));

                            case 5:
                                ticker = _context7.sent;
                                return _context7.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTicker(_x11) {
                return _ref7.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['time'] * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': trade['id'].toString(),
                'order': undefined,
                'type': undefined,
                'side': trade['type'].toLowerCase(),
                'price': trade['price'],
                'amount': trade['quantity']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.publicGetExchangeLastTrades(this.extend({
                                    'currencyPair': market['id']
                                }, params));

                            case 5:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTrades(_x13) {
                return _ref8.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeInteger(order, 'lastModificationTime');
            if (!timestamp) timestamp = this.parse8601(order['lastModificationTime']);
            var trades = undefined;
            if ('trades' in order)
                // TODO currently not supported by livecoin
                // trades = this.parseTrades (order['trades'], market, since, limit);
                trades = undefined;
            var status = undefined;
            if (order['orderStatus'] === 'OPEN' || order['orderStatus'] === 'PARTIALLY_FILLED') {
                status = 'open';
            } else if (order['orderStatus'] === 'EXECUTED' || order['orderStatus'] === 'PARTIALLY_FILLED_AND_CANCELLED') {
                status = 'closed';
            } else {
                status = 'canceled';
            }
            var symbol = order['currencyPair'];
            var parts = symbol.split('/');
            var quote = parts[1];
            // let [ base, quote ] = symbol.split ('/');
            var type = undefined;
            var side = undefined;
            if (order['type'].indexOf('MARKET') >= 0) {
                type = 'market';
            } else {
                type = 'limit';
            }
            if (order['type'].indexOf('SELL') >= 0) {
                side = 'sell';
            } else {
                side = 'buy';
            }
            var price = this.safeFloat(order, 'price', 0.0);
            var cost = this.safeFloat(order, 'commissionByTrade', 0.0);
            var remaining = this.safeFloat(order, 'remainingQuantity', 0.0);
            var amount = this.safeFloat(order, 'quantity', remaining);
            var filled = amount - remaining;
            return {
                'info': order,
                'id': order['id'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': type,
                'side': side,
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': trades,
                'fee': {
                    'cost': cost,
                    'currency': quote
                }
            };
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response, result, rawOrders, i, order;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {};

                                if (typeof symbol !== 'undefined') {
                                    market = this.market(symbol);
                                    request['currencyPair'] = market['id'];
                                }
                                if (typeof since !== 'undefined') request['issuedFrom'] = parseInt(since);
                                if (typeof limit !== 'undefined') request['endRow'] = limit - 1;
                                _context9.next = 9;
                                return this.privateGetExchangeClientOrders(this.extend(request, params));

                            case 9:
                                response = _context9.sent;
                                result = [];
                                rawOrders = [];

                                if (response['data']) rawOrders = response['data'];
                                for (i = 0; i < rawOrders.length; i++) {
                                    order = rawOrders[i];

                                    result.push(this.parseOrder(order, market));
                                }
                                return _context9.abrupt('return', result);

                            case 15:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'openClosed': 'OPEN'
                                }, params));

                            case 2:
                                result = _context10.sent;
                                return _context10.abrupt('return', result);

                            case 4:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOpenOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'openClosed': 'CLOSED'
                                }, params));

                            case 2:
                                result = _context11.sent;
                                return _context11.abrupt('return', result);

                            case 4:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchClosedOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, market, order, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePostExchange' + this.capitalize(side) + type;
                                market = this.market(symbol);
                                order = {
                                    'quantity': this.amountToPrecision(symbol, amount),
                                    'currencyPair': market['id']
                                };

                                if (type === 'limit') order['price'] = this.priceToPrecision(symbol, price);
                                _context12.next = 8;
                                return this[method](this.extend(order, params));

                            case 8:
                                response = _context12.sent;
                                return _context12.abrupt('return', {
                                    'info': response,
                                    'id': response['orderId'].toString()
                                });

                            case 10:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function createOrder(_x30, _x31, _x32, _x33) {
                return _ref12.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, currencyPair, response, message;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                if (symbol) {
                                    _context13.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder requires a symbol argument');

                            case 2:
                                _context13.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                currencyPair = market['id'];
                                _context13.next = 8;
                                return this.privatePostExchangeCancellimit(this.extend({
                                    'orderId': id,
                                    'currencyPair': currencyPair
                                }, params));

                            case 8:
                                response = _context13.sent;
                                message = this.safeString(response, 'message', this.json(response));

                                if (!('success' in response)) {
                                    _context13.next = 21;
                                    break;
                                }

                                if (response['success']) {
                                    _context13.next = 15;
                                    break;
                                }

                                throw new InvalidOrder(message);

                            case 15:
                                if (!('cancelled' in response)) {
                                    _context13.next = 21;
                                    break;
                                }

                                if (!response['cancelled']) {
                                    _context13.next = 20;
                                    break;
                                }

                                return _context13.abrupt('return', response);

                            case 20:
                                throw new OrderNotFound(message);

                            case 21:
                                throw new ExchangeError(this.id + ' cancelOrder() failed: ' + this.json(response));

                            case 22:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function cancelOrder(_x36) {
                return _ref13.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wallet, withdrawal, response, id;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.loadMarkets();

                            case 2:
                                this.checkAddress(address);
                                wallet = address;

                                if (typeof tag !== 'undefined') wallet += '::' + tag;
                                withdrawal = {
                                    'amount': this.truncate(amount, this.currencies[currency]['precision']), // throws an error when amount is too precise
                                    'currency': this.commonCurrencyCode(currency),
                                    'wallet': wallet
                                };
                                _context14.next = 8;
                                return this.privatePostPaymentOutCoin(this.extend(withdrawal, params));

                            case 8:
                                response = _context14.sent;
                                id = this.safeInteger(response, 'id');

                                if (!(typeof id === 'undefined')) {
                                    _context14.next = 12;
                                    break;
                                }

                                throw new InsufficientFunds(this.id + ' insufficient funds to cover requested withdrawal amount post fees ' + this.json(response));

                            case 12:
                                return _context14.abrupt('return', {
                                    'info': response,
                                    'id': id
                                });

                            case 13:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function withdraw(_x39, _x40, _x41) {
                return _ref14.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, response, address, tag, parts;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                request = {
                                    'currency': currency
                                };
                                _context15.next = 3;
                                return this.privateGetPaymentGetAddress(this.extend(request, params));

                            case 3:
                                response = _context15.sent;
                                address = this.safeString(response, 'wallet');
                                tag = undefined;

                                if (address.indexOf(':') >= 0) {
                                    parts = address.split(':');

                                    address = parts[0];
                                    tag = parts[2];
                                }
                                this.checkAddress(address);
                                return _context15.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function fetchDepositAddress(_x44) {
                return _ref15.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + path;
            var query = this.urlencode(this.keysort(params));
            if (method === 'GET') {
                if (Object.keys(params).length) {
                    url += '?' + query;
                }
            }
            if (api === 'private') {
                this.checkRequiredCredentials();
                if (method === 'POST') body = query;
                var signature = this.hmac(this.encode(query), this.encode(this.secret), 'sha256');
                headers = {
                    'Api-Key': this.apiKey,
                    'Sign': signature.toUpperCase(),
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (typeof body !== 'string') return;
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if (code >= 300) {
                    var errorCode = this.safeString(response, 'errorCode');
                    if (errorCode in this.exceptions) {
                        var ExceptionClass = this.exceptions[errorCode];
                        throw new ExceptionClass(this.id + ' ' + body);
                    } else {
                        throw new ExchangeError(this.id + ' ' + body);
                    }
                }
                // returns status code 200 even if success === false
                var success = this.safeValue(response, 'success', true);
                if (!success) {
                    throw new ExchangeError(this.id + ' ' + body);
                }
            }
        }
    }]);

    return livecoin;
}(Exchange);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(luno, _Exchange);

    function luno() {
        _classCallCheck(this, luno);

        return _possibleConstructorReturn(this, (luno.__proto__ || Object.getPrototypeOf(luno)).apply(this, arguments));
    }

    _createClass(luno, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(luno.prototype.__proto__ || Object.getPrototypeOf(luno.prototype), 'describe', this).call(this), {
                'id': 'luno',
                'name': 'luno',
                'countries': ['GB', 'SG', 'ZA'],
                'rateLimit': 10000,
                'version': '1',
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOrder': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766607-8c1a69d8-5ede-11e7-930c-540b5eb9be24.jpg',
                    'api': 'https://api.mybitx.com/api',
                    'www': 'https://www.luno.com',
                    'doc': ['https://www.luno.com/en/api', 'https://npmjs.org/package/bitx', 'https://github.com/bausmeier/node-bitx']
                },
                'api': {
                    'public': {
                        'get': ['orderbook', 'ticker', 'tickers', 'trades']
                    },
                    'private': {
                        'get': ['accounts/{id}/pending', 'accounts/{id}/transactions', 'balance', 'fee_info', 'funding_address', 'listorders', 'listtrades', 'orders/{id}', 'quotes/{id}', 'withdrawals', 'withdrawals/{id}'],
                        'post': ['accounts', 'postorder', 'marketorder', 'stoporder', 'funding_address', 'withdrawals', 'send', 'quotes', 'oauth2/grant'],
                        'put': ['quotes/{id}'],
                        'delete': ['quotes/{id}', 'withdrawals/{id}']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetTickers();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets['tickers'].length; p++) {
                                    market = markets['tickers'][p];
                                    id = market['pair'];
                                    base = id.slice(0, 3);
                                    quote = id.slice(3, 6);

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, reserved, unconfirmed, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetBalance();

                            case 4:
                                response = _context2.sent;
                                balances = response['balance'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = this.commonCurrencyCode(balance['asset']);
                                    reserved = parseFloat(balance['reserved']);
                                    unconfirmed = parseFloat(balance['unconfirmed']);
                                    account = {
                                        'free': 0.0,
                                        'used': this.sum(reserved, unconfirmed),
                                        'total': parseFloat(balance['balance'])
                                    };

                                    account['free'] = account['total'] - account['used'];
                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderbook(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                timestamp = orderbook['timestamp'];
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'volume'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = order['creation_timestamp'];
            var status = order['state'] === 'PENDING' ? 'open' : 'closed';
            var side = order['type'] === 'ASK' ? 'sell' : 'buy';
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var price = this.safeFloat(order, 'limit_price');
            var amount = this.safeFloat(order, 'limit_volume');
            var quoteFee = this.safeFloat(order, 'fee_counter');
            var baseFee = this.safeFloat(order, 'fee_base');
            var fee = { 'currency': undefined };
            if (quoteFee) {
                fee['side'] = 'quote';
                fee['cost'] = quoteFee;
            } else {
                fee['side'] = 'base';
                fee['cost'] = baseFee;
            }
            return {
                'id': order['order_id'],
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': undefined,
                'side': side,
                'price': price,
                'amount': amount,
                'filled': undefined,
                'remaining': undefined,
                'trades': undefined,
                'fee': fee,
                'info': order
            };
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privateGetOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrder(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['timestamp'];
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last_trade');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'rolling_24_hour_volume'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetTickers(params);

                            case 4:
                                response = _context5.sent;
                                tickers = this.indexBy(response['tickers'], 'pair');
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTicker(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                ticker = _context6.sent;
                                return _context6.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x12) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var side = trade['is_buy'] ? 'buy' : 'sell';
            return {
                'info': trade,
                'id': undefined,
                'order': undefined,
                'timestamp': trade['timestamp'],
                'datetime': this.iso8601(trade['timestamp']),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'volume')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id']
                                };

                                if (typeof since !== 'undefined') request['since'] = since;
                                _context7.next = 7;
                                return this.publicGetTrades(this.extend(request, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x14) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                method = 'privatePost';
                                order = { 'pair': this.marketId(symbol) };

                                if (type === 'market') {
                                    method += 'Marketorder';
                                    order['type'] = side.toUpperCase();
                                    if (side === 'buy') order['counter_volume'] = amount;else order['base_volume'] = amount;
                                } else {
                                    method += 'Postorder';
                                    order['volume'] = amount;
                                    order['price'] = price;
                                    if (side === 'buy') order['type'] = 'BID';else order['type'] = 'ASK';
                                }
                                _context8.next = 7;
                                return this[method](this.extend(order, params));

                            case 7:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['order_id']
                                });

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x18, _x19, _x20, _x21) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostStoporder({ 'order_id': id });

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x24) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (Object.keys(query).length) url += '?' + this.urlencode(query);
            if (api === 'private') {
                this.checkRequiredCredentials();
                var auth = this.encode(this.apiKey + ':' + this.secret);
                auth = this.stringToBase64(auth);
                headers = { 'Authorization': 'Basic ' + this.decode(auth) };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context10.sent;

                                if (!('error' in response)) {
                                    _context10.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context10.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function request(_x32) {
                return _ref10.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return luno;
}(Exchange);

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(lykke, _Exchange);

    function lykke() {
        _classCallCheck(this, lykke);

        return _possibleConstructorReturn(this, (lykke.__proto__ || Object.getPrototypeOf(lykke)).apply(this, arguments));
    }

    _createClass(lykke, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(lykke.prototype.__proto__ || Object.getPrototypeOf(lykke.prototype), 'describe', this).call(this), {
                'id': 'lykke',
                'name': 'Lykke',
                'countries': 'CH',
                'version': 'v1',
                'rateLimit': 200,
                'has': {
                    'CORS': false,
                    'fetchOHLCV': false,
                    'fetchTrades': false,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'fetchOrder': true,
                    'fetchOrders': true
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/34487620-3139a7b0-efe6-11e7-90f5-e520cef74451.jpg',
                    'api': {
                        'mobile': 'https://api.lykkex.com/api',
                        'public': 'https://hft-api.lykke.com/api',
                        'private': 'https://hft-api.lykke.com/api',
                        'test': {
                            'mobile': 'https://api.lykkex.com/api',
                            'public': 'https://hft-service-dev.lykkex.net/api',
                            'private': 'https://hft-service-dev.lykkex.net/api'
                        }
                    },
                    'www': 'https://www.lykke.com',
                    'doc': ['https://hft-api.lykke.com/swagger/ui/', 'https://www.lykke.com/lykke_api'],
                    'fees': 'https://www.lykke.com/trading-conditions'
                },
                'api': {
                    'mobile': {
                        'get': ['AllAssetPairRates/{market}']
                    },
                    'public': {
                        'get': ['AssetPairs', 'AssetPairs/{id}', 'IsAlive', 'OrderBooks', 'OrderBooks/{AssetPairId}']
                    },
                    'private': {
                        'get': ['Orders', 'Orders/{id}', 'Wallets'],
                        'post': ['Orders/limit', 'Orders/market', 'Orders/{id}/Cancel']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.0, // as of 7 Feb 2018, see https://github.com/ccxt/ccxt/issues/1863
                        'taker': 0.0 // https://www.lykke.com/cp/wallet-fees-and-limits
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.001
                        },
                        'deposit': {
                            'BTC': 0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, i, balance, currency, total, used, free;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privateGetWallets();

                            case 4:
                                balances = _context.sent;
                                result = { 'info': balances };

                                for (i = 0; i < balances.length; i++) {
                                    balance = balances[i];
                                    currency = balance['AssetId'];
                                    total = balance['Balance'];
                                    used = balance['Reserved'];
                                    free = total - used;

                                    result[currency] = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.privatePostOrdersIdCancel({ 'id': id });

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function cancelOrder(_x2) {
                return _ref2.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, query, method, result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                query = {
                                    'AssetPairId': market['id'],
                                    'OrderAction': this.capitalize(side),
                                    'Volume': amount
                                };

                                if (type === 'market') {
                                    query['Asset'] = side === 'buy' ? market['base'] : market['quote'];
                                } else if (type === 'limit') {
                                    query['Price'] = price;
                                }
                                method = 'privatePostOrders' + this.capitalize(type);
                                _context3.next = 8;
                                return this[method](this.extend(query, params));

                            case 8:
                                result = _context3.sent;
                                return _context3.abrupt('return', {
                                    'id': undefined,
                                    'info': result
                                });

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function createOrder(_x5, _x6, _x7, _x8) {
                return _ref3.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var markets, result, i, market, id, base, quote, symbol, precision;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.publicGetAssetPairs();

                            case 2:
                                markets = _context4.sent;
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['Id'];
                                    base = market['BaseAssetId'];
                                    quote = market['QuotingAssetId'];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = market['Name'];
                                    precision = {
                                        'amount': market['Accuracy'],
                                        'price': market['InvertedAccuracy']
                                    };

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': true,
                                        'info': market,
                                        'lot': Math.pow(10, -precision['amount']),
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision['amount']),
                                                'max': Math.pow(10, precision['amount'])
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision['price']),
                                                'max': Math.pow(10, precision['price'])
                                            }
                                        }
                                    });
                                }
                                return _context4.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchMarkets() {
                return _ref4.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            ticker = ticker['Result'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': parseFloat(ticker['Rate']['Bid']),
                'bidVolume': undefined,
                'ask': parseFloat(ticker['Rate']['Ask']),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': undefined,
                'last': undefined,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': undefined,
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.mobileGetAllAssetPairRatesMarket(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x12) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            if (status === 'Pending') {
                return 'open';
            } else if (status === 'InOrderBook') {
                return 'open';
            } else if (status === 'Processing') {
                return 'open';
            } else if (status === 'Matched') {
                return 'closed';
            } else if (status === 'Cancelled') {
                return 'canceled';
            } else if (status === 'NotEnoughFunds') {
                return 'NotEnoughFunds';
            } else if (status === 'NoLiquidity') {
                return 'NoLiquidity';
            } else if (status === 'UnknownAsset') {
                return 'UnknownAsset';
            } else if (status === 'LeadToNegativeSpread') {
                return 'LeadToNegativeSpread';
            }
            return status;
        }
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var status = this.parseOrderStatus(order['Status']);
            var symbol = undefined;
            if (!market) {
                if ('AssetPairId' in order) if (order['AssetPairId'] in this.markets_by_id) market = this.markets_by_id[order['AssetPairId']];
            }
            if (market) symbol = market['symbol'];
            var timestamp = undefined;
            if ('LastMatchTime' in order && order['LastMatchTime']) {
                timestamp = this.parse8601(order['LastMatchTime']);
            } else if ('Registered' in order && order['Registered']) {
                timestamp = this.parse8601(order['Registered']);
            } else if ('CreatedAt' in order && order['CreatedAt']) {
                timestamp = this.parse8601(order['CreatedAt']);
            }
            var price = this.safeFloat(order, 'Price');
            var amount = this.safeFloat(order, 'Volume');
            var remaining = this.safeFloat(order, 'RemainingVolume');
            var filled = amount - remaining;
            var cost = filled * price;
            var result = {
                'info': order,
                'id': order['Id'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': undefined,
                'side': undefined,
                'price': price,
                'cost': cost,
                'average': undefined,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privateGetOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOrder(response));

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchOrder(_x15) {
                return _ref6.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privateGetOrders();

                            case 4:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOrders(response, undefined, since, limit));

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateGetOrders(this.extend({
                                    'status': 'InOrderBook'
                                }, params));

                            case 4:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrders(response, undefined, since, limit));

                            case 6:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOpenOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privateGetOrders(this.extend({
                                    'status': 'Matched'
                                }, params));

                            case 4:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(response, undefined, since, limit));

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchClosedOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook, timestamp, i, side, sideTimestamp;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.publicGetOrderBooksAssetPairId(this.extend({
                                    'AssetPairId': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context10.sent;
                                orderbook = {
                                    'timestamp': undefined,
                                    'bids': [],
                                    'asks': []
                                };
                                timestamp = undefined;

                                for (i = 0; i < response.length; i++) {
                                    side = response[i];

                                    if (side['IsBuy']) {
                                        orderbook['bids'] = this.arrayConcat(orderbook['bids'], side['Prices']);
                                    } else {
                                        orderbook['asks'] = this.arrayConcat(orderbook['asks'], side['Prices']);
                                    }
                                    sideTimestamp = this.parse8601(side['Timestamp']);

                                    timestamp = typeof timestamp === 'undefined' ? sideTimestamp : Math.max(timestamp, sideTimestamp);
                                }
                                return _context10.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'Price', 'Volume'));

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchOrderBook(_x30) {
                return _ref10.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseBidAsk',
        value: function parseBidAsk(bidask) {
            var priceKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var amountKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

            var price = parseFloat(bidask[priceKey]);
            var amount = parseFloat(bidask[amountKey]);
            if (amount < 0) amount = -amount;
            return [price, amount];
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else if (api === 'private') {
                if (method === 'GET') if (Object.keys(query).length) url += '?' + this.urlencode(query);
                this.checkRequiredCredentials();
                headers = {
                    'api-key': this.apiKey,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                };
                if (method === 'POST') if (Object.keys(params).length) body = this.json(params);
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return lykke;
}(Exchange);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(mercado, _Exchange);

    function mercado() {
        _classCallCheck(this, mercado);

        return _possibleConstructorReturn(this, (mercado.__proto__ || Object.getPrototypeOf(mercado)).apply(this, arguments));
    }

    _createClass(mercado, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(mercado.prototype.__proto__ || Object.getPrototypeOf(mercado.prototype), 'describe', this).call(this), {
                'id': 'mercado',
                'name': 'Mercado Bitcoin',
                'countries': 'BR', // Brazil
                'rateLimit': 1000,
                'version': 'v3',
                'has': {
                    'CORS': true,
                    'createMarketOrder': false,
                    'fetchOrder': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27837060-e7c58714-60ea-11e7-9192-f05e86adb83f.jpg',
                    'api': {
                        'public': 'https://www.mercadobitcoin.net/api',
                        'private': 'https://www.mercadobitcoin.net/tapi'
                    },
                    'www': 'https://www.mercadobitcoin.com.br',
                    'doc': ['https://www.mercadobitcoin.com.br/api-doc', 'https://www.mercadobitcoin.com.br/trade-api']
                },
                'api': {
                    'public': {
                        'get': ['{coin}/orderbook/', // last slash critical
                        '{coin}/ticker/', '{coin}/trades/', '{coin}/trades/{from}/', '{coin}/trades/{from}/{to}', '{coin}/day-summary/{year}/{month}/{day}/']
                    },
                    'private': {
                        'post': ['cancel_order', 'get_account_info', 'get_order', 'get_withdrawal', 'list_system_messages', 'list_orders', 'list_orderbook', 'place_buy_order', 'place_sell_order', 'withdraw_coin']
                    }
                },
                'markets': {
                    'BTC/BRL': { 'id': 'BRLBTC', 'symbol': 'BTC/BRL', 'base': 'BTC', 'quote': 'BRL', 'suffix': 'Bitcoin' },
                    'LTC/BRL': { 'id': 'BRLLTC', 'symbol': 'LTC/BRL', 'base': 'LTC', 'quote': 'BRL', 'suffix': 'Litecoin' },
                    'BCH/BRL': { 'id': 'BRLBCH', 'symbol': 'BCH/BRL', 'base': 'BCH', 'quote': 'BRL', 'suffix': 'BCash' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.3 / 100,
                        'taker': 0.7 / 100
                    }
                }
            });
        }
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                market = this.market(symbol);
                                _context.next = 3;
                                return this.publicGetCoinOrderbook(this.extend({
                                    'coin': market['base']
                                }, params));

                            case 3:
                                orderbook = _context.sent;
                                return _context.abrupt('return', this.parseOrderBook(orderbook));

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOrderBook(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                market = this.market(symbol);
                                _context2.next = 3;
                                return this.publicGetCoinTicker(this.extend({
                                    'coin': market['base']
                                }, params));

                            case 3:
                                response = _context2.sent;
                                ticker = response['ticker'];
                                timestamp = parseInt(ticker['date']) * 1000;
                                last = this.safeFloat(ticker, 'last');
                                return _context2.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'vol'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTicker(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['date'] * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': trade['tid'].toString(),
                'order': undefined,
                'type': undefined,
                'side': trade['type'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, method, request, to, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                market = this.market(symbol);
                                method = 'publicGetCoinTrades';
                                request = {
                                    'coin': market['base']
                                };

                                if (typeof since !== 'undefined') {
                                    method += 'From';
                                    request['from'] = parseInt(since / 1000);
                                }
                                to = this.safeInteger(params, 'to');

                                if (typeof to !== 'undefined') method += 'To';
                                _context3.next = 8;
                                return this[method](this.extend(request, params));

                            case 8:
                                response = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x6) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencies, i, currency, lowercase, account;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.privatePostGetAccountInfo();

                            case 2:
                                response = _context4.sent;
                                balances = response['response_data']['balance'];
                                result = { 'info': response };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();

                                    if (lowercase in balances) {
                                        account['free'] = parseFloat(balances[lowercase]['available']);
                                        account['total'] = parseFloat(balances[lowercase]['total']);
                                        account['used'] = account['total'] - account['free'];
                                    }
                                    result[currency] = account;
                                }
                                return _context4.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchBalance() {
                return _ref4.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context5.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                method = 'privatePostPlace' + this.capitalize(side) + 'Order';
                                order = {
                                    'coin_pair': this.marketId(symbol),
                                    'quantity': amount,
                                    'limit_price': price
                                };
                                _context5.next = 6;
                                return this[method](this.extend(order, params));

                            case 6:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['response_data']['order']['order_id'].toString()
                                });

                            case 8:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (symbol) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder() requires a symbol argument');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                _context6.next = 7;
                                return this.privatePostCancelOrder(this.extend({
                                    'coin_pair': market['id'],
                                    'order_id': id
                                }, params));

                            case 7:
                                return _context6.abrupt('return', _context6.sent);

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = undefined;
            if ('order_type' in order) side = order['order_type'] === 1 ? 'buy' : 'sell';
            var status = order['status'];
            var symbol = undefined;
            if (!market) {
                if ('coin_pair' in order) if (order['coin_pair'] in this.markets_by_id) market = this.markets_by_id[order['coin_pair']];
            }
            if (market) symbol = market['symbol'];
            var timestamp = undefined;
            if ('created_timestamp' in order) timestamp = parseInt(order['created_timestamp']) * 1000;
            if ('updated_timestamp' in order) timestamp = parseInt(order['updated_timestamp']) * 1000;
            var fee = {
                'cost': this.safeFloat(order, 'fee'),
                'currency': market['quote']
            };
            var price = this.safeFloat(order, 'limit_price');
            // price = this.safeFloat (order, 'executed_price_avg', price);
            var average = this.safeFloat(order, 'executed_price_avg');
            var amount = this.safeFloat(order, 'quantity');
            var filled = this.safeFloat(order, 'executed_quantity');
            var remaining = amount - filled;
            var cost = amount * average;
            var result = {
                'info': order,
                'id': order['order_id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': 'limit',
                'side': side,
                'price': price,
                'cost': cost,
                'average': average,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': fee
            };
            return result;
        }
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (symbol) {
                                    _context7.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' cancelOrder() requires a symbol argument');

                            case 2:
                                _context7.next = 4;
                                return this.loadMarkets();

                            case 4:
                                market = this.market(symbol);
                                response = undefined;
                                _context7.next = 8;
                                return this.privatePostGetOrder(this.extend({
                                    'coin_pair': market['id'],
                                    'order_id': parseInt(id)
                                }, params));

                            case 8:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOrder(response['response_data']['order']));

                            case 10:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOrder(_x21) {
                return _ref7.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, account_ref, tx_fee, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this.checkAddress(address);
                                _context8.next = 3;
                                return this.loadMarkets();

                            case 3:
                                request = {
                                    'coin': currency,
                                    'quantity': amount.toFixed(10),
                                    'address': address
                                };

                                if (!(currency === 'BRL')) {
                                    _context8.next = 10;
                                    break;
                                }

                                account_ref = 'account_ref' in params;

                                if (account_ref) {
                                    _context8.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' requires account_ref parameter to withdraw ' + currency);

                            case 8:
                                _context8.next = 14;
                                break;

                            case 10:
                                if (!(currency !== 'LTC')) {
                                    _context8.next = 14;
                                    break;
                                }

                                tx_fee = 'tx_fee' in params;

                                if (tx_fee) {
                                    _context8.next = 14;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' requires tx_fee parameter to withdraw ' + currency);

                            case 14:
                                _context8.next = 16;
                                return this.privatePostWithdrawCoin(this.extend(request, params));

                            case 16:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['response_data']['withdrawal']['id']
                                });

                            case 18:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function withdraw(_x24, _x25, _x26) {
                return _ref8.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/';
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                url += this.implodeParams(path, params);
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                url += this.version + '/';
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'tapi_method': path,
                    'tapi_nonce': nonce
                }, params));
                var auth = '/tapi/' + this.version + '/' + '?' + body;
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'TAPI-ID': this.apiKey,
                    'TAPI-MAC': this.hmac(this.encode(auth), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context9.sent;

                                if (!('error_message' in response)) {
                                    _context9.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context9.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function request(_x34) {
                return _ref9.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return mercado;
}(Exchange);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(mixcoins, _Exchange);

    function mixcoins() {
        _classCallCheck(this, mixcoins);

        return _possibleConstructorReturn(this, (mixcoins.__proto__ || Object.getPrototypeOf(mixcoins)).apply(this, arguments));
    }

    _createClass(mixcoins, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(mixcoins.prototype.__proto__ || Object.getPrototypeOf(mixcoins.prototype), 'describe', this).call(this), {
                'id': 'mixcoins',
                'name': 'MixCoins',
                'countries': ['GB', 'HK'],
                'rateLimit': 1500,
                'version': 'v1',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30237212-ed29303c-9535-11e7-8af8-fcd381cfa20c.jpg',
                    'api': 'https://mixcoins.com/api',
                    'www': 'https://mixcoins.com',
                    'doc': 'https://mixcoins.com/help/api/'
                },
                'api': {
                    'public': {
                        'get': ['ticker', 'trades', 'depth']
                    },
                    'private': {
                        'post': ['cancel', 'info', 'orders', 'order', 'transactions', 'trade']
                    }
                },
                'markets': {
                    'BTC/USD': { 'id': 'btc_usd', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'maker': 0.0015, 'taker': 0.0025 },
                    'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'maker': 0.001, 'taker': 0.0015 },
                    'BCH/BTC': { 'id': 'bch_btc', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'maker': 0.001, 'taker': 0.0015 },
                    'LSK/BTC': { 'id': 'lsk_btc', 'symbol': 'LSK/BTC', 'base': 'LSK', 'quote': 'BTC', 'maker': 0.0015, 'taker': 0.0025 },
                    'BCH/USD': { 'id': 'bch_usd', 'symbol': 'BCH/USD', 'base': 'BCH', 'quote': 'USD', 'maker': 0.001, 'taker': 0.0015 },
                    'ETH/USD': { 'id': 'eth_usd', 'symbol': 'ETH/USD', 'base': 'ETH', 'quote': 'USD', 'maker': 0.001, 'taker': 0.0015 }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balance, result, currencies, i, currency, lowercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostInfo();

                            case 2:
                                response = _context.sent;
                                balance = response['result']['wallet'];
                                result = { 'info': balance };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();

                                    if (lowercase in balance) {
                                        account['free'] = parseFloat(balance[lowercase]['avail']);
                                        account['used'] = parseFloat(balance[lowercase]['lock']);
                                        account['total'] = this.sum(account['free'], account['used']);
                                    }
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetDepth(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(response['result']));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetTicker(this.extend({
                                    'market': this.marketId(symbol)
                                }, params));

                            case 2:
                                response = _context3.sent;
                                ticker = response['result'];
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'buy'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'sell'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'vol'),
                                    'quoteVolume': undefined,
                                    'info': ticker
                                });

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'id': trade['id'].toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTrades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response['result'], market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                order = {
                                    'market': this.marketId(symbol),
                                    'op': side,
                                    'amount': amount
                                };

                                if (type === 'market') {
                                    order['order_type'] = 1;
                                    order['price'] = price;
                                } else {
                                    order['order_type'] = 0;
                                }
                                _context5.next = 4;
                                return this.privatePostTrade(this.extend(order, params));

                            case 4:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['result']['id'].toString()
                                });

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancel({ 'id': id });

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                if (Object.keys(params).length) url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'nonce': nonce
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.secret, 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('status' in response)) {
                                    _context7.next = 6;
                                    break;
                                }

                                if (!(response['status'] === 200)) {
                                    _context7.next = 6;
                                    break;
                                }

                                return _context7.abrupt('return', response);

                            case 6:
                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return mixcoins;
}(Exchange);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(negociecoins, _Exchange);

    function negociecoins() {
        _classCallCheck(this, negociecoins);

        return _possibleConstructorReturn(this, (negociecoins.__proto__ || Object.getPrototypeOf(negociecoins)).apply(this, arguments));
    }

    _createClass(negociecoins, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(negociecoins.prototype.__proto__ || Object.getPrototypeOf(negociecoins.prototype), 'describe', this).call(this), {
                'id': 'negociecoins',
                'name': 'NegocieCoins',
                'countries': 'BR',
                'rateLimit': 1000,
                'version': 'v3',
                'has': {
                    'fetchOrder': true,
                    'fetchOrders': true,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/38008571-25a6246e-3258-11e8-969b-aeb691049245.jpg',
                    'api': {
                        'public': 'https://broker.negociecoins.com.br/api/v3',
                        'private': 'https://broker.negociecoins.com.br/tradeapi/v1'
                    },
                    'www': 'https://www.negociecoins.com.br',
                    'doc': ['https://www.negociecoins.com.br/documentacao-tradeapi', 'https://www.negociecoins.com.br/documentacao-api'],
                    'fees': 'https://www.negociecoins.com.br/comissoes'
                },
                'api': {
                    'public': {
                        'get': ['{PAR}/ticker', '{PAR}/orderbook', '{PAR}/trades', '{PAR}/trades/{timestamp_inicial}', '{PAR}/trades/{timestamp_inicial}/{timestamp_final}']
                    },
                    'private': {
                        'get': ['user/balance', 'user/order/{orderId}'],
                        'post': ['user/order', 'user/orders'],
                        'delete': ['user/order/{orderId}']
                    }
                },
                'markets': {
                    'B2X/BRL': { 'id': 'b2xbrl', 'symbol': 'B2X/BRL', 'base': 'B2X', 'quote': 'BRL' },
                    'BCH/BRL': { 'id': 'bchbrl', 'symbol': 'BCH/BRL', 'base': 'BCH', 'quote': 'BRL' },
                    'BTC/BRL': { 'id': 'btcbrl', 'symbol': 'BTC/BRL', 'base': 'BTC', 'quote': 'BRL' },
                    'BTG/BRL': { 'id': 'btgbrl', 'symbol': 'BTG/BRL', 'base': 'BTG', 'quote': 'BRL' },
                    'DASH/BRL': { 'id': 'dashbrl', 'symbol': 'DASH/BRL', 'base': 'DASH', 'quote': 'BRL' },
                    'LTC/BRL': { 'id': 'ltcbrl', 'symbol': 'LTC/BRL', 'base': 'LTC', 'quote': 'BRL' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.003,
                        'taker': 0.004
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.001,
                            'BCH': 0.00003,
                            'BTG': 0.00009,
                            'LTC': 0.005
                        }
                    }
                },
                'limits': {
                    'amount': {
                        'min': 0.001,
                        'max': undefined
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                }
            });
        }
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['date'] * 1000;
            var symbol = typeof market !== 'undefined' ? market['symbol'] : undefined;
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'sell'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context.next = 5;
                                return this.publicGetPARTicker(this.extend({
                                    'PAR': market['id']
                                }, params));

                            case 5:
                                ticker = _context.sent;
                                return _context.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchTicker(_x2) {
                return _ref.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetPAROrderbook(this.extend({
                                    'PAR': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bid', 'ask', 'price', 'quantity'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = trade['date'] * 1000;
            var price = this.safeFloat(trade, 'price');
            var amount = this.safeFloat(trade, 'amount');
            var symbol = market['symbol'];
            var cost = parseFloat(this.costToPrecision(symbol, price * amount));
            return {
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tid'),
                'order': undefined,
                'type': 'limit',
                'side': trade['type'].toLowerCase(),
                'price': price,
                'amount': amount,
                'cost': cost,
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, trades;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (typeof since === 'undefined') since = 0;
                                request = {
                                    'PAR': market['id'],
                                    'timestamp_inicial': parseInt(since / 1000)
                                };
                                _context3.next = 7;
                                return this.publicGetPARTradesTimestampInicial(this.extend(request, params));

                            case 7:
                                trades = _context3.sent;
                                return _context3.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTrades(_x8) {
                return _ref3.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, id, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privateGetUserBalance(params);

                            case 4:
                                balances = _context4.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(balances);

                                for (i = 0; i < currencies.length; i++) {
                                    id = currencies[i];
                                    balance = balances[id];
                                    currency = this.commonCurrencyCode(id);
                                    account = {
                                        'free': parseFloat(balance['total']),
                                        'used': 0.0,
                                        'total': parseFloat(balance['available'])
                                    };

                                    account['used'] = account['total'] - account['free'];
                                    result[currency] = account;
                                }
                                return _context4.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchBalance() {
                return _ref4.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (!market) {
                market = this.safeValue(this.marketsById, order['pair']);
                if (market) symbol = market['symbol'];
            }
            var timestamp = this.parse8601(order['created']);
            var price = this.safeFloat(order, 'price');
            var amount = this.safeFloat(order, 'quantity');
            var cost = this.safeFloat(order, 'total');
            var remaining = this.safeFloat(order, 'pending_quantity');
            var filled = this.safeFloat(order, 'executed_quantity');
            var status = order['status'];
            // cancelled, filled, partially filled, pending, rejected
            if (status === 'filled') {
                status = 'closed';
            } else if (status === 'cancelled') {
                status = 'canceled';
            } else {
                status = 'open';
            }
            var trades = undefined;
            // if (order['operations'])
            //     trades = this.parseTrades (order['operations']);
            return {
                'id': order['id'].toString(),
                'datetime': this.iso8601(timestamp),
                'timestamp': timestamp,
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': 'limit',
                'side': order['type'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': trades,
                'fee': {
                    'currency': market['quote'],
                    'cost': this.safeFloat(order, 'fee')
                },
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, response, order, id;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.privatePostUserOrder(this.extend({
                                    'pair': market['id'],
                                    'price': this.priceToPrecision(symbol, price),
                                    'volume': this.amountToPrecision(symbol, amount),
                                    'type': side
                                }, params));

                            case 5:
                                response = _context5.sent;
                                order = this.parseOrder(response[0], market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context5.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.markets[symbol];
                                _context6.next = 5;
                                return this.privateDeleteUserOrderOrderId(this.extend({
                                    'orderId': id
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseOrder(response[0], market));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x20) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var order;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privateGetUserOrderOrderId(this.extend({
                                    'orderId': id
                                }, params));

                            case 4:
                                order = _context7.sent;
                                return _context7.abrupt('return', this.parseOrder(order[0]));

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOrder(_x23) {
                return _ref7.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, orders;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'pair': market['id']
                                    // type: buy, sell
                                    // status: cancelled, filled, partially filled, pending, rejected
                                    // startId
                                    // endId
                                    // startDate yyyy-MM-dd
                                    // endDate: yyyy-MM-dd
                                };

                                if (typeof since !== 'undefined') request['startDate'] = this.ymd(since);
                                if (typeof limit !== 'undefined') request['pageSize'] = limit;
                                _context8.next = 8;
                                return this.privatePostUserOrders(this.extend(request, params));

                            case 8:
                                orders = _context8.sent;
                                return _context8.abrupt('return', this.parseOrders(orders, market));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': 'pending'
                                }, params));

                            case 2:
                                return _context9.abrupt('return', _context9.sent);

                            case 3:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchOpenOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.fetchOrders(symbol, since, limit, this.extend({
                                    'status': 'filled'
                                }, params));

                            case 2:
                                return _context10.abrupt('return', _context10.sent);

                            case 3:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchClosedOrders() {
                return _ref10.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            var queryString = this.urlencode(query);
            if (api === 'public') {
                if (queryString.length) url += '?' + queryString;
            } else {
                this.checkRequiredCredentials();
                var timestamp = this.seconds().toString();
                var nonce = this.nonce().toString();
                var content = '';
                if (queryString.length) {
                    body = this.json(query);
                    content = this.hash(this.encode(body), 'md5', 'base64');
                } else {
                    body = '';
                }
                var uri = this.encodeURIComponent(url).toLowerCase();
                var payload = [this.apiKey, method, uri, timestamp, nonce, content].join('');
                var secret = this.base64ToBinary(this.secret);
                var signature = this.hmac(this.encode(payload), this.encode(secret), 'sha256', 'base64');
                signature = this.binaryToString(signature);
                var auth = [this.apiKey, signature, nonce, timestamp].join(':');
                headers = {
                    'Authorization': 'amx ' + auth
                };
                if (method === 'POST') {
                    headers['Content-Type'] = 'application/json; charset=UTF-8';
                    headers['Content-Length'] = body.length;
                } else if (queryString.length) {
                    url += '?' + queryString;
                    body = undefined;
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return negociecoins;
}(Exchange);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(nova, _Exchange);

    function nova() {
        _classCallCheck(this, nova);

        return _possibleConstructorReturn(this, (nova.__proto__ || Object.getPrototypeOf(nova)).apply(this, arguments));
    }

    _createClass(nova, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(nova.prototype.__proto__ || Object.getPrototypeOf(nova.prototype), 'describe', this).call(this), {
                'id': 'nova',
                'name': 'Novaexchange',
                'countries': 'TZ', // Tanzania
                'rateLimit': 2000,
                'version': 'v2',
                'has': {
                    'CORS': false,
                    'createMarketOrder': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30518571-78ca0bca-9b8a-11e7-8840-64b83a4a94b2.jpg',
                    'api': 'https://novaexchange.com/remote',
                    'www': 'https://novaexchange.com',
                    'doc': 'https://novaexchange.com/remote/faq'
                },
                'api': {
                    'public': {
                        'get': ['markets/', 'markets/{basecurrency}/', 'market/info/{pair}/', 'market/orderhistory/{pair}/', 'market/openorders/{pair}/buy/', 'market/openorders/{pair}/sell/', 'market/openorders/{pair}/both/', 'market/openorders/{pair}/{ordertype}/']
                    },
                    'private': {
                        'post': ['getbalances/', 'getbalance/{currency}/', 'getdeposits/', 'getwithdrawals/', 'getnewdepositaddress/{currency}/', 'getdepositaddress/{currency}/', 'myopenorders/', 'myopenorders_market/{pair}/', 'cancelorder/{orderid}/', 'withdraw/{currency}/', 'trade/{pair}/', 'tradehistory/', 'getdeposithistory/', 'getwithdrawalhistory/', 'walletstatus/', 'walletstatus/{currency}/']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, markets, result, i, market, id, _id$split, _id$split2, quote, base, symbol, active;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                response = _context.sent;
                                markets = response['markets'];
                                result = [];

                                for (i = 0; i < markets.length; i++) {
                                    market = markets[i];
                                    id = market['marketname'];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), quote = _id$split2[0], base = _id$split2[1];
                                    symbol = base + '/' + quote;
                                    active = true;

                                    if (market['disabled']) active = false;
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': active,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.publicGetMarketOpenordersPairBoth(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buyorders', 'sellorders', 'price', 'amount'));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetMarketInfoPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                response = _context3.sent;
                                ticker = response['markets'][0];
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'last_price');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high24h'),
                                    'low': this.safeFloat(ticker, 'low24h'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': this.safeFloat(ticker, 'change24h'),
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': this.safeFloat(ticker, 'volume24h'),
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['unix_t_datestamp'] * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': undefined,
                'order': undefined,
                'type': undefined,
                'side': trade['tradetype'].toLowerCase(),
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context4.next = 5;
                                return this.publicGetMarketOrderhistoryPair(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response['items'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x6) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, lockbox, trades, account;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.privatePostGetbalances();

                            case 4:
                                response = _context5.sent;
                                balances = response['balances'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    lockbox = parseFloat(balance['amount_lockbox']);
                                    trades = parseFloat(balance['amount_trades']);
                                    account = {
                                        'free': parseFloat(balance['amount']),
                                        'used': this.sum(lockbox, trades),
                                        'total': parseFloat(balance['amount_total'])
                                    };

                                    result[currency] = account;
                                }
                                return _context5.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchBalance() {
                return _ref5.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context6.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context6.next = 4;
                                return this.loadMarkets();

                            case 4:
                                amount = amount.toString();
                                price = price.toString();
                                market = this.market(symbol);
                                order = {
                                    'tradetype': side.toUpperCase(),
                                    'tradeamount': amount,
                                    'tradeprice': price,
                                    'tradebase': 1,
                                    'pair': market['id']
                                };
                                _context6.next = 10;
                                return this.privatePostTradePair(this.extend(order, params));

                            case 10:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 12:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.privatePostCancelorder(this.extend({
                                    'orderid': id
                                }, params));

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x17) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/';
            if (api === 'private') url += api + '/';
            url += this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                url += '?' + this.urlencode({ 'nonce': nonce });
                var signature = this.hmac(this.encode(url), this.encode(this.secret), 'sha512', 'base64');
                body = this.urlencode(this.extend({
                    'apikey': this.apiKey,
                    'signature': signature
                }, query));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context8.sent;

                                if (!('status' in response)) {
                                    _context8.next = 6;
                                    break;
                                }

                                if (!(response['status'] !== 'success')) {
                                    _context8.next = 6;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 6:
                                return _context8.abrupt('return', response);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function request(_x25) {
                return _ref8.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return nova;
}(Exchange);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var okcoinusd = __webpack_require__(10);

// ---------------------------------------------------------------------------

module.exports = function (_okcoinusd) {
    _inherits(okcoincny, _okcoinusd);

    function okcoincny() {
        _classCallCheck(this, okcoincny);

        return _possibleConstructorReturn(this, (okcoincny.__proto__ || Object.getPrototypeOf(okcoincny)).apply(this, arguments));
    }

    _createClass(okcoincny, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(okcoincny.prototype.__proto__ || Object.getPrototypeOf(okcoincny.prototype), 'describe', this).call(this), {
                'id': 'okcoincny',
                'name': 'OKCoin CNY',
                'countries': 'CN',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766792-8be9157a-5ee5-11e7-926c-6d69b8d3378d.jpg',
                    'api': {
                        'web': 'https://www.okcoin.cn',
                        'public': 'https://www.okcoin.cn/api',
                        'private': 'https://www.okcoin.cn/api'
                    },
                    'www': 'https://www.okcoin.cn',
                    'doc': 'https://www.okcoin.cn/rest_getStarted.html'
                },
                'markets': {
                    'BTC/CNY': { 'id': 'btc_cny', 'symbol': 'BTC/CNY', 'base': 'BTC', 'quote': 'CNY', 'type': 'spot', 'spot': true, 'future': false },
                    'LTC/CNY': { 'id': 'ltc_cny', 'symbol': 'LTC/CNY', 'base': 'LTC', 'quote': 'CNY', 'type': 'spot', 'spot': true, 'future': false },
                    'ETH/CNY': { 'id': 'eth_cny', 'symbol': 'ETH/CNY', 'base': 'ETH', 'quote': 'CNY', 'type': 'spot', 'spot': true, 'future': false },
                    'ETC/CNY': { 'id': 'etc_cny', 'symbol': 'ETC/CNY', 'base': 'ETC', 'quote': 'CNY', 'type': 'spot', 'spot': true, 'future': false },
                    'BCH/CNY': { 'id': 'bcc_cny', 'symbol': 'BCH/CNY', 'base': 'BCH', 'quote': 'CNY', 'type': 'spot', 'spot': true, 'future': false }
                }
            });
        }
    }]);

    return okcoincny;
}(okcoinusd);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var okcoinusd = __webpack_require__(10);

// ---------------------------------------------------------------------------

module.exports = function (_okcoinusd) {
    _inherits(okex, _okcoinusd);

    function okex() {
        _classCallCheck(this, okex);

        return _possibleConstructorReturn(this, (okex.__proto__ || Object.getPrototypeOf(okex)).apply(this, arguments));
    }

    _createClass(okex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(okex.prototype.__proto__ || Object.getPrototypeOf(okex.prototype), 'describe', this).call(this), {
                'id': 'okex',
                'name': 'OKEX',
                'countries': ['CN', 'US'],
                'has': {
                    'CORS': false,
                    'futures': true,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/32552768-0d6dd3c6-c4a6-11e7-90f8-c043b64756a7.jpg',
                    'api': {
                        'web': 'https://www.okex.com/v2',
                        'public': 'https://www.okex.com/api',
                        'private': 'https://www.okex.com/api'
                    },
                    'www': 'https://www.okex.com',
                    'doc': 'https://github.com/okcoin-okex/API-docs-OKEx.com',
                    'fees': 'https://www.okex.com/fees.html'
                },
                'commonCurrencies': {
                    'FAIR': 'FairGame',
                    'HMC': 'Hi Mutual Society',
                    'MAG': 'Maggie',
                    'NANO': 'XRB',
                    'YOYO': 'YOYOW'
                }
            });
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var key = 'quote';
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * rate));
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(symbol, cost))
            };
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, i;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _get(okex.prototype.__proto__ || Object.getPrototypeOf(okex.prototype), 'fetchMarkets', this).call(this);

                            case 2:
                                markets = _context.sent;

                                // TODO: they have a new fee schedule as of Feb 7
                                // the new fees are progressive and depend on 30-day traded volume
                                // the following is the worst case
                                for (i = 0; i < markets.length; i++) {
                                    if (markets[i]['spot']) {
                                        markets[i]['maker'] = 0.0015;
                                        markets[i]['taker'] = 0.0020;
                                    } else {
                                        markets[i]['maker'] = 0.0003;
                                        markets[i]['taker'] = 0.0005;
                                    }
                                }
                                return _context.abrupt('return', markets);

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, response, tickers, timestamp, result, i, ticker, market, marketId, symbol;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {};
                                _context2.next = 5;
                                return this.publicGetTickers(this.extend(request, params));

                            case 5:
                                response = _context2.sent;
                                tickers = response['tickers'];
                                timestamp = parseInt(response['date']) * 1000;
                                result = {};

                                for (i = 0; i < tickers.length; i++) {
                                    ticker = tickers[i];
                                    market = undefined;

                                    if ('symbol' in ticker) {
                                        marketId = ticker['symbol'];

                                        if (marketId in this.markets_by_id) market = this.markets_by_id[marketId];
                                    }
                                    ticker = this.parseTicker(this.extend(tickers[i], { 'timestamp': timestamp }), market);
                                    symbol = ticker['symbol'];

                                    result[symbol] = ticker;
                                }
                                return _context2.abrupt('return', result);

                            case 11:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchTickers() {
                return _ref2.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }]);

    return okex;
}(okcoinusd);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(paymium, _Exchange);

    function paymium() {
        _classCallCheck(this, paymium);

        return _possibleConstructorReturn(this, (paymium.__proto__ || Object.getPrototypeOf(paymium)).apply(this, arguments));
    }

    _createClass(paymium, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(paymium.prototype.__proto__ || Object.getPrototypeOf(paymium.prototype), 'describe', this).call(this), {
                'id': 'paymium',
                'name': 'Paymium',
                'countries': ['FR', 'EU'],
                'rateLimit': 2000,
                'version': 'v1',
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27790564-a945a9d4-5ff9-11e7-9d2d-b635763f2f24.jpg',
                    'api': 'https://paymium.com/api',
                    'www': 'https://www.paymium.com',
                    'doc': ['https://github.com/Paymium/api-documentation', 'https://www.paymium.com/page/developers']
                },
                'api': {
                    'public': {
                        'get': ['countries', 'data/{id}/ticker', 'data/{id}/trades', 'data/{id}/depth', 'bitcoin_charts/{id}/trades', 'bitcoin_charts/{id}/depth']
                    },
                    'private': {
                        'get': ['merchant/get_payment/{UUID}', 'user', 'user/addresses', 'user/addresses/{btc_address}', 'user/orders', 'user/orders/{UUID}', 'user/price_alerts'],
                        'post': ['user/orders', 'user/addresses', 'user/payment_requests', 'user/price_alerts', 'merchant/create_payment'],
                        'delete': ['user/orders/{UUID}/cancel', 'user/price_alerts/{id}']
                    }
                },
                'markets': {
                    'BTC/EUR': { 'id': 'eur', 'symbol': 'BTC/EUR', 'base': 'BTC', 'quote': 'EUR' }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0059,
                        'taker': 0.0059
                    }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, currency, lowercase, account, balance, locked;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetUser();

                            case 2:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = this.account();
                                    balance = 'balance_' + lowercase;
                                    locked = 'locked_' + lowercase;

                                    if (balance in balances) account['free'] = balances[balance];
                                    if (locked in balances) account['used'] = balances[locked];
                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetDataIdDepth(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context2.sent;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'price', 'amount'));

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetDataIdTicker(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = ticker['at'] * 1000;
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'price');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': this.safeFloat(ticker, 'variation'),
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['created_at_int']) * 1000;
            var volume = 'traded_' + market['base'].toLowerCase();
            return {
                'info': trade,
                'id': trade['uuid'],
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['side'],
                'price': trade['price'],
                'amount': trade[volume]
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetDataIdTrades(this.extend({
                                    'id': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                order = {
                                    'type': this.capitalize(type) + 'Order',
                                    'currency': this.marketId(symbol),
                                    'direction': side,
                                    'amount': amount
                                };

                                if (type === 'market') order['price'] = price;
                                _context5.next = 4;
                                return this.privatePostUserOrders(this.extend(order, params));

                            case 4:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['uuid']
                                });

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancelOrder(this.extend({
                                    'orderNumber': id
                                }, params));

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + url;
                if (method === 'POST') {
                    if (Object.keys(query).length) {
                        body = this.json(query);
                        auth += body;
                    }
                }
                headers = {
                    'Api-Key': this.apiKey,
                    'Api-Signature': this.hmac(this.encode(auth), this.encode(this.secret)),
                    'Api-Nonce': nonce,
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context7.sent;

                                if (!('errors' in response)) {
                                    _context7.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context7.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function request(_x25) {
                return _ref7.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return paymium;
}(Exchange);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    ExchangeNotAvailable = _require.ExchangeNotAvailable,
    RequestTimeout = _require.RequestTimeout,
    AuthenticationError = _require.AuthenticationError,
    DDoSProtection = _require.DDoSProtection,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    OrderNotCached = _require.OrderNotCached,
    InvalidOrder = _require.InvalidOrder,
    CancelPending = _require.CancelPending,
    InvalidNonce = _require.InvalidNonce;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(poloniex, _Exchange);

    function poloniex() {
        _classCallCheck(this, poloniex);

        return _possibleConstructorReturn(this, (poloniex.__proto__ || Object.getPrototypeOf(poloniex)).apply(this, arguments));
    }

    _createClass(poloniex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(poloniex.prototype.__proto__ || Object.getPrototypeOf(poloniex.prototype), 'describe', this).call(this), {
                'id': 'poloniex',
                'name': 'Poloniex',
                'countries': 'US',
                'rateLimit': 1000, // up to 6 calls per second
                'has': {
                    'createDepositAddress': true,
                    'fetchDepositAddress': true,
                    'CORS': false,
                    'editOrder': true,
                    'createMarketOrder': false,
                    'fetchOHLCV': true,
                    'fetchMyTrades': true,
                    'fetchOrder': 'emulated',
                    'fetchOrders': 'emulated',
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': 'emulated',
                    'fetchTickers': true,
                    'fetchTradingFees': true,
                    'fetchCurrencies': true,
                    'withdraw': true
                },
                'timeframes': {
                    '5m': 300,
                    '15m': 900,
                    '30m': 1800,
                    '2h': 7200,
                    '4h': 14400,
                    '1d': 86400
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766817-e9456312-5ee6-11e7-9b3c-b628ca5626a5.jpg',
                    'api': {
                        'public': 'https://poloniex.com/public',
                        'private': 'https://poloniex.com/tradingApi'
                    },
                    'www': 'https://poloniex.com',
                    'doc': ['https://poloniex.com/support/api/', 'http://pastebin.com/dMX7mZE0'],
                    'fees': 'https://poloniex.com/fees'
                },
                'api': {
                    'public': {
                        'get': ['return24hVolume', 'returnChartData', 'returnCurrencies', 'returnLoanOrders', 'returnOrderBook', 'returnTicker', 'returnTradeHistory']
                    },
                    'private': {
                        'post': ['buy', 'cancelLoanOffer', 'cancelOrder', 'closeMarginPosition', 'createLoanOffer', 'generateNewAddress', 'getMarginPosition', 'marginBuy', 'marginSell', 'moveOrder', 'returnActiveLoans', 'returnAvailableAccountBalances', 'returnBalances', 'returnCompleteBalances', 'returnDepositAddresses', 'returnDepositsWithdrawals', 'returnFeeInfo', 'returnLendingHistory', 'returnMarginAccountSummary', 'returnOpenLoanOffers', 'returnOpenOrders', 'returnOrderTrades', 'returnTradableBalances', 'returnTradeHistory', 'sell', 'toggleAutoRenew', 'transferBalance', 'withdraw']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.0015,
                        'taker': 0.0025
                    },
                    'funding': {}
                },
                'limits': {
                    'amount': {
                        'min': 0.00000001,
                        'max': 1000000000
                    },
                    'price': {
                        'min': 0.00000001,
                        'max': 1000000000
                    },
                    'cost': {
                        'min': 0.00000000,
                        'max': 1000000000
                    }
                },
                'precision': {
                    'amount': 8,
                    'price': 8
                },
                'commonCurrencies': {
                    'BTM': 'Bitmark',
                    'STR': 'XLM',
                    'BCC': 'BTCtalkcoin'
                }
            });
        }
    }, {
        key: 'calculateFee',
        value: function calculateFee(symbol, type, side, amount, price) {
            var takerOrMaker = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'taker';
            var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

            var market = this.markets[symbol];
            var key = 'quote';
            var rate = market[takerOrMaker];
            var cost = parseFloat(this.costToPrecision(symbol, amount * rate));
            if (side === 'sell') {
                cost *= price;
            } else {
                key = 'base';
            }
            return {
                'type': takerOrMaker,
                'currency': market[key],
                'rate': rate,
                'cost': parseFloat(this.feeToPrecision(symbol, cost))
            };
        }
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '5m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv['date'] * 1000, ohlcv['open'], ohlcv['high'], ohlcv['low'], ohlcv['close'], ohlcv['quoteVolume']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '5m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!since) since = 0;
                                request = {
                                    'currencyPair': market['id'],
                                    'period': this.timeframes[timeframe],
                                    'start': parseInt(since / 1000)
                                };

                                if (typeof limit !== 'undefined') request['end'] = this.sum(request['start'], limit * this.timeframes[timeframe]);
                                _context.next = 8;
                                return this.publicGetReturnChartData(this.extend(request, params));

                            case 8:
                                response = _context.sent;
                                return _context.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchOHLCV(_x7) {
                return _ref.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var markets, keys, result, p, id, market, _id$split, _id$split2, quote, base, symbol;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetReturnTicker();

                            case 2:
                                markets = _context2.sent;
                                keys = Object.keys(markets);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    id = keys[p];
                                    market = markets[id];
                                    _id$split = id.split('_'), _id$split2 = _slicedToArray(_id$split, 2), quote = _id$split2[0], base = _id$split2[1];

                                    base = this.commonCurrencyCode(base);
                                    quote = this.commonCurrencyCode(quote);
                                    symbol = base + '/' + quote;

                                    result.push(this.extend(this.fees['trading'], {
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': true,
                                        'precision': {
                                            'amount': 8,
                                            'price': 8
                                        },
                                        'limits': {
                                            'amount': {
                                                'min': 0.00000001,
                                                'max': 1000000000
                                            },
                                            'price': {
                                                'min': 0.00000001,
                                                'max': 1000000000
                                            },
                                            'cost': {
                                                'min': 0.00000000,
                                                'max': 1000000000
                                            }
                                        },
                                        'info': market
                                    }));
                                }
                                return _context2.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, c, id, balance, currency, account;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.privatePostReturnCompleteBalances(this.extend({
                                    'account': 'all'
                                }, params));

                            case 4:
                                balances = _context3.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(balances);

                                for (c = 0; c < currencies.length; c++) {
                                    id = currencies[c];
                                    balance = balances[id];
                                    currency = this.commonCurrencyCode(id);
                                    account = {
                                        'free': parseFloat(balance['available']),
                                        'used': parseFloat(balance['onOrders']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[currency] = account;
                                }
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchTradingFees',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fees;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.privatePostReturnFeeInfo();

                            case 4:
                                fees = _context4.sent;
                                return _context4.abrupt('return', {
                                    'info': fees,
                                    'maker': this.safeFloat(fees, 'makerFee'),
                                    'taker': this.safeFloat(fees, 'takerFee'),
                                    'withdraw': {},
                                    'deposit': {}
                                });

                            case 6:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTradingFees() {
                return _ref4.apply(this, arguments);
            }

            return fetchTradingFees;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'currencyPair': this.marketId(symbol)
                                };

                                if (typeof limit !== 'undefined') request['depth'] = limit; // 100
                                _context5.next = 6;
                                return this.publicGetReturnOrderBook(this.extend(request, params));

                            case 6:
                                response = _context5.sent;
                                orderbook = this.parseOrderBook(response);

                                orderbook['nonce'] = this.safeInteger(response, 'sec');
                                return _context5.abrupt('return', orderbook);

                            case 10:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchOrderBook(_x14) {
                return _ref5.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var open = undefined;
            var change = undefined;
            var average = undefined;
            var last = this.safeFloat(ticker, 'last');
            var relativeChange = this.safeFloat(ticker, 'percentChange');
            if (relativeChange !== -1) {
                open = last / this.sum(1, relativeChange);
                change = last - open;
                average = this.sum(last, open) / 2;
            }
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high24hr'),
                'low': this.safeFloat(ticker, 'low24hr'),
                'bid': this.safeFloat(ticker, 'highestBid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'lowestAsk'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': open,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': change,
                'percentage': relativeChange * 100,
                'average': average,
                'baseVolume': this.safeFloat(ticker, 'quoteVolume'),
                'quoteVolume': this.safeFloat(ticker, 'baseVolume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.publicGetReturnTicker(params);

                            case 4:
                                tickers = _context6.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context6.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTickers() {
                return _ref6.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var currencies, ids, result, i, id, currency, precision, code, active, status;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.publicGetReturnCurrencies(params);

                            case 2:
                                currencies = _context7.sent;
                                ids = Object.keys(currencies);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    currency = currencies[id];
                                    // todo: will need to rethink the fees
                                    // to add support for multiple withdrawal/deposit methods and
                                    // differentiated fees for each particular method

                                    precision = 8; // default precision, todo: fix "magic constants"

                                    code = this.commonCurrencyCode(id);
                                    active = currency['delisted'] === 0;
                                    status = currency['disabled'] ? 'disabled' : 'ok';

                                    if (status !== 'ok') active = false;
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'info': currency,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': status,
                                        'fee': this.safeFloat(currency, 'txFee'), // todo: redesign
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['txFee'],
                                                'max': Math.pow(10, precision)
                                            }
                                        }
                                    };
                                }
                                return _context7.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchCurrencies() {
                return _ref7.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, tickers, ticker;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context8.next = 5;
                                return this.publicGetReturnTicker(params);

                            case 5:
                                tickers = _context8.sent;
                                ticker = tickers[market['id']];
                                return _context8.abrupt('return', this.parseTicker(ticker, market));

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchTicker(_x21) {
                return _ref8.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['date']);
            var symbol = undefined;
            var base = undefined;
            var quote = undefined;
            if (!market && 'currencyPair' in trade) {
                var currencyPair = trade['currencyPair'];
                if (currencyPair in this.markets_by_id) {
                    market = this.markets_by_id[currencyPair];
                } else {
                    var parts = currencyPair.split('_');
                    quote = parts[0];
                    base = parts[1];
                    symbol = base + '/' + quote;
                }
            }
            if (market) {
                symbol = market['symbol'];
                base = market['base'];
                quote = market['quote'];
            }
            var side = trade['type'];
            var fee = undefined;
            var cost = this.safeFloat(trade, 'total');
            var amount = this.safeFloat(trade, 'amount');
            if ('fee' in trade) {
                var rate = this.safeFloat(trade, 'fee');
                var feeCost = undefined;
                var currency = undefined;
                if (side === 'buy') {
                    currency = base;
                    feeCost = amount * rate;
                } else {
                    currency = quote;
                    if (typeof cost !== 'undefined') feeCost = cost * rate;
                }
                fee = {
                    'type': undefined,
                    'rate': rate,
                    'cost': feeCost,
                    'currency': currency
                };
            }
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': symbol,
                'id': this.safeString(trade, 'tradeID'),
                'order': this.safeString(trade, 'orderNumber'),
                'type': 'limit',
                'side': side,
                'price': this.safeFloat(trade, 'rate'),
                'amount': amount,
                'cost': cost,
                'fee': fee
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, trades;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'currencyPair': market['id']
                                };

                                if (typeof since !== 'undefined') {
                                    request['start'] = parseInt(since / 1000);
                                    request['end'] = this.seconds(); // last 50000 trades by default
                                }
                                _context9.next = 7;
                                return this.publicGetReturnTradeHistory(this.extend(request, params));

                            case 7:
                                trades = _context9.sent;
                                return _context9.abrupt('return', this.parseTrades(trades, market, since, limit));

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchTrades(_x24) {
                return _ref9.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'fetchMyTrades',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                var market, pair, request, response, result, ids, i, id, _market, trades, j;

                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (symbol) market = this.market(symbol);
                                pair = market ? market['id'] : 'all';
                                request = { 'currencyPair': pair };

                                if (typeof since !== 'undefined') {
                                    request['start'] = parseInt(since / 1000);
                                    request['end'] = this.seconds();
                                }
                                // limit is disabled (does not really work as expected)
                                if (limit) request['limit'] = parseInt(limit);
                                _context10.next = 10;
                                return this.privatePostReturnTradeHistory(this.extend(request, params));

                            case 10:
                                response = _context10.sent;
                                result = [];

                                if (market) {
                                    result = this.parseTrades(response, market);
                                } else {
                                    if (response) {
                                        ids = Object.keys(response);

                                        for (i = 0; i < ids.length; i++) {
                                            id = ids[i];
                                            _market = undefined;

                                            if (id in this.markets_by_id) _market = this.markets_by_id[id];
                                            trades = this.parseTrades(response[id], _market);

                                            for (j = 0; j < trades.length; j++) {
                                                result.push(trades[j]);
                                            }
                                        }
                                    }
                                }
                                return _context10.abrupt('return', this.filterBySinceLimit(result, since, limit));

                            case 14:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function fetchMyTrades() {
                return _ref10.apply(this, arguments);
            }

            return fetchMyTrades;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.safeInteger(order, 'timestamp');
            if (!timestamp) timestamp = this.parse8601(order['date']);
            var trades = undefined;
            if ('resultingTrades' in order) trades = this.parseTrades(order['resultingTrades'], market);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var price = this.safeFloat(order, 'price');
            var remaining = this.safeFloat(order, 'amount');
            var amount = this.safeFloat(order, 'startingAmount', remaining);
            var filled = undefined;
            var cost = 0;
            if (typeof amount !== 'undefined') {
                if (typeof remaining !== 'undefined') {
                    filled = amount - remaining;
                    if (typeof price !== 'undefined') cost = filled * price;
                }
            }
            if (typeof filled === 'undefined') {
                if (typeof trades !== 'undefined') {
                    filled = 0;
                    cost = 0;
                    for (var i = 0; i < trades.length; i++) {
                        var trade = trades[i];
                        var tradeAmount = trade['amount'];
                        var tradePrice = trade['price'];
                        filled = this.sum(filled, tradeAmount);
                        cost += tradePrice * tradeAmount;
                    }
                }
            }
            return {
                'info': order,
                'id': order['orderNumber'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': order['status'],
                'symbol': symbol,
                'type': order['type'],
                'side': order['side'],
                'price': price,
                'cost': cost,
                'amount': amount,
                'filled': filled,
                'remaining': remaining,
                'trades': trades,
                'fee': undefined
            };
        }
    }, {
        key: 'parseOpenOrders',
        value: function parseOpenOrders(orders, market) {
            var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

            for (var i = 0; i < orders.length; i++) {
                var order = orders[i];
                var extended = this.extend(order, {
                    'status': 'open',
                    'type': 'limit',
                    'side': order['type'],
                    'price': order['rate']
                });
                result.push(this.parseOrder(extended, market));
            }
            return result;
        }
    }, {
        key: 'fetchOrders',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

                var market, pair, response, openOrders, marketIds, i, marketId, orders, m, j, openOrdersIndexedById, cachedOrderIds, result, k, id, _order, order;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (symbol) market = this.market(symbol);
                                pair = market ? market['id'] : 'all';
                                _context11.next = 7;
                                return this.privatePostReturnOpenOrders(this.extend({
                                    'currencyPair': pair
                                }));

                            case 7:
                                response = _context11.sent;
                                openOrders = [];

                                if (market) {
                                    openOrders = this.parseOpenOrders(response, market, openOrders);
                                } else {
                                    marketIds = Object.keys(response);

                                    for (i = 0; i < marketIds.length; i++) {
                                        marketId = marketIds[i];
                                        orders = response[marketId];
                                        m = this.markets_by_id[marketId];

                                        openOrders = this.parseOpenOrders(orders, m, openOrders);
                                    }
                                }
                                for (j = 0; j < openOrders.length; j++) {
                                    this.orders[openOrders[j]['id']] = openOrders[j];
                                }
                                openOrdersIndexedById = this.indexBy(openOrders, 'id');
                                cachedOrderIds = Object.keys(this.orders);
                                result = [];

                                for (k = 0; k < cachedOrderIds.length; k++) {
                                    id = cachedOrderIds[k];

                                    if (id in openOrdersIndexedById) {
                                        this.orders[id] = this.extend(this.orders[id], openOrdersIndexedById[id]);
                                    } else {
                                        _order = this.orders[id];

                                        if (_order['status'] === 'open') {
                                            _order = this.extend(_order, {
                                                'status': 'closed',
                                                'cost': undefined,
                                                'filled': _order['amount'],
                                                'remaining': 0.0
                                            });
                                            if (typeof _order['cost'] === 'undefined') {
                                                if (typeof _order['filled'] !== 'undefined') _order['cost'] = _order['filled'] * _order['price'];
                                            }
                                            this.orders[id] = _order;
                                        }
                                    }
                                    order = this.orders[id];

                                    if (market) {
                                        if (order['symbol'] === symbol) result.push(order);
                                    } else {
                                        result.push(order);
                                    }
                                }
                                return _context11.abrupt('return', this.filterBySinceLimit(result, since, limit));

                            case 16:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function fetchOrders() {
                return _ref11.apply(this, arguments);
            }

            return fetchOrders;
        }()
    }, {
        key: 'fetchOrder',
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var since, limit, request, orders, i;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                since = this.safeValue(params, 'since');
                                limit = this.safeValue(params, 'limit');
                                request = this.omit(params, ['since', 'limit']);
                                _context12.next = 5;
                                return this.fetchOrders(symbol, since, limit, request);

                            case 5:
                                orders = _context12.sent;
                                i = 0;

                            case 7:
                                if (!(i < orders.length)) {
                                    _context12.next = 13;
                                    break;
                                }

                                if (!(orders[i]['id'] === id)) {
                                    _context12.next = 10;
                                    break;
                                }

                                return _context12.abrupt('return', orders[i]);

                            case 10:
                                i++;
                                _context12.next = 7;
                                break;

                            case 13:
                                throw new OrderNotCached(this.id + ' order id ' + id.toString() + ' is not in "open" state and not found in cache');

                            case 14:
                            case 'end':
                                return _context12.stop();
                        }
                    }
                }, _callee12, this);
            }));

            function fetchOrder(_x38) {
                return _ref12.apply(this, arguments);
            }

            return fetchOrder;
        }()
    }, {
        key: 'filterOrdersByStatus',
        value: function filterOrdersByStatus(orders, status) {
            var result = [];
            for (var i = 0; i < orders.length; i++) {
                if (orders[i]['status'] === status) result.push(orders[i]);
            }
            return result;
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context13.sent;
                                return _context13.abrupt('return', this.filterOrdersByStatus(orders, 'open'));

                            case 4:
                            case 'end':
                                return _context13.stop();
                        }
                    }
                }, _callee13, this);
            }));

            function fetchOpenOrders() {
                return _ref13.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var orders;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this.fetchOrders(symbol, since, limit, params);

                            case 2:
                                orders = _context14.sent;
                                return _context14.abrupt('return', this.filterOrdersByStatus(orders, 'closed'));

                            case 4:
                            case 'end':
                                return _context14.stop();
                        }
                    }
                }, _callee14, this);
            }));

            function fetchClosedOrders() {
                return _ref14.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, market, response, timestamp, order, id;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                if (!(type === 'market')) {
                                    _context15.next = 2;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 2:
                                _context15.next = 4;
                                return this.loadMarkets();

                            case 4:
                                method = 'privatePost' + this.capitalize(side);
                                market = this.market(symbol);

                                price = parseFloat(price);
                                amount = parseFloat(amount);
                                _context15.next = 10;
                                return this[method](this.extend({
                                    'currencyPair': market['id'],
                                    'rate': this.priceToPrecision(symbol, price),
                                    'amount': this.amountToPrecision(symbol, amount)
                                }, params));

                            case 10:
                                response = _context15.sent;
                                timestamp = this.milliseconds();
                                order = this.parseOrder(this.extend({
                                    'timestamp': timestamp,
                                    'status': 'open',
                                    'type': type,
                                    'side': side,
                                    'price': price,
                                    'amount': amount
                                }, response), market);
                                id = order['id'];

                                this.orders[id] = order;
                                return _context15.abrupt('return', this.extend({ 'info': response }, order));

                            case 16:
                            case 'end':
                                return _context15.stop();
                        }
                    }
                }, _callee15, this);
            }));

            function createOrder(_x49, _x50, _x51, _x52) {
                return _ref15.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'editOrder',
        value: function () {
            var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(id, symbol, type, side, amount) {
                var price = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var params = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
                var request, response, result, newid, market;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.next = 2;
                                return this.loadMarkets();

                            case 2:
                                price = parseFloat(price);
                                request = {
                                    'orderNumber': id,
                                    'rate': this.priceToPrecision(symbol, price)
                                };

                                if (typeof amount !== 'undefined') {
                                    amount = parseFloat(amount);
                                    request['amount'] = this.amountToPrecision(symbol, amount);
                                }
                                _context16.next = 7;
                                return this.privatePostMoveOrder(this.extend(request, params));

                            case 7:
                                response = _context16.sent;
                                result = undefined;

                                if (id in this.orders) {
                                    this.orders[id]['status'] = 'canceled';
                                    newid = response['orderNumber'];

                                    this.orders[newid] = this.extend(this.orders[id], {
                                        'id': newid,
                                        'price': price,
                                        'status': 'open'
                                    });
                                    if (typeof amount !== 'undefined') this.orders[newid]['amount'] = amount;
                                    result = this.extend(this.orders[newid], { 'info': response });
                                } else {
                                    market = undefined;

                                    if (symbol) market = this.market(symbol);
                                    result = this.parseOrder(response, market);
                                    this.orders[result['id']] = result;
                                }
                                return _context16.abrupt('return', result);

                            case 11:
                            case 'end':
                                return _context16.stop();
                        }
                    }
                }, _callee16, this);
            }));

            function editOrder(_x55, _x56, _x57, _x58, _x59) {
                return _ref16.apply(this, arguments);
            }

            return editOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.next = 2;
                                return this.loadMarkets();

                            case 2:
                                response = undefined;
                                _context17.prev = 3;
                                _context17.next = 6;
                                return this.privatePostCancelOrder(this.extend({
                                    'orderNumber': id
                                }, params));

                            case 6:
                                response = _context17.sent;
                                _context17.next = 13;
                                break;

                            case 9:
                                _context17.prev = 9;
                                _context17.t0 = _context17['catch'](3);

                                if (_context17.t0 instanceof CancelPending) {
                                    // A request to cancel the order has been sent already.
                                    // If we then attempt to cancel the order the second time
                                    // before the first request is processed the exchange will
                                    // throw a CancelPending exception. Poloniex won't show the
                                    // order in the list of active (open) orders and the cached
                                    // order will be marked as 'closed' (see #1801 for details).
                                    // To avoid that we proactively mark the order as 'canceled'
                                    // here. If for some reason the order does not get canceled
                                    // and still appears in the active list then the order cache
                                    // will eventually get back in sync on a call to `fetchOrder`.
                                    if (id in this.orders) this.orders[id]['status'] = 'canceled';
                                }
                                throw _context17.t0;

                            case 13:
                                if (id in this.orders) this.orders[id]['status'] = 'canceled';
                                return _context17.abrupt('return', response);

                            case 15:
                            case 'end':
                                return _context17.stop();
                        }
                    }
                }, _callee17, this, [[3, 9]]);
            }));

            function cancelOrder(_x62) {
                return _ref17.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchOrderStatus',
        value: function () {
            var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var orders, indexed;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context18.next = 4;
                                return this.fetchOpenOrders(symbol);

                            case 4:
                                orders = _context18.sent;
                                indexed = this.indexBy(orders, 'id');
                                return _context18.abrupt('return', id in indexed ? 'open' : 'closed');

                            case 7:
                            case 'end':
                                return _context18.stop();
                        }
                    }
                }, _callee18, this);
            }));

            function fetchOrderStatus(_x65) {
                return _ref18.apply(this, arguments);
            }

            return fetchOrderStatus;
        }()
    }, {
        key: 'fetchOrderTrades',
        value: function () {
            var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var trades;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context19.next = 4;
                                return this.privatePostReturnOrderTrades(this.extend({
                                    'orderNumber': id
                                }, params));

                            case 4:
                                trades = _context19.sent;
                                return _context19.abrupt('return', this.parseTrades(trades));

                            case 6:
                            case 'end':
                                return _context19.stop();
                        }
                    }
                }, _callee19, this);
            }));

            function fetchOrderTrades(_x67) {
                return _ref19.apply(this, arguments);
            }

            return fetchOrderTrades;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address;
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                currency = this.currency(code);
                                _context20.next = 3;
                                return this.privatePostGenerateNewAddress({
                                    'currency': currency['id']
                                });

                            case 3:
                                response = _context20.sent;
                                address = undefined;

                                if (response['success'] === 1) address = this.safeString(response, 'response');
                                this.checkAddress(address);
                                return _context20.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 8:
                            case 'end':
                                return _context20.stop();
                        }
                    }
                }, _callee20, this);
            }));

            function createDepositAddress(_x70) {
                return _ref20.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, currencyId, address, status;
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                currency = this.currency(code);
                                _context21.next = 3;
                                return this.privatePostReturnDepositAddresses();

                            case 3:
                                response = _context21.sent;
                                currencyId = currency['id'];
                                address = this.safeString(response, currencyId);

                                this.checkAddress(address);
                                status = address ? 'ok' : 'none';
                                return _context21.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': status,
                                    'info': response
                                });

                            case 9:
                            case 'end':
                                return _context21.stop();
                        }
                    }
                }, _callee21, this);
            }));

            function fetchDepositAddress(_x72) {
                return _ref21.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, request, result;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                this.checkAddress(address);
                                _context22.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                request = {
                                    'currency': currency['id'],
                                    'amount': amount,
                                    'address': address
                                };

                                if (tag) request['paymentId'] = tag;
                                _context22.next = 8;
                                return this.privatePostWithdraw(this.extend(request, params));

                            case 8:
                                result = _context22.sent;
                                return _context22.abrupt('return', {
                                    'info': result,
                                    'id': result['response']
                                });

                            case 10:
                            case 'end':
                                return _context22.stop();
                        }
                    }
                }, _callee22, this);
            }));

            function withdraw(_x74, _x75, _x76) {
                return _ref22.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            var query = this.extend({ 'command': path }, params);
            if (api === 'public') {
                url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                query['nonce'] = this.nonce();
                body = this.urlencode(query);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            var response = undefined;
            try {
                response = JSON.parse(body);
            } catch (e) {
                // syntax error, resort to default error handler
                return;
            }
            if ('error' in response) {
                var error = response['error'];
                var feedback = this.id + ' ' + this.json(response);
                if (error === 'Invalid order number, or you are not the person who placed the order.') {
                    throw new OrderNotFound(feedback);
                } else if (error === 'Connection timed out. Please try again.') {
                    throw new RequestTimeout(feedback);
                } else if (error === 'Internal error. Please try again.') {
                    throw new ExchangeNotAvailable(feedback);
                } else if (error === 'Order not found, or you are not the person who placed it.') {
                    throw new OrderNotFound(feedback);
                } else if (error === 'Invalid API key/secret pair.') {
                    throw new AuthenticationError(feedback);
                } else if (error === 'Please do not make more than 8 API calls per second.') {
                    throw new DDoSProtection(feedback);
                } else if (error.indexOf('Total must be at least') >= 0) {
                    throw new InvalidOrder(feedback);
                } else if (error.indexOf('Not enough') >= 0) {
                    throw new InsufficientFunds(feedback);
                } else if (error.indexOf('Nonce must be greater') >= 0) {
                    throw new InvalidNonce(feedback);
                } else if (error.indexOf('You have already called cancelOrder or moveOrder on this order.') >= 0) {
                    throw new CancelPending(feedback);
                } else {
                    throw new ExchangeError(this.id + ': unknown error: ' + this.json(response));
                }
            }
        }
    }]);

    return poloniex;
}(Exchange);

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    AuthenticationError = _require.AuthenticationError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(quadrigacx, _Exchange);

    function quadrigacx() {
        _classCallCheck(this, quadrigacx);

        return _possibleConstructorReturn(this, (quadrigacx.__proto__ || Object.getPrototypeOf(quadrigacx)).apply(this, arguments));
    }

    _createClass(quadrigacx, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(quadrigacx.prototype.__proto__ || Object.getPrototypeOf(quadrigacx.prototype), 'describe', this).call(this), {
                'id': 'quadrigacx',
                'name': 'QuadrigaCX',
                'countries': 'CA',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'fetchDepositAddress': true,
                    'CORS': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766825-98a6d0de-5ee7-11e7-9fa4-38e11a2c6f52.jpg',
                    'api': 'https://api.quadrigacx.com',
                    'www': 'https://www.quadrigacx.com',
                    'doc': 'https://www.quadrigacx.com/api_info'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['order_book', 'ticker', 'transactions']
                    },
                    'private': {
                        'post': ['balance', 'bitcoin_deposit_address', 'bitcoin_withdrawal', 'bitcoincash_deposit_address', 'bitcoincash_withdrawal', 'bitcoingold_deposit_address', 'bitcoingold_withdrawal', 'buy', 'cancel_order', 'ether_deposit_address', 'ether_withdrawal', 'litecoin_deposit_address', 'litecoin_withdrawal', 'lookup_order', 'open_orders', 'sell', 'user_transactions']
                    }
                },
                'markets': {
                    'BTC/CAD': { 'id': 'btc_cad', 'symbol': 'BTC/CAD', 'base': 'BTC', 'quote': 'CAD', 'maker': 0.005, 'taker': 0.005 },
                    'BTC/USD': { 'id': 'btc_usd', 'symbol': 'BTC/USD', 'base': 'BTC', 'quote': 'USD', 'maker': 0.005, 'taker': 0.005 },
                    'ETH/BTC': { 'id': 'eth_btc', 'symbol': 'ETH/BTC', 'base': 'ETH', 'quote': 'BTC', 'maker': 0.002, 'taker': 0.002 },
                    'ETH/CAD': { 'id': 'eth_cad', 'symbol': 'ETH/CAD', 'base': 'ETH', 'quote': 'CAD', 'maker': 0.005, 'taker': 0.005 },
                    'LTC/CAD': { 'id': 'ltc_cad', 'symbol': 'LTC/CAD', 'base': 'LTC', 'quote': 'CAD', 'maker': 0.005, 'taker': 0.005 },
                    'LTC/BTC': { 'id': 'ltc_btc', 'symbol': 'LTC/BTC', 'base': 'LTC', 'quote': 'BTC', 'maker': 0.005, 'taker': 0.005 },
                    'BCH/CAD': { 'id': 'bch_cad', 'symbol': 'BCH/CAD', 'base': 'BCH', 'quote': 'CAD', 'maker': 0.005, 'taker': 0.005 },
                    'BCH/BTC': { 'id': 'bch_btc', 'symbol': 'BCH/BTC', 'base': 'BCH', 'quote': 'BTC', 'maker': 0.005, 'taker': 0.005 },
                    'BTG/CAD': { 'id': 'btg_cad', 'symbol': 'BTG/CAD', 'base': 'BTG', 'quote': 'CAD', 'maker': 0.005, 'taker': 0.005 },
                    'BTG/BTC': { 'id': 'btg_btc', 'symbol': 'BTG/BTC', 'base': 'BTG', 'quote': 'BTC', 'maker': 0.005, 'taker': 0.005 }
                }
            });
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, currencies, i, currency, lowercase, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privatePostBalance();

                            case 2:
                                balances = _context.sent;
                                result = { 'info': balances };
                                currencies = Object.keys(this.currencies);

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    lowercase = currency.toLowerCase();
                                    account = {
                                        'free': parseFloat(balances[lowercase + '_available']),
                                        'used': parseFloat(balances[lowercase + '_reserved']),
                                        'total': parseFloat(balances[lowercase + '_balance'])
                                    };

                                    result[currency] = account;
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetOrderBook(this.extend({
                                    'book': this.marketId(symbol)
                                }, params));

                            case 2:
                                orderbook = _context2.sent;
                                timestamp = parseInt(orderbook['timestamp']) * 1000;
                                return _context2.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 5:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref2.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.publicGetTicker(this.extend({
                                    'book': this.marketId(symbol)
                                }, params));

                            case 2:
                                ticker = _context3.sent;
                                timestamp = parseInt(ticker['timestamp']) * 1000;
                                vwap = this.safeFloat(ticker, 'vwap');
                                baseVolume = this.safeFloat(ticker, 'volume');
                                quoteVolume = baseVolume * vwap;
                                last = this.safeFloat(ticker, 'last');
                                return _context3.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': this.safeFloat(ticker, 'bid'),
                                    'bidVolume': undefined,
                                    'ask': this.safeFloat(ticker, 'ask'),
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchTicker(_x5) {
                return _ref3.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = parseInt(trade['date']) * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': trade['tid'].toString(),
                'order': undefined,
                'type': undefined,
                'side': trade['side'],
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'amount')
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                market = this.market(symbol);
                                _context4.next = 3;
                                return this.publicGetTransactions(this.extend({
                                    'book': market['id']
                                }, params));

                            case 3:
                                response = _context4.sent;
                                return _context4.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 5:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTrades(_x7) {
                return _ref4.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var method, order, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                method = 'privatePost' + this.capitalize(side);
                                order = {
                                    'amount': amount,
                                    'book': this.marketId(symbol)
                                };

                                if (type === 'limit') order['price'] = price;
                                _context5.next = 5;
                                return this[method](this.extend(order, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', {
                                    'info': response,
                                    'id': response['id'].toString()
                                });

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref5.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.privatePostCancelOrder(this.extend({
                                    'id': id
                                }, params));

                            case 2:
                                return _context6.abrupt('return', _context6.sent);

                            case 3:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function cancelOrder(_x17) {
                return _ref6.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(currency) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var method, response, address, status;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                method = 'privatePost' + this.getCurrencyName(currency) + 'DepositAddress';
                                _context7.next = 3;
                                return this[method](params);

                            case 3:
                                response = _context7.sent;
                                address = undefined;
                                status = undefined;
                                // [E|e]rror

                                if (response.indexOf('rror') >= 0) {
                                    status = 'error';
                                } else {
                                    address = response;
                                    status = 'ok';
                                }
                                this.checkAddress(address);
                                return _context7.abrupt('return', {
                                    'currency': currency,
                                    'address': address,
                                    'status': status,
                                    'info': this.last_http_response
                                });

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchDepositAddress(_x20) {
                return _ref7.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'getCurrencyName',
        value: function getCurrencyName(currency) {
            var currencies = {
                'ETH': 'Ether',
                'BTC': 'Bitcoin',
                'LTC': 'Litecoin',
                'BCH': 'Bitcoincash',
                'BTG': 'Bitcoingold'
            };
            return currencies[currency];
        }
    }, {
        key: 'withdraw',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, method, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                this.checkAddress(address);
                                _context8.next = 3;
                                return this.loadMarkets();

                            case 3:
                                request = {
                                    'amount': amount,
                                    'address': address
                                };
                                method = 'privatePost' + this.getCurrencyName(currency) + 'Withdrawal';
                                _context8.next = 7;
                                return this[method](this.extend(request, params));

                            case 7:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function withdraw(_x22, _x23, _x24) {
                return _ref8.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + path;
            if (api === 'public') {
                url += '?' + this.urlencode(params);
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                var request = [nonce.toString(), this.uid, this.apiKey].join('');
                var signature = this.hmac(this.encode(request), this.encode(this.secret));
                var query = this.extend({
                    'key': this.apiKey,
                    'nonce': nonce,
                    'signature': signature
                }, params);
                body = this.json(query);
                headers = {
                    'Content-Type': 'application/json'
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(statusCode, statusText, url, method, headers, body) {
            if (typeof body !== 'string') return; // fallback to default error handler
            if (body.length < 2) return;
            // Here is a sample QuadrigaCX response in case of authentication failure:
            // {"error":{"code":101,"message":"Invalid API Code or Invalid Signature"}}
            if (statusCode === 200 && body.indexOf('Invalid API Code or Invalid Signature') >= 0) {
                throw new AuthenticationError(this.id + ' ' + body);
            }
        }
    }, {
        key: 'request',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context9.sent;

                                if (!(typeof response === 'string')) {
                                    _context9.next = 5;
                                    break;
                                }

                                return _context9.abrupt('return', response);

                            case 5:
                                if (!('error' in response)) {
                                    _context9.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 7:
                                return _context9.abrupt('return', response);

                            case 8:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function request(_x32) {
                return _ref9.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return quadrigacx;
}(Exchange);

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var qryptos = __webpack_require__(36);

// ---------------------------------------------------------------------------

module.exports = function (_qryptos) {
    _inherits(quoinex, _qryptos);

    function quoinex() {
        _classCallCheck(this, quoinex);

        return _possibleConstructorReturn(this, (quoinex.__proto__ || Object.getPrototypeOf(quoinex)).apply(this, arguments));
    }

    _createClass(quoinex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(quoinex.prototype.__proto__ || Object.getPrototypeOf(quoinex.prototype), 'describe', this).call(this), {
                'id': 'quoinex',
                'name': 'QUOINEX',
                'countries': ['JP', 'SG', 'VN'],
                'version': '2',
                'rateLimit': 1000,
                'has': {
                    'CORS': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/35047114-0e24ad4a-fbaa-11e7-96a9-69c1a756083b.jpg',
                    'api': 'https://api.quoine.com',
                    'www': 'https://quoinex.com/',
                    'doc': ['https://developers.quoine.com', 'https://developers.quoine.com/v2'],
                    'fees': 'https://news.quoinex.com/fees/'
                }
            });
        }
    }]);

    return quoinex;
}(qryptos);

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(southxchange, _Exchange);

    function southxchange() {
        _classCallCheck(this, southxchange);

        return _possibleConstructorReturn(this, (southxchange.__proto__ || Object.getPrototypeOf(southxchange)).apply(this, arguments));
    }

    _createClass(southxchange, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(southxchange.prototype.__proto__ || Object.getPrototypeOf(southxchange.prototype), 'describe', this).call(this), {
                'id': 'southxchange',
                'name': 'SouthXchange',
                'countries': 'AR', // Argentina
                'rateLimit': 1000,
                'has': {
                    'CORS': true,
                    'createDepositAddress': true,
                    'fetchOpenOrders': true,
                    'fetchTickers': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27838912-4f94ec8a-60f6-11e7-9e5d-bbf9bd50a559.jpg',
                    'api': 'https://www.southxchange.com/api',
                    'www': 'https://www.southxchange.com',
                    'doc': 'https://www.southxchange.com/Home/Api'
                },
                'api': {
                    'public': {
                        'get': ['markets', 'price/{symbol}', 'prices', 'book/{symbol}', 'trades/{symbol}']
                    },
                    'private': {
                        'post': ['cancelMarketOrders', 'cancelOrder', 'generatenewaddress', 'listOrders', 'listBalances', 'placeOrder', 'withdraw']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    }
                },
                'commonCurrencies': {
                    'SMT': 'SmartNode'
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, baseId, quoteId, base, quote, symbol, id;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetMarkets();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    baseId = market[0];
                                    quoteId = market[1];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);
                                    symbol = base + '/' + quote;
                                    id = symbol;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currencyId, uppercase, currency, code, free, deposited, unconfirmed, total, used, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostListBalances();

                            case 4:
                                balances = _context2.sent;

                                if (balances) {
                                    _context2.next = 7;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchBalance got an unrecognized response');

                            case 7:
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currencyId = balance['Currency'];
                                    uppercase = currencyId.toUpperCase();
                                    currency = this.currencies_by_id[uppercase];
                                    code = currency['code'];
                                    free = parseFloat(balance['Available']);
                                    deposited = parseFloat(balance['Deposited']);
                                    unconfirmed = parseFloat(balance['Unconfirmed']);
                                    total = this.sum(deposited, unconfirmed);
                                    used = total - free;
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };

                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetBookSymbol(this.extend({
                                    'symbol': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'BuyOrders', 'SellOrders', 'Price', 'Amount'));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'Last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': undefined,
                'low': undefined,
                'bid': this.safeFloat(ticker, 'Bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'Ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': this.safeFloat(ticker, 'Variation24Hr'),
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'Volume24Hr'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, ids, result, i, id, symbol, market, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetPrices(params);

                            case 4:
                                response = _context4.sent;
                                tickers = this.indexBy(response, 'Market');
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    symbol = id;
                                    market = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    }
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetPriceSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = trade['At'] * 1000;
            return {
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'id': undefined,
                'order': undefined,
                'type': undefined,
                'side': trade['Type'],
                'price': trade['Price'],
                'amount': trade['Amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetTradesSymbol(this.extend({
                                    'symbol': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var status = 'open';
            var symbol = order['ListingCurrency'] + '/' + order['ReferenceCurrency'];
            var timestamp = undefined;
            var price = this.safeFloat(order, 'LimitPrice');
            var amount = this.safeFloat(order, 'OriginalAmount');
            var remaining = this.safeFloat(order, 'Amount');
            var filled = undefined;
            var cost = undefined;
            if (typeof amount !== 'undefined') {
                cost = price * amount;
                if (typeof remaining !== 'undefined') filled = amount - remaining;
            }
            var orderType = order['Type'].toLowerCase();
            var result = {
                'info': order,
                'id': order['Code'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'symbol': symbol,
                'type': 'limit',
                'side': orderType,
                'price': price,
                'amount': amount,
                'cost': cost,
                'filled': filled,
                'remaining': remaining,
                'status': status,
                'fee': undefined
            };
            return result;
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;

                                if (typeof symbol !== 'undefined') market = this.market(symbol);
                                _context7.next = 6;
                                return this.privatePostListOrders();

                            case 6:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseOrders(response, market, since, limit));

                            case 8:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOpenOrders() {
                return _ref7.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                order = {
                                    'listingCurrency': market['base'],
                                    'referenceCurrency': market['quote'],
                                    'type': side,
                                    'amount': amount
                                };

                                if (type === 'limit') order['limitPrice'] = price;
                                _context8.next = 7;
                                return this.privatePostPlaceOrder(this.extend(order, params));

                            case 7:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response.toString()
                                });

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x19, _x20, _x21, _x22) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context9.next = 4;
                                return this.privatePostCancelOrder(this.extend({
                                    'orderCode': id
                                }, params));

                            case 4:
                                return _context9.abrupt('return', _context9.sent);

                            case 5:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x25) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, parts, numParts, address, tag;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context10.next = 5;
                                return this.privatePostGeneratenewaddress(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context10.sent;
                                parts = response.split('|');
                                numParts = parts.length;
                                address = parts[0];

                                this.checkAddress(address);
                                tag = undefined;

                                if (numParts > 1) tag = parts[1];
                                return _context10.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 13:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function createDepositAddress(_x28) {
                return _ref10.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var request, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                this.checkAddress(address);
                                request = {
                                    'currency': currency,
                                    'address': address,
                                    'amount': amount
                                };

                                if (typeof tag !== 'undefined') request['address'] = address + '|' + tag;
                                _context11.next = 5;
                                return this.privatePostWithdraw(this.extend(request, params));

                            case 5:
                                response = _context11.sent;
                                return _context11.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function withdraw(_x30, _x31, _x32) {
                return _ref11.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                query = this.extend({
                    'key': this.apiKey,
                    'nonce': nonce
                }, query);
                body = this.json(query);
                headers = {
                    'Content-Type': 'application/json',
                    'Hash': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return southxchange;
}(Exchange);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var foxbit = __webpack_require__(7);

// ---------------------------------------------------------------------------

module.exports = function (_foxbit) {
    _inherits(surbitcoin, _foxbit);

    function surbitcoin() {
        _classCallCheck(this, surbitcoin);

        return _possibleConstructorReturn(this, (surbitcoin.__proto__ || Object.getPrototypeOf(surbitcoin)).apply(this, arguments));
    }

    _createClass(surbitcoin, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(surbitcoin.prototype.__proto__ || Object.getPrototypeOf(surbitcoin.prototype), 'describe', this).call(this), {
                'id': 'surbitcoin',
                'name': 'SurBitcoin',
                'countries': 'VE',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27991511-f0a50194-6481-11e7-99b5-8f02932424cc.jpg',
                    'api': {
                        'public': 'https://api.blinktrade.com/api',
                        'private': 'https://api.blinktrade.com/tapi'
                    },
                    'www': 'https://surbitcoin.com',
                    'doc': 'https://blinktrade.com/docs'
                },
                'options': {
                    'brokerId': '1' // https://blinktrade.com/docs/#brokers
                }
            });
        }
    }]);

    return surbitcoin;
}(foxbit);

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(therock, _Exchange);

    function therock() {
        _classCallCheck(this, therock);

        return _possibleConstructorReturn(this, (therock.__proto__ || Object.getPrototypeOf(therock)).apply(this, arguments));
    }

    _createClass(therock, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(therock.prototype.__proto__ || Object.getPrototypeOf(therock.prototype), 'describe', this).call(this), {
                'id': 'therock',
                'name': 'TheRockTrading',
                'countries': 'MT',
                'rateLimit': 1000,
                'version': 'v1',
                'has': {
                    'CORS': false,
                    'fetchTickers': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766869-75057fa2-5ee9-11e7-9a6f-13e641fa4707.jpg',
                    'api': 'https://api.therocktrading.com',
                    'www': 'https://therocktrading.com',
                    'doc': ['https://api.therocktrading.com/doc/v1/index.html', 'https://api.therocktrading.com/doc/']
                },
                'api': {
                    'public': {
                        'get': ['funds/{id}/orderbook', 'funds/{id}/ticker', 'funds/{id}/trades', 'funds/tickers']
                    },
                    'private': {
                        'get': ['balances', 'balances/{id}', 'discounts', 'discounts/{id}', 'funds', 'funds/{id}', 'funds/{id}/trades', 'funds/{fund_id}/orders', 'funds/{fund_id}/orders/{id}', 'funds/{fund_id}/position_balances', 'funds/{fund_id}/positions', 'funds/{fund_id}/positions/{id}', 'transactions', 'transactions/{id}', 'withdraw_limits/{id}', 'withdraw_limits'],
                        'post': ['atms/withdraw', 'funds/{fund_id}/orders'],
                        'delete': ['funds/{fund_id}/orders/{id}', 'funds/{fund_id}/orders/remove_all']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': false,
                        'withdraw': {
                            'BTC': 0.0005,
                            'BCH': 0.0005,
                            'PPC': 0.02,
                            'ETH': 0.001,
                            'ZEC': 0.001,
                            'LTC': 0.002,
                            'EUR': 2.5 // worst-case scenario: https://therocktrading.com/en/pages/fees
                        },
                        'deposit': {
                            'BTC': 0,
                            'BCH': 0,
                            'PPC': 0,
                            'ETH': 0,
                            'ZEC': 0,
                            'LTC': 0,
                            'EUR': 0
                        }
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetFundsTickers();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets['tickers'].length; p++) {
                                    market = markets['tickers'][p];
                                    id = market['fund_id'];
                                    base = id.slice(0, 3);
                                    quote = id.slice(3);
                                    symbol = base + '/' + quote;

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, free, total, used, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetBalances();

                            case 4:
                                response = _context2.sent;
                                balances = response['balances'];
                                result = { 'info': response };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    free = balance['trading_balance'];
                                    total = balance['balance'];
                                    used = total - free;
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetFundsIdOrderbook(this.extend({
                                    'id': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                timestamp = this.parse8601(orderbook['date']);
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'bids', 'asks', 'price', 'amount'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(ticker['date']);
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'bid'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'ask'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': this.safeFloat(ticker, 'open'),
                'close': last,
                'last': last,
                'previousClose': this.safeFloat(ticker, 'close'), // previous day close, if any
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'volume_traded'),
                'quoteVolume': this.safeFloat(ticker, 'volume'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, tickers, ids, result, i, id, market, symbol, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetFundsTickers(params);

                            case 4:
                                response = _context4.sent;
                                tickers = this.indexBy(response['tickers'], 'fund_id');
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = this.markets_by_id[id];
                                    symbol = market['symbol'];
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetFundsIdTicker(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                ticker = _context5.sent;
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            if (!market) market = this.markets_by_id[trade['fund_id']];
            var timestamp = this.parse8601(trade['date']);
            return {
                'info': trade,
                'id': trade['id'].toString(),
                'order': undefined,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': trade['side'],
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetFundsIdTrades(this.extend({
                                    'id': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTrades(response['trades'], market, since, limit));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x11) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (type === 'market') price = 0;
                                _context7.next = 5;
                                return this.privatePostFundsFundIdOrders(this.extend({
                                    'fund_id': this.marketId(symbol),
                                    'side': side,
                                    'amount': amount,
                                    'price': price
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['id'].toString()
                                });

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x15, _x16, _x17, _x18) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context8.next = 4;
                                return this.privateDeleteFundsFundIdOrdersId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                return _context8.abrupt('return', _context8.sent);

                            case 5:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x21) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/' + this.version + '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var auth = nonce + url;
                headers = {
                    'X-TRT-KEY': this.apiKey,
                    'X-TRT-NONCE': nonce,
                    'X-TRT-SIGN': this.hmac(this.encode(auth), this.encode(this.secret), 'sha512')
                };
                if (Object.keys(query).length) {
                    body = this.json(query);
                    headers['Content-Type'] = 'application/json';
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context9.sent;

                                if (!('errors' in response)) {
                                    _context9.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 5:
                                return _context9.abrupt('return', response);

                            case 6:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function request(_x29) {
                return _ref9.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return therock;
}(Exchange);

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(tidebit, _Exchange);

    function tidebit() {
        _classCallCheck(this, tidebit);

        return _possibleConstructorReturn(this, (tidebit.__proto__ || Object.getPrototypeOf(tidebit)).apply(this, arguments));
    }

    _createClass(tidebit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(tidebit.prototype.__proto__ || Object.getPrototypeOf(tidebit.prototype), 'describe', this).call(this), {
                'id': 'tidebit',
                'name': 'TideBit',
                'countries': 'HK',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'fetchDepositAddress': true,
                    'CORS': true,
                    'fetchTickers': true,
                    'fetchOHLCV': true,
                    'withdraw': true
                },
                'timeframes': {
                    '1m': '1',
                    '5m': '5',
                    '15m': '15',
                    '30m': '30',
                    '1h': '60',
                    '2h': '120',
                    '4h': '240',
                    '12h': '720',
                    '1d': '1440',
                    '3d': '4320',
                    '1w': '10080'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/39034921-e3acf016-4480-11e8-9945-a6086a1082fe.jpg',
                    'api': 'https://www.tidebit.com/api',
                    'www': 'https://www.tidebit.com',
                    'doc': 'https://www.tidebit.com/documents/api_v2'
                },
                'api': {
                    'public': {
                        'get': ['v2/markets', // V2MarketsJson
                        'v2/tickers', // V2TickersJson
                        'v2/tickers/{market}', // V2TickersMarketJson
                        'v2/trades', // V2TradesJson
                        'v2/trades/{market}', // V2TradesMarketJson
                        'v2/order_book', // V2OrderBookJson
                        'v2/order', // V2OrderJson
                        'v2/k_with_pending_trades', // V2KWithPendingTradesJson
                        'v2/k', // V2KJson
                        'v2/depth'],
                        'post': []
                    },
                    'private': {
                        'get': ['v2/deposits', // V2DepositsJson
                        'v2/deposit_address', // V2DepositAddressJson
                        'v2/deposit', // V2DepositJson
                        'v2/members/me', // V2MembersMeJson
                        'v2/addresses/{address}'],
                        'post': ['v2/order/delete', // V2OrderDeleteJson
                        'v2/order', // V2OrderJson
                        'v2/order/multi', // V2OrderMultiJson
                        'v2/order/clear']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'tierBased': false,
                        'percentage': true,
                        'withdraw': {} // There is only 1% fee on withdrawals to your bank account.
                    }
                },
                'exceptions': {
                    '2002': InsufficientFunds,
                    '2003': OrderNotFound
                }
            });
        }
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, response, address, tag;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                _context.next = 5;
                                return this.privateGetV2DepositAddress(this.extend({
                                    'currency': currency['id']
                                }, params));

                            case 5:
                                response = _context.sent;

                                if (!('success' in response)) {
                                    _context.next = 11;
                                    break;
                                }

                                if (!response['success']) {
                                    _context.next = 11;
                                    break;
                                }

                                address = this.safeString(response, 'address');
                                tag = this.safeString(response, 'addressTag');
                                return _context.abrupt('return', {
                                    'currency': code,
                                    'address': this.checkAddress(address),
                                    'tag': tag,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchDepositAddress(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var markets, result, p, market, id, symbol, _symbol$split, _symbol$split2, baseId, quoteId, base, quote;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.publicGetV2Markets();

                            case 2:
                                markets = _context2.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['id'];
                                    symbol = market['name'];
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), baseId = _symbol$split2[0], quoteId = _symbol$split2[1];
                                    base = this.commonCurrencyCode(baseId);
                                    quote = this.commonCurrencyCode(quoteId);

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'baseId': baseId,
                                        'quoteId': quoteId,
                                        'info': market
                                    });
                                }
                                return _context2.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchMarkets() {
                return _ref2.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currencyId, code, account;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.privateGetV2Deposits();

                            case 4:
                                response = _context3.sent;
                                balances = response['accounts'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currencyId = balance['currency'];
                                    code = currencyId.toUpperCase();

                                    if (currencyId in this.currencies_by_id) code = this.currencies_by_id[currencyId]['code'];
                                    account = {
                                        'free': parseFloat(balance['balance']),
                                        'used': parseFloat(balance['locked']),
                                        'total': 0.0
                                    };

                                    account['total'] = this.sum(account['free'], account['used']);
                                    result[code] = account;
                                }
                                return _context3.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchBalance() {
                return _ref3.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, request, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                request = {
                                    'market': market['id']
                                };

                                if (typeof limit === 'undefined') request['limit'] = limit; // default = 300
                                request['market'] = market['id'];
                                _context4.next = 8;
                                return this.publicGetV2Depth(this.extend(request, params));

                            case 8:
                                orderbook = _context4.sent;
                                timestamp = orderbook['timestamp'] * 1000;
                                return _context4.abrupt('return', this.parseOrderBook(orderbook, timestamp));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['at'] * 1000;
            ticker = ticker['ticker'];
            var symbol = undefined;
            if (typeof market !== 'undefined') symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'buy'),
                'ask': this.safeFloat(ticker, 'sell'),
                'bidVolume': undefined,
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'change': undefined,
                'percentage': undefined,
                'previousClose': undefined,
                'average': undefined,
                'baseVolume': this.safeFloat(ticker, 'vol'),
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, base, quote, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context5.next = 4;
                                return this.publicGetV2Tickers(params);

                            case 4:
                                tickers = _context5.sent;
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = undefined;
                                    symbol = id;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    } else {
                                        base = id.slice(0, 3);
                                        quote = id.slice(3, 6);

                                        base = base.toUpperCase();
                                        quote = quote.toUpperCase();
                                        base = this.commonCurrencyCode(base);
                                        quote = this.commonCurrencyCode(quote);
                                        symbol = base + '/' + quote;
                                    }
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context5.abrupt('return', result);

                            case 9:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTickers() {
                return _ref5.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetV2TickersMarket(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context6.sent;
                                return _context6.abrupt('return', this.parseTicker(response, market));

                            case 7:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTicker(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = this.parse8601(trade['created_at']);
            return {
                'id': trade['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'volume'),
                'cost': this.safeFloat(trade, 'funds'),
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context7.next = 5;
                                return this.publicGetV2Trades(this.extend({
                                    'market': market['id']
                                }, params));

                            case 5:
                                response = _context7.sent;
                                return _context7.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchTrades(_x13) {
                return _ref7.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv[0] * 1000, ohlcv[1], ohlcv[2], ohlcv[3], ohlcv[4], ohlcv[5]];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);

                                if (!limit) limit = 30; // default is 30
                                request = {
                                    'market': market['id'],
                                    'period': this.timeframes[timeframe],
                                    'limit': limit
                                };

                                if (typeof since !== 'undefined') {
                                    request['timestamp'] = since;
                                } else {
                                    request['timestamp'] = 1800000;
                                }
                                _context8.next = 8;
                                return this.publicGetV2K(this.extend(request, params));

                            case 8:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOHLCVs(response, market, timeframe, since, limit));

                            case 10:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOHLCV(_x21) {
                return _ref8.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var symbol = undefined;
            if (market) {
                symbol = market['symbol'];
            } else {
                var marketId = order['market'];
                symbol = this.markets_by_id[marketId]['symbol'];
            }
            var timestamp = this.parse8601(order['created_at']);
            var state = order['state'];
            var status = undefined;
            if (state === 'done') {
                status = 'closed';
            } else if (state === 'wait') {
                status = 'open';
            } else if (state === 'cancel') {
                status = 'canceled';
            }
            return {
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': status,
                'symbol': symbol,
                'type': order['ord_type'],
                'side': order['side'],
                'price': this.safeFloat(order, 'price'),
                'amount': this.safeFloat(order, 'volume'),
                'filled': this.safeFloat(order, 'executed_volume'),
                'remaining': this.safeFloat(order, 'remaining_volume'),
                'trades': undefined,
                'fee': undefined,
                'info': order
            };
        }
    }, {
        key: 'createOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var order, response, market;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                order = {
                                    'market': this.marketId(symbol),
                                    'side': side,
                                    'volume': amount.toString(),
                                    'ord_type': type
                                };

                                if (type === 'limit') {
                                    order['price'] = price.toString();
                                }
                                _context9.next = 6;
                                return this.privatePostV2Order(this.extend(order, params));

                            case 6:
                                response = _context9.sent;
                                market = this.markets_by_id[response['market']];
                                return _context9.abrupt('return', this.parseOrder(response, market));

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function createOrder(_x27, _x28, _x29, _x30) {
                return _ref9.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var result, order, status;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context10.next = 4;
                                return this.privatePostV2OrderDelete({ 'id': id });

                            case 4:
                                result = _context10.sent;
                                order = this.parseOrder(result);
                                status = order['status'];

                                if (!(status === 'closed' || status === 'canceled')) {
                                    _context10.next = 9;
                                    break;
                                }

                                throw new OrderNotFound(this.id + ' ' + this.json(order));

                            case 9:
                                return _context10.abrupt('return', order);

                            case 10:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function cancelOrder(_x33) {
                return _ref10.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                this.checkAddress(address);
                                _context11.next = 3;
                                return this.loadMarkets();

                            case 3:
                                _context11.next = 5;
                                return this.privatePostWithdraw(this.extend({
                                    'currency': currency.toLowerCase(),
                                    'sum': amount,
                                    'address': address
                                }, params));

                            case 5:
                                result = _context11.sent;
                                return _context11.abrupt('return', {
                                    'info': result,
                                    'id': undefined
                                });

                            case 7:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function withdraw(_x36, _x37, _x38) {
                return _ref11.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'encodeParams',
        value: function encodeParams(params) {
            return this.urlencode(this.keysort(params));
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var request = this.implodeParams(path, params) + '.json';
            var query = this.omit(params, this.extractParams(path));
            var url = this.urls['api'] + '/' + request;
            if (api === 'public') {
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce().toString();
                var _query = this.urlencode(this.extend({
                    'access_key': this.apiKey,
                    'tonce': nonce
                }, params));
                var payload = method + '|' + request + '|' + _query;
                var signature = this.hmac(this.encode(payload), this.encode(this.secret));
                var suffix = _query + '&signature=' + signature;
                if (method === 'GET') {
                    url += '?' + suffix;
                } else {
                    body = suffix;
                    headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 400) {
                var response = JSON.parse(body);
                var error = this.safeValue(response, 'error');
                var errorCode = this.safeString(error, 'code');
                var feedback = this.id + ' ' + this.json(response);
                var exceptions = this.exceptions;
                if (errorCode in exceptions) {
                    throw new exceptions[errorCode](feedback);
                }
                // fallback to default error handler
            }
        }
    }]);

    return tidebit;
}(Exchange);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var liqui = __webpack_require__(8);

// ---------------------------------------------------------------------------

module.exports = function (_liqui) {
    _inherits(tidex, _liqui);

    function tidex() {
        _classCallCheck(this, tidex);

        return _possibleConstructorReturn(this, (tidex.__proto__ || Object.getPrototypeOf(tidex)).apply(this, arguments));
    }

    _createClass(tidex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(tidex.prototype.__proto__ || Object.getPrototypeOf(tidex.prototype), 'describe', this).call(this), {
                'id': 'tidex',
                'name': 'Tidex',
                'countries': 'UK',
                'rateLimit': 2000,
                'version': '3',
                'has': {
                    // 'CORS': false,
                    // 'fetchTickers': true
                    'fetchCurrencies': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30781780-03149dc4-a12e-11e7-82bb-313b269d24d4.jpg',
                    'api': {
                        'web': 'https://web.tidex.com/api',
                        'public': 'https://api.tidex.com/api/3',
                        'private': 'https://api.tidex.com/tapi'
                    },
                    'www': 'https://tidex.com',
                    'doc': 'https://tidex.com/exchange/public-api',
                    'fees': ['https://tidex.com/exchange/assets-spec', 'https://tidex.com/exchange/pairs-spec']
                },
                'api': {
                    'web': {
                        'get': ['currency', 'pairs', 'tickers', 'orders', 'ordershistory', 'trade-data', 'trade-data/{id}']
                    }
                },
                'fees': {
                    'trading': {
                        'tierBased': false,
                        'percentage': true,
                        'taker': 0.1 / 100,
                        'maker': 0.1 / 100
                    }
                },
                'commonCurrencies': {
                    'MGO': 'WMGO',
                    'EMGO': 'MGO'
                }
            });
        }
    }, {
        key: 'fetchCurrencies',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var currencies, result, i, currency, id, precision, code, active, status, canWithdraw, canDeposit;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.webGetCurrency(params);

                            case 2:
                                currencies = _context.sent;
                                result = {};

                                for (i = 0; i < currencies.length; i++) {
                                    currency = currencies[i];
                                    id = currency['symbol'];
                                    precision = currency['amountPoint'];
                                    code = id.toUpperCase();

                                    code = this.commonCurrencyCode(code);
                                    active = currency['visible'] === true;
                                    status = 'ok';

                                    if (!active) {
                                        status = 'disabled';
                                    }
                                    canWithdraw = currency['withdrawEnable'] === true;
                                    canDeposit = currency['depositEnable'] === true;

                                    if (!canWithdraw || !canDeposit) {
                                        active = false;
                                    }
                                    result[code] = {
                                        'id': id,
                                        'code': code,
                                        'name': currency['name'],
                                        'active': active,
                                        'status': status,
                                        'precision': precision,
                                        'funding': {
                                            'withdraw': {
                                                'active': canWithdraw,
                                                'fee': currency['withdrawFee']
                                            },
                                            'deposit': {
                                                'active': canDeposit,
                                                'fee': 0.0
                                            }
                                        },
                                        'limits': {
                                            'amount': {
                                                'min': undefined,
                                                'max': Math.pow(10, precision)
                                            },
                                            'price': {
                                                'min': Math.pow(10, -precision),
                                                'max': Math.pow(10, precision)
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            },
                                            'withdraw': {
                                                'min': currency['withdrawMinAmout'],
                                                'max': undefined
                                            },
                                            'deposit': {
                                                'min': currency['depositMinAmount'],
                                                'max': undefined
                                            }
                                        },
                                        'info': currency
                                    };
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchCurrencies() {
                return _ref.apply(this, arguments);
            }

            return fetchCurrencies;
        }()
    }, {
        key: 'getVersionString',
        value: function getVersionString() {
            return '';
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            var query = this.omit(params, this.extractParams(path));
            if (api === 'private') {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'nonce': nonce,
                    'method': path
                }, query));
                var signature = this.signBodyWithSecret(body);
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': signature
                };
            } else if (api === 'public') {
                url += this.getVersionString() + '/' + this.implodeParams(path, params);
                if (Object.keys(query).length) {
                    url += '?' + this.urlencode(query);
                }
            } else {
                url += '/' + this.implodeParams(path, params);
                if (method === 'GET') {
                    if (Object.keys(query).length) {
                        url += '?' + this.urlencode(query);
                    }
                } else {
                    if (Object.keys(query).length) {
                        body = this.urlencode(query);
                        headers = {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        };
                    }
                }
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return tidex;
}(liqui);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var foxbit = __webpack_require__(7);

// ---------------------------------------------------------------------------

module.exports = function (_foxbit) {
    _inherits(urdubit, _foxbit);

    function urdubit() {
        _classCallCheck(this, urdubit);

        return _possibleConstructorReturn(this, (urdubit.__proto__ || Object.getPrototypeOf(urdubit)).apply(this, arguments));
    }

    _createClass(urdubit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(urdubit.prototype.__proto__ || Object.getPrototypeOf(urdubit.prototype), 'describe', this).call(this), {
                'id': 'urdubit',
                'name': 'UrduBit',
                'countries': 'PK',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27991453-156bf3ae-6480-11e7-82eb-7295fe1b5bb4.jpg',
                    'api': {
                        'public': 'https://api.blinktrade.com/api',
                        'private': 'https://api.blinktrade.com/tapi'
                    },
                    'www': 'https://urdubit.com',
                    'doc': 'https://blinktrade.com/docs'
                },
                'options': {
                    'brokerId': '8' // https://blinktrade.com/docs/#brokers
                }
            });
        }
    }]);

    return urdubit;
}(foxbit);

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(vaultoro, _Exchange);

    function vaultoro() {
        _classCallCheck(this, vaultoro);

        return _possibleConstructorReturn(this, (vaultoro.__proto__ || Object.getPrototypeOf(vaultoro)).apply(this, arguments));
    }

    _createClass(vaultoro, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(vaultoro.prototype.__proto__ || Object.getPrototypeOf(vaultoro.prototype), 'describe', this).call(this), {
                'id': 'vaultoro',
                'name': 'Vaultoro',
                'countries': 'CH',
                'rateLimit': 1000,
                'version': '1',
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766880-f205e870-5ee9-11e7-8fe2-0d5b15880752.jpg',
                    'api': 'https://api.vaultoro.com',
                    'www': 'https://www.vaultoro.com',
                    'doc': 'https://api.vaultoro.com'
                },
                'commonCurrencies': {
                    'GLD': 'Gold'
                },
                'api': {
                    'public': {
                        'get': ['bidandask', 'buyorders', 'latest', 'latesttrades', 'markets', 'orderbook', 'sellorders', 'transactions/day', 'transactions/hour', 'transactions/month']
                    },
                    'private': {
                        'get': ['balance', 'mytrades', 'orders'],
                        'post': ['buy/{symbol}/{type}', 'cancel/{id}', 'sell/{symbol}/{type}', 'withdraw']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var result, markets, market, baseId, quoteId, base, quote, symbol, id;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                result = [];
                                _context.next = 3;
                                return this.publicGetMarkets();

                            case 3:
                                markets = _context.sent;
                                market = markets['data'];
                                baseId = market['BaseCurrency'];
                                quoteId = market['MarketCurrency'];
                                base = this.commonCurrencyCode(baseId);
                                quote = this.commonCurrencyCode(quoteId);
                                symbol = base + '/' + quote;
                                id = market['MarketName'];

                                result.push({
                                    'id': id,
                                    'symbol': symbol,
                                    'base': base,
                                    'quote': quote,
                                    'baseId': baseId,
                                    'quoteId': quoteId,
                                    'info': market
                                });
                                return _context.abrupt('return', result);

                            case 13:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currencyId, code, free, used, total, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetBalance();

                            case 4:
                                response = _context2.sent;
                                balances = response['data'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currencyId = balance['currency_code'].toUpperCase();
                                    code = currencyId;

                                    if (currencyId in this.currencies_by_id[currencyId]) code = this.currencies_by_id[currencyId]['code'];
                                    free = balance['cash'];
                                    used = balance['reserved'];
                                    total = this.sum(free, used);
                                    account = {
                                        'free': free,
                                        'used': used,
                                        'total': total
                                    };

                                    result[code] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var response, orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetOrderbook(params);

                            case 4:
                                response = _context3.sent;
                                orderbook = {
                                    'bids': response['data'][0]['b'],
                                    'asks': response['data'][1]['s']
                                };
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, undefined, 'bids', 'asks', 'Gold_Price', 'Gold_Amount'));

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var quote, bidsLength, bid, ask, response, ticker, timestamp, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetBidandask(params);

                            case 4:
                                quote = _context4.sent;
                                bidsLength = quote['bids'].length;
                                bid = quote['bids'][bidsLength - 1];
                                ask = quote['asks'][0];
                                _context4.next = 10;
                                return this.publicGetMarkets(params);

                            case 10:
                                response = _context4.sent;
                                ticker = response['data'];
                                timestamp = this.milliseconds();
                                last = this.safeFloat(ticker, 'LastPrice');
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, '24hHigh'),
                                    'low': this.safeFloat(ticker, '24hLow'),
                                    'bid': bid[0],
                                    'bidVolume': undefined,
                                    'ask': ask[0],
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': undefined,
                                    'quoteVolume': this.safeFloat(ticker, '24hVolume'),
                                    'info': ticker
                                });

                            case 15:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade, market) {
            var timestamp = this.parse8601(trade['Time']);
            return {
                'id': undefined,
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'order': undefined,
                'type': undefined,
                'side': undefined,
                'price': trade['Gold_Price'],
                'amount': trade['Gold_Amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTransactionsDay(params);

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, method, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                method = 'privatePost' + this.capitalize(side) + 'SymbolType';
                                _context6.next = 6;
                                return this[method](this.extend({
                                    'symbol': market['quoteId'].toLowerCase(),
                                    'type': type,
                                    'gld': amount,
                                    'price': price || 1
                                }, params));

                            case 6:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['data']['Order_ID']
                                });

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x11, _x12, _x13, _x14) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context7.next = 4;
                                return this.privatePostCancelId(this.extend({
                                    'id': id
                                }, params));

                            case 4:
                                return _context7.abrupt('return', _context7.sent);

                            case 5:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x17) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/';
            if (api === 'public') {
                url += path;
            } else {
                this.checkRequiredCredentials();
                var nonce = this.nonce();
                url += this.version + '/' + this.implodeParams(path, params);
                var query = this.extend({
                    'nonce': nonce,
                    'apikey': this.apiKey
                }, this.omit(params, this.extractParams(path)));
                url += '?' + this.urlencode(query);
                headers = {
                    'Content-Type': 'application/json',
                    'X-Signature': this.hmac(this.encode(url), this.encode(this.secret))
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return vaultoro;
}(Exchange);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var foxbit = __webpack_require__(7);

// ---------------------------------------------------------------------------

module.exports = function (_foxbit) {
    _inherits(vbtc, _foxbit);

    function vbtc() {
        _classCallCheck(this, vbtc);

        return _possibleConstructorReturn(this, (vbtc.__proto__ || Object.getPrototypeOf(vbtc)).apply(this, arguments));
    }

    _createClass(vbtc, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(vbtc.prototype.__proto__ || Object.getPrototypeOf(vbtc.prototype), 'describe', this).call(this), {
                'id': 'vbtc',
                'name': 'VBTC',
                'countries': 'VN',
                'has': {
                    'CORS': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27991481-1f53d1d8-6481-11e7-884e-21d17e7939db.jpg',
                    'api': {
                        'public': 'https://api.blinktrade.com/api',
                        'private': 'https://api.blinktrade.com/tapi'
                    },
                    'www': 'https://vbtc.exchange',
                    'doc': 'https://blinktrade.com/docs'
                },
                'options': {
                    'brokerId': '3' // https://blinktrade.com/docs/#brokers
                }
            });
        }
    }]);

    return vbtc;
}(foxbit);

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(virwox, _Exchange);

    function virwox() {
        _classCallCheck(this, virwox);

        return _possibleConstructorReturn(this, (virwox.__proto__ || Object.getPrototypeOf(virwox)).apply(this, arguments));
    }

    _createClass(virwox, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(virwox.prototype.__proto__ || Object.getPrototypeOf(virwox.prototype), 'describe', this).call(this), {
                'id': 'virwox',
                'name': 'VirWoX',
                'countries': ['AT', 'EU'],
                'rateLimit': 1000,
                'has': {
                    'CORS': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766894-6da9d360-5eea-11e7-90aa-41f2711b7405.jpg',
                    'api': {
                        'public': 'http://api.virwox.com/api/json.php',
                        'private': 'https://www.virwox.com/api/trading.php'
                    },
                    'www': 'https://www.virwox.com',
                    'doc': 'https://www.virwox.com/developers.php'
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': false,
                    'login': true,
                    'password': true
                },
                'api': {
                    'public': {
                        'get': ['getInstruments', 'getBestPrices', 'getMarketDepth', 'estimateMarketOrder', 'getTradedPriceVolume', 'getRawTradeData', 'getStatistics', 'getTerminalList', 'getGridList', 'getGridStatistics'],
                        'post': ['getInstruments', 'getBestPrices', 'getMarketDepth', 'estimateMarketOrder', 'getTradedPriceVolume', 'getRawTradeData', 'getStatistics', 'getTerminalList', 'getGridList', 'getGridStatistics']
                    },
                    'private': {
                        'get': ['cancelOrder', 'getBalances', 'getCommissionDiscount', 'getOrders', 'getTransactions', 'placeOrder'],
                        'post': ['cancelOrder', 'getBalances', 'getCommissionDiscount', 'getOrders', 'getTransactions', 'placeOrder']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, keys, result, p, market, id, symbol, base, quote;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetGetInstruments();

                            case 2:
                                markets = _context.sent;
                                keys = Object.keys(markets['result']);
                                result = [];

                                for (p = 0; p < keys.length; p++) {
                                    market = markets['result'][keys[p]];
                                    id = market['instrumentID'];
                                    symbol = market['symbol'];
                                    base = market['longCurrency'];
                                    quote = market['shortCurrency'];

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, b, balance, currency, total, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetBalances();

                            case 4:
                                response = _context2.sent;
                                balances = response['result']['accountList'];
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['currency'];
                                    total = balance['balance'];
                                    account = {
                                        'free': total,
                                        'used': 0.0,
                                        'total': total
                                    };

                                    result[currency] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 9:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchMarketPrice',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicPostGetBestPrices(this.extend({
                                    'symbols': [symbol]
                                }, params));

                            case 4:
                                response = _context3.sent;
                                result = response['result'];
                                return _context3.abrupt('return', {
                                    'bid': this.safeFloat(result[0], 'bestBuyPrice'),
                                    'ask': this.safeFloat(result[0], 'bestSellPrice')
                                });

                            case 7:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchMarketPrice(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchMarketPrice;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var request, response, orderbook;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                request = {
                                    'symbols': [symbol]
                                };

                                if (typeof limit !== 'undefined') {
                                    request['buyDepth'] = limit; // 100
                                    request['sellDepth'] = limit; // 100
                                }
                                _context4.next = 6;
                                return this.publicPostGetMarketDepth(this.extend(request, params));

                            case 6:
                                response = _context4.sent;
                                orderbook = response['result'][0];
                                return _context4.abrupt('return', this.parseOrderBook(orderbook, undefined, 'buy', 'sell', 'price', 'volume'));

                            case 9:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchOrderBook(_x4) {
                return _ref4.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var end, start, response, tickers, keys, length, lastKey, ticker, timestamp, close;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                end = this.milliseconds();
                                start = end - 86400000;
                                _context5.next = 6;
                                return this.publicGetGetTradedPriceVolume(this.extend({
                                    'instrument': symbol,
                                    'endDate': this.ymdhms(end),
                                    'startDate': this.ymdhms(start),
                                    'HLOC': 1
                                }, params));

                            case 6:
                                response = _context5.sent;
                                tickers = response['result']['priceVolumeList'];
                                keys = Object.keys(tickers);
                                length = keys.length;
                                lastKey = keys[length - 1];
                                ticker = tickers[lastKey];
                                timestamp = this.milliseconds();
                                close = this.safeFloat(ticker, 'close');
                                return _context5.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': this.safeFloat(ticker, 'high'),
                                    'low': this.safeFloat(ticker, 'low'),
                                    'bid': undefined,
                                    'bidVolume': undefined,
                                    'ask': undefined,
                                    'askVolume': undefined,
                                    'vwap': undefined,
                                    'open': this.safeFloat(ticker, 'open'),
                                    'close': close,
                                    'last': close,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': this.safeFloat(ticker, 'longVolume'),
                                    'quoteVolume': this.safeFloat(ticker, 'shortVolume'),
                                    'info': ticker
                                });

                            case 15:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x7) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var sec = this.safeInteger(trade, 'time');
            var timestamp = sec * 1000;
            return {
                'id': trade['tid'],
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'order': undefined,
                'symbol': symbol,
                'type': undefined,
                'side': undefined,
                'price': this.safeFloat(trade, 'price'),
                'amount': this.safeFloat(trade, 'vol'),
                'fee': undefined,
                'info': trade
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response, result, trades;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context6.next = 5;
                                return this.publicGetGetRawTradeData(this.extend({
                                    'instrument': symbol,
                                    'timespan': 3600
                                }, params));

                            case 5:
                                response = _context6.sent;
                                result = response['result'];
                                trades = result['data'];
                                return _context6.abrupt('return', this.parseTrades(trades, market));

                            case 9:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var market, order, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                order = {
                                    'instrument': market['symbol'],
                                    'orderType': side.toUpperCase(),
                                    'amount': amount
                                };

                                if (type === 'limit') order['price'] = price;
                                _context7.next = 7;
                                return this.privatePostPlaceOrder(this.extend(order, params));

                            case 7:
                                response = _context7.sent;
                                return _context7.abrupt('return', {
                                    'info': response,
                                    'id': response['result']['orderID'].toString()
                                });

                            case 9:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function createOrder(_x14, _x15, _x16, _x17) {
                return _ref7.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.privatePostCancelOrder(this.extend({
                                    'orderID': id
                                }, params));

                            case 2:
                                return _context8.abrupt('return', _context8.sent);

                            case 3:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function cancelOrder(_x20) {
                return _ref8.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'][api];
            var auth = {};
            if (api === 'private') {
                this.checkRequiredCredentials();
                auth['key'] = this.apiKey;
                auth['user'] = this.login;
                auth['pass'] = this.password;
            }
            var nonce = this.nonce();
            if (method === 'GET') {
                url += '?' + this.urlencode(this.extend({
                    'method': path,
                    'id': nonce
                }, auth, params));
            } else {
                headers = { 'Content-Type': 'application/json' };
                body = this.json({
                    'method': path,
                    'params': this.extend(auth, params),
                    'id': nonce
                });
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 200) {
                if (body[0] === '{' || body[0] === '[') {
                    var response = JSON.parse(body);
                    if ('result' in response) {
                        var result = response['result'];
                        if ('errorCode' in result) {
                            var errorCode = result['errorCode'];
                            if (errorCode !== 'OK') {
                                throw new ExchangeError(this.id + ' error returned: ' + body);
                            }
                        }
                    } else {
                        throw new ExchangeError(this.id + ' malformed response: no result in response: ' + body);
                    }
                } else {
                    // if not a JSON response
                    throw new ExchangeError(this.id + ' returned a non-JSON reply: ' + body);
                }
            }
        }
    }]);

    return virwox;
}(Exchange);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var liqui = __webpack_require__(8);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    OrderNotFound = _require.OrderNotFound,
    DDoSProtection = _require.DDoSProtection;

// ---------------------------------------------------------------------------

module.exports = function (_liqui) {
    _inherits(wex, _liqui);

    function wex() {
        _classCallCheck(this, wex);

        return _possibleConstructorReturn(this, (wex.__proto__ || Object.getPrototypeOf(wex)).apply(this, arguments));
    }

    _createClass(wex, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(wex.prototype.__proto__ || Object.getPrototypeOf(wex.prototype), 'describe', this).call(this), {
                'id': 'wex',
                'name': 'WEX',
                'countries': 'NZ', // New Zealand
                'version': '3',
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchDepositAddress': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/30652751-d74ec8f8-9e31-11e7-98c5-71469fcef03e.jpg',
                    'api': {
                        'public': 'https://wex.nz/api',
                        'private': 'https://wex.nz/tapi'
                    },
                    'www': 'https://wex.nz',
                    'doc': ['https://wex.nz/api/3/docs', 'https://wex.nz/tapi/docs'],
                    'fees': 'https://wex.nz/fees'
                },
                'api': {
                    'public': {
                        'get': ['info', 'ticker/{pair}', 'depth/{pair}', 'trades/{pair}']
                    },
                    'private': {
                        'post': ['getInfo', 'Trade', 'ActiveOrders', 'OrderInfo', 'CancelOrder', 'TradeHistory', 'TransHistory', 'CoinDepositAddress', 'WithdrawCoin', 'CreateCoupon', 'RedeemCoupon']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.2 / 100,
                        'taker': 0.2 / 100
                    },
                    'funding': {
                        'withdraw': {
                            'BTC': 0.001,
                            'LTC': 0.001,
                            'NMC': 0.1,
                            'NVC': 0.1,
                            'PPC': 0.1,
                            'DASH': 0.001,
                            'ETH': 0.003,
                            'BCH': 0.001,
                            'ZEC': 0.001
                        }
                    }
                },
                'exceptions': {
                    'messages': {
                        'bad status': OrderNotFound,
                        'Requests too often': DDoSProtection,
                        'not available': DDoSProtection,
                        'external service unavailable': DDoSProtection
                    }
                },
                'commonCurrencies': {
                    'RUR': 'RUB'
                }
            });
        }
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = ticker['updated'] * 1000;
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            var last = this.safeFloat(ticker, 'last');
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': this.safeFloat(ticker, 'high'),
                'low': this.safeFloat(ticker, 'low'),
                'bid': this.safeFloat(ticker, 'sell'),
                'bidVolume': undefined,
                'ask': this.safeFloat(ticker, 'buy'),
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': this.safeFloat(ticker, 'avg'),
                'baseVolume': this.safeFloat(ticker, 'vol_cur'),
                'quoteVolume': this.safeFloat(ticker, 'vol'),
                'info': ticker
            };
        }
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var request, response;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                request = { 'coinName': this.commonCurrencyCode(code) };
                                _context.next = 3;
                                return this.privatePostCoinDepositAddress(this.extend(request, params));

                            case 3:
                                response = _context.sent;
                                return _context.abrupt('return', {
                                    'currency': code,
                                    'address': response['return']['address'],
                                    'tag': undefined,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchDepositAddress(_x2) {
                return _ref.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (code === 200) {
                if (body[0] !== '{') {
                    // response is not JSON -> resort to default error handler
                    return;
                }
                var response = JSON.parse(body);
                if ('success' in response) {
                    if (!response['success']) {
                        var error = this.safeString(response, 'error');
                        if (!error) {
                            throw new ExchangeError(this.id + ' returned a malformed error: ' + body);
                        }
                        if (error === 'no orders') {
                            // returned by fetchOpenOrders if no open orders (fix for #489) -> not an error
                            return;
                        }
                        var feedback = this.id + ' ' + this.json(response);
                        var messages = this.exceptions['messages'];
                        if (error in messages) {
                            throw new messages[error](feedback);
                        }
                        if (error.indexOf('It is not enough') >= 0) {
                            throw new InsufficientFunds(feedback);
                        } else {
                            throw new ExchangeError(feedback);
                        }
                    }
                }
            }
        }
    }]);

    return wex;
}(liqui);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    NotSupported = _require.NotSupported,
    AuthenticationError = _require.AuthenticationError;

// ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(xbtce, _Exchange);

    function xbtce() {
        _classCallCheck(this, xbtce);

        return _possibleConstructorReturn(this, (xbtce.__proto__ || Object.getPrototypeOf(xbtce)).apply(this, arguments));
    }

    _createClass(xbtce, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(xbtce.prototype.__proto__ || Object.getPrototypeOf(xbtce.prototype), 'describe', this).call(this), {
                'id': 'xbtce',
                'name': 'xBTCe',
                'countries': 'RU',
                'rateLimit': 2000, // responses are cached every 2 seconds
                'version': 'v1',
                'has': {
                    'publicAPI': false,
                    'CORS': false,
                    'fetchTickers': true,
                    'createMarketOrder': false
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28059414-e235970c-662c-11e7-8c3a-08e31f78684b.jpg',
                    'api': 'https://cryptottlivewebapi.xbtce.net:8443/api',
                    'www': 'https://www.xbtce.com',
                    'doc': ['https://www.xbtce.com/tradeapi', 'https://support.xbtce.info/Knowledgebase/Article/View/52/25/xbtce-exchange-api']
                },
                'requiredCredentials': {
                    'apiKey': true,
                    'secret': true,
                    'uid': true
                },
                'api': {
                    'public': {
                        'get': ['currency', 'currency/{filter}', 'level2', 'level2/{filter}', 'quotehistory/{symbol}/{periodicity}/bars/ask', 'quotehistory/{symbol}/{periodicity}/bars/bid', 'quotehistory/{symbol}/level2', 'quotehistory/{symbol}/ticks', 'symbol', 'symbol/{filter}', 'tick', 'tick/{filter}', 'ticker', 'ticker/{filter}', 'tradesession']
                    },
                    'private': {
                        'get': ['tradeserverinfo', 'tradesession', 'currency', 'currency/{filter}', 'level2', 'level2/{filter}', 'symbol', 'symbol/{filter}', 'tick', 'tick/{filter}', 'account', 'asset', 'asset/{id}', 'position', 'position/{id}', 'trade', 'trade/{id}', 'quotehistory/{symbol}/{periodicity}/bars/ask', 'quotehistory/{symbol}/{periodicity}/bars/ask/info', 'quotehistory/{symbol}/{periodicity}/bars/bid', 'quotehistory/{symbol}/{periodicity}/bars/bid/info', 'quotehistory/{symbol}/level2', 'quotehistory/{symbol}/level2/info', 'quotehistory/{symbol}/periodicities', 'quotehistory/{symbol}/ticks', 'quotehistory/{symbol}/ticks/info', 'quotehistory/cache/{symbol}/{periodicity}/bars/ask', 'quotehistory/cache/{symbol}/{periodicity}/bars/bid', 'quotehistory/cache/{symbol}/level2', 'quotehistory/cache/{symbol}/ticks', 'quotehistory/symbols', 'quotehistory/version'],
                        'post': ['trade', 'tradehistory'],
                        'put': ['trade'],
                        'delete': ['trade']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, base, quote, symbol;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.privateGetSymbol();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['Symbol'];
                                    base = market['MarginCurrency'];
                                    quote = market['ProfitCurrency'];

                                    if (base === 'DSH') base = 'DASH';
                                    symbol = base + '/' + quote;

                                    symbol = market['IsTradeAllowed'] ? symbol : id;
                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var balances, result, b, balance, currency, uppercase, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privateGetAsset();

                            case 4:
                                balances = _context2.sent;
                                result = { 'info': balances };

                                for (b = 0; b < balances.length; b++) {
                                    balance = balances[b];
                                    currency = balance['Currency'];
                                    uppercase = currency.toUpperCase();
                                    // xbtce names DASH incorrectly as DSH

                                    if (uppercase === 'DSH') uppercase = 'DASH';
                                    account = {
                                        'free': balance['FreeAmount'],
                                        'used': balance['LockedAmount'],
                                        'total': balance['Amount']
                                    };

                                    result[uppercase] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var market, orderbook, timestamp;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context3.next = 5;
                                return this.privateGetLevel2Filter(this.extend({
                                    'filter': market['id']
                                }, params));

                            case 5:
                                orderbook = _context3.sent;

                                orderbook = orderbook[0];
                                timestamp = orderbook['Timestamp'];
                                return _context3.abrupt('return', this.parseOrderBook(orderbook, timestamp, 'Bids', 'Asks', 'Price', 'Volume'));

                            case 9:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'parseTicker',
        value: function parseTicker(ticker) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var timestamp = 0;
            var last = undefined;
            if ('LastBuyTimestamp' in ticker) if (timestamp < ticker['LastBuyTimestamp']) {
                timestamp = ticker['LastBuyTimestamp'];
                last = ticker['LastBuyPrice'];
            }
            if ('LastSellTimestamp' in ticker) if (timestamp < ticker['LastSellTimestamp']) {
                timestamp = ticker['LastSellTimestamp'];
                last = ticker['LastSellPrice'];
            }
            if (!timestamp) timestamp = this.milliseconds();
            var symbol = undefined;
            if (market) symbol = market['symbol'];
            return {
                'symbol': symbol,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'high': ticker['DailyBestBuyPrice'],
                'low': ticker['DailyBestSellPrice'],
                'bid': ticker['BestBid'],
                'bidVolume': undefined,
                'ask': ticker['BestAsk'],
                'askVolume': undefined,
                'vwap': undefined,
                'open': undefined,
                'close': last,
                'last': last,
                'previousClose': undefined,
                'change': undefined,
                'percentage': undefined,
                'average': undefined,
                'baseVolume': ticker['DailyTradedTotalVolume'],
                'quoteVolume': undefined,
                'info': ticker
            };
        }
    }, {
        key: 'fetchTickers',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var symbols = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var tickers, ids, result, i, id, market, symbol, base, quote, ticker;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTicker(params);

                            case 4:
                                tickers = _context4.sent;

                                tickers = this.indexBy(tickers, 'Symbol');
                                ids = Object.keys(tickers);
                                result = {};

                                for (i = 0; i < ids.length; i++) {
                                    id = ids[i];
                                    market = undefined;
                                    symbol = undefined;

                                    if (id in this.markets_by_id) {
                                        market = this.markets_by_id[id];
                                        symbol = market['symbol'];
                                    } else {
                                        base = id.slice(0, 3);
                                        quote = id.slice(3, 6);

                                        if (base === 'DSH') base = 'DASH';
                                        if (quote === 'DSH') quote = 'DASH';
                                        symbol = base + '/' + quote;
                                    }
                                    ticker = tickers[id];

                                    result[symbol] = this.parseTicker(ticker, market);
                                }
                                return _context4.abrupt('return', result);

                            case 10:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTickers() {
                return _ref4.apply(this, arguments);
            }

            return fetchTickers;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var market, tickers, length, ticker;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTickerFilter(this.extend({
                                    'filter': market['id']
                                }, params));

                            case 5:
                                tickers = _context5.sent;
                                length = tickers.length;

                                if (!(length < 1)) {
                                    _context5.next = 9;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' fetchTicker returned empty response, xBTCe public API error');

                            case 9:
                                tickers = this.indexBy(tickers, 'Symbol');
                                ticker = tickers[market['id']];
                                return _context5.abrupt('return', this.parseTicker(ticker, market));

                            case 12:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTicker(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context6.next = 4;
                                return this.privateGetTrade(params);

                            case 4:
                                return _context6.abrupt('return', _context6.sent);

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function fetchTrades(_x10) {
                return _ref6.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'parseOHLCV',
        value: function parseOHLCV(ohlcv) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var timeframe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1m';
            var since = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
            var limit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

            return [ohlcv['Timestamp'], ohlcv['Open'], ohlcv['High'], ohlcv['Low'], ohlcv['Close'], ohlcv['Volume']];
        }
    }, {
        key: 'fetchOHLCV',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(symbol) {
                var timeframe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1m';
                var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                throw new NotSupported(this.id + ' fetchOHLCV is disabled by the exchange');

                            case 1:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function fetchOHLCV(_x18) {
                return _ref7.apply(this, arguments);
            }

            return fetchOHLCV;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(type === 'market')) {
                                    _context8.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 4:
                                _context8.next = 6;
                                return this.privatePostTrade(this.extend({
                                    'pair': this.marketId(symbol),
                                    'type': side,
                                    'amount': amount,
                                    'rate': price
                                }, params));

                            case 6:
                                response = _context8.sent;
                                return _context8.abrupt('return', {
                                    'info': response,
                                    'id': response['Id'].toString()
                                });

                            case 8:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function createOrder(_x23, _x24, _x25, _x26) {
                return _ref8.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.privateDeleteTrade(this.extend({
                                    'Type': 'Cancel',
                                    'Id': id
                                }, params));

                            case 2:
                                return _context9.abrupt('return', _context9.sent);

                            case 3:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function cancelOrder(_x29) {
                return _ref9.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            return this.milliseconds();
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            if (!this.apiKey) throw new AuthenticationError(this.id + ' requires apiKey for all requests, their public API is always busy');
            if (!this.uid) throw new AuthenticationError(this.id + ' requires uid property for authentication and trading, their public API is always busy');
            var url = this.urls['api'] + '/' + this.version;
            if (api === 'public') url += '/' + api;
            url += '/' + this.implodeParams(path, params);
            var query = this.omit(params, this.extractParams(path));
            if (api === 'public') {
                if (Object.keys(query).length) url += '?' + this.urlencode(query);
            } else {
                this.checkRequiredCredentials();
                headers = { 'Accept-Encoding': 'gzip, deflate' };
                var nonce = this.nonce().toString();
                if (method === 'POST') {
                    if (Object.keys(query).length) {
                        headers['Content-Type'] = 'application/json';
                        body = this.json(query);
                    } else {
                        url += '?' + this.urlencode(query);
                    }
                }
                var auth = nonce + this.uid + this.apiKey + method + url;
                if (body) auth += body;
                var signature = this.hmac(this.encode(auth), this.encode(this.secret), 'sha256', 'base64');
                var credentials = this.uid + ':' + this.apiKey + ':' + nonce + ':' + this.binaryToString(signature);
                headers['Authorization'] = 'HMAC ' + credentials;
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }]);

    return xbtce;
}(Exchange);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var liqui = __webpack_require__(8);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError,
    InsufficientFunds = _require.InsufficientFunds,
    DDoSProtection = _require.DDoSProtection;

// ---------------------------------------------------------------------------

module.exports = function (_liqui) {
    _inherits(yobit, _liqui);

    function yobit() {
        _classCallCheck(this, yobit);

        return _possibleConstructorReturn(this, (yobit.__proto__ || Object.getPrototypeOf(yobit)).apply(this, arguments));
    }

    _createClass(yobit, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(yobit.prototype.__proto__ || Object.getPrototypeOf(yobit.prototype), 'describe', this).call(this), {
                'id': 'yobit',
                'name': 'YoBit',
                'countries': 'RU',
                'rateLimit': 3000, // responses are cached every 2 seconds
                'version': '3',
                'has': {
                    'createDepositAddress': true,
                    'fetchDepositAddress': true,
                    'CORS': false,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766910-cdcbfdae-5eea-11e7-9859-03fea873272d.jpg',
                    'api': {
                        'public': 'https://yobit.net/api',
                        'private': 'https://yobit.net/tapi'
                    },
                    'www': 'https://www.yobit.net',
                    'doc': 'https://www.yobit.net/en/api/',
                    'fees': 'https://www.yobit.net/en/fees/'
                },
                'api': {
                    'public': {
                        'get': ['depth/{pair}', 'info', 'ticker/{pair}', 'trades/{pair}']
                    },
                    'private': {
                        'post': ['ActiveOrders', 'CancelOrder', 'GetDepositAddress', 'getInfo', 'OrderInfo', 'Trade', 'TradeHistory', 'WithdrawCoinsToAddress']
                    }
                },
                'fees': {
                    'trading': {
                        'maker': 0.002,
                        'taker': 0.002
                    },
                    'funding': {
                        'withdraw': {}
                    }
                },
                'commonCurrencies': {
                    'AIR': 'AirCoin',
                    'ANI': 'ANICoin',
                    'ANT': 'AntsCoin',
                    'AST': 'Astral',
                    'ATM': 'Autumncoin',
                    'BCC': 'BCH',
                    'BCS': 'BitcoinStake',
                    'BLN': 'Bulleon',
                    'BTS': 'Bitshares2',
                    'CAT': 'BitClave',
                    'COV': 'Coven Coin',
                    'CPC': 'Capricoin',
                    'CS': 'CryptoSpots',
                    'DCT': 'Discount',
                    'DGD': 'DarkGoldCoin',
                    'DROP': 'FaucetCoin',
                    'ERT': 'Eristica Token',
                    'ICN': 'iCoin',
                    'KNC': 'KingN Coin',
                    'LIZI': 'LiZi',
                    'LOC': 'LocoCoin',
                    'LOCX': 'LOC',
                    'LUN': 'LunarCoin',
                    'MDT': 'Midnight',
                    'NAV': 'NavajoCoin',
                    'OMG': 'OMGame',
                    'STK': 'StakeCoin',
                    'PAY': 'EPAY',
                    'PLC': 'Platin Coin',
                    'REP': 'Republicoin',
                    'RUR': 'RUB',
                    'XIN': 'XINCoin'
                },
                'options': {
                    'fetchOrdersRequiresSymbol': true
                }
            });
        }
    }, {
        key: 'parseOrderStatus',
        value: function parseOrderStatus(status) {
            var statuses = {
                '0': 'open',
                '1': 'closed',
                '2': 'canceled',
                '3': 'open' // or partially-filled and closed? https://github.com/ccxt/ccxt/issues/1594
            };
            if (status in statuses) return statuses[status];
            return status;
        }
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, sides, keys, i, key, side, currencies, j, lowercase, uppercase, currency, account;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context.next = 4;
                                return this.privatePostGetInfo();

                            case 4:
                                response = _context.sent;
                                balances = response['return'];
                                result = { 'info': balances };
                                sides = { 'free': 'funds', 'total': 'funds_incl_orders' };
                                keys = Object.keys(sides);

                                for (i = 0; i < keys.length; i++) {
                                    key = keys[i];
                                    side = sides[key];

                                    if (side in balances) {
                                        currencies = Object.keys(balances[side]);

                                        for (j = 0; j < currencies.length; j++) {
                                            lowercase = currencies[j];
                                            uppercase = lowercase.toUpperCase();
                                            currency = this.commonCurrencyCode(uppercase);
                                            account = undefined;

                                            if (currency in result) {
                                                account = result[currency];
                                            } else {
                                                account = this.account();
                                            }
                                            account[key] = balances[side][lowercase];
                                            if (typeof account['total'] !== 'undefined' && typeof account['free'] !== 'undefined') account['used'] = account['total'] - account['free'];
                                            result[currency] = account;
                                        }
                                    }
                                }
                                return _context.abrupt('return', this.parseBalance(result));

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchBalance() {
                return _ref.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'createDepositAddress',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var response, address;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.fetchDepositAddress(code, this.extend({
                                    'need_new': 1
                                }, params));

                            case 2:
                                response = _context2.sent;
                                address = this.safeString(response, 'address');

                                this.checkAddress(address);
                                return _context2.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response['info']
                                });

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function createDepositAddress(_x2) {
                return _ref2.apply(this, arguments);
            }

            return createDepositAddress;
        }()
    }, {
        key: 'fetchDepositAddress',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(code) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var currency, request, response, address;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                currency = this.currency(code);
                                request = {
                                    'coinName': currency['id'],
                                    'need_new': 0
                                };
                                _context3.next = 6;
                                return this.privatePostGetDepositAddress(this.extend(request, params));

                            case 6:
                                response = _context3.sent;
                                address = this.safeString(response['return'], 'address');

                                this.checkAddress(address);
                                return _context3.abrupt('return', {
                                    'currency': code,
                                    'address': address,
                                    'status': 'ok',
                                    'info': response
                                });

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchDepositAddress(_x4) {
                return _ref3.apply(this, arguments);
            }

            return fetchDepositAddress;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(code, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var currency, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                this.checkAddress(address);
                                _context4.next = 3;
                                return this.loadMarkets();

                            case 3:
                                currency = this.currency(code);
                                _context4.next = 6;
                                return this.privatePostWithdrawCoinsToAddress(this.extend({
                                    'coinName': currency['id'],
                                    'amount': amount,
                                    'address': address
                                }, params));

                            case 6:
                                response = _context4.sent;
                                return _context4.abrupt('return', {
                                    'info': response,
                                    'id': undefined
                                });

                            case 8:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function withdraw(_x6, _x7, _x8) {
                return _ref4.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'handleErrors',
        value: function handleErrors(code, reason, url, method, headers, body) {
            if (body[0] === '{') {
                var response = JSON.parse(body);
                if ('success' in response) {
                    if (!response['success']) {
                        if ('error_log' in response) {
                            if (response['error_log'].indexOf('Insufficient funds') >= 0) {
                                // not enougTh is a typo inside Liqui's own API...
                                throw new InsufficientFunds(this.id + ' ' + this.json(response));
                            } else if (response['error_log'] === 'Requests too often') {
                                throw new DDoSProtection(this.id + ' ' + this.json(response));
                            } else if (response['error_log'] === 'not available' || response['error_log'] === 'external service unavailable') {
                                throw new DDoSProtection(this.id + ' ' + this.json(response));
                            }
                        }
                        throw new ExchangeError(this.id + ' ' + this.json(response));
                    }
                }
            }
        }
    }]);

    return yobit;
}(liqui);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ---------------------------------------------------------------------------

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var acx = __webpack_require__(17);

// ---------------------------------------------------------------------------

module.exports = function (_acx) {
    _inherits(yunbi, _acx);

    function yunbi() {
        _classCallCheck(this, yunbi);

        return _possibleConstructorReturn(this, (yunbi.__proto__ || Object.getPrototypeOf(yunbi)).apply(this, arguments));
    }

    _createClass(yunbi, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(yunbi.prototype.__proto__ || Object.getPrototypeOf(yunbi.prototype), 'describe', this).call(this), {
                'id': 'yunbi',
                'name': 'YUNBI',
                'countries': 'CN',
                'rateLimit': 1000,
                'version': 'v2',
                'has': {
                    'CORS': false,
                    'fetchTickers': true,
                    'fetchOHLCV': true
                },
                'timeframes': {
                    '1m': '1',
                    '5m': '5',
                    '15m': '15',
                    '30m': '30',
                    '1h': '60',
                    '2h': '120',
                    '4h': '240',
                    '12h': '720',
                    '1d': '1440',
                    '3d': '4320',
                    '1w': '10080'
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/28570548-4d646c40-7147-11e7-9cf6-839b93e6d622.jpg',
                    'extension': '.json', // default extension appended to endpoint URLs
                    'api': 'https://yunbi.com',
                    'www': 'https://yunbi.com',
                    'doc': ['https://yunbi.com/documents/api/guide', 'https://yunbi.com/swagger/']
                },
                'api': {
                    'public': {
                        'get': ['tickers', 'tickers/{market}', 'markets', 'order_book', 'k', 'depth', 'trades', 'k_with_pending_trades', 'timestamp', 'addresses/{address}', 'partners/orders/{id}/trades']
                    },
                    'private': {
                        'get': ['deposits', 'members/me', 'deposit', 'deposit_address', 'order', 'orders', 'trades/my'],
                        'post': ['order/delete', 'orders', 'orders/multi', 'orders/clear']
                    }
                }
            });
        }
    }]);

    return yunbi;
}(acx);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//  ---------------------------------------------------------------------------

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Exchange = __webpack_require__(1);

var _require = __webpack_require__(0),
    ExchangeError = _require.ExchangeError;

//  ---------------------------------------------------------------------------

module.exports = function (_Exchange) {
    _inherits(zaif, _Exchange);

    function zaif() {
        _classCallCheck(this, zaif);

        return _possibleConstructorReturn(this, (zaif.__proto__ || Object.getPrototypeOf(zaif)).apply(this, arguments));
    }

    _createClass(zaif, [{
        key: 'describe',
        value: function describe() {
            return this.deepExtend(_get(zaif.prototype.__proto__ || Object.getPrototypeOf(zaif.prototype), 'describe', this).call(this), {
                'id': 'zaif',
                'name': 'Zaif',
                'countries': 'JP',
                'rateLimit': 2000,
                'version': '1',
                'has': {
                    'CORS': false,
                    'createMarketOrder': false,
                    'fetchOpenOrders': true,
                    'fetchClosedOrders': true,
                    'withdraw': true
                },
                'urls': {
                    'logo': 'https://user-images.githubusercontent.com/1294454/27766927-39ca2ada-5eeb-11e7-972f-1b4199518ca6.jpg',
                    'api': 'https://api.zaif.jp',
                    'www': 'https://zaif.jp',
                    'doc': ['http://techbureau-api-document.readthedocs.io/ja/latest/index.html', 'https://corp.zaif.jp/api-docs', 'https://corp.zaif.jp/api-docs/api_links', 'https://www.npmjs.com/package/zaif.jp', 'https://github.com/you21979/node-zaif'],
                    'fees': 'https://zaif.jp/fee?lang=en'
                },
                'fees': {
                    'trading': {
                        'percentage': true,
                        'taker': -0.0001,
                        'maker': -0.0005
                    }
                },
                'api': {
                    'public': {
                        'get': ['depth/{pair}', 'currencies/{pair}', 'currencies/all', 'currency_pairs/{pair}', 'currency_pairs/all', 'last_price/{pair}', 'ticker/{pair}', 'trades/{pair}']
                    },
                    'private': {
                        'post': ['active_orders', 'cancel_order', 'deposit_history', 'get_id_info', 'get_info', 'get_info2', 'get_personal_info', 'trade', 'trade_history', 'withdraw', 'withdraw_history']
                    },
                    'ecapi': {
                        'post': ['createInvoice', 'getInvoice', 'getInvoiceIdsByOrderNumber', 'cancelInvoice']
                    },
                    'tlapi': {
                        'post': ['get_positions', 'position_history', 'active_positions', 'create_position', 'change_position', 'cancel_position']
                    },
                    'fapi': {
                        'get': ['groups/{group_id}', 'last_price/{group_id}/{pair}', 'ticker/{group_id}/{pair}', 'trades/{group_id}/{pair}', 'depth/{group_id}/{pair}']
                    }
                }
            });
        }
    }, {
        key: 'fetchMarkets',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var markets, result, p, market, id, symbol, _symbol$split, _symbol$split2, base, quote, precision;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.publicGetCurrencyPairsAll();

                            case 2:
                                markets = _context.sent;
                                result = [];

                                for (p = 0; p < markets.length; p++) {
                                    market = markets[p];
                                    id = market['currency_pair'];
                                    symbol = market['name'];
                                    _symbol$split = symbol.split('/'), _symbol$split2 = _slicedToArray(_symbol$split, 2), base = _symbol$split2[0], quote = _symbol$split2[1];
                                    precision = {
                                        'amount': -Math.log10(market['item_unit_step']),
                                        'price': market['aux_unit_point']
                                    };

                                    result.push({
                                        'id': id,
                                        'symbol': symbol,
                                        'base': base,
                                        'quote': quote,
                                        'active': true, // can trade or not
                                        'precision': precision,
                                        'limits': {
                                            'amount': {
                                                'min': this.safeFloat(market, 'item_unit_min'),
                                                'max': undefined
                                            },
                                            'price': {
                                                'min': this.safeFloat(market, 'aux_unit_min'),
                                                'max': undefined
                                            },
                                            'cost': {
                                                'min': undefined,
                                                'max': undefined
                                            }
                                        },
                                        'info': market
                                    });
                                }
                                return _context.abrupt('return', result);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchMarkets() {
                return _ref.apply(this, arguments);
            }

            return fetchMarkets;
        }()
    }, {
        key: 'fetchBalance',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var response, balances, result, currencies, c, currency, balance, uppercase, account;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context2.next = 4;
                                return this.privatePostGetInfo();

                            case 4:
                                response = _context2.sent;
                                balances = response['return'];
                                result = { 'info': balances };
                                currencies = Object.keys(balances['funds']);

                                for (c = 0; c < currencies.length; c++) {
                                    currency = currencies[c];
                                    balance = balances['funds'][currency];
                                    uppercase = currency.toUpperCase();
                                    account = {
                                        'free': balance,
                                        'used': 0.0,
                                        'total': balance
                                    };

                                    if ('deposit' in balances) {
                                        if (currency in balances['deposit']) {
                                            account['total'] = balances['deposit'][currency];
                                            account['used'] = account['total'] - account['free'];
                                        }
                                    }
                                    result[uppercase] = account;
                                }
                                return _context2.abrupt('return', this.parseBalance(result));

                            case 10:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function fetchBalance() {
                return _ref2.apply(this, arguments);
            }

            return fetchBalance;
        }()
    }, {
        key: 'fetchOrderBook',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(symbol) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var orderbook;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context3.next = 4;
                                return this.publicGetDepthPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                orderbook = _context3.sent;
                                return _context3.abrupt('return', this.parseOrderBook(orderbook));

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function fetchOrderBook(_x2) {
                return _ref3.apply(this, arguments);
            }

            return fetchOrderBook;
        }()
    }, {
        key: 'fetchTicker',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(symbol) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var ticker, timestamp, vwap, baseVolume, quoteVolume, last;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.loadMarkets();

                            case 2:
                                _context4.next = 4;
                                return this.publicGetTickerPair(this.extend({
                                    'pair': this.marketId(symbol)
                                }, params));

                            case 4:
                                ticker = _context4.sent;
                                timestamp = this.milliseconds();
                                vwap = ticker['vwap'];
                                baseVolume = ticker['volume'];
                                quoteVolume = baseVolume * vwap;
                                last = ticker['last'];
                                return _context4.abrupt('return', {
                                    'symbol': symbol,
                                    'timestamp': timestamp,
                                    'datetime': this.iso8601(timestamp),
                                    'high': ticker['high'],
                                    'low': ticker['low'],
                                    'bid': ticker['bid'],
                                    'bidVolume': undefined,
                                    'ask': ticker['ask'],
                                    'askVolume': undefined,
                                    'vwap': vwap,
                                    'open': undefined,
                                    'close': last,
                                    'last': last,
                                    'previousClose': undefined,
                                    'change': undefined,
                                    'percentage': undefined,
                                    'average': undefined,
                                    'baseVolume': baseVolume,
                                    'quoteVolume': quoteVolume,
                                    'info': ticker
                                });

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function fetchTicker(_x5) {
                return _ref4.apply(this, arguments);
            }

            return fetchTicker;
        }()
    }, {
        key: 'parseTrade',
        value: function parseTrade(trade) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = trade['trade_type'] === 'bid' ? 'buy' : 'sell';
            var timestamp = trade['date'] * 1000;
            var id = this.safeString(trade, 'id');
            id = this.safeString(trade, 'tid', id);
            if (!market) market = this.markets_by_id[trade['currency_pair']];
            return {
                'id': id.toString(),
                'info': trade,
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'symbol': market['symbol'],
                'type': undefined,
                'side': side,
                'price': trade['price'],
                'amount': trade['amount']
            };
        }
    }, {
        key: 'fetchTrades',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(symbol) {
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = this.market(symbol);
                                _context5.next = 5;
                                return this.publicGetTradesPair(this.extend({
                                    'pair': market['id']
                                }, params));

                            case 5:
                                response = _context5.sent;
                                return _context5.abrupt('return', this.parseTrades(response, market, since, limit));

                            case 7:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function fetchTrades(_x8) {
                return _ref5.apply(this, arguments);
            }

            return fetchTrades;
        }()
    }, {
        key: 'createOrder',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(symbol, type, side, amount) {
                var price = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var params = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return this.loadMarkets();

                            case 2:
                                if (!(type === 'market')) {
                                    _context6.next = 4;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' allows limit orders only');

                            case 4:
                                _context6.next = 6;
                                return this.privatePostTrade(this.extend({
                                    'currency_pair': this.marketId(symbol),
                                    'action': side === 'buy' ? 'bid' : 'ask',
                                    'amount': amount,
                                    'price': price
                                }, params));

                            case 6:
                                response = _context6.sent;
                                return _context6.abrupt('return', {
                                    'info': response,
                                    'id': response['return']['order_id'].toString()
                                });

                            case 8:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function createOrder(_x12, _x13, _x14, _x15) {
                return _ref6.apply(this, arguments);
            }

            return createOrder;
        }()
    }, {
        key: 'cancelOrder',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
                var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this.privatePostCancelOrder(this.extend({
                                    'order_id': id
                                }, params));

                            case 2:
                                return _context7.abrupt('return', _context7.sent);

                            case 3:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function cancelOrder(_x18) {
                return _ref7.apply(this, arguments);
            }

            return cancelOrder;
        }()
    }, {
        key: 'parseOrder',
        value: function parseOrder(order) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

            var side = order['action'] === 'bid' ? 'buy' : 'sell';
            var timestamp = parseInt(order['timestamp']) * 1000;
            if (!market) market = this.markets_by_id[order['currency_pair']];
            var price = order['price'];
            var amount = order['amount'];
            return {
                'id': order['id'].toString(),
                'timestamp': timestamp,
                'datetime': this.iso8601(timestamp),
                'lastTradeTimestamp': undefined,
                'status': 'open',
                'symbol': market['symbol'],
                'type': 'limit',
                'side': side,
                'price': price,
                'cost': price * amount,
                'amount': amount,
                'filled': undefined,
                'remaining': undefined,
                'trades': undefined,
                'fee': undefined
            };
        }
    }, {
        key: 'parseOrders',
        value: function parseOrders(orders) {
            var market = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
            var since = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
            var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;

            var ids = Object.keys(orders);
            var result = [];
            for (var i = 0; i < ids.length; i++) {
                var id = ids[i];
                var order = orders[id];
                var extended = this.extend(order, { 'id': id });
                result.push(this.parseOrder(extended, market));
            }
            return this.filterBySinceLimit(result, since, limit);
        }
    }, {
        key: 'fetchOpenOrders',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {
                                    // 'is_token': false,
                                    // 'is_token_both': false,
                                };

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['currency_pair'] = market['id'];
                                }
                                _context8.next = 7;
                                return this.privatePostActiveOrders(this.extend(request, params));

                            case 7:
                                response = _context8.sent;
                                return _context8.abrupt('return', this.parseOrders(response['return'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function fetchOpenOrders() {
                return _ref8.apply(this, arguments);
            }

            return fetchOpenOrders;
        }()
    }, {
        key: 'fetchClosedOrders',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var symbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var since = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
                var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var market, request, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this.loadMarkets();

                            case 2:
                                market = undefined;
                                request = {
                                    // 'from': 0,
                                    // 'count': 1000,
                                    // 'from_id': 0,
                                    // 'end_id': 1000,
                                    // 'order': 'DESC',
                                    // 'since': 1503821051,
                                    // 'end': 1503821051,
                                    // 'is_token': false,
                                };

                                if (symbol) {
                                    market = this.market(symbol);
                                    request['currency_pair'] = market['id'];
                                }
                                _context9.next = 7;
                                return this.privatePostTradeHistory(this.extend(request, params));

                            case 7:
                                response = _context9.sent;
                                return _context9.abrupt('return', this.parseOrders(response['return'], market, since, limit));

                            case 9:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function fetchClosedOrders() {
                return _ref9.apply(this, arguments);
            }

            return fetchClosedOrders;
        }()
    }, {
        key: 'withdraw',
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(currency, amount, address) {
                var tag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
                var params = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var result;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                this.checkAddress(address);
                                _context10.next = 3;
                                return this.loadMarkets();

                            case 3:
                                if (!(currency === 'JPY')) {
                                    _context10.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' does not allow ' + currency + ' withdrawals');

                            case 5:
                                _context10.next = 7;
                                return this.privatePostWithdraw(this.extend({
                                    'currency': currency,
                                    'amount': amount,
                                    'address': address
                                    // 'message': 'Hi!', // XEM only
                                    // 'opt_fee': 0.003, // BTC and MONA only
                                }, params));

                            case 7:
                                result = _context10.sent;
                                return _context10.abrupt('return', {
                                    'info': result,
                                    'id': result['return']['txid'],
                                    'fee': result['return']['fee']
                                });

                            case 9:
                            case 'end':
                                return _context10.stop();
                        }
                    }
                }, _callee10, this);
            }));

            function withdraw(_x33, _x34, _x35) {
                return _ref10.apply(this, arguments);
            }

            return withdraw;
        }()
    }, {
        key: 'nonce',
        value: function nonce() {
            var nonce = parseFloat(this.milliseconds() / 1000);
            return nonce.toFixed(8);
        }
    }, {
        key: 'sign',
        value: function sign(path) {
            var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'public';
            var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
            var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
            var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;

            var url = this.urls['api'] + '/';
            if (api === 'public') {
                url += 'api/' + this.version + '/' + this.implodeParams(path, params);
            } else if (api === 'fapi') {
                url += 'fapi/' + this.version + '/' + this.implodeParams(path, params);
            } else {
                this.checkRequiredCredentials();
                if (api === 'ecapi') {
                    url += 'ecapi';
                } else if (api === 'tlapi') {
                    url += 'tlapi';
                } else {
                    url += 'tapi';
                }
                var nonce = this.nonce();
                body = this.urlencode(this.extend({
                    'method': path,
                    'nonce': nonce
                }, params));
                headers = {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Key': this.apiKey,
                    'Sign': this.hmac(this.encode(body), this.encode(this.secret), 'sha512')
                };
            }
            return { 'url': url, 'method': method, 'body': body, 'headers': headers };
        }
    }, {
        key: 'request',
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(path) {
                var api = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'api';
                var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
                var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                var body = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
                var response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this.fetch2(path, api, method, params, headers, body);

                            case 2:
                                response = _context11.sent;

                                if (!('error' in response)) {
                                    _context11.next = 5;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + response['error']);

                            case 5:
                                if (!('success' in response)) {
                                    _context11.next = 8;
                                    break;
                                }

                                if (response['success']) {
                                    _context11.next = 8;
                                    break;
                                }

                                throw new ExchangeError(this.id + ' ' + this.json(response));

                            case 8:
                                return _context11.abrupt('return', response);

                            case 9:
                            case 'end':
                                return _context11.stop();
                        }
                    }
                }, _callee11, this);
            }));

            function request(_x43) {
                return _ref11.apply(this, arguments);
            }

            return request;
        }()
    }]);

    return zaif;
}(Exchange);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ccxt.js